
function ItemListRepoComplete() {
    return(itemsDatalist);
}

function ItemListRepoConsult(itemId) {
    return(itemsDatalist[itemId])
}

export {ItemListRepoComplete, ItemListRepoConsult};


const itemsDatalist = {

500: {"AegisName":"Warnut_Chocoball"},
501: {"AegisName":"Red_Potion"},
502: {"AegisName":"Orange_Potion"},
503: {"AegisName":"Yellow_Potion"},
504: {"AegisName":"White_Potion"},
505: {"AegisName":"Blue_Potion"},
506: {"AegisName":"Green_Potion"},
507: {"AegisName":"Red_Herb"},
508: {"AegisName":"Yellow_Herb"},
509: {"AegisName":"White_Herb"},
510: {"AegisName":"Blue_Herb"},
511: {"AegisName":"Green_Herb"},
512: {"AegisName":"Apple"},
513: {"AegisName":"Banana"},
514: {"AegisName":"Grape"},
515: {"AegisName":"Carrot"},
516: {"AegisName":"Sweet_Potato"},
517: {"AegisName":"Meat"},
518: {"AegisName":"Honey"},
519: {"AegisName":"Milk"},
520: {"AegisName":"Leaflet_Of_Hinal"},
521: {"AegisName":"Leaflet_Of_Aloe"},
522: {"AegisName":"Fruit_Of_Mastela"},
523: {"AegisName":"Holy_Water"},
525: {"AegisName":"Panacea"},
526: {"AegisName":"Royal_Jelly"},
528: {"AegisName":"Monster's_Feed"},
529: {"AegisName":"Candy"},
530: {"AegisName":"Candy_Striper"},
531: {"AegisName":"Apple_Juice"},
532: {"AegisName":"Banana_Juice"},
533: {"AegisName":"Grape_Juice"},
534: {"AegisName":"Carrot_Juice"},
535: {"AegisName":"Pumpkin"},
536: {"AegisName":"Ice_Cream"},
537: {"AegisName":"Pet_Food"},
538: {"AegisName":"Well_Baked_Cookie"},
539: {"AegisName":"Piece_Of_Cake"},
540: {"AegisName":"Falcon's_Feed"},
541: {"AegisName":"Pecopeco's_Feed"},
542: {"AegisName":"Festive_Cookie"},
543: {"AegisName":"Festive_Rainbow_Cake"},
544: {"AegisName":"Fish_Slice"},
545: {"AegisName":"Red_Slim_Potion"},
546: {"AegisName":"Yellow_Slim_Potion"},
547: {"AegisName":"White_Slim_Potion"},
548: {"AegisName":"Cheese"},
549: {"AegisName":"Nice_Sweet_Potato"},
550: {"AegisName":"Popped_Rice"},
551: {"AegisName":"Shusi"},
552: {"AegisName":"KETUPAT"},
553: {"AegisName":"Bun"},
554: {"AegisName":"Mojji"},
555: {"AegisName":"Rice_Cake"},
556: {"AegisName":"Long_Rice_Cake"},
557: {"AegisName":"Hash_Rice_Cake"},
558: {"AegisName":"Chocolate"},
559: {"AegisName":"HandMade_Chocolate"},
560: {"AegisName":"HandMade_Chocolate_"},
561: {"AegisName":"White_Chocolate"},
562: {"AegisName":"Pizza"},
563: {"AegisName":"Pizza_01"},
564: {"AegisName":"Rice_Ball"},
565: {"AegisName":"Vita500_Bottle"},
566: {"AegisName":"Tomyumkung"},
567: {"AegisName":"Prawn"},
568: {"AegisName":"Lemon"},
569: {"AegisName":"Novice_Potion"},
570: {"AegisName":"Lucky_Candy"},
571: {"AegisName":"Lucky_Candy_Cane"},
572: {"AegisName":"Lucky_Cookie"},
573: {"AegisName":"Chocolate_Drink"},
574: {"AegisName":"Egg"},
575: {"AegisName":"Piece_Of_Cake_"},
576: {"AegisName":"Prickly_Fruit"},
577: {"AegisName":"Grain"},
578: {"AegisName":"Strawberry"},
579: {"AegisName":"Delicious_Fish"},
580: {"AegisName":"Bread"},
581: {"AegisName":"Mushroom"},
582: {"AegisName":"Orange"},
583: {"AegisName":"KETUPAT_"},
584: {"AegisName":"Fish_Ball_Soup"},
585: {"AegisName":"Wurst"},
586: {"AegisName":"Mother's_Cake"},
587: {"AegisName":"Prickly_Fruit_"},
588: {"AegisName":"Spaghetti"},
589: {"AegisName":"Pizza_02"},
590: {"AegisName":"Brezel_"},
591: {"AegisName":"Caviar_Pancake"},
592: {"AegisName":"Jam_Pancake"},
593: {"AegisName":"Honey_Pancake"},
594: {"AegisName":"Sour_Cream_Pancake"},
595: {"AegisName":"Mushroom_Pancake"},
596: {"AegisName":"Cute_Strawberry_Choco"},
597: {"AegisName":"Lovely_Choco_Tart"},
598: {"AegisName":"Light_Red_Pot"},
599: {"AegisName":"Light_Orange_Pot"},
601: {"AegisName":"Wing_Of_Fly"},
602: {"AegisName":"Wing_Of_Butterfly"},
603: {"AegisName":"Old_Blue_Box"},
604: {"AegisName":"Branch_Of_Dead_Tree"},
605: {"AegisName":"Anodyne"},
606: {"AegisName":"Aloebera"},
607: {"AegisName":"Yggdrasilberry"},
608: {"AegisName":"Seed_Of_Yggdrasil"},
609: {"AegisName":"Amulet"},
610: {"AegisName":"Leaf_Of_Yggdrasil"},
611: {"AegisName":"Spectacles"},
612: {"AegisName":"Portable_Furnace"},
613: {"AegisName":"Iron_Hammer"},
614: {"AegisName":"Golden_Hammer"},
615: {"AegisName":"Oridecon_Hammer"},
616: {"AegisName":"Old_Card_Album"},
617: {"AegisName":"Old_Violet_Box"},
618: {"AegisName":"Worn_Out_Scroll"},
619: {"AegisName":"Unripe_Apple"},
620: {"AegisName":"Orange_Juice"},
621: {"AegisName":"Bitter_Herb"},
622: {"AegisName":"Rainbow_Carrot"},
623: {"AegisName":"Earthworm_The_Dude"},
624: {"AegisName":"Rotten_Fish"},
625: {"AegisName":"Lusty_Iron"},
626: {"AegisName":"Monster_Juice"},
627: {"AegisName":"Sweet_Milk"},
628: {"AegisName":"Well_Dried_Bone"},
629: {"AegisName":"Singing_Flower"},
630: {"AegisName":"Dew_Laden_Moss"},
631: {"AegisName":"Deadly_Noxious_Herb"},
632: {"AegisName":"Fatty_Chubby_Earthworm"},
633: {"AegisName":"Baked_Yam"},
634: {"AegisName":"Tropical_Banana"},
635: {"AegisName":"Horror_Of_Tribe"},
636: {"AegisName":"No_Recipient"},
637: {"AegisName":"Old_Broom"},
638: {"AegisName":"Silver_Knife_Of_Chaste"},
639: {"AegisName":"Armlet_Of_Obedience"},
640: {"AegisName":"Shining_Stone"},
641: {"AegisName":"Contracts_In_Shadow"},
642: {"AegisName":"Book_Of_Devil"},
643: {"AegisName":"Pet_Incubator"},
644: {"AegisName":"Gift_Box"},
645: {"AegisName":"Center_Potion"},
656: {"AegisName":"Awakening_Potion"},
657: {"AegisName":"Berserk_Potion"},
658: {"AegisName":"Union_Of_Tribe"},
659: {"AegisName":"Heart_Of_Her"},
660: {"AegisName":"Prohibition_Red_Candle"},
661: {"AegisName":"Sway_Apron"},
662: {"AegisName":"Inspector_Certificate"},
663: {"AegisName":"Korea_Rice_Cake"},
664: {"AegisName":"Gift_Box_1"},
665: {"AegisName":"Gift_Box_2"},
666: {"AegisName":"Gift_Box_3"},
667: {"AegisName":"Gift_Box_4"},
668: {"AegisName":"Handsei"},
669: {"AegisName":"Rice_Cake_Soup"},
670: {"AegisName":"Gold_Coin_Moneybag"},
671: {"AegisName":"Gold_Coin"},
672: {"AegisName":"Copper_Coin_Moneybag"},
673: {"AegisName":"Copper_Coin"},
674: {"AegisName":"Mithril_Coin"},
675: {"AegisName":"Silver_Coin"},
676: {"AegisName":"Silver_Coin_Moneybag"},
677: {"AegisName":"White_Gold_Coin"},
678: {"AegisName":"Poison_Bottle"},
679: {"AegisName":"Gold_Pill"},
680: {"AegisName":"Magical_Carnation"},
681: {"AegisName":"Memory_Of_Wedding"},
682: {"AegisName":"Realgar_Wine"},
683: {"AegisName":"Exorcize_Herb"},
684: {"AegisName":"Durian"},
685: {"AegisName":"RAMADAN"},
686: {"AegisName":"Earth_Scroll_1_3"},
687: {"AegisName":"Earth_Scroll_1_5"},
688: {"AegisName":"Cold_Scroll_1_3"},
689: {"AegisName":"Cold_Scroll_1_5"},
690: {"AegisName":"Fire_Scroll_1_3"},
691: {"AegisName":"Fire_Scroll_1_5"},
692: {"AegisName":"Wind_Scroll_1_3"},
693: {"AegisName":"Wind_Scroll_1_5"},
694: {"AegisName":"Ghost_Scroll_1_3"},
695: {"AegisName":"Ghost_Scroll_1_5"},
696: {"AegisName":"Fire_Scroll_2_1"},
697: {"AegisName":"Fire_Scroll_2_5"},
698: {"AegisName":"Fire_Scroll_3_1"},
699: {"AegisName":"Fire_Scroll_3_5"},
700: {"AegisName":"Cold_Scroll_2_1"},
701: {"AegisName":"Ora_Ora"},
702: {"AegisName":"Animal_Blood"},
703: {"AegisName":"Hinalle"},
704: {"AegisName":"Aloe"},
705: {"AegisName":"Clover"},
706: {"AegisName":"Four_Leaf_Clover"},
707: {"AegisName":"Singing_Plant"},
708: {"AegisName":"Ment"},
709: {"AegisName":"Izidor"},
710: {"AegisName":"Illusion_Flower"},
711: {"AegisName":"Shoot"},
712: {"AegisName":"Flower"},
713: {"AegisName":"Empty_Bottle"},
714: {"AegisName":"Emperium"},
715: {"AegisName":"Yellow_Gemstone"},
716: {"AegisName":"Red_Gemstone"},
717: {"AegisName":"Blue_Gemstone"},
718: {"AegisName":"Dark_Red_Jewel"},
719: {"AegisName":"Violet_Jewel"},
720: {"AegisName":"Skyblue_Jewel"},
721: {"AegisName":"Azure_Jewel"},
722: {"AegisName":"Scarlet_Jewel"},
723: {"AegisName":"Cardinal_Jewel"},
724: {"AegisName":"Cardinal_Jewel_"},
725: {"AegisName":"Red_Jewel"},
726: {"AegisName":"Blue_Jewel"},
727: {"AegisName":"White_Jewel"},
728: {"AegisName":"Golden_Jewel"},
729: {"AegisName":"Bluish_Green_Jewel"},
730: {"AegisName":"Crystal_Jewel"},
731: {"AegisName":"Crystal_Jewel_"},
732: {"AegisName":"Crystal_Jewel__"},
733: {"AegisName":"Crystal_Jewel___"},
734: {"AegisName":"Red_Frame"},
735: {"AegisName":"Blue_Porcelain"},
736: {"AegisName":"White_Platter"},
737: {"AegisName":"Black_Ladle"},
738: {"AegisName":"Pencil_Case"},
739: {"AegisName":"Rouge"},
740: {"AegisName":"Stuffed_Doll"},
741: {"AegisName":"Poring_Doll"},
742: {"AegisName":"Chonchon_Doll"},
743: {"AegisName":"Spore_Doll"},
744: {"AegisName":"Bunch_Of_Flowers"},
745: {"AegisName":"Wedding_Bouquet"},
746: {"AegisName":"Glass_Bead"},
747: {"AegisName":"Crystal_Mirror"},
748: {"AegisName":"Witherless_Rose"},
749: {"AegisName":"Frozen_Rose"},
750: {"AegisName":"Baphomet_Doll"},
751: {"AegisName":"Osiris_Doll"},
752: {"AegisName":"Grasshopper_Doll"},
753: {"AegisName":"Monkey_Doll"},
754: {"AegisName":"Raccoondog_Doll"},
756: {"AegisName":"Oridecon_Stone"},
757: {"AegisName":"Elunium_Stone"},
766: {"AegisName":"Silky_Fur_Bundle"},
793: {"AegisName":"2ndTH_S_Booster_Ticket"},
824: {"AegisName":"3rdTH_Ragwart_Ticket"},
901: {"AegisName":"Danggie"},
902: {"AegisName":"Tree_Root"},
903: {"AegisName":"Reptile_Tongue"},
904: {"AegisName":"Scorpion's_Tail"},
905: {"AegisName":"Stem"},
906: {"AegisName":"Pointed_Scale"},
907: {"AegisName":"Resin"},
908: {"AegisName":"Spawn"},
909: {"AegisName":"Jellopy"},
910: {"AegisName":"Garlet"},
911: {"AegisName":"Scell"},
912: {"AegisName":"Zargon"},
913: {"AegisName":"Tooth_Of_Bat"},
914: {"AegisName":"Fluff"},
915: {"AegisName":"Chrysalis"},
916: {"AegisName":"Feather_Of_Birds"},
917: {"AegisName":"Talon"},
918: {"AegisName":"Sticky_Webfoot"},
919: {"AegisName":"Animal's_Skin"},
920: {"AegisName":"Claw_Of_Wolves"},
921: {"AegisName":"Mushroom_Spore"},
922: {"AegisName":"Orcish_Cuspid"},
923: {"AegisName":"Evil_Horn"},
924: {"AegisName":"Powder_Of_Butterfly"},
925: {"AegisName":"Bill_Of_Birds"},
926: {"AegisName":"Scale_Of_Snakes"},
928: {"AegisName":"Insect_Feeler"},
929: {"AegisName":"Immortal_Heart"},
930: {"AegisName":"Rotten_Bandage"},
931: {"AegisName":"Orcish_Voucher"},
932: {"AegisName":"Skel_Bone"},
934: {"AegisName":"Mementos"},
935: {"AegisName":"Shell"},
936: {"AegisName":"Scales_Shell"},
937: {"AegisName":"Posionous_Canine"},
938: {"AegisName":"Sticky_Mucus"},
939: {"AegisName":"Bee_Sting"},
940: {"AegisName":"Grasshopper's_Leg"},
941: {"AegisName":"Nose_Ring"},
942: {"AegisName":"Yoyo_Tail"},
943: {"AegisName":"Solid_Shell"},
944: {"AegisName":"Horseshoe"},
945: {"AegisName":"Raccoon_Leaf"},
946: {"AegisName":"Snail's_Shell"},
947: {"AegisName":"Horn"},
948: {"AegisName":"Bear's_Foot"},
949: {"AegisName":"Feather"},
950: {"AegisName":"Heart_Of_Mermaid"},
951: {"AegisName":"Fin"},
952: {"AegisName":"Cactus_Needle"},
953: {"AegisName":"Stone_Heart"},
954: {"AegisName":"Shining_Scales"},
955: {"AegisName":"Worm_Peelings"},
956: {"AegisName":"Gill"},
957: {"AegisName":"Decayed_Nail"},
958: {"AegisName":"Horrendous_Mouth"},
959: {"AegisName":"Rotten_Scale"},
960: {"AegisName":"Nipper"},
961: {"AegisName":"Conch"},
962: {"AegisName":"Tentacle"},
963: {"AegisName":"Sharp_Scale"},
964: {"AegisName":"Crap_Shell"},
965: {"AegisName":"Clam_Shell"},
966: {"AegisName":"Flesh_Of_Clam"},
967: {"AegisName":"Turtle_Shell"},
968: {"AegisName":"Voucher_Of_Orcish_Hero"},
969: {"AegisName":"Gold"},
970: {"AegisName":"Alchol"},
971: {"AegisName":"Detrimindexta"},
972: {"AegisName":"Karvodailnirol"},
973: {"AegisName":"Counteragent"},
974: {"AegisName":"Mixture"},
975: {"AegisName":"Scarlet_Dyestuffs"},
976: {"AegisName":"Lemon_Dyestuffs"},
978: {"AegisName":"Cobaltblue_Dyestuffs"},
979: {"AegisName":"Darkgreen_Dyestuffs"},
980: {"AegisName":"Orange_Dyestuffs"},
981: {"AegisName":"Violet_Dyestuffs"},
982: {"AegisName":"White_Dyestuffs"},
983: {"AegisName":"Black_Dyestuffs"},
984: {"AegisName":"Oridecon"},
985: {"AegisName":"Elunium"},
986: {"AegisName":"Anvil"},
987: {"AegisName":"Oridecon_Anvil"},
988: {"AegisName":"Golden_Anvil"},
989: {"AegisName":"Emperium_Anvil"},
990: {"AegisName":"Boody_Red"},
991: {"AegisName":"Crystal_Blue"},
992: {"AegisName":"Wind_Of_Verdure"},
993: {"AegisName":"Yellow_Live"},
994: {"AegisName":"Flame_Heart"},
995: {"AegisName":"Mistic_Frozen"},
996: {"AegisName":"Rough_Wind"},
997: {"AegisName":"Great_Nature"},
998: {"AegisName":"Iron"},
999: {"AegisName":"Steel"},
1000: {"AegisName":"Star_Crumb"},
1001: {"AegisName":"Sparkling_Dust"},
1002: {"AegisName":"Iron_Ore"},
1003: {"AegisName":"Coal"},
1004: {"AegisName":"Patriotism_Marks"},
1005: {"AegisName":"Hammer_Of_Blacksmith"},
1006: {"AegisName":"Old_Magic_Book"},
1007: {"AegisName":"Penetration"},
1008: {"AegisName":"Frozen_Heart"},
1009: {"AegisName":"Sacred_Marks"},
1010: {"AegisName":"Phracon"},
1011: {"AegisName":"Emveretarcon"},
1012: {"AegisName":"Lizard_Scruff"},
1013: {"AegisName":"Colorful_Shell"},
1014: {"AegisName":"Jaws_Of_Ant"},
1015: {"AegisName":"Thin_N'_Long_Tongue"},
1016: {"AegisName":"Rat_Tail"},
1017: {"AegisName":"Moustache_Of_Mole"},
1018: {"AegisName":"Nail_Of_Mole"},
1019: {"AegisName":"Wooden_Block"},
1020: {"AegisName":"Long_Hair"},
1021: {"AegisName":"Dokkaebi_Horn"},
1022: {"AegisName":"Fox_Tail"},
1023: {"AegisName":"Fish_Tail"},
1024: {"AegisName":"Chinese_Ink"},
1025: {"AegisName":"Spiderweb"},
1026: {"AegisName":"Acorn"},
1027: {"AegisName":"Porcupine_Spike"},
1028: {"AegisName":"Wild_Boar's_Mane"},
1029: {"AegisName":"Tiger's_Skin"},
1030: {"AegisName":"Tiger_Footskin"},
1031: {"AegisName":"Limb_Of_Mantis"},
1032: {"AegisName":"Blossom_Of_Maneater"},
1033: {"AegisName":"Root_Of_Maneater"},
1034: {"AegisName":"Cobold_Hair"},
1035: {"AegisName":"Dragon_Canine"},
1036: {"AegisName":"Dragon_Scale"},
1037: {"AegisName":"Dragon_Train"},
1038: {"AegisName":"Petite_DiablOfs_Horn"},
1039: {"AegisName":"Petite_DiablOfs_Wing"},
1040: {"AegisName":"Elder_Pixie's_Beard"},
1041: {"AegisName":"Lantern"},
1042: {"AegisName":"Short_Leg"},
1043: {"AegisName":"Nail_Of_Orc"},
1044: {"AegisName":"Tooth_Of_"},
1045: {"AegisName":"Sacred_Masque"},
1046: {"AegisName":"Tweezer"},
1047: {"AegisName":"Head_Of_Medusa"},
1048: {"AegisName":"Slender_Snake"},
1049: {"AegisName":"Skirt_Of_Virgin"},
1050: {"AegisName":"Tendon"},
1051: {"AegisName":"Detonator"},
1052: {"AegisName":"Single_Cell"},
1053: {"AegisName":"Tooth_Of_Ancient_Fish"},
1054: {"AegisName":"Lip_Of_Ancient_Fish"},
1055: {"AegisName":"Earthworm_Peeling"},
1056: {"AegisName":"Grit"},
1057: {"AegisName":"Moth_Dust"},
1058: {"AegisName":"Wing_Of_Moth"},
1059: {"AegisName":"Transparent_Cloth"},
1060: {"AegisName":"Golden_Hair"},
1061: {"AegisName":"Starsand_Of_Witch"},
1062: {"AegisName":"Pumpkin_Head"},
1063: {"AegisName":"Sharpened_Cuspid"},
1064: {"AegisName":"Reins"},
1065: {"AegisName":"Booby_Trap"},
1066: {"AegisName":"Tree_Of_Archer_1"},
1067: {"AegisName":"Tree_Of_Archer_2"},
1068: {"AegisName":"Tree_Of_Archer_3"},
1069: {"AegisName":"Mushroom_Of_Thief_1"},
1070: {"AegisName":"Mushroom_Of_Thief_2"},
1071: {"AegisName":"Mage_Test_1"},
1072: {"AegisName":"Delivery_Message"},
1073: {"AegisName":"Merchant_Voucher_1"},
1074: {"AegisName":"Merchant_Voucher_2"},
1075: {"AegisName":"Merchant_Voucher_3"},
1076: {"AegisName":"Merchant_Voucher_4"},
1077: {"AegisName":"Merchant_Voucher_5"},
1078: {"AegisName":"Merchant_Voucher_6"},
1079: {"AegisName":"Merchant_Voucher_7"},
1080: {"AegisName":"Merchant_Voucher_8"},
1081: {"AegisName":"Merchant_Box_1"},
1082: {"AegisName":"Merchant_Box_2"},
1083: {"AegisName":"Merchant_Box_3"},
1084: {"AegisName":"Kapra's_Pass"},
1085: {"AegisName":"Mage_Test_2"},
1086: {"AegisName":"Mage_Test_3"},
1087: {"AegisName":"Mage_Test_4"},
1088: {"AegisName":"Morocc_Potion"},
1089: {"AegisName":"Payon_Potion"},
1090: {"AegisName":"Mage_Test_Etc"},
1091: {"AegisName":"Merchant_Box_Etc"},
1092: {"AegisName":"Empty_Cylinder"},
1093: {"AegisName":"Empty_Potion"},
1094: {"AegisName":"Short_Daenggie"},
1095: {"AegisName":"Needle_Of_Alarm"},
1096: {"AegisName":"Round_Shell"},
1097: {"AegisName":"Worn_Out_Page"},
1098: {"AegisName":"Manacles"},
1099: {"AegisName":"Worn_Out_Prison_Uniform"},
1100: {"AegisName":"Taurus_Sword_J"},
1101: {"AegisName":"Sword"},
1102: {"AegisName":"Sword_"},
1103: {"AegisName":"Sword__"},
1104: {"AegisName":"Falchion"},
1105: {"AegisName":"Falchion_"},
1106: {"AegisName":"Falchion__"},
1107: {"AegisName":"Blade"},
1108: {"AegisName":"Blade_"},
1109: {"AegisName":"Blade__"},
1110: {"AegisName":"Lapier"},
1111: {"AegisName":"Lapier_"},
1112: {"AegisName":"Lapier__"},
1113: {"AegisName":"Scimiter"},
1114: {"AegisName":"Scimiter_"},
1115: {"AegisName":"Scimiter__"},
1116: {"AegisName":"Katana"},
1117: {"AegisName":"Katana_"},
1118: {"AegisName":"Katana__"},
1119: {"AegisName":"Tsurugi"},
1120: {"AegisName":"Tsurugi_"},
1121: {"AegisName":"Tsurugi__"},
1122: {"AegisName":"Ring_Pommel_Saber"},
1123: {"AegisName":"Haedonggum"},
1124: {"AegisName":"Orcish_Sword"},
1125: {"AegisName":"Ring_Pommel_Saber_"},
1126: {"AegisName":"Saber"},
1127: {"AegisName":"Saber_"},
1128: {"AegisName":"Hae_Dong_Gum_"},
1129: {"AegisName":"Flamberge"},
1130: {"AegisName":"Nagan"},
1131: {"AegisName":"Ice_Falchon"},
1132: {"AegisName":"Edge"},
1133: {"AegisName":"Fire_Brand"},
1134: {"AegisName":"Scissores_Sword"},
1135: {"AegisName":"Cutlas"},
1136: {"AegisName":"Solar_Sword"},
1137: {"AegisName":"Excalibur"},
1138: {"AegisName":"Mysteltainn_"},
1139: {"AegisName":"Tale_Fing_"},
1140: {"AegisName":"Byeorrun_Gum"},
1141: {"AegisName":"Immaterial_Sword"},
1142: {"AegisName":"Jewel_Sword"},
1143: {"AegisName":"Gaia_Sword"},
1144: {"AegisName":"Sasimi"},
1145: {"AegisName":"Holy_Avenger"},
1146: {"AegisName":"Town_Sword"},
1147: {"AegisName":"Town_Sword_"},
1148: {"AegisName":"Star_Dust_Blade"},
1149: {"AegisName":"Flamberge_"},
1150: {"AegisName":"Libra_Krasnaya_J"},
1151: {"AegisName":"Slayer"},
1152: {"AegisName":"Slayer_"},
1153: {"AegisName":"Slayer__"},
1154: {"AegisName":"Bastard_Sword"},
1155: {"AegisName":"Bastard_Sword_"},
1156: {"AegisName":"Bastard_Sword__"},
1157: {"AegisName":"Two_Hand_Sword"},
1158: {"AegisName":"Two_Hand_Sword_"},
1159: {"AegisName":"Two_Hand_Sword__"},
1160: {"AegisName":"Broad_Sword"},
1161: {"AegisName":"Balmung"},
1162: {"AegisName":"Broad_Sword_"},
1163: {"AegisName":"Claymore"},
1164: {"AegisName":"Muramasa"},
1165: {"AegisName":"Masamune"},
1166: {"AegisName":"Dragon_Slayer"},
1167: {"AegisName":"Schweizersabel"},
1168: {"AegisName":"Zweihander"},
1169: {"AegisName":"Executioner_"},
1170: {"AegisName":"Katzbalger"},
1171: {"AegisName":"Zweihander_"},
1172: {"AegisName":"Claymore_"},
1173: {"AegisName":"Muramasa_C"},
1174: {"AegisName":"Executioner_C"},
1175: {"AegisName":"Altas_Weapon"},
1176: {"AegisName":"Muscle_Cutter"},
1177: {"AegisName":"Muramash"},
1178: {"AegisName":"Schweizersabel_"},
1179: {"AegisName":"Executioner__"},
1180: {"AegisName":"Dragon_Slayer_"},
1181: {"AegisName":"Tae_Goo_Lyeon"},
1182: {"AegisName":"Bloody_Eater"},
1183: {"AegisName":"BF_Two_Handed_Sword1"},
1184: {"AegisName":"BF_Two_Handed_Sword2"},
1185: {"AegisName":"Violet_Fear"},
1186: {"AegisName":"Death_Guidance"},
1187: {"AegisName":"Krieger_Twohand_Sword1"},
1188: {"AegisName":"Veteran_Sword"},
1189: {"AegisName":"Krasnaya"},
1190: {"AegisName":"Claymore_C"},
1191: {"AegisName":"Alca_Bringer"},
1192: {"AegisName":"P_Slayer1"},
1193: {"AegisName":"P_Slayer2"},
1194: {"AegisName":"F_Executioner_C"},
1195: {"AegisName":"E_Executioner_C"},
1196: {"AegisName":"Chrome_Twohand_Sword"},
1197: {"AegisName":"P_Slayer3"},
1198: {"AegisName":"Hairtail"},
1199: {"AegisName":"Ebony_Toe_Nail"},
1201: {"AegisName":"Knife"},
1202: {"AegisName":"Knife_"},
1203: {"AegisName":"Knife__"},
1204: {"AegisName":"Cutter"},
1205: {"AegisName":"Cutter_"},
1206: {"AegisName":"Cutter__"},
1207: {"AegisName":"Main_Gauche"},
1208: {"AegisName":"Main_Gauche_"},
1209: {"AegisName":"Main_Gauche__"},
1210: {"AegisName":"Dirk"},
1211: {"AegisName":"Dirk_"},
1212: {"AegisName":"Dirk__"},
1213: {"AegisName":"Dagger"},
1214: {"AegisName":"Dagger_"},
1215: {"AegisName":"Dagger__"},
1216: {"AegisName":"Stiletto"},
1217: {"AegisName":"Stiletto_"},
1218: {"AegisName":"Stiletto__"},
1219: {"AegisName":"Gladius"},
1220: {"AegisName":"Gladius_"},
1221: {"AegisName":"Gladius__"},
1222: {"AegisName":"Damascus"},
1223: {"AegisName":"Forturn_Sword"},
1224: {"AegisName":"Sword_Breaker"},
1225: {"AegisName":"Mail_Breaker"},
1226: {"AegisName":"Damascus_"},
1227: {"AegisName":"Weeder_Knife"},
1228: {"AegisName":"Combat_Knife"},
1229: {"AegisName":"Mama's_Knife"},
1230: {"AegisName":"House_Auger"},
1231: {"AegisName":"Bazerald"},
1232: {"AegisName":"Assasin_Dagger"},
1233: {"AegisName":"Exercise"},
1234: {"AegisName":"Moonlight_Sword"},
1235: {"AegisName":"Azoth"},
1236: {"AegisName":"Sucsamad"},
1237: {"AegisName":"Grimtooth_"},
1238: {"AegisName":"Zeny_Knife"},
1239: {"AegisName":"Poison_Knife"},
1240: {"AegisName":"Princess_Knife"},
1241: {"AegisName":"Cursed_Dagger"},
1242: {"AegisName":"Counter_Dagger"},
1243: {"AegisName":"Novice_Knife"},
1244: {"AegisName":"Holy_Dagger"},
1245: {"AegisName":"Cinquedea"},
1246: {"AegisName":"Cinquedea_"},
1247: {"AegisName":"Kindling_Dagger"},
1248: {"AegisName":"Obsidian_Dagger"},
1249: {"AegisName":"Fisherman's_Dagger"},
1250: {"AegisName":"Jur"},
1251: {"AegisName":"Jur_"},
1252: {"AegisName":"Katar"},
1253: {"AegisName":"Katar_"},
1254: {"AegisName":"Jamadhar"},
1255: {"AegisName":"Jamadhar_"},
1256: {"AegisName":"Katar_Of_Cold_Icicle"},
1257: {"AegisName":"Katar_Of_Thornbush"},
1258: {"AegisName":"Katar_Of_Raging_Blaze"},
1259: {"AegisName":"Katar_Of_Piercing_Wind"},
1260: {"AegisName":"Ghoul_Leg"},
1261: {"AegisName":"Infiltrator"},
1262: {"AegisName":"Nail_Of_Loki"},
1263: {"AegisName":"Unholy_Touch"},
1264: {"AegisName":"Various_Jur"},
1265: {"AegisName":"Bloody_Roar"},
1266: {"AegisName":"Infiltrator_"},
1267: {"AegisName":"Infiltrator_C"},
1268: {"AegisName":"Wild_Beast_Claw"},
1269: {"AegisName":"Inverse_Scale"},
1270: {"AegisName":"Drill_Katar"},
1271: {"AegisName":"Blood_Tears"},
1272: {"AegisName":"Scratcher"},
1273: {"AegisName":"Bloody_Roar_C"},
1274: {"AegisName":"Unholy_Touch_C"},
1275: {"AegisName":"Katar_Of_Cold_Icicle_"},
1276: {"AegisName":"Katar_Of_Thornbush_"},
1277: {"AegisName":"Katar_Of_Raging_Blaze_"},
1278: {"AegisName":"Katar_Of_Piercing_Wind_"},
1279: {"AegisName":"BF_Katar1"},
1280: {"AegisName":"BF_Katar2"},
1281: {"AegisName":"Krieger_Katar1"},
1282: {"AegisName":"Krieger_Katar2"},
1283: {"AegisName":"Katar_Of_Speed"},
1284: {"AegisName":"Krishna"},
1285: {"AegisName":"Cakram"},
1286: {"AegisName":"Jamadhar_C"},
1287: {"AegisName":"Durga"},
1288: {"AegisName":"Bloody_Fear_C"},
1289: {"AegisName":"P_Katar1"},
1290: {"AegisName":"Agent_Katar"},
1291: {"AegisName":"Guillotine_Katar"},
1292: {"AegisName":"Upg_Katar"},
1293: {"AegisName":"Velum_Jamadhar"},
1294: {"AegisName":"Velum_Scare"},
1295: {"AegisName":"Blood_Tears_"},
1296: {"AegisName":"Metal_Katar"},
1297: {"AegisName":"Inverse_Scale_"},
1298: {"AegisName":"Shiver_Katar"},
1299: {"AegisName":"TE_Woe_Katar"},
1300: {"AegisName":"Cleaver_"},
1301: {"AegisName":"Axe"},
1302: {"AegisName":"Axe_"},
1303: {"AegisName":"Axe__"},
1304: {"AegisName":"Orcish_Axe"},
1305: {"AegisName":"Cleaver"},
1306: {"AegisName":"War_Axe"},
1307: {"AegisName":"Windhawk"},
1308: {"AegisName":"Golden_Axe"},
1309: {"AegisName":"Orcish_Axe_"},
1310: {"AegisName":"Krieger_Onehand_Axe1"},
1311: {"AegisName":"Vecer_Axe"},
1312: {"AegisName":"Orcish_Axe_C"},
1313: {"AegisName":"Tourist_Axe"},
1314: {"AegisName":"F_Tomahawk_C"},
1315: {"AegisName":"F_Right_Epsilon_C"},
1316: {"AegisName":"Adventure_Axe"},
1317: {"AegisName":"Academy_Axe"},
1318: {"AegisName":"Dofle_Axe"},
1319: {"AegisName":"TE_Woe_Axe"},
1320: {"AegisName":"Diva_Axe"},
1321: {"AegisName":"Dofle_Axe_"},
1322: {"AegisName":"Ru_Blue_Axe"},
1323: {"AegisName":"Ru_Gold_Axe"},
1324: {"AegisName":"War_Axe_S"},
1325: {"AegisName":"Mirage_Axe"},
1326: {"AegisName":"War_Axe_IL"},
1327: {"AegisName":"Axe_Z"},
1328: {"AegisName":"Blut_Axe"},
1329: {"AegisName":"Woe_One_Hand_Axe1_Z"},
1330: {"AegisName":"Sunset_Buster"},
1331: {"AegisName":"Variant_Axe"},
1332: {"AegisName":"Octopus_Axe"},
1333: {"AegisName":"Golden_Wrench"},
1334: {"AegisName":"Ein_1HAXE"},
1335: {"AegisName":"Cancer_Axe_J"},
1336: {"AegisName":"G_Knight_Axe"},
1337: {"AegisName":"Golden_Wrench_J"},
1339: {"AegisName":"Hauyne_Huuma_EXE"},
1340: {"AegisName":"Arcanite_Hammer_EXE"},
1341: {"AegisName":"Destruction_Axe"},
1350: {"AegisName":"Comp_Avenger"},
1351: {"AegisName":"Battle_Axe"},
1352: {"AegisName":"Battle_Axe_"},
1353: {"AegisName":"Battle_Axe__"},
1354: {"AegisName":"Hammer"},
1355: {"AegisName":"Hammer_"},
1356: {"AegisName":"Hammer__"},
1357: {"AegisName":"Buster"},
1358: {"AegisName":"Buster_"},
1359: {"AegisName":"Buster__"},
1360: {"AegisName":"Two_Handed_Axe"},
1361: {"AegisName":"Two_Handed_Axe_"},
1362: {"AegisName":"Two_Handed_Axe__"},
1363: {"AegisName":"Brood_Axe"},
1364: {"AegisName":"Great_Axe"},
1365: {"AegisName":"Sabbath"},
1366: {"AegisName":"Right_Epsilon"},
1367: {"AegisName":"Slaughter"},
1368: {"AegisName":"Tomahawk"},
1369: {"AegisName":"Guillotine"},
1370: {"AegisName":"Doom_Slayer"},
1371: {"AegisName":"Doom_Slayer_"},
1372: {"AegisName":"Right_Epsilon_C"},
1373: {"AegisName":"Brood_Axe_C"},
1374: {"AegisName":"Tomahawk_C"},
1375: {"AegisName":"Berdysz"},
1376: {"AegisName":"Heart_Breaker"},
1377: {"AegisName":"Hurricane_Fury"},
1378: {"AegisName":"Great_Axe_C"},
1379: {"AegisName":"BF_Two_Handed_Axe1"},
1380: {"AegisName":"BF_Two_Handed_Axe2"},
1381: {"AegisName":"N_Battle_Axe"},
1382: {"AegisName":"Krieger_Twohand_Axe1"},
1383: {"AegisName":"Holy_Celestial_Axe"},
1384: {"AegisName":"Veteran_Axe"},
1385: {"AegisName":"Bradium_Stonehammer"},
1386: {"AegisName":"Doom_Slayer_I"},
1387: {"AegisName":"Giant_Axe"},
1388: {"AegisName":"Two_Handed_Axe_C"},
1389: {"AegisName":"E_Tomahawk_C"},
1390: {"AegisName":"E_Right_Epsilon_C"},
1391: {"AegisName":"P_Two_Handed_Axe1"},
1392: {"AegisName":"Ygnus_Stale"},
1393: {"AegisName":"End_Sektura"},
1394: {"AegisName":"Upg_Two_Handed_Axe"},
1395: {"AegisName":"Velum_Buster"},
1396: {"AegisName":"Velum_Guillotine"},
1397: {"AegisName":"Bradium_Stonehammer_"},
1398: {"AegisName":"Metal_Two_Handed_Axe"},
1399: {"AegisName":"TE_Woe_Two_Handed_Axe"},
1400: {"AegisName":"Sinister_Spear"},
1401: {"AegisName":"Javelin"},
1402: {"AegisName":"Javelin_"},
1403: {"AegisName":"Javelin__"},
1404: {"AegisName":"Spear"},
1405: {"AegisName":"Spear_"},
1406: {"AegisName":"Spear__"},
1407: {"AegisName":"Pike"},
1408: {"AegisName":"Pike_"},
1409: {"AegisName":"Pike__"},
1410: {"AegisName":"Lance"},
1411: {"AegisName":"Lance_"},
1412: {"AegisName":"Lance__"},
1413: {"AegisName":"Gungnir"},
1414: {"AegisName":"Gelerdria"},
1415: {"AegisName":"Skewer"},
1416: {"AegisName":"Tjungkuletti"},
1417: {"AegisName":"Pole_Axe"},
1418: {"AegisName":"Gungnir_"},
1419: {"AegisName":"Pole_Axe_C"},
1420: {"AegisName":"Long_Horn"},
1421: {"AegisName":"Battle_Hook"},
1422: {"AegisName":"Hunting_Spear"},
1423: {"AegisName":"Pole_XO"},
1424: {"AegisName":"Skewer_C"},
1425: {"AegisName":"BF_Spear1"},
1426: {"AegisName":"Krieger_Onehand_Spear1"},
1427: {"AegisName":"Spear_Of_Excellent"},
1428: {"AegisName":"Long_Horn_M"},
1429: {"AegisName":"Hunting_Spear_M"},
1430: {"AegisName":"Pike_C"},
1431: {"AegisName":"F_Pole_Axe_C"},
1432: {"AegisName":"E_Pole_Axe_C"},
1433: {"AegisName":"Imperial_Spear"},
1434: {"AegisName":"P_Sphere1"},
1435: {"AegisName":"Cannon_Spear"},
1436: {"AegisName":"Velum_Spear"},
1437: {"AegisName":"TE_Woe_Pike"},
1438: {"AegisName":"Thanos_Spear"},
1439: {"AegisName":"Half_BF_Spear1"},
1440: {"AegisName":"Battle_Hook_"},
1441: {"AegisName":"Ru_Blue_Spear"},
1442: {"AegisName":"Ru_Gold_Spear"},
1443: {"AegisName":"Scarlet_Spear"},
1444: {"AegisName":"Spear_of_Trust"},
1445: {"AegisName":"Spear_of_Trust2"},
1446: {"AegisName":"Thanos_Spear_J"},
1447: {"AegisName":"Poison_Forged_Spear"},
1448: {"AegisName":"UnrivaledSpear"},
1449: {"AegisName":"Gelerdria_"},
1450: {"AegisName":"Sinister_Lance"},
1451: {"AegisName":"Guisarme"},
1452: {"AegisName":"Guisarme_"},
1453: {"AegisName":"Guisarme__"},
1454: {"AegisName":"Glaive"},
1455: {"AegisName":"Glaive_"},
1456: {"AegisName":"Glaive__"},
1457: {"AegisName":"Partizan"},
1458: {"AegisName":"Partizan_"},
1459: {"AegisName":"Partizan__"},
1460: {"AegisName":"Trident"},
1461: {"AegisName":"Trident_"},
1462: {"AegisName":"Trident__"},
1463: {"AegisName":"Halberd"},
1464: {"AegisName":"Halberd_"},
1465: {"AegisName":"Halberd__"},
1466: {"AegisName":"Crescent_Scythe"},
1467: {"AegisName":"Bill_Guisarme"},
1468: {"AegisName":"Zephyrus"},
1469: {"AegisName":"Longinus's_Spear"},
1470: {"AegisName":"Brionac"},
1471: {"AegisName":"Hell_Fire"},
1472: {"AegisName":"Staff_Of_Soul"},
1473: {"AegisName":"Wizardy_Staff"},
1474: {"AegisName":"Gae_Bolg"},
1475: {"AegisName":"Horseback_Lance"},
1476: {"AegisName":"Crescent_Scythe_"},
1477: {"AegisName":"Spectral_Spear"},
1478: {"AegisName":"Ahlspiess"},
1479: {"AegisName":"Spectral_Spear_"},
1480: {"AegisName":"Gae_Bolg_"},
1481: {"AegisName":"Zephyrus_"},
1482: {"AegisName":"BF_Lance1"},
1483: {"AegisName":"Ivory_Lance"},
1484: {"AegisName":"Cardo"},
1485: {"AegisName":"Battle_Fork"},
1486: {"AegisName":"Krieger_Twohand_Spear1"},
1487: {"AegisName":"Lance_C"},
1488: {"AegisName":"Ahlspiess_C"},
1489: {"AegisName":"Spearfish_"},
1490: {"AegisName":"Giant_Lance"},
1491: {"AegisName":"Upg_Lance"},
1492: {"AegisName":"Velum_Glaive"},
1493: {"AegisName":"Metal_Lance"},
1494: {"AegisName":"Undine_Spear"},
1495: {"AegisName":"TE_Woe_Lance"},
1496: {"AegisName":"Thanos_Long_Spear"},
1497: {"AegisName":"Hell_Fire_S"},
1498: {"AegisName":"Scarlet_Lance"},
1499: {"AegisName":"Thanos_Long_Spear_J"},
1501: {"AegisName":"Club"},
1502: {"AegisName":"Club_"},
1503: {"AegisName":"Club__"},
1504: {"AegisName":"Mace"},
1505: {"AegisName":"Mace_"},
1506: {"AegisName":"Mace__"},
1507: {"AegisName":"Smasher"},
1508: {"AegisName":"Smasher_"},
1509: {"AegisName":"Smasher__"},
1510: {"AegisName":"Flail"},
1511: {"AegisName":"Flail_"},
1512: {"AegisName":"Flail__"},
1513: {"AegisName":"Morning_Star"},
1514: {"AegisName":"Morning_Star_"},
1515: {"AegisName":"Morning_Star__"},
1516: {"AegisName":"Sword_Mace"},
1517: {"AegisName":"Sword_Mace_"},
1518: {"AegisName":"Sword_Mace__"},
1519: {"AegisName":"Chain"},
1520: {"AegisName":"Chain_"},
1521: {"AegisName":"Chain__"},
1522: {"AegisName":"Stunner"},
1523: {"AegisName":"Spike"},
1524: {"AegisName":"Golden_Mace"},
1525: {"AegisName":"Long_Mace"},
1526: {"AegisName":"Slash"},
1527: {"AegisName":"Quadrille"},
1528: {"AegisName":"Grand_Cross"},
1529: {"AegisName":"Iron_Driver"},
1530: {"AegisName":"Mjolnir"},
1531: {"AegisName":"Spanner"},
1532: {"AegisName":"Stunner_"},
1533: {"AegisName":"Warrior_Balmung"},
1534: {"AegisName":"Spanner_C"},
1535: {"AegisName":"Hollgrehenn_Hammer"},
1536: {"AegisName":"Good_Morning_Star"},
1537: {"AegisName":"Quadrille_C"},
1538: {"AegisName":"Spike_"},
1539: {"AegisName":"Golden_Mace_"},
1540: {"AegisName":"Grand_Cross_"},
1541: {"AegisName":"Nemesis"},
1542: {"AegisName":"BF_Morning_Star1"},
1543: {"AegisName":"BF_Morning_Star2"},
1544: {"AegisName":"Lunakaligo"},
1545: {"AegisName":"N_Mace"},
1546: {"AegisName":"Krieger_Onehand_Mace1"},
1547: {"AegisName":"Mace_Of_Madness"},
1548: {"AegisName":"Veteran_Hammer"},
1549: {"AegisName":"Pilebuncker"},
1550: {"AegisName":"Book"},
1551: {"AegisName":"Bible"},
1552: {"AegisName":"Tablet"},
1553: {"AegisName":"Book_Of_Billows"},
1554: {"AegisName":"Book_Of_Mother_Earth"},
1555: {"AegisName":"Book_Of_Blazing_Sun"},
1556: {"AegisName":"Book_Of_Gust_Of_Wind"},
1557: {"AegisName":"Book_Of_The_Apocalypse"},
1558: {"AegisName":"Girl's_Diary"},
1559: {"AegisName":"Legacy_Of_Dragon"},
1560: {"AegisName":"Diary_Of_Great_Sage"},
1561: {"AegisName":"Hardback"},
1562: {"AegisName":"Bible_Of_Battlefield"},
1563: {"AegisName":"Diary_Of_Great_Sage_C"},
1564: {"AegisName":"Encyclopedia"},
1565: {"AegisName":"Death_Note"},
1566: {"AegisName":"Diary_Of_Great_Basil"},
1567: {"AegisName":"Hardback_C"},
1568: {"AegisName":"Book_Of_Billows_"},
1569: {"AegisName":"Book_Of_Mother_Earth_"},
1570: {"AegisName":"Book_Of_Blazing_Sun_"},
1571: {"AegisName":"Book_Of_Gust_Of_Wind_"},
1572: {"AegisName":"Principles_Of_Magic"},
1573: {"AegisName":"Ancient_Magic"},
1574: {"AegisName":"BF_Book1"},
1575: {"AegisName":"BF_Book2"},
1576: {"AegisName":"Krieger_Book1"},
1577: {"AegisName":"Krieger_Book2"},
1578: {"AegisName":"Book_Of_Prayer"},
1579: {"AegisName":"Death_Note_M"},
1580: {"AegisName":"Encyclopedia_C"},
1581: {"AegisName":"F_Diary_Of_Great_Sage_C"},
1582: {"AegisName":"E_Diary_Of_Great_Sage_C"},
1583: {"AegisName":"P_Dic1"},
1584: {"AegisName":"Chilly_Spell_Book"},
1585: {"AegisName":"Upg_Book"},
1586: {"AegisName":"Velum_Bible"},
1587: {"AegisName":"Velum_Encyclopedia"},
1588: {"AegisName":"Metal_Book"},
1589: {"AegisName":"Legacy_Of_Dragon_"},
1590: {"AegisName":"Snake_Encyclopedia"},
1591: {"AegisName":"TE_Woe_Book"},
1592: {"AegisName":"Thor_Pedigree_Book"},
1593: {"AegisName":"Book_Of_Destiny"},
1594: {"AegisName":"Fire_Pedigree_Book"},
1595: {"AegisName":"Ice_Pedigree_Book"},
1596: {"AegisName":"Earth_Pedigree_Book"},
1597: {"AegisName":"Half_BF_Book2"},
1598: {"AegisName":"Snake_Encyclopedia_"},
1599: {"AegisName":"Angra_Manyu"},
1600: {"AegisName":"Sinister_Rod"},
1601: {"AegisName":"Rod"},
1602: {"AegisName":"Rod_"},
1603: {"AegisName":"Rod__"},
1604: {"AegisName":"Wand"},
1605: {"AegisName":"Wand_"},
1606: {"AegisName":"Wand__"},
1607: {"AegisName":"Staff"},
1608: {"AegisName":"Staff_"},
1609: {"AegisName":"Staff__"},
1610: {"AegisName":"Arc_Wand"},
1611: {"AegisName":"Arc_Wand_"},
1612: {"AegisName":"Arc_Wand__"},
1613: {"AegisName":"Mighty_Staff"},
1614: {"AegisName":"Blessed_Wand"},
1615: {"AegisName":"Bone_Wand"},
1616: {"AegisName":"Staff_Of_Wing"},
1617: {"AegisName":"Survival_Rod"},
1618: {"AegisName":"Survival_Rod_"},
1619: {"AegisName":"Survival_Rod2"},
1620: {"AegisName":"Survival_Rod2_"},
1621: {"AegisName":"Hypnotist's_Staff"},
1622: {"AegisName":"Hypnotist's_Staff_"},
1623: {"AegisName":"Mighty_Staff_C"},
1624: {"AegisName":"Lich_Bone_Wand"},
1625: {"AegisName":"Healing_Staff"},
1626: {"AegisName":"Piercing_Staff"},
1627: {"AegisName":"Staffy"},
1628: {"AegisName":"Survival_Rod_C"},
1629: {"AegisName":"Walking_Stick"},
1630: {"AegisName":"Release_Of_Wish"},
1631: {"AegisName":"Holy_Stick"},
1632: {"AegisName":"BF_Staff1"},
1633: {"AegisName":"BF_Staff2"},
1634: {"AegisName":"BF_Staff3"},
1635: {"AegisName":"BF_Staff4"},
1636: {"AegisName":"Thorn_Staff"},
1637: {"AegisName":"Eraser"},
1638: {"AegisName":"Healing_Staff_C"},
1639: {"AegisName":"N_Rod"},
1640: {"AegisName":"Krieger_Onehand_Staff1"},
1641: {"AegisName":"Krieger_Onehand_Staff2"},
1642: {"AegisName":"Staff_Of_Darkness"},
1643: {"AegisName":"Dead_Tree_Cane"},
1644: {"AegisName":"Piercing_Staff_M"},
1645: {"AegisName":"Lich_Bone_Wand_M"},
1646: {"AegisName":"La'cryma_Stick"},
1647: {"AegisName":"Croce_Staff"},
1648: {"AegisName":"Staff_Of_Bordeaux"},
1649: {"AegisName":"Rafini_Staff"},
1650: {"AegisName":"P_Staff1"},
1651: {"AegisName":"P_Staff2"},
1652: {"AegisName":"Tourist_Staff"},
1653: {"AegisName":"Staff_Of_Healing_C"},
1654: {"AegisName":"Mental_Stick"},
1655: {"AegisName":"Adventure_Staff"},
1656: {"AegisName":"Academy_Wand"},
1657: {"AegisName":"Wand_Of_Affection"},
1658: {"AegisName":"P_Staff3"},
1659: {"AegisName":"Recovery_Light"},
1660: {"AegisName":"Wand_Of_Affection2"},
1661: {"AegisName":"Mental_Destroyer"},
1662: {"AegisName":"Bone_Wand_"},
1663: {"AegisName":"Staff_Of_Bordeaux_"},
1664: {"AegisName":"Thorn_Staff_"},
1665: {"AegisName":"Piercing_Staff_"},
1666: {"AegisName":"Healing_Staff_"},
1667: {"AegisName":"TE_Woe_Staff"},
1668: {"AegisName":"Sword_Stick"},
1669: {"AegisName":"Thanos_Staff"},
1670: {"AegisName":"RWC_Memory_Staff"},
1671: {"AegisName":"Staff_Of_Evil_Slayer"},
1672: {"AegisName":"Safety_Rod"},
1673: {"AegisName":"Half_BF_Staff4"},
1674: {"AegisName":"Half_BF_Staff2"},
1675: {"AegisName":"Walking_Stick_"},
1676: {"AegisName":"Baculum_Daemonicum"},
1677: {"AegisName":"Ru_Blue_Wand"},
1678: {"AegisName":"Ru_Gold_Wand"},
1679: {"AegisName":"Rafini_Staff_S"},
1680: {"AegisName":"Scarlet_Rod"},
1681: {"AegisName":"Newbie_Foxtail"},
1682: {"AegisName":"Shadow_Staff"},
1683: {"AegisName":"Abundantly_Foxtail"},
1684: {"AegisName":"Long_Foxtail"},
1685: {"AegisName":"DragonFry_Foxtail"},
1686: {"AegisName":"BigSize_Foxtail"},
1687: {"AegisName":"Beginner_FoxTail"},
1688: {"AegisName":"Staff_of_Trust"},
1689: {"AegisName":"Staff_of_Trust2"},
1690: {"AegisName":"Amazing_Foxtail"},
1691: {"AegisName":"Strange_Foxtail"},
1692: {"AegisName":"Magical_Foxtail"},
1693: {"AegisName":"Magical_Y_Foxtail"},
1694: {"AegisName":"Model_Foxtail"},
1695: {"AegisName":"Detail_Model_Foxtail"},
1696: {"AegisName":"Ex_Model_Foxtail"},
1697: {"AegisName":"Ex_Y_Model_Foxtail"},
1698: {"AegisName":"Thanos_Staff_J"},
1699: {"AegisName":"P_Foxtail1"},
1701: {"AegisName":"Bow"},
1702: {"AegisName":"Bow_"},
1703: {"AegisName":"Bow__"},
1704: {"AegisName":"Composite_Bow"},
1705: {"AegisName":"Composite_Bow_"},
1706: {"AegisName":"Composite_Bow__"},
1707: {"AegisName":"Great_Bow"},
1708: {"AegisName":"Great_Bow_"},
1709: {"AegisName":"Great_Bow__"},
1710: {"AegisName":"CrossBow"},
1711: {"AegisName":"CrossBow_"},
1712: {"AegisName":"CrossBow__"},
1713: {"AegisName":"Arbalest"},
1714: {"AegisName":"Kakkung"},
1715: {"AegisName":"Arbalest_"},
1716: {"AegisName":"Kakkung_"},
1718: {"AegisName":"Hunter_Bow"},
1719: {"AegisName":"Bow_Of_Roguemaster"},
1720: {"AegisName":"Bow_Of_Rudra"},
1721: {"AegisName":"Repeting_CrossBow"},
1722: {"AegisName":"Balistar"},
1723: {"AegisName":"Luna_Bow"},
1724: {"AegisName":"Dragon_Wing"},
1725: {"AegisName":"Bow_Of_Minstrel"},
1726: {"AegisName":"Hunter_Bow_"},
1727: {"AegisName":"Balistar_"},
1728: {"AegisName":"Balistar_C"},
1729: {"AegisName":"Bow_Of_Rudra_C"},
1730: {"AegisName":"Burning_Bow"},
1731: {"AegisName":"Frozen_Bow"},
1732: {"AegisName":"Earth_Bow"},
1733: {"AegisName":"Gust_Bow"},
1734: {"AegisName":"Orc_Archer_Bow"},
1735: {"AegisName":"Kkakkung"},
1736: {"AegisName":"Double_Bound"},
1737: {"AegisName":"Ixion_Wing"},
1738: {"AegisName":"BF_Bow1"},
1739: {"AegisName":"BF_Bow2"},
1740: {"AegisName":"Nepenthes_Bow"},
1741: {"AegisName":"Cursed_Lyre"},
1742: {"AegisName":"N_Composite_Bow"},
1743: {"AegisName":"Krieger_Bow1"},
1744: {"AegisName":"Bow_Of_Evil"},
1745: {"AegisName":"Falken_Blitz"},
1746: {"AegisName":"Elven_Bow"},
1747: {"AegisName":"P_Bow1"},
1748: {"AegisName":"P_Bow2"},
1749: {"AegisName":"Tourist_Bow"},
1750: {"AegisName":"Arrow"},
1751: {"AegisName":"Silver_Arrow"},
1752: {"AegisName":"Fire_Arrow"},
1753: {"AegisName":"Steel_Arrow"},
1754: {"AegisName":"Crystal_Arrow"},
1755: {"AegisName":"Arrow_Of_Wind"},
1756: {"AegisName":"Stone_Arrow"},
1757: {"AegisName":"Immatrial_Arrow"},
1758: {"AegisName":"Stun_Arrow"},
1759: {"AegisName":"Freezing_Arrow"},
1760: {"AegisName":"Flash_Arrow"},
1761: {"AegisName":"Curse_Arrow"},
1762: {"AegisName":"Rusty_Arrow"},
1763: {"AegisName":"Poison_Arrow"},
1764: {"AegisName":"Incisive_Arrow"},
1765: {"AegisName":"Oridecon_Arrow"},
1766: {"AegisName":"Arrow_Of_Counter_Evil"},
1767: {"AegisName":"Arrow_Of_Shadow"},
1768: {"AegisName":"Sleep_Arrow"},
1769: {"AegisName":"Silence_Arrow"},
1770: {"AegisName":"Iron_Arrow"},
1771: {"AegisName":"Venom_Knife"},
1772: {"AegisName":"Holy_Arrow"},
1773: {"AegisName":"Arrow_Of_Elf"},
1774: {"AegisName":"Hunting_Arrow"},
1775: {"AegisName":"Siege_Arrow_S"},
1776: {"AegisName":"Siege_Arrow_A"},
1800: {"AegisName":"Sinister_Fist"},
1801: {"AegisName":"Waghnakh"},
1802: {"AegisName":"Waghnakh_"},
1803: {"AegisName":"Knuckle_Duster"},
1804: {"AegisName":"Knuckle_Duster_"},
1805: {"AegisName":"Hora"},
1806: {"AegisName":"Hora_"},
1807: {"AegisName":"Fist"},
1808: {"AegisName":"Fist_"},
1809: {"AegisName":"Claw"},
1810: {"AegisName":"Claw_"},
1811: {"AegisName":"Finger"},
1812: {"AegisName":"Finger_"},
1813: {"AegisName":"Kaiser_Knuckle"},
1814: {"AegisName":"Berserk"},
1815: {"AegisName":"Claw_Of_Garm"},
1816: {"AegisName":"Berserk_"},
1817: {"AegisName":"Kaiser_Knuckle_C"},
1818: {"AegisName":"Magma_Fist"},
1819: {"AegisName":"Icicle_Fist"},
1820: {"AegisName":"Electric_Fist"},
1821: {"AegisName":"Seismic_Fist"},
1822: {"AegisName":"Combo_Battle_Glove"},
1823: {"AegisName":"BF_Knuckle1"},
1824: {"AegisName":"BF_Knuckle2"},
1825: {"AegisName":"Horn_Of_Hilthrion"},
1826: {"AegisName":"Krieger_Knuckle1"},
1827: {"AegisName":"Krieger_Knuckle2"},
1828: {"AegisName":"Monk_Knuckle"},
1829: {"AegisName":"Fist_C"},
1830: {"AegisName":"Sura_Rampage"},
1831: {"AegisName":"P_Knuckle1"},
1832: {"AegisName":"Velum_Claw"},
1833: {"AegisName":"Claw_Of_Flash"},
1834: {"AegisName":"TE_Woe_Fist"},
1835: {"AegisName":"Spartacus"},
1836: {"AegisName":"Thanos_Knuckle"},
1837: {"AegisName":"Iron_nail"},
1838: {"AegisName":"Half_BF_Knuckle1"},
1839: {"AegisName":"Scarlet_Knuckle"},
1840: {"AegisName":"Thanos_Knuckle_J"},
1841: {"AegisName":"Claw_Of_Flash_"},
1842: {"AegisName":"Diva_Claw"},
1843: {"AegisName":"Mirage_Claw"},
1844: {"AegisName":"Sinister_Fist_J"},
1845: {"AegisName":"Probation_Knuckle"},
1846: {"AegisName":"Combo_Battle_Glove_IL"},
1847: {"AegisName":"Iron_Nail_K"},
1848: {"AegisName":"Rebeginer_SR_Nuckle"},
1857: {"AegisName":"Local01_Claw"},
1858: {"AegisName":"Local02_Claw"},
1859: {"AegisName":"Woe_Pist1_Z"},
1861: {"AegisName":"Variant_Claw"},
1862: {"AegisName":"Burning_Knuckle_OS"},
1864: {"AegisName":"Evt_Iron_Nail_K"},
1865: {"AegisName":"Combo_Fist"},
1866: {"AegisName":"Asura_Bandage"},
1867: {"AegisName":"Ein_1HKNUCK"},
1868: {"AegisName":"Combo_Fist_J"},
1869: {"AegisName":"Asura_Bandage_J"},
1870: {"AegisName":"R_Knuckle"},
1871: {"AegisName":"Bauxite_Knuckle_EXE"},
1872: {"AegisName":"Knuckle_Of_Infinite"},
1873: {"AegisName":"Comp_Iron_Nail_K"},
1900: {"AegisName":"Sinister_Viollin"},
1901: {"AegisName":"Violin"},
1902: {"AegisName":"Violin_"},
1903: {"AegisName":"Mandolin"},
1904: {"AegisName":"Mandolin_"},
1905: {"AegisName":"Lute"},
1906: {"AegisName":"Lute_"},
1907: {"AegisName":"Guitar"},
1908: {"AegisName":"Guitar_"},
1909: {"AegisName":"Harp"},
1910: {"AegisName":"Harp_"},
1911: {"AegisName":"Guh_Moon_Goh"},
1912: {"AegisName":"Guh_Moon_Goh_"},
1913: {"AegisName":"Electronic_Guitar"},
1914: {"AegisName":"Guitar_Of_Passion"},
1915: {"AegisName":"Guitar_Of_Blue_Solo"},
1916: {"AegisName":"Guitar_Of_Vast_Land"},
1917: {"AegisName":"Guitar_Of_Gentle_Breeze"},
1918: {"AegisName":"Oriental_Lute"},
1919: {"AegisName":"Base_Guitar"},
1920: {"AegisName":"Berserk_Guitar"},
1921: {"AegisName":"Guh_Moon_Gom"},
1922: {"AegisName":"Oriental_Lute_"},
1923: {"AegisName":"BF_Instrument1"},
1924: {"AegisName":"BF_Instrument2"},
1925: {"AegisName":"Cello"},
1926: {"AegisName":"Harp_Of_Nepenthes"},
1927: {"AegisName":"Krieger_Instrument1"},
1928: {"AegisName":"Berserk_Guitar_I"},
1929: {"AegisName":"Guitar_C"},
1930: {"AegisName":"Green_Whistle"},
1931: {"AegisName":"P_String_Inst1"},
1932: {"AegisName":"TE_Woe_Guitar"},
1933: {"AegisName":"Thanos_Violin"},
1934: {"AegisName":"Contabass"},
1935: {"AegisName":"Ukulele_Of_Newoz"},
1936: {"AegisName":"Ru_Blue_Violin"},
1937: {"AegisName":"Ru_Gold_Violin"},
1938: {"AegisName":"Viollin_Of_Infinite"},
1939: {"AegisName":"Scarlet_Viollin"},
1940: {"AegisName":"Trumpet_Shell"},
1941: {"AegisName":"Union_Viollin"},
1942: {"AegisName":"Thanos_Violin_J"},
1943: {"AegisName":"Erhu"},
1944: {"AegisName":"Hippie_Guitar"},
1945: {"AegisName":"Diva_Viollin"},
1946: {"AegisName":"Mirage_Viollin"},
1947: {"AegisName":"Sinister_Viollin_J"},
1948: {"AegisName":"Hippie_Guitar_J"},
1949: {"AegisName":"2nd_Job_Weapon12"},
1950: {"AegisName":"Rope"},
1951: {"AegisName":"Rope_"},
1952: {"AegisName":"Line"},
1953: {"AegisName":"Line_"},
1954: {"AegisName":"Wire"},
1955: {"AegisName":"Wire_"},
1956: {"AegisName":"Rante"},
1957: {"AegisName":"Rante_"},
1958: {"AegisName":"Tail"},
1959: {"AegisName":"Tail_"},
1960: {"AegisName":"Whip"},
1961: {"AegisName":"Whip_"},
1962: {"AegisName":"Lariat"},
1963: {"AegisName":"Rapture_Rose"},
1964: {"AegisName":"Chemeti"},
1965: {"AegisName":"Whip_Of_Red_Flame"},
1966: {"AegisName":"Whip_Of_Ice_Piece"},
1967: {"AegisName":"Whip_Of_Earth"},
1968: {"AegisName":"Jump_Rope"},
1969: {"AegisName":"Bladed_Whip"},
1970: {"AegisName":"Queen's_Whip"},
1971: {"AegisName":"Electric_Wire"},
1972: {"AegisName":"Electric_Eel"},
1973: {"AegisName":"Sea_Witch_Foot"},
1974: {"AegisName":"Carrot_Whip"},
1975: {"AegisName":"Queen_Is_Whip"},
1976: {"AegisName":"Queen's_Whip_"},
1977: {"AegisName":"BF_Whip1"},
1978: {"AegisName":"BF_Whip2"},
1979: {"AegisName":"Stem_Of_Nepenthes"},
1980: {"AegisName":"Whip_Of_Balance"},
1981: {"AegisName":"Krieger_Whip1"},
1982: {"AegisName":"Phenomena_Whip"},
1983: {"AegisName":"Rante_C"},
1984: {"AegisName":"Stem_Whip"},
1985: {"AegisName":"Rosebine"},
1986: {"AegisName":"P_Tail1"},
1987: {"AegisName":"TE_Woe_Rope"},
1988: {"AegisName":"Thanos_Whip"},
1989: {"AegisName":"Gymnastics_Ribbon"},
1990: {"AegisName":"Floral_Mic_Of_Igu"},
1991: {"AegisName":"Ru_Blue_Whip"},
1992: {"AegisName":"Ru_Gold_Whip"},
1993: {"AegisName":"Concertina_Wire"},
1994: {"AegisName":"Whip_Of_Infinite"},
1995: {"AegisName":"Scarlet_Wire"},
1996: {"AegisName":"Sinister_Wire"},
1997: {"AegisName":"Union_Wire"},
1998: {"AegisName":"Thanos_Whip_J"},
1999: {"AegisName":"Moonlight_Bell"},
2000: {"AegisName":"Destruction_Rod"},
2001: {"AegisName":"Divine_Cross"},
2002: {"AegisName":"Krieger_Twohand_Staff1"},
2003: {"AegisName":"Destruction_Rod_M"},
2004: {"AegisName":"Kronos"},
2005: {"AegisName":"Dea_Staff"},
2006: {"AegisName":"G_Staff_Of_Light"},
2007: {"AegisName":"Golden_Rod_Staff"},
2008: {"AegisName":"Aqua_Staff"},
2009: {"AegisName":"Crimson_Staff"},
2010: {"AegisName":"Forest_Staff"},
2011: {"AegisName":"Golden_Rod_Staff2"},
2012: {"AegisName":"Aqua_Staff2"},
2013: {"AegisName":"Crimson_Staff2"},
2014: {"AegisName":"Forest_Staff2"},
2015: {"AegisName":"Upg_Staff"},
2016: {"AegisName":"Velum_Arc_Wand"},
2017: {"AegisName":"Divine_Cross_"},
2018: {"AegisName":"Metal_Staff"},
2019: {"AegisName":"TE_Woe_Two_Hand_Staff"},
2020: {"AegisName":"Jormungand"},
2021: {"AegisName":"Ganbantein"},
2022: {"AegisName":"Staff_Of_Geffen"},
2023: {"AegisName":"Thanos_Rod"},
2024: {"AegisName":"D_Staff_Of_Infinite"},
2025: {"AegisName":"Scarlet_Staff"},
2026: {"AegisName":"Sinister_Staff"},
2027: {"AegisName":"Staff_170"},
2028: {"AegisName":"Aion_Staff"},
2029: {"AegisName":"TStaff_Of_E_Slayer_J"},
2030: {"AegisName":"Union_Twohand_Staff"},
2031: {"AegisName":"Tw_Staff_Of_Malang_J"},
2032: {"AegisName":"Thanos_Rod_J"},
2033: {"AegisName":"Toughen_Metal_Staff"},
2034: {"AegisName":"Avenger_Wizardy_Staff"},
2035: {"AegisName":"Diva_Staff"},
2036: {"AegisName":"Mirage_Staff"},
2037: {"AegisName":"Sinister_Staff_J"},
2038: {"AegisName":"Staff_170_J"},
2039: {"AegisName":"Wizardy_Staff_IL"},
2040: {"AegisName":"Probation_Staff"},
2041: {"AegisName":"Jirant_Staff"},
2042: {"AegisName":"Neev_Wizardy_Staff"},
2043: {"AegisName":"Neev_Arc_Wand"},
2044: {"AegisName":"Neev_Holy_Stick"},
2045: {"AegisName":"Neev_Divine_Cross"},
2046: {"AegisName":"Rebeginer_WL_Staff"},
2047: {"AegisName":"Jirant_Staff_BR"},
2048: {"AegisName":"Iron_Staff"},
2049: {"AegisName":"Staff_Of_Blue_Flame"},
2050: {"AegisName":"2nd_Job_Weapon8"},
2051: {"AegisName":"Survival_Staff_IL"},
2052: {"AegisName":"Woe_T_Staff1_Z"},
2053: {"AegisName":"Variant_Staff"},
2054: {"AegisName":"Evt_Iron_Staff"},
2055: {"AegisName":"Staff_Of_Miracle"},
2056: {"AegisName":"Gravitation_Staff"},
2057: {"AegisName":"Adorare_Staff"},
2058: {"AegisName":"Ein_BHSTAFF"},
2059: {"AegisName":"Survival_Staff_IL_J"},
2060: {"AegisName":"R_Magician_Staff"},
2061: {"AegisName":"Staff_Of_Miracle_J"},
2062: {"AegisName":"Gravitation_Staff_J"},
2063: {"AegisName":"Adorare_Staff_J"},
2064: {"AegisName":"Comp_Iron_Staff"},
2101: {"AegisName":"Guard"},
2102: {"AegisName":"Guard_"},
2103: {"AegisName":"Buckler"},
2104: {"AegisName":"Buckler_"},
2105: {"AegisName":"Shield"},
2106: {"AegisName":"Shield_"},
2107: {"AegisName":"Mirror_Shield"},
2108: {"AegisName":"Mirror_Shield_"},
2109: {"AegisName":"Memorize_Book"},
2110: {"AegisName":"Holy_Guard"},
2111: {"AegisName":"Herald_Of_GOD"},
2112: {"AegisName":"Novice_Guard"},
2113: {"AegisName":"Novice_Shield"},
2114: {"AegisName":"Stone_Buckler"},
2115: {"AegisName":"Valkyrja's_Shield"},
2116: {"AegisName":"Angel's_Safeguard"},
2117: {"AegisName":"Arm_Guard"},
2118: {"AegisName":"Arm_Guard_"},
2119: {"AegisName":"Improved_Arm_Guard"},
2120: {"AegisName":"Improved_Arm_Guard_"},
2121: {"AegisName":"Memorize_Book_"},
2122: {"AegisName":"Platinum_Shield"},
2123: {"AegisName":"Orleans_Server"},
2124: {"AegisName":"Thorny_Buckler"},
2125: {"AegisName":"Strong_Shield"},
2126: {"AegisName":"Guyak_Shield"},
2127: {"AegisName":"Secular_Mission"},
2128: {"AegisName":"Herald_Of_GOD_"},
2129: {"AegisName":"Exorcism_Bible"},
2130: {"AegisName":"Cross_Shield"},
2131: {"AegisName":"Magic_Study_Vol1"},
2132: {"AegisName":"Shelter_Resistance"},
2133: {"AegisName":"Tournament_Shield"},
2134: {"AegisName":"Shield_Of_Naga"},
2135: {"AegisName":"Shadow_Guard"},
2136: {"AegisName":"Cracked_Buckler"},
2137: {"AegisName":"Valkyrja's_Shield_C"},
2138: {"AegisName":"Bradium_Shield"},
2139: {"AegisName":"Flame_Thrower"},
2140: {"AegisName":"Energy_Rune_Guard"},
2141: {"AegisName":"Freyja_SShield7"},
2142: {"AegisName":"Freyja_SShield30"},
2143: {"AegisName":"Freyja_SShield60"},
2144: {"AegisName":"Freyja_SShield90"},
2145: {"AegisName":"Time_Keepr_Shield"},
2146: {"AegisName":"Siver_Guard"},
2147: {"AegisName":"Round_Buckler"},
2148: {"AegisName":"Rotha_Shield"},
2149: {"AegisName":"Upg_Guard"},
2150: {"AegisName":"Upg_Buckler"},
2151: {"AegisName":"Upg_Shield"},
2152: {"AegisName":"Anti_Demon_Shield_C"},
2153: {"AegisName":"Imperial_Guard"},
2154: {"AegisName":"Toy_Shield"},
2155: {"AegisName":"Academy_Shield"},
2156: {"AegisName":"Bible_Of_Promise1"},
2157: {"AegisName":"Insecticide"},
2158: {"AegisName":"Ramor_Shield_Undead"},
2159: {"AegisName":"Sharel_Shield"},
2160: {"AegisName":"Giant_Shield"},
2161: {"AegisName":"Geffenia_Book_Water"},
2162: {"AegisName":"Bible_Of_Promise2"},
2163: {"AegisName":"Flow_Shield"},
2164: {"AegisName":"Sombre_Shield"},
2165: {"AegisName":"Sol_Shield"},
2166: {"AegisName":"Exorcism_Bible_"},
2167: {"AegisName":"Poison_Shield"},
2168: {"AegisName":"Immuned_Shield"},
2169: {"AegisName":"Kalasak"},
2170: {"AegisName":"Bayani_Kalasak"},
2171: {"AegisName":"Fox_Armguard"},
2172: {"AegisName":"Wolf_Armguard"},
2173: {"AegisName":"Crescent_Armguard"},
2174: {"AegisName":"Lumiere_Shield"},
2175: {"AegisName":"Esprit_Shield"},
2176: {"AegisName":"Dark_Book"},
2177: {"AegisName":"Shield_Of_Death"},
2178: {"AegisName":"TE_Woe_Buckler"},
2179: {"AegisName":"TE_Woe_Shield"},
2180: {"AegisName":"TE_Woe_Magic_Guard"},
2181: {"AegisName":"Hervor"},
2182: {"AegisName":"Hervor_Alvitr"},
2183: {"AegisName":"Impr_Angel's_Safeguard"},
2184: {"AegisName":"Bunker_Shield"},
2185: {"AegisName":"Magic_Reflector"},
2186: {"AegisName":"Encyclopedia_Revision"},
2187: {"AegisName":"Shield_Of_Gray"},
2188: {"AegisName":"Svalinn_J"},
2189: {"AegisName":"Mad_Bunny"},
2190: {"AegisName":"Ancient_Shield_Of_Aeon"},
2191: {"AegisName":"Solomon_Key"},
2192: {"AegisName":"Rose_Of_Eden"},
2193: {"AegisName":"Fallen_Angel_Shield"},
2194: {"AegisName":"Rouban_Shield"},
2195: {"AegisName":"Lian_Shield"},
2196: {"AegisName":"White_Gold_Shield"},
2197: {"AegisName":"Iron_Shield"},
2198: {"AegisName":"Lapine_Shield"},
2199: {"AegisName":"Ahura_Mazda"},
2201: {"AegisName":"Sunglasses"},
2202: {"AegisName":"Sunglasses_"},
2203: {"AegisName":"Glasses"},
2204: {"AegisName":"Glasses_"},
2205: {"AegisName":"Diver's_Goggles"},
2206: {"AegisName":"Wedding_Veil"},
2207: {"AegisName":"Fancy_Flower"},
2208: {"AegisName":"Ribbon"},
2209: {"AegisName":"Ribbon_"},
2210: {"AegisName":"Hair_Band"},
2211: {"AegisName":"Bandana"},
2212: {"AegisName":"Eye_Bandage"},
2213: {"AegisName":"Cat_Hairband"},
2214: {"AegisName":"Bunny_Band"},
2215: {"AegisName":"Flower_Hairband"},
2216: {"AegisName":"Biretta"},
2217: {"AegisName":"Biretta_"},
2218: {"AegisName":"Flu_Mask"},
2219: {"AegisName":"Flu_Mask_"},
2220: {"AegisName":"Hat"},
2221: {"AegisName":"Hat_"},
2222: {"AegisName":"Turban"},
2223: {"AegisName":"Turban_"},
2224: {"AegisName":"Goggle"},
2225: {"AegisName":"Goggle_"},
2226: {"AegisName":"Cap"},
2227: {"AegisName":"Cap_"},
2228: {"AegisName":"Helm"},
2229: {"AegisName":"Helm_"},
2230: {"AegisName":"Gemmed_Sallet"},
2231: {"AegisName":"Gemmed_Sallet_"},
2232: {"AegisName":"Circlet"},
2233: {"AegisName":"Circlet_"},
2234: {"AegisName":"Tiara"},
2235: {"AegisName":"Crown"},
2236: {"AegisName":"Santa's_Hat"},
2237: {"AegisName":"Weird_Goatee"},
2238: {"AegisName":"Weird_Moustache"},
2239: {"AegisName":"One_Eyed_Glass"},
2240: {"AegisName":"Beard"},
2241: {"AegisName":"Granpa_Beard"},
2242: {"AegisName":"Luxury_Sunglasses"},
2243: {"AegisName":"Spinning_Eyes"},
2244: {"AegisName":"Big_Sis'_Ribbon"},
2245: {"AegisName":"Sweet_Gents"},
2246: {"AegisName":"Golden_Gear"},
2247: {"AegisName":"Oldman's_Romance"},
2248: {"AegisName":"Western_Grace"},
2249: {"AegisName":"Coronet"},
2250: {"AegisName":"Fillet"},
2251: {"AegisName":"Holy_Bonnet"},
2252: {"AegisName":"Star_Sparkling"},
2253: {"AegisName":"Sunflower"},
2254: {"AegisName":"Angelic_Chain"},
2255: {"AegisName":"Satanic_Chain"},
2256: {"AegisName":"Magestic_Goat"},
2257: {"AegisName":"Snowy_Horn"},
2258: {"AegisName":"Sharp_Gear"},
2259: {"AegisName":"Mini_Propeller"},
2260: {"AegisName":"Mini_Glasses"},
2261: {"AegisName":"Prontera_Army_Cap"},
2262: {"AegisName":"Pierrot_Nose"},
2263: {"AegisName":"Gangster_Patch"},
2264: {"AegisName":"Munak_Turban"},
2265: {"AegisName":"Ganster_Mask"},
2266: {"AegisName":"Iron_Cane"},
2267: {"AegisName":"Cigar"},
2268: {"AegisName":"Smoking_Pipe"},
2269: {"AegisName":"Centimental_Flower"},
2270: {"AegisName":"Centimental_Leaf"},
2271: {"AegisName":"Jack_A_Dandy"},
2272: {"AegisName":"Stop_Post"},
2273: {"AegisName":"Doctor_Cap"},
2274: {"AegisName":"Ghost_Bandana"},
2275: {"AegisName":"Red_Bandana"},
2276: {"AegisName":"Eagle_Eyes"},
2277: {"AegisName":"Nurse_Cap"},
2278: {"AegisName":"Mr_Smile"},
2279: {"AegisName":"Bomb_Wick"},
2280: {"AegisName":"Sahkkat"},
2281: {"AegisName":"Phantom_Of_Opera"},
2282: {"AegisName":"Spirit_Chain"},
2283: {"AegisName":"Ear_Mufs"},
2284: {"AegisName":"Antler"},
2285: {"AegisName":"Apple_Of_Archer"},
2286: {"AegisName":"Elven_Ears"},
2287: {"AegisName":"Pirate_Bandana"},
2288: {"AegisName":"Mr_Scream"},
2289: {"AegisName":"Poo_Poo_Hat"},
2290: {"AegisName":"Funeral_Costume"},
2291: {"AegisName":"Masquerade"},
2292: {"AegisName":"Welding_Mask"},
2293: {"AegisName":"Pretend_Murdered"},
2294: {"AegisName":"Star_Dust"},
2295: {"AegisName":"Blinker"},
2296: {"AegisName":"Binoculars"},
2297: {"AegisName":"Goblini_Mask"},
2298: {"AegisName":"Green_Feeler"},
2299: {"AegisName":"Viking_Helm"},
2301: {"AegisName":"Cotton_Shirt"},
2302: {"AegisName":"Cotton_Shirt_"},
2303: {"AegisName":"Leather_Jacket"},
2304: {"AegisName":"Leather_Jacket_"},
2305: {"AegisName":"Adventure_Suit"},
2306: {"AegisName":"Adventurere's_Suit_"},
2307: {"AegisName":"Mantle"},
2308: {"AegisName":"Mantle_"},
2309: {"AegisName":"Coat"},
2310: {"AegisName":"Coat_"},
2311: {"AegisName":"Mink_Coat"},
2312: {"AegisName":"Padded_Armor"},
2313: {"AegisName":"Padded_Armor_"},
2314: {"AegisName":"Chain_Mail"},
2315: {"AegisName":"Chain_Mail_"},
2316: {"AegisName":"Plate_Armor"},
2317: {"AegisName":"Plate_Armor_"},
2318: {"AegisName":"Clothes_Of_The_Lord"},
2319: {"AegisName":"Glittering_Clothes"},
2320: {"AegisName":"Formal_Suit"},
2321: {"AegisName":"Silk_Robe"},
2322: {"AegisName":"Silk_Robe_"},
2323: {"AegisName":"Scapulare"},
2324: {"AegisName":"Scapulare_"},
2325: {"AegisName":"Saint_Robe"},
2326: {"AegisName":"Saint_Robe_"},
2327: {"AegisName":"Holy_Robe"},
2328: {"AegisName":"Wooden_Mail"},
2329: {"AegisName":"Wooden_Mail_"},
2330: {"AegisName":"Tights"},
2331: {"AegisName":"Tights_"},
2332: {"AegisName":"Silver_Robe"},
2333: {"AegisName":"Silver_Robe_"},
2334: {"AegisName":"Mage_Coat"},
2335: {"AegisName":"Thief_Clothes"},
2336: {"AegisName":"Thief_Clothes_"},
2337: {"AegisName":"Ninja_Suit"},
2338: {"AegisName":"Wedding_Dress"},
2339: {"AegisName":"G_Strings"},
2340: {"AegisName":"Novice_Breast"},
2341: {"AegisName":"Full_Plate_Armor"},
2342: {"AegisName":"Full_Plate_Armor_"},
2343: {"AegisName":"Robe_Of_Casting"},
2344: {"AegisName":"Flame_Sprits_Armor"},
2345: {"AegisName":"Flame_Sprits_Armor_"},
2346: {"AegisName":"Water_Sprits_Armor"},
2347: {"AegisName":"Water_Sprits_Armor_"},
2348: {"AegisName":"Wind_Sprits_Armor"},
2349: {"AegisName":"Wind_Sprits_Armor_"},
2350: {"AegisName":"Earth_Sprits_Armor"},
2351: {"AegisName":"Earth_Sprits_Armor_"},
2352: {"AegisName":"Novice_Plate"},
2353: {"AegisName":"Odin's_Blessing"},
2354: {"AegisName":"Goibne's_Armor"},
2355: {"AegisName":"Angel's_Protection"},
2356: {"AegisName":"Vestment_Of_Grace"},
2357: {"AegisName":"Valkyrie_Armor"},
2358: {"AegisName":"Dress_Of_Angel"},
2359: {"AegisName":"Ninja_Suit_"},
2360: {"AegisName":"Robe_Of_Casting_"},
2361: {"AegisName":"Blue_Aodai"},
2362: {"AegisName":"Red_Aodai"},
2363: {"AegisName":"White_Aodai"},
2364: {"AegisName":"Meteo_Plate_Armor"},
2365: {"AegisName":"Orleans_Gown"},
2366: {"AegisName":"Divine_Cloth"},
2367: {"AegisName":"Sniping_Suit"},
2368: {"AegisName":"Golden_Armor"},
2369: {"AegisName":"Freyja_Overcoat"},
2370: {"AegisName":"Used_Mage_Coat"},
2371: {"AegisName":"G_Strings_"},
2372: {"AegisName":"Mage_Coat_"},
2373: {"AegisName":"Holy_Robe_"},
2374: {"AegisName":"Diabolus_Robe"},
2375: {"AegisName":"Diabolus_Armor"},
2376: {"AegisName":"Assaulter_Plate"},
2377: {"AegisName":"Elite_Engineer_Armor"},
2378: {"AegisName":"Assassin_Robe"},
2379: {"AegisName":"Warlock_Battle_Robe"},
2380: {"AegisName":"Medic_Robe"},
2381: {"AegisName":"Elite_Archer_Suit"},
2382: {"AegisName":"Elite_Shooter_Suit"},
2383: {"AegisName":"Brynhild"},
2384: {"AegisName":"Spritual_Tunic"},
2385: {"AegisName":"Recuperative_Armor"},
2386: {"AegisName":"Chameleon_Armor"},
2387: {"AegisName":"Sprint_Mail"},
2388: {"AegisName":"Kandura"},
2389: {"AegisName":"Armor_Of_Naga"},
2390: {"AegisName":"Improved_Tights"},
2391: {"AegisName":"Life_Link"},
2392: {"AegisName":"Old_Pant"},
2393: {"AegisName":"N_Adventurer's_Suit"},
2394: {"AegisName":"Krieger_Suit1"},
2395: {"AegisName":"Krieger_Suit2"},
2396: {"AegisName":"Krieger_Suit3"},
2397: {"AegisName":"Incredible_Coat"},
2398: {"AegisName":"Sniping_Suit_M"},
2399: {"AegisName":"Dragon_Vest"},
2400: {"AegisName":"Pollux_Shoes_J"},
2401: {"AegisName":"Sandals"},
2402: {"AegisName":"Sandals_"},
2403: {"AegisName":"Shoes"},
2404: {"AegisName":"Shoes_"},
2405: {"AegisName":"Boots"},
2406: {"AegisName":"Boots_"},
2407: {"AegisName":"Chrystal_Pumps"},
2408: {"AegisName":"Cuffs"},
2409: {"AegisName":"Spiky_Heel"},
2410: {"AegisName":"Sleipnir"},
2411: {"AegisName":"Grave"},
2412: {"AegisName":"Grave_"},
2413: {"AegisName":"Safty_Boots"},
2414: {"AegisName":"Novice_Boots"},
2415: {"AegisName":"Slipper"},
2416: {"AegisName":"Novice_Shoes"},
2417: {"AegisName":"Fricco_Shoes"},
2418: {"AegisName":"Vidar's_Boots"},
2419: {"AegisName":"Goibne's_Combat_Boots"},
2420: {"AegisName":"Angel's_Arrival"},
2421: {"AegisName":"Valkyrie_Shoes"},
2422: {"AegisName":"High_Fashion_Sandals"},
2423: {"AegisName":"Variant_Shoes"},
2424: {"AegisName":"Tidal_Shoes"},
2425: {"AegisName":"Black_Leather_Boots"},
2426: {"AegisName":"Shadow_Walk"},
2427: {"AegisName":"Golden_Shoes"},
2428: {"AegisName":"Freyja_Boots"},
2429: {"AegisName":"Iron_Boots01"},
2430: {"AegisName":"Iron_Boots02"},
2431: {"AegisName":"Valley_Shoes"},
2432: {"AegisName":"Spiky_Heel_"},
2433: {"AegisName":"Diabolus_Boots"},
2434: {"AegisName":"Black_Leather_Boots_"},
2435: {"AegisName":"Battle_Greave"},
2436: {"AegisName":"Combat_Boots"},
2437: {"AegisName":"Battle_Boots"},
2438: {"AegisName":"Paw_Of_Cat"},
2439: {"AegisName":"Refresh_Shoes"},
2440: {"AegisName":"Sprint_Shoes"},
2441: {"AegisName":"Beach_Sandal"},
2442: {"AegisName":"Boots_Perforated"},
2443: {"AegisName":"Fish_Shoes"},
2444: {"AegisName":"Krieger_Shoes1"},
2445: {"AegisName":"Krieger_Shoes2"},
2446: {"AegisName":"Krieger_Shoes3"},
2447: {"AegisName":"Military_Boots"},
2448: {"AegisName":"Air_Boss"},
2449: {"AegisName":"Variant_Shoes_M"},
2450: {"AegisName":"Vital_Tree_Shoes"},
2451: {"AegisName":"Freyja_SSandal7"},
2452: {"AegisName":"Freyja_SSandal30"},
2453: {"AegisName":"Freyja_SSandal60"},
2454: {"AegisName":"Freyja_SSandal90"},
2455: {"AegisName":"Time_Keepr_Boots"},
2456: {"AegisName":"Para_Team_Boots1"},
2457: {"AegisName":"Para_Team_Boots2"},
2458: {"AegisName":"Para_Team_Boots3"},
2459: {"AegisName":"Upg_Shoes"},
2460: {"AegisName":"Upg_Boots"},
2461: {"AegisName":"Upg_Greave"},
2462: {"AegisName":"Sleipnir_C"},
2463: {"AegisName":"Feral_Boots"},
2464: {"AegisName":"No_Fear_Shoes"},
2465: {"AegisName":"Dance_Shoes"},
2466: {"AegisName":"Training_Shoes"},
2467: {"AegisName":"Golden_Rod_Shoes"},
2468: {"AegisName":"Aqua_Shoes"},
2469: {"AegisName":"Crimson_Shoes"},
2470: {"AegisName":"Forest_Shoes"},
2471: {"AegisName":"Shoes_Of_Affection"},
2472: {"AegisName":"Shoes_Of_Judgement"},
2473: {"AegisName":"Para_Team_Boots4"},
2474: {"AegisName":"Lehmannza_Shoes"},
2475: {"AegisName":"Ur_Greave"},
2476: {"AegisName":"Peuz_Greave"},
2477: {"AegisName":"Sabah_Shoes"},
2478: {"AegisName":"Nab_Shoes"},
2479: {"AegisName":"White_Wing_Boots"},
2480: {"AegisName":"Black_Wing_Boots"},
2481: {"AegisName":"Rune_Boots"},
2482: {"AegisName":"Shoes_Of_Valor"},
2483: {"AegisName":"Siege_Greave"},
2484: {"AegisName":"Siege_Boots"},
2485: {"AegisName":"Siege_Shoes"},
2486: {"AegisName":"Shadow_Walk_"},
2487: {"AegisName":"Vital_Tree_Shoes_"},
2488: {"AegisName":"Fricco_Shoes_"},
2489: {"AegisName":"Vidar's_Boots_"},
2490: {"AegisName":"Rune_Boots_"},
2491: {"AegisName":"Bangungot_Boots"},
2492: {"AegisName":"Bayani_Bangungot_Boots"},
2493: {"AegisName":"Goibne_Combat_Boots_"},
2494: {"AegisName":"Chrystal_Pumps_"},
2495: {"AegisName":"Egir_Shoes"},
2496: {"AegisName":"TE_Woe_Shoes"},
2497: {"AegisName":"TE_Woe_Boots"},
2498: {"AegisName":"TE_Woe_Magic_Sandal"},
2499: {"AegisName":"Temporal_Boots"},
2501: {"AegisName":"Hood"},
2502: {"AegisName":"Hood_"},
2503: {"AegisName":"Muffler"},
2504: {"AegisName":"Muffler_"},
2505: {"AegisName":"Manteau"},
2506: {"AegisName":"Manteau_"},
2507: {"AegisName":"Cape_Of_Ancient_Lord"},
2508: {"AegisName":"Ragamuffin_Cape"},
2509: {"AegisName":"Clack_Of_Servival"},
2510: {"AegisName":"Novice_Hood"},
2511: {"AegisName":"Skeleton's_Cape"},
2512: {"AegisName":"Novice_Manteau"},
2513: {"AegisName":"Celestial_Robe"},
2514: {"AegisName":"Pauldron"},
2515: {"AegisName":"Wing_Of_Eagle"},
2516: {"AegisName":"Falcon_Robe"},
2517: {"AegisName":"Vali's_Manteau"},
2518: {"AegisName":"Morpheus's_Shawl"},
2519: {"AegisName":"Morrigane's_Manteau"},
2520: {"AegisName":"Goibne's_Shoulder_Arms"},
2521: {"AegisName":"Angel's_Warmth"},
2522: {"AegisName":"Undershirt"},
2523: {"AegisName":"Undershirt_"},
2524: {"AegisName":"Valkyrie_Manteau"},
2525: {"AegisName":"Cape_Of_Ancient_Lord_"},
2526: {"AegisName":"Dragon_Scale_Coat"},
2527: {"AegisName":"Dragon_Breath"},
2528: {"AegisName":"Wool_Scarf"},
2529: {"AegisName":"Rider_Insignia"},
2530: {"AegisName":"Rider_Insignia_"},
2531: {"AegisName":"Ulfhedinn"},
2532: {"AegisName":"Mithril_Magic_Cape"},
2533: {"AegisName":"Freyja_Cape"},
2534: {"AegisName":"Ruffler"},
2535: {"AegisName":"Cloak_Of_Survival_C"},
2536: {"AegisName":"Skin_Of_Ventus"},
2537: {"AegisName":"Diabolus_Manteau"},
2538: {"AegisName":"Commander_Manteau"},
2539: {"AegisName":"Commander_Manteau_"},
2540: {"AegisName":"Sheriff_Manteau"},
2541: {"AegisName":"Asprika"},
2542: {"AegisName":"Flame_Manteau"},
2543: {"AegisName":"Sylphid_Manteau"},
2544: {"AegisName":"Leather_Of_Tendrilion"},
2545: {"AegisName":"Musika"},
2546: {"AegisName":"Beach_Manteau"},
2547: {"AegisName":"Cheap_Running_Shirts"},
2548: {"AegisName":"Muffler_C"},
2549: {"AegisName":"Krieger_Muffler1"},
2550: {"AegisName":"Fisher's_Muffler"},
2551: {"AegisName":"Rider_Insignia_M"},
2552: {"AegisName":"Mithril_Magic_Cape_M"},
2553: {"AegisName":"Dragon_Manteau"},
2554: {"AegisName":"Piece_Of_Angent_Skin"},
2555: {"AegisName":"Freyja_SScarf7"},
2556: {"AegisName":"Freyja_SScarf30"},
2557: {"AegisName":"Freyja_SScarf60"},
2558: {"AegisName":"Freyja_SScarf90"},
2559: {"AegisName":"Time_Keepr_Manteau"},
2560: {"AegisName":"Para_Team_Manteau"},
2561: {"AegisName":"Upg_Hood"},
2562: {"AegisName":"Upg_Muffler"},
2563: {"AegisName":"Upg_Manteau"},
2564: {"AegisName":"Feral_Tail"},
2565: {"AegisName":"Beach_Towel"},
2566: {"AegisName":"Half_Asprika"},
2567: {"AegisName":"Academy_Manteau"},
2568: {"AegisName":"Muffler_Of_Roki"},
2569: {"AegisName":"Shawl_Of_Affection"},
2570: {"AegisName":"Shawl_Of_Judgement"},
2571: {"AegisName":"Para_Team_Manteau2"},
2572: {"AegisName":"Katabart_Sholder"},
2573: {"AegisName":"Archangel_Wing"},
2574: {"AegisName":"Ur_Manteau"},
2575: {"AegisName":"Peuz_Manteau"},
2576: {"AegisName":"Bravery_Bag"},
2577: {"AegisName":"Sabah_Hood"},
2578: {"AegisName":"Nab_Hood"},
2579: {"AegisName":"Magic_Stole"},
2580: {"AegisName":"White_Wing_Manteau"},
2581: {"AegisName":"Black_Wing_Manteau"},
2582: {"AegisName":"Salvage_Cape"},
2583: {"AegisName":"Holy_Cape"},
2584: {"AegisName":"Wanderer_Outer"},
2585: {"AegisName":"Muffler_Of_Valor"},
2586: {"AegisName":"Siege_Manteau"},
2587: {"AegisName":"Siege_Muffler"},
2588: {"AegisName":"Ragamuffin_Cape_"},
2589: {"AegisName":"Fallen_Angel_Wing"},
2590: {"AegisName":"Buwaya_Cloth"},
2591: {"AegisName":"Bayani_Buwaya_Cloth"},
2592: {"AegisName":"Boss_Domovoi_Cape"},
2593: {"AegisName":"Flow_Manteau"},
2594: {"AegisName":"Wrapping_Manteau"},
2595: {"AegisName":"Sombre_Manteau"},
2596: {"AegisName":"Sharel_Manteau"},
2597: {"AegisName":"Scarlet_Poncho"},
2598: {"AegisName":"Ramor_Manteau"},
2599: {"AegisName":"Goibne_Shoulder_Arms_"},
2601: {"AegisName":"Ring"},
2602: {"AegisName":"Earring"},
2603: {"AegisName":"Necklace"},
2604: {"AegisName":"Glove"},
2605: {"AegisName":"Brooch"},
2606: {"AegisName":"Whike_Black_Tail_L"},
2607: {"AegisName":"Clip"},
2608: {"AegisName":"Rosary"},
2609: {"AegisName":"Skul_Ring"},
2610: {"AegisName":"Gold_Ring"},
2611: {"AegisName":"Silver_Ring"},
2612: {"AegisName":"Flower_Ring"},
2613: {"AegisName":"Diamond_Ring"},
2614: {"AegisName":"An_Eye_Of_Dullahan"},
2615: {"AegisName":"Safety_Ring"},
2616: {"AegisName":"Critical_Ring"},
2617: {"AegisName":"Mitten_Of_Presbyter"},
2618: {"AegisName":"Matyr's_Flea_Guard"},
2619: {"AegisName":"Thimble_Of_Archer"},
2620: {"AegisName":"Ring_Of_Rogue"},
2621: {"AegisName":"Ring_"},
2622: {"AegisName":"Earring_"},
2623: {"AegisName":"Necklace_"},
2624: {"AegisName":"Glove_"},
2625: {"AegisName":"Brooch_"},
2626: {"AegisName":"Rosary_"},
2627: {"AegisName":"Belt"},
2628: {"AegisName":"Novice_Armlet"},
2629: {"AegisName":"Magingiorde"},
2630: {"AegisName":"Brysinggamen"},
2631: {"AegisName":"First_Age_Ring"},
2632: {"AegisName":"Korean_Trinket"},
2633: {"AegisName":"Jade_Ring"},
2634: {"AegisName":"Bridegroom_Ring"},
2635: {"AegisName":"Bride_Ring"},
2636: {"AegisName":"Gold_Ring_"},
2637: {"AegisName":"Silver_Ring_"},
2638: {"AegisName":"Exorcize_Sachet"},
2639: {"AegisName":"Purification_Sachet"},
2640: {"AegisName":"Kafra_Ring"},
2641: {"AegisName":"Fashionable_Sack"},
2642: {"AegisName":"Serin's_Gold_Ring"},
2643: {"AegisName":"Serin's_Gold_Ring_"},
2644: {"AegisName":"The_Sign_"},
2645: {"AegisName":"Moonlight_Ring"},
2646: {"AegisName":"Bunch_Of_Carnation"},
2647: {"AegisName":"Nile_Rose"},
2648: {"AegisName":"Morpheus's_Ring"},
2649: {"AegisName":"Morpheus's_Armlet"},
2650: {"AegisName":"Morrigane's_Belt"},
2651: {"AegisName":"Morrigane's_Pendant"},
2652: {"AegisName":"Cursed_Lucky_Brooch"},
2653: {"AegisName":"Sacrifice_Ring"},
2654: {"AegisName":"Shinobi's_Sash"},
2655: {"AegisName":"Bloody_Iron_Ball"},
2656: {"AegisName":"Hyper_Changer"},
2657: {"AegisName":"Lab_Passport"},
2658: {"AegisName":"Nile_Rose_"},
2659: {"AegisName":"Vesper_Core01"},
2660: {"AegisName":"Vesper_Core02"},
2661: {"AegisName":"Vesper_Core03"},
2662: {"AegisName":"Vesper_Core04"},
2663: {"AegisName":"Gauntlet_Of_Accuracy"},
2664: {"AegisName":"Scarf_Belt"},
2665: {"AegisName":"Ring_Of_Exorcism"},
2666: {"AegisName":"Lamp_Of_Hope"},
2667: {"AegisName":"Glove_Of_Archer"},
2668: {"AegisName":"Women's_Glory"},
2669: {"AegisName":"Golden_Necklace_"},
2670: {"AegisName":"Ring_Of_Longing"},
2671: {"AegisName":"Thimble_Of_Archer_"},
2672: {"AegisName":"Anniversary_Ring"},
2673: {"AegisName":"Shining_Ring"},
2674: {"AegisName":"Honor_Ring"},
2675: {"AegisName":"Lord_Ring"},
2676: {"AegisName":"Hunter_Earring"},
2677: {"AegisName":"Spiritual_Ring"},
2678: {"AegisName":"Ring_Of_Flame_Lord"},
2679: {"AegisName":"Ring_Of_Resonance"},
2680: {"AegisName":"Lesser_Elemental_Ring"},
2681: {"AegisName":"Republic_Ring"},
2682: {"AegisName":"Ring_Of_Water"},
2683: {"AegisName":"Ring_Of_Fire"},
2684: {"AegisName":"Ring_Of_Wind"},
2685: {"AegisName":"Ring_Of_Earth"},
2686: {"AegisName":"Elven_Ears_C"},
2687: {"AegisName":"Steel_Flower_C"},
2688: {"AegisName":"Critical_Ring_C"},
2689: {"AegisName":"Earring_C"},
2690: {"AegisName":"Ring_C"},
2691: {"AegisName":"Necklace_C"},
2692: {"AegisName":"Glove_C"},
2693: {"AegisName":"Brooch_C"},
2694: {"AegisName":"Rosary_C"},
2695: {"AegisName":"Safety_Ring_C"},
2696: {"AegisName":"Vesper_Core01_C"},
2697: {"AegisName":"Vesper_Core02_C"},
2698: {"AegisName":"Vesper_Core03_C"},
2699: {"AegisName":"Vesper_Core04_C"},
2700: {"AegisName":"Red_Silk_Seal"},
2701: {"AegisName":"Orleans_Glove"},
2702: {"AegisName":"Bison_Horn"},
2703: {"AegisName":"Expert_Ring"},
2704: {"AegisName":"Golden_Accessory"},
2705: {"AegisName":"Golden_Accessory2"},
2706: {"AegisName":"Handcuff"},
2707: {"AegisName":"GUSLI"},
2708: {"AegisName":"Chinese_Handicraft"},
2709: {"AegisName":"5_Anniversary_Coin"},
2710: {"AegisName":"Bloody_Iron_Ball_C"},
2711: {"AegisName":"Spiritual_Ring_C"},
2712: {"AegisName":"Ragnarok_Limited_Ed"},
2713: {"AegisName":"Certificate_TW"},
2714: {"AegisName":"Marvelous_Pandent"},
2715: {"AegisName":"Skul_Ring_"},
2716: {"AegisName":"Librarian_Glove"},
2717: {"AegisName":"Pocket_Watch_"},
2718: {"AegisName":"Lunatic_Brooch"},
2719: {"AegisName":"Iron_Wrist"},
2720: {"AegisName":"Medal_Swordman"},
2721: {"AegisName":"Medal_Thief"},
2722: {"AegisName":"Medal_Acolyte"},
2723: {"AegisName":"Medal_Mage"},
2724: {"AegisName":"Medal_Archer"},
2725: {"AegisName":"Medal_Merchant"},
2726: {"AegisName":"Icarus_Wing"},
2727: {"AegisName":"Bowman_Scarf"},
2728: {"AegisName":"Cursed_Hand"},
2729: {"AegisName":"Diabolus_Ring"},
2730: {"AegisName":"Morroc_Seal"},
2731: {"AegisName":"Morroc_Charm_Stone"},
2732: {"AegisName":"Morroc_Ring"},
2733: {"AegisName":"Medal_Gunner"},
2734: {"AegisName":"Directive_A"},
2735: {"AegisName":"Directive_B"},
2736: {"AegisName":"Navel_Ring"},
2737: {"AegisName":"Foot_Ring"},
2738: {"AegisName":"Shiny_Coin"},
2739: {"AegisName":"Ordinary_Coin"},
2740: {"AegisName":"Rusty_Coin"},
2741: {"AegisName":"All_In_One_Ring"},
2742: {"AegisName":"Lucky_Clip"},
2743: {"AegisName":"Angelic_Ring"},
2744: {"AegisName":"Sprint_Ring"},
2745: {"AegisName":"Pinguicula_Corsage"},
2746: {"AegisName":"Cold_Heart"},
2747: {"AegisName":"Black_Cat"},
2748: {"AegisName":"Cursed_Star"},
2749: {"AegisName":"Linen_Glove"},
2750: {"AegisName":"Summer_Night_Dream"},
2751: {"AegisName":"Academy_Badge"},
2752: {"AegisName":"Praxinus_C"},
2753: {"AegisName":"Beholder_Ring"},
2754: {"AegisName":"Hallow_Ring"},
2755: {"AegisName":"Clamorous_Ring"},
2756: {"AegisName":"Chemical_Ring"},
2757: {"AegisName":"Insecticide_Ring"},
2758: {"AegisName":"Fisher_Ring"},
2759: {"AegisName":"Decussate_Ring"},
2760: {"AegisName":"Bloody_Ring"},
2761: {"AegisName":"Satanic_Ring"},
2762: {"AegisName":"Dragoon_Ring"},
2763: {"AegisName":"Skul_Ring_C"},
2764: {"AegisName":"Small_Fishing_Rod"},
2765: {"AegisName":"Novice_Figure"},
2766: {"AegisName":"Swordman_Figure"},
2767: {"AegisName":"Acolyte_Figure"},
2768: {"AegisName":"Mage_Figure"},
2769: {"AegisName":"Archer_Figure"},
2770: {"AegisName":"Thief_Figure"},
2771: {"AegisName":"Merchant_Figure"},
2772: {"AegisName":"Krieger_Ring1"},
2773: {"AegisName":"Krieger_Ring2"},
2774: {"AegisName":"Krieger_Ring3"},
2775: {"AegisName":"Lure"},
2776: {"AegisName":"Cool_Towel"},
2777: {"AegisName":"Shaman_Ring"},
2778: {"AegisName":"Shaman_Earing"},
2779: {"AegisName":"Dark_Knight_Belt"},
2780: {"AegisName":"Dark_Knight_Glove"},
2781: {"AegisName":"Aumdura's_Grace"},
2782: {"AegisName":"Ring_Of_Wise_King"},
2783: {"AegisName":"Eyes_Stone_Ring"},
2784: {"AegisName":"Oh_Holy_Night"},
2785: {"AegisName":"Orleans_Glove_M"},
2786: {"AegisName":"Spiritual_Ring_M"},
2787: {"AegisName":"Waterdrop_Brooch"},
2788: {"AegisName":"Bradium_Earing"},
2789: {"AegisName":"Bradium_Ring"},
2790: {"AegisName":"Bradium_Brooch"},
2791: {"AegisName":"Just_Got_Fish"},
2792: {"AegisName":"Ring_Of_Flame_Lord_I"},
2793: {"AegisName":"Ring_Of_Resonance_I"},
2794: {"AegisName":"Magic_Stone_Ring"},
2795: {"AegisName":"Green_Apple_Ring"},
2796: {"AegisName":"Magical_Stone"},
2797: {"AegisName":"Magical_Stone_"},
2798: {"AegisName":"Will_Of_Exhausted_Angel"},
2799: {"AegisName":"Kuirpenring"},
2800: {"AegisName":"Accelerator"},
2801: {"AegisName":"Hovering_Booster"},
2802: {"AegisName":"Suicidal_Device"},
2803: {"AegisName":"Shape_Shifter"},
2804: {"AegisName":"Cooling_Device"},
2805: {"AegisName":"Mag_Field_Generator"},
2806: {"AegisName":"Barrier_Builder"},
2807: {"AegisName":"Repair_Kit"},
2808: {"AegisName":"Camouflage_Generator"},
2809: {"AegisName":"High_Quality_Cooler"},
2810: {"AegisName":"Special_Cooler"},
2811: {"AegisName":"Freyja_SBracelet7"},
2812: {"AegisName":"Freyja_SBracelet30"},
2813: {"AegisName":"Freyja_SBracelet60"},
2814: {"AegisName":"Freyja_SBracelet90"},
2815: {"AegisName":"Th_Ring_Of_Water"},
2816: {"AegisName":"Radar_Ring1"},
2817: {"AegisName":"Radar_Ring2"},
2818: {"AegisName":"Radar_Ring3"},
2819: {"AegisName":"Swordman_Manual"},
2820: {"AegisName":"Thief_Manual"},
2821: {"AegisName":"Acolyte_Manual"},
2822: {"AegisName":"Archer_Manual"},
2823: {"AegisName":"Merchant_Manual"},
2824: {"AegisName":"Mage_Manual"},
2825: {"AegisName":"Shaman_EaringB"},
2826: {"AegisName":"Dark_Knight_BeltB"},
2827: {"AegisName":"Dark_Knight_GloveB"},
2828: {"AegisName":"Upg_Clip"},
2829: {"AegisName":"Greed_Clip"},
2830: {"AegisName":"Magingiorde_C"},
2831: {"AegisName":"Brysinggamen_C"},
2832: {"AegisName":"Freyja_Ring"},
2833: {"AegisName":"Odin's_Recall"},
2834: {"AegisName":"F_All_In_One_Ring"},
2835: {"AegisName":"F_Critical_Ring_C"},
2836: {"AegisName":"F_Glove_C"},
2837: {"AegisName":"F_Safety_Ring_C"},
2838: {"AegisName":"F_Necklace_C"},
2839: {"AegisName":"F_Ring_C"},
2840: {"AegisName":"F_Rosary_C"},
2841: {"AegisName":"Caracas_Ring"},
2842: {"AegisName":"F_Earing_C"},
2843: {"AegisName":"Gold_Trickle"},
2844: {"AegisName":"El_Dicastes_Light"},
2845: {"AegisName":"No_Fear_Belt"},
2846: {"AegisName":"E_All_In_One_Ring"},
2847: {"AegisName":"E_Critical_Ring_C"},
2848: {"AegisName":"E_Glove_C"},
2849: {"AegisName":"E_Safety_Ring_C"},
2850: {"AegisName":"E_Ring_C"},
2851: {"AegisName":"E_Necklace_C"},
2852: {"AegisName":"E_Rosary_C"},
2853: {"AegisName":"Telekinetic_Orb"},
2854: {"AegisName":"Alchemy_Glove"},
2855: {"AegisName":"Whike_Black_Tail"},
2856: {"AegisName":"Half_Megin"},
2857: {"AegisName":"Half_Brysing"},
2858: {"AegisName":"Pendant_Of_Guardian"},
2859: {"AegisName":"Golden_Rod_Orb"},
2860: {"AegisName":"Aqua_Orb"},
2861: {"AegisName":"Crimson_Orb"},
2862: {"AegisName":"Forest_Orb"},
2863: {"AegisName":"Ring_Of_Valkyrie"},
2864: {"AegisName":"Light_Of_Cure"},
2865: {"AegisName":"Seal_Of_Cathedral"},
2866: {"AegisName":"Ring_Of_Archbishop"},
2867: {"AegisName":"Broken_Bamboo_Piece"},
2868: {"AegisName":"Green_Batik"},
2869: {"AegisName":"Colorful_Ketupat"},
2870: {"AegisName":"Tw_8th_Anni_Ring"},
2871: {"AegisName":"Brazilian_Emblem"},
2872: {"AegisName":"G_Honor_Certificate"},
2873: {"AegisName":"Cat_Hand_Glove"},
2874: {"AegisName":"Buffalo_Horn"},
2875: {"AegisName":"RO_Appreciation_Ring"},
2876: {"AegisName":"Necklace_Spica"},
2877: {"AegisName":"Glove_Sabik"},
2878: {"AegisName":"Bracelet_Arunairi"},
2879: {"AegisName":"Badge_Giorredart"},
2880: {"AegisName":"Ring_Lupak"},
2881: {"AegisName":"Orleans_Necklace"},
2882: {"AegisName":"Ecoro_Cardslip"},
2883: {"AegisName":"Ur_Seal"},
2884: {"AegisName":"Peuz_Seal"},
2885: {"AegisName":"Mother_Heart"},
2886: {"AegisName":"Sabah_Ring"},
2887: {"AegisName":"Nab_Ring"},
2888: {"AegisName":"School_Bag"},
2889: {"AegisName":"Endure_Ring"},
2890: {"AegisName":"White_Wing_Brooch"},
2891: {"AegisName":"Black_wing_Brooch"},
2892: {"AegisName":"Assassin_Handcuffs"},
2893: {"AegisName":"Cursed_Heart"},
2894: {"AegisName":"Glove_Of_Shura"},
2895: {"AegisName":"Medal_Of_Valor1"},
2896: {"AegisName":"Medal_Of_Valor2"},
2897: {"AegisName":"2011RWC_Necklace_J"},
2898: {"AegisName":"Black_Rosary"},
2899: {"AegisName":"Sound_Amplifier"},
2900: {"AegisName":"Morrigane's_Belt_"},
2901: {"AegisName":"Morrigane's_Pendant_"},
2902: {"AegisName":"Morpheus's_Ring_"},
2903: {"AegisName":"Morpheus's_Armlet_"},
2904: {"AegisName":"Naqsh"},
2905: {"AegisName":"Super_Ora_Ora"},
2906: {"AegisName":"Happy_Gauntlet"},
2907: {"AegisName":"Buwaya_Tattoo"},
2908: {"AegisName":"Light_Ring"},
2909: {"AegisName":"Darkness_Ring"},
2910: {"AegisName":"Bakonawa_Tattoo"},
2911: {"AegisName":"Bangungot_Tattoo"},
2912: {"AegisName":"Xylitol_2011"},
2913: {"AegisName":"Thief_Handcuff"},
2914: {"AegisName":"Wizard_Left_Eye"},
2915: {"AegisName":"Ettlang_Keepsake"},
2916: {"AegisName":"Fairy_Wing"},
2917: {"AegisName":"Str_Glove"},
2918: {"AegisName":"Int_Glove"},
2919: {"AegisName":"Agi_Glove"},
2920: {"AegisName":"Vit_Glove"},
2921: {"AegisName":"Dex_Glove"},
2922: {"AegisName":"Luk_Glove"},
2923: {"AegisName":"Str_Glove_"},
2924: {"AegisName":"Int_Glove_"},
2925: {"AegisName":"Agi_Glove_"},
2926: {"AegisName":"Vit_Glove_"},
2927: {"AegisName":"Dex_Glove_"},
2928: {"AegisName":"Luk_Glove_"},
2929: {"AegisName":"Charm_Str"},
2930: {"AegisName":"Charm_Agi"},
2931: {"AegisName":"Charm_Vit"},
2932: {"AegisName":"Charm_Dex"},
2933: {"AegisName":"Charm_Int"},
2934: {"AegisName":"Charm_Luk"},
2935: {"AegisName":"Sprint_Glove"},
2936: {"AegisName":"Recovery_Ring"},
2937: {"AegisName":"RJC_Exp"},
2938: {"AegisName":"RJC_Status"},
2939: {"AegisName":"RJC_Spell"},
2940: {"AegisName":"Ninja_Manual"},
2941: {"AegisName":"Gunslinger_Manual"},
2942: {"AegisName":"Taekwon_Manual"},
2943: {"AegisName":"Critical_Ring_"},
2944: {"AegisName":"TE_Ring_Of_Protection"},
2945: {"AegisName":"TE_Ring_Of_Rage"},
2946: {"AegisName":"TE_Ring_Of_Defiance"},
2947: {"AegisName":"Memories_of_Spring"},
2948: {"AegisName":"Demon_Wing"},
2949: {"AegisName":"Silversmith_Bracelet"},
2950: {"AegisName":"Rune_Ring"},
2951: {"AegisName":"Kvasir_Ring_Blue"},
2952: {"AegisName":"Kvasir_Ring_Red"},
2953: {"AegisName":"Kvasir_Ring_Green"},
2954: {"AegisName":"Kvasir_Ring_Brown"},
2955: {"AegisName":"Neutral_Ring_J"},
2956: {"AegisName":"Safety_Ring_"},
2957: {"AegisName":"Good_Ring_Of_Flame_Lord"},
2958: {"AegisName":"Good_Ring_Of_Resonance"},
2959: {"AegisName":"Fidelity_Necklace"},
2960: {"AegisName":"Badge_Of_Manny"},
2961: {"AegisName":"Magic_Carpet"},
2962: {"AegisName":"Willpower_Ring"},
2963: {"AegisName":"Body_Power_Up_Ring"},
2964: {"AegisName":"Ring_Of_Spell_Explosion"},
2965: {"AegisName":"Angel_Egg"},
2966: {"AegisName":"RWC_2012_Ring"},
2967: {"AegisName":"RWC_2012_Ring_"},
2968: {"AegisName":"RWC_2012_Pendant"},
2969: {"AegisName":"RWC_2012_Pendant_"},
2970: {"AegisName":"Pie_Fruit_Box"},
2971: {"AegisName":"Pocket_Watch__"},
2974: {"AegisName":"Eternal_Protected_Love"},
2975: {"AegisName":"10th_Anni_Badge_J"},
2976: {"AegisName":"Red_Lantern"},
2977: {"AegisName":"Hurt_Mind"},
2978: {"AegisName":"KindHeart"},
2979: {"AegisName":"Strawberry_Decoration"},
2980: {"AegisName":"Evilspirit_Gloves"},
2981: {"AegisName":"RingOfHero"},
2982: {"AegisName":"Earth_Ring_J"},
2983: {"AegisName":"Brooch_Greed"},
2984: {"AegisName":"Limnil_Glove"},
2985: {"AegisName":"Gyges_Ring"},
2986: {"AegisName":"Snake_Ring"},
2987: {"AegisName":"Snake_Pendant"},
2988: {"AegisName":"Winged_Ring_Of_Newoz"},
2989: {"AegisName":"Floral_Bracelet_Of_Igu"},
2990: {"AegisName":"Pendant_Of_Harmony"},
2991: {"AegisName":"Pendant_Of_Chaos"},
2992: {"AegisName":"Pendant_Of_Maelstorm"},
2993: {"AegisName":"Yggdrasil_Ring"},
2994: {"AegisName":"Water_Crystal_Stone"},
2995: {"AegisName":"Supplement_Part_Dex"},
2996: {"AegisName":"Upgrade_Part_Gun_Barrel"},
2997: {"AegisName":"RWC_Gold_Brooch"},
2998: {"AegisName":"Shining_Trapezohedron"},
2999: {"AegisName":"RWC_Silver_Brooch"},
4001: {"AegisName":"Poring_Card"},
4002: {"AegisName":"Fabre_Card"},
4003: {"AegisName":"Pupa_Card"},
4004: {"AegisName":"Drops_Card"},
4005: {"AegisName":"Poring__Card"},
4006: {"AegisName":"Lunatic_Card"},
4007: {"AegisName":"Pecopeco_Egg_Card"},
4008: {"AegisName":"Picky_Card"},
4009: {"AegisName":"Chonchon_Card"},
4010: {"AegisName":"Wilow_Card"},
4011: {"AegisName":"Picky__Card"},
4012: {"AegisName":"Thief_Bug_Egg_Card"},
4013: {"AegisName":"Andre_Egg_Card"},
4014: {"AegisName":"Roda_Frog_Card"},
4015: {"AegisName":"Condor_Card"},
4016: {"AegisName":"Thief_Bug_Card"},
4017: {"AegisName":"Savage_Babe_Card"},
4018: {"AegisName":"Andre_Larva_Card"},
4019: {"AegisName":"Hornet_Card"},
4020: {"AegisName":"Farmiliar_Card"},
4021: {"AegisName":"Rocker_Card"},
4022: {"AegisName":"Spore_Card"},
4023: {"AegisName":"Desert_Wolf_Babe_Card"},
4024: {"AegisName":"Plankton_Card"},
4025: {"AegisName":"Skeleton_Card"},
4026: {"AegisName":"Thief_Bug_Female_Card"},
4027: {"AegisName":"Kukre_Card"},
4028: {"AegisName":"Tarou_Card"},
4029: {"AegisName":"Wolf_Card"},
4030: {"AegisName":"Mandragora_Card"},
4031: {"AegisName":"Pecopeco_Card"},
4032: {"AegisName":"Ambernite_Card"},
4033: {"AegisName":"Poporing_Card"},
4034: {"AegisName":"Worm_Tail_Card"},
4035: {"AegisName":"Hydra_Card"},
4036: {"AegisName":"Muka_Card"},
4037: {"AegisName":"Snake_Card"},
4038: {"AegisName":"Zombie_Card"},
4039: {"AegisName":"Stainer_Card"},
4040: {"AegisName":"Creamy_Card"},
4041: {"AegisName":"Coco_Card"},
4042: {"AegisName":"Steel_Chonchon_Card"},
4043: {"AegisName":"Andre_Card"},
4044: {"AegisName":"Smokie_Card"},
4045: {"AegisName":"Horn_Card"},
4046: {"AegisName":"Martin_Card"},
4047: {"AegisName":"Ghostring_Card"},
4048: {"AegisName":"Poison_Spore_Card"},
4049: {"AegisName":"Vadon_Card"},
4050: {"AegisName":"Thief_Bug_Male_Card"},
4051: {"AegisName":"Yoyo_Card"},
4052: {"AegisName":"Elder_Wilow_Card"},
4053: {"AegisName":"Vitata_Card"},
4054: {"AegisName":"Angeling_Card"},
4055: {"AegisName":"Marina_Card"},
4056: {"AegisName":"Dustiness_Card"},
4057: {"AegisName":"Metaller_Card"},
4058: {"AegisName":"Thara_Frog_Card"},
4059: {"AegisName":"Soldier_Andre_Card"},
4060: {"AegisName":"Goblin_Card"},
4061: {"AegisName":"Cornutus_Card"},
4062: {"AegisName":"Anacondaq_Card"},
4063: {"AegisName":"Caramel_Card"},
4064: {"AegisName":"Zerom_Card"},
4065: {"AegisName":"Kaho_Card"},
4066: {"AegisName":"Orc_Warrior_Card"},
4067: {"AegisName":"Megalodon_Card"},
4068: {"AegisName":"Scorpion_Card"},
4069: {"AegisName":"Drainliar_Card"},
4070: {"AegisName":"Eggyra_Card"},
4071: {"AegisName":"Orc_Zombie_Card"},
4072: {"AegisName":"Golem_Card"},
4073: {"AegisName":"Pirate_Skel_Card"},
4074: {"AegisName":"BigFoot_Card"},
4075: {"AegisName":"Argos_Card"},
4076: {"AegisName":"Magnolia_Card"},
4077: {"AegisName":"Phen_Card"},
4078: {"AegisName":"Savage_Card"},
4079: {"AegisName":"Mantis_Card"},
4080: {"AegisName":"Flora_Card"},
4081: {"AegisName":"Hode_Card"},
4082: {"AegisName":"Desert_Wolf_Card"},
4083: {"AegisName":"Rafflesia_Card"},
4084: {"AegisName":"Marine_Sphere_Card"},
4085: {"AegisName":"Orc_Skeleton_Card"},
4086: {"AegisName":"Soldier_Skeleton_Card"},
4087: {"AegisName":"Giearth_Card"},
4088: {"AegisName":"Frilldora_Card"},
4089: {"AegisName":"Sword_Fish_Card"},
4090: {"AegisName":"Munak_Card"},
4091: {"AegisName":"Kobold_Card"},
4092: {"AegisName":"Skel_Worker_Card"},
4093: {"AegisName":"Obeaune_Card"},
4094: {"AegisName":"Archer_Skeleton_Card"},
4095: {"AegisName":"Marse_Card"},
4096: {"AegisName":"Zenorc_Card"},
4097: {"AegisName":"Matyr_Card"},
4098: {"AegisName":"Dokebi_Card"},
4099: {"AegisName":"Pasana_Card"},
4100: {"AegisName":"Sohee_Card"},
4101: {"AegisName":"Sand_Man_Card"},
4102: {"AegisName":"Whisper_Card"},
4103: {"AegisName":"Horong_Card"},
4104: {"AegisName":"Requiem_Card"},
4105: {"AegisName":"Marc_Card"},
4106: {"AegisName":"Mummy_Card"},
4107: {"AegisName":"Verit_Card"},
4108: {"AegisName":"Myst_Card"},
4109: {"AegisName":"Jakk_Card"},
4110: {"AegisName":"Ghoul_Card"},
4111: {"AegisName":"Strouf_Card"},
4112: {"AegisName":"Marduk_Card"},
4113: {"AegisName":"Marionette_Card"},
4114: {"AegisName":"Argiope_Card"},
4115: {"AegisName":"Hunter_Fly_Card"},
4116: {"AegisName":"Isis_Card"},
4117: {"AegisName":"Side_Winder_Card"},
4118: {"AegisName":"Petit_Card"},
4119: {"AegisName":"Bathory_Card"},
4120: {"AegisName":"Petit__Card"},
4121: {"AegisName":"Phreeoni_Card"},
4122: {"AegisName":"Deviruchi_Card"},
4123: {"AegisName":"Eddga_Card"},
4124: {"AegisName":"Medusa_Card"},
4125: {"AegisName":"Deviace_Card"},
4126: {"AegisName":"Minorous_Card"},
4127: {"AegisName":"Nightmare_Card"},
4128: {"AegisName":"Golden_Bug_Card"},
4129: {"AegisName":"Baphomet__Card"},
4130: {"AegisName":"Scorpion_King_Card"},
4131: {"AegisName":"Moonlight_Flower_Card"},
4132: {"AegisName":"Mistress_Card"},
4133: {"AegisName":"Daydric_Card"},
4134: {"AegisName":"Dracula_Card"},
4135: {"AegisName":"Orc_Load_Card"},
4136: {"AegisName":"Khalitzburg_Card"},
4137: {"AegisName":"Drake_Card"},
4138: {"AegisName":"Anubis_Card"},
4139: {"AegisName":"Joker_Card"},
4140: {"AegisName":"Knight_Of_Abyss_Card"},
4141: {"AegisName":"Evil_Druid_Card"},
4142: {"AegisName":"Doppelganger_Card"},
4143: {"AegisName":"Orc_Hero_Card"},
4144: {"AegisName":"Osiris_Card"},
4145: {"AegisName":"Berzebub_Card"},
4146: {"AegisName":"Maya_Card"},
4147: {"AegisName":"Baphomet_Card"},
4148: {"AegisName":"Pharaoh_Card"},
4149: {"AegisName":"Gargoyle_Card"},
4150: {"AegisName":"Goat_Card"},
4151: {"AegisName":"Gajomart_Card"},
4152: {"AegisName":"Galapago_Card"},
4153: {"AegisName":"Crab_Card"},
4154: {"AegisName":"Rice_Cake_Boy_Card"},
4155: {"AegisName":"Goblin_Leader_Card"},
4156: {"AegisName":"Steam_Goblin_Card"},
4157: {"AegisName":"Goblin_Archer_Card"},
4158: {"AegisName":"Flying_Deleter_Card"},
4159: {"AegisName":"Nine_Tail_Card"},
4160: {"AegisName":"Antique_Firelock_Card"},
4161: {"AegisName":"Grand_Peco_Card"},
4162: {"AegisName":"Grizzly_Card"},
4163: {"AegisName":"Gryphon_Card"},
4164: {"AegisName":"Gullinbursti_Card"},
4165: {"AegisName":"Gig_Card"},
4166: {"AegisName":"Nightmare_Terror_Card"},
4167: {"AegisName":"Neraid_Card"},
4168: {"AegisName":"Dark_Lord_Card"},
4169: {"AegisName":"Dark_Illusion_Card"},
4170: {"AegisName":"Dark_Frame_Card"},
4171: {"AegisName":"Dark_Priest_Card"},
4172: {"AegisName":"The_Paper_Card"},
4173: {"AegisName":"Demon_Pungus_Card"},
4174: {"AegisName":"Deviling_Card"},
4175: {"AegisName":"Poison_Toad_Card"},
4176: {"AegisName":"Dullahan_Card"},
4177: {"AegisName":"Dryad_Card"},
4178: {"AegisName":"Dragon_Tail_Card"},
4179: {"AegisName":"Dragon_Fly_Card"},
4180: {"AegisName":"Driller_Card"},
4181: {"AegisName":"Disguise_Card"},
4182: {"AegisName":"Diabolic_Card"},
4183: {"AegisName":"Vagabond_Wolf_Card"},
4184: {"AegisName":"Lava_Golem_Card"},
4185: {"AegisName":"Rideword_Card"},
4186: {"AegisName":"Raggler_Card"},
4187: {"AegisName":"Raydric_Archer_Card"},
4188: {"AegisName":"Leib_Olmai_Card"},
4189: {"AegisName":"Wraith_Dead_Card"},
4190: {"AegisName":"Wraith_Card"},
4191: {"AegisName":"Loli_Ruri_Card"},
4192: {"AegisName":"Rotar_Zairo_Card"},
4193: {"AegisName":"Lude_Card"},
4194: {"AegisName":"Rybio_Card"},
4195: {"AegisName":"Leaf_Cat_Card"},
4196: {"AegisName":"Marin_Card"},
4197: {"AegisName":"Mastering_Card"},
4198: {"AegisName":"Maya_Puple_Card"},
4199: {"AegisName":"Merman_Card"},
4200: {"AegisName":"Megalith_Card"},
4201: {"AegisName":"Majoruros_Card"},
4202: {"AegisName":"Civil_Servant_Card"},
4203: {"AegisName":"Mutant_Dragon_Card"},
4204: {"AegisName":"Mini_Demon_Card"},
4205: {"AegisName":"Mimic_Card"},
4206: {"AegisName":"Mystcase_Card"},
4207: {"AegisName":"Mysteltainn_Card"},
4208: {"AegisName":"Miyabi_Ningyo_Card"},
4209: {"AegisName":"Violy_Card"},
4210: {"AegisName":"Wander_Man_Card"},
4211: {"AegisName":"Vocal_Card"},
4212: {"AegisName":"Bon_Gun_Card"},
4213: {"AegisName":"Brilight_Card"},
4214: {"AegisName":"Bloody_Murderer_Card"},
4215: {"AegisName":"Blazzer_Card"},
4216: {"AegisName":"Sasquatch_Card"},
4217: {"AegisName":"Live_Peach_Tree_Card"},
4218: {"AegisName":"Succubus_Card"},
4219: {"AegisName":"Sageworm_Card"},
4220: {"AegisName":"Solider_Card"},
4221: {"AegisName":"Skeleton_General_Card"},
4222: {"AegisName":"Skel_Prisoner_Card"},
4223: {"AegisName":"Stalactic_Golem_Card"},
4224: {"AegisName":"Stem_Worm_Card"},
4225: {"AegisName":"Stone_Shooter_Card"},
4226: {"AegisName":"Sting_Card"},
4227: {"AegisName":"Spring_Rabbit_Card"},
4228: {"AegisName":"Sleeper_Card"},
4229: {"AegisName":"C_Tower_Manager_Card"},
4230: {"AegisName":"Shinobi_Card"},
4231: {"AegisName":"Increase_Soil_Card"},
4232: {"AegisName":"Wild_Ginseng_Card"},
4233: {"AegisName":"Baby_Leopard_Card"},
4234: {"AegisName":"Anolian_Card"},
4235: {"AegisName":"Cookie_XMAS_Card"},
4236: {"AegisName":"Amon_Ra_Card"},
4237: {"AegisName":"Owl_Duke_Card"},
4238: {"AegisName":"Owl_Baron_Card"},
4239: {"AegisName":"Iron_Fist_Card"},
4240: {"AegisName":"Arclouse_Card"},
4241: {"AegisName":"Archangeling_Card"},
4242: {"AegisName":"Apocalips_Card"},
4243: {"AegisName":"Antonio_Card"},
4244: {"AegisName":"Alarm_Card"},
4245: {"AegisName":"Am_Mut_Card"},
4246: {"AegisName":"Assulter_Card"},
4247: {"AegisName":"Aster_Card"},
4248: {"AegisName":"Ancient_Mummy_Card"},
4249: {"AegisName":"Ancient_Worm_Card"},
4250: {"AegisName":"Executioner_Card"},
4251: {"AegisName":"Elder_Card"},
4252: {"AegisName":"Alligator_Card"},
4253: {"AegisName":"Alice_Card"},
4254: {"AegisName":"Tirfing_Card"},
4255: {"AegisName":"Orc_Lady_Card"},
4256: {"AegisName":"Orc_Archer_Card"},
4257: {"AegisName":"Wild_Rose_Card"},
4258: {"AegisName":"Wicked_Nymph_Card"},
4259: {"AegisName":"Wooden_Golem_Card"},
4260: {"AegisName":"Wootan_Shooter_Card"},
4261: {"AegisName":"Wootan_Fighter_Card"},
4262: {"AegisName":"Evil_Cloud_Hermit_Card"},
4263: {"AegisName":"Incant_Samurai_Card"},
4264: {"AegisName":"Wind_Ghost_Card"},
4265: {"AegisName":"Li_Me_Mang_Ryang_Card"},
4266: {"AegisName":"Eclipse_Card"},
4267: {"AegisName":"Explosion_Card"},
4268: {"AegisName":"Injustice_Card"},
4269: {"AegisName":"Incubus_Card"},
4270: {"AegisName":"Giant_Spider_Card"},
4271: {"AegisName":"Giant_Honet_Card"},
4272: {"AegisName":"Dancing_Dragon_Card"},
4273: {"AegisName":"Shellfish_Card"},
4274: {"AegisName":"Zombie_Master_Card"},
4275: {"AegisName":"Zombie_Prisoner_Card"},
4276: {"AegisName":"Lord_Of_Death_Card"},
4277: {"AegisName":"Zherlthsh_Card"},
4278: {"AegisName":"Gibbet_Card"},
4279: {"AegisName":"Deleter_Card"},
4280: {"AegisName":"Geographer_Card"},
4281: {"AegisName":"Zipper_Bear_Card"},
4282: {"AegisName":"Tengu_Card"},
4283: {"AegisName":"Greatest_General_Card"},
4284: {"AegisName":"Chepet_Card"},
4285: {"AegisName":"Choco_Card"},
4286: {"AegisName":"Karakasa_Card"},
4287: {"AegisName":"Kapha_Card"},
4288: {"AegisName":"Carat_Card"},
4289: {"AegisName":"Caterpillar_Card"},
4290: {"AegisName":"Cat_O_Nine_Tail_Card"},
4291: {"AegisName":"Kobold_Leader_Card"},
4292: {"AegisName":"Kobold_Archer_Card"},
4293: {"AegisName":"Cookie_Card"},
4294: {"AegisName":"Quve_Card"},
4295: {"AegisName":"Kraben_Card"},
4296: {"AegisName":"Cramp_Card"},
4297: {"AegisName":"Cruiser_Card"},
4298: {"AegisName":"Cremy_Fear_Card"},
4299: {"AegisName":"Clock_Card"},
4300: {"AegisName":"Chimera_Card"},
4301: {"AegisName":"Killer_Mantis_Card"},
4302: {"AegisName":"Tao_Gunka_Card"},
4303: {"AegisName":"Whisper_Boss_Card"},
4304: {"AegisName":"Tamruan_Card"},
4305: {"AegisName":"Turtle_General_Card"},
4306: {"AegisName":"Toad_Card"},
4307: {"AegisName":"Kind_Of_Beetle_Card"},
4308: {"AegisName":"Tri_Joint_Card"},
4309: {"AegisName":"Parasite_Card"},
4310: {"AegisName":"Panzer_Goblin_Card"},
4311: {"AegisName":"Permeter_Card"},
4312: {"AegisName":"Fur_Seal_Card"},
4313: {"AegisName":"Punk_Card"},
4314: {"AegisName":"Penomena_Card"},
4315: {"AegisName":"Pest_Card"},
4316: {"AegisName":"Fake_Angel_Card"},
4317: {"AegisName":"Mobster_Card"},
4318: {"AegisName":"Knight_Windstorm_Card"},
4319: {"AegisName":"Freezer_Card"},
4320: {"AegisName":"Bloody_Knight_Card"},
4321: {"AegisName":"Hylozoist_Card"},
4322: {"AegisName":"High_Orc_Card"},
4323: {"AegisName":"Garm_Baby_Card"},
4324: {"AegisName":"Garm_Card"},
4325: {"AegisName":"Harpy_Card"},
4326: {"AegisName":"See_Otter_Card"},
4327: {"AegisName":"Blood_Butterfly_Card"},
4328: {"AegisName":"Hyegun_Card"},
4329: {"AegisName":"Phendark_Card"},
4330: {"AegisName":"Dark_Snake_Lord_Card"},
4331: {"AegisName":"Heater_Card"},
4332: {"AegisName":"Waste_Stove_Card"},
4333: {"AegisName":"Venomous_Card"},
4334: {"AegisName":"Noxious_Card"},
4335: {"AegisName":"Pitman_Card"},
4336: {"AegisName":"Ungoliant_Card"},
4337: {"AegisName":"Porcellio_Card"},
4338: {"AegisName":"Obsidian_Card"},
4339: {"AegisName":"Mineral_Card"},
4340: {"AegisName":"Teddy_Bear_Card"},
4341: {"AegisName":"Metaling_Card"},
4342: {"AegisName":"Rsx_0806_Card"},
4343: {"AegisName":"Mole_Card"},
4344: {"AegisName":"Anopheles_Card"},
4345: {"AegisName":"Hill_Wind_Card"},
4346: {"AegisName":"Ygnizem_Card"},
4347: {"AegisName":"Armaia_Card"},
4348: {"AegisName":"Whikebain_Card"},
4349: {"AegisName":"Erend_Card"},
4350: {"AegisName":"Rawrel_Card"},
4351: {"AegisName":"Kavac_Card"},
4352: {"AegisName":"B_Ygnizem_Card"},
4353: {"AegisName":"Removal_Card"},
4354: {"AegisName":"Gemini_Card"},
4355: {"AegisName":"Gremlin_Card"},
4356: {"AegisName":"Beholder_Card"},
4357: {"AegisName":"B_Seyren_Card"},
4358: {"AegisName":"Seyren_Card"},
4359: {"AegisName":"B_Eremes_Card"},
4360: {"AegisName":"Eremes_Card"},
4361: {"AegisName":"B_Harword_Card"},
4362: {"AegisName":"Harword_Card"},
4363: {"AegisName":"B_Magaleta_Card"},
4364: {"AegisName":"Magaleta_Card"},
4365: {"AegisName":"B_Katrinn_Card"},
4366: {"AegisName":"Katrinn_Card"},
4367: {"AegisName":"B_Shecil_Card"},
4368: {"AegisName":"Shecil_Card"},
4369: {"AegisName":"Venatu_Card"},
4370: {"AegisName":"Dimik_Card"},
4371: {"AegisName":"Archdam_Card"},
4372: {"AegisName":"Bacsojin_Card"},
4373: {"AegisName":"Chung_E_Card"},
4374: {"AegisName":"Apocalips_H_Card"},
4375: {"AegisName":"Orc_Baby_Card_Card"},
4376: {"AegisName":"Lady_Tanee_Card"},
4377: {"AegisName":"Green_Iguana_Card"},
4378: {"AegisName":"Acidus_Card"},
4379: {"AegisName":"Acidus__Card"},
4380: {"AegisName":"Ferus_Card"},
4381: {"AegisName":"Ferus__Card"},
4382: {"AegisName":"Novus__Card"},
4383: {"AegisName":"Novus_Card"},
4384: {"AegisName":"Hydro_Card"},
4385: {"AegisName":"Dragon_Egg_Card"},
4386: {"AegisName":"Detale_Card"},
4387: {"AegisName":"Ancient_Mimic_Card"},
4388: {"AegisName":"Deathword_Card"},
4389: {"AegisName":"Plasma_Card"},
4390: {"AegisName":"Breeze_Card"},
4391: {"AegisName":"Retribution_Card"},
4392: {"AegisName":"Observation_Card"},
4393: {"AegisName":"Shelter_Card"},
4394: {"AegisName":"Solace_Card"},
4395: {"AegisName":"Tha_Maero_Card"},
4396: {"AegisName":"Tha_Odium_Card"},
4397: {"AegisName":"Tha_Despero_Card"},
4398: {"AegisName":"Tha_Dolor_Card"},
4399: {"AegisName":"Thanatos_Card"},
4400: {"AegisName":"Aliza_Card"},
4401: {"AegisName":"Alicel_Card"},
4402: {"AegisName":"Aliot_Card"},
4403: {"AegisName":"Kiel_Card"},
4404: {"AegisName":"Skogul_Card"},
4405: {"AegisName":"Frus_Card"},
4406: {"AegisName":"Skeggiold_Card"},
4407: {"AegisName":"Randgris_Card"},
4408: {"AegisName":"Gloom_Under_Night_Card"},
4409: {"AegisName":"Agav_Card"},
4410: {"AegisName":"Echio_Card"},
4411: {"AegisName":"Vanberk_Card"},
4412: {"AegisName":"Isilla_Card"},
4413: {"AegisName":"Hodremlin_Card"},
4414: {"AegisName":"Seeker_Card"},
4415: {"AegisName":"Snowier_Card"},
4416: {"AegisName":"Siroma_Card"},
4417: {"AegisName":"Ice_Titan_Card"},
4418: {"AegisName":"Gazeti_Card"},
4419: {"AegisName":"Ktullanux_Card"},
4420: {"AegisName":"Muscipular_Card"},
4421: {"AegisName":"Drosera_Card"},
4422: {"AegisName":"Roween_Card"},
4423: {"AegisName":"Galion_Card"},
4424: {"AegisName":"Stapo_Card"},
4425: {"AegisName":"Atroce_Card"},
4426: {"AegisName":"Byorgue_Card"},
4427: {"AegisName":"Sword_Guardian_Card"},
4428: {"AegisName":"Bow_Guardian_Card"},
4429: {"AegisName":"Salamander_Card"},
4430: {"AegisName":"Ifrit_Card"},
4431: {"AegisName":"Kasa_Card"},
4432: {"AegisName":"Magmaring_Card"},
4433: {"AegisName":"Imp_Card"},
4434: {"AegisName":"Knocker_Card"},
4435: {"AegisName":"Zombie_Slaughter_Card"},
4436: {"AegisName":"Ragged_Zombie_Card"},
4437: {"AegisName":"Hell_Poodle_Card"},
4438: {"AegisName":"Banshee_Card"},
4439: {"AegisName":"Flame_Skull_Card"},
4440: {"AegisName":"Necromancer_Card"},
4441: {"AegisName":"Fallen_Bishop_Card"},
4442: {"AegisName":"Tatacho_Card"},
4443: {"AegisName":"Aqua_Elemental_Card"},
4444: {"AegisName":"Draco_Card"},
4445: {"AegisName":"Luciola_Vespa_Card"},
4446: {"AegisName":"P_Skeleton_Card"},
4447: {"AegisName":"Centipede_Card"},
4448: {"AegisName":"Cornus_Card"},
4449: {"AegisName":"Dark_Shadow_Card"},
4450: {"AegisName":"Banshee_Master_Card"},
4451: {"AegisName":"Ant_Buyanne_Card"},
4452: {"AegisName":"Centipede_Larva_Card"},
4453: {"AegisName":"Hilsrion_Card"},
4454: {"AegisName":"Light_Up_Card1"},
4455: {"AegisName":"Light_Up_Card2"},
4456: {"AegisName":"Nidhogg_Shadow_Card"},
4457: {"AegisName":"Nahtzigger_Card"},
4458: {"AegisName":"Duneirre_Card"},
4459: {"AegisName":"Lata_Card"},
4460: {"AegisName":"Ringco_Card"},
4461: {"AegisName":"Pillar_Card"},
4462: {"AegisName":"Hardrock_Mommos_Card"},
4463: {"AegisName":"Tendrilion_Card"},
4464: {"AegisName":"Aunoe_Card"},
4465: {"AegisName":"Panat_Card"},
4466: {"AegisName":"Beholder_Master_Card"},
4467: {"AegisName":"Heavy_Metaling_Card"},
4468: {"AegisName":"Pinguicula_Dark_Card"},
4469: {"AegisName":"Naga_Card"},
4470: {"AegisName":"Nepenthes_Card"},
4471: {"AegisName":"Egg_Of_Draco_Card"},
4472: {"AegisName":"Bradium_Goram_Card"},
4473: {"AegisName":"Ancient_Tree_Card"},
4474: {"AegisName":"Jakudam_Card"},
4475: {"AegisName":"Cobalt_Mineral_Card"},
4476: {"AegisName":"Pinguicula_Card"},
4477: {"AegisName":"Hell_Apocalips_Card"},
4478: {"AegisName":"Light_Up_Card3"},
4479: {"AegisName":"Light_Up_Card4"},
4480: {"AegisName":"Sealed_Kiel_Card"},
4481: {"AegisName":"Sealed_Ktullanux_Card"},
4482: {"AegisName":"Sealed_B_Ygnizem_Card"},
4483: {"AegisName":"Sealed_Dracula_Card"},
4484: {"AegisName":"Sealed_Mistress_Card"},
4485: {"AegisName":"Sealed_Gloom_Card"},
4486: {"AegisName":"Sealed_Berz_Card"},
4487: {"AegisName":"Sealed_Ifrit_Card"},
4488: {"AegisName":"Sealed_D_Lord_Card"},
4489: {"AegisName":"Sealed_Pharaoh_Card"},
4490: {"AegisName":"Sealed_M_Flower_Card"},
4491: {"AegisName":"Sealed_B_Shecil_Card"},
4492: {"AegisName":"Sealed_Orc_Hero_Card"},
4493: {"AegisName":"Sealed_Tao_Card"},
4494: {"AegisName":"Sealed_TurtleG_Card"},
4495: {"AegisName":"Sealed_Amon_Ra_Card"},
4496: {"AegisName":"Sealed_Drake_Card"},
4497: {"AegisName":"Sealed_Knight_WS_Card"},
4498: {"AegisName":"Sealed_Lady_Tanee_Card"},
4499: {"AegisName":"Sealed_Samurai_Card"},
4500: {"AegisName":"Sealed_Orc_Load_Card"},
4501: {"AegisName":"Sealed_B_Magaleta_Card"},
4502: {"AegisName":"Sealed_B_Harword_Card"},
4503: {"AegisName":"Sealed_Apocalips_H_Card"},
4504: {"AegisName":"Sealed_Eddga_Card"},
4505: {"AegisName":"Scaraba_Card"},
4506: {"AegisName":"Dolomedes_Card"},
4507: {"AegisName":"Q_Scaraba_Card"},
4508: {"AegisName":"Gold_Scaraba_Card"},
4509: {"AegisName":"Gold_Q_Scaraba_Card"},
4510: {"AegisName":"Miming_Card"},
4511: {"AegisName":"Little_Fatum_Card"},
4512: {"AegisName":"Parus_Card"},
4513: {"AegisName":"Angra_Mantis_Card"},
4514: {"AegisName":"Pom_Spider_Card"},
4515: {"AegisName":"Alnoldi_Card"},
4516: {"AegisName":"Comodo_Card"},
4517: {"AegisName":"Cendrawasih_Card"},
4518: {"AegisName":"Banaspaty_Card"},
4519: {"AegisName":"Butoijo_Card"},
4520: {"AegisName":"Leak_Card"},
4521: {"AegisName":"Sedora_Card"},
4522: {"AegisName":"Sropho_Card"},
4523: {"AegisName":"Pot_Dofle_Card"},
4524: {"AegisName":"King_Dramoh_Card"},
4525: {"AegisName":"Kraken_Card"},
4526: {"AegisName":"Odd_Coelacanth_Card"},
4527: {"AegisName":"Black_Coelacanth_Card"},
4528: {"AegisName":"Mutant_Coelacanth_Card"},
4529: {"AegisName":"Cruel_Coelacanth_Card"},
4530: {"AegisName":"Siorava_Card"},
4531: {"AegisName":"Red_Eruma_Card"},
4532: {"AegisName":"Wild_Rider_Card"},
4533: {"AegisName":"Mini_Octopus_Card"},
4534: {"AegisName":"Giant_Octopus_Card"},
4535: {"AegisName":"Sealed_Rand_Card"},
4536: {"AegisName":"Sealed_Atroce_Card"},
4537: {"AegisName":"Sealed_Phreeoni_Card"},
4538: {"AegisName":"Sealed_Bacsojin_Card"},
4539: {"AegisName":"Sealed_F_Bishop_Card"},
4540: {"AegisName":"SLD_Lord_Of_Death_Card"},
4541: {"AegisName":"SLD_B_Katrinn_Card"},
4542: {"AegisName":"SLD_Detale_Card"},
4543: {"AegisName":"SLD_Garm_Card"},
4544: {"AegisName":"SLD_Dark_Snake_Card"},
4545: {"AegisName":"Novice_Poring_Card"},
4546: {"AegisName":"Light_Up_Card5"},
4547: {"AegisName":"Upd_Byorgue_Card"},
4548: {"AegisName":"Upd_Salamander_Card"},
4549: {"AegisName":"Upd_Maya_Puple_Card"},
4550: {"AegisName":"Upd_Bow_Guardian_Card"},
4551: {"AegisName":"Upd_Necromancer_Card"},
4552: {"AegisName":"Manny_Card"},
4553: {"AegisName":"Sid_Card"},
4554: {"AegisName":"Diego_Card"},
4555: {"AegisName":"Scrat_Card"},
4556: {"AegisName":"Fenrir_Card"},
4557: {"AegisName":"Fenrir_Card_"},
4558: {"AegisName":"Woodie_Card"},
4559: {"AegisName":"M_Morocc_Card"},
4560: {"AegisName":"Clown_Card"},
4561: {"AegisName":"Professor_Card"},
4562: {"AegisName":"Champion_Card"},
4563: {"AegisName":"Creator_Card"},
4564: {"AegisName":"Stalker_Card"},
4565: {"AegisName":"Paladin_Card"},
4566: {"AegisName":"Gypsy_Card"},
4567: {"AegisName":"Alphoccio_Card"},
4568: {"AegisName":"Ceila_Card"},
4569: {"AegisName":"Chen_Card"},
4570: {"AegisName":"Flamel_Card"},
4571: {"AegisName":"Gertie_Card"},
4572: {"AegisName":"Randel_Card"},
4573: {"AegisName":"Trentini_Card"},
4574: {"AegisName":"Daehyon_Card"},
4575: {"AegisName":"Soheon_Card"},
4576: {"AegisName":"Gioia_Card"},
4577: {"AegisName":"Elvira_Card"},
4578: {"AegisName":"Pyuriel_Card"},
4579: {"AegisName":"Lora_Card"},
4580: {"AegisName":"Kades_Card"},
4581: {"AegisName":"Rudo_Card"},
4582: {"AegisName":"Bungisngis_Card"},
4583: {"AegisName":"Engkanto_Card"},
4584: {"AegisName":"Manananggal_Card"},
4585: {"AegisName":"Mangkukulam_Card"},
4586: {"AegisName":"Tikbalang_Card"},
4587: {"AegisName":"Tiyanak_Card"},
4588: {"AegisName":"Wakwak_Card"},
4589: {"AegisName":"Jejeling_Card"},
4590: {"AegisName":"Bangungot_Card"},
4591: {"AegisName":"Bakonawa_Card"},
4592: {"AegisName":"Buwaya_Card"},
4593: {"AegisName":"Menblatt_Card"},
4594: {"AegisName":"Petal_Card"},
4595: {"AegisName":"Cenere_Card"},
4596: {"AegisName":"AntiqueBook_Card"},
4597: {"AegisName":"LichternB_Card"},
4598: {"AegisName":"LichternY_Card"},
4599: {"AegisName":"LichternR_Card"},
4600: {"AegisName":"LichternG_Card"},
4601: {"AegisName":"Amdarais_Card"},
4602: {"AegisName":"AmdaraisH_Card"},
4603: {"AegisName":"CorruptionRoot_Card"},
4604: {"AegisName":"CorruptionRootH_Card"},
4605: {"AegisName":"UndeadKnightM_Card"},
4606: {"AegisName":"UndeadKnightF_Card"},
4607: {"AegisName":"FaithfulManager_Card"},
4608: {"AegisName":"White_Knightage_Card"},
4609: {"AegisName":"Khaliz_Knightage_Card"},
4610: {"AegisName":"Sarah_Card"},
4623: {"AegisName":"Adventures_Card"},
4625: {"AegisName":"Timeholder_Card"},
4626: {"AegisName":"Big_Ben_Card"},
4627: {"AegisName":"Big_Bell_Card"},
4628: {"AegisName":"Neo_Punk_Card"},
4629: {"AegisName":"Arc_Elder_Card"},
4630: {"AegisName":"Time_Keeper_Card"},
4631: {"AegisName":"Owl_Viscount_Card"},
4632: {"AegisName":"Owl_Marquees_Card"},
4633: {"AegisName":"P_Archer_Skeleton_Card"},
4634: {"AegisName":"P_Soldier_Skeleton_Card"},
4635: {"AegisName":"P_Amdarais_Card"},
4636: {"AegisName":"Bijou_Card"},
4637: {"AegisName":"Immotal_Corps_Card"},
4638: {"AegisName":"Watcher_Card"},
4639: {"AegisName":"Tappy_Card"},
4640: {"AegisName":"Frozenwolf_Card"},
4641: {"AegisName":"Zombie_Guard_Card"},
4642: {"AegisName":"IFN_Toad_Card"},
4643: {"AegisName":"IFN_V_Wolf_Card"},
4644: {"AegisName":"IFN_Vocal_Card"},
4645: {"AegisName":"IFN_Eclipse_Card"},
4646: {"AegisName":"IFN_Chimera_Card"},
4647: {"AegisName":"IFN_Osiris_Card"},
4648: {"AegisName":"IFN_Eddga_Card"},
4649: {"AegisName":"IFN_Phreeoni_Card"},
4650: {"AegisName":"IFN_OrcHero_Card"},
4651: {"AegisName":"IFN_Tao_Gunka_Card"},
4652: {"AegisName":"Grave_Amon_Ra_Card"},
4653: {"AegisName":"Grave_Arclouse_Card"},
4654: {"AegisName":"Grave_Mimic_Card"},
4655: {"AegisName":"Grave_Minorous_Card"},
4656: {"AegisName":"Grave_Mummy_Card"},
4657: {"AegisName":"Grave_A_Mummy_Card"},
4658: {"AegisName":"Grave_Verit_Card"},
4659: {"AegisName":"Eggring_Card"},
4660: {"AegisName":"Basilisk1_Card"},
4661: {"AegisName":"Basilisk2_Card"},
4662: {"AegisName":"Big_Eggring_Card"},
4663: {"AegisName":"Leaf_Lunatic_Card"},
4664: {"AegisName":"Grass_Fabre_Card"},
4665: {"AegisName":"Wild_Honet_Card"},
4666: {"AegisName":"Sw_Roda_Frog_Card"},
4667: {"AegisName":"Hunter_Wolf_Card"},
4668: {"AegisName":"Trance_Spore_Card"},
4669: {"AegisName":"Ju_Mandragora_Card"},
4670: {"AegisName":"Fru_Pom_Spider_Card"},
4671: {"AegisName":"Sorcerer_Card"},
4672: {"AegisName":"Sura_Card"},
4673: {"AegisName":"Minstrel_Card"},
4674: {"AegisName":"GuillotineCross_Card"},
4675: {"AegisName":"Archbishop_Card"},
4676: {"AegisName":"Ranger_Card"},
4677: {"AegisName":"Mechanic_Card"},
4678: {"AegisName":"Warlock_Card"},
4679: {"AegisName":"RuneKnight_Card"},
4680: {"AegisName":"RoyalGuard_Card"},
4681: {"AegisName":"Genetic_Card"},
4682: {"AegisName":"ShadowChaser_Card"},
4683: {"AegisName":"Wanderer_Card"},
4684: {"AegisName":"Real_Eremes_Card"},
4685: {"AegisName":"Real_Magaleta_Card"},
4686: {"AegisName":"Real_Katrinn_Card"},
4687: {"AegisName":"Real_Shecil_Card"},
4688: {"AegisName":"Real_Harword_Card"},
4689: {"AegisName":"Real_Seyren_Card"},
4690: {"AegisName":"Real_Randel_Card"},
4691: {"AegisName":"Real_Flamel_Card"},
4692: {"AegisName":"Real_Ceila_Card"},
4693: {"AegisName":"Real_Chen_Card"},
4694: {"AegisName":"Real_Gertie_Card"},
4695: {"AegisName":"Real_Trentini_Card"},
4696: {"AegisName":"Real_Alphoccio_Card"},
4697: {"AegisName":"Charleston_Card"},
4698: {"AegisName":"Step_Card"},
4699: {"AegisName":"Rock_Step_Card"},
4700: {"AegisName":"Strength1"},
4701: {"AegisName":"Strength2"},
4702: {"AegisName":"Strength3"},
4703: {"AegisName":"Strength4"},
4704: {"AegisName":"Strength5"},
4705: {"AegisName":"Strength6"},
4706: {"AegisName":"Strength7"},
4707: {"AegisName":"Strength8"},
4708: {"AegisName":"Strength9"},
4709: {"AegisName":"Strength10"},
4710: {"AegisName":"Inteligence1"},
4711: {"AegisName":"Inteligence2"},
4712: {"AegisName":"Inteligence3"},
4713: {"AegisName":"Inteligence4"},
4714: {"AegisName":"Inteligence5"},
4715: {"AegisName":"Inteligence6"},
4716: {"AegisName":"Inteligence7"},
4717: {"AegisName":"Inteligence8"},
4718: {"AegisName":"Inteligence9"},
4719: {"AegisName":"Inteligence10"},
4720: {"AegisName":"Dexterity1"},
4721: {"AegisName":"Dexterity2"},
4722: {"AegisName":"Dexterity3"},
4723: {"AegisName":"Dexterity4"},
4724: {"AegisName":"Dexterity5"},
4725: {"AegisName":"Dexterity6"},
4726: {"AegisName":"Dexterity7"},
4727: {"AegisName":"Dexterity8"},
4728: {"AegisName":"Dexterity9"},
4729: {"AegisName":"Dexterity10"},
4730: {"AegisName":"Agility1"},
4731: {"AegisName":"Agility2"},
4732: {"AegisName":"Agility3"},
4733: {"AegisName":"Agility4"},
4734: {"AegisName":"Agility5"},
4735: {"AegisName":"Agility6"},
4736: {"AegisName":"Agility7"},
4737: {"AegisName":"Agility8"},
4738: {"AegisName":"Agility9"},
4739: {"AegisName":"Agility10"},
4740: {"AegisName":"Vitality1"},
4741: {"AegisName":"Vitality2"},
4742: {"AegisName":"Vitality3"},
4743: {"AegisName":"Vitality4"},
4744: {"AegisName":"Vitality5"},
4745: {"AegisName":"Vitality6"},
4746: {"AegisName":"Vitality7"},
4747: {"AegisName":"Vitality8"},
4748: {"AegisName":"Vitality9"},
4749: {"AegisName":"Vitality10"},
4750: {"AegisName":"Luck1"},
4751: {"AegisName":"Luck2"},
4752: {"AegisName":"Luck3"},
4753: {"AegisName":"Luck4"},
4754: {"AegisName":"Luck5"},
4755: {"AegisName":"Luck6"},
4756: {"AegisName":"Luck7"},
4757: {"AegisName":"Luck8"},
4758: {"AegisName":"Luck9"},
4759: {"AegisName":"Luck10"},
4760: {"AegisName":"Matk1"},
4761: {"AegisName":"Matk2"},
4762: {"AegisName":"Evasion6"},
4763: {"AegisName":"Evasion12"},
4764: {"AegisName":"Critical5"},
4765: {"AegisName":"Critical7"},
4766: {"AegisName":"Atk2"},
4767: {"AegisName":"Atk3"},
4768: {"AegisName":"Str1_J"},
4769: {"AegisName":"Str2_J"},
4770: {"AegisName":"Str3_J"},
4771: {"AegisName":"Int1_J"},
4772: {"AegisName":"Int2_J"},
4773: {"AegisName":"Int3_J"},
4774: {"AegisName":"Vit1_J"},
4775: {"AegisName":"Vit2_J"},
4776: {"AegisName":"Vit3_J"},
4777: {"AegisName":"Agi1_J"},
4778: {"AegisName":"Agi2_J"},
4779: {"AegisName":"Agi3_J"},
4780: {"AegisName":"Dex1_J"},
4781: {"AegisName":"Dex2_J"},
4782: {"AegisName":"Dex3_J"},
4783: {"AegisName":"Luk1_J"},
4784: {"AegisName":"Luk2_J"},
4785: {"AegisName":"Luk3_J"},
4786: {"AegisName":"Mdef2"},
4787: {"AegisName":"Mdef4"},
4788: {"AegisName":"Mdef6"},
4789: {"AegisName":"Mdef8"},
4790: {"AegisName":"Mdef10"},
4791: {"AegisName":"Def3"},
4792: {"AegisName":"Def6"},
4793: {"AegisName":"Def9"},
4794: {"AegisName":"Def12"},
4795: {"AegisName":"HP100"},
4796: {"AegisName":"HP200"},
4797: {"AegisName":"HP300"},
4798: {"AegisName":"HP400"},
4799: {"AegisName":"HP500"},
4800: {"AegisName":"SP50"},
4801: {"AegisName":"SP100"},
4802: {"AegisName":"SP150"},
4803: {"AegisName":"Highness_Heal_3sec"},
4804: {"AegisName":"Coluceo_Heal30"},
4805: {"AegisName":"Heal_Amount2"},
4806: {"AegisName":"Matk3"},
4807: {"AegisName":"Atk_Speed1"},
4808: {"AegisName":"Fighting_Spirit4"},
4809: {"AegisName":"Fighting_Spirit3"},
4810: {"AegisName":"Fighting_Spirit2"},
4811: {"AegisName":"Fighting_Spirit1"},
4812: {"AegisName":"Spell4"},
4813: {"AegisName":"Spell3"},
4814: {"AegisName":"Spell2"},
4815: {"AegisName":"Spell1"},
4816: {"AegisName":"Sharp3"},
4817: {"AegisName":"Sharp2"},
4818: {"AegisName":"Sharp1"},
4819: {"AegisName":"Atk1"},
4820: {"AegisName":"Fighting_Spirit5"},
4821: {"AegisName":"Fighting_Spirit6"},
4822: {"AegisName":"Fighting_Spirit7"},
4823: {"AegisName":"Fighting_Spirit8"},
4824: {"AegisName":"Fighting_Spirit9"},
4825: {"AegisName":"Fighting_Spirit10"},
4826: {"AegisName":"Spell5"},
4827: {"AegisName":"Spell6"},
4828: {"AegisName":"Spell7"},
4829: {"AegisName":"Spell8"},
4830: {"AegisName":"Spell9"},
4831: {"AegisName":"Spell10"},
4832: {"AegisName":"Expert_Archer1"},
4833: {"AegisName":"Expert_Archer2"},
4834: {"AegisName":"Expert_Archer3"},
4835: {"AegisName":"Expert_Archer4"},
4836: {"AegisName":"Expert_Archer5"},
4837: {"AegisName":"Expert_Archer6"},
4838: {"AegisName":"Expert_Archer7"},
4839: {"AegisName":"Expert_Archer8"},
4840: {"AegisName":"Expert_Archer9"},
4841: {"AegisName":"Expert_Archer10"},
4842: {"AegisName":"Atk_Speed2"},
4843: {"AegisName":"Sharp4"},
4844: {"AegisName":"Sharp5"},
4845: {"AegisName":"Sea_Energy"},
4846: {"AegisName":"2011Valentin_Angel"},
4847: {"AegisName":"2011Valentin_Devil"},
4848: {"AegisName":"Immuned1"},
4849: {"AegisName":"Cranial1"},
4850: {"AegisName":"Heal_Amount3"},
4851: {"AegisName":"Heal_Amount4"},
4852: {"AegisName":"Heal_Amount5"},
4853: {"AegisName":"S_Str"},
4854: {"AegisName":"S_Agi"},
4855: {"AegisName":"S_Vital"},
4856: {"AegisName":"S_Int"},
4857: {"AegisName":"S_Dex"},
4858: {"AegisName":"S_Luck"},
4859: {"AegisName":"Evasion1"},
4860: {"AegisName":"Evasion3"},
4861: {"AegisName":"MHP1"},
4862: {"AegisName":"MHP2"},
4863: {"AegisName":"Fatal1"},
4864: {"AegisName":"Fatal2"},
4865: {"AegisName":"Fatal3"},
4866: {"AegisName":"Fatal4"},
4867: {"AegisName":"MHP3"},
4868: {"AegisName":"MHP4"},
4869: {"AegisName":"Attack_Delay_1"},
4870: {"AegisName":"SP25"},
4871: {"AegisName":"SP75"},
4872: {"AegisName":"Attack_Delay_2"},
4873: {"AegisName":"Attack_Delay_3"},
4874: {"AegisName":"Beryl_of_Spring"},
4875: {"AegisName":"Bear's_Power"},
4876: {"AegisName":"Runaway_Magic"},
4877: {"AegisName":"Speed_Of_Light"},
4878: {"AegisName":"Muscle_Fool"},
4879: {"AegisName":"Hawkeye"},
4880: {"AegisName":"Lucky_Day"},
4881: {"AegisName":"Attack_Delay_4"},
4882: {"AegisName":"Atk1p"},
4883: {"AegisName":"Matk1p"},
4884: {"AegisName":"HIT1"},
4885: {"AegisName":"Conjure1"},
4886: {"AegisName":"Conjure2"},
4887: {"AegisName":"Conjure3"},
4888: {"AegisName":"Conjure4"},
4889: {"AegisName":"Conjure5"},
4890: {"AegisName":"Mdef1"},
4891: {"AegisName":"Mdef3"},
4892: {"AegisName":"Mdef5"},
4893: {"AegisName":"Def15"},
4894: {"AegisName":"Atk4p"},
4895: {"AegisName":"Atk5p"},
4896: {"AegisName":"Matk2p"},
4897: {"AegisName":"Matk3p"},
4898: {"AegisName":"Matk4p"},
4899: {"AegisName":"Matk5p"},
4900: {"AegisName":"MHP5"},
4902: {"AegisName":"Def18"},
4903: {"AegisName":"Def21"},
4904: {"AegisName":"Atk6p"},
4905: {"AegisName":"Atk7p"},
4906: {"AegisName":"Matk6p"},
4907: {"AegisName":"Matk7p"},
4908: {"AegisName":"Force1"},
4909: {"AegisName":"Force2"},
4910: {"AegisName":"Force3"},
4911: {"AegisName":"Intellect1"},
4912: {"AegisName":"Intellect2"},
4913: {"AegisName":"Intellect3"},
4914: {"AegisName":"Swiftness1"},
4915: {"AegisName":"Swiftness2"},
4916: {"AegisName":"Swiftness3"},
4917: {"AegisName":"Tough1"},
4918: {"AegisName":"Tough2"},
4919: {"AegisName":"Tough3"},
4920: {"AegisName":"Artful1"},
4921: {"AegisName":"Artful2"},
4922: {"AegisName":"Artful3"},
4923: {"AegisName":"Fortune1"},
4924: {"AegisName":"Fortune2"},
4925: {"AegisName":"Fortune3"},
4926: {"AegisName":"Critical1"},
4927: {"AegisName":"HP50"},
4928: {"AegisName":"SP10"},
4929: {"AegisName":"MSP1"},
4930: {"AegisName":"HEAL2"},
4931: {"AegisName":"HEALHP1"},
4932: {"AegisName":"HEALSP1"},
4933: {"AegisName":"Tolerance_Not1"},
4934: {"AegisName":"Tolerance_Not2"},
4935: {"AegisName":"Tolerance_Not3"},
4936: {"AegisName":"ATK_BIG1"},
4937: {"AegisName":"ATK_MEDIUM1"},
4938: {"AegisName":"ATK_SMALL1"},
4939: {"AegisName":"Critical2"},
4940: {"AegisName":"Critical3"},
4941: {"AegisName":"Critical4"},
4942: {"AegisName":"Dodge1"},
4943: {"AegisName":"Dodge2"},
4944: {"AegisName":"Dodge3"},
4945: {"AegisName":"Thrift1"},
4946: {"AegisName":"Thrift2"},
4947: {"AegisName":"Thrift3"},
4948: {"AegisName":"Skill_Delay1"},
4949: {"AegisName":"Skill_Delay2"},
4950: {"AegisName":"Skill_Delay3"},
4951: {"AegisName":"A_Drop_Of_Dark_"},
4952: {"AegisName":"A_Drop_Of_Fire_"},
4953: {"AegisName":"A_Drop_Of_Water_"},
4954: {"AegisName":"A_Drop_Of_Tree_"},
4955: {"AegisName":"A_Drop_Of_Light_"},
4956: {"AegisName":"A_Drop_Of_Heal_"},
4957: {"AegisName":"CollaboPower"},
4958: {"AegisName":"Z_Stone_1"},
4959: {"AegisName":"Z_Stone_2"},
4960: {"AegisName":"Z_Stone_3"},
4961: {"AegisName":"Z_Stone_4"},
4962: {"AegisName":"Z_Stone_5"},
4963: {"AegisName":"Z_Stone_6"},
4964: {"AegisName":"Z_Stone_7"},
4965: {"AegisName":"Z_Stone_8"},
4966: {"AegisName":"Z_Stone_9"},
4967: {"AegisName":"Z_Stone_10"},
4968: {"AegisName":"Z_Stone_11"},
4969: {"AegisName":"Z_Stone_12"},
4970: {"AegisName":"Reactor_P_FIRE"},
4971: {"AegisName":"Reactor_P_WATER"},
4972: {"AegisName":"Reactor_P_GROUND"},
4973: {"AegisName":"Reactor_P_WIND"},
4974: {"AegisName":"Reactor_T_FIRE"},
4975: {"AegisName":"Reactor_T_WATER"},
4976: {"AegisName":"Reactor_T_GROUND"},
4977: {"AegisName":"Reactor_T_WIND"},
4978: {"AegisName":"Reactor_Cure_101"},
4979: {"AegisName":"Reactor_Cure_102"},
4980: {"AegisName":"Reactor_Cure_201"},
4981: {"AegisName":"Reactor_Cure_202"},
4982: {"AegisName":"Reactor_A_STR"},
4983: {"AegisName":"Reactor_A_INT"},
4984: {"AegisName":"Reactor_A_DEF"},
4985: {"AegisName":"Reactor_A_AVOI"},
4986: {"AegisName":"Reactor_A_ATK"},
4987: {"AegisName":"Reactor_A_MATK"},
4988: {"AegisName":"Reactor_A_MHP"},
4989: {"AegisName":"Reactor_A_MSP"},
4990: {"AegisName":"Reactor_A_FROZ"},
4991: {"AegisName":"Reactor_A_ASPD"},
4992: {"AegisName":"HPdrain1"},
4993: {"AegisName":"SPdrain1"},
4994: {"AegisName":"Neev_STR_1"},
4995: {"AegisName":"Neev_STR_2"},
4996: {"AegisName":"Neev_STR_3"},
4997: {"AegisName":"Neev_AGI_1"},
4998: {"AegisName":"Neev_AGI_2"},
4999: {"AegisName":"Neev_AGI_3"},
5001: {"AegisName":"Headset"},
5002: {"AegisName":"Gemmed_Crown"},
5003: {"AegisName":"Joker_Jester"},
5004: {"AegisName":"Oxygen_Mask"},
5005: {"AegisName":"Gas_Mask"},
5006: {"AegisName":"Machoman_Glasses"},
5007: {"AegisName":"Loard_Circlet"},
5008: {"AegisName":"Puppy_Love"},
5009: {"AegisName":"Safety_Helmet"},
5010: {"AegisName":"Indian_Hair_Piece"},
5011: {"AegisName":"Antenna"},
5012: {"AegisName":"Ph.D_Hat"},
5013: {"AegisName":"Horn_Of_Lord_Kaho"},
5014: {"AegisName":"Fin_Helm"},
5015: {"AegisName":"Egg_Shell"},
5016: {"AegisName":"Boy's_Cap"},
5017: {"AegisName":"Bone_Helm"},
5018: {"AegisName":"Feather_Bonnet"},
5019: {"AegisName":"Corsair"},
5020: {"AegisName":"Kafra_Band"},
5021: {"AegisName":"Bankruptcy_Of_Heart"},
5022: {"AegisName":"Helm_Of_Sun"},
5023: {"AegisName":"Hat_Of_Bundle"},
5024: {"AegisName":"Hat_Of_Cake"},
5025: {"AegisName":"Helm_Of_Angel"},
5026: {"AegisName":"Hat_Of_Cook"},
5027: {"AegisName":"Wizardry_Hat"},
5028: {"AegisName":"Candle"},
5029: {"AegisName":"Spore_Hat"},
5030: {"AegisName":"Panda_Cap"},
5031: {"AegisName":"Mine_Helm"},
5032: {"AegisName":"Picnic_Hat"},
5033: {"AegisName":"Smokie_Hat"},
5034: {"AegisName":"Light_Bulb_Band"},
5035: {"AegisName":"Poring_Hat"},
5036: {"AegisName":"Cross_Band"},
5037: {"AegisName":"Fruit_Shell"},
5038: {"AegisName":"Deviruchi_Cap"},
5039: {"AegisName":"Mottled_Egg_Shell"},
5040: {"AegisName":"Blush"},
5041: {"AegisName":"Heart_Hair_Pin"},
5042: {"AegisName":"Hair_Protector"},
5043: {"AegisName":"Opera_Ghost_Mask"},
5044: {"AegisName":"Devil's_Wing"},
5045: {"AegisName":"Magician_Hat"},
5046: {"AegisName":"Bongun_Hat"},
5047: {"AegisName":"Fashion_Sunglass"},
5048: {"AegisName":"First_Moon_Hair_Pin"},
5049: {"AegisName":"Stripe_Band"},
5050: {"AegisName":"Mystery_Fruit_Shell"},
5051: {"AegisName":"Kitty_Bell"},
5052: {"AegisName":"Blue_Hair_Band"},
5053: {"AegisName":"Spinx_Helm"},
5054: {"AegisName":"Popcorn_Hair"},
5055: {"AegisName":"Novice_Egg_Cap"},
5056: {"AegisName":"Love_Berry"},
5057: {"AegisName":"Ear_Of_Black_Cat"},
5058: {"AegisName":"Drooping_Kitty"},
5059: {"AegisName":"Brown_Bear_Cap"},
5060: {"AegisName":"Party_Hat"},
5061: {"AegisName":"Flower_Hairpin"},
5062: {"AegisName":"Straw_Hat"},
5063: {"AegisName":"Plaster"},
5064: {"AegisName":"Leaf_Headgear"},
5065: {"AegisName":"Fish_On_Head"},
5066: {"AegisName":"Horn_Of_Succubus"},
5067: {"AegisName":"Sombrero"},
5068: {"AegisName":"Ear_Of_Devil's_Wing"},
5069: {"AegisName":"Mask_Of_Fox"},
5070: {"AegisName":"Headband_Of_Power"},
5071: {"AegisName":"Indian_Headband"},
5072: {"AegisName":"Inccubus_Horn"},
5073: {"AegisName":"Cap_Of_Concentration"},
5074: {"AegisName":"Ear_Of_Angel's_Wing"},
5075: {"AegisName":"Cowboy_Hat"},
5076: {"AegisName":"Fur_Hat"},
5077: {"AegisName":"Tulip_Hairpin"},
5078: {"AegisName":"Sea_Otter_Cap"},
5079: {"AegisName":"Crossed_Hair_Band"},
5080: {"AegisName":"Headgear_Of_Queen"},
5081: {"AegisName":"Mistress_Crown"},
5082: {"AegisName":"Mushroom_Band"},
5083: {"AegisName":"Red_Tailed_Ribbon"},
5084: {"AegisName":"Lazy_Raccoon"},
5085: {"AegisName":"Pair_Of_Red_Ribbon"},
5086: {"AegisName":"Alarm_Mask"},
5087: {"AegisName":"Goblin_Mask_01"},
5088: {"AegisName":"Goblin_Mask_02"},
5089: {"AegisName":"Goblin_Mask_03"},
5090: {"AegisName":"Goblin_Mask_04"},
5091: {"AegisName":"Big_Golden_Bell"},
5092: {"AegisName":"Blue_Coif"},
5093: {"AegisName":"Blue_Coif_"},
5094: {"AegisName":"Orc_Hero_Helm"},
5095: {"AegisName":"Orc_Hero_Helm_"},
5096: {"AegisName":"Assassin_Mask_"},
5097: {"AegisName":"Cone_Hat_"},
5098: {"AegisName":"Tiger_Mask"},
5099: {"AegisName":"Cat_Hat"},
5100: {"AegisName":"Sales_Signboard"},
5101: {"AegisName":"Takius_Blindfold"},
5102: {"AegisName":"Round_Eyes"},
5103: {"AegisName":"Sunflower_Hairpin"},
5104: {"AegisName":"Dark_Blindfold"},
5105: {"AegisName":"Hat_Of_Cake_"},
5106: {"AegisName":"Cone_Hat_INA"},
5107: {"AegisName":"Well_Baked_Toast"},
5108: {"AegisName":"Detective_Hat"},
5109: {"AegisName":"Red_Bonnet"},
5110: {"AegisName":"Baby_Pacifier"},
5111: {"AegisName":"Galapago_Cap"},
5112: {"AegisName":"Super_Novice_Hat"},
5113: {"AegisName":"Angry_Mouth"},
5114: {"AegisName":"Fedora"},
5115: {"AegisName":"Winter_Hat"},
5116: {"AegisName":"Banana_Hat"},
5117: {"AegisName":"Mistic_Rose"},
5118: {"AegisName":"Ear_Of_Puppy"},
5119: {"AegisName":"Super_Novice_Hat_"},
5120: {"AegisName":"Fedora_"},
5121: {"AegisName":"Zherlthsh_Mask"},
5122: {"AegisName":"Magni_Cap"},
5123: {"AegisName":"Ulle_Cap"},
5124: {"AegisName":"Fricca_Circlet"},
5125: {"AegisName":"Kiss_Of_Angel"},
5126: {"AegisName":"Morpheus's_Hood"},
5127: {"AegisName":"Morrigane's_Helm"},
5128: {"AegisName":"Goibne's_Helmet"},
5129: {"AegisName":"Bird_Nest"},
5130: {"AegisName":"Lion_Mask"},
5131: {"AegisName":"Close_Helmet"},
5132: {"AegisName":"Angeling_Hat"},
5133: {"AegisName":"Sheep_Hat"},
5134: {"AegisName":"Pumpkin_Hat"},
5135: {"AegisName":"Cyclops_Visor"},
5136: {"AegisName":"Santa's_Hat_"},
5137: {"AegisName":"Alice_Doll"},
5138: {"AegisName":"Magic_Eyes"},
5139: {"AegisName":"Hibiscus"},
5140: {"AegisName":"Charming_Ribbon"},
5141: {"AegisName":"Marionette_Doll"},
5142: {"AegisName":"Crescent_Helm"},
5143: {"AegisName":"Kabuki_Mask"},
5144: {"AegisName":"Gambler_Hat"},
5145: {"AegisName":"Carnival_Joker_Jester"},
5146: {"AegisName":"Elephant_Hat"},
5147: {"AegisName":"Baseball_Cap"},
5148: {"AegisName":"Phrygian_Cap"},
5149: {"AegisName":"Silver_Tiara"},
5150: {"AegisName":"Joker_Jester_"},
5151: {"AegisName":"Headset_OST"},
5152: {"AegisName":"Chinese_Crown"},
5153: {"AegisName":"Angeling_Hairpin"},
5154: {"AegisName":"Sunglasses_F"},
5155: {"AegisName":"Granpa_Beard_F"},
5156: {"AegisName":"Flu_Mask_F"},
5157: {"AegisName":"Viking_Helm_"},
5158: {"AegisName":"Holy_Bonnet_"},
5159: {"AegisName":"Golden_Gear_"},
5160: {"AegisName":"Magestic_Goat_"},
5161: {"AegisName":"Sharp_Gear_"},
5162: {"AegisName":"Bone_Helm_"},
5163: {"AegisName":"Corsair_"},
5164: {"AegisName":"Tiara_"},
5165: {"AegisName":"Crown_"},
5166: {"AegisName":"Spinx_Helm_"},
5167: {"AegisName":"Munak_Turban_"},
5168: {"AegisName":"Bongun_Hat_"},
5169: {"AegisName":"Bride_Mask"},
5170: {"AegisName":"Feather_Beret"},
5171: {"AegisName":"Valkyrie_Helm"},
5172: {"AegisName":"Beret"},
5173: {"AegisName":"Satto_Hat"},
5174: {"AegisName":"Ayam"},
5175: {"AegisName":"Censor_Bar"},
5176: {"AegisName":"Hahoe_Mask"},
5177: {"AegisName":"Guardian_Lion_Mask"},
5178: {"AegisName":"Candle_"},
5179: {"AegisName":"Gold_Tiara"},
5180: {"AegisName":"Phrygian_Cap_"},
5181: {"AegisName":"Helm_Of_Darkness"},
5182: {"AegisName":"Puppy_Hat"},
5183: {"AegisName":"Bird_Nest_Hat"},
5184: {"AegisName":"Captain_Hat"},
5185: {"AegisName":"Laurel_Wreath"},
5186: {"AegisName":"Geographer_Band"},
5187: {"AegisName":"Twin_Ribbon"},
5188: {"AegisName":"Minstrel_Hat"},
5189: {"AegisName":"Fallen_Leaves"},
5190: {"AegisName":"Baseball_Cap_"},
5191: {"AegisName":"Ribbon_Black"},
5192: {"AegisName":"Ribbon_Yellow"},
5193: {"AegisName":"Ribbon_Green"},
5194: {"AegisName":"Ribbon_Pink"},
5195: {"AegisName":"Ribbon_Red"},
5196: {"AegisName":"Ribbon_Orange"},
5197: {"AegisName":"Ribbon_White"},
5198: {"AegisName":"Drooping_Bunny"},
5199: {"AegisName":"Baseball_Cap_I"},
5200: {"AegisName":"Coppola"},
5201: {"AegisName":"Party_Hat_B"},
5202: {"AegisName":"Pumpkin_Hat_"},
5203: {"AegisName":"Tongue_Mask"},
5204: {"AegisName":"Event_Pierrot_Nose"},
5205: {"AegisName":"Wreath"},
5206: {"AegisName":"Romantic_White_Flower"},
5207: {"AegisName":"Gold_Spirit_Chain"},
5208: {"AegisName":"Rideword_Hat"},
5209: {"AegisName":"Yellow_Baseball_Cap"},
5210: {"AegisName":"Flying_Angel"},
5211: {"AegisName":"Dress_Hat"},
5212: {"AegisName":"Satellite_Hairband"},
5213: {"AegisName":"Black_Bunny_Band"},
5214: {"AegisName":"Moonlight_Flower_Hat"},
5215: {"AegisName":"Angelic_Chain_"},
5216: {"AegisName":"Satanic_Chain_"},
5217: {"AegisName":"Magestic_Goat_TW"},
5218: {"AegisName":"Bunny_Band_"},
5219: {"AegisName":"Drooping_Kitty_"},
5220: {"AegisName":"Smoking_Pipe_"},
5221: {"AegisName":"Pair_Of_Red_Ribbon_"},
5222: {"AegisName":"Fish_On_Head_"},
5223: {"AegisName":"Big_Golden_Bell_"},
5224: {"AegisName":"Orc_Hero_Helm_TW"},
5225: {"AegisName":"Marcher_Hat"},
5226: {"AegisName":"Mini_Propeller_"},
5227: {"AegisName":"Red_Deviruchi_Cap"},
5228: {"AegisName":"White_Deviruchi_Cap"},
5229: {"AegisName":"Gray_Deviruchi_Cap"},
5230: {"AegisName":"White_Drooping_Kitty"},
5231: {"AegisName":"Gray_Drooping_Kitty"},
5232: {"AegisName":"Pink_Drooping_Kitty"},
5233: {"AegisName":"Blue_Drooping_Kitty"},
5234: {"AegisName":"Yellow_Drooping_Kitty"},
5235: {"AegisName":"Gray_Fur_Hat"},
5236: {"AegisName":"Blue_Fur_Hat"},
5237: {"AegisName":"Pink_Fur_Hat"},
5238: {"AegisName":"Red_Wizardry_Hat"},
5239: {"AegisName":"White_Wizardry_Hat"},
5240: {"AegisName":"Gray_Wizardry_Hat"},
5241: {"AegisName":"Blue_Wizardry_Hat"},
5242: {"AegisName":"Yellow_Wizardry_Hat"},
5243: {"AegisName":"Chullos"},
5244: {"AegisName":"Elven_Blindfold"},
5245: {"AegisName":"Elven_Sunglasses"},
5246: {"AegisName":"Angelic_Helm"},
5247: {"AegisName":"Satanic_Helm"},
5248: {"AegisName":"Robotic_Blindfold"},
5249: {"AegisName":"Human_Blindfold"},
5250: {"AegisName":"Robotic_Ears"},
5251: {"AegisName":"Round_Ears"},
5252: {"AegisName":"Drooping_Nine_Tail"},
5253: {"AegisName":"Lif_Doll_Hat"},
5254: {"AegisName":"Deviling_Hat"},
5255: {"AegisName":"Triple_Poring_Hat"},
5256: {"AegisName":"Valkyrie_Feather_Band"},
5257: {"AegisName":"Soulless_Wing"},
5258: {"AegisName":"Afro_Wig"},
5259: {"AegisName":"Elephant_Hat_"},
5260: {"AegisName":"Cookie_Hat"},
5261: {"AegisName":"Silver_Tiara_"},
5262: {"AegisName":"Gold_Tiara_"},
5263: {"AegisName":"Ati_Atihan_Hat"},
5264: {"AegisName":"Aussie_Flag_Hat"},
5265: {"AegisName":"Apple_Of_Archer_C"},
5266: {"AegisName":"Bunny_Band_C"},
5267: {"AegisName":"Sahkkat_C"},
5268: {"AegisName":"Lord_Circlet_C"},
5269: {"AegisName":"Flying_Angel_"},
5270: {"AegisName":"Fallen_Leaves_"},
5271: {"AegisName":"Chinese_Crown_"},
5272: {"AegisName":"Tongue_Mask_"},
5273: {"AegisName":"Happy_Wig"},
5274: {"AegisName":"Shiny_Wig"},
5275: {"AegisName":"Marvelous_Wig"},
5276: {"AegisName":"Fantastic_Wig"},
5277: {"AegisName":"Yellow_Bandana"},
5278: {"AegisName":"Yellow_Ribbon"},
5279: {"AegisName":"Drooping_Kitty_C"},
5280: {"AegisName":"Magestic_Goat_C"},
5281: {"AegisName":"Deviruchi_Cap_C"},
5282: {"AegisName":"euRO_Baseball_Cap"},
5283: {"AegisName":"Chick_Hat"},
5284: {"AegisName":"Water_Lily_Crown"},
5285: {"AegisName":"Vane_Hairpin"},
5286: {"AegisName":"Pecopeco_Hairband"},
5287: {"AegisName":"Vacation_Hat"},
5288: {"AegisName":"Red_Glasses"},
5289: {"AegisName":"Vanilmirth_Hat"},
5290: {"AegisName":"Drooping_Bunny_"},
5291: {"AegisName":"Kettle_Hat"},
5292: {"AegisName":"Dragon_Skull"},
5293: {"AegisName":"Ramen_Hat"},
5294: {"AegisName":"Whisper_Mask"},
5295: {"AegisName":"Golden_Bandana"},
5296: {"AegisName":"Drooping_Nine_Tail_"},
5297: {"AegisName":"Soulless_Wing_"},
5298: {"AegisName":"Marvelous_Wig_"},
5299: {"AegisName":"Ati_Atihan_Hat_"},
5300: {"AegisName":"Bullock_Helm"},
5301: {"AegisName":"Russian_Ribbon"},
5302: {"AegisName":"Lotus_Flower_Hat"},
5303: {"AegisName":"Flower_Coronet"},
5304: {"AegisName":"Cap_Of_Blindness"},
5305: {"AegisName":"Pirate_Dagger"},
5306: {"AegisName":"Freyja_Crown"},
5307: {"AegisName":"Carmen_Miranda's_Hat"},
5308: {"AegisName":"Brazilian_Flag_Hat"},
5309: {"AegisName":"Mahican"},
5310: {"AegisName":"Bulb_Hairband"},
5311: {"AegisName":"Large_Hibiscus"},
5312: {"AegisName":"Ayothaya_Hat"},
5313: {"AegisName":"Diadem"},
5314: {"AegisName":"Hockey_Mask"},
5315: {"AegisName":"Observer"},
5316: {"AegisName":"Umbrella_Hat"},
5317: {"AegisName":"Fisherman_Hat"},
5318: {"AegisName":"Poring_Party_Hat"},
5319: {"AegisName":"Hellomother_Hat"},
5320: {"AegisName":"Champion_Wreath"},
5321: {"AegisName":"Indonesian_Bandana"},
5322: {"AegisName":"Scarf"},
5323: {"AegisName":"Misstrance_Crown"},
5324: {"AegisName":"Little_Angel_Doll"},
5325: {"AegisName":"Robo_Eye"},
5326: {"AegisName":"Masquerade_C"},
5327: {"AegisName":"Orc_Hero_Helm_C"},
5328: {"AegisName":"Evil_Wing_Ears_C"},
5329: {"AegisName":"Dark_Blindfold_C"},
5330: {"AegisName":"kRO_Drooping_Kitty_C"},
5331: {"AegisName":"Corsair_C"},
5332: {"AegisName":"Loki_Mask"},
5333: {"AegisName":"Radio_Antenna"},
5334: {"AegisName":"Angeling_Wanna_Fly"},
5335: {"AegisName":"Jumping_Poring"},
5336: {"AegisName":"Guildsman_Recruiter"},
5337: {"AegisName":"Party_Recruiter_Hat"},
5338: {"AegisName":"Bf_Recruiter_Hat"},
5339: {"AegisName":"Friend_Recruiter_Hat"},
5340: {"AegisName":"Deprotai_Doll_Hat"},
5341: {"AegisName":"Claris_Doll_Hat"},
5342: {"AegisName":"Sorin_Doll_Hat"},
5343: {"AegisName":"Tayelin_Doll_Hat"},
5344: {"AegisName":"Binit_Doll_Hat"},
5345: {"AegisName":"Debril_Doll_Hat"},
5346: {"AegisName":"Gf_Recruiter_Hat"},
5347: {"AegisName":"Ph.D_Hat_"},
5348: {"AegisName":"Big_Sis'_Ribbon_"},
5349: {"AegisName":"Boy's_Cap_"},
5350: {"AegisName":"Pirate_Bandana_"},
5351: {"AegisName":"Sunflower_"},
5352: {"AegisName":"Poporing_Cap"},
5353: {"AegisName":"Helm_Of_Sun_"},
5354: {"AegisName":"Muslim_Hat_M"},
5355: {"AegisName":"Muslim_Hat_F"},
5356: {"AegisName":"Pumpkin_Hat_H"},
5357: {"AegisName":"Wings_Of_Victory"},
5358: {"AegisName":"Pecopeco_Wing_Ears"},
5359: {"AegisName":"J_Captain_Hat"},
5360: {"AegisName":"Whikebain_Ears"},
5361: {"AegisName":"Gang_Scarf"},
5362: {"AegisName":"Ninja_Scroll"},
5363: {"AegisName":"Helm_Of_Abyss"},
5364: {"AegisName":"Dark_Snake_Lord_Hat"},
5365: {"AegisName":"Fried_Egg"},
5366: {"AegisName":"Hat_0f_King"},
5367: {"AegisName":"Hyegun_Hat"},
5368: {"AegisName":"White_Wing"},
5369: {"AegisName":"Dark_Wing"},
5370: {"AegisName":"Orchid_Hairband"},
5371: {"AegisName":"Hat_Of_Judge"},
5372: {"AegisName":"Drooping_White_Kitty"},
5373: {"AegisName":"Darkness_Helm"},
5374: {"AegisName":"L_Magestic_Goat"},
5375: {"AegisName":"L_Orc_Hero_Helm"},
5376: {"AegisName":"Satanic_Chain_P"},
5377: {"AegisName":"Antique_Pipe"},
5378: {"AegisName":"Rabbit_Ear_Hat"},
5379: {"AegisName":"Balloon_Hat"},
5380: {"AegisName":"Fish_Head_Hat"},
5381: {"AegisName":"Santa_Poring_Hat"},
5382: {"AegisName":"Bell_Ribbon"},
5383: {"AegisName":"Hunting_Cap"},
5384: {"AegisName":"Santa_Hat_1"},
5385: {"AegisName":"Yoyo_Hat"},
5386: {"AegisName":"Ayam_"},
5387: {"AegisName":"Neko_Mimi_Kafra"},
5388: {"AegisName":"Snake_Head"},
5389: {"AegisName":"Angel_Spirit"},
5390: {"AegisName":"Santa_Hat_2"},
5391: {"AegisName":"Toast_C"},
5392: {"AegisName":"Louyang_Cap"},
5393: {"AegisName":"Valentine_Hat"},
5394: {"AegisName":"Bubblegum_Lower"},
5395: {"AegisName":"Tiraya_Bonnet"},
5396: {"AegisName":"Jasper_Crest"},
5397: {"AegisName":"Scuba_Mask"},
5398: {"AegisName":"Bone_Head"},
5399: {"AegisName":"Mandragora_Cap"},
5400: {"AegisName":"Fox_Hat"},
5401: {"AegisName":"Black_Glasses"},
5402: {"AegisName":"Mischievous_Fairy"},
5403: {"AegisName":"Fish_In_Mouth"},
5404: {"AegisName":"Blue_Ribbon"},
5405: {"AegisName":"Filir_Hat"},
5406: {"AegisName":"Academy_Freshman_Hat"},
5407: {"AegisName":"Academy_Graduating_Cap"},
5408: {"AegisName":"Old_Bandanna"},
5409: {"AegisName":"New_Cowboy_Hat"},
5410: {"AegisName":"Bread_Bag2"},
5411: {"AegisName":"White_Snake_Hat"},
5412: {"AegisName":"Sweet_Candy"},
5413: {"AegisName":"Popcorn_Hat"},
5414: {"AegisName":"Campfire_Hat"},
5415: {"AegisName":"Poring_Cake_Cap"},
5416: {"AegisName":"Beer_Cap"},
5417: {"AegisName":"Crown_Parrot"},
5418: {"AegisName":"Soldier_Hat"},
5419: {"AegisName":"Evolved_Leaf"},
5420: {"AegisName":"Mask_Of_Ifrit"},
5421: {"AegisName":"Ifrit's_Ear"},
5422: {"AegisName":"Linguistic_Book_Cap"},
5423: {"AegisName":"Lovecap_China"},
5424: {"AegisName":"Fanta_Orange_Can"},
5425: {"AegisName":"Fanta_Grape_Can"},
5426: {"AegisName":"Karada_Meguri_Tea_Hat"},
5427: {"AegisName":"Royal_Milk_Tea_Hat"},
5428: {"AegisName":"Bread_Bag1"},
5429: {"AegisName":"Bogy_Cap"},
5430: {"AegisName":"Sacred_Torch_Coronet"},
5431: {"AegisName":"Chicken_Hat"},
5432: {"AegisName":"Brazil_Baseball_Cap"},
5433: {"AegisName":"Golden_Wreath"},
5434: {"AegisName":"Cola_Can"},
5435: {"AegisName":"Coke_Hat"},
5436: {"AegisName":"Bride's_Corolla"},
5437: {"AegisName":"Flower_Of_Fairy"},
5438: {"AegisName":"Fillet_Green"},
5439: {"AegisName":"Fillet_Red"},
5440: {"AegisName":"Fillet_Blue"},
5441: {"AegisName":"Fillet_White"},
5442: {"AegisName":"Necktie"},
5443: {"AegisName":"Status_Of_Baby_Angel"},
5444: {"AegisName":"Hair_Brush"},
5445: {"AegisName":"Candy_Cane_In_The_Mouth"},
5446: {"AegisName":"Cat_Foot_Hairpin"},
5447: {"AegisName":"Frog_Cap"},
5448: {"AegisName":"Solo_Play_Box1"},
5449: {"AegisName":"Solo_Play_Box2"},
5450: {"AegisName":"Sun_Cap"},
5451: {"AegisName":"Dragonhelm_Gold"},
5452: {"AegisName":"Dragonhelm_Silver"},
5453: {"AegisName":"Dragonhelm_Copper"},
5454: {"AegisName":"Dog_Cap_"},
5455: {"AegisName":"Geographer_Band_"},
5456: {"AegisName":"Vacation_Hat_"},
5457: {"AegisName":"Spring_Rabbit_Hat"},
5458: {"AegisName":"Pinwheel_Cap"},
5459: {"AegisName":"Drooping_Bunny_Chusuk"},
5460: {"AegisName":"Adv_Dragon_Skull"},
5461: {"AegisName":"Adv_Whisper_Mask"},
5462: {"AegisName":"Spiked_Scarf"},
5463: {"AegisName":"Rainbow_Scarf"},
5464: {"AegisName":"Zaha_Doll_Hat"},
5465: {"AegisName":"Celestial_Hat"},
5466: {"AegisName":"Wind_Milestone"},
5467: {"AegisName":"Helm_Of_Dragoon"},
5468: {"AegisName":"Parade_Cap"},
5469: {"AegisName":"Noble_Hat"},
5470: {"AegisName":"Eyes_Of_Darkness"},
5471: {"AegisName":"Hairband_Of_Reginleif"},
5472: {"AegisName":"Red_White_Hat"},
5473: {"AegisName":"Forceps_Hairpin"},
5474: {"AegisName":"Notice_Board"},
5475: {"AegisName":"Cube_Mask"},
5476: {"AegisName":"Hairband_Of_Grandpeco"},
5477: {"AegisName":"Bro_Flag"},
5478: {"AegisName":"Classic_Hat"},
5479: {"AegisName":"Shaman's_Hair_Ornament"},
5480: {"AegisName":"Bizofnil_Wing_Deco"},
5481: {"AegisName":"Hermose_Cap"},
5482: {"AegisName":"Dark_Knight_Mask"},
5483: {"AegisName":"Odin_Mask"},
5484: {"AegisName":"Taiwan_Flag_Hat"},
5485: {"AegisName":"Tiger_Face"},
5486: {"AegisName":"J_Anniversary_Hat"},
5487: {"AegisName":"J_Poringcake_Hat"},
5488: {"AegisName":"J_Twin_Santahat"},
5489: {"AegisName":"Love_Daddy"},
5490: {"AegisName":"Anubis_Helm"},
5491: {"AegisName":"Hat_Of_Outlaw"},
5492: {"AegisName":"Boy's_Cap_I"},
5493: {"AegisName":"Ulle_Cap_I"},
5494: {"AegisName":"Spinx_Helm_I"},
5495: {"AegisName":"Power_Of_Thor"},
5496: {"AegisName":"Dice_Hat"},
5497: {"AegisName":"King_Tiger_Doll_Hat"},
5498: {"AegisName":"Wondering_Wolf_Helm"},
5499: {"AegisName":"Pizza_Hat"},
5500: {"AegisName":"Icecream_Hat"},
5501: {"AegisName":"Pirate's_Pride"},
5502: {"AegisName":"Necromencer's_Hood"},
5503: {"AegisName":"Rabbit_Magic_Hat"},
5504: {"AegisName":"China_Wedding_Veil"},
5505: {"AegisName":"Asara_Fairy_Hat"},
5506: {"AegisName":"Blue_Pajamas_Hat"},
5507: {"AegisName":"Pink_Pajamas_Hat"},
5508: {"AegisName":"Shark_Hat"},
5509: {"AegisName":"Sting_Hat"},
5510: {"AegisName":"Shower_Cap"},
5511: {"AegisName":"Samambaia"},
5512: {"AegisName":"Aquarius_Diadem"},
5513: {"AegisName":"Aquarius_Crown"},
5514: {"AegisName":"Pisces_Diadem"},
5515: {"AegisName":"Pisces_Crown"},
5516: {"AegisName":"Hawk_Eyes01"},
5517: {"AegisName":"Hawk_Eyes02"},
5518: {"AegisName":"L_Magestic_Goat2"},
5519: {"AegisName":"Peacock_Feather"},
5520: {"AegisName":"Rabbit_Earplug"},
5521: {"AegisName":"Angry_Mouth_C"},
5522: {"AegisName":"Fanta_Zero_Lemon_Hat"},
5523: {"AegisName":"Sakura_Mist_Hat"},
5524: {"AegisName":"Sakura_Milk_Tea_Hat"},
5525: {"AegisName":"First_Leaf_Tea_Hat"},
5526: {"AegisName":"Lady_Tanee_Doll"},
5527: {"AegisName":"Lunatic_Hat"},
5528: {"AegisName":"King_Frog_Hat"},
5529: {"AegisName":"Evil's_Bone_Hat"},
5530: {"AegisName":"Raven_Cap"},
5531: {"AegisName":"B_Dragon_Hat"},
5532: {"AegisName":"Pirate_Dagger_J"},
5533: {"AegisName":"Emperor_Wreath_J"},
5534: {"AegisName":"Fox_Hat_J"},
5535: {"AegisName":"Side_Cap"},
5536: {"AegisName":"Spare_Card"},
5537: {"AegisName":"Quati_Hat"},
5538: {"AegisName":"Tucan_Hat"},
5539: {"AegisName":"Jaguar_Hat"},
5540: {"AegisName":"Freyja_SCirclet7"},
5541: {"AegisName":"Freyja_SCirclet30"},
5542: {"AegisName":"Freyja_SCirclet60"},
5543: {"AegisName":"Freyja_SCirclet90"},
5544: {"AegisName":"Time_Keeper_Hat"},
5545: {"AegisName":"Aries_Diadem"},
5546: {"AegisName":"Aries_Crown"},
5547: {"AegisName":"RJC_Katusa"},
5548: {"AegisName":"Scarlet_Rose"},
5549: {"AegisName":"Taurus_Diadem"},
5550: {"AegisName":"Taurus_Crown"},
5551: {"AegisName":"Holy_Egg_Hat"},
5552: {"AegisName":"Fest_Lord_Circlet"},
5553: {"AegisName":"Fest_Bunny_Band"},
5554: {"AegisName":"Octopus_Hat"},
5555: {"AegisName":"Leaf_Cat_Hat"},
5556: {"AegisName":"Fur_Seal_Hat"},
5557: {"AegisName":"Wild_Rose_Hat"},
5558: {"AegisName":"Saci_Hat"},
5559: {"AegisName":"Piece_Of_White_Cloth_E"},
5560: {"AegisName":"Bullock_Helm_J"},
5561: {"AegisName":"Rabbit_Magic_Hat_J"},
5562: {"AegisName":"Good_Wedding_Veil_J"},
5563: {"AegisName":"Dolor_Hat"},
5564: {"AegisName":"Crown_Of_Deceit"},
5565: {"AegisName":"Dragon_Arhat_Mask"},
5566: {"AegisName":"Tiger_Arhat_Mask"},
5567: {"AegisName":"Bright_Fury"},
5568: {"AegisName":"Rabbit_Bonnet"},
5569: {"AegisName":"Gemini_Diadem"},
5570: {"AegisName":"Gemini_Crown"},
5571: {"AegisName":"Rasta_Wig"},
5572: {"AegisName":"Savage_Baby_Hat"},
5573: {"AegisName":"Bogy_Horn"},
5574: {"AegisName":"Pencil_In_Mouth"},
5575: {"AegisName":"Onigiri_Hat"},
5576: {"AegisName":"Japan_Winecup"},
5577: {"AegisName":"Dark_Knight_MaskB"},
5578: {"AegisName":"Voyage_Hat"},
5579: {"AegisName":"Wanderer's_Sakkat"},
5580: {"AegisName":"Red_Beret"},
5581: {"AegisName":"Cancer_Diadem"},
5582: {"AegisName":"Cancer_Crown"},
5583: {"AegisName":"Para_Team_Hat"},
5584: {"AegisName":"Majestic_Evil_Horn"},
5585: {"AegisName":"Rune_Hairband"},
5586: {"AegisName":"Mosquito_Coil"},
5587: {"AegisName":"Mosquito_Coil_1Use"},
5588: {"AegisName":"Leo_Crown"},
5589: {"AegisName":"Leo_Diadem"},
5590: {"AegisName":"K_Poring_Cake_Cap"},
5591: {"AegisName":"Desert_Prince"},
5592: {"AegisName":"Sigrun's_Wing"},
5593: {"AegisName":"K_Rabbit_Bonnet"},
5594: {"AegisName":"Donut_In_Mouth"},
5595: {"AegisName":"Eye_Of_Juno"},
5596: {"AegisName":"4Leaf_Clover_In_Mouth"},
5597: {"AegisName":"Bubble_Gum_In_Mouth"},
5598: {"AegisName":"Virgo_Crown"},
5599: {"AegisName":"Virgo_Diadem"},
5600: {"AegisName":"Br_Twin_Ribbon"},
5601: {"AegisName":"Br_Beret"},
5602: {"AegisName":"Jaguar_Hat_J"},
5603: {"AegisName":"RTC_Winner_Only"},
5604: {"AegisName":"RTC_Second_Best"},
5605: {"AegisName":"RTC_Third_Best"},
5606: {"AegisName":"Campume_Hat"},
5607: {"AegisName":"Lyria_Doll_Hat"},
5608: {"AegisName":"Dorothy_Doll_Hat"},
5609: {"AegisName":"Chung_Hairband"},
5610: {"AegisName":"Ice_Wing_Ear"},
5611: {"AegisName":"Turtle_Hat"},
5612: {"AegisName":"F_Blue_Drooping_Kitty"},
5613: {"AegisName":"F_Flying_Angel"},
5614: {"AegisName":"F_Smoking_Pipe_"},
5615: {"AegisName":"F_Pair_Of_Red_Ribbon_"},
5616: {"AegisName":"F_Fish_On_Head_"},
5617: {"AegisName":"F_Hibiscus"},
5618: {"AegisName":"F_Cat_Hat"},
5619: {"AegisName":"F_Bunny_Band_"},
5620: {"AegisName":"F_Magestic_Goat_TW"},
5621: {"AegisName":"F_Sheep_Hat"},
5622: {"AegisName":"F_Mini_Propeller_"},
5623: {"AegisName":"F_Alice_Doll"},
5624: {"AegisName":"F_Red_Glasses"},
5625: {"AegisName":"F_Chick_Hat"},
5626: {"AegisName":"F_White_Deviruchi_Cap"},
5627: {"AegisName":"F_Vane_Hairpin"},
5628: {"AegisName":"F_Pecopeco_Hairband"},
5629: {"AegisName":"F_Vacation_Hat"},
5630: {"AegisName":"F_Charming_Ribbon"},
5631: {"AegisName":"F_Water_Lily_Crown"},
5632: {"AegisName":"F_Vanilmirth_Hat"},
5633: {"AegisName":"F_Drooping_Bunny_"},
5634: {"AegisName":"F_Kettle_Hat"},
5635: {"AegisName":"F_Dragon_Skull"},
5636: {"AegisName":"F_Ramen_Hat"},
5637: {"AegisName":"F_Pink_Fur_Hat"},
5638: {"AegisName":"F_Puppy_Hat"},
5639: {"AegisName":"F_Magic_Eyes"},
5640: {"AegisName":"F_Jumping_Poring"},
5641: {"AegisName":"F_Robo_Eye"},
5642: {"AegisName":"F_Yellow_Wizardry_Hat"},
5643: {"AegisName":"F_Crescent_Helm"},
5644: {"AegisName":"F_Tiger_Mask"},
5645: {"AegisName":"F_Fantastic_Wig"},
5646: {"AegisName":"F_Whisper_Mask"},
5647: {"AegisName":"F_Bunny_Band_C"},
5648: {"AegisName":"F_Centimental_Flower_C"},
5649: {"AegisName":"F_Apple_Of_Archer_C"},
5650: {"AegisName":"F_Elven_Ears_C"},
5651: {"AegisName":"F_Brooch_C"},
5652: {"AegisName":"F_Magestic_Goat_C"},
5653: {"AegisName":"Darkness_Helm_J"},
5654: {"AegisName":"Holy_Marching_Hat_J"},
5655: {"AegisName":"Dark_Snake_Lord_Hat_J"},
5656: {"AegisName":"Scooter_Hat_J"},
5657: {"AegisName":"Antique_Pipe_J"},
5658: {"AegisName":"Imp_Hat"},
5659: {"AegisName":"Sleepr_Hat"},
5660: {"AegisName":"Gryphon_Hat"},
5661: {"AegisName":"Red_Pirate_Bandana"},
5662: {"AegisName":"Libra_Crown"},
5663: {"AegisName":"Libra_Diadem"},
5664: {"AegisName":"Filir_Wing"},
5665: {"AegisName":"Shaman_Hat"},
5666: {"AegisName":"Golden_Crown"},
5667: {"AegisName":"Skull_Hood"},
5668: {"AegisName":"Weird_Pumpkin_Hat"},
5669: {"AegisName":"Poring_Party_Hat_J"},
5670: {"AegisName":"Aniv_Star_Hat"},
5671: {"AegisName":"Drooping_Morocc_Minion"},
5672: {"AegisName":"Southern_Cross"},
5673: {"AegisName":"Home_Cherry_Blossom"},
5674: {"AegisName":"Pig_Moneybox"},
5675: {"AegisName":"Poring_Letter"},
5676: {"AegisName":"Scorpio_Crown"},
5677: {"AegisName":"Scorpio_Diadem"},
5678: {"AegisName":"Notation_Hairband"},
5679: {"AegisName":"Engineer_Cap"},
5680: {"AegisName":"Hawkeyes"},
5681: {"AegisName":"F_Ribbon_Green"},
5682: {"AegisName":"Triangle_Rune_Cap"},
5683: {"AegisName":"Majestic_Goat_Repl"},
5684: {"AegisName":"Jewel_Crown_Repl"},
5685: {"AegisName":"Prontera_Army_Cap_Repl"},
5686: {"AegisName":"Feather_Bonnet_Repl"},
5687: {"AegisName":"Viking_Helm_Repl"},
5688: {"AegisName":"2009Love_Daddy"},
5689: {"AegisName":"Queen_Ant_Diadem"},
5690: {"AegisName":"Red_Wing_Hat"},
5691: {"AegisName":"Catain_Bandanna"},
5692: {"AegisName":"Sea_Cat_Hat"},
5693: {"AegisName":"No_Fear_Underware"},
5694: {"AegisName":"No_Fear_P_Headgear"},
5695: {"AegisName":"E_Blue_Drooping_Kitty"},
5696: {"AegisName":"E_Flying_Angel"},
5697: {"AegisName":"E_Smoking_Pipe_"},
5698: {"AegisName":"E_Pair_OE_Red_Ribbon_"},
5699: {"AegisName":"E_Fish_On_Head_"},
5700: {"AegisName":"E_Hibiscus"},
5701: {"AegisName":"E_Cat_Hat"},
5702: {"AegisName":"E_Bunny_Band_"},
5703: {"AegisName":"E_Magestic_Goat_TW"},
5704: {"AegisName":"E_Sheep_Hat"},
5705: {"AegisName":"E_Mini_Propeller_"},
5706: {"AegisName":"E_Alice_Doll"},
5707: {"AegisName":"E_Red_Glasses"},
5708: {"AegisName":"E_Chick_Hat"},
5709: {"AegisName":"E_White_Deviruchi_Cap"},
5710: {"AegisName":"E_Vane_Hairpin"},
5711: {"AegisName":"E_Pecopeco_Hairband"},
5712: {"AegisName":"E_Vacation_Hat"},
5713: {"AegisName":"E_Charming_Ribbon"},
5714: {"AegisName":"E_Water_Lily_Crown"},
5715: {"AegisName":"E_Vanilmirth_Hat"},
5716: {"AegisName":"E_Drooping_Bunny_"},
5717: {"AegisName":"E_Kettle_Hat"},
5718: {"AegisName":"E_Dragon_Skull"},
5719: {"AegisName":"E_Ramen_Hat"},
5720: {"AegisName":"E_Pink_Fur_Hat"},
5721: {"AegisName":"E_Puppy_Hat"},
5722: {"AegisName":"E_Magic_Eyes"},
5723: {"AegisName":"E_Jumping_Poring"},
5724: {"AegisName":"E_Robo_Eye"},
5725: {"AegisName":"E_Yellow_Wizardry_Hat"},
5726: {"AegisName":"E_Crescent_Helm"},
5727: {"AegisName":"E_Tiger_Mask"},
5728: {"AegisName":"E_Fantastic_Wig"},
5729: {"AegisName":"E_Bunny_Band_C"},
5730: {"AegisName":"E_Centimental_Flower_C"},
5731: {"AegisName":"E_Apple_OE_Archer_C"},
5732: {"AegisName":"E_Elven_Ears_C"},
5733: {"AegisName":"E_Brooch_C"},
5734: {"AegisName":"E_Magestic_Goat_C"},
5735: {"AegisName":"E_Ribbon_Green"},
5736: {"AegisName":"EF_Whisper_Mask"},
5737: {"AegisName":"Cactus_Hat"},
5738: {"AegisName":"Snowman_Hat"},
5739: {"AegisName":"Sagittarius_Crown"},
5740: {"AegisName":"Sagittarius_Diadem"},
5741: {"AegisName":"Im_Egg_Shell_Hat"},
5742: {"AegisName":"Rudolf_Santa_Hat"},
5743: {"AegisName":"Orange_Stem_Hat"},
5744: {"AegisName":"Capricon_Crown"},
5745: {"AegisName":"Capricon_Diadem"},
5746: {"AegisName":"Rune_Circlet"},
5747: {"AegisName":"Mitra"},
5748: {"AegisName":"Sniper_Goggle"},
5749: {"AegisName":"Driver_Band"},
5750: {"AegisName":"Shadow_Handicraft"},
5751: {"AegisName":"Minstrel_Song_Hat"},
5752: {"AegisName":"Midas_Whisper"},
5753: {"AegisName":"Magic_Stone_Hat"},
5754: {"AegisName":"Blazing_Soul"},
5755: {"AegisName":"Silent_Executer"},
5756: {"AegisName":"Wind_Whisper"},
5757: {"AegisName":"Schmidt_Helm"},
5758: {"AegisName":"Dying_Swan"},
5759: {"AegisName":"Noah_Hat"},
5760: {"AegisName":"Driver_Band_"},
5761: {"AegisName":"Sloth_Hat"},
5762: {"AegisName":"Duneyrr_Helm"},
5763: {"AegisName":"Red_Bunny_Band"},
5764: {"AegisName":"Love_Rabbit_Hood"},
5765: {"AegisName":"Black_Tail_Ribbon"},
5766: {"AegisName":"Amistr_Cap"},
5767: {"AegisName":"Samurai_Mask"},
5768: {"AegisName":"Sakura_Coronet"},
5769: {"AegisName":"Gold_Angel_Sculpture"},
5770: {"AegisName":"Splash_Hat"},
5771: {"AegisName":"Family_Hat"},
5772: {"AegisName":"Red_Navy_Hat"},
5773: {"AegisName":"Navy_Beret"},
5774: {"AegisName":"Red_Pirate_Hat"},
5775: {"AegisName":"Choco_Donut_In_Mouth"},
5776: {"AegisName":"Blazing_Sun"},
5777: {"AegisName":"Remover_Hat"},
5778: {"AegisName":"Blue_Arara_Hat"},
5779: {"AegisName":"Drooping_Boto"},
5780: {"AegisName":"Tendrilion_Hat"},
5781: {"AegisName":"Persika"},
5782: {"AegisName":"Hoplite_Helmet"},
5783: {"AegisName":"YellowBunny_Hairband"},
5784: {"AegisName":"PinkBunny_Hairband"},
5785: {"AegisName":"Green_Bunny_Hairband"},
5786: {"AegisName":"Ancient_Elven_Ear"},
5787: {"AegisName":"Tha_Maero_Mask"},
5788: {"AegisName":"3D_Glasses"},
5789: {"AegisName":"Thanatos_Mal_Mask"},
5790: {"AegisName":"Holy_Mom_Love"},
5791: {"AegisName":"Tenkaippin_Ramen"},
5792: {"AegisName":"Fish_Pin"},
5793: {"AegisName":"Ribbon_Of_Life"},
5794: {"AegisName":"3D_Glasses_"},
5795: {"AegisName":"Red_Dress_Hat"},
5796: {"AegisName":"Cheer_Scarf"},
5797: {"AegisName":"Cheer_Scarf2"},
5798: {"AegisName":"Cheer_Scarf3"},
5799: {"AegisName":"Cheer_Scarf4"},
5800: {"AegisName":"Blush_Of_Groom"},
5801: {"AegisName":"Ribbon_Of_Bride"},
5802: {"AegisName":"Upgrade_Elephant_Hat"},
5803: {"AegisName":"Flower_Love_Hat"},
5804: {"AegisName":"Pirate_Eyepatch"},
5805: {"AegisName":"Victorious_Coronet"},
5806: {"AegisName":"Poem_Natalia_Hat"},
5807: {"AegisName":"October_Fest_Cap"},
5808: {"AegisName":"Diabolus_Helmet"},
5809: {"AegisName":"Boom_Boom_Hat"},
5810: {"AegisName":"Ph.D_Hat_V"},
5811: {"AegisName":"Santa_Beard"},
5812: {"AegisName":"Hat_Of_Expert"},
5813: {"AegisName":"Red_Ph.D_Hat"},
5814: {"AegisName":"Ati_Atihan_Hat3"},
5815: {"AegisName":"Classic_Hat_J"},
5816: {"AegisName":"Cowboy_Hat_J"},
5817: {"AegisName":"Valentine_Pledge"},
5818: {"AegisName":"Carnival_Hat"},
5819: {"AegisName":"Carnival_Circlet"},
5820: {"AegisName":"Black_Elven_Ears"},
5821: {"AegisName":"Gold_Tulip_Hairpin"},
5822: {"AegisName":"Love_Chick_Hat"},
5823: {"AegisName":"Love_Arrow"},
5824: {"AegisName":"Fools_Day_Hat"},
5825: {"AegisName":"Badge_Of_Order_Grace"},
5826: {"AegisName":"Valkyrie_Helmet"},
5827: {"AegisName":"Book_File_Hat"},
5828: {"AegisName":"Honor_Gold_Ring"},
5829: {"AegisName":"Ordinary_Armor"},
5830: {"AegisName":"Woe_Sahkkat"},
5831: {"AegisName":"Woe_Big_Sis_Ribbon"},
5832: {"AegisName":"Woe_Vane_Hairpin"},
5833: {"AegisName":"Woe_Picnic_Hat"},
5834: {"AegisName":"Woe_Crown"},
5835: {"AegisName":"Woe_Tiara"},
5836: {"AegisName":"Woe_Boys_Cap"},
5837: {"AegisName":"Woe_Sunglass"},
5838: {"AegisName":"Woe_Fin_Helm"},
5839: {"AegisName":"Woe_Blush"},
5840: {"AegisName":"Woe_Elven_Ears"},
5841: {"AegisName":"Shaman_Hat_"},
5842: {"AegisName":"Loyal_Ring1"},
5843: {"AegisName":"Loyal_Ring2"},
5844: {"AegisName":"Loyal_Ring3"},
5845: {"AegisName":"Buzzy_Ball_Board"},
5846: {"AegisName":"Buzzy_Ball_Gum"},
5847: {"AegisName":"Fools_Day_Helmet"},
5848: {"AegisName":"Robin_Eyepatch"},
5849: {"AegisName":"Doctor_Hairband"},
5850: {"AegisName":"Golden_Savage_Hat"},
5851: {"AegisName":"Summer_Knight"},
5852: {"AegisName":"Easter_Egg_Shell"},
5853: {"AegisName":"1Aniversary_Crown"},
5855: {"AegisName":"Fish_Rod"},
5856: {"AegisName":"Passion_FB_Hat"},
5857: {"AegisName":"Cool_FB_Hat"},
5858: {"AegisName":"Victory_FB_Hat"},
5859: {"AegisName":"Glory_FB_Hat"},
5864: {"AegisName":"Shadow_Booster"},
5865: {"AegisName":"Filir_Wing_Ears"},
5866: {"AegisName":"Red_Cherry_Blossom"},
5867: {"AegisName":"Hat_Of_Drowsy_Cat"},
5868: {"AegisName":"Bushy_Moustache"},
5869: {"AegisName":"Mimic_Egg_Shell"},
5870: {"AegisName":"Bunny_Egg_Shell"},
5871: {"AegisName":"Picky_Egg_Shell"},
5873: {"AegisName":"Helmet_Of_Siegfried"},
5874: {"AegisName":"Circlet_Of_Kriemhild"},
5875: {"AegisName":"Diadem_Of_Bruenhild"},
5878: {"AegisName":"Miracle_Blue_Rose"},
5879: {"AegisName":"Poring_Sunglasses_J"},
5880: {"AegisName":"Cheering_Whistle_J"},
5881: {"AegisName":"Weissbier_Hat"},
5882: {"AegisName":"White_Wizardry_Hat_C"},
5883: {"AegisName":"Gray_Wizardry_Hat_C"},
5884: {"AegisName":"Blue_Wizardry_Hat_C"},
5885: {"AegisName":"Red_Wizardry_Hat_C"},
5886: {"AegisName":"Yellow_Wizardry_Hat_C"},
5887: {"AegisName":"Half_L_Magestic_Goat"},
5888: {"AegisName":"Wedding_Veil_"},
5889: {"AegisName":"L_Orc_Hero_Helm_"},
5890: {"AegisName":"Angel_Earing"},
5891: {"AegisName":"Black_Cat_Hat"},
5892: {"AegisName":"RCC2013_1ST_CROWN"},
5893: {"AegisName":"RCC2013_2ND_CROWN"},
5894: {"AegisName":"RCC2013_3RD_CROWN"},
5895: {"AegisName":"RCC2013_ANV_Hat"},
5896: {"AegisName":"EGGTART_HAT"},
5897: {"AegisName":"Ascendant_Crown_"},
5898: {"AegisName":"Autumn_Headband"},
5899: {"AegisName":"Black_Ribbon_"},
5900: {"AegisName":"Divine_Guard_Hat_"},
5901: {"AegisName":"Focus_Beret_"},
5902: {"AegisName":"Harvester_Hat_"},
5903: {"AegisName":"Hitaikakushi_"},
5904: {"AegisName":"Inconspicuous_Hat_"},
5905: {"AegisName":"Lyrica_Hat_"},
5906: {"AegisName":"Oni_Horns_"},
5907: {"AegisName":"Sea_Captain_Hat_"},
5908: {"AegisName":"Accessory_of_Ascetic"},
5909: {"AegisName":"C_Valkyrie_Circlet"},
5911: {"AegisName":"C_Imperial_Feather"},
5912: {"AegisName":"C_Minions_Of_Devil"},
5913: {"AegisName":"C_Anemos_Mask"},
5914: {"AegisName":"C_Flutter_Butterfly"},
5915: {"AegisName":"C_Angel_Veil"},
5916: {"AegisName":"Exosrcist_Glass"},
5917: {"AegisName":"Yellow_Scarf"},
5918: {"AegisName":"Gambler_Seal"},
5919: {"AegisName":"Camellia_Hair_Pin"},
5920: {"AegisName":"Medical_Boots"},
5921: {"AegisName":"Monster_Fish_Gill"},
5924: {"AegisName":"DragonKnight_Eyepatch"},
5930: {"AegisName":"Magical_Feather"},
5931: {"AegisName":"Niflheim_Bunny_Hat"},
5932: {"AegisName":"Heaven_Cage"},
5933: {"AegisName":"Crow_Tengu_Mask"},
5934: {"AegisName":"Happy_Balloon_J"},
5936: {"AegisName":"8_Type_PurgatorialWing"},
5937: {"AegisName":"Flying_Helmet"},
5938: {"AegisName":"Octopus_Hat_J"},
5940: {"AegisName":"Boitata_Hat_J"},
5943: {"AegisName":"Owlviscount_Silk_Hat"},
5944: {"AegisName":"Thief_Hood"},
5945: {"AegisName":"Red_Pencil_Mouth"},
5946: {"AegisName":"Drama_Clockwork"},
5953: {"AegisName":"Love_Guard_L"},
5963: {"AegisName":"Wing_Headphone"},
5965: {"AegisName":"Riot_Chip_J"},
5966: {"AegisName":"KarduiEar"},
5967: {"AegisName":"FlyingGalapago"},
5968: {"AegisName":"DVAngelNurseCap"},
5969: {"AegisName":"QueenAnzRevenge"},
5970: {"AegisName":"RuneHelm"},
5971: {"AegisName":"Moon_Eyepatch"},
5972: {"AegisName":"Chatty_Parrot"},
5973: {"AegisName":"Ancient_Elven_Ear_J"},
5975: {"AegisName":"Zherlthsh_Doll"},
5977: {"AegisName":"C_Poker_Card_In_Mouth"},
5978: {"AegisName":"Toy_Syringe"},
5979: {"AegisName":"C_Angel_Fluttering"},
5980: {"AegisName":"C_Classical_Fhat"},
5981: {"AegisName":"C_Satanic_Chain_P"},
5985: {"AegisName":"Noble_Mask"},
5986: {"AegisName":"Whikebain_Ears_"},
6000: {"AegisName":"Dark_Ashes"},
6001: {"AegisName":"Essence_Of_Fire"},
6002: {"AegisName":"Token_Of_Apostle"},
6003: {"AegisName":"Soul_Pendant"},
6004: {"AegisName":"Bapho_Doll"},
6005: {"AegisName":"New_Year_Rice_Cake"},
6006: {"AegisName":"Rice_Cake_Delivery_Box"},
6007: {"AegisName":"New_Year_Rice_Cake_Soup"},
6008: {"AegisName":"Wood"},
6009: {"AegisName":"Large_Magical_Fan"},
6010: {"AegisName":"Pickaxe"},
6011: {"AegisName":"Blue_Card_B"},
6012: {"AegisName":"Blue_Card_C"},
6013: {"AegisName":"Blue_Card_J"},
6015: {"AegisName":"Blue_Card_M"},
6016: {"AegisName":"Blue_Card_Q"},
6017: {"AegisName":"Blue_Card_T"},
6018: {"AegisName":"Blue_Card_V"},
6019: {"AegisName":"Blue_Card_Z"},
6020: {"AegisName":"Fur"},
6021: {"AegisName":"Peaked_Hat"},
6022: {"AegisName":"Hard_Skin"},
6023: {"AegisName":"Mystic_Horn"},
6024: {"AegisName":"17Carat_Dia"},
6025: {"AegisName":"Towel_Of_Memory"},
6026: {"AegisName":"Marriage_Covenant"},
6027: {"AegisName":"Crystal_Of_Feardoom"},
6028: {"AegisName":"Seal_Scroll"},
6029: {"AegisName":"Morocc_Tracing_Log"},
6030: {"AegisName":"Glitering_PaperA"},
6031: {"AegisName":"Glitering_PaperB"},
6032: {"AegisName":"Horn_Of_Hilsrion"},
6033: {"AegisName":"Horn_Of_Tendrilion"},
6034: {"AegisName":"Weird_Part"},
6035: {"AegisName":"Decaying_Stem"},
6036: {"AegisName":"Invite_To_Meeting"},
6037: {"AegisName":"Rough_File"},
6038: {"AegisName":"Neat_Report"},
6039: {"AegisName":"Piece_Of_Fish"},
6040: {"AegisName":"Some_Of_Report"},
6041: {"AegisName":"Strong_Bine"},
6042: {"AegisName":"Ordinary_Branch"},
6043: {"AegisName":"Letter_From_Lugen"},
6044: {"AegisName":"Letter_From_Otto"},
6045: {"AegisName":"Supply_Box"},
6046: {"AegisName":"Clothing_Dye_Coupon"},
6047: {"AegisName":"Clothing_Dye_Coupon2"},
6048: {"AegisName":"Unidentified_Mineral"},
6049: {"AegisName":"Marlin"},
6050: {"AegisName":"Mercenary_Contract"},
6051: {"AegisName":"Gray_Hollow"},
6052: {"AegisName":"Ornamental_Hairpin"},
6053: {"AegisName":"Yuanbao"},
6054: {"AegisName":"Blue_Card_6"},
6055: {"AegisName":"Blue_Card_Annyver"},
6056: {"AegisName":"Blue_Card_Sary"},
6057: {"AegisName":"Blue_Card_E"},
6058: {"AegisName":"Blue_Card_Ven"},
6059: {"AegisName":"Blue_Card_Nt"},
6060: {"AegisName":"Moon_Admin_Ticket"},
6061: {"AegisName":"Plantain"},
6062: {"AegisName":"Moon_Cake15"},
6063: {"AegisName":"Moon_Cake16"},
6064: {"AegisName":"Moon_Cake17"},
6065: {"AegisName":"Moon_Cake18"},
6066: {"AegisName":"Moon_Cake19"},
6067: {"AegisName":"Moon_Cake20"},
6068: {"AegisName":"Rabbit_Skin"},
6069: {"AegisName":"ABUNDANCE"},
6070: {"AegisName":"Shaman's_Old_Paper"},
6071: {"AegisName":"Broken_Sword"},
6072: {"AegisName":"Wing_Of_Bizofnil"},
6073: {"AegisName":"Dragon's_Mane"},
6074: {"AegisName":"Bazett's_Order"},
6075: {"AegisName":"Crystalized_Teardrop"},
6076: {"AegisName":"Portable_Toolbox"},
6077: {"AegisName":"Rough_Mineral"},
6078: {"AegisName":"Stone_Fragments"},
6079: {"AegisName":"Flower_Of_Alfheim"},
6080: {"AegisName":"Manuk_Coin"},
6081: {"AegisName":"Splendide_Coin"},
6082: {"AegisName":"Spirit_Of_Alfheim"},
6083: {"AegisName":"Dolly_Capsule"},
6084: {"AegisName":"Bradium_Fragments"},
6085: {"AegisName":"Shaggy_Muffler"},
6086: {"AegisName":"Withered_Flower"},
6087: {"AegisName":"Crystal_Of_Soul_01"},
6088: {"AegisName":"Crystal_Of_Soul_02"},
6089: {"AegisName":"Piece_Of_Darkness"},
6090: {"AegisName":"Purified_Bradium"},
6091: {"AegisName":"Dark_Red_Scale"},
6092: {"AegisName":"Singing_Crystal_Piece"},
6093: {"AegisName":"Egg_Of_Draco"},
6094: {"AegisName":"Traditional_Cookie"},
6095: {"AegisName":"Flavored_Alcohol"},
6096: {"AegisName":"Fish_With_Blue_Back"},
6097: {"AegisName":"Pumpkin_Pie_"},
6098: {"AegisName":"Small_Snow_Flower"},
6099: {"AegisName":"Grilled_Rice_Cake"},
6100: {"AegisName":"Damp_Darkness"},
6101: {"AegisName":"Attendance_Card"},
6102: {"AegisName":"Report_On_Splendide"},
6103: {"AegisName":"Report_On_Manuk"},
6104: {"AegisName":"Big_Cell"},
6105: {"AegisName":"Morning_Dew"},
6106: {"AegisName":"Well_Ripened_Berry"},
6107: {"AegisName":"Sunset_On_The_Rock"},
6108: {"AegisName":"Apple_Pudding"},
6109: {"AegisName":"Plant_Neutrient"},
6110: {"AegisName":"Vital_Flower"},
6111: {"AegisName":"Mystic_Stone"},
6112: {"AegisName":"Fresh_Plant"},
6113: {"AegisName":"Vital_Flower_"},
6114: {"AegisName":"Flame_Gemstone"},
6115: {"AegisName":"Bun_"},
6116: {"AegisName":"Succu_Pet_Coupon"},
6117: {"AegisName":"Imp_Pet_Coupon"},
6118: {"AegisName":"Chung_E_Pet_Coupon"},
6119: {"AegisName":"Natural_Leather"},
6120: {"AegisName":"Face_Paint"},
6121: {"AegisName":"Makeover_Brush"},
6122: {"AegisName":"Paint_Brush"},
6123: {"AegisName":"Surface_Paint"},
6124: {"AegisName":"Wolf's_Flute"},
6125: {"AegisName":"Lucky_Box"},
6126: {"AegisName":"Happy_Box"},
6127: {"AegisName":"Purification_Stone"},
6128: {"AegisName":"Guillotine_Antidote"},
6129: {"AegisName":"Ticket_Nightmare"},
6130: {"AegisName":"Ticket_Loli_Ruri"},
6131: {"AegisName":"Ticket_Goblin_Leader"},
6132: {"AegisName":"Ticket_Incubus"},
6133: {"AegisName":"Ticket_Miyabi_Ningyo"},
6134: {"AegisName":"Ticket_Whisper"},
6135: {"AegisName":"Ticket_Wicked_Nymph"},
6136: {"AegisName":"Ticket_Medusa"},
6137: {"AegisName":"Ticket_Stoneshooter"},
6138: {"AegisName":"Ticket_Marionette"},
6139: {"AegisName":"Ticket_Leafcat"},
6140: {"AegisName":"Ticket_Dullahan"},
6141: {"AegisName":"Ticket_Shinobi"},
6142: {"AegisName":"Ticket_Golem"},
6143: {"AegisName":"Ticket_Civil_Servant"},
6144: {"AegisName":"Heartbroken_Tears"},
6145: {"AegisName":"Vulcan_Bullet"},
6146: {"AegisName":"Magic_Gear_Fuel"},
6147: {"AegisName":"Liquid_Condensed_Bullet"},
6148: {"AegisName":"Chocolate_Of_Eternity"},
6149: {"AegisName":"Plain_Chocolate"},
6150: {"AegisName":"Key_Of_The_Mansion"},
6151: {"AegisName":"Peice_Of_Great_Bradium"},
6152: {"AegisName":"Glittering_Crystal"},
6153: {"AegisName":"Special_Exchange_Coupon"},
6154: {"AegisName":"Broken_Horn_Pipe"},
6155: {"AegisName":"Coke_Membership_Card"},
6156: {"AegisName":"Approval_Report"},
6157: {"AegisName":"Poring_Ticket"},
6158: {"AegisName":"Drops_Ticket"},
6159: {"AegisName":"Poporing_Ticket"},
6160: {"AegisName":"Lunatic_Ticket"},
6161: {"AegisName":"Picky_Ticket"},
6162: {"AegisName":"Pecopeco_Ticket"},
6163: {"AegisName":"Savage_Baby_Ticket"},
6164: {"AegisName":"Spore_Ticket"},
6165: {"AegisName":"Poison_Spore_Ticket"},
6166: {"AegisName":"Chonchon_Ticket"},
6167: {"AegisName":"Steel_Chonchon_Ticket"},
6168: {"AegisName":"Petit_Ticket"},
6169: {"AegisName":"Deviruchi_Ticket"},
6170: {"AegisName":"Isis_Ticket"},
6171: {"AegisName":"Smokie_Ticket"},
6172: {"AegisName":"Dokebi_Ticket"},
6173: {"AegisName":"Desert_Wolf_B_Ticket"},
6174: {"AegisName":"Yoyo_Ticket"},
6175: {"AegisName":"Sohee_Ticket"},
6176: {"AegisName":"Rocker_Ticket"},
6177: {"AegisName":"Hunter_Fly_Ticket"},
6178: {"AegisName":"Orc_Warrior_Ticket"},
6179: {"AegisName":"Bapho_Jr_Ticket"},
6180: {"AegisName":"Munak_Ticket"},
6181: {"AegisName":"Bongun_Ticket"},
6182: {"AegisName":"Goblin_Ticket"},
6183: {"AegisName":"Hardtack_Ticket"},
6184: {"AegisName":"Zherlthsh_Ticket"},
6185: {"AegisName":"Alice_Ticket"},
6186: {"AegisName":"Monkey_Wrench"},
6187: {"AegisName":"Blank_Card"},
6188: {"AegisName":"Slot_Coupon"},
6189: {"AegisName":"Magic_Book_FB"},
6190: {"AegisName":"Magic_Book_CB"},
6191: {"AegisName":"Magic_Book_LB"},
6192: {"AegisName":"Magic_Book_SG"},
6193: {"AegisName":"Magic_Book_LOV"},
6194: {"AegisName":"Magic_Book_MS"},
6195: {"AegisName":"Magic_Book_CM"},
6196: {"AegisName":"Magic_Book_TV"},
6197: {"AegisName":"Magic_Book_TS"},
6198: {"AegisName":"Magic_Book_JT"},
6199: {"AegisName":"Magic_Book_WB"},
6200: {"AegisName":"Magic_Book_HD"},
6201: {"AegisName":"Magic_Book_ES"},
6202: {"AegisName":"Magic_Book_ES_"},
6203: {"AegisName":"Magic_Book_CL"},
6204: {"AegisName":"Magic_Book_CR"},
6205: {"AegisName":"Magic_Book_DL"},
6206: {"AegisName":"I_Love_You"},
6207: {"AegisName":"Thank_You"},
6208: {"AegisName":"I_Respect_You"},
6209: {"AegisName":"Glory_Of_Knights"},
6210: {"AegisName":"Seed_Of_Horny_Plant"},
6211: {"AegisName":"Bloodsuck_Plant_Seed"},
6212: {"AegisName":"Bomb_Mushroom_Spore"},
6213: {"AegisName":"Explosive_Powder"},
6214: {"AegisName":"Smoke_Powder"},
6215: {"AegisName":"Tear_Gas"},
6216: {"AegisName":"Oil_Bottle"},
6217: {"AegisName":"Mandragora_Flowerpot"},
6218: {"AegisName":"Disin_Delivery_Box"},
6219: {"AegisName":"Para_Team_Mark"},
6220: {"AegisName":"Mysterious_Dyestuff"},
6221: {"AegisName":"Mystic_Leaf_Cat_Ball"},
6222: {"AegisName":"Shining_Beads"},
6223: {"AegisName":"Carnium"},
6224: {"AegisName":"Bradium"},
6225: {"AegisName":"HD_Carnium"},
6226: {"AegisName":"HD_Bradium"},
6228: {"AegisName":"Guarantee_Weapon_9Up"},
6229: {"AegisName":"Guarantee_Weapon_8Up"},
6230: {"AegisName":"Guarantee_Weapon_7Up"},
6231: {"AegisName":"Guarantee_Weapon_6Up"},
6232: {"AegisName":"Guarantee_Armor_9Up"},
6233: {"AegisName":"Guarantee_Armor_8Up"},
6234: {"AegisName":"Guarantee_Armor_7Up"},
6235: {"AegisName":"Guarantee_Armor_6Up"},
6236: {"AegisName":"Blue_Card_7"},
6237: {"AegisName":"Guarana_Fruit"},
6238: {"AegisName":"Guarantee_Weapon_11Up"},
6239: {"AegisName":"Guarantee_Armor_11Up"},
6240: {"AegisName":"HD_Oridecon"},
6241: {"AegisName":"HD_Elunium"},
6242: {"AegisName":"Midgard_Coin"},
6243: {"AegisName":"Exchange_Coupon"},
6244: {"AegisName":"Gun_Powder"},
6245: {"AegisName":"Black_Powder"},
6246: {"AegisName":"Yellow_Powder"},
6247: {"AegisName":"White_Powder"},
6248: {"AegisName":"Melange_Pot"},
6249: {"AegisName":"Savage_Meat"},
6250: {"AegisName":"Cooking_Skewer"},
6251: {"AegisName":"Black_Charcoal"},
6252: {"AegisName":"Wolf_Blood"},
6253: {"AegisName":"Cold_Ice"},
6254: {"AegisName":"Beef_Head_Meat"},
6255: {"AegisName":"Large_Cookpot"},
6256: {"AegisName":"Ice_Fragment"},
6257: {"AegisName":"Ice_Crystal"},
6258: {"AegisName":"Comodo_Tropic_Fruit"},
6259: {"AegisName":"Drocera_Tentacle"},
6260: {"AegisName":"Petti_Tail"},
6261: {"AegisName":"Fine_Noodle"},
6262: {"AegisName":"Cool_Gravy"},
6263: {"AegisName":"Coconut_Fruit"},
6264: {"AegisName":"Melon"},
6265: {"AegisName":"Pineapple"},
6266: {"AegisName":"Cheat_Key"},
6267: {"AegisName":"Virtual_Key"},
6268: {"AegisName":"Mirth_Key"},
6269: {"AegisName":"Master_Brush"},
6270: {"AegisName":"Mins_Picture"},
6271: {"AegisName":"Mins_Receipt"},
6272: {"AegisName":"Experiment_Seed"},
6273: {"AegisName":"Altered_Seed"},
6274: {"AegisName":"Saint_Cloth_Piece"},
6275: {"AegisName":"King_Shield"},
6276: {"AegisName":"Clear_Reagent"},
6277: {"AegisName":"Red_Reagent"},
6278: {"AegisName":"Black_Reagent"},
6279: {"AegisName":"Apple_Bomb_CB"},
6280: {"AegisName":"Pinepple_Bomb_CB"},
6281: {"AegisName":"Coconut_Bomb_CB"},
6282: {"AegisName":"Melon_Bomb_CB"},
6283: {"AegisName":"Banana_Bomb_CB"},
6284: {"AegisName":"Plant_Genetic_Grow"},
6285: {"AegisName":"Quality_Potion_Book"},
6286: {"AegisName":"F_Max_Weight_Up_Scroll"},
6287: {"AegisName":"F_Clothing_Dye_Coupon"},
6288: {"AegisName":"F_Happy_Box"},
6289: {"AegisName":"F_Mysterious_Dyestuff"},
6290: {"AegisName":"F_New_Style_Coupon"},
6291: {"AegisName":"F_Enriched_Elunium"},
6292: {"AegisName":"F_Enriched_Oridecon"},
6293: {"AegisName":"F_Token_Of_Siegfried"},
6294: {"AegisName":"F_Marriage_Covenant"},
6295: {"AegisName":"F_Clothing_Dye_Coupon2"},
6296: {"AegisName":"RF_Taining_Notice"},
6297: {"AegisName":"Bottle_To_Throw"},
6298: {"AegisName":"Pumpkin_Head_Crushed"},
6299: {"AegisName":"Worn_Cloth_Piece"},
6300: {"AegisName":"J_7Draw"},
6301: {"AegisName":"J_Semi_Draw"},
6302: {"AegisName":"GM_Handwriting"},
6303: {"AegisName":"Changed_Hydra_Ball"},
6304: {"AegisName":"Sapa_Feat_Cert"},
6305: {"AegisName":"Frozen_Skin_Piece"},
6306: {"AegisName":"Solid_Bloodstain"},
6307: {"AegisName":"Suspicious_Magic_Stone"},
6308: {"AegisName":"Unidentified_Relic"},
6309: {"AegisName":"E_Max_Weight_Up_Scroll"},
6310: {"AegisName":"E_Cloth_Dye_Coupon"},
6311: {"AegisName":"E_Happy_Box"},
6312: {"AegisName":"E_Mysterious_Dyestuff"},
6313: {"AegisName":"E_New_Style_Coupon"},
6314: {"AegisName":"E_Enriched_Elunium"},
6315: {"AegisName":"E_Enriched_Oridecon"},
6316: {"AegisName":"E_Token_Of_Siegfried"},
6317: {"AegisName":"E_Marriage_Covenant"},
6318: {"AegisName":"E_Cloth_Dye_Coupon2"},
6319: {"AegisName":"Small_Bradium"},
6320: {"AegisName":"Premium_Reset_Stone"},
6321: {"AegisName":"Rakehorn_Helm"},
6322: {"AegisName":"Antler_Helm"},
6323: {"AegisName":"Twinhorn_Helm"},
6324: {"AegisName":"Singlehorn_Helm"},
6325: {"AegisName":"White_Spider_Limb"},
6326: {"AegisName":"Queen_Wing_Piece"},
6327: {"AegisName":"LI_HD_Bradium"},
6328: {"AegisName":"Calender_January"},
6329: {"AegisName":"Calender_February"},
6330: {"AegisName":"Calender_March"},
6331: {"AegisName":"Calender_April"},
6332: {"AegisName":"Calender_May"},
6333: {"AegisName":"Calender_June"},
6334: {"AegisName":"Calender_July"},
6335: {"AegisName":"Calender_August"},
6336: {"AegisName":"Calender_September"},
6337: {"AegisName":"Calender_October"},
6338: {"AegisName":"Calender_November"},
6339: {"AegisName":"Calender_December"},
6340: {"AegisName":"Fade_Notation_Green"},
6341: {"AegisName":"Fade_Notation_Red"},
6342: {"AegisName":"Fade_Notation_Purple"},
6343: {"AegisName":"Fade_Notation_Blue"},
6344: {"AegisName":"Muscle_Story"},
6345: {"AegisName":"Love_Ball"},
6346: {"AegisName":"Seagate_Mark"},
6347: {"AegisName":"Bless_Word_Paper1"},
6348: {"AegisName":"Bless_Word_Paper2"},
6349: {"AegisName":"Bless_Word_Paper3"},
6350: {"AegisName":"Bless_Word_Paper4"},
6351: {"AegisName":"Bless_Word_Paper5"},
6352: {"AegisName":"Bless_Word_Paper6"},
6353: {"AegisName":"Bless_Word_Paper7"},
6354: {"AegisName":"Bless_Word_Paper8"},
6355: {"AegisName":"Bless_Word_Paper9"},
6356: {"AegisName":"Bless_Word_Paper10"},
6357: {"AegisName":"Fortune_Cookie_Fail"},
6358: {"AegisName":"Free_Cash_Coupon"},
6359: {"AegisName":"Guidebook_Exchange"},
6360: {"AegisName":"Scarlet_Pts"},
6361: {"AegisName":"Indigo_Pts"},
6362: {"AegisName":"Yellow_Wish_Pts"},
6363: {"AegisName":"Lime_Green_Pts"},
6364: {"AegisName":"Woe_Coin"},
6365: {"AegisName":"Arena_Coin"},
6366: {"AegisName":"Turbo_Track_Coin"},
6367: {"AegisName":"Kafra_Coin"},
6368: {"AegisName":"Endless_Coin"},
6369: {"AegisName":"Amatsu_Bead_A"},
6370: {"AegisName":"Amatsu_Bead_Ma"},
6371: {"AegisName":"Amatsu_Bead_Tsu"},
6372: {"AegisName":"Amatsu_Bead_Jam"},
6373: {"AegisName":"Amatsu_Bead_Bo"},
6374: {"AegisName":"Amatsu_Bead_Ree"},
6375: {"AegisName":"Amatsu_Bead_!"},
6376: {"AegisName":"KVM_Badge"},
6377: {"AegisName":"Buy_Market_Permit"},
6378: {"AegisName":"Winning_Mark"},
6379: {"AegisName":"Card_Coin"},
6380: {"AegisName":"Mora_Coin"},
6381: {"AegisName":"Field_Shovel"},
6382: {"AegisName":"Urn"},
6383: {"AegisName":"Clue_Of_Lope"},
6384: {"AegisName":"Ring_Of_Lope"},
6385: {"AegisName":"Research_Tool_Bag"},
6386: {"AegisName":"Bathtub_R_Sample"},
6387: {"AegisName":"Teeth_Sample"},
6388: {"AegisName":"Scale_Sample"},
6389: {"AegisName":"Puddle_R_Sample"},
6390: {"AegisName":"Small_Pocket"},
6391: {"AegisName":"Splendid_Supply_Kit"},
6392: {"AegisName":"Bradium_Box"},
6393: {"AegisName":"Round_Feather"},
6394: {"AegisName":"Golden_Feather"},
6395: {"AegisName":"Angel_Magic_Power"},
6396: {"AegisName":"Auger_Of_Spirit"},
6397: {"AegisName":"PR_Team_Ticket"},
6398: {"AegisName":"Develop_Team_Ticket"},
6399: {"AegisName":"Marketing_Team_Ticket"},
6400: {"AegisName":"Operating_Team_Ticket"},
6401: {"AegisName":"Palm_O"},
6402: {"AegisName":"Oil_Palm_F"},
6403: {"AegisName":"Comodo_L"},
6404: {"AegisName":"Caress_H"},
6405: {"AegisName":"Cendrawasih_F"},
6406: {"AegisName":"Cendrawasih_SF"},
6407: {"AegisName":"Life_Stone1"},
6408: {"AegisName":"Life_Stone2"},
6409: {"AegisName":"Life_Stone3"},
6410: {"AegisName":"Idul_Fitri_Card"},
6411: {"AegisName":"Ripe_Watermelon"},
6412: {"AegisName":"Special_Medal"},
6413: {"AegisName":"New_Insurance"},
6414: {"AegisName":"Raganta_Card"},
6415: {"AegisName":"Strange_Embryo"},
6416: {"AegisName":"Pet_Exchange"},
6417: {"AegisName":"Silvervine"},
6418: {"AegisName":"Agrade_Coin"},
6419: {"AegisName":"Bgrade_Coin"},
6420: {"AegisName":"Cgrade_Coin"},
6421: {"AegisName":"Dgrade_Coin"},
6422: {"AegisName":"Egrade_Coin"},
6423: {"AegisName":"Anger_Seagod"},
6424: {"AegisName":"Halloween_Fragment"},
6425: {"AegisName":"Halloween_Certificate"},
6426: {"AegisName":"Bad_Can"},
6427: {"AegisName":"Bad_Can_Sack"},
6428: {"AegisName":"Bravery_Card_A"},
6429: {"AegisName":"Bravery_Card_B"},
6430: {"AegisName":"Picture_Piece"},
6431: {"AegisName":"Bucket"},
6432: {"AegisName":"Full_Bucket"},
6433: {"AegisName":"Clean_Brush"},
6434: {"AegisName":"Fix_Kit"},
6435: {"AegisName":"Fresh_Fruit"},
6436: {"AegisName":"Ptotection_Seagod"},
6437: {"AegisName":"Scaraba_Perfume"},
6438: {"AegisName":"Unbreakable_Weap"},
6439: {"AegisName":"Unbreakable_Def"},
6440: {"AegisName":"General_Lubricant"},
6441: {"AegisName":"High_RankLubricant"},
6442: {"AegisName":"Octopus_Hunt_Stick"},
6443: {"AegisName":"Sillit_Pong_Bottle"},
6444: {"AegisName":"Emperium_G"},
6445: {"AegisName":"Blue_Card_X"},
6446: {"AegisName":"Green_Paper"},
6447: {"AegisName":"Red_Paper"},
6448: {"AegisName":"White_Paper"},
6449: {"AegisName":"Casual_Diary"},
6450: {"AegisName":"Honest_Diary"},
6451: {"AegisName":"Unknown_Fish"},
6452: {"AegisName":"Etoile_Ring"},
6453: {"AegisName":"Undelivered_Gift"},
6454: {"AegisName":"Santa_Bag"},
6455: {"AegisName":"Tiny_Ticket"},
6456: {"AegisName":"Guarantee_Weapon_5Up"},
6457: {"AegisName":"Guarantee_Armor_5Up"},
6459: {"AegisName":"Jae_Sinho_Unpo"},
6460: {"AegisName":"Jae_Sinho_Undo"},
6461: {"AegisName":"Mimong_Sungjin"},
6462: {"AegisName":"Gilsang_Yeoui"},
6463: {"AegisName":"Sin_Sun_Jeonsul"},
6464: {"AegisName":"Hate_Bundle"},
6465: {"AegisName":"Guard_Coin"},
6466: {"AegisName":"Clean_Water"},
6467: {"AegisName":"Perfume"},
6468: {"AegisName":"Thai_Perfume"},
6469: {"AegisName":"Will_Of_Warrior"},
6470: {"AegisName":"Blood_Thirst"},
6471: {"AegisName":"Goast_Chill"},
6472: {"AegisName":"Holy_Mom_Blaze"},
6473: {"AegisName":"Amatsu_Orb01"},
6474: {"AegisName":"Amatsu_Orb02"},
6475: {"AegisName":"Amatsu_Orb03"},
6476: {"AegisName":"Amatsu_Orb04"},
6477: {"AegisName":"Amatsu_Orb05"},
6478: {"AegisName":"Amatsu_Orb06"},
6479: {"AegisName":"Amatsu_Orb07"},
6480: {"AegisName":"Event_Coin"},
6481: {"AegisName":"Holy_Rock_Piece"},
6482: {"AegisName":"Ancient_City_Key"},
6483: {"AegisName":"Dream_Scroll"},
6484: {"AegisName":"Enchant_Book"},
6485: {"AegisName":"BlueCard_2"},
6486: {"AegisName":"BlueCard_0"},
6487: {"AegisName":"BlueCard_1"},
6488: {"AegisName":"Thanks_Invest_Ticket"},
6489: {"AegisName":"Cats_Invest_Certif"},
6490: {"AegisName":"Magic_Clay_Fragment"},
6491: {"AegisName":"Magic_Clay"},
6492: {"AegisName":"Magic_Clay_Lump"},
6493: {"AegisName":"Makibishi"},
6494: {"AegisName":"Kafra_Coin2"},
6495: {"AegisName":"Eden_Merit_Badge"},
6496: {"AegisName":"Tikbalang_Thick_Spine"},
6497: {"AegisName":"Lesser_Agimat"},
6498: {"AegisName":"Jejellopy"},
6499: {"AegisName":"Ancient_Grudge"},
6500: {"AegisName":"Sharp_Bamboo"},
6501: {"AegisName":"Salt_Bag"},
6502: {"AegisName":"Silver_Cross"},
6503: {"AegisName":"Soul_Protection"},
6504: {"AegisName":"Cast_Iron_Caldron"},
6505: {"AegisName":"Purified_Bone"},
6506: {"AegisName":"Offering_Bouquet"},
6507: {"AegisName":"Evil_Bone"},
6508: {"AegisName":"Silver_Bracelet"},
6509: {"AegisName":"Mysterious_Flower"},
6510: {"AegisName":"Elegant_Flower"},
6511: {"AegisName":"Beautiful_Flower"},
6512: {"AegisName":"Charm_Fire"},
6513: {"AegisName":"Charm_Ice"},
6514: {"AegisName":"Charm_Wind"},
6515: {"AegisName":"Charm_Earth"},
6516: {"AegisName":"Bakonawa_Doll"},
6517: {"AegisName":"Bangungot_Doll"},
6518: {"AegisName":"Buwaya_Doll"},
6519: {"AegisName":"Collected_Sample"},
6520: {"AegisName":"Lost_Belongings"},
6521: {"AegisName":"Royal_Certificate"},
6522: {"AegisName":"Royal_Certificate_"},
6523: {"AegisName":"Bakonawa_Spirit_Piece"},
6524: {"AegisName":"Bangungot_Spirit_Piece"},
6525: {"AegisName":"Buwaya_Spirit_Piece"},
6526: {"AegisName":"BlueCard_Happy"},
6527: {"AegisName":"BlueCard_Enjoy"},
6528: {"AegisName":"BlueCard_Light"},
6529: {"AegisName":"BlueCard_Mid"},
6530: {"AegisName":"BlueCard_Fall"},
6531: {"AegisName":"Royal_Certificate__"},
6532: {"AegisName":"Honey_Songpyun"},
6533: {"AegisName":"Torn_Document"},
6534: {"AegisName":"Fruit_Sundae"},
6535: {"AegisName":"Red_Cloth"},
6536: {"AegisName":"Star_Decor"},
6537: {"AegisName":"Sky_Medal"},
6538: {"AegisName":"Real_Blank_Card"},
6539: {"AegisName":"Old_Left_Lapine"},
6540: {"AegisName":"Golden_Leaf"},
6541: {"AegisName":"Avant_Research_Data"},
6542: {"AegisName":"Star_Shape_Mushroom"},
6543: {"AegisName":"Lv110_Achieved_Coin"},
6544: {"AegisName":"Lv120_Achieved_Coin"},
6545: {"AegisName":"Firm_Hair"},
6546: {"AegisName":"Younger_Bro_Letter"},
6547: {"AegisName":"Stained_Research_Book"},
6548: {"AegisName":"Piece_Of_Lapine_Wing"},
6549: {"AegisName":"Courtesy_Ticket"},
6550: {"AegisName":"Brownie_Ticket"},
6551: {"AegisName":"RWC_Spirit_Auger"},
6552: {"AegisName":"Mail_Package"},
6553: {"AegisName":"Leaf_Made_Wood"},
6554: {"AegisName":"Seed_Box"},
6555: {"AegisName":"Birthday_Candle"},
6556: {"AegisName":"Nespresso_Ticket"},
6557: {"AegisName":"Fancy_Fairy_Wing"},
6558: {"AegisName":"Pile_Of_Acorn"},
6559: {"AegisName":"Eye_Drops"},
6560: {"AegisName":"Leaf_Bookmark"},
6561: {"AegisName":"Dustball"},
6562: {"AegisName":"Tiny_Mouse_Tail"},
6563: {"AegisName":"Weeds"},
6564: {"AegisName":"Captive_Hatchling"},
6565: {"AegisName":"Racy_Spice"},
6566: {"AegisName":"Cacao99_Recipe"},
6567: {"AegisName":"Choco_Drink_Recipe"},
6581: {"AegisName":"Holy_Amulet"},
6583: {"AegisName":"3rd_Test_Pass"},
6584: {"AegisName":"Guarantee_Weapon_12Up"},
6585: {"AegisName":"Guarantee_Armor_12Up"},
6586: {"AegisName":"CapturedBook"},
6592: {"AegisName":"Small_Wooden_Chest"},
6593: {"AegisName":"Cryptura_Hair_Coupon"},
6594: {"AegisName":"Magic_Bronze_Bullion"},
6595: {"AegisName":"Hammer_Of_Velund"},
6596: {"AegisName":"Anvil_Of_Velund"},
6597: {"AegisName":"Bracelet_Of_Velund"},
6598: {"AegisName":"Rib_Of_Jormungand"},
6599: {"AegisName":"Spirit_Of_Hugin"},
6600: {"AegisName":"Spirit_Of_Munin"},
6601: {"AegisName":"Chisel_Of_Giant"},
6602: {"AegisName":"Secret_Of_Rune"},
6603: {"AegisName":"Skin_Of_Hraesvelg"},
6604: {"AegisName":"Essence_Of_Rune"},
6605: {"AegisName":"Muspellium"},
6606: {"AegisName":"P_Cart_C"},
6607: {"AegisName":"Temporal_Crystal"},
6608: {"AegisName":"Coagulated_Spell"},
6609: {"AegisName":"Glast_Decayed_Nail"},
6610: {"AegisName":"Glast_Horrendous_Mouth"},
6611: {"AegisName":"Colorful_Key"},
6612: {"AegisName":"Gold_Coin_Basket"},
6613: {"AegisName":"Colorful_Brooch"},
6615: {"AegisName":"Siege_Guild_Coin"},
6616: {"AegisName":"Lmtd_Manny_Card"},
6617: {"AegisName":"Lmtd_Sid_Card"},
6618: {"AegisName":"Lmtd_Diego_Card"},
6619: {"AegisName":"Lmtd_Scrat_Card"},
6623: {"AegisName":"Rough_Energy_Crystal"},
6624: {"AegisName":"Purified_Energy_Crystal"},
6625: {"AegisName":"High_Purity_Energy_Xtal"},
6635: {"AegisName":"Blacksmith_Blessing"},
6636: {"AegisName":"STRStone_Top"},
6637: {"AegisName":"INTStone_Top"},
6638: {"AegisName":"AGIStone_Top"},
6639: {"AegisName":"DEXStone_Top"},
6640: {"AegisName":"VITStone_Top"},
6641: {"AegisName":"LUKStone_Top"},
6642: {"AegisName":"ATKStone_Middle"},
6643: {"AegisName":"MATKStone_Middle"},
6644: {"AegisName":"HITStone_Bottom"},
6645: {"AegisName":"FLEEStone_Bottom"},
6646: {"AegisName":"Poring_Badge"},
6648: {"AegisName":"Shabby_Crown"},
6649: {"AegisName":"Broken_Horn"},
6650: {"AegisName":"Shabby_Ring"},
6651: {"AegisName":"Rusty_Bracelet"},
6652: {"AegisName":"Old_Photo_Album"},
6653: {"AegisName":"Shabby_Pill"},
6654: {"AegisName":"Needle_And_Thread"},
6655: {"AegisName":"Firm_Pumpkin"},
6656: {"AegisName":"Goast_Free_Charm"},
6657: {"AegisName":"Memory_Of_Jack"},
6658: {"AegisName":"Halloween_Coin"},
6665: {"AegisName":"RWC_Inicializer"},
6669: {"AegisName":"Jade_Leaf"},
6671: {"AegisName":"Geffen_Magic_Coin"},
6672: {"AegisName":"Gray_Shard"},
6673: {"AegisName":"Bossnia_Ticket"},
6674: {"AegisName":"Daily_Coin"},
6681: {"AegisName":"XMAS_Cookie"},
6682: {"AegisName":"Bag_Of_Selling_Goods"},
6683: {"AegisName":"Thirsty_Flower"},
6684: {"AegisName":"TokenOfHero"},
6685: {"AegisName":"MoroccMerit"},
6686: {"AegisName":"Brick"},
6687: {"AegisName":"LongRopes"},
6688: {"AegisName":"Wood_"},
6689: {"AegisName":"BurningSkin"},
6690: {"AegisName":"YummyStem"},
6691: {"AegisName":"BurningFeather"},
6692: {"AegisName":"PatrolLog"},
6693: {"AegisName":"Stone_Of_Blessing"},
6694: {"AegisName":"Monster_Blood"},
6695: {"AegisName":"ToothOfFlameGolem"},
6696: {"AegisName":"ToothOfFlameFrilldora"},
6697: {"AegisName":"Costume_Exchange"},
6698: {"AegisName":"Hatchet"},
6699: {"AegisName":"Silence_Of_God"},
6700: {"AegisName":"White_Scale"},
6701: {"AegisName":"Treasure_Of_Dvergr"},
6702: {"AegisName":"Sweat_Of_Dvergr"},
6703: {"AegisName":"Tear_Of_Warrior"},
6704: {"AegisName":"Anger_Of_Warrior"},
6705: {"AegisName":"Medal_Of_Honor"},
6706: {"AegisName":"Flower_Of_Guardian"},
6707: {"AegisName":"J_Shop_Coupon"},
6708: {"AegisName":"Mana_crystal"},
6709: {"AegisName":"Crispy_silk"},
6710: {"AegisName":"Twisted_Snake"},
6712: {"AegisName":"Lovely_Stick"},
6713: {"AegisName":"Soul_Of_Ahat"},
6714: {"AegisName":"Soul_Of_Shnaim"},
6715: {"AegisName":"P_Of_Evil_Soul"},
6716: {"AegisName":"Cri_Stone"},
6717: {"AegisName":"MaxHP_Stone"},
6718: {"AegisName":"MaxSP_Stone"},
6719: {"AegisName":"Tooth_Of_Jitterbug"},
6720: {"AegisName":"Status_Reset_Coupon"},
6721: {"AegisName":"Status_Reset_Coupon2"},
6722: {"AegisName":"Delicious_Clam"},
6723: {"AegisName":"Delicious_Can"},
6724: {"AegisName":"Savage_Box"},
6725: {"AegisName":"Grand_Peco_Box"},
6726: {"AegisName":"Desert_Wolf_Box"},
6727: {"AegisName":"Meeting_Album"},
6732: {"AegisName":"Monster_Coin"},
6733: {"AegisName":"Itchy_Feather"},
6734: {"AegisName":"Unknown_Meal"},
6735: {"AegisName":"Special_Condiment"},
6736: {"AegisName":"Minced_Meat"},
6737: {"AegisName":"Fermented_Wheat_Flour"},
6738: {"AegisName":"Rissole"},
6739: {"AegisName":"Recipe"},
6740: {"AegisName":"HealStone_Top"},
6741: {"AegisName":"HealStone2_Top"},
6742: {"AegisName":"HealStone_Middle"},
6743: {"AegisName":"HPStone_Middle"},
6744: {"AegisName":"SPStone_Middle"},
6745: {"AegisName":"HealStone_Bottom"},
6746: {"AegisName":"Steel_Article"},
6747: {"AegisName":"Steel_Article_"},
6748: {"AegisName":"Excavator_Repoet"},
6749: {"AegisName":"Power_Control_Device"},
6750: {"AegisName":"Wrong_Engine"},
6751: {"AegisName":"Distorted_Iron_Plate"},
6752: {"AegisName":"Charleston_Parts"},
6753: {"AegisName":"Sign_Of_Destruction"},
6754: {"AegisName":"Collected_Herb"},
6755: {"AegisName":"Polluted_Spell"},
6756: {"AegisName":"Condensed_Energy"},
6757: {"AegisName":"Memory_Record"},
6762: {"AegisName":"Banana_Can"},
6763: {"AegisName":"Spicy_Rice_Cake"},
6764: {"AegisName":"Hotdog"},
6765: {"AegisName":"Big_Wheel_Cracker"},
6766: {"AegisName":"Ice_World_Ticket"},
6767: {"AegisName":"Summer_Fes_Coin"},
6768: {"AegisName":"Red_Beans_Of_Ice"},
6769: {"AegisName":"Sweet_Rice_Cake"},
6770: {"AegisName":"Shark"},
6771: {"AegisName":"Bluefin_Tuna"},
6772: {"AegisName":"Octopus"},
6773: {"AegisName":"Snapper"},
6774: {"AegisName":"Piranha"},
6775: {"AegisName":"Salmon"},
6776: {"AegisName":"Eels"},
6777: {"AegisName":"Carp"},
6778: {"AegisName":"Squid_2"},
6779: {"AegisName":"Mackerel"},
6780: {"AegisName":"Crucian_Carp"},
6781: {"AegisName":"Living_Earthworm"},
6782: {"AegisName":"Fresh_Lobster"},
6784: {"AegisName":"Squid_Skewer"},
6785: {"AegisName":"Fantastic_Sauce"},
6786: {"AegisName":"Squid_Of_Bbq"},
6787: {"AegisName":"Good_Firewood"},
6788: {"AegisName":"Rose_Knife"},
6789: {"AegisName":"Custom_Pan"},
6790: {"AegisName":"BigStone_Top"},
6791: {"AegisName":"MediumStone_Top"},
6792: {"AegisName":"SmallStone_Top"},
6795: {"AegisName":"Ticket_Card_RO2"},
6796: {"AegisName":"Name_Card_RO2"},
6797: {"AegisName":"11th_Coin"},
6803: {"AegisName":"Piece_Of_Gigantes"},
6804: {"AegisName":"ORGANIC_PUMPKIN"},
6805: {"AegisName":"INORGANIC_PUMPKIN"},
6813: {"AegisName":"LI_Kapra's_Pass"},
6814: {"AegisName":"Soul_Of_Swordman"},
6815: {"AegisName":"Soul_Of_Merchant"},
6816: {"AegisName":"Soul_Of_Thief"},
6817: {"AegisName":"Soul_Of_Magicion"},
6818: {"AegisName":"Soul_Of_Archer"},
6819: {"AegisName":"Soul_Of_Acolyte"},
6820: {"AegisName":"Particles_Of_Energy"},
6821: {"AegisName":"Solo_Troops_Badge"},
6824: {"AegisName":"Lab_Memory_Record"},
6825: {"AegisName":"Box_Of_Aircleaner"},
6826: {"AegisName":"Fresh_Grape"},
6827: {"AegisName":"Normal_Parts"},
6828: {"AegisName":"Gravity_Parts"},
6832: {"AegisName":"Problematical_Part"},
6833: {"AegisName":"LI_Token_Of_Siegfried"},
6834: {"AegisName":"Legendary_Fur"},
6835: {"AegisName":"Legendary_Mane"},
6836: {"AegisName":"Charm_Of_Soul"},
6837: {"AegisName":"Mouse_Soul_Piece"},
6838: {"AegisName":"Secret_Letter_K"},
6839: {"AegisName":"Gold_Chocoin"},
6840: {"AegisName":"Silver_Chocoin"},
6841: {"AegisName":"Bronze_Chocoin"},
6842: {"AegisName":"Big_Jewel"},
6843: {"AegisName":"Grass_Ring"},
6844: {"AegisName":"Soft_Stone"},
6845: {"AegisName":"Aged_Poo"},
6846: {"AegisName":"LC_Max_WeightUp_Srl"},
6847: {"AegisName":"Very_Tiny_Box"},
6848: {"AegisName":"Light_Box"},
6849: {"AegisName":"Request_Complete"},
6850: {"AegisName":"Suspicious_Box"},
6851: {"AegisName":"Suspicious_Paper"},
6852: {"AegisName":"Super_Neutralizer"},
6853: {"AegisName":"Thankful_Flowers"},
6854: {"AegisName":"Captured_Novus"},
6855: {"AegisName":"Captured_Tatacho"},
6856: {"AegisName":"Blood_Pus_Script"},
6857: {"AegisName":"Very_Hard_Stone"},
6858: {"AegisName":"Captured_Rude"},
6859: {"AegisName":"Captured_Wanderer"},
6860: {"AegisName":"Cow_Soul_Piece"},
6862: {"AegisName":"Tiger_Soul_Piece"},
6863: {"AegisName":"Tiger_Soul_Piece2"},
6864: {"AegisName":"Guarantee_Weapon_19Up"},
6865: {"AegisName":"Guarantee_Armor_19Up"},
6866: {"AegisName":"Rabbit_Soul_Piece"},
6867: {"AegisName":"InsectCollected_BigBox"},
6868: {"AegisName":"InsectCollected_MidBox"},
6869: {"AegisName":"Dust_14ySummerEvent"},
6870: {"AegisName":"Guarantee_Weapon_13Up"},
6871: {"AegisName":"Guarantee_Weapon_14Up"},
6872: {"AegisName":"Guarantee_Weapon_15Up"},
6873: {"AegisName":"Guarantee_Weapon_16Up"},
6874: {"AegisName":"Guarantee_Weapon_17Up"},
6875: {"AegisName":"Guarantee_Weapon_18Up"},
6876: {"AegisName":"Guarantee_Armor_13Up"},
6877: {"AegisName":"Guarantee_Armor_14Up"},
6878: {"AegisName":"Guarantee_Armor_15Up"},
6879: {"AegisName":"Guarantee_Armor_16Up"},
6880: {"AegisName":"Guarantee_Armor_17Up"},
6881: {"AegisName":"Guarantee_Armor_18Up"},
6882: {"AegisName":"Bait_14ySummerEvent"},
6883: {"AegisName":"Snow_Rabbit_Ticket"},
6884: {"AegisName":"Tikbalang_Ticket"},
6885: {"AegisName":"Dragon_Soul_Piece"},
6886: {"AegisName":"Dragon_Soul_Piece2"},
6892: {"AegisName":"Invasion_Plan"},
6893: {"AegisName":"Human_Cookbook"},
6894: {"AegisName":"Champion_Badge"},
6895: {"AegisName":"TE_RuneOfAncient"},
6896: {"AegisName":"TE_RuneOfMystery"},
6897: {"AegisName":"Blue_Whale"},
6898: {"AegisName":"Whale"},
6899: {"AegisName":"Giant_Octopus"},
6900: {"AegisName":"Giant_Squid"},
6901: {"AegisName":"Sturgeon"},
6902: {"AegisName":"Jumbo_Shrimp"},
6903: {"AegisName":"Giant_Earthworm"},
6904: {"AegisName":"Snake_Soul_Piece"},
6905: {"AegisName":"Shattered_Rune"},
6906: {"AegisName":"LI_HD_Carnium"},
6907: {"AegisName":"Horse_Soul_Piece"},
6908: {"AegisName":"ASPDStone_Robe"},
6909: {"AegisName":"Nyangvine_Fruit"},
6910: {"AegisName":"LI_HD_Oridecon"},
6911: {"AegisName":"LI_HD_Elunium"},
6912: {"AegisName":"Lamb_Soul_Piece"},
6913: {"AegisName":"Sacred_Rosary"},
6914: {"AegisName":"Black_Soul"},
6915: {"AegisName":"Captured_Soul"},
6916: {"AegisName":"Monkey_Soul_Piece"},
6917: {"AegisName":"Chicken_Soul_Piece"},
6919: {"AegisName":"TokenOfHonor"},
6920: {"AegisName":"RuneMagicPowder"},
6921: {"AegisName":"Desiccant"},
6922: {"AegisName":"Sandpaper"},
6923: {"AegisName":"Bright_Lights"},
6924: {"AegisName":"Red_Eyes"},
6925: {"AegisName":"Prisoner_Letter"},
6926: {"AegisName":"Midgards_Histories"},
6927: {"AegisName":"Filled_With_SeaStones"},
6928: {"AegisName":"Poring_Loofah"},
6929: {"AegisName":"Letters_Stamped_Seal"},
6930: {"AegisName":"Biz_Items_Sample"},
6931: {"AegisName":"Secret_Documents"},
6932: {"AegisName":"Rare_Old_Books"},
6933: {"AegisName":"Banquet_Invitation"},
6934: {"AegisName":"Wonderful_Cuisine"},
6935: {"AegisName":"Luxurious_Dish"},
6936: {"AegisName":"Stone_Of_Chill"},
6937: {"AegisName":"Soften_Skin"},
6938: {"AegisName":"Porcupine_Big_Spike"},
6939: {"AegisName":"Shabby_Old_Belt"},
6940: {"AegisName":"Moving_Black_Things"},
6941: {"AegisName":"Valkyrie_Fragment"},
6942: {"AegisName":"Will_Of_Owner"},
6943: {"AegisName":"ATKStone_Top"},
6944: {"AegisName":"MATKStone_Top"},
6945: {"AegisName":"STRStone_Middle"},
6946: {"AegisName":"INTStone_Middle"},
6947: {"AegisName":"AGIStone_Middle"},
6948: {"AegisName":"DEXStone_Middle"},
6949: {"AegisName":"VITStone_Middle"},
6950: {"AegisName":"LUKStone_Middle"},
6951: {"AegisName":"HPStone_Bottom"},
6953: {"AegisName":"RamorRob_G_Ticket"},
6954: {"AegisName":"Dog_Soul_Piece"},
6955: {"AegisName":"Pig_Soul_Piece"},
6956: {"AegisName":"Captured_Sheep"},
6957: {"AegisName":"Soft_Wool"},
6958: {"AegisName":"Lamb_Horn"},
6959: {"AegisName":"Costume_Ticket"},
6960: {"AegisName":"Air_Stronghold_Key"},
6961: {"AegisName":"LargeScrap"},
6962: {"AegisName":"OldTank"},
6963: {"AegisName":"HPdrainStone_Robe"},
6964: {"AegisName":"SPdrainStone_Robe"},
6965: {"AegisName":"Reactor_P_FIRE_"},
6966: {"AegisName":"Reactor_P_WATER_"},
6967: {"AegisName":"Reactor_P_GROUND_"},
6968: {"AegisName":"Reactor_P_WIND_"},
6969: {"AegisName":"Reactor_T_FIRE_"},
6970: {"AegisName":"Reactor_T_WATER_"},
6971: {"AegisName":"Reactor_T_GROUND_"},
6972: {"AegisName":"Reactor_T_WIND_"},
6973: {"AegisName":"Reactor_Cure_101_"},
6974: {"AegisName":"Reactor_Cure_102_"},
6975: {"AegisName":"Reactor_Cure_201_"},
6976: {"AegisName":"Reactor_Cure_202_"},
6977: {"AegisName":"Reactor_A_STR_"},
6978: {"AegisName":"Reactor_A_INT_"},
6979: {"AegisName":"Reactor_A_DEF_"},
6980: {"AegisName":"Reactor_A_AVOI_"},
6981: {"AegisName":"Reactor_A_ATK_"},
6982: {"AegisName":"Reactor_A_MATK_"},
6983: {"AegisName":"Reactor_A_MHP_"},
6984: {"AegisName":"Reactor_A_MSP_"},
6985: {"AegisName":"Reactor_A_FROZ_"},
6986: {"AegisName":"Reactor_A_ASPD_"},
6993: {"AegisName":"Guarantee_Weapon_10Up"},
6994: {"AegisName":"Guarantee_Armor_10Up"},
6995: {"AegisName":"WarmStone"},
6996: {"AegisName":"Rabbit_Doll"},
6997: {"AegisName":"Antique_Arrow"},
6999: {"AegisName":"HPdrainStone_Top"},
7000: {"AegisName":"Evt_Cos_Coin"},
7001: {"AegisName":"Mould_Powder"},
7002: {"AegisName":"Ogre_Tooth"},
7003: {"AegisName":"Anolian_Skin"},
7004: {"AegisName":"Mud_Lump"},
7005: {"AegisName":"Skull"},
7006: {"AegisName":"Wing_Of_Red_Bat"},
7007: {"AegisName":"Claw_Of_Rat"},
7008: {"AegisName":"Stiff_Horn"},
7009: {"AegisName":"Glitter_Shell"},
7010: {"AegisName":"Tail_Of_Steel_Scorpion"},
7011: {"AegisName":"Claw_Of_Monkey"},
7012: {"AegisName":"Tough_Scalelike_Stem"},
7013: {"AegisName":"Coral_Reef"},
7014: {"AegisName":"Old_Portrait"},
7015: {"AegisName":"Bookclip_In_Memory"},
7016: {"AegisName":"Spoon_Stub"},
7017: {"AegisName":"Executioner's_Mitten"},
7018: {"AegisName":"Young_Twig"},
7019: {"AegisName":"Loki's_Whispers"},
7020: {"AegisName":"Mother's_Nightmare"},
7021: {"AegisName":"Foolishness_Of_Blind"},
7022: {"AegisName":"Old_Hilt"},
7023: {"AegisName":"Blade_Lost_In_Darkness"},
7024: {"AegisName":"Bloody_Edge"},
7025: {"AegisName":"Lucifer's_Lament"},
7026: {"AegisName":"Key_Of_Clock_Tower"},
7027: {"AegisName":"Underground_Key"},
7028: {"AegisName":"Invite_For_Duel"},
7029: {"AegisName":"Admission_For_Duel"},
7030: {"AegisName":"Claw_Of_Desert_Wolf"},
7031: {"AegisName":"Old_Frying_Pan"},
7032: {"AegisName":"Piece_Of_Egg_Shell"},
7033: {"AegisName":"Poison_Spore"},
7034: {"AegisName":"Red_Socks_With_Holes"},
7035: {"AegisName":"Matchstick"},
7036: {"AegisName":"Fang_Of_Garm"},
7037: {"AegisName":"Trade_Coupon"},
7038: {"AegisName":"Yarn"},
7039: {"AegisName":"Novice_Nametag"},
7040: {"AegisName":"Megaphone"},
7041: {"AegisName":"Fine_Grit"},
7042: {"AegisName":"Leather_Bag_Of_Infinity"},
7043: {"AegisName":"Fine_Sand"},
7044: {"AegisName":"Vigorgra"},
7045: {"AegisName":"Magic_Paint"},
7046: {"AegisName":"Cart_Parts"},
7047: {"AegisName":"Alice's_Apron"},
7048: {"AegisName":"Talon_Of_Griffin"},
7049: {"AegisName":"Stone"},
7050: {"AegisName":"Cotton_Mat"},
7051: {"AegisName":"Silk_Mat"},
7052: {"AegisName":"Old_Magazine"},
7053: {"AegisName":"Cyfar"},
7054: {"AegisName":"Brigan"},
7055: {"AegisName":"Animal_Pooopoo"},
7056: {"AegisName":"Payroll_Of_Kafra"},
7057: {"AegisName":"Gallar_Horn"},
7058: {"AegisName":"Gullraifnir"},
7059: {"AegisName":"Cargo_Free_Ticket"},
7060: {"AegisName":"Warp_Free_Ticket"},
7061: {"AegisName":"Cart_Free_Ticket"},
7062: {"AegisName":"Turtle_Shell_"},
7063: {"AegisName":"Soft_Feather"},
7064: {"AegisName":"Dragon_Fly_Wing"},
7065: {"AegisName":"Sea_Otter_Leather"},
7066: {"AegisName":"Ice_Piece"},
7067: {"AegisName":"Stone_Piece"},
7068: {"AegisName":"Burn_Tree"},
7069: {"AegisName":"Broken_Armor_Piece"},
7070: {"AegisName":"Broken_Shell"},
7071: {"AegisName":"Tatters_Clothes"},
7072: {"AegisName":"Rust_Suriken"},
7073: {"AegisName":"Jewel_Of_Prayer"},
7074: {"AegisName":"Iron_Glove"},
7075: {"AegisName":"Iron_Maiden"},
7076: {"AegisName":"Mystery_Wheel"},
7077: {"AegisName":"Silver_Fancy"},
7078: {"AegisName":"Anger_Of_Valkurye"},
7079: {"AegisName":"Feather_Of_Angel"},
7080: {"AegisName":"Foot_Step_Of_Cat"},
7081: {"AegisName":"Beard_Of_Women"},
7082: {"AegisName":"Root_Of_Stone"},
7083: {"AegisName":"Soul_Of_Fish"},
7084: {"AegisName":"Saliva_Of_Bird"},
7085: {"AegisName":"Tendon_Of_Bear"},
7086: {"AegisName":"Symbol_Of_Sun"},
7087: {"AegisName":"Breath_Of_Soul"},
7088: {"AegisName":"Crystal_Of_Snow"},
7089: {"AegisName":"Indication_Of_Tempest"},
7090: {"AegisName":"Slilince_Wave"},
7091: {"AegisName":"Rough_Billows"},
7092: {"AegisName":"Air_Stream"},
7093: {"AegisName":"Wheel"},
7094: {"AegisName":"Mystery_Piece"},
7095: {"AegisName":"Broken_Steel_Piece"},
7096: {"AegisName":"Cold_Magma"},
7097: {"AegisName":"Burning_Heart"},
7098: {"AegisName":"Live_Coal"},
7099: {"AegisName":"Old_Magic_Circle"},
7100: {"AegisName":"Sharp_Leaf"},
7101: {"AegisName":"Peco_Wing_Feather"},
7102: {"AegisName":"Hideous_Dream"},
7103: {"AegisName":"Unknown_Liquid_Bottle"},
7104: {"AegisName":"Fake_Angel_Wing"},
7105: {"AegisName":"Fake_Angel_Loop"},
7106: {"AegisName":"Goat's_Horn"},
7107: {"AegisName":"Gaoat's_Skin"},
7108: {"AegisName":"Boroken_Shiled_Piece"},
7109: {"AegisName":"Shine_Spear_Blade"},
7110: {"AegisName":"Vroken_Sword"},
7111: {"AegisName":"Smooth_Paper"},
7112: {"AegisName":"Fright_Paper_Blade"},
7113: {"AegisName":"Broken_Pharaoh_Symbol"},
7114: {"AegisName":"Tutankhamen's_Mask"},
7115: {"AegisName":"Harpy's_Feather"},
7116: {"AegisName":"Harpy's_Claw"},
7117: {"AegisName":"Rent_Spell_Book"},
7118: {"AegisName":"Rent_Scroll"},
7119: {"AegisName":"Spawns"},
7120: {"AegisName":"Burning_Horse_Shoe"},
7121: {"AegisName":"Honey_Jar"},
7122: {"AegisName":"Hot_Hair"},
7123: {"AegisName":"Dragon's_Skin"},
7124: {"AegisName":"Sand_Lump"},
7125: {"AegisName":"Scropion's_Nipper"},
7126: {"AegisName":"Large_Jellopy"},
7127: {"AegisName":"Alcol_Create_Book"},
7128: {"AegisName":"FireBottle_Create_Book"},
7129: {"AegisName":"Acid_Create_Book"},
7130: {"AegisName":"Plant_Create_Book"},
7131: {"AegisName":"Mine_Create_Book"},
7132: {"AegisName":"Coating_Create_Book"},
7133: {"AegisName":"Slim_Potion_Create_Book"},
7134: {"AegisName":"Medicine_Bowl"},
7135: {"AegisName":"Fire_Bottle"},
7136: {"AegisName":"Acid_Bottle"},
7137: {"AegisName":"MenEater_Plant_Bottle"},
7138: {"AegisName":"Mini_Bottle"},
7139: {"AegisName":"Coating_Bottle"},
7140: {"AegisName":"Seed_Of_Life"},
7141: {"AegisName":"Yggdrasilberry_Dew"},
7142: {"AegisName":"Germination_Breed"},
7143: {"AegisName":"Life_Force_Pot"},
7144: {"AegisName":"Normal_Potion_Book"},
7145: {"AegisName":"Rag_T_Shirts"},
7146: {"AegisName":"Vacance_Ticket"},
7147: {"AegisName":"Jasmin"},
7148: {"AegisName":"Mother_Letter"},
7149: {"AegisName":"Yellow_Plate"},
7150: {"AegisName":"Bamboo_Cut"},
7151: {"AegisName":"Oil_Paper"},
7152: {"AegisName":"Glossy_Hair"},
7153: {"AegisName":"Old_Japaness_Clothes"},
7154: {"AegisName":"Poison_Powder"},
7155: {"AegisName":"Poison_Toad's_Skin"},
7156: {"AegisName":"Broken_Shuriken"},
7157: {"AegisName":"Black_Mask"},
7158: {"AegisName":"Broken_Wine_Vessel"},
7159: {"AegisName":"Tengu's_Nose"},
7160: {"AegisName":"Lord's_Passable_Ticket"},
7161: {"AegisName":"Black_Bear's_Skin"},
7162: {"AegisName":"Cloud_Piece"},
7163: {"AegisName":"Sharp_Feeler"},
7164: {"AegisName":"Hard_Peach"},
7165: {"AegisName":"Limpid_Celestial_Robe"},
7166: {"AegisName":"Soft_Silk_Cloth"},
7167: {"AegisName":"Mystery_Iron_Bit"},
7168: {"AegisName":"Great_Wing"},
7169: {"AegisName":"Taegeuk_Plate"},
7170: {"AegisName":"Tuxedo"},
7171: {"AegisName":"Leopard_Skin"},
7172: {"AegisName":"Leopard_Talon"},
7173: {"AegisName":"BurnBuster_Bag"},
7174: {"AegisName":"Packing_Ribbon"},
7175: {"AegisName":"Packing_Paper"},
7176: {"AegisName":"XMAS_Coupon"},
7177: {"AegisName":"Part_Of_Star's_Sob"},
7178: {"AegisName":"Star's_Sob"},
7179: {"AegisName":"Donation_Card"},
7180: {"AegisName":"Introduction_Of_Mr.Han"},
7181: {"AegisName":"Receipt_01"},
7182: {"AegisName":"Cacao"},
7183: {"AegisName":"Sister_Letter"},
7184: {"AegisName":"Piano_Keyboard"},
7185: {"AegisName":"Quiz_Ticket"},
7186: {"AegisName":"Thin_Stem"},
7187: {"AegisName":"Festival_Mask"},
7188: {"AegisName":"Browny_Root"},
7189: {"AegisName":"Heart_Of_Tree"},
7190: {"AegisName":"Solid_Peeling"},
7191: {"AegisName":"Lamplight"},
7192: {"AegisName":"Blade_Of_Pinwheel"},
7193: {"AegisName":"Germinating_Sprout"},
7194: {"AegisName":"Soft_Leaf"},
7195: {"AegisName":"Air_Rifle"},
7196: {"AegisName":"Shoulder_Protection"},
7197: {"AegisName":"Tough_Vines"},
7198: {"AegisName":"Great_Leaf"},
7199: {"AegisName":"Coupon"},
7200: {"AegisName":"Flexible_String"},
7201: {"AegisName":"Log"},
7202: {"AegisName":"Beetle_Nipper"},
7203: {"AegisName":"Solid_Twig"},
7204: {"AegisName":"Gunpowder"},
7205: {"AegisName":"Piece_Of_Black_Cloth"},
7206: {"AegisName":"Black_Kitty_Doll"},
7207: {"AegisName":"Old_Manteau"},
7208: {"AegisName":"Rusty_Cleaver"},
7209: {"AegisName":"Dullahan's_Helm"},
7210: {"AegisName":"Dullahan_Armor"},
7211: {"AegisName":"Rojerta_Piece"},
7212: {"AegisName":"Hanging_Doll"},
7213: {"AegisName":"Needle_Pouch"},
7214: {"AegisName":"Bat_Cage"},
7215: {"AegisName":"Broken_Needle"},
7216: {"AegisName":"Red_Scarf"},
7217: {"AegisName":"Spool"},
7218: {"AegisName":"Rotten_Rope"},
7219: {"AegisName":"Striped_Socks"},
7220: {"AegisName":"Ectoplasm"},
7221: {"AegisName":"Tangled_Chain"},
7222: {"AegisName":"Tree_Knot"},
7223: {"AegisName":"Distorted_Portrait"},
7224: {"AegisName":"Stone_Of_Intelligence"},
7225: {"AegisName":"Pumpkin_Bucket"},
7226: {"AegisName":"Pill"},
7227: {"AegisName":"TCG_Card"},
7228: {"AegisName":"Gold_Bullion"},
7229: {"AegisName":"Silver_Bullion"},
7230: {"AegisName":"White_Gold_Bullion"},
7231: {"AegisName":"Gold_Ore"},
7232: {"AegisName":"Silver_Ore"},
7233: {"AegisName":"Mithril_Ore"},
7234: {"AegisName":"Soul_Of_Guild"},
7235: {"AegisName":"Soul_Of_Courage"},
7236: {"AegisName":"Soul_Of_Guard"},
7237: {"AegisName":"Soul_Of_Partnership"},
7238: {"AegisName":"Soul_Of_Correspondence"},
7239: {"AegisName":"Soul_Of_Proceeding"},
7240: {"AegisName":"Soul_Of_Confidence"},
7241: {"AegisName":"Soul_Of_Agreement"},
7242: {"AegisName":"Soul_Of_Harmony"},
7243: {"AegisName":"Soul_Of_Cooperate"},
7244: {"AegisName":"Soul_Of_Unity"},
7245: {"AegisName":"Soul_Of_Friendship"},
7246: {"AegisName":"Soul_Of_Peace"},
7247: {"AegisName":"Soul_Of_Spirit"},
7248: {"AegisName":"Soul_Of_Honor"},
7249: {"AegisName":"Soul_Of_Service"},
7250: {"AegisName":"Soul_Of_Glory"},
7251: {"AegisName":"Soul_Of_Victory"},
7252: {"AegisName":"Herb_Medicine"},
7253: {"AegisName":"Taeguk_Flag"},
7254: {"AegisName":"Digital_Print_Ticket"},
7255: {"AegisName":"China_Marble01"},
7256: {"AegisName":"China_Marble02"},
7257: {"AegisName":"China_Marble03"},
7258: {"AegisName":"China_Marble04"},
7259: {"AegisName":"China_Marble05"},
7260: {"AegisName":"China_Marble06"},
7261: {"AegisName":"China_Marble07"},
7262: {"AegisName":"Fan"},
7263: {"AegisName":"Cat_Eyed_Stone"},
7264: {"AegisName":"Dried_Sand"},
7265: {"AegisName":"Dragon_Horn"},
7266: {"AegisName":"Dragon_Fang"},
7267: {"AegisName":"Tiger_Skin_Panties"},
7268: {"AegisName":"Little_Blacky_Ghost"},
7269: {"AegisName":"Bib"},
7270: {"AegisName":"Milk_Bottle"},
7271: {"AegisName":"Figure"},
7272: {"AegisName":"Meat_Dumpling_Doll"},
7273: {"AegisName":"Golden_Necklace"},
7274: {"AegisName":"Ancient_Translator"},
7275: {"AegisName":"Ancient_Document"},
7276: {"AegisName":"Picture_Letter"},
7277: {"AegisName":"Munak_Doll"},
7278: {"AegisName":"Wellbeing_Letter"},
7279: {"AegisName":"Vita500_Lid"},
7280: {"AegisName":"Quiz_Ticket01"},
7281: {"AegisName":"Quiz_Ticket02"},
7282: {"AegisName":"Quiz_Ticket03"},
7283: {"AegisName":"Quiz_Ticket04"},
7284: {"AegisName":"Quiz_Ticket05"},
7285: {"AegisName":"Thread_Skein"},
7286: {"AegisName":"Chilli"},
7287: {"AegisName":"Thread_Skein_"},
7288: {"AegisName":"Thai_Ring"},
7289: {"AegisName":"Olivine"},
7290: {"AegisName":"Phlogopite"},
7291: {"AegisName":"Agate"},
7292: {"AegisName":"Muscovite"},
7293: {"AegisName":"Rose_Quartz"},
7294: {"AegisName":"Turquoise"},
7295: {"AegisName":"Citrine"},
7296: {"AegisName":"Pyroxene"},
7297: {"AegisName":"Biotite"},
7298: {"AegisName":"Leaf_Clothes"},
7299: {"AegisName":"Bamboo_Basket"},
7300: {"AegisName":"Gemstone"},
7301: {"AegisName":"Sword_Accessory"},
7302: {"AegisName":"KRATHONG"},
7303: {"AegisName":"Bag_Of_Rice"},
7304: {"AegisName":"Witch's_Spell_Book"},
7305: {"AegisName":"Authority_Of_Nine_World"},
7306: {"AegisName":"Fragment_Of_Soul"},
7307: {"AegisName":"Whisper_Of_Soul"},
7308: {"AegisName":"Witch's_Potion"},
7309: {"AegisName":"Wing_Of_Crow"},
7310: {"AegisName":"Free_Peco_Ticket"},
7311: {"AegisName":"Free_Flying_Ship_Ticket"},
7312: {"AegisName":"Jubilee"},
7313: {"AegisName":"Seal_Of_Witch"},
7314: {"AegisName":"The_Sign"},
7315: {"AegisName":"Dark_Crystal_Fragment"},
7316: {"AegisName":"Long_Limb"},
7317: {"AegisName":"Screw"},
7318: {"AegisName":"Old_Pick"},
7319: {"AegisName":"Old_Steel_Plate"},
7320: {"AegisName":"Air_Pollutant"},
7321: {"AegisName":"Fragment_Of_Crystal"},
7322: {"AegisName":"Poisonous_Gas"},
7323: {"AegisName":"Battered_Kettle"},
7324: {"AegisName":"IL_Kraken_Leg"},
7325: {"AegisName":"Tube"},
7326: {"AegisName":"Fluorescent_Liquid"},
7327: {"AegisName":"Headlamp"},
7328: {"AegisName":"Legendary_Scroll"},
7329: {"AegisName":"Old_Copper_Key"},
7330: {"AegisName":"2anny"},
7331: {"AegisName":"Flower_Of_Heaven"},
7332: {"AegisName":"Slate"},
7333: {"AegisName":"Piece_Of_Slate_1"},
7334: {"AegisName":"Piece_Of_Slate_2"},
7335: {"AegisName":"Piece_Of_Slate_3"},
7336: {"AegisName":"Piece_Of_Slate_4"},
7337: {"AegisName":"Eye_Of_Hellion"},
7338: {"AegisName":"RO_Transportation_Card"},
7339: {"AegisName":"RO_Transportation_Card_"},
7340: {"AegisName":"Will_Of_Darkness"},
7341: {"AegisName":"Worn_Out_Pendant"},
7342: {"AegisName":"File01"},
7343: {"AegisName":"File02"},
7344: {"AegisName":"File03"},
7345: {"AegisName":"Armlet_Of_Prisoner"},
7346: {"AegisName":"Pile_Of_Ymir_Heart"},
7347: {"AegisName":"Lab_Staff_Record"},
7348: {"AegisName":"Indication_Of_Member01"},
7349: {"AegisName":"Indication_Of_Member02"},
7350: {"AegisName":"Pass"},
7351: {"AegisName":"Friend's_Diary"},
7352: {"AegisName":"Transparent_Plate01"},
7353: {"AegisName":"Transparent_Plate02"},
7354: {"AegisName":"Transparent_Plate03"},
7355: {"AegisName":"Transparent_Plate04"},
7356: {"AegisName":"Piece_Of_Crest1"},
7357: {"AegisName":"Piece_Of_Crest2"},
7358: {"AegisName":"Piece_Of_Crest3"},
7359: {"AegisName":"Piece_Of_Crest4"},
7360: {"AegisName":"RO_Festival_Ticket"},
7361: {"AegisName":"Lotto01"},
7362: {"AegisName":"Lotto02"},
7363: {"AegisName":"Lotto03"},
7364: {"AegisName":"Lotto04"},
7365: {"AegisName":"Lotto05"},
7366: {"AegisName":"Lotto06"},
7367: {"AegisName":"Lotto07"},
7368: {"AegisName":"Lotto08"},
7369: {"AegisName":"Lotto09"},
7370: {"AegisName":"Lotto10"},
7371: {"AegisName":"Lotto11"},
7372: {"AegisName":"Lotto12"},
7373: {"AegisName":"Lotto13"},
7374: {"AegisName":"Lotto14"},
7375: {"AegisName":"Lotto15"},
7376: {"AegisName":"Lotto16"},
7377: {"AegisName":"Lotto17"},
7378: {"AegisName":"Lotto18"},
7379: {"AegisName":"Lotto19"},
7380: {"AegisName":"Lotto20"},
7381: {"AegisName":"Lotto21"},
7382: {"AegisName":"Lotto22"},
7383: {"AegisName":"Lotto23"},
7384: {"AegisName":"Lotto24"},
7385: {"AegisName":"Lotto25"},
7386: {"AegisName":"Lotto26"},
7387: {"AegisName":"Lotto27"},
7388: {"AegisName":"Lotto28"},
7389: {"AegisName":"Lotto29"},
7390: {"AegisName":"Lotto30"},
7391: {"AegisName":"Lotto31"},
7392: {"AegisName":"Lotto32"},
7393: {"AegisName":"Lotto33"},
7394: {"AegisName":"Lotto34"},
7395: {"AegisName":"Lotto35"},
7396: {"AegisName":"Lotto36"},
7397: {"AegisName":"Lotto37"},
7398: {"AegisName":"Lotto38"},
7399: {"AegisName":"Word_Card01"},
7400: {"AegisName":"Word_Card02"},
7401: {"AegisName":"Word_Card03"},
7402: {"AegisName":"Word_Card04"},
7403: {"AegisName":"Word_Card05"},
7404: {"AegisName":"Word_Card06"},
7405: {"AegisName":"Crushed_Can"},
7406: {"AegisName":"Moon_Cake1"},
7407: {"AegisName":"Moon_Cake2"},
7408: {"AegisName":"Moon_Cake3"},
7409: {"AegisName":"Moon_Cake4"},
7410: {"AegisName":"Moon_Cake5"},
7411: {"AegisName":"Moon_Cake6"},
7412: {"AegisName":"Moon_Cake7"},
7413: {"AegisName":"Moon_Cake8"},
7414: {"AegisName":"Moon_Cake9"},
7415: {"AegisName":"Stone_Of_Summons"},
7416: {"AegisName":"Letter_Of_Recommend"},
7417: {"AegisName":"Mission_ScrollA"},
7418: {"AegisName":"Mission_ScrollB"},
7419: {"AegisName":"Embryo_HandBook"},
7420: {"AegisName":"Skull_"},
7421: {"AegisName":"Key_Red"},
7422: {"AegisName":"Key_Yellow"},
7423: {"AegisName":"Key_Blue"},
7424: {"AegisName":"Key_Green"},
7425: {"AegisName":"Key_Black"},
7426: {"AegisName":"Magic_Gem_Red"},
7427: {"AegisName":"Magic_Gem_Yellow"},
7428: {"AegisName":"Magic_Gem_Blue"},
7429: {"AegisName":"Magic_Gem_Green"},
7430: {"AegisName":"Magic_Gem_Black"},
7431: {"AegisName":"Several_Books"},
7432: {"AegisName":"Leather_Pouch"},
7433: {"AegisName":"Scroll"},
7434: {"AegisName":"Elemental_Potion_Book"},
7435: {"AegisName":"Golden_Bracelet"},
7436: {"AegisName":"Piece_Of_Memory_Green"},
7437: {"AegisName":"Piece_Of_Memory_Purple"},
7438: {"AegisName":"Piece_Of_Memory_Blue"},
7439: {"AegisName":"Piece_Of_Memory_Red"},
7440: {"AegisName":"Red_Feather"},
7441: {"AegisName":"Blue_Feather"},
7442: {"AegisName":"Cursed_Seal"},
7443: {"AegisName":"Tri_Headed_Dragon_Head"},
7444: {"AegisName":"Treasure_Box"},
7445: {"AegisName":"Dragonball_Green"},
7446: {"AegisName":"Dragonball_Blue"},
7447: {"AegisName":"Dragonball_Red"},
7448: {"AegisName":"Dragonball_Yellow"},
7449: {"AegisName":"Bloody_Page"},
7450: {"AegisName":"Piece_Of_Bone_Armor"},
7451: {"AegisName":"Scale_Of_Red_Dragon"},
7452: {"AegisName":"Yellow_Spice"},
7453: {"AegisName":"Sweet_Sauce"},
7454: {"AegisName":"Plain_Sauce"},
7455: {"AegisName":"Hot_Sauce"},
7456: {"AegisName":"Red_Spice"},
7457: {"AegisName":"Cooking_Oil"},
7458: {"AegisName":"Baphomet's_Horn"},
7459: {"AegisName":"RAMADAN_"},
7460: {"AegisName":"Niflheim_Ticket"},
7461: {"AegisName":"BlueCard_A"},
7462: {"AegisName":"BlueCard_E"},
7463: {"AegisName":"BlueCard_F"},
7464: {"AegisName":"BlueCard_H"},
7465: {"AegisName":"BlueCard_L"},
7466: {"AegisName":"BlueCard_N"},
7467: {"AegisName":"BlueCard_O"},
7468: {"AegisName":"BlueCard_P"},
7469: {"AegisName":"BlueCard_U"},
7470: {"AegisName":"BlueCard_W"},
7471: {"AegisName":"BlueCard_Y"},
7472: {"AegisName":"Cookbook01"},
7473: {"AegisName":"Cookbook02"},
7474: {"AegisName":"Cookbook03"},
7475: {"AegisName":"Cookbook04"},
7476: {"AegisName":"Cookbook05"},
7477: {"AegisName":"Cookbook06"},
7478: {"AegisName":"Cookbook07"},
7479: {"AegisName":"Cookbook08"},
7480: {"AegisName":"Cookbook09"},
7481: {"AegisName":"Cookbook10"},
7482: {"AegisName":"Pot"},
7483: {"AegisName":"Key_Of_Seal"},
7484: {"AegisName":"Warrior_Symbol"},
7485: {"AegisName":"2nd_Floor_Pass"},
7486: {"AegisName":"3rd_Floor_Pass"},
7487: {"AegisName":"Tavern_Wine"},
7488: {"AegisName":"Delivery_Box"},
7489: {"AegisName":"Villa_Spare_Key"},
7490: {"AegisName":"Kyll_Hire_Letter"},
7491: {"AegisName":"Iron_Box"},
7492: {"AegisName":"Yellow_Key_Card"},
7493: {"AegisName":"Golden_Key"},
7494: {"AegisName":"Kiel_Button"},
7495: {"AegisName":"Blue_Key_Card"},
7496: {"AegisName":"Red_Key_Card"},
7497: {"AegisName":"Steel_Piece"},
7498: {"AegisName":"Rosimier_Key"},
7499: {"AegisName":"Family_Portrait"},
7500: {"AegisName":"Elysia_Portrait"},
7501: {"AegisName":"Kyll_Hire_Letter2"},
7502: {"AegisName":"Piece_Memo_Of_James"},
7503: {"AegisName":"Man_Portrait"},
7504: {"AegisName":"Toy_Motor"},
7505: {"AegisName":"Toy_Key"},
7506: {"AegisName":"Black_Key_Card"},
7507: {"AegisName":"Sturdy_Iron_Piece"},
7508: {"AegisName":"Elysia_Ring"},
7509: {"AegisName":"Fancy_Key_Card"},
7510: {"AegisName":"Valhalla_Flower"},
7511: {"AegisName":"Rune_Of_Darkness"},
7512: {"AegisName":"Burnt_Parts"},
7513: {"AegisName":"Pocket_Watch"},
7514: {"AegisName":"Monster_Ticket"},
7515: {"AegisName":"Marvelous_Medal"},
7516: {"AegisName":"Green_Key_Card"},
7517: {"AegisName":"Gold_Coin_"},
7518: {"AegisName":"Women's_Medal"},
7519: {"AegisName":"Money_Envelope"},
7520: {"AegisName":"Chinese_Scroll"},
7521: {"AegisName":"Flame_Stone"},
7522: {"AegisName":"Ice_Stone"},
7523: {"AegisName":"Wind_Stone"},
7524: {"AegisName":"Shadow_Orb"},
7525: {"AegisName":"Summer_Feast_Ticket"},
7526: {"AegisName":"Manuscript_Paper"},
7527: {"AegisName":"Life_Book"},
7528: {"AegisName":"Id_Lottery_Ticket"},
7529: {"AegisName":"Stolen_Sandals"},
7530: {"AegisName":"Travel_Brochure_01"},
7531: {"AegisName":"Travel_Brochure_02"},
7532: {"AegisName":"Travel_Brochure_03"},
7533: {"AegisName":"Travel_Brochure_04"},
7534: {"AegisName":"Photo_Album_01"},
7535: {"AegisName":"Photo_Album_02"},
7536: {"AegisName":"Photo_Album_03"},
7537: {"AegisName":"Photo_Album_04"},
7538: {"AegisName":"Sifted_Sand"},
7539: {"AegisName":"Poring_Coin"},
7540: {"AegisName":"Lotto39"},
7541: {"AegisName":"Lotto40"},
7542: {"AegisName":"Lotto41"},
7543: {"AegisName":"Lotto42"},
7544: {"AegisName":"Lotto43"},
7545: {"AegisName":"Lotto44"},
7546: {"AegisName":"Lotto45"},
7547: {"AegisName":"Soccer_Ball"},
7548: {"AegisName":"Soccer_Shoes"},
7549: {"AegisName":"Brazilian_Flag"},
7550: {"AegisName":"Ticket01"},
7551: {"AegisName":"Ticket02"},
7552: {"AegisName":"Ticket03"},
7553: {"AegisName":"Lotus_Flower"},
7554: {"AegisName":"Striped_Candle"},
7555: {"AegisName":"Green_Incense"},
7556: {"AegisName":"Longing_Heart"},
7557: {"AegisName":"Invitation_Letter"},
7558: {"AegisName":"Invitation_Ticket"},
7559: {"AegisName":"Key_Of_Flower_Garden"},
7560: {"AegisName":"Longing_Heart2"},
7561: {"AegisName":"Ice_Heart"},
7562: {"AegisName":"Ice_Scale"},
7563: {"AegisName":"Bloody_Rune"},
7564: {"AegisName":"Rotten_Meat"},
7565: {"AegisName":"Sticky_Poison"},
7566: {"AegisName":"Will_Of_Darkness_"},
7567: {"AegisName":"Suspicious_Hat"},
7568: {"AegisName":"White_Mask"},
7569: {"AegisName":"Hammer_Of_Wind"},
7570: {"AegisName":"Temple_Lottery_Ticket"},
7571: {"AegisName":"Diary_Of_Blue"},
7572: {"AegisName":"Magic_Necklace"},
7573: {"AegisName":"Magic_Necklace_"},
7574: {"AegisName":"Ice_Particle"},
7575: {"AegisName":"Red_Jewel_"},
7576: {"AegisName":"Blue_Jewel_"},
7577: {"AegisName":"Golden_Jewel_"},
7578: {"AegisName":"Anti_Spell_Bead"},
7579: {"AegisName":"Silk_Handkerchief"},
7580: {"AegisName":"Black_Bead"},
7581: {"AegisName":"Anniversary_Ticket"},
7582: {"AegisName":"Gem_Of_Ruin"},
7583: {"AegisName":"Evil_Mind"},
7584: {"AegisName":"Proof_Of_Guard1"},
7585: {"AegisName":"Proof_Of_Guard2"},
7586: {"AegisName":"Proof_Of_Guard3"},
7587: {"AegisName":"Proof_Of_Guard4"},
7588: {"AegisName":"IPOD_Ticker"},
7589: {"AegisName":"Moon_Cake10"},
7590: {"AegisName":"Moon_Cake11"},
7591: {"AegisName":"Moon_Cake12"},
7592: {"AegisName":"Moon_Cake13"},
7593: {"AegisName":"Moon_Cake14"},
7594: {"AegisName":"Sonia's_Letter"},
7595: {"AegisName":"Unique_Sword"},
7596: {"AegisName":"Unique_Shield"},
7597: {"AegisName":"Magic_Stone"},
7598: {"AegisName":"BlueCard_I"},
7599: {"AegisName":"BlueCard_D"},
7600: {"AegisName":"BlueCard_K"},
7601: {"AegisName":"BlueCard_S"},
7602: {"AegisName":"BlueCard_R"},
7603: {"AegisName":"RO_Party_Ticket"},
7604: {"AegisName":"Flour"},
7605: {"AegisName":"Chicken_Egg"},
7606: {"AegisName":"Coin"},
7607: {"AegisName":"Evil_Dragon_Head"},
7608: {"AegisName":"Premium_Ticket"},
7609: {"AegisName":"Pumpkin_Mojo"},
7610: {"AegisName":"Food_Ticket"},
7611: {"AegisName":"Fox_Symbol"},
7612: {"AegisName":"Heart_Of_Fox_Queen"},
7613: {"AegisName":"Small_Rice_Dough"},
7614: {"AegisName":"Special_Packing_Paper"},
7615: {"AegisName":"MVP_Ticket"},
7616: {"AegisName":"Mini_Boss_Ticket"},
7617: {"AegisName":"Monster_Ticket_"},
7618: {"AegisName":"Monster_Crystal"},
7619: {"AegisName":"Enriched_Elunium"},
7620: {"AegisName":"Enriched_Oridecon"},
7621: {"AegisName":"Token_Of_Siegfried"},
7622: {"AegisName":"New_Style_Coupon"},
7623: {"AegisName":"Name_Change_Coupon"},
7624: {"AegisName":"Spring_Stanza23"},
7625: {"AegisName":"Registration_Ticket"},
7626: {"AegisName":"Bubble_Gum_Token"},
7627: {"AegisName":"Sage_Key"},
7628: {"AegisName":"Idiot_Key"},
7629: {"AegisName":"Pink_Gift_Box"},
7630: {"AegisName":"Clean_Beach_Brush"},
7631: {"AegisName":"Trash_Debris"},
7632: {"AegisName":"To_Afterworld_Record"},
7633: {"AegisName":"To_Heaven_Record"},
7634: {"AegisName":"Rose_Of_Father"},
7635: {"AegisName":"Perfume_Pouch"},
7636: {"AegisName":"Magic_Potion_Bottle"},
7637: {"AegisName":"Father_Giftbox"},
7638: {"AegisName":"Tw_Green_Box"},
7639: {"AegisName":"Tw_Red_Box"},
7640: {"AegisName":"Butterfly_Hair_Clip"},
7641: {"AegisName":"Cure_Box"},
7642: {"AegisName":"Bloody_Coin"},
7643: {"AegisName":"Bloody_Letter"},
7644: {"AegisName":"Unsent_Mail"},
7646: {"AegisName":"RO_Luk_Bookmark"},
7647: {"AegisName":"Taiwan_Luk_Coin"},
7648: {"AegisName":"Snake_Bookmark"},
7649: {"AegisName":"Big_Luk_Bookmark"},
7651: {"AegisName":"Mystery_Egg"},
7663: {"AegisName":"Full_Metal_Jacket"},
7664: {"AegisName":"Shooting_Mine"},
7665: {"AegisName":"Dragon_Tail_Missile"},
7666: {"AegisName":"TimeTravel_Scroll"},
7667: {"AegisName":"Abandoned_Machine"},
7668: {"AegisName":"Clean_Bandage"},
7669: {"AegisName":"Rubbing_Alchohol"},
7670: {"AegisName":"Sour_Grass"},
7671: {"AegisName":"187_Firstaid_Kit"},
7672: {"AegisName":"Relief_Food"},
7674: {"AegisName":"Mysterious_Ingredient"},
7675: {"AegisName":"Mysterious_Doll"},
7676: {"AegisName":"Transmission_Coupon"},
7679: {"AegisName":"Oneclick_Weapon_7UP"},
7680: {"AegisName":"Oneclick_Weapon9UP"},
7681: {"AegisName":"Oneclick_Armor_7UP"},
7682: {"AegisName":"Oneclick_Armor_9UP"},
7685: {"AegisName":"Sour_Melon"},
7690: {"AegisName":"Special_Tiket"},
7701: {"AegisName":"Dragon_Spirit"},
7702: {"AegisName":"Special_Cogwheel"},
7703: {"AegisName":"Piece_Of_Cogwheel"},
7704: {"AegisName":"Broken_Thermometer"},
7705: {"AegisName":"Note_Of_Geologist"},
7706: {"AegisName":"Spoiled_Carrot_Juice"},
7707: {"AegisName":"Spoiled_Banana_Juice"},
7708: {"AegisName":"Spoiled_Apple_Juice"},
7709: {"AegisName":"Spoiled_Grape_Juice"},
7710: {"AegisName":"Black_Gemstone"},
7711: {"AegisName":"Update_Ticket"},
7712: {"AegisName":"Nokia5500"},
7713: {"AegisName":"BlueCard_A_"},
7714: {"AegisName":"BlueCard_R_"},
7715: {"AegisName":"Handmade_Choco_Recipe"},
7716: {"AegisName":"Strawberry_Choco_Recipe"},
7717: {"AegisName":"Choco_Tart_Recipe"},
7718: {"AegisName":"Cacao_Bean"},
7719: {"AegisName":"BlueCard_G"},
7720: {"AegisName":"Gold_Coin_US"},
7721: {"AegisName":"Treasure_Box_"},
7722: {"AegisName":"Debt_Note"},
7723: {"AegisName":"Diamond_Of_Ruin"},
7724: {"AegisName":"Forbidden_Secret_Art"},
7725: {"AegisName":"Unlucky_Emerald"},
7726: {"AegisName":"Token_Of_King"},
7727: {"AegisName":"HP_Doctor_Ticket"},
7728: {"AegisName":"SP_Doctor_Ticket"},
7729: {"AegisName":"Rok_Star_Badge"},
7730: {"AegisName":"Mission_Certificate1"},
7731: {"AegisName":"Mission_Certificate2"},
7732: {"AegisName":"Mission_Certificate3"},
7733: {"AegisName":"Mission_Certificate4"},
7734: {"AegisName":"Mission_Certificate5"},
7735: {"AegisName":"Mission_Certificate6"},
7736: {"AegisName":"Mission_Certificate7"},
7737: {"AegisName":"Mission_Certificate8"},
7738: {"AegisName":"Mission_Certificate9"},
7739: {"AegisName":"Mission_Certificate10"},
7740: {"AegisName":"Mission_Certificate11"},
7741: {"AegisName":"Mission_Certificate12"},
7742: {"AegisName":"Kaong"},
7743: {"AegisName":"Gulaman"},
7744: {"AegisName":"Leche_Flan"},
7745: {"AegisName":"Ube_Jam"},
7746: {"AegisName":"Sago"},
7747: {"AegisName":"Langka"},
7748: {"AegisName":"Sweet_Bean"},
7749: {"AegisName":"Sweet_Banana"},
7750: {"AegisName":"Macapuno"},
7751: {"AegisName":"Old_White_Cloth"},
7752: {"AegisName":"Clattering_Skull"},
7753: {"AegisName":"Broken_Farming_Utensil"},
7754: {"AegisName":"Broken_Crown"},
7755: {"AegisName":"Research_Note"},
7756: {"AegisName":"Sealed_Book"},
7757: {"AegisName":"Mithril"},
7758: {"AegisName":"Star_Crystal"},
7759: {"AegisName":"Geology_Report"},
7760: {"AegisName":"Yaga_Magic_Book"},
7761: {"AegisName":"Magic_Gourd_Bottle"},
7762: {"AegisName":"Yaga_Pestle"},
7763: {"AegisName":"Sticky_Herb"},
7764: {"AegisName":"High_Strength_Adhesive"},
7765: {"AegisName":"Yaga_Secret_Medicine"},
7766: {"AegisName":"Bok_Choy"},
7767: {"AegisName":"Chung_E_Cake"},
7768: {"AegisName":"Squid"},
7769: {"AegisName":"Egg_Yolk"},
7770: {"AegisName":"Sweet_Rice"},
7771: {"AegisName":"Lotus_Leaf"},
7772: {"AegisName":"String"},
7773: {"AegisName":"War_Badge"},
7774: {"AegisName":"Chung_E_Ticket"},
7775: {"AegisName":"Spring_Rabbit_Ticket"},
7776: {"AegisName":"Max_Weight_Up_Scroll"},
7777: {"AegisName":"Gold_Box"},
7778: {"AegisName":"Silver_Box"},
7779: {"AegisName":"Gold_Key_TW"},
7780: {"AegisName":"Silver_Key"},
7781: {"AegisName":"Heart_Box"},
7782: {"AegisName":"Gold_Key77"},
7783: {"AegisName":"Silver_Key77"},
7784: {"AegisName":"Fawner_Coupon1"},
7785: {"AegisName":"Fawner_Coupon2"},
7786: {"AegisName":"Fawner_Coupon3"},
7787: {"AegisName":"Fawner_Coupon4"},
7788: {"AegisName":"Fawner_Coupon5"},
7789: {"AegisName":"Fawner_Coupon6"},
7790: {"AegisName":"Fawner_Coupon7"},
7791: {"AegisName":"Fawner_Coupon8"},
7792: {"AegisName":"Guyak"},
7793: {"AegisName":"Golden_Apple"},
7794: {"AegisName":"Fate_Of_Crow"},
7795: {"AegisName":"Mami_Photo_Album"},
7796: {"AegisName":"Author_Autograph"},
7797: {"AegisName":"Author_Memo"},
7798: {"AegisName":"Dark_Debris"},
7799: {"AegisName":"Dark_Crystal"},
7800: {"AegisName":"Golden_Apple_"},
7801: {"AegisName":"Girl_Fan_Letter"},
7802: {"AegisName":"Autograph_Book"},
7803: {"AegisName":"Battle_Manual_TW"},
7804: {"AegisName":"Octopig_Tentacle"},
7805: {"AegisName":"Brown_Ring"},
7806: {"AegisName":"Black_Anvil"},
7807: {"AegisName":"Ore"},
7808: {"AegisName":"Gold_Hammer"},
7809: {"AegisName":"Gold_Furnace"},
7810: {"AegisName":"Yellow_Cat_Eyed_Stone"},
7811: {"AegisName":"Gold_Anvil"},
7812: {"AegisName":"Red_Cat_Eyed_Stone"},
7813: {"AegisName":"Th_Red_Ring"},
7814: {"AegisName":"Green_Ring"},
7815: {"AegisName":"Blue_Ring"},
7816: {"AegisName":"Blue_Cat_Eyed_Stone"},
7817: {"AegisName":"White_Cat_Eyed_Stone"},
7818: {"AegisName":"RJC_Golden_Necklace"},
7819: {"AegisName":"Nokia5300"},
7820: {"AegisName":"Morroc_Skin"},
7821: {"AegisName":"Green_Apple"},
7822: {"AegisName":"Whole_Barbecue"},
7823: {"AegisName":"Meat_Veg_Skewer"},
7824: {"AegisName":"Spirit_Liquor"},
7825: {"AegisName":"Heroic_Stone"},
7826: {"AegisName":"Continental_Guard_Paper"},
7827: {"AegisName":"Mineral_Report"},
7828: {"AegisName":"BF_Badge1"},
7829: {"AegisName":"BF_Badge2"},
7830: {"AegisName":"Goddess_Tear"},
7831: {"AegisName":"Valkyrie_Token"},
7832: {"AegisName":"Brynhild_Armor_Piece"},
7833: {"AegisName":"Hero_Remains"},
7834: {"AegisName":"Andvari_Ring"},
7835: {"AegisName":"Dusk_Glow"},
7836: {"AegisName":"Dawn_Essence"},
7837: {"AegisName":"Cold_Moonlight"},
7838: {"AegisName":"Hazy_Starlight"},
7839: {"AegisName":"Crystal_Key"},
7840: {"AegisName":"Valkyrie_Gift"},
7841: {"AegisName":"Spotted_Paper"},
7842: {"AegisName":"Torn_Paper"},
7843: {"AegisName":"Old_Paper"},
7844: {"AegisName":"Burnt_Paper"},
7845: {"AegisName":"Copy_Of_Spotted_Paper"},
7846: {"AegisName":"Copy_Of_Torn_Paper"},
7847: {"AegisName":"Copy_Of_Old_Paper"},
7848: {"AegisName":"Copy_Of_Burnt_Paper"},
7849: {"AegisName":"Soul_Crystal"},
7850: {"AegisName":"Wooden_Block_"},
7851: {"AegisName":"Pass_F1"},
7852: {"AegisName":"Pass_F2"},
7853: {"AegisName":"Pass_F3"},
7854: {"AegisName":"Pass_CF"},
7855: {"AegisName":"Heart"},
7856: {"AegisName":"GuillotineC_Pack_Item_2"},
7857: {"AegisName":"Handmade_Kitty_Doll"},
7858: {"AegisName":"Dragonball_Yellow_"},
7859: {"AegisName":"Game_Ticket"},
7860: {"AegisName":"Peeps"},
7861: {"AegisName":"Jelly_Bean"},
7862: {"AegisName":"Marshmallow"},
7863: {"AegisName":"GOLD_ID4"},
7864: {"AegisName":"Love_Flower"},
7865: {"AegisName":"Gold_Pouch"},
7866: {"AegisName":"Certificate"},
7867: {"AegisName":"SesamePouch"},
7868: {"AegisName":"Water"},
7869: {"AegisName":"RicePouch"},
7870: {"AegisName":"Corn"},
7871: {"AegisName":"BeanPouch"},
7872: {"AegisName":"Grass"},
7873: {"AegisName":"MVP_Monster_Scroll"},
7874: {"AegisName":"Monster_Scroll"},
7875: {"AegisName":"Pirate_Box"},
7876: {"AegisName":"Gold_Key"},
7877: {"AegisName":"Red_Ring"},
7878: {"AegisName":"Lusalka_Hair"},
7879: {"AegisName":"Golden_Thread"},
7880: {"AegisName":"Babayaga_Silver_Spoon"},
7881: {"AegisName":"Book_Of_Magic"},
7882: {"AegisName":"Pointed_Branch"},
7883: {"AegisName":"Pointed_Wooden_Flute"},
7884: {"AegisName":"Jade_Plate"},
7885: {"AegisName":"Sacred_Arrow"},
7886: {"AegisName":"Bean_Paste"},
7887: {"AegisName":"Dried_Fruit_Box"},
7888: {"AegisName":"Bag_Of_Nuts"},
7889: {"AegisName":"Chicken_Feed"},
7891: {"AegisName":"Mug"},
7892: {"AegisName":"Charcoal"},
7893: {"AegisName":"Sulfur"},
7894: {"AegisName":"Nitrate"},
7895: {"AegisName":"TRO_Memory_Book01"},
7896: {"AegisName":"TRO_Memory_Book02"},
7897: {"AegisName":"TRO_Memory_Book03"},
7898: {"AegisName":"VVS_Balmung"},
7899: {"AegisName":"Spiritualist_Dagger"},
7900: {"AegisName":"Jenoss_Ring1"},
7901: {"AegisName":"Jenoss_Ring2"},
7902: {"AegisName":"Jenoss_Ring3"},
7903: {"AegisName":"Jenoss_Ring4"},
7904: {"AegisName":"Piano_Key"},
7905: {"AegisName":"Rok_Star_Badge_"},
7906: {"AegisName":"Poppy_Wreath"},
7907: {"AegisName":"Bobbin_Of_Goddess"},
7908: {"AegisName":"Louis_Hair_Coupon"},
7909: {"AegisName":"Stolen_Cookie"},
7910: {"AegisName":"Stolen_Candy"},
7911: {"AegisName":"Yulia_Hat"},
7912: {"AegisName":"Portable_Snowman"},
7913: {"AegisName":"Test_Certificate"},
7914: {"AegisName":"Ancient_Document_TW"},
7915: {"AegisName":"Copper_Coin_"},
7916: {"AegisName":"Silver_Coin_"},
7917: {"AegisName":"Magic_Potion"},
7918: {"AegisName":"Particle_Of_Memory"},
7919: {"AegisName":"Festival_Ticket"},
7920: {"AegisName":"Hero's_Arsenal"},
7921: {"AegisName":"Essence_Of_Dragon"},
7922: {"AegisName":"RWC_Ticket"},
7923: {"AegisName":"KRATHONG_"},
7924: {"AegisName":"Special_Ticket_Lv170"},
7925: {"AegisName":"M_Dimension_Essence"},
7926: {"AegisName":"Break_Box_CN"},
7927: {"AegisName":"Old_Box_CN"},
7928: {"AegisName":"Brazilian_Flag_"},
7929: {"AegisName":"Golden_Coin_"},
7930: {"AegisName":"Cowking's_Nose_Ring"},
7931: {"AegisName":"Poison_Kit"},
7932: {"AegisName":"Poison_Herb_Nerium"},
7933: {"AegisName":"Poison_Herb_Rantana"},
7934: {"AegisName":"Poison_Herb_Makulata"},
7935: {"AegisName":"Poison_Herb_Seratum"},
7936: {"AegisName":"Poison_Herb_Scopolia"},
7937: {"AegisName":"Poison_Herb_Amoena"},
7938: {"AegisName":"Light_Granule"},
7939: {"AegisName":"Elder_Branch"},
7940: {"AegisName":"Special_Alloy_Trap"},
7941: {"AegisName":"Halloween_Ticket"},
7942: {"AegisName":"Letter_From_Chico"},
7943: {"AegisName":"Caskinya"},
7944: {"AegisName":"Box_Of_Seal"},
7945: {"AegisName":"Almighty_Charm"},
7946: {"AegisName":"Valentine_Gold_Ring"},
7947: {"AegisName":"Valentine_Silver_Ring"},
7948: {"AegisName":"Box"},
7949: {"AegisName":"Woven_Wool"},
7950: {"AegisName":"Ayothaya_Ticket"},
7951: {"AegisName":"Gold_Tulip"},
7952: {"AegisName":"Gift_From_Romiros"},
7953: {"AegisName":"Gift_From_Juliedge"},
7954: {"AegisName":"Festival_Ticket_"},
7955: {"AegisName":"Lost_Card1"},
7956: {"AegisName":"Lost_Card2"},
7957: {"AegisName":"Lost_Card3"},
7958: {"AegisName":"Lost_Card4"},
7959: {"AegisName":"Ancient_Gold_Coin"},
7960: {"AegisName":"Ancient_Silver_Coin"},
7961: {"AegisName":"Weapon_Exchange"},
7962: {"AegisName":"Treasure_Map1"},
7963: {"AegisName":"Treasure_Map2"},
7964: {"AegisName":"Treasure_Map3"},
7965: {"AegisName":"Treasure_Map4"},
7966: {"AegisName":"Weird_Parchment1"},
7967: {"AegisName":"Weird_Parchment2"},
7968: {"AegisName":"Weird_Parchment3"},
7969: {"AegisName":"Weird_Parchment4"},
7970: {"AegisName":"Unwritten_Letter1"},
7971: {"AegisName":"Unwritten_Letter2"},
7972: {"AegisName":"Oath_Day_Letter"},
7973: {"AegisName":"Immortality_Egg"},
7974: {"AegisName":"Illusion_Piece"},
7975: {"AegisName":"Cupid_Choco"},
7976: {"AegisName":"Gf_Magic_Coin"},
7977: {"AegisName":"Hunting_Medal_Badge"},
7978: {"AegisName":"Spring_Stanza1"},
7979: {"AegisName":"Spring_Stanza2"},
7980: {"AegisName":"Spring_Stanza3"},
7981: {"AegisName":"Spring_Stanza4"},
7982: {"AegisName":"Spring_Stanza5"},
7983: {"AegisName":"Spring_Stanza6"},
7984: {"AegisName":"Spring_Stanza7"},
7985: {"AegisName":"Spring_Stanza8"},
7986: {"AegisName":"Spring_Stanza9"},
7987: {"AegisName":"Spring_Stanza10"},
7988: {"AegisName":"Spring_Stanza11"},
7989: {"AegisName":"Spring_Stanza12"},
7990: {"AegisName":"Spring_Stanza13"},
7991: {"AegisName":"Spring_Stanza14"},
7992: {"AegisName":"Spring_Stanza15"},
7993: {"AegisName":"Spring_Stanza16"},
7994: {"AegisName":"Spring_Stanza17"},
7995: {"AegisName":"Spring_Stanza18"},
7996: {"AegisName":"Spring_Stanza19"},
7997: {"AegisName":"Spring_Stanza20"},
7998: {"AegisName":"Spring_Stanza21"},
7999: {"AegisName":"Spring_Stanza22"},
9001: {"AegisName":"Poring_Egg"},
9002: {"AegisName":"Drops_Egg"},
9003: {"AegisName":"Poporing_Egg"},
9004: {"AegisName":"Lunatic_Egg"},
9005: {"AegisName":"Picky_Egg"},
9006: {"AegisName":"Chonchon_Egg"},
9007: {"AegisName":"Steel_Chonchon_Egg"},
9008: {"AegisName":"Hunter_Fly_Egg"},
9009: {"AegisName":"Savage_Bebe_Egg"},
9010: {"AegisName":"Baby_Desert_Wolf_Egg"},
9011: {"AegisName":"Rocker_Egg"},
9012: {"AegisName":"Spore_Egg"},
9013: {"AegisName":"Poison_Spore_Egg"},
9014: {"AegisName":"PecoPeco_Egg"},
9015: {"AegisName":"Smokie_Egg"},
9016: {"AegisName":"Yoyo_Egg"},
9017: {"AegisName":"Orc_Warrior_Egg"},
9018: {"AegisName":"Munak_Egg"},
9019: {"AegisName":"Dokkaebi_Egg"},
9020: {"AegisName":"Sohee_Egg"},
9021: {"AegisName":"Isis_Egg"},
9022: {"AegisName":"Green_Petite_Egg"},
9023: {"AegisName":"Deviruchi_Egg"},
9024: {"AegisName":"Bapho_Jr._Egg"},
9025: {"AegisName":"Bongun_Egg"},
9026: {"AegisName":"Zherlthsh_Egg"},
9027: {"AegisName":"Alice_Egg"},
9028: {"AegisName":"Rice_Cake_Egg"},
9029: {"AegisName":"Santa_Goblin_Egg"},
9030: {"AegisName":"Chung_E_Egg"},
9031: {"AegisName":"Spring_Rabbit_Egg"},
9032: {"AegisName":"Knife_Goblin_Egg"},
9033: {"AegisName":"Flail_Goblin_Egg"},
9034: {"AegisName":"Hammer_Goblin_Egg"},
9035: {"AegisName":"Red_Deleter_Egg"},
9036: {"AegisName":"Diabolic_Egg"},
9037: {"AegisName":"Wanderer_Egg"},
9038: {"AegisName":"New_Year_Doll_Egg"},
9039: {"AegisName":"Bacsojin_Egg"},
9040: {"AegisName":"Civil_Servant_Egg"},
9041: {"AegisName":"Leaf_Cat_Egg"},
9042: {"AegisName":"Loli_Ruri_Egg"},
9043: {"AegisName":"Marionette_Egg"},
9044: {"AegisName":"Shinobi_Egg"},
9045: {"AegisName":"Whisper_Egg"},
9046: {"AegisName":"Goblin_Leader_Egg"},
9047: {"AegisName":"Wicked_Nymph_Egg"},
9048: {"AegisName":"Miyabi_Ningyo_Egg"},
9049: {"AegisName":"Dullahan_Egg"},
9050: {"AegisName":"Medusa_Egg"},
9051: {"AegisName":"Stone_Shooter_Egg"},
9052: {"AegisName":"Incubus_Egg"},
9053: {"AegisName":"Golem_Egg"},
9054: {"AegisName":"Nightmare_Terror_Egg"},
9055: {"AegisName":"Succubus_Egg"},
9056: {"AegisName":"Imp_Egg"},
9057: {"AegisName":"Egg_Of_Tiny"},
9058: {"AegisName":"Snow_Rabbit_Egg"},
9059: {"AegisName":"Tikbalang_Pet"},
9060: {"AegisName":"Brownie_Egg"},
9061: {"AegisName":"Marin_Egg"},
9062: {"AegisName":"Novice_Poring_Egg"},
9063: {"AegisName":"Woodie_Egg"},
9064: {"AegisName":"Elephant_Egg"},
9065: {"AegisName":"Gorilla_Egg"},
9066: {"AegisName":"Lion_Egg"},
9067: {"AegisName":"Rhino_Egg"},
9068: {"AegisName":"Blue_Unicorn_Egg"},
9069: {"AegisName":"Mastering_Egg"},
9070: {"AegisName":"Savage_Egg"},
9071: {"AegisName":"Grand_Peco_Egg"},
9072: {"AegisName":"Orc_Hero_Egg"},
9073: {"AegisName":"Orc_Lord_Egg"},
9074: {"AegisName":"Rubylit_Egg"},
9075: {"AegisName":"Sapphilit_Egg"},
9076: {"AegisName":"Emelit_Egg"},
9077: {"AegisName":"Topalit_Egg"},
9078: {"AegisName":"Amelit_Egg"},
9079: {"AegisName":"Mythlit_Egg"},
9080: {"AegisName":"Tamadora_Egg"},
9087: {"AegisName":"High_Orc_Egg"},
9088: {"AegisName":"Angeling_Egg"},
9089: {"AegisName":"Ammut_Egg"},
9090: {"AegisName":"Littleisis_Egg"},
9091: {"AegisName":"Choco_Egg"},
9092: {"AegisName":"Eggring_Egg"},
9093: {"AegisName":"Hyegun_Egg"},
9094: {"AegisName":"Leaf_Lunatic_Egg"},
9095: {"AegisName":"Nine_Tail_Egg"},
9096: {"AegisName":"Cat_O_Nine_Tail_Egg"},
9097: {"AegisName":"Diabolic_Egg2"},
9098: {"AegisName":"Red_Deleter_Egg2"},
9099: {"AegisName":"Teddy_Bear_Egg"},
9100: {"AegisName":"Gremlin_Egg"},
9101: {"AegisName":"Scatletoncarrier"},
9102: {"AegisName":"Mummy_Egg"},
9103: {"AegisName":"Wilow_Egg"},
9104: {"AegisName":"Roween_Egg"},
9105: {"AegisName":"Hodremlin_Egg"},
9106: {"AegisName":"Metaller_Egg"},
9107: {"AegisName":"Ancient_Mummy_Egg"},
9108: {"AegisName":"Xm_Teddybear_Egg"},
9109: {"AegisName":"Sweets_Drops_Egg"},
9111: {"AegisName":"Phreeoni_Egg"},
9112: {"AegisName":"Moonlight_Egg"},
9113: {"AegisName":"Roost_Of_Skelion"},
9114: {"AegisName":"Pouring_Egg"},
9115: {"AegisName":"Bacsojin_Egg2"},
9116: {"AegisName":"Nightmare_TerrorH_EGG"},
9117: {"AegisName":"Wanderer_H_EGG"},
9118: {"AegisName":"Aliot_EGG"},
9119: {"AegisName":"Alicel_EGG"},
9120: {"AegisName":"Aliza_EGG"},
9121: {"AegisName":"Ork_Hero_EGG"},
9122: {"AegisName":"Gloom_Under_Egg"},
9123: {"AegisName":"Ep17_2_C_Admin1_Egg"},
9124: {"AegisName":"Ep17_2_C_Admin2_Egg"},
9125: {"AegisName":"E_Duckling_Egg"},
9126: {"AegisName":"Kiel_Egg"},
9128: {"AegisName":"Dark_Priest_Egg"},
9129: {"AegisName":"Desert_Wolf_Egg"},
9130: {"AegisName":"Chaos_Bapho_Jr_Egg"},
9131: {"AegisName":"Fire_Golem_Egg"},
9132: {"AegisName":"Abyss_Knight_Egg"},
9133: {"AegisName":"Change_W_Knight_Egg"},
9134: {"AegisName":"White_Knight_Egg"},
9137: {"AegisName":"Baphomet_Egg"},
9138: {"AegisName":"Farmiliar_Egg"},
9139: {"AegisName":"Dark_Illusion_Egg"},
9140: {"AegisName":"Blue_Moon_Loli_Ruri_Egg"},
9141: {"AegisName":"Wild_Rose_Egg2"},
9142: {"AegisName":"Eddga_Egg2"},
9144: {"AegisName":"Larva_Violet_Egg"},
9145: {"AegisName":"Copo_Egg"},
9146: {"AegisName":"Grey_Icewind_Egg"},
9147: {"AegisName":"Icewind_Egg"},
9148: {"AegisName":"Dark_Lord_Egg"},
9155: {"AegisName":"aegis_9155"},
9156: {"AegisName":"Sonic_Chao_Egg"},
9157: {"AegisName":"aegis_9157"},
9183: {"AegisName":"CLB_SS_Egg01"},
9184: {"AegisName":"CLB_SS_Egg02"},
9192: {"AegisName":"aegis_9192"},
9193: {"AegisName":"aegis_9193"},
9510: {"AegisName":"Enchant_Stone_Box17"},
9514: {"AegisName":"Ein_Ddbox"},
9515: {"AegisName":"Ein_1HITEMbox"},
9517: {"AegisName":"Ein_UNDIUM"},
9523: {"AegisName":"Metal_Rifine_Ticket"},
9529: {"AegisName":"Ein_Ddbox2"},
9530: {"AegisName":"PC_Costume_Box"},
9539: {"AegisName":"Blue_Potion_B_10"},
9550: {"AegisName":"Gemstone_Of_Time"},
9551: {"AegisName":"Time_Unseal_Key"},
9553: {"AegisName":"C_CatPaw_7Day_Box_"},
9569: {"AegisName":"Festival_Noodle"},
9581: {"AegisName":"Wet_Sealed_Card"},
9582: {"AegisName":"Fancy_Spray_Of_Flowers"},
9585: {"AegisName":"Small_Spray_Of_Flowers"},
9586: {"AegisName":"2019_SStarR_Tbox"},
9587: {"AegisName":"E_Life_Potion_Pack"},
9588: {"AegisName":"E_DEF_Scroll_Box"},
9589: {"AegisName":"E_Almighty_Box"},
9590: {"AegisName":"E_LimitPowerBooster"},
9610: {"AegisName":"E_Mysterious_Water"},
9785: {"AegisName":"Frozen_Box_IL"},
9862: {"AegisName":"Comp_Job_Manual50"},
9894: {"AegisName":"DF_Adrenaline_Scroll"},
9895: {"AegisName":"DF_Abrasive"},
9896: {"AegisName":"DF_Power_Booster"},
9897: {"AegisName":"E_Glittering_Doll_B"},
9908: {"AegisName":"DF_Mental_Potion"},
9909: {"AegisName":"DF_Ex_Def_Potion"},
9932: {"AegisName":"Royal_Secret_Box"},
9933: {"AegisName":"True_Hunting_9Refine"},
9934: {"AegisName":"True_Hunting_Opt_A"},
9935: {"AegisName":"True_Hunting_Opt_B"},
9969: {"AegisName":"Arca_Cura_BR"},
9970: {"AegisName":"Arca_Palito_BR"},
9971: {"AegisName":"Arca_Batalha2_BR"},
9972: {"AegisName":"Arca_Batalha_BR"},
9973: {"AegisName":"Arca_Vida2_BR"},
9974: {"AegisName":"Arca_Vida_BR"},
9975: {"AegisName":"Arca_Divina2_BR"},
9976: {"AegisName":"Arca_Divina_BR"},
9977: {"AegisName":"Arca_Refino2_BR"},
9978: {"AegisName":"Arca_Refino_BR"},
9979: {"AegisName":"Arca_Enriquecido_BR"},
9980: {"AegisName":"Arca_Minerio_BR"},
9981: {"AegisName":"Arca_Pergaminho_BR"},
9982: {"AegisName":"Arca_Especial_BR"},
9983: {"AegisName":"Arca_Celeste2_BR"},
9984: {"AegisName":"Arca_Celeste_BR"},
9985: {"AegisName":"Arca_Status_BR"},
9986: {"AegisName":"Arca_Reset_BR"},
9987: {"AegisName":"Arca_Up2_BR"},
9988: {"AegisName":"Arca_Up_BR"},
9991: {"AegisName":"Boarding_Halter_Box_7d"},
9999: {"AegisName":"Season_Evt_Reward_2"},
10001: {"AegisName":"Skull_Helm"},
10002: {"AegisName":"Monster_Oxygen_Mask"},
10003: {"AegisName":"Transparent_Headgear"},
10004: {"AegisName":"Pacifier"},
10005: {"AegisName":"Wig"},
10006: {"AegisName":"Queen's_Hair_Ornament"},
10007: {"AegisName":"Silk_Ribbon"},
10008: {"AegisName":"Punisher"},
10009: {"AegisName":"Wild_Flower"},
10010: {"AegisName":"Battered_Pot"},
10011: {"AegisName":"Stellar_Hairpin"},
10012: {"AegisName":"Tiny_Egg_Shell"},
10013: {"AegisName":"Backpack"},
10014: {"AegisName":"Rocker_Glasses"},
10015: {"AegisName":"Green_Lace"},
10016: {"AegisName":"Golden_Bell"},
10017: {"AegisName":"Bark_Shorts"},
10018: {"AegisName":"Monkey_Circlet"},
10019: {"AegisName":"Red_Muffler"},
10020: {"AegisName":"Sword_Of_Grave_Keeper"},
10021: {"AegisName":"Round_Hair_Ornament"},
10022: {"AegisName":"Golden_Earing"},
10023: {"AegisName":"Green_Lucky_Bag"},
10024: {"AegisName":"Fashionable_Glasses"},
10025: {"AegisName":"Star_Hairband"},
10026: {"AegisName":"Wine_On_Sleeve"},
10027: {"AegisName":"Spirit_Chain_"},
10028: {"AegisName":"Nice_Badge"},
10029: {"AegisName":"Jade_Trinket"},
10030: {"AegisName":"Summer_Fan"},
10031: {"AegisName":"Death_Coil"},
10032: {"AegisName":"Queen's_Coronet"},
10033: {"AegisName":"Apro_Hair"},
10034: {"AegisName":"Ball_Mask"},
10035: {"AegisName":"Windup_Spring"},
10036: {"AegisName":"Hell_Horn"},
10037: {"AegisName":"Black_Butterfly_Mask"},
10038: {"AegisName":"Horn_Protector"},
10039: {"AegisName":"Tw_Backpack"},
10040: {"AegisName":"Red_Chorker_Bell"},
10041: {"AegisName":"Twinkle_Star_Button"},
10042: {"AegisName":"Dark_Mane"},
10043: {"AegisName":"Ep_17_2_C_Admin1_Acc"},
10044: {"AegisName":"Ep_17_2_C_Admin2_Acc"},
10045: {"AegisName":"C_Twinkle_Star_Button"},
10625: {"AegisName":"Hero_Hammer_Package_5"},
11000: {"AegisName":"Prontera_Book_01"},
11001: {"AegisName":"Adventure_Story01"},
11002: {"AegisName":"Great_Chef_Orleans01"},
11003: {"AegisName":"Legend_Of_Kafra01"},
11004: {"AegisName":"Mercenary_Rebellion"},
11005: {"AegisName":"Tyrant_Schmidt"},
11006: {"AegisName":"Blood_Flower01"},
11007: {"AegisName":"Blood_Flower02"},
11008: {"AegisName":"Barmund"},
11009: {"AegisName":"Adventure_Story02"},
11010: {"AegisName":"Reward_List_Book"},
11011: {"AegisName":"Barmund_Note"},
11012: {"AegisName":"Expedition_Report"},
11013: {"AegisName":"Expedition_Report_Vol1"},
11014: {"AegisName":"Expedition_Report_Vol2"},
11015: {"AegisName":"Expedition_Report_Vol3"},
11016: {"AegisName":"Expedition_Report_Vol4"},
11017: {"AegisName":"Reward_List_Book2"},
11018: {"AegisName":"Splendide_Selling_Item"},
11019: {"AegisName":"Manuk_Selling_Item"},
11020: {"AegisName":"Japan_Book1"},
11021: {"AegisName":"Japan_Book2"},
11022: {"AegisName":"Mix_Cook_Book"},
11023: {"AegisName":"Increase_Stamina_Study"},
11024: {"AegisName":"Vital_Drink_CB"},
11025: {"AegisName":"Swordman_Book_Basic"},
11026: {"AegisName":"Swordman_Book_Practice"},
11027: {"AegisName":"Swrodman_Book_Misc"},
11028: {"AegisName":"Thief_Book_Basic"},
11029: {"AegisName":"Thief_Book_Practice"},
11030: {"AegisName":"Thief_Book_Misc"},
11031: {"AegisName":"Archer_Book_Basic"},
11032: {"AegisName":"Archer_Book_Practice"},
11033: {"AegisName":"Archer_Book_Misc"},
11034: {"AegisName":"Acol_Book_Basic"},
11035: {"AegisName":"Acol_Book_Practice"},
11036: {"AegisName":"Acol_Book_Misc"},
11037: {"AegisName":"Mage_Book_Basic"},
11038: {"AegisName":"Mage_Book_Practice"},
11039: {"AegisName":"Mage_Book_Misc"},
11040: {"AegisName":"Mer_Book_Basic"},
11041: {"AegisName":"Mer_Book_Practice"},
11042: {"AegisName":"Mer_Book_Misc"},
11043: {"AegisName":"TK_Book_Basic"},
11044: {"AegisName":"TK_Book_Practice"},
11045: {"AegisName":"TK_Book_Misc"},
11046: {"AegisName":"Ninja_Book_Basic"},
11047: {"AegisName":"Ninja_Book_Practice"},
11048: {"AegisName":"Ninja_Book_Misc"},
11049: {"AegisName":"Gun_Book_Basic"},
11050: {"AegisName":"Gun_Book_Practice"},
11051: {"AegisName":"Gun_Book_Misc"},
11052: {"AegisName":"SN_Book_Basic"},
11053: {"AegisName":"SN_Book_Practice"},
11054: {"AegisName":"SN_Book_Misc"},
11055: {"AegisName":"Basic_Adventure"},
11056: {"AegisName":"Spiritualism_Guide"},
11057: {"AegisName":"Feb_Sweets"},
11058: {"AegisName":"Novice_Combi_Book"},
11059: {"AegisName":"WoE_TE_Rental_List"},
11060: {"AegisName":"Energy_Xtal_Combi_Book"},
11061: {"AegisName":"EP16List"},
11064: {"AegisName":"Spiritualism_Guide2"},
11500: {"AegisName":"Light_Yellow_Pot"},
11501: {"AegisName":"Light_White_Pot"},
11502: {"AegisName":"Light_Blue_Pot"},
11503: {"AegisName":"Siege_White_Potion"},
11504: {"AegisName":"Siege_Blue_Potion"},
11505: {"AegisName":"Iris"},
11506: {"AegisName":"Fanta_Orange"},
11507: {"AegisName":"Fanta_Grape"},
11508: {"AegisName":"Karada_Meguri_Tea"},
11509: {"AegisName":"Royal_Milk_Tea"},
11510: {"AegisName":"Coke_Zero"},
11511: {"AegisName":"Coke_No_Cal"},
11512: {"AegisName":"Coca_Cola"},
11513: {"AegisName":"Protect_Neck_Candy"},
11514: {"AegisName":"Enriched_Slim_Pot"},
11515: {"AegisName":"Coconut"},
11516: {"AegisName":"Asai_Fruit"},
11517: {"AegisName":"Puri_Potion"},
11518: {"AegisName":"N_Blue_Potion"},
11519: {"AegisName":"Beef_Toast"},
11520: {"AegisName":"Mora_Mandarin"},
11521: {"AegisName":"Pingui_Berry_Juice"},
11522: {"AegisName":"Red_Raffle_Sap"},
11523: {"AegisName":"Yellow_Raffle_Sap"},
11524: {"AegisName":"White_Raffle_Sap"},
11525: {"AegisName":"Mora_Hip_Tea"},
11526: {"AegisName":"Rafflecino"},
11527: {"AegisName":"Baklava"},
11528: {"AegisName":"Kanafeh"},
11529: {"AegisName":"MAAMOUL_"},
11530: {"AegisName":"Jujube"},
11531: {"AegisName":"Coffee"},
11532: {"AegisName":"Nasi_Goreng"},
11533: {"AegisName":"Satay"},
11534: {"AegisName":"Coco_Juice"},
11535: {"AegisName":"Almond_Chocolate"},
11536: {"AegisName":"Cat_Hard_Biscuit"},
11537: {"AegisName":"Rice_weevil_Bug"},
11538: {"AegisName":"Octupus_Leg"},
11539: {"AegisName":"Athale_Choco"},
11540: {"AegisName":"Shyai_Choco"},
11541: {"AegisName":"Mid_Choco"},
11542: {"AegisName":"Zonda_Choco"},
11543: {"AegisName":"Goedo_Choco"},
11544: {"AegisName":"Huike_Choco"},
11545: {"AegisName":"Rune_Choco"},
11546: {"AegisName":"Pope_Choco"},
11547: {"AegisName":"Woe_Violet_Potion"},
11548: {"AegisName":"Woe_White_Potion"},
11549: {"AegisName":"Woe_Blue_Potion"},
11550: {"AegisName":"Pumpkin_Cake"},
11551: {"AegisName":"Savory_Herb_Salad"},
11552: {"AegisName":"Apple_Carrot_Salad"},
11553: {"AegisName":"Casual_Stew"},
11554: {"AegisName":"Golden_Roasted_Apple"},
11555: {"AegisName":"Red_Potion_RG"},
11556: {"AegisName":"Blue_Potion_RG"},
11557: {"AegisName":"TE_White_Potion"},
11558: {"AegisName":"TE_White_Slim_Potion"},
11562: {"AegisName":"Pie_Fruit"},
11563: {"AegisName":"Hot_Tee"},
11564: {"AegisName":"Sweet_Canape"},
11565: {"AegisName":"White_Potion_B"},
11566: {"AegisName":"Yellow_Potion_B"},
11567: {"AegisName":"Novice_Potion_B"},
11568: {"AegisName":"Red_Slim_Potion_B"},
11569: {"AegisName":"Orange_Potion_B"},
11570: {"AegisName":"Red_Potion_B"},
11571: {"AegisName":"Green_Potion_B"},
11572: {"AegisName":"Blue_Potion_B"},
11573: {"AegisName":"White_Slim_Potion_B"},
11574: {"AegisName":"Yellow_Slim_Potion_B"},
11575: {"AegisName":"Lucky_Cookie_B"},
11576: {"AegisName":"Lucky_Candy_Cane_B"},
11577: {"AegisName":"Rice_Ball_B"},
11578: {"AegisName":"Candy_Striper_B"},
11579: {"AegisName":"Lucky_Candy_B"},
11580: {"AegisName":"Candy_B"},
11581: {"AegisName":"Piece_Of_Cake_B"},
11582: {"AegisName":"Well_Baked_Cookie_B"},
11583: {"AegisName":"Chocolate_Drink_B"},
11584: {"AegisName":"White_Chocolate_B"},
11585: {"AegisName":"HandMade_Chocolate_B"},
11586: {"AegisName":"HandMade_Chocolate_B_"},
11587: {"AegisName":"Chocolate_B"},
11588: {"AegisName":"Strawberry_"},
11589: {"AegisName":"Iceflake"},
11590: {"AegisName":"Meat_Skewer5"},
11592: {"AegisName":"Trance_Candy_R"},
11593: {"AegisName":"Trance_Candy_B"},
11594: {"AegisName":"Trance_Candy_Y"},
11595: {"AegisName":"Trance_Candy_G"},
11596: {"AegisName":"Blood_In_Skull"},
11597: {"AegisName":"Iron_Bug"},
11598: {"AegisName":"Bitter_Cacao_Bean"},
11599: {"AegisName":"superstar_potion"},
11600: {"AegisName":"ShiningHolyWater"},
11601: {"AegisName":"Tasty_Anchovy"},
11602: {"AegisName":"Nepeta_Cataria"},
11603: {"AegisName":"Fruit_Of_Mastela_"},
11604: {"AegisName":"Royal_Jelly_"},
11605: {"AegisName":"Cookies_Bat"},
11606: {"AegisName":"Light_White_Pot_"},
11607: {"AegisName":"Crepe"},
11608: {"AegisName":"Chocolate_Egg"},
11609: {"AegisName":"Yummy_Cookie_Egg"},
11610: {"AegisName":"Sweet_Melon"},
11611: {"AegisName":"Pop_Corn"},
11612: {"AegisName":"Aromatic_Pop_Corn"},
11613: {"AegisName":"Harvest_Cookie"},
11614: {"AegisName":"Fresh_Milk"},
11615: {"AegisName":"Sweet_Potato_"},
11616: {"AegisName":"Yummy_Meat"},
11617: {"AegisName":"Silvervine_Choco"},
11620: {"AegisName":"Bearopy"},
11621: {"AegisName":"High_RedPotion"},
11622: {"AegisName":"High_YelloPotion"},
11623: {"AegisName":"High_WhitePotion"},
11624: {"AegisName":"High_BluePotion"},
11625: {"AegisName":"Gourmet_Popcorn"},
11626: {"AegisName":"Kings_Melon_5"},
11627: {"AegisName":"High_Q_Beef_Jerky"},
11628: {"AegisName":"Fleshy_Larva"},
11629: {"AegisName":"Acorn_Chocoball"},
11630: {"AegisName":"Pignic_Lunch"},
11631: {"AegisName":"2401_ev_Rainbow"},
11632: {"AegisName":"2401_ev_Sesamepastry"},
11633: {"AegisName":"2401_ev_WindTteok"},
11634: {"AegisName":"2401_ev_Yugwa"},
11635: {"AegisName":"2401_ev_RedLin"},
11636: {"AegisName":"24_S_Ev_Lime_Soda"},
11637: {"AegisName":"24_S_Ev_Berry_Soda"},
11638: {"AegisName":"24_A_Ev_Choco_C"},
11639: {"AegisName":"24_A_Ev_Egg_C"},
11640: {"AegisName":"E_Deli_BBQ"},
11641: {"AegisName":"E_Leather_Bottle"},
11701: {"AegisName":"Girl_Bunch_Of_Flower"},
11702: {"AegisName":"Moon_Cookie"},
11703: {"AegisName":"Mysterious_Blood"},
11704: {"AegisName":"KETUPAT_F"},
11705: {"AegisName":"Special_White_Potion"},
11706: {"AegisName":"Steak"},
11707: {"AegisName":"Roasted_Beef"},
11708: {"AegisName":"Fore_Flank_Sirloin"},
11709: {"AegisName":"Fanta_Zero_Lemon"},
11710: {"AegisName":"Sakura_Mist"},
11711: {"AegisName":"Sakura_Milk_Tea"},
11712: {"AegisName":"First_Leaf_Tea"},
11713: {"AegisName":"Julia's_Candy"},
12000: {"AegisName":"Cold_Scroll_2_5"},
12001: {"AegisName":"Holy_Scroll_1_3"},
12002: {"AegisName":"Holy_Scroll_1_5"},
12003: {"AegisName":"Holy_Scroll_2_1"},
12004: {"AegisName":"Arrow_Container"},
12005: {"AegisName":"Iron_Arrow_Container"},
12006: {"AegisName":"Steel_Arrow_Container"},
12007: {"AegisName":"Ori_Arrow_Container"},
12008: {"AegisName":"Fire_Arrow_Container"},
12009: {"AegisName":"Silver_Arrow_Container"},
12010: {"AegisName":"Wind_Arrow_Container"},
12011: {"AegisName":"Stone_Arrow_Container"},
12012: {"AegisName":"Crystal_Arrow_Container"},
12013: {"AegisName":"Shadow_Arrow_Container"},
12014: {"AegisName":"Imma_Arrow_Container"},
12015: {"AegisName":"Rusty_Arrow_Container"},
12016: {"AegisName":"Speed_Up_Potion"},
12017: {"AegisName":"Slow_Down_Potion"},
12018: {"AegisName":"Fire_Cracker"},
12019: {"AegisName":"Holy_Egg"},
12020: {"AegisName":"Water_Of_Darkness"},
12021: {"AegisName":"Pork_Belly"},
12022: {"AegisName":"Spareribs"},
12023: {"AegisName":"Giftbox_China"},
12024: {"AegisName":"Red_Pouch_Of_Surprise"},
12025: {"AegisName":"Egg_Boy"},
12026: {"AegisName":"Egg_Girl"},
12027: {"AegisName":"Giggling_Box"},
12028: {"AegisName":"Box_Of_Thunder"},
12029: {"AegisName":"Gloomy_Box"},
12030: {"AegisName":"Box_Of_Grudge"},
12031: {"AegisName":"Sleepy_Box"},
12032: {"AegisName":"Box_Of_Storm"},
12033: {"AegisName":"Box_Of_Sunlight"},
12034: {"AegisName":"Painting_Box"},
12035: {"AegisName":"Lotto_Box01"},
12036: {"AegisName":"Lotto_Box02"},
12037: {"AegisName":"Lotto_Box03"},
12038: {"AegisName":"Lotto_Box04"},
12039: {"AegisName":"Lotto_Box05"},
12040: {"AegisName":"Stone_Of_Intelligence_"},
12041: {"AegisName":"Str_Dish01"},
12042: {"AegisName":"Str_Dish02"},
12043: {"AegisName":"Str_Dish03"},
12044: {"AegisName":"Str_Dish04"},
12045: {"AegisName":"Str_Dish05"},
12046: {"AegisName":"Int_Dish01"},
12047: {"AegisName":"Int_Dish02"},
12048: {"AegisName":"Int_Dish03"},
12049: {"AegisName":"Int_Dish04"},
12050: {"AegisName":"Int_Dish05"},
12051: {"AegisName":"Vit_Dish01"},
12052: {"AegisName":"Vit_Dish02"},
12053: {"AegisName":"Vit_Dish03"},
12054: {"AegisName":"Vit_Dish04"},
12055: {"AegisName":"Vit_Dish05"},
12056: {"AegisName":"Agi_Dish01"},
12057: {"AegisName":"Agi_Dish02"},
12058: {"AegisName":"Agi_Dish03"},
12059: {"AegisName":"Agi_Dish04"},
12060: {"AegisName":"Agi_Dish05"},
12061: {"AegisName":"Dex_Dish01"},
12062: {"AegisName":"Dex_Dish02"},
12063: {"AegisName":"Dex_Dish03"},
12064: {"AegisName":"Dex_Dish04"},
12065: {"AegisName":"Dex_Dish05"},
12066: {"AegisName":"Luk_Dish01"},
12067: {"AegisName":"Luk_Dish02"},
12068: {"AegisName":"Luk_Dish03"},
12069: {"AegisName":"Luk_Dish04"},
12070: {"AegisName":"Luk_Dish05"},
12071: {"AegisName":"Str_Dish06"},
12072: {"AegisName":"Str_Dish07"},
12073: {"AegisName":"Str_Dish08"},
12074: {"AegisName":"Str_Dish09"},
12075: {"AegisName":"Str_Dish10"},
12076: {"AegisName":"Int_Dish06"},
12077: {"AegisName":"Int_Dish07"},
12078: {"AegisName":"Int_Dish08"},
12079: {"AegisName":"Int_Dish09"},
12080: {"AegisName":"Int_Dish10"},
12081: {"AegisName":"Vit_Dish06"},
12082: {"AegisName":"Vit_Dish07"},
12083: {"AegisName":"Vit_Dish08"},
12084: {"AegisName":"Vit_Dish09"},
12085: {"AegisName":"Vit_Dish10"},
12086: {"AegisName":"Agi_Dish06"},
12087: {"AegisName":"Agi_Dish07"},
12088: {"AegisName":"Agi_Dish08"},
12089: {"AegisName":"Agi_Dish09"},
12090: {"AegisName":"Agi_Dish10"},
12091: {"AegisName":"Dex_Dish06"},
12092: {"AegisName":"Dex_Dish07"},
12093: {"AegisName":"Dex_Dish08"},
12094: {"AegisName":"Dex_Dish09"},
12095: {"AegisName":"Dex_Dish10"},
12096: {"AegisName":"Luk_Dish06"},
12097: {"AegisName":"Luk_Dish07"},
12098: {"AegisName":"Luk_Dish08"},
12099: {"AegisName":"Luk_Dish09"},
12100: {"AegisName":"Luk_Dish10"},
12101: {"AegisName":"Citron"},
12102: {"AegisName":"Meat_Skewer"},
12103: {"AegisName":"Bloody_Dead_Branch"},
12104: {"AegisName":"Random_Quiver"},
12105: {"AegisName":"Set_Of_Taiming_Item"},
12106: {"AegisName":"Accessory_Box"},
12107: {"AegisName":"Wrapped_Mask"},
12108: {"AegisName":"Bundle_Of_Magic_Scroll"},
12109: {"AegisName":"Poring_Box"},
12110: {"AegisName":"First_Aid_Kit"},
12111: {"AegisName":"Food_Package"},
12112: {"AegisName":"Tropical_Sograt"},
12113: {"AegisName":"Vermilion_The_Beach"},
12114: {"AegisName":"Elemental_Fire"},
12115: {"AegisName":"Elemental_Water"},
12116: {"AegisName":"Elemental_Earth"},
12117: {"AegisName":"Elemental_Wind"},
12118: {"AegisName":"Resist_Fire"},
12119: {"AegisName":"Resist_Water"},
12120: {"AegisName":"Resist_Earth"},
12121: {"AegisName":"Resist_Wind"},
12122: {"AegisName":"Sesame_Pastry"},
12123: {"AegisName":"Honey_Pastry"},
12124: {"AegisName":"Rainbow_Cake"},
12125: {"AegisName":"Outdoor_Cooking_Kits"},
12126: {"AegisName":"Indoor_Cooking_Kits"},
12127: {"AegisName":"High_end_Cooking_Kits"},
12128: {"AegisName":"Imperial_Cooking_Kits"},
12129: {"AegisName":"Fantastic_Cooking_Kits"},
12130: {"AegisName":"Cookie_Bag"},
12131: {"AegisName":"Lucky_Potion"},
12132: {"AegisName":"Red_Bag"},
12133: {"AegisName":"Ice_Cream_"},
12134: {"AegisName":"Red_Envelope"},
12135: {"AegisName":"Green_Ale"},
12136: {"AegisName":"Women's_Bundle"},
12137: {"AegisName":"1st_Stage_Prize"},
12138: {"AegisName":"2nd_Stage_Prize"},
12139: {"AegisName":"3rd_Stage_Prize"},
12140: {"AegisName":"4th_Stage_Prize"},
12141: {"AegisName":"5th_Stage_Prize"},
12142: {"AegisName":"Magic_Book"},
12143: {"AegisName":"Red_Can"},
12144: {"AegisName":"Sphere_Case_Wind"},
12145: {"AegisName":"Sphere_Case_Darkness"},
12146: {"AegisName":"Sphere_Case_Poison"},
12147: {"AegisName":"Sphere_Case_Water"},
12148: {"AegisName":"Sphere_Case_Fire"},
12149: {"AegisName":"Bullet_Case"},
12150: {"AegisName":"Bullet_Case_Blood"},
12151: {"AegisName":"Bullet_Case_Silver"},
12152: {"AegisName":"Special_Box"},
12153: {"AegisName":"Bow_Mercenary_Scroll1"},
12154: {"AegisName":"Bow_Mercenary_Scroll2"},
12155: {"AegisName":"Bow_Mercenary_Scroll3"},
12156: {"AegisName":"Bow_Mercenary_Scroll4"},
12157: {"AegisName":"Bow_Mercenary_Scroll5"},
12158: {"AegisName":"Bow_Mercenary_Scroll6"},
12159: {"AegisName":"Bow_Mercenary_Scroll7"},
12160: {"AegisName":"Bow_Mercenary_Scroll8"},
12161: {"AegisName":"Bow_Mercenary_Scroll9"},
12162: {"AegisName":"Bow_Mercenary_Scroll10"},
12163: {"AegisName":"SwordMercenary_Scroll1"},
12164: {"AegisName":"SwordMercenary_Scroll2"},
12165: {"AegisName":"SwordMercenary_Scroll3"},
12166: {"AegisName":"SwordMercenary_Scroll4"},
12167: {"AegisName":"SwordMercenary_Scroll5"},
12168: {"AegisName":"SwordMercenary_Scroll6"},
12169: {"AegisName":"SwordMercenary_Scroll7"},
12170: {"AegisName":"SwordMercenary_Scroll8"},
12171: {"AegisName":"SwordMercenary_Scroll9"},
12172: {"AegisName":"SwordMercenary_Scroll10"},
12173: {"AegisName":"SpearMercenary_Scroll1"},
12174: {"AegisName":"SpearMercenary_Scroll2"},
12175: {"AegisName":"SpearMercenary_Scroll3"},
12176: {"AegisName":"SpearMercenary_Scroll4"},
12177: {"AegisName":"SpearMercenary_Scroll5"},
12178: {"AegisName":"SpearMercenary_Scroll6"},
12179: {"AegisName":"SpearMercenary_Scroll7"},
12180: {"AegisName":"SpearMercenary_Scroll8"},
12181: {"AegisName":"SpearMercenary_Scroll9"},
12182: {"AegisName":"SpearMercenary_Scroll10"},
12183: {"AegisName":"Holy_Arrow_Quiver"},
12184: {"AegisName":"Mercenary_Red_Potion"},
12185: {"AegisName":"Mercenary_Blue_Potion"},
12186: {"AegisName":"Red_Box"},
12187: {"AegisName":"Green_Box"},
12188: {"AegisName":"Magical_Moon_Cake"},
12189: {"AegisName":"Red_Box_"},
12190: {"AegisName":"Moon_Cake"},
12191: {"AegisName":"Special_Moon_Cake"},
12192: {"AegisName":"Pumpkin_Pie"},
12193: {"AegisName":"Brezel"},
12194: {"AegisName":"Hometown_Gift"},
12195: {"AegisName":"Plain_Rice_Cake"},
12196: {"AegisName":"Hearty_Rice_Cake"},
12197: {"AegisName":"Salty_Rice_Cake"},
12198: {"AegisName":"Lucky_Rice_Cake"},
12199: {"AegisName":"Rice_Scroll"},
12200: {"AegisName":"Event_Cake"},
12201: {"AegisName":"Red_Box_C"},
12202: {"AegisName":"Str_Dish10_"},
12203: {"AegisName":"Agi_Dish10_"},
12204: {"AegisName":"Int_Dish10_"},
12205: {"AegisName":"Dex_Dish10_"},
12206: {"AegisName":"Luk_Dish10_"},
12207: {"AegisName":"Vit_Dish10_"},
12208: {"AegisName":"Battle_Manual"},
12209: {"AegisName":"Insurance"},
12210: {"AegisName":"Bubble_Gum"},
12211: {"AegisName":"Kafra_Card"},
12212: {"AegisName":"Giant_Fly_Wing"},
12213: {"AegisName":"Neuralizer"},
12214: {"AegisName":"Convex_Mirror"},
12215: {"AegisName":"Blessing_10_Scroll"},
12216: {"AegisName":"Inc_Agi_10_Scroll"},
12217: {"AegisName":"Aspersio_5_Scroll"},
12218: {"AegisName":"Assumptio_5_Scroll"},
12219: {"AegisName":"Wind_Walk_10_Scroll"},
12220: {"AegisName":"Adrenaline_Scroll"},
12221: {"AegisName":"Megaphone_"},
12223: {"AegisName":"Sweets_Macacake"},
12224: {"AegisName":"Sweets_Sparfait"},
12225: {"AegisName":"Sweet_Candy_Striper"},
12226: {"AegisName":"Examination1"},
12227: {"AegisName":"Examination2"},
12228: {"AegisName":"Examination3"},
12229: {"AegisName":"Examination4"},
12230: {"AegisName":"Examination5"},
12231: {"AegisName":"Examination6"},
12232: {"AegisName":"Gingerbread"},
12233: {"AegisName":"Kvass"},
12234: {"AegisName":"Cacao99"},
12235: {"AegisName":"Strawberry_Choco"},
12236: {"AegisName":"Choco_Tart"},
12237: {"AegisName":"Choco_Lump"},
12238: {"AegisName":"New_Year_Rice_Cake_1"},
12239: {"AegisName":"New_Year_Rice_Cake_2"},
12240: {"AegisName":"Old_Yellow_Box"},
12241: {"AegisName":"M_Center_Potion"},
12242: {"AegisName":"M_Awakening_Potion"},
12243: {"AegisName":"M_Berserk_Potion"},
12244: {"AegisName":"Old_Gift_Box"},
12245: {"AegisName":"Green_Ale_US"},
12246: {"AegisName":"Magic_Card_Album"},
12247: {"AegisName":"Halohalo"},
12248: {"AegisName":"Masquerade_Ball_Box"},
12249: {"AegisName":"Payroll_Of_Kafra_"},
12250: {"AegisName":"Str_Dish10_M"},
12251: {"AegisName":"Agi_Dish10_M"},
12252: {"AegisName":"Int_Dish10_M"},
12253: {"AegisName":"Dex_Dish10_M"},
12254: {"AegisName":"Luk_Dish10_M"},
12255: {"AegisName":"Vit_Dish10_M"},
12256: {"AegisName":"PRO_Gift_Box"},
12257: {"AegisName":"Cold_Medicine"},
12258: {"AegisName":"Bombring_Box"},
12259: {"AegisName":"Miracle_Medicine"},
12260: {"AegisName":"Cool_Summer_Outfit"},
12261: {"AegisName":"Secret_Medicine"},
12262: {"AegisName":"Inspector_Certificate_"},
12263: {"AegisName":"Comp_Battle_Manual"},
12264: {"AegisName":"Comp_Bubble_Gum"},
12265: {"AegisName":"Comp_Insurance"},
12266: {"AegisName":"Sesame_Pastry_"},
12267: {"AegisName":"Honey_Pastry_"},
12268: {"AegisName":"Rainbow_Cake_"},
12269: {"AegisName":"Tasty_Colonel"},
12270: {"AegisName":"Tasty_Major"},
12271: {"AegisName":"Mre_A"},
12272: {"AegisName":"Mre_B"},
12273: {"AegisName":"Mre_C"},
12274: {"AegisName":"Gold_Pill_1"},
12275: {"AegisName":"Gold_Pill_2"},
12276: {"AegisName":"Mimic_Scroll"},
12277: {"AegisName":"Disguise_Scroll"},
12278: {"AegisName":"Alice_Scroll"},
12279: {"AegisName":"Undead_Element_Scroll"},
12280: {"AegisName":"Holy_Element_Scroll"},
12281: {"AegisName":"Tresure_Box_WoE"},
12282: {"AegisName":"Internet_Cafe1"},
12283: {"AegisName":"Internet_Cafe2"},
12284: {"AegisName":"Internet_Cafe3"},
12285: {"AegisName":"Internet_Cafe4"},
12286: {"AegisName":"Masquerade_Ball_Box2"},
12287: {"AegisName":"Love_Angel"},
12288: {"AegisName":"Squirrel"},
12289: {"AegisName":"Gogo"},
12290: {"AegisName":"Mysterious_Can"},
12291: {"AegisName":"Mysterious_PET_Bottle"},
12292: {"AegisName":"Unripe_Fruit"},
12293: {"AegisName":"Dried_Yggdrasilberry"},
12294: {"AegisName":"PC_Bang_Coin_Box1"},
12295: {"AegisName":"PC_Bang_Coin_Box2"},
12296: {"AegisName":"PC_Bang_Coin_Box3"},
12297: {"AegisName":"PC_Bang_Coin_Box4"},
12298: {"AegisName":"SP_Potion"},
12299: {"AegisName":"Mega_Resist_Potion"},
12300: {"AegisName":"Wild_Rose_Scroll"},
12301: {"AegisName":"Doppelganger_Scroll"},
12302: {"AegisName":"Ygnizem_Scroll"},
12303: {"AegisName":"Water_Of_Blessing"},
12304: {"AegisName":"Picture_Diary"},
12305: {"AegisName":"Mini_Heart"},
12306: {"AegisName":"Newcomer"},
12307: {"AegisName":"Kid"},
12308: {"AegisName":"Magic_Castle"},
12309: {"AegisName":"Bulging_Head"},
12310: {"AegisName":"Spray_Of_Flowers"},
12311: {"AegisName":"Large_Spray_Of_Flowers"},
12312: {"AegisName":"Thick_Manual50"},
12313: {"AegisName":"Protection_Of_Angel"},
12314: {"AegisName":"Noive_Box"},
12315: {"AegisName":"Goddess_Bless"},
12316: {"AegisName":"Angel_Bless"},
12317: {"AegisName":"Powder_Snow"},
12318: {"AegisName":"Little_Heart"},
12319: {"AegisName":"Strawberry_Cake"},
12320: {"AegisName":"Pineapple_Juice"},
12321: {"AegisName":"Spicy_Sandwich"},
12322: {"AegisName":"Chocolate_Pie"},
12323: {"AegisName":"N_Fly_Wing"},
12324: {"AegisName":"N_Butterfly_Wing"},
12325: {"AegisName":"N_Magnifier"},
12326: {"AegisName":"J_Firecracker"},
12327: {"AegisName":"Charm_Of_Luck"},
12328: {"AegisName":"Charm_Of_Happiness"},
12329: {"AegisName":"Recall_MaleGM"},
12330: {"AegisName":"Recall_FemaleGM"},
12331: {"AegisName":"Ginseng"},
12332: {"AegisName":"Fruit_Juice"},
12333: {"AegisName":"Ansila"},
12334: {"AegisName":"Cherish_Box"},
12335: {"AegisName":"Yummy_Skewered_Dish"},
12336: {"AegisName":"Baked_Mushroom"},
12337: {"AegisName":"Grilled_Sausage"},
12338: {"AegisName":"Grilled_Corn"},
12339: {"AegisName":"Cherish_Box_Ori"},
12340: {"AegisName":"Mysterious_Rice_Powder"},
12341: {"AegisName":"Special_Alloy_Trap_Box"},
12342: {"AegisName":"Manuk's_Opportunity"},
12343: {"AegisName":"Manuk's_Courage"},
12344: {"AegisName":"Pinguicula's_fruit_Jam"},
12345: {"AegisName":"Luciola's_Honey_Jam"},
12346: {"AegisName":"Unripe_Acorn"},
12347: {"AegisName":"Acorn_Jelly"},
12348: {"AegisName":"Manuk's_Faith"},
12349: {"AegisName":"Cornus'_Tears"},
12350: {"AegisName":"Angeling_Potion"},
12351: {"AegisName":"Shout_Megaphone"},
12352: {"AegisName":"Dun_Tele_Scroll3_fr"},
12353: {"AegisName":"Tiny_Waterbottle"},
12354: {"AegisName":"Buche_De_Noel"},
12355: {"AegisName":"Xmas_Gift"},
12356: {"AegisName":"Louise_Costume_Box"},
12357: {"AegisName":"Shiny_Wing_Gown"},
12358: {"AegisName":"Fan_Of_Wind"},
12359: {"AegisName":"Very_Soft_Plant"},
12360: {"AegisName":"Very_Red_Juice"},
12361: {"AegisName":"Delicious_Shaved_Ice"},
12362: {"AegisName":"Kuloren"},
12363: {"AegisName":"Fit_Pipe"},
12364: {"AegisName":"Staff_Of_Leader"},
12365: {"AegisName":"Charming_Lotus"},
12366: {"AegisName":"Gril_Doll"},
12367: {"AegisName":"Luxury_Whisky_Bottle"},
12368: {"AegisName":"Splendid_Mirror"},
12369: {"AegisName":"Oilpalm_Coconut"},
12370: {"AegisName":"Gril's_Naivety"},
12371: {"AegisName":"Magical_Lithography"},
12372: {"AegisName":"Hell_Contract"},
12373: {"AegisName":"Boy's_Naivety"},
12374: {"AegisName":"Flaming_Ice"},
12375: {"AegisName":"Acaraje"},
12376: {"AegisName":"Mysterious_Can2"},
12377: {"AegisName":"Mysterious_PET_Bottle2"},
12378: {"AegisName":"2009_Rice_Cake_Soup"},
12379: {"AegisName":"Pope's_Cookie"},
12380: {"AegisName":"Desert_Wolf_Babe_Scroll"},
12381: {"AegisName":"ValkyrieA_Scroll"},
12382: {"AegisName":"ValkyrieB_Scroll"},
12383: {"AegisName":"Vulcan_Bullet_Magazine"},
12384: {"AegisName":"Rainbow_Ruby_Water"},
12385: {"AegisName":"Rainbow_Ruby_Fire"},
12386: {"AegisName":"Rainbow_Ruby_Wind"},
12387: {"AegisName":"Rainbow_Ruby_Earth"},
12388: {"AegisName":"Runstone_Crush"},
12389: {"AegisName":"Runstone_Storm"},
12390: {"AegisName":"Runstone_Millennium"},
12391: {"AegisName":"Lucky_Egg_C"},
12392: {"AegisName":"RepairA"},
12393: {"AegisName":"RepairB"},
12394: {"AegisName":"RepairC"},
12395: {"AegisName":"Tantanmen"},
12396: {"AegisName":"Fools_Day_Box"},
12397: {"AegisName":"Fools_Day_Box2"},
12398: {"AegisName":"PCBang_Gift_Box"},
12399: {"AegisName":"Castle_Treasure_Box"},
12400: {"AegisName":"Water_Of_Blessing_"},
12401: {"AegisName":"Rune_Kn_Test_Int"},
12402: {"AegisName":"29Fruit"},
12403: {"AegisName":"Lucky_Egg_C2"},
12404: {"AegisName":"Acti_Potion"},
12405: {"AegisName":"Underripe_Yggseed"},
12406: {"AegisName":"Psychic_ArmorS"},
12407: {"AegisName":"PCBang_Coupon_Box"},
12408: {"AegisName":"Leaf_Cat_Ball"},
12409: {"AegisName":"Pork_Belly_H"},
12410: {"AegisName":"Spareribs_H"},
12411: {"AegisName":"HE_Battle_Manual"},
12412: {"AegisName":"HE_Bubble_Gum"},
12413: {"AegisName":"PCBang_Coupon_Box2"},
12414: {"AegisName":"Guarana_Candy"},
12415: {"AegisName":"Siege_Teleport_Scroll2"},
12416: {"AegisName":"Lucky_Egg_C3"},
12417: {"AegisName":"Boost500"},
12418: {"AegisName":"Full_SwingK"},
12419: {"AegisName":"Mana_Plus"},
12420: {"AegisName":"Stamina_Up_M"},
12421: {"AegisName":"Digestive_F"},
12422: {"AegisName":"HP_Increase_PotionS"},
12423: {"AegisName":"HP_Increase_PotionM"},
12424: {"AegisName":"HP_Increase_PotionL"},
12425: {"AegisName":"SP_Increase_PotionS"},
12426: {"AegisName":"SP_Increase_PotionM"},
12427: {"AegisName":"SP_Increase_PotionL"},
12428: {"AegisName":"Enrich_White_PotionZ"},
12429: {"AegisName":"Savage_BBQ"},
12430: {"AegisName":"Wug_Blood_Cocktail"},
12431: {"AegisName":"Minor_Brisket"},
12432: {"AegisName":"Siroma_Icetea"},
12433: {"AegisName":"Drocera_Herb_Stew"},
12434: {"AegisName":"Petti_Tail_Noodle"},
12435: {"AegisName":"Black_Thing"},
12436: {"AegisName":"Vitata500"},
12437: {"AegisName":"Enrich_Celermine_Juice"},
12438: {"AegisName":"F_Giant_Fly_Wing"},
12439: {"AegisName":"F_Battle_Manual"},
12440: {"AegisName":"F_Insurance"},
12441: {"AegisName":"F_Bubble_Gum"},
12442: {"AegisName":"F_Kafra_Card"},
12443: {"AegisName":"F_Neuralizer"},
12444: {"AegisName":"F_Dun_Tele_Scroll1"},
12445: {"AegisName":"F_Str_Dish10_"},
12446: {"AegisName":"F_Agi_Dish10_"},
12447: {"AegisName":"F_Int_Dish10_"},
12448: {"AegisName":"F_Dex_Dish10_"},
12449: {"AegisName":"F_Luk_Dish10_"},
12450: {"AegisName":"F_Vit_Dish10_"},
12451: {"AegisName":"F_WOB_Rune"},
12452: {"AegisName":"F_WOB_Schwaltz"},
12453: {"AegisName":"F_WOB_Rachel"},
12454: {"AegisName":"F_WOB_Local"},
12456: {"AegisName":"F_Greed_Scroll"},
12457: {"AegisName":"F_Glass_Of_Illusion"},
12458: {"AegisName":"F_Abrasive"},
12459: {"AegisName":"F_Med_Life_Potion"},
12460: {"AegisName":"F_Small_Life_Potion"},
12461: {"AegisName":"F_Regeneration_Potion"},
12462: {"AegisName":"F_B_Mdef_Potion"},
12463: {"AegisName":"F_S_Mdef_Potion"},
12464: {"AegisName":"F_B_Def_Potion"},
12465: {"AegisName":"F_S_Def_Potion"},
12466: {"AegisName":"F_Blessing_10_Scroll"},
12467: {"AegisName":"F_Inc_Agi_10_Scroll"},
12468: {"AegisName":"F_Aspersio_5_Scroll"},
12470: {"AegisName":"F_Wind_Walk_10_Scroll"},
12471: {"AegisName":"F_Adrenaline_Scroll"},
12472: {"AegisName":"F_Convex_Mirror"},
12473: {"AegisName":"RWC_Parti_Box"},
12474: {"AegisName":"RWC_Final_Comp_Box"},
12475: {"AegisName":"Cure_Free"},
12476: {"AegisName":"PCBang_Coupon_Box3"},
12477: {"AegisName":"Gift_Bundle"},
12478: {"AegisName":"Chance_Box"},
12479: {"AegisName":"Caracas_Ring_Box"},
12480: {"AegisName":"Attend_3Day_Box"},
12481: {"AegisName":"Attend_7Day_Box"},
12482: {"AegisName":"Attend_10Day_Box"},
12483: {"AegisName":"Attend_15Day_Box"},
12484: {"AegisName":"Attend_20Day_Box"},
12485: {"AegisName":"Attend_25Day_Box"},
12486: {"AegisName":"GoldPC_First_Box"},
12487: {"AegisName":"PC_4Leaf_Clover_Box"},
12488: {"AegisName":"Ticket_Gift_Box"},
12489: {"AegisName":"Ticket_Gift_Box2"},
12490: {"AegisName":"Vivid_Notation"},
12491: {"AegisName":"Curious_Snowball"},
12492: {"AegisName":"Crumpled_Paper"},
12493: {"AegisName":"Lucky_Egg_C4"},
12494: {"AegisName":"E_Giant_Fly_Wing"},
12495: {"AegisName":"E_Battle_Manual"},
12496: {"AegisName":"E_Insurance"},
12497: {"AegisName":"E_Bubble_Gum"},
12498: {"AegisName":"E_Kafra_Card"},
12499: {"AegisName":"E_Neuralizer"},
12500: {"AegisName":"E_Dun_Tele_Scroll1"},
12501: {"AegisName":"E_Str_Dish10_"},
12502: {"AegisName":"E_Agi_Dish10_"},
12503: {"AegisName":"E_Int_Dish10_"},
12504: {"AegisName":"E_Dex_Dish10_"},
12505: {"AegisName":"E_Luk_Dish10_"},
12506: {"AegisName":"E_Vit_Dish10_"},
12507: {"AegisName":"E_WOB_Rune"},
12508: {"AegisName":"E_WOB_Schwaltz"},
12509: {"AegisName":"E_WOB_Rachel"},
12510: {"AegisName":"E_WOB_Local"},
12511: {"AegisName":"E_Siege_Teleport_Scroll"},
12512: {"AegisName":"E_Greed_Scroll"},
12513: {"AegisName":"E_Glass_Of_Illusion"},
12514: {"AegisName":"E_Abrasive"},
12515: {"AegisName":"E_Med_Life_Potion"},
12516: {"AegisName":"E_Small_Life_Potion"},
12517: {"AegisName":"E_Regeneration_Potion"},
12518: {"AegisName":"E_B_Mdef_Potion"},
12519: {"AegisName":"E_S_Mdef_Potion"},
12520: {"AegisName":"E_B_Def_Potion"},
12521: {"AegisName":"E_S_Def_Potion"},
12522: {"AegisName":"E_Blessing_10_Scroll"},
12523: {"AegisName":"E_Inc_Agi_10_Scroll"},
12524: {"AegisName":"E_Aspersio_5_Scroll"},
12525: {"AegisName":"E_Assumptio_5_Scroll"},
12526: {"AegisName":"E_Wind_Walk_10_Scroll"},
12527: {"AegisName":"E_Adrenaline_Scroll"},
12528: {"AegisName":"E_Convex_Mirror"},
12529: {"AegisName":"White_Slim_Potion_Box"},
12530: {"AegisName":"Mastela_Fruit_Box"},
12531: {"AegisName":"White_Potion_Box"},
12532: {"AegisName":"Royal_Jelly_Box2"},
12533: {"AegisName":"Blue_Herb_Box2"},
12534: {"AegisName":"Yggdrasil_Seed_Box"},
12535: {"AegisName":"Iggdrasilberry_Box"},
12536: {"AegisName":"NY_Rice_Cake_Soup"},
12537: {"AegisName":"Solo_Gift_Basket"},
12538: {"AegisName":"Couple_Event_Basket"},
12539: {"AegisName":"Splendid_Box"},
12540: {"AegisName":"GM_Warp_Box"},
12541: {"AegisName":"Fortune_Cookie1"},
12542: {"AegisName":"Fortune_Cookie2"},
12543: {"AegisName":"Fortune_Cookie3"},
12544: {"AegisName":"Mystic_Tree_Branch"},
12545: {"AegisName":"Lucky_Egg_C5"},
12546: {"AegisName":"Suspicious_Dish"},
12547: {"AegisName":"Chalcenodny_Box"},
12548: {"AegisName":"Buy_Market_Permit2"},
12549: {"AegisName":"White_Slim_Pot_Box2"},
12550: {"AegisName":"Poison_Bottle_Box2"},
12551: {"AegisName":"MVP_Tele_Scroll"},
12552: {"AegisName":"Quest_Tele_Scroll"},
12553: {"AegisName":"Brysinggamen_Piece_Box"},
12554: {"AegisName":"Asprika_Piece_Box"},
12555: {"AegisName":"Brynhild_Piece_Box"},
12556: {"AegisName":"Sleipnir_Piece_Box"},
12557: {"AegisName":"Mjolnir_Piece_Box"},
12558: {"AegisName":"Magingiorde_Piece_Box"},
12559: {"AegisName":"Tenkaippin_Strong"},
12560: {"AegisName":"Tenkaippin_Clean"},
12561: {"AegisName":"Mysterious_Seed"},
12562: {"AegisName":"Bubble_Gum_Plus"},
12563: {"AegisName":"BM75"},
12564: {"AegisName":"3D_Glasses_Box"},
12565: {"AegisName":"Cheer_Scarf_Box"},
12566: {"AegisName":"Cheer_Scarf2_Box"},
12567: {"AegisName":"Cheer_Scarf3_Box"},
12568: {"AegisName":"Cheer_Scarf4_Box"},
12569: {"AegisName":"Cheer_Scarf6_Box"},
12570: {"AegisName":"Cheer_Scarf8_Box"},
12571: {"AegisName":"Cheer_Scarf10_Box"},
12572: {"AegisName":"Cheer_Scarf10_Box2"},
12573: {"AegisName":"Fruit_Basket"},
12574: {"AegisName":"Mora_Berry"},
12575: {"AegisName":"Arrow_Of_Elf_Cntr"},
12576: {"AegisName":"Hunting_Arrow_Cntr"},
12577: {"AegisName":"Lucky_Egg_C6"},
12578: {"AegisName":"Rapid_Life_Water"},
12579: {"AegisName":"Ring_Of_Valkyrie_Box"},
12580: {"AegisName":"Vending_Search_Scroll"},
12581: {"AegisName":"Vending_Search_Scroll2"},
12582: {"AegisName":"Siege_Supply_Box"},
12583: {"AegisName":"PR_Team_Box"},
12584: {"AegisName":"Develop_Team_box"},
12585: {"AegisName":"Marketing_Team_Box"},
12586: {"AegisName":"Operating_Team_Box"},
12587: {"AegisName":"Summer_Night_box"},
12588: {"AegisName":"Summer_Night_box2"},
12589: {"AegisName":"Summer_Night_box3"},
12591: {"AegisName":"Uni_Catalog_Bz"},
12592: {"AegisName":"Cyclops_Box1"},
12593: {"AegisName":"Cyclops_Box2"},
12594: {"AegisName":"Cyclops_Box3"},
12595: {"AegisName":"Lucky_Egg_C7"},
12596: {"AegisName":"Magic_Candy"},
12597: {"AegisName":"Opor_Ayam"},
12598: {"AegisName":"Dendeng_Balado"},
12599: {"AegisName":"Kurma"},
12600: {"AegisName":"Treasure_Box_Scroll"},
12601: {"AegisName":"Cold_Watermelon_Juice"},
12602: {"AegisName":"Special_Box1"},
12603: {"AegisName":"Special_Box2"},
12604: {"AegisName":"Special_Box3"},
12605: {"AegisName":"Special_Box4"},
12606: {"AegisName":"Special_Box5"},
12607: {"AegisName":"Lolli_Pop_Box"},
12608: {"AegisName":"Splendid_Box2"},
12609: {"AegisName":"Old_Ore_Box"},
12610: {"AegisName":"Mysterious_Egg"},
12612: {"AegisName":"Old_Coin_Pocket"},
12613: {"AegisName":"High_Coin_Pocket"},
12614: {"AegisName":"Mid_Coin_Pocket"},
12615: {"AegisName":"Low_Coin_Pocket"},
12616: {"AegisName":"Sgrade_Pocket"},
12617: {"AegisName":"Agrade_Pocket"},
12618: {"AegisName":"Bgrade_Pocket"},
12619: {"AegisName":"Cgrade_Pocket"},
12620: {"AegisName":"Dgrade_Pocket"},
12621: {"AegisName":"Egrade_Pocket"},
12622: {"AegisName":"Boarding_Halter"},
12623: {"AegisName":"High_Weapon_Box"},
12624: {"AegisName":"Delicious_Jelly"},
12625: {"AegisName":"Sapa_Feat_Cert_Pack"},
12626: {"AegisName":"Wander_Man_Scroll"},
12627: {"AegisName":"Wicked_Nymph_Scroll"},
12628: {"AegisName":"Kasa_Scroll"},
12629: {"AegisName":"Salamander_Scroll"},
12630: {"AegisName":"Teddy_Bear_Scroll"},
12631: {"AegisName":"Macro_Stone_A"},
12632: {"AegisName":"Macro_Stone_B"},
12633: {"AegisName":"Malang_Cat_Can"},
12634: {"AegisName":"Macro_Stone_A1"},
12635: {"AegisName":"Macro_Stone_A2"},
12636: {"AegisName":"Malang_Sp_Can"},
12637: {"AegisName":"Gong_Bug_Pocket"},
12638: {"AegisName":"Dried_Squid_Box"},
12639: {"AegisName":"Flying_Fish_Box"},
12640: {"AegisName":"Starfish_Box"},
12641: {"AegisName":"Lucky_Egg_C8"},
12642: {"AegisName":"Fruit_Of_Mastela_Box2"},
12643: {"AegisName":"E_Coin_Pack50"},
12644: {"AegisName":"PCBang_Coupon_Box4"},
12645: {"AegisName":"J_Aspersio_5_Scroll_C"},
12646: {"AegisName":"Takoyaki"},
12647: {"AegisName":"Ink_Ball"},
12648: {"AegisName":"Special_Potion_Set"},
12649: {"AegisName":"Lv70_Imperial_Gift"},
12650: {"AegisName":"Lv90_Imperial_Gift"},
12651: {"AegisName":"Lv110_Imperial_Gift"},
12652: {"AegisName":"Lv130_Imperial_Gift"},
12653: {"AegisName":"Lv150_Imperial_Gift"},
12654: {"AegisName":"Lucky_Egg_C9"},
12655: {"AegisName":"Brain_Powder"},
12656: {"AegisName":"Magical_Powder"},
12657: {"AegisName":"Madness_Powder"},
12658: {"AegisName":"Trans_Scroll_Devi"},
12659: {"AegisName":"Trans_Scroll_Ray_Arch"},
12660: {"AegisName":"Trans_Scroll_Mavka"},
12661: {"AegisName":"Trans_Scroll_Marduk"},
12662: {"AegisName":"Trans_Scroll_Banshee"},
12663: {"AegisName":"Trans_Scroll_Poring"},
12664: {"AegisName":"Trans_Scroll_Golem"},
12665: {"AegisName":"Grovel_Buff"},
12666: {"AegisName":"Thai_Perfume_MATK"},
12667: {"AegisName":"Thai_Perfume_ATK"},
12668: {"AegisName":"Thai_Perfume_ASPD"},
12669: {"AegisName":"Thai_Perfume_CAST"},
12670: {"AegisName":"Beast_Powder"},
12671: {"AegisName":"99lv_Battle_Manual"},
12672: {"AegisName":"Start_New_Box"},
12673: {"AegisName":"Lucky_Egg_C10"},
12674: {"AegisName":"God_Material_Box"},
12675: {"AegisName":"Sg_Weapon_Supply_Box"},
12676: {"AegisName":"Sg_Violet_Potion_Box"},
12677: {"AegisName":"Siege_Arrow_Quiver_S"},
12678: {"AegisName":"Siege_Arrow_Quiver_A"},
12679: {"AegisName":"Sg_White_Potion_Box"},
12680: {"AegisName":"Sg_Blue_Potion_Box"},
12681: {"AegisName":"Nestea_Lemon"},
12682: {"AegisName":"Nestea_Blacktea"},
12683: {"AegisName":"Sg_Vi_Potion_Box200"},
12684: {"AegisName":"ASPD_Potion"},
12685: {"AegisName":"Gryphon_Egg_Scroll"},
12686: {"AegisName":"Str_Dish20"},
12687: {"AegisName":"Int_Dish20"},
12688: {"AegisName":"Vit_Dish20"},
12689: {"AegisName":"Dex_Dish20"},
12690: {"AegisName":"Old_C_Album_Helm"},
12691: {"AegisName":"Old_C_Album_Armor"},
12692: {"AegisName":"Old_C_Album_Shield"},
12693: {"AegisName":"Old_C_Album_Garment"},
12694: {"AegisName":"Old_C_Album_Shoes"},
12695: {"AegisName":"Old_C_Album_Acc"},
12696: {"AegisName":"RWC_Cele_Fire"},
12697: {"AegisName":"RWC_Cele_Fire2"},
12698: {"AegisName":"Old_C_Album_Weapon"},
12699: {"AegisName":"Tikbalang_Belt"},
12700: {"AegisName":"Insideout_Shirt"},
12701: {"AegisName":"Old_Blue_Box_F"},
12702: {"AegisName":"Old_Bleu_Box"},
12703: {"AegisName":"Holy_Egg_2"},
12704: {"AegisName":"Elixir_Of_Life"},
12705: {"AegisName":"Noble_Nameplate"},
12706: {"AegisName":"Lucky_Cookie01"},
12707: {"AegisName":"Lucky_Cookie02"},
12708: {"AegisName":"Lucky_Cookie03"},
12709: {"AegisName":"Guyak_Candy"},
12710: {"AegisName":"Guyak_Pudding"},
12711: {"AegisName":"Pretzel"},
12712: {"AegisName":"Green_Beer"},
12713: {"AegisName":"Monster_Extract"},
12714: {"AegisName":"Easter_Scroll"},
12715: {"AegisName":"Black_Treasure_Box"},
12716: {"AegisName":"Indian_Rice_Cake"},
12717: {"AegisName":"Poison_Paralysis"},
12718: {"AegisName":"Poison_Leech"},
12719: {"AegisName":"Poison_Oblivion"},
12720: {"AegisName":"Poison_Contamination"},
12721: {"AegisName":"Poison_Numb"},
12722: {"AegisName":"Poison_Fever"},
12723: {"AegisName":"Poison_Laughing"},
12724: {"AegisName":"Poison_Fatigue"},
12725: {"AegisName":"Runstone_Nosiege"},
12726: {"AegisName":"Runstone_Rhydo"},
12727: {"AegisName":"Runstone_Verkana"},
12728: {"AegisName":"Runstone_Isia"},
12729: {"AegisName":"Runstone_Asir"},
12730: {"AegisName":"Runstone_Urj"},
12731: {"AegisName":"Runstone_Turisus"},
12732: {"AegisName":"Runstone_Pertz"},
12733: {"AegisName":"Runstone_Hagalas"},
12734: {"AegisName":"Runstone_Quality"},
12735: {"AegisName":"Runstone_Ancient"},
12736: {"AegisName":"Runstone_Mystic"},
12737: {"AegisName":"Runstone_Ordinary"},
12738: {"AegisName":"Runstone_Rare"},
12739: {"AegisName":"Snow_Flower"},
12740: {"AegisName":"Inc_Str_Scroll"},
12741: {"AegisName":"Inc_Int_Scroll"},
12742: {"AegisName":"Valentine_Gift_Box1"},
12743: {"AegisName":"Valentine_Gift_Box2"},
12744: {"AegisName":"Chocotate_Box"},
12745: {"AegisName":"Skull_Scroll"},
12746: {"AegisName":"Destruction_Scroll"},
12747: {"AegisName":"Royal_Scroll"},
12748: {"AegisName":"Immune_Scroll"},
12749: {"AegisName":"Mystic_Scroll"},
12750: {"AegisName":"Battle_Scroll"},
12751: {"AegisName":"Armor_Scroll"},
12752: {"AegisName":"Prayer_Scroll"},
12753: {"AegisName":"Soul_Scroll"},
12754: {"AegisName":"New_Year_Bun"},
12755: {"AegisName":"Traditional_Firecrack"},
12756: {"AegisName":"New_Gift_Envelope"},
12757: {"AegisName":"Loyal_Ring1_Box"},
12758: {"AegisName":"Loyal_Ring2_Box"},
12759: {"AegisName":"Loyal_Ring3_Box"},
12760: {"AegisName":"Bubble_Gum_Green"},
12761: {"AegisName":"Bubble_Gum_Yellow"},
12762: {"AegisName":"Bubble_Gum_Orange"},
12763: {"AegisName":"Bubble_Gum_Red"},
12764: {"AegisName":"Fools_Day_Box_Tw"},
12765: {"AegisName":"Summer_Knight_Box"},
12766: {"AegisName":"Reward_Job_BM25"},
12767: {"AegisName":"Passion_FB_Hat_Box"},
12768: {"AegisName":"Cool_FB_Hat_Box"},
12769: {"AegisName":"Victory_FB_Hat_Box"},
12770: {"AegisName":"Glory_FB_Hat_Box"},
12771: {"AegisName":"Passion_Hat_Box2"},
12772: {"AegisName":"Cool_Hat_Box2"},
12773: {"AegisName":"Victory_Hat_Box2"},
12774: {"AegisName":"Empty_Potion_Bottle"},
12775: {"AegisName":"Ancient_Spirit_Agimat"},
12776: {"AegisName":"Agi_Dish20"},
12777: {"AegisName":"Luk_Dish20"},
12778: {"AegisName":"Bapho_Jr_Scroll"},
12779: {"AegisName":"Galapago_Scroll"},
12780: {"AegisName":"10M_Zeny_Check"},
12781: {"AegisName":"1M_Zeny_Check"},
12782: {"AegisName":"100T_Zeny_Check"},
12783: {"AegisName":"10000_Zeny_Check"},
12784: {"AegisName":"1000_Zeny_Check"},
12785: {"AegisName":"Dragon_Egg_Scroll"},
12786: {"AegisName":"Change_Slot_Card"},
12787: {"AegisName":"Diabolic_Scroll"},
12788: {"AegisName":"No100_Firecracker"},
12789: {"AegisName":"Juicy_Fruit"},
12790: {"AegisName":"Change_Name_Card"},
12791: {"AegisName":"Combat_Pill"},
12792: {"AegisName":"P_Combat_Pill"},
12793: {"AegisName":"Combat_Pill_Box10"},
12794: {"AegisName":"P_Combat_Pill_Box10"},
12795: {"AegisName":"2011_RWC_Scroll_Kr"},
12796: {"AegisName":"Red_Booster"},
12797: {"AegisName":"Wish_Maiden_Scroll"},
12798: {"AegisName":"Zealotus_Scroll"},
12799: {"AegisName":"PCBang_Coupon_Box5"},
12800: {"AegisName":"Ktullanux_Scroll"},
12801: {"AegisName":"Eddga_Scroll"},
12802: {"AegisName":"Time_Guardian_Box"},
12803: {"AegisName":"Beginner_Kit_Box"},
12804: {"AegisName":"Cru_Scroll"},
12805: {"AegisName":"Mystic_Powder"},
12806: {"AegisName":"Scaraba_Scroll"},
12807: {"AegisName":"Mercenary_Casting_"},
12808: {"AegisName":"Mother_Love_Box"},
12809: {"AegisName":"Level_Up_Box"},
12810: {"AegisName":"Event_Gift_Box"},
12811: {"AegisName":"Event_Gift_Box_"},
12812: {"AegisName":"Snow_Flip"},
12813: {"AegisName":"Peony_Mommy"},
12814: {"AegisName":"Slapping_Herb"},
12815: {"AegisName":"Yggdrasil_Dust"},
12816: {"AegisName":"Old_Ore_Box_"},
12817: {"AegisName":"Old_Card_Album_"},
12818: {"AegisName":"High_Weapon_Box_"},
12819: {"AegisName":"Zherlthsh_Tck_Box_"},
12820: {"AegisName":"Mao_Guai_Scroll"},
12821: {"AegisName":"Loli_Ruri_Scroll"},
12822: {"AegisName":"Songpyun_Box50"},
12823: {"AegisName":"Sedora_Scroll"},
12824: {"AegisName":"Chepet_Scroll"},
12825: {"AegisName":"FlipPackage"},
12826: {"AegisName":"Wind_Type_Scroll"},
12827: {"AegisName":"Water_Type_Scroll"},
12828: {"AegisName":"Fire_Type_Scroll"},
12829: {"AegisName":"Earth_Type_Scroll"},
12830: {"AegisName":"Dead_Tree_Box"},
12831: {"AegisName":"Potion_Box"},
12832: {"AegisName":"Mysterious_Water"},
12833: {"AegisName":"Union_Of_Tribe_"},
12834: {"AegisName":"Undead_Egg"},
12835: {"AegisName":"Girls_Heart"},
12837: {"AegisName":"Wooden_Treasure_Box"},
12838: {"AegisName":"Iron_Treasure_Box"},
12839: {"AegisName":"bronze_Treasure_Box"},
12840: {"AegisName":"Silver_Treasure_Box"},
12841: {"AegisName":"Golden_Treasure_Box"},
12842: {"AegisName":"Platinum_Treasure_Box"},
12843: {"AegisName":"Pearl_Treasure_Box"},
12844: {"AegisName":"Diamond_Treasure_Box"},
12845: {"AegisName":"WOB_Amatsu"},
12846: {"AegisName":"Unripe_Apple2"},
12847: {"AegisName":"Old_Equipment_Box"},
12848: {"AegisName":"Falcon_Pipe"},
12849: {"AegisName":"Combination_Kit"},
12850: {"AegisName":"Heaven_Scroll"},
12851: {"AegisName":"Vocation_Scroll"},
12852: {"AegisName":"Wisdom_Scroll"},
12853: {"AegisName":"Patron_Scroll"},
12854: {"AegisName":"Full_Spray_Of_Flowers"},
12855: {"AegisName":"Pope_Scroll"},
12856: {"AegisName":"GoldenApple_P_RG"},
12857: {"AegisName":"GoldenApple_RG"},
12858: {"AegisName":"Golden_Potion_RG"},
12860: {"AegisName":"Mommy_Day_Cake"},
12863: {"AegisName":"Treasure_Box_Scroll2"},
12871: {"AegisName":"Mysterious_Egg2"},
12872: {"AegisName":"Battle_Manual_Limit"},
12873: {"AegisName":"TE_Potion_Box"},
12874: {"AegisName":"Frost_Giant_Blood"},
12875: {"AegisName":"Golem_Stone"},
12876: {"AegisName":"Elf_Tear_Stun"},
12877: {"AegisName":"Elf_Tear_Stone_Curse"},
12878: {"AegisName":"Elf_Tear_Freezing"},
12879: {"AegisName":"Elf_Tear_Sleep"},
12880: {"AegisName":"Elf_Tear_Curse"},
12881: {"AegisName":"Elf_Tear_Silence"},
12882: {"AegisName":"Elf_Tear_Blind"},
12883: {"AegisName":"Almighty"},
12884: {"AegisName":"Infinite_Center_Potion"},
12885: {"AegisName":"Ifn_Awakening_Potion"},
12886: {"AegisName":"Infinite_Berserk_Potion"},
12887: {"AegisName":"C_Wing_Of_Fly"},
12888: {"AegisName":"Siege_Kit_Box"},
12889: {"AegisName":"Weapon_Box_Spear"},
12890: {"AegisName":"Weapon_Box_Mace"},
12891: {"AegisName":"Weapon_Box_Dagger"},
12892: {"AegisName":"Weapon_Box_Axe"},
12893: {"AegisName":"Weapon_Box_Bow"},
12894: {"AegisName":"Weapon_Box_Sword"},
12895: {"AegisName":"Weapon_Box_Fist"},
12896: {"AegisName":"Weapon_Box_Book"},
12897: {"AegisName":"Weapon_Box_Guitar"},
12898: {"AegisName":"Weapon_Box_Whip"},
12899: {"AegisName":"Weapon_Box_Wand"},
12900: {"AegisName":"Battle_Manual_Box"},
12901: {"AegisName":"Insurance_Package"},
12902: {"AegisName":"Bubble_Gum_Box"},
12903: {"AegisName":"Str_Dish_Box"},
12904: {"AegisName":"Agi_Dish_Box"},
12905: {"AegisName":"Int_Dish_Box"},
12906: {"AegisName":"Dex_Dish_Box"},
12907: {"AegisName":"Luk_Dish_Box"},
12908: {"AegisName":"Vit_Dish_Box"},
12909: {"AegisName":"Kafra_Card_Box"},
12910: {"AegisName":"Giant_Fly_Wing_Box"},
12911: {"AegisName":"Neuralizer_Box"},
12912: {"AegisName":"Convex_Mirror_Box"},
12913: {"AegisName":"Blessing_10_Scroll_Box"},
12914: {"AegisName":"Inc_Agi_10_Scroll_Box"},
12915: {"AegisName":"Aspersio_5_Scroll_Box"},
12916: {"AegisName":"Assumptio_5_Scroll_Box"},
12917: {"AegisName":"Wind_Walk_10_Scroll_Box"},
12918: {"AegisName":"Adrenaline_Scroll_Box"},
12919: {"AegisName":"Megaphone_Box"},
12920: {"AegisName":"Enriched_Elunium_Box"},
12921: {"AegisName":"Enriched_Oridecon_Box"},
12922: {"AegisName":"Token_Of_Siegfried_Box"},
12923: {"AegisName":"Pet_Egg_Scroll_Box1"},
12924: {"AegisName":"Pet_Egg_Scroll_Box2"},
12925: {"AegisName":"Pet_Egg_Scroll1"},
12926: {"AegisName":"Pet_Egg_Scroll2"},
12927: {"AegisName":"J_Aspersio_5_Scroll_Box"},
12928: {"AegisName":"J_Aspersio_5_Scroll"},
12929: {"AegisName":"Pet_Egg_Scroll_Box3"},
12930: {"AegisName":"Pet_Egg_Scroll_Box4"},
12931: {"AegisName":"Pet_Egg_Scroll_Box5"},
12932: {"AegisName":"Pet_Egg_Scroll3"},
12933: {"AegisName":"Pet_Egg_Scroll4"},
12934: {"AegisName":"Pet_Egg_Scroll5"},
12935: {"AegisName":"Infiltrator_Box"},
12936: {"AegisName":"Muramasa_Box"},
12937: {"AegisName":"Excalibur_Box"},
12938: {"AegisName":"Combat_Knife_Box"},
12939: {"AegisName":"Counter_Dagger_Box"},
12940: {"AegisName":"Kaiser_Knuckle_Box"},
12941: {"AegisName":"Pole_Axe_Box"},
12942: {"AegisName":"Mighty_Staff_Box"},
12943: {"AegisName":"Right_Epsilon_Box"},
12944: {"AegisName":"Balistar_Box"},
12945: {"AegisName":"Diary_Of_Great_Sage_Box"},
12946: {"AegisName":"Asura_Box"},
12947: {"AegisName":"Apple_Of_Archer_Box"},
12948: {"AegisName":"Bunny_Band_Box"},
12949: {"AegisName":"Sahkkat_Box"},
12950: {"AegisName":"Lord_Circlet_Box"},
12951: {"AegisName":"Elven_Ears_Box"},
12952: {"AegisName":"Steel_Flower_Box"},
12953: {"AegisName":"Critical_Ring_Box"},
12954: {"AegisName":"Earring_Box"},
12955: {"AegisName":"Ring_Box"},
12956: {"AegisName":"Necklace_Box"},
12957: {"AegisName":"Glove_Box"},
12958: {"AegisName":"Brooch_Box"},
12959: {"AegisName":"Rosary_Box"},
12960: {"AegisName":"Safety_Ring_Box"},
12961: {"AegisName":"Vesper_Core01_Box"},
12962: {"AegisName":"Vesper_Core02_Box"},
12963: {"AegisName":"Vesper_Core03_Box"},
12964: {"AegisName":"Vesper_Core04_Box"},
12965: {"AegisName":"Emergency_Box1"},
12966: {"AegisName":"Emergency_Box2"},
12967: {"AegisName":"Emergency_Box3"},
12968: {"AegisName":"Emergency_Scroll1"},
12969: {"AegisName":"Emergency_Scroll2"},
12970: {"AegisName":"Emergency_Scroll3"},
12971: {"AegisName":"Teleport_Box1"},
12972: {"AegisName":"Teleport_Box2"},
12973: {"AegisName":"Teleport_Box3"},
12974: {"AegisName":"Teleport_Box4"},
12975: {"AegisName":"Teleport_Box5"},
12976: {"AegisName":"Teleport_Box6"},
12977: {"AegisName":"Teleport_Scroll1"},
12978: {"AegisName":"Teleport_Scroll2"},
12979: {"AegisName":"Teleport_Scroll3"},
12980: {"AegisName":"Teleport_Scroll4"},
12981: {"AegisName":"Teleport_Scroll5"},
12982: {"AegisName":"Teleport_Scroll6"},
12983: {"AegisName":"Pet_Egg_Scroll_Box6"},
12984: {"AegisName":"Pet_Egg_Scroll_Box7"},
12985: {"AegisName":"Pet_Egg_Scroll_Box8"},
12986: {"AegisName":"Pet_Egg_Scroll_Box9"},
12987: {"AegisName":"Pet_Egg_Scroll_Box10"},
12988: {"AegisName":"Pet_Egg_Scroll_Box11"},
12989: {"AegisName":"Pet_Egg_Scroll6"},
12990: {"AegisName":"Pet_Egg_Scroll7"},
12991: {"AegisName":"Pet_Egg_Scroll8"},
12992: {"AegisName":"Pet_Egg_Scroll9"},
12993: {"AegisName":"Pet_Egg_Scroll10"},
12994: {"AegisName":"Pet_Egg_Scroll11"},
12995: {"AegisName":"White_Herb_Box"},
12996: {"AegisName":"Blue_Herb_Box"},
12997: {"AegisName":"Elunium_Box"},
12998: {"AegisName":"Oridecon_Box"},
12999: {"AegisName":"Branch_Of_Dead_Tree_Box"},
13000: {"AegisName":"Jujube_Dagger"},
13001: {"AegisName":"Dragon_Killer"},
13002: {"AegisName":"Ginnungagap"},
13003: {"AegisName":"Coward"},
13004: {"AegisName":"Coward_"},
13005: {"AegisName":"Counter_Dagger_IL_J"},
13006: {"AegisName":"Khukri"},
13007: {"AegisName":"Jitte"},
13008: {"AegisName":"Jitte_"},
13009: {"AegisName":"Kamaitachi"},
13010: {"AegisName":"Asura"},
13011: {"AegisName":"Asura_"},
13012: {"AegisName":"Murasame"},
13013: {"AegisName":"Murasame_"},
13014: {"AegisName":"Hakujin"},
13015: {"AegisName":"Hakujin_"},
13016: {"AegisName":"Poison_Knife_"},
13017: {"AegisName":"House_Auger_"},
13018: {"AegisName":"Sucsamad_"},
13019: {"AegisName":"Ginnungagap_"},
13020: {"AegisName":"Warrior_Balmung_"},
13021: {"AegisName":"Combat_Knife_C"},
13022: {"AegisName":"Counter_Dagger_C"},
13023: {"AegisName":"Asura_C"},
13024: {"AegisName":"Sword_Breaker_C"},
13025: {"AegisName":"Mail_Breaker_C"},
13026: {"AegisName":"Moonlight_Sword_C"},
13027: {"AegisName":"Scalpel"},
13028: {"AegisName":"Tooth_Blade"},
13029: {"AegisName":"Prinsence_Knife"},
13030: {"AegisName":"Dragon_Killer_"},
13031: {"AegisName":"Sword_Breaker_"},
13032: {"AegisName":"Mail_Breaker_"},
13033: {"AegisName":"Assasin_Dagger_"},
13034: {"AegisName":"Twilight_Desert"},
13035: {"AegisName":"Sandstorm"},
13036: {"AegisName":"BF_Dagger1"},
13037: {"AegisName":"BF_Dagger2"},
13038: {"AegisName":"Dagger_Of_Hunter"},
13039: {"AegisName":"Ivory_Knife"},
13040: {"AegisName":"N_Cutter"},
13041: {"AegisName":"N_Main_Gauche"},
13042: {"AegisName":"Krieger_Dagger1"},
13043: {"AegisName":"Fortune_Sword_I"},
13044: {"AegisName":"House_Auger_I"},
13045: {"AegisName":"Kamaitachi_I"},
13046: {"AegisName":"Krieg"},
13047: {"AegisName":"Weihna"},
13048: {"AegisName":"Damascus_C"},
13049: {"AegisName":"Lacma"},
13050: {"AegisName":"P_Dagger1"},
13051: {"AegisName":"P_Dagger2"},
13052: {"AegisName":"Tourist_Dagger"},
13053: {"AegisName":"F_Moonlight_Sword_C"},
13054: {"AegisName":"F_Combat_Knife_C"},
13055: {"AegisName":"F_Asura_C"},
13056: {"AegisName":"F_Counter_Dagger_C"},
13057: {"AegisName":"E_Moonlight_Sword_C"},
13058: {"AegisName":"E_Combat_Knife_C"},
13059: {"AegisName":"E_Asura_C"},
13060: {"AegisName":"E_Counter_Dagger_C"},
13061: {"AegisName":"Black_Wing"},
13062: {"AegisName":"Ancient_Dagger"},
13063: {"AegisName":"Adventure_Knife"},
13064: {"AegisName":"Academy_Knife"},
13065: {"AegisName":"Academy_Eti_Knife"},
13066: {"AegisName":"P_Dagger3"},
13067: {"AegisName":"Caress"},
13068: {"AegisName":"Saurel"},
13069: {"AegisName":"Aztoe_Nail"},
13070: {"AegisName":"Scarletto_Nail"},
13071: {"AegisName":"Upg_Dagger"},
13072: {"AegisName":"Velum_Damascus"},
13073: {"AegisName":"Counter_Dagger_"},
13074: {"AegisName":"Ninja_Cutter"},
13075: {"AegisName":"Kurenai"},
13076: {"AegisName":"Raksasa_Dagger"},
13077: {"AegisName":"Kagekiri"},
13078: {"AegisName":"Mikatsuki"},
13079: {"AegisName":"Metal_Dagger"},
13080: {"AegisName":"Rogue_Kinfe"},
13081: {"AegisName":"Octo_kitchen_Knife"},
13082: {"AegisName":"Ivory_Knife_"},
13083: {"AegisName":"TE_Woe_Knife"},
13084: {"AegisName":"Eihwaz_Knife"},
13085: {"AegisName":"Volcano_Knife"},
13086: {"AegisName":"Goldsmithing_Dagger"},
13087: {"AegisName":"Hagalas_Knife"},
13088: {"AegisName":"Krishnagar"},
13089: {"AegisName":"FaceWorm_Leg"},
13090: {"AegisName":"FaceWormQueen_Leg"},
13091: {"AegisName":"Owl_Cutter"},
13092: {"AegisName":"RWC_Memory_Knife"},
13093: {"AegisName":"Thanos_Dagger"},
13094: {"AegisName":"Dagger_Of_Evil_Slayer"},
13096: {"AegisName":"Half_BF_Dagger2"},
13097: {"AegisName":"Ru_Blue_Dagger"},
13098: {"AegisName":"Ru_Blue_Ashura"},
13099: {"AegisName":"Ru_Blue_Knife"},
13100: {"AegisName":"Six_Shooter"},
13101: {"AegisName":"Six_Shooter_"},
13102: {"AegisName":"Crimson_Bolt"},
13103: {"AegisName":"Crimson_Bolt_"},
13104: {"AegisName":"The_Garrison"},
13105: {"AegisName":"The_Garrison_"},
13106: {"AegisName":"Gold_Lux"},
13107: {"AegisName":"Wasteland_Outlaw"},
13108: {"AegisName":"BF_Pistol1"},
13109: {"AegisName":"Wasteland_Outlaw_C"},
13110: {"AegisName":"Krieger_Pistol1"},
13111: {"AegisName":"Sharpshooter_Revolver"},
13112: {"AegisName":"P_Revolver1"},
13113: {"AegisName":"P_Revolver2"},
13114: {"AegisName":"P_Revolver3"},
13115: {"AegisName":"Upg_Revolver"},
13116: {"AegisName":"Novice_Revolver"},
13117: {"AegisName":"TE_Woe_Pistol"},
13118: {"AegisName":"Tiny_Flame"},
13119: {"AegisName":"Freedom_Flame"},
13120: {"AegisName":"H_FEATHER_H_FIRE"},
13122: {"AegisName":"ALTAIR_ARES"},
13124: {"AegisName":"ALTAIR_ARES_"},
13125: {"AegisName":"Metal_Revolver"},
13126: {"AegisName":"Gun_Of_Infinite"},
13127: {"AegisName":"Scarlet_Revolver"},
13128: {"AegisName":"Sinister_Revolver"},
13129: {"AegisName":"Union_Revolver"},
13130: {"AegisName":"Gun_of_Trust"},
13131: {"AegisName":"Gun_of_Trust2"},
13132: {"AegisName":"Toughen_Metal_Revolver"},
13133: {"AegisName":"UnrivaledGun"},
13134: {"AegisName":"ALTAIR_ARES_J"},
13135: {"AegisName":"H_FEATHER_H_FIRE_J"},
13136: {"AegisName":"Probation_Revolver"},
13137: {"AegisName":"Avenger_Revolver"},
13138: {"AegisName":"Dark_Rose"},
13139: {"AegisName":"Blue_Gun"},
13140: {"AegisName":"Diva_Handgun"},
13141: {"AegisName":"Mirage_Handgun"},
13142: {"AegisName":"Sinister_Revolver_J"},
13144: {"AegisName":"Rebeginer_RL_Gun"},
13145: {"AegisName":"Calf_Deathadder_J"},
13146: {"AegisName":"Calf_Deathadder"},
13150: {"AegisName":"Branch"},
13151: {"AegisName":"The_Cyclone"},
13152: {"AegisName":"The_Cyclone_"},
13153: {"AegisName":"Dusk"},
13154: {"AegisName":"Rolling_Stone"},
13155: {"AegisName":"Black_Rose"},
13156: {"AegisName":"Gate_Keeper"},
13157: {"AegisName":"Drifter"},
13158: {"AegisName":"Butcher"},
13159: {"AegisName":"Butcher_"},
13160: {"AegisName":"Destroyer"},
13161: {"AegisName":"Destroyer_"},
13162: {"AegisName":"Inferno"},
13163: {"AegisName":"Long_Barrel"},
13164: {"AegisName":"Long_Barrel_"},
13165: {"AegisName":"Jungle_Carbine"},
13166: {"AegisName":"Jungle_Carbine_"},
13167: {"AegisName":"Gate_KeeperDD"},
13168: {"AegisName":"Thunder_P"},
13169: {"AegisName":"Thunder_P_"},
13170: {"AegisName":"Lever_Action_Rifle"},
13171: {"AegisName":"BF_Rifle1"},
13172: {"AegisName":"BF_Gatling_Gun1"},
13173: {"AegisName":"BF_Shotgun1"},
13174: {"AegisName":"BF_Launcher1"},
13175: {"AegisName":"Lever_Action_Rifle_C"},
13176: {"AegisName":"Krieger_Rifle1"},
13177: {"AegisName":"Krieger_Gatling1"},
13178: {"AegisName":"Krieger_Shotgun1"},
13179: {"AegisName":"Krieger_Launcher1"},
13180: {"AegisName":"Novice_Rifle"},
13181: {"AegisName":"Novice_Shotgun"},
13182: {"AegisName":"Novice_Gatling"},
13183: {"AegisName":"Novice_Grenade_Launcher"},
13184: {"AegisName":"TE_Woe_Rifle"},
13185: {"AegisName":"TE_Woe_Gatling"},
13186: {"AegisName":"TE_Woe_Shotgun"},
13187: {"AegisName":"TE_Woe_Grenade"},
13189: {"AegisName":"COLORSCOPE"},
13190: {"AegisName":"RAG203_"},
13192: {"AegisName":"DEATHFIRE"},
13193: {"AegisName":"R_THUNDER"},
13194: {"AegisName":"P_BREAKER"},
13195: {"AegisName":"RAG203"},
13196: {"AegisName":"P_BREAKER_"},
13197: {"AegisName":"MINIMAY"},
13198: {"AegisName":"TEMPEST"},
13199: {"AegisName":"TEMPEST_"},
13200: {"AegisName":"Bullet"},
13201: {"AegisName":"Silver_Bullet"},
13202: {"AegisName":"Shell_Of_Blood"},
13203: {"AegisName":"Flare_Sphere"},
13204: {"AegisName":"Lighting_Sphere"},
13205: {"AegisName":"Poison_Sphere"},
13206: {"AegisName":"Blind_Sphere"},
13207: {"AegisName":"Freezing_Sphere"},
13208: {"AegisName":"Gong_Bug"},
13210: {"AegisName":"Slug_Bullet_1"},
13211: {"AegisName":"Slug_Bullet_2"},
13212: {"AegisName":"Slug_Bullet_3"},
13213: {"AegisName":"Slug_Bullet_4"},
13214: {"AegisName":"Slug_Bullet_5"},
13215: {"AegisName":"AP_Ammo"},
13216: {"AegisName":"Blaze_Bullet"},
13217: {"AegisName":"Freezing_Bullet"},
13218: {"AegisName":"Electric_Shock_Bullet"},
13219: {"AegisName":"Magical_Stone_Bullet"},
13220: {"AegisName":"Sanctified_Bullet"},
13221: {"AegisName":"Silver_Bullet_"},
13222: {"AegisName":"Shell_Of_Blood_"},
13223: {"AegisName":"Flare_Sphere_"},
13224: {"AegisName":"Lighting_Sphere_"},
13225: {"AegisName":"Poison_Sphere_"},
13226: {"AegisName":"Blind_Sphere_"},
13227: {"AegisName":"Freezing_Sphere_"},
13228: {"AegisName":"Flare_Bullet"},
13229: {"AegisName":"Lighting_Bullet"},
13230: {"AegisName":"Ice_Bullet"},
13231: {"AegisName":"Poison_Bullet"},
13232: {"AegisName":"Blind_Bullet"},
13250: {"AegisName":"Shuriken"},
13251: {"AegisName":"Nimbus_Shuriken"},
13252: {"AegisName":"Flash_Shuriken"},
13253: {"AegisName":"Sharp_Leaf_Shuriken"},
13254: {"AegisName":"Thorn_Needle_Shuriken"},
13255: {"AegisName":"Kunai_Of_Icicle"},
13256: {"AegisName":"Kunai_Of_Black_Soil"},
13257: {"AegisName":"Kunai_Of_Furious_Wind"},
13258: {"AegisName":"Kunai_Of_Fierce_Flame"},
13259: {"AegisName":"Kunai_Of_Deadly_Poison"},
13260: {"AegisName":"Apple_Bomb"},
13261: {"AegisName":"Coconut_Bomb"},
13262: {"AegisName":"Melon_Bomb"},
13263: {"AegisName":"Pineapple_Bomb"},
13264: {"AegisName":"Banana_Bomb"},
13265: {"AegisName":"Black_Lump"},
13266: {"AegisName":"Black_Hard_Lump"},
13267: {"AegisName":"Very_Hard_Lump"},
13268: {"AegisName":"Mysterious_Powder"},
13269: {"AegisName":"Boost500_To_Throw"},
13270: {"AegisName":"Full_SwingK_To_Throw"},
13271: {"AegisName":"Mana_Plus_To_Throw"},
13272: {"AegisName":"Cure_Free_To_Throw"},
13273: {"AegisName":"Stamina_Up_M_To_Throw"},
13274: {"AegisName":"Digestive_F_To_Throw"},
13275: {"AegisName":"HP_Inc_PotS_To_Throw"},
13276: {"AegisName":"HP_Inc_PotM_To_Throw"},
13277: {"AegisName":"HP_Inc_PotL_To_Throw"},
13278: {"AegisName":"SP_Inc_PotS_To_Throw"},
13279: {"AegisName":"SP_Inc_PotM_To_Throw"},
13280: {"AegisName":"SP_Inc_PotL_To_Throw"},
13281: {"AegisName":"En_White_PotZ_To_Throw"},
13282: {"AegisName":"Vitata500_To_Throw"},
13283: {"AegisName":"En_Cel_Juice_To_Throw"},
13284: {"AegisName":"Savage_BBQ_To_Throw"},
13285: {"AegisName":"Wug_Cocktail_To_Throw"},
13286: {"AegisName":"M_Brisket_To_Throw"},
13287: {"AegisName":"Siroma_Icetea_To_Throw"},
13288: {"AegisName":"Drocera_Stew_To_Throw"},
13289: {"AegisName":"Petti_Noodle_To_Throw"},
13290: {"AegisName":"Black_Thing_To_Throw"},
13291: {"AegisName":"Starfish"},
13292: {"AegisName":"Dried_Squid"},
13293: {"AegisName":"Flying_Fish"},
13294: {"AegisName":"Explosive_Kunai"},
13295: {"AegisName":"Light_Shuriken"},
13300: {"AegisName":"Huuma_Bird_Wing"},
13301: {"AegisName":"Huuma_Giant_Wheel"},
13302: {"AegisName":"Huuma_Giant_Wheel_"},
13303: {"AegisName":"Huuma_Blaze"},
13304: {"AegisName":"Huuma_Calm_Mind"},
13305: {"AegisName":"BF_Huuma_Shuriken1"},
13306: {"AegisName":"BF_Huuma_Shuriken2"},
13307: {"AegisName":"Krieger_Huuma_Shuriken1"},
13308: {"AegisName":"Huuma_Blaze_I"},
13309: {"AegisName":"Huuma_Giant_Wheel_C"},
13310: {"AegisName":"P_Huuma_Shuriken1"},
13311: {"AegisName":"Huuma_Shadow"},
13312: {"AegisName":"Huuma_Job_Test"},
13313: {"AegisName":"Huuma_Swirling_Petal"},
13314: {"AegisName":"Huuma_Fluttering_Snow"},
13315: {"AegisName":"Huuma_Thunderstorm"},
13316: {"AegisName":"Upg_Huuma_Shuriken"},
13317: {"AegisName":"TE_Woe_Huuma"},
13321: {"AegisName":"Half_BF_Huuma_Shuriken2"},
13322: {"AegisName":"Metal_Huuma_Shuriken"},
13323: {"AegisName":"Huuma_Of_Infinite"},
13327: {"AegisName":"Scarlet_Huuma"},
13328: {"AegisName":"Sinister_Huuma"},
13329: {"AegisName":"Union_Huuma"},
13330: {"AegisName":"Toughen_Metal_Shuriken"},
13332: {"AegisName":"Huuma_Hundred_Petal"},
13333: {"AegisName":"Diva_Huuma"},
13334: {"AegisName":"Mirage_Huuma"},
13335: {"AegisName":"Sinister_Huuma_J"},
13336: {"AegisName":"Probation_Huuma"},
13337: {"AegisName":"Huuma_Flutter_Snow_IL"},
13338: {"AegisName":"Huuma_Bird_Wing_IL"},
13339: {"AegisName":"Neev_Huuma_Shuriken"},
13340: {"AegisName":"Huuma_Hundred_Petal_J"},
13341: {"AegisName":"Rebeginer_KO_Humma"},
13343: {"AegisName":"Variant_Huuma"},
13345: {"AegisName":"Humma_Clear"},
13346: {"AegisName":"Ein_BHHuuma"},
13347: {"AegisName":"R_Huuma_Shuriken"},
13400: {"AegisName":"Cutlas_"},
13401: {"AegisName":"Excalibur_C"},
13402: {"AegisName":"Cutlas_C"},
13403: {"AegisName":"Solar_Sword_C"},
13404: {"AegisName":"Platinum_Shotel"},
13405: {"AegisName":"Curved_Sword"},
13406: {"AegisName":"Edger"},
13407: {"AegisName":"Nagan_C"},
13408: {"AegisName":"Fire_Brand_C"},
13409: {"AegisName":"Immaterial_Sword_C"},
13410: {"AegisName":"BF_Sword1"},
13411: {"AegisName":"BF_Sword2"},
13412: {"AegisName":"Twin_Edge_B"},
13413: {"AegisName":"Twin_Edge_R"},
13414: {"AegisName":"Elemental_Sword"},
13415: {"AegisName":"N_Falchion"},
13416: {"AegisName":"Krieger_Onehand_Sword1"},
13417: {"AegisName":"Krieger_Onehand_Sword2"},
13418: {"AegisName":"Krieger_Onehand_Sword3"},
13419: {"AegisName":"Holy_Saber"},
13420: {"AegisName":"Honglyun's_Sword"},
13421: {"AegisName":"Ruber"},
13422: {"AegisName":"Flamberge_C"},
13423: {"AegisName":"P_Sabre1"},
13424: {"AegisName":"P_Sabre2"},
13425: {"AegisName":"Tourist_Sword"},
13426: {"AegisName":"F_Cutlas_C"},
13427: {"AegisName":"F_Solar_Sword_C"},
13428: {"AegisName":"Priest_Sword"},
13429: {"AegisName":"E_Cutlas_C"},
13430: {"AegisName":"E_Solar_Sword_C"},
13431: {"AegisName":"Chrome_Sword"},
13432: {"AegisName":"Adventure_Sword"},
13433: {"AegisName":"Academy_Sword"},
13434: {"AegisName":"P_Saber3"},
13435: {"AegisName":"Fire_Brand_"},
13436: {"AegisName":"Ice_Falchon_"},
13437: {"AegisName":"Orcish_Sword_"},
13438: {"AegisName":"Magical_Blade"},
13439: {"AegisName":"TE_Woe_Sword"},
13440: {"AegisName":"Ceremonial_Sword"},
13441: {"AegisName":"Thanos_Sword"},
13442: {"AegisName":"Old_Parasol"},
13444: {"AegisName":"Pala"},
13445: {"AegisName":"Half_BF_Sword1"},
13446: {"AegisName":"Star_Dust_Blade_"},
13447: {"AegisName":"Byeorrun_Gum_"},
13448: {"AegisName":"Magical_Blade_"},
13449: {"AegisName":"Gladius_Daemonicus"},
13450: {"AegisName":"LI_Saber"},
13451: {"AegisName":"Ru_Blue_Sword"},
13452: {"AegisName":"Ru_Gold_Sword"},
13453: {"AegisName":"Mysteltainn_S"},
13454: {"AegisName":"Scarlet_Saber"},
13455: {"AegisName":"Sinister_Saber"},
13456: {"AegisName":"Union_Sword"},
13457: {"AegisName":"Union_Dagger"},
13460: {"AegisName":"Sealed_Magic_Sword"},
13461: {"AegisName":"Sealed_Evil_Sword"},
13462: {"AegisName":"Sealed_Max_Sword"},
13465: {"AegisName":"Save_The_King"},
13466: {"AegisName":"Diva_Blade"},
13467: {"AegisName":"Mirage_Blade"},
13468: {"AegisName":"Sinister_Saber_J"},
13469: {"AegisName":"Immaterial_Sword_IL"},
13470: {"AegisName":"Sealed_Magic_SwordJ"},
13471: {"AegisName":"Sealed_Evil_SwordJ"},
13472: {"AegisName":"Sealed_Max_SwordJ"},
13473: {"AegisName":"Gods_Sword"},
13474: {"AegisName":"Sword_Z"},
13475: {"AegisName":"Falchion_Z"},
13476: {"AegisName":"Blade_Z"},
13477: {"AegisName":"Lapier_Z"},
13478: {"AegisName":"Scimiter_Z"},
13479: {"AegisName":"Tsurugi_z"},
13480: {"AegisName":"Ring_Pommel_Saber_Z"},
13481: {"AegisName":"Saber_Z"},
13482: {"AegisName":"Orcish_Blade"},
13483: {"AegisName":"Rebeginer_GN_Sword"},
13485: {"AegisName":"Sword_Of_Bluefire"},
13488: {"AegisName":"Local01_Sword"},
13489: {"AegisName":"Local02_Sword"},
13490: {"AegisName":"Woe_Onehand_Sword1_Z"},
13492: {"AegisName":"Variant_Blade"},
13493: {"AegisName":"Cannon_Rapier_OS"},
13495: {"AegisName":"Evt_Bluefire_Sword"},
13497: {"AegisName":"Edge_Z"},
13498: {"AegisName":"Nagan_Z"},
13499: {"AegisName":"Sword_Kladenets"},
13500: {"AegisName":"Insurance60_Package"},
13501: {"AegisName":"Assorted_Scroll_Box"},
13502: {"AegisName":"Drooping_Kitty_Box"},
13503: {"AegisName":"Magestic_Goat_Box"},
13504: {"AegisName":"Deviruchi_Cap_Box"},
13505: {"AegisName":"Executioner_Box"},
13506: {"AegisName":"Brood_Axe_Box"},
13507: {"AegisName":"Tomahawk_Box"},
13508: {"AegisName":"Bow_Of_Rudra_Box"},
13509: {"AegisName":"Cutlas_Box"},
13510: {"AegisName":"Solar_Sword_Box"},
13511: {"AegisName":"Sword_Breaker_Box"},
13512: {"AegisName":"Mail_Breaker_Box"},
13513: {"AegisName":"Moonlight_Sword_Box"},
13514: {"AegisName":"Spanner_Box"},
13515: {"AegisName":"Grape_Box"},
13516: {"AegisName":"Royal_Jelly_Box"},
13517: {"AegisName":"Yggdrasilberry_Box"},
13518: {"AegisName":"Weapon_Card_Scroll_Box"},
13519: {"AegisName":"Armor_Card_Scroll_Box"},
13520: {"AegisName":"Helmet_Card_Scroll_Box"},
13521: {"AegisName":"Garment_Card_Scroll_Box"},
13522: {"AegisName":"Shield_Card_Scroll_Box"},
13523: {"AegisName":"Shoes_Card_Scroll_Box"},
13524: {"AegisName":"Accy_Card_Scroll_Box"},
13525: {"AegisName":"Zeny_Card_Scroll_Box"},
13526: {"AegisName":"Pet_Egg_Scroll_Box1_"},
13527: {"AegisName":"Pet_Egg_Scroll_Box2_"},
13528: {"AegisName":"Pet_Egg_Scroll_Box3_"},
13529: {"AegisName":"Pet_Egg_Scroll_Box4_"},
13530: {"AegisName":"Pet_Egg_Scroll_Box5_"},
13531: {"AegisName":"Light_Red_Pot_Box"},
13532: {"AegisName":"Light_Orange_Pot_Box"},
13533: {"AegisName":"Light_Yellow_Pot_Box"},
13534: {"AegisName":"Light_White_Pot_Box"},
13535: {"AegisName":"Light_Center_Pot_Box"},
13536: {"AegisName":"Light_Awakening_Pot_Box"},
13537: {"AegisName":"Light_Berserk_Pot_Box"},
13538: {"AegisName":"Meteor_10_Scroll_Box"},
13539: {"AegisName":"Storm_10_Scroll_Box"},
13540: {"AegisName":"Vermilion_10_Scroll_Box"},
13541: {"AegisName":"Lex_Aeterna_Scroll_Box"},
13542: {"AegisName":"Magnificat_5_Scroll_Box"},
13543: {"AegisName":"CP_Helm_Scroll_Box"},
13544: {"AegisName":"CP_Shield_Scroll_Box"},
13545: {"AegisName":"CP_Armor_Scroll_Box"},
13546: {"AegisName":"CP_Weapon_Scroll_Box"},
13547: {"AegisName":"Repair_Scroll_Box"},
13548: {"AegisName":"Big_Bun_Box"},
13549: {"AegisName":"Pill__Box"},
13550: {"AegisName":"Superb_Fish_Slice_Box"},
13551: {"AegisName":"Chewy_Ricecake_Box"},
13552: {"AegisName":"Oriental_Pastry_Box"},
13553: {"AegisName":"Dun_Tele_Scroll1_Box"},
13554: {"AegisName":"Weapon_Card_Scroll_Box2"},
13555: {"AegisName":"Weapon_Card_Scroll_Box3"},
13556: {"AegisName":"Armor_Card_Scroll_Box2"},
13557: {"AegisName":"Accy_Card_Scroll_Box2"},
13558: {"AegisName":"Weapon_Card_Scroll"},
13559: {"AegisName":"Armor_Card_Scroll"},
13560: {"AegisName":"Helmet_Card_Scroll"},
13561: {"AegisName":"Hood_Card_Scroll"},
13562: {"AegisName":"Hood_Card_Scroll2"},
13563: {"AegisName":"Shoes_Card_Scroll"},
13564: {"AegisName":"Accy_Card_Scroll"},
13565: {"AegisName":"Weapon_Card_Scroll2"},
13566: {"AegisName":"Weapon_Card_Scroll3"},
13567: {"AegisName":"Armor_Card_Scroll2"},
13568: {"AegisName":"Accy_Card_Scroll2"},
13569: {"AegisName":"PVP_Tele_Scroll_Box"},
13570: {"AegisName":"Giant_Fly_Wing_Box50"},
13571: {"AegisName":"Giant_Fly_Wing_Box100"},
13572: {"AegisName":"Dex_Dish_Box30"},
13573: {"AegisName":"Dex_Dish_Box50"},
13574: {"AegisName":"Luk_Dish_Box30"},
13575: {"AegisName":"Luk_Dish_Box50"},
13576: {"AegisName":"Inc_Agi_10_Box30"},
13577: {"AegisName":"Inc_Agi_10_Box50"},
13578: {"AegisName":"Vit_Dish_Box30"},
13579: {"AegisName":"Vit_Dish_Box50"},
13580: {"AegisName":"Insurance_Package30"},
13581: {"AegisName":"Insurance_Package50"},
13582: {"AegisName":"Convex_Mirror_Box5"},
13583: {"AegisName":"Convex_Mirror_Box30"},
13584: {"AegisName":"Blessing10_Box30"},
13585: {"AegisName":"Blessing10_Box50"},
13586: {"AegisName":"Adrenaline10_Box30"},
13587: {"AegisName":"Adrenaline10_Box50"},
13588: {"AegisName":"Assumptio_5_Box30"},
13589: {"AegisName":"Assumptio_5_Box50"},
13590: {"AegisName":"Aspersio_5_Box30"},
13591: {"AegisName":"Aspersio_5_Box50"},
13592: {"AegisName":"Agi_Dish_Box30"},
13593: {"AegisName":"Agi_Dish_Box50"},
13594: {"AegisName":"Wind_Walk10_Box30"},
13595: {"AegisName":"Wind_Walk10_Box50"},
13596: {"AegisName":"Int_Dish_Box30"},
13597: {"AegisName":"Int_Dish_Box50"},
13598: {"AegisName":"Battle_Manual_Box1"},
13599: {"AegisName":"Battle_Manual_Box5"},
13600: {"AegisName":"Siegfried_Box5"},
13601: {"AegisName":"Siegfried_Box20"},
13602: {"AegisName":"Kafra_Card_Box30"},
13603: {"AegisName":"Kafra_Card_Box50"},
13604: {"AegisName":"Str_Dish_Box30"},
13605: {"AegisName":"Str_Dish_Box50"},
13606: {"AegisName":"Bubble_Gum_Box1"},
13607: {"AegisName":"Bubble_Gum_Box5"},
13608: {"AegisName":"Megaphone_Box1"},
13609: {"AegisName":"Megaphone_Box5"},
13610: {"AegisName":"Enriched_Elunium_Box5"},
13611: {"AegisName":"Enriched_Oridecon_Box5"},
13612: {"AegisName":"Handcuff_Box"},
13613: {"AegisName":"Super_Pet_Egg_Box1"},
13614: {"AegisName":"Super_Pet_Egg_Box2"},
13615: {"AegisName":"Super_Pet_Egg_Box3"},
13616: {"AegisName":"Super_Pet_Egg_Box4"},
13617: {"AegisName":"Super_Pet_Egg1"},
13618: {"AegisName":"Super_Pet_Egg2"},
13619: {"AegisName":"Super_Pet_Egg3"},
13620: {"AegisName":"Super_Pet_Egg4"},
13621: {"AegisName":"Greed_Box30"},
13622: {"AegisName":"Greed_Box50"},
13623: {"AegisName":"Greed_Box100"},
13624: {"AegisName":"Flee_30_Scroll_Box"},
13625: {"AegisName":"Accuracy_30_Scroll_Box"},
13626: {"AegisName":"Super_Card_Pet_Egg_Box1"},
13627: {"AegisName":"Super_Card_Pet_Egg_Box2"},
13628: {"AegisName":"Super_Card_Pet_Egg_Box3"},
13629: {"AegisName":"Super_Card_Pet_Egg_Box4"},
13630: {"AegisName":"Super_Card_Pet_Egg1"},
13631: {"AegisName":"Super_Card_Pet_Egg2"},
13632: {"AegisName":"Super_Card_Pet_Egg3"},
13633: {"AegisName":"Super_Card_Pet_Egg4"},
13634: {"AegisName":"Vigorgra_Package1"},
13635: {"AegisName":"Vigorgra_Package2"},
13636: {"AegisName":"Vigorgra_Package3"},
13637: {"AegisName":"Vigorgra_Package4"},
13638: {"AegisName":"Vigorgra_Package5"},
13639: {"AegisName":"Vigorgra_Package6"},
13640: {"AegisName":"Vigorgra_Package7"},
13641: {"AegisName":"Vigorgra_Package8"},
13642: {"AegisName":"Vigorgra_Package9"},
13643: {"AegisName":"Vigorgra_Package10"},
13644: {"AegisName":"Vigorgra_Package11"},
13645: {"AegisName":"Vigorgra_Package12"},
13646: {"AegisName":"Infiltrator_Box1"},
13647: {"AegisName":"Muramasa_Box1"},
13648: {"AegisName":"Excalibur_Box1"},
13649: {"AegisName":"Combat_Knife_Box1"},
13650: {"AegisName":"Counter_Dagger_Box1"},
13651: {"AegisName":"Kaiser_Knuckle_Box1"},
13652: {"AegisName":"Pole_Axe_Box1"},
13653: {"AegisName":"Mighty_Staff_Box1"},
13654: {"AegisName":"Right_Epsilon_Box1"},
13655: {"AegisName":"Balistar_Box1"},
13656: {"AegisName":"Diary_Of_Sage_Box1"},
13657: {"AegisName":"Asura_Box1"},
13658: {"AegisName":"Apple_Of_Archer_Box1"},
13659: {"AegisName":"Bunny_Band_Box1"},
13660: {"AegisName":"Sahkkat_Box1"},
13661: {"AegisName":"Lord_Circlet_Box1"},
13662: {"AegisName":"Elven_Ears_Box1"},
13663: {"AegisName":"Steel_Flower_Box1"},
13664: {"AegisName":"Critical_Ring_Box1"},
13665: {"AegisName":"Earring_Box1"},
13666: {"AegisName":"Ring_Box1"},
13667: {"AegisName":"Necklace_Box1"},
13668: {"AegisName":"Glove_Box1"},
13669: {"AegisName":"Brooch_Box1"},
13670: {"AegisName":"Rosary_Box1"},
13671: {"AegisName":"Safety_Ring_Box1"},
13672: {"AegisName":"Vesper_Core01_Box1"},
13673: {"AegisName":"Vesper_Core02_Box1"},
13674: {"AegisName":"Vesper_Core03_Box1"},
13675: {"AegisName":"Vesper_Core04_Box1"},
13676: {"AegisName":"Drooping_Kitty_Box1"},
13677: {"AegisName":"Magestic_Goat_Box1"},
13678: {"AegisName":"Deviruchi_Cap_Box1"},
13679: {"AegisName":"Executioner_Box1"},
13680: {"AegisName":"Brood_Axe_Box1"},
13681: {"AegisName":"Tomahawk_Box1"},
13682: {"AegisName":"Bow_Of_Rudra_Box1"},
13683: {"AegisName":"Cutlas_Box1"},
13684: {"AegisName":"Solar_Sword_Box1"},
13685: {"AegisName":"Sword_Breaker_Box1"},
13686: {"AegisName":"Mail_Breaker_Box1"},
13687: {"AegisName":"Moonlight_Sword_Box1"},
13688: {"AegisName":"Spanner_Box1"},
13689: {"AegisName":"Bok_Choy_Box"},
13690: {"AegisName":"Chung_E_Cake_Box"},
13691: {"AegisName":"Freyja_Overcoat_Box"},
13692: {"AegisName":"Freyja_Boots_Box"},
13693: {"AegisName":"Freyja_Cape_Box"},
13694: {"AegisName":"Freyja_Crown_Box"},
13695: {"AegisName":"Battle_Manual25_Box"},
13696: {"AegisName":"Battle_Manual100_Box"},
13697: {"AegisName":"J_Blessing10_Box"},
13698: {"AegisName":"J_Inc_Agi10_Box"},
13699: {"AegisName":"J_Wind_Walk10_Box"},
13700: {"AegisName":"J_Adrenaline10_Box"},
13701: {"AegisName":"Pet_Egg_Scroll12"},
13702: {"AegisName":"Pet_Egg_Scroll13"},
13703: {"AegisName":"Pet_Egg_Scroll14"},
13704: {"AegisName":"Super_Pet_Egg5"},
13705: {"AegisName":"Super_Pet_Egg6"},
13706: {"AegisName":"Super_Pet_Egg7"},
13707: {"AegisName":"Super_Pet_Egg8"},
13708: {"AegisName":"Pet_Egg_Scroll_E"},
13709: {"AegisName":"BRO_Package1"},
13710: {"AegisName":"Max_Weight_Up_Box"},
13711: {"AegisName":"Small_Life_Potion_Box"},
13712: {"AegisName":"Small_Life_Potion_Box30"},
13713: {"AegisName":"Small_Life_Potion_Box50"},
13714: {"AegisName":"Med_Life_Potion_Box"},
13715: {"AegisName":"Med_Life_Potion_Box30"},
13716: {"AegisName":"Med_Life_Potion_Box50"},
13717: {"AegisName":"Abrasive_Box5"},
13718: {"AegisName":"Abrasive_Box10"},
13719: {"AegisName":"Regeneration_Box5"},
13720: {"AegisName":"Regeneration_Box10"},
13721: {"AegisName":"Dun_Tele_Scroll_Box10"},
13722: {"AegisName":"Pecopeco_Hairband_Box"},
13723: {"AegisName":"Red_Glasses_Box"},
13724: {"AegisName":"Whisper_Mask_Box"},
13725: {"AegisName":"Ramen_Hat_Box"},
13726: {"AegisName":"Gold_Box_"},
13727: {"AegisName":"Silver_Box_"},
13728: {"AegisName":"Gold_Key1_Box"},
13729: {"AegisName":"Gold_Key5_Box"},
13730: {"AegisName":"Silver_Key1_Box"},
13731: {"AegisName":"Silver_Key5_Box"},
13734: {"AegisName":"Pecopeco_Hairband_Box1"},
13735: {"AegisName":"Red_Glasses_Box1"},
13736: {"AegisName":"Whisper_Mask_Box1"},
13737: {"AegisName":"Ramen_Hat_Box1"},
13738: {"AegisName":"Glass_Of_Illusion_Box5"},
13739: {"AegisName":"Glass_Of_Illusion_Box10"},
13740: {"AegisName":"Shadow_Armor_S_Box5"},
13741: {"AegisName":"Shadow_Armor_S_Box10"},
13742: {"AegisName":"Shadow_Armor_S_Box30"},
13743: {"AegisName":"Holy_Armor_S_Box5"},
13744: {"AegisName":"Holy_Armor_S_Box10"},
13745: {"AegisName":"Holy_Armor_S_Box30"},
13746: {"AegisName":"S_Def_Potion_Box10"},
13747: {"AegisName":"S_Def_Potion_Box30"},
13748: {"AegisName":"S_Def_Potion_Box50"},
13749: {"AegisName":"B_Def_Potion_Box10"},
13750: {"AegisName":"B_Def_Potion_Box30"},
13751: {"AegisName":"B_Def_Potion_Box50"},
13752: {"AegisName":"S_Mdef_Potion_Box10"},
13753: {"AegisName":"S_Mdef_Potion_Box30"},
13754: {"AegisName":"S_Mdef_Potion_Box50"},
13755: {"AegisName":"B_Mdef_Potion_Box10"},
13756: {"AegisName":"B_Mdef_Potion_Box30"},
13757: {"AegisName":"B_Mdef_Potion_Box50"},
13758: {"AegisName":"Battle_Manual_X3_Box"},
13759: {"AegisName":"In_Blue_Herb_Box"},
13760: {"AegisName":"Honey_Box"},
13761: {"AegisName":"Empty_Bottle_Box"},
13762: {"AegisName":"In_Royal_Jelly_Box"},
13763: {"AegisName":"5_Anniversary_Coin_Box"},
13764: {"AegisName":"Battle_Manual_Box_TW"},
13765: {"AegisName":"Certificate_TW_Box"},
13766: {"AegisName":"Nagan_Box"},
13767: {"AegisName":"Skewer_Box"},
13768: {"AegisName":"Survival_Rod_Box"},
13769: {"AegisName":"Quadrille_Box"},
13770: {"AegisName":"Great_Axe_Box"},
13771: {"AegisName":"Bloody_Roar_Box"},
13772: {"AegisName":"Hardback_Box"},
13773: {"AegisName":"Fire_Brand_Box"},
13774: {"AegisName":"Immaterial_Sword_Box"},
13775: {"AegisName":"Unholy_Touch_Box"},
13776: {"AegisName":"Cloak_Of_Survival_Box"},
13777: {"AegisName":"Masquerade_Box"},
13778: {"AegisName":"Orc_Hero_Helm_Box"},
13779: {"AegisName":"Evil_Wing_Ears_Box"},
13780: {"AegisName":"Dark_Blindfold_Box"},
13781: {"AegisName":"kRO_Drooping_Kitty_Box"},
13782: {"AegisName":"Corsair_Box"},
13783: {"AegisName":"Bloody_Iron_Ball_Box"},
13784: {"AegisName":"Spiritual_Ring_Box"},
13785: {"AegisName":"Nagan_Box1"},
13786: {"AegisName":"Skewer_Box1"},
13787: {"AegisName":"Survival_Rod_Box1"},
13788: {"AegisName":"Quadrille_Box1"},
13789: {"AegisName":"Great_Axe_Box1"},
13790: {"AegisName":"Bloody_Roar_Box1"},
13791: {"AegisName":"Hardback_Box1"},
13792: {"AegisName":"Fire_Brand_Box1"},
13793: {"AegisName":"Immaterial_Sword_Box1"},
13794: {"AegisName":"Unholy_Touch_Box1"},
13795: {"AegisName":"Cloak_Of_Survival_Box1"},
13796: {"AegisName":"Masquerade_Box1"},
13797: {"AegisName":"Orc_Hero_Helm_Box1"},
13798: {"AegisName":"Evil_Wing_Ears_Box1"},
13799: {"AegisName":"Dark_Blindfold_Box1"},
13800: {"AegisName":"kRO_Drooping_Kitty_Box1"},
13801: {"AegisName":"Corsair_Box1"},
13802: {"AegisName":"Bloody_Iron_Ball_Box1"},
13803: {"AegisName":"Spiritual_Ring_Box1"},
13804: {"AegisName":"Fire_Cracker_Love_Box"},
13805: {"AegisName":"Fire_Cracker_Wday_Box"},
13806: {"AegisName":"Fire_Cracker_Vday_Box"},
13807: {"AegisName":"Fire_Cracker_Bday_Box"},
13808: {"AegisName":"Fire_Cracker_Xmas_Box"},
13809: {"AegisName":"Blue_Gemstone_Box"},
13810: {"AegisName":"Blue_Potion_Box"},
13811: {"AegisName":"Food_Box_Lv1"},
13812: {"AegisName":"Food_Box_Lv2"},
13813: {"AegisName":"Food_Box_Lv3"},
13814: {"AegisName":"Indonesia_Box"},
13815: {"AegisName":"Knife_Goblin_Box"},
13816: {"AegisName":"Flail_Goblin_Box"},
13817: {"AegisName":"Hammer_Goblin_Box"},
13818: {"AegisName":"Red_Deleter_Box"},
13819: {"AegisName":"Diabolic_Box"},
13820: {"AegisName":"Wanderer_Box"},
13821: {"AegisName":"Green_Apple_Box"},
13822: {"AegisName":"Whole_Barbecue_Box"},
13823: {"AegisName":"Meat_Veg_Skewer_Box"},
13824: {"AegisName":"Spirit_Liquor_Box"},
13825: {"AegisName":"Green_Box_"},
13826: {"AegisName":"Power_Box1"},
13827: {"AegisName":"Power_Box2"},
13828: {"AegisName":"Resist_Box1"},
13829: {"AegisName":"Resist_Box2"},
13830: {"AegisName":"Stat_Boost1"},
13831: {"AegisName":"Stat_Boost2"},
13832: {"AegisName":"Stat_Boost3"},
13833: {"AegisName":"Stat_Boost4"},
13834: {"AegisName":"Dun_Tele_Scroll2_Box5"},
13835: {"AegisName":"Dun_Tele_Scroll2_Box10"},
13836: {"AegisName":"Mbl_Str_Dish_Box"},
13837: {"AegisName":"Mbl_Agi_Dish_Box"},
13838: {"AegisName":"Mbl_Int_Dish_Box"},
13839: {"AegisName":"Mbl_Dex_Dish_Box"},
13840: {"AegisName":"Mbl_Luk_Dish_Box"},
13841: {"AegisName":"Mbl_Vit_Dish_Box"},
13842: {"AegisName":"Mbl_Kafra_Card_Box"},
13843: {"AegisName":"Mbl_Battle_Manual_Box"},
13844: {"AegisName":"Heroic_Stone_Box"},
13845: {"AegisName":"Mysterious_Travel_Sack1"},
13846: {"AegisName":"Mysterious_Travel_Sack2"},
13847: {"AegisName":"Mysterious_Travel_Sack3"},
13848: {"AegisName":"Mysterious_Travel_Sack4"},
13849: {"AegisName":"WOB_Box_Rune5"},
13850: {"AegisName":"WOB_Box_Rune10"},
13851: {"AegisName":"WOB_Box_Schawaltz5"},
13852: {"AegisName":"WOB_Box_Schawaltz10"},
13853: {"AegisName":"WOB_Box_Rachel5"},
13854: {"AegisName":"WOB_Box_Rachel10"},
13855: {"AegisName":"WOB_Box_Local5"},
13856: {"AegisName":"WOB_Box_Local10"},
13857: {"AegisName":"Spark_Candy_Box5"},
13858: {"AegisName":"Spark_Candy_Box10"},
13859: {"AegisName":"Directive_A_Envelope"},
13860: {"AegisName":"Directive_B_Envelope"},
13861: {"AegisName":"Mini_Battle_Manual_Box"},
13862: {"AegisName":"Trial_Box"},
13863: {"AegisName":"Repair_Scroll_Box10"},
13864: {"AegisName":"Hockey_Mask_Box"},
13865: {"AegisName":"Observer_Box"},
13866: {"AegisName":"Flying_Angel_Box"},
13867: {"AegisName":"Neko_Mimi_Box"},
13868: {"AegisName":"MFH_Box"},
13869: {"AegisName":"Chick_Hat_Box"},
13870: {"AegisName":"New_Style_Box"},
13871: {"AegisName":"Mage_Card_Box"},
13872: {"AegisName":"Acolyte_Card_Box"},
13873: {"AegisName":"Archer_Card_Box"},
13874: {"AegisName":"Swordman_Card_Box"},
13875: {"AegisName":"Thief_Card_Box"},
13876: {"AegisName":"Merchant_Card_Box"},
13877: {"AegisName":"Clock_Tower_Card_Box"},
13878: {"AegisName":"Geffenia_Card_Box"},
13879: {"AegisName":"Owl_Card_Box"},
13880: {"AegisName":"Ghost_Card_Box"},
13881: {"AegisName":"Nightmare_Card_Box"},
13882: {"AegisName":"Curse_Card_Box"},
13883: {"AegisName":"Sleep_Card_Box"},
13884: {"AegisName":"Freeze_Card_Box"},
13885: {"AegisName":"Stun_Card_Box"},
13886: {"AegisName":"Silence_Card_Box"},
13887: {"AegisName":"Blind_Card_Box"},
13888: {"AegisName":"Chaos_Card_Box"},
13889: {"AegisName":"Elunium_Box_"},
13890: {"AegisName":"Oridecon_Box_"},
13891: {"AegisName":"Fire_Converter_Box"},
13892: {"AegisName":"Water_Converter_Box"},
13893: {"AegisName":"Wind_Converter_Box"},
13894: {"AegisName":"Earth_Converter_Box"},
13895: {"AegisName":"Starter_Pack"},
13896: {"AegisName":"Mimic_Scroll_Box5"},
13897: {"AegisName":"Disguise_Croll_Box5"},
13898: {"AegisName":"Alice_Scroll_Box5"},
13899: {"AegisName":"Mimic_Scroll_Box10"},
13900: {"AegisName":"Disguise_Croll_Box10"},
13901: {"AegisName":"Alice_Scroll_Box10"},
13902: {"AegisName":"Fish_Head_Hat_Box"},
13903: {"AegisName":"Santa_Poring_Hat_Box"},
13904: {"AegisName":"Bell_Ribbon_Box"},
13905: {"AegisName":"Hard_Core_Set_Box"},
13906: {"AegisName":"Kitty_Set_Box"},
13907: {"AegisName":"Soft_Core_Set_Box"},
13908: {"AegisName":"Deviruchi_Set_Box"},
13909: {"AegisName":"MVP_Hunt_Box"},
13910: {"AegisName":"Cook_Box"},
13911: {"AegisName":"Xmas_Pet_Scroll"},
13912: {"AegisName":"Party_Blessing_Box"},
13913: {"AegisName":"Party_Inc_Agi_Box"},
13914: {"AegisName":"Party_Assumptio_Box"},
13915: {"AegisName":"Love_Angel_Box"},
13916: {"AegisName":"Squirrel_Box"},
13917: {"AegisName":"Gogo_Box"},
13918: {"AegisName":"Drooping_Kitty__Box"},
13919: {"AegisName":"Magestic_Goat__Box"},
13920: {"AegisName":"Satanic__Chain_Box"},
13921: {"AegisName":"Antique_Pipe_Box"},
13922: {"AegisName":"Bunny_Band__Box"},
13923: {"AegisName":"Darkness_Helm_Box"},
13924: {"AegisName":"L_Orc_Hero_Helm_Box"},
13925: {"AegisName":"Year_Of_Mouse_Scroll"},
13926: {"AegisName":"Crusader_Card_Box"},
13927: {"AegisName":"Alchemist_Card_Box"},
13928: {"AegisName":"Rogue_Card_Box"},
13929: {"AegisName":"Bard_Dancer_Card_Box"},
13930: {"AegisName":"Sage_Card_Box"},
13931: {"AegisName":"Monk_Card_Box"},
13932: {"AegisName":"Sylph_Box"},
13933: {"AegisName":"Undine_Box"},
13934: {"AegisName":"Salamander_Box"},
13935: {"AegisName":"Soul_Box"},
13936: {"AegisName":"Noum_Bpx"},
13937: {"AegisName":"Robo_Eye_Box"},
13938: {"AegisName":"Twin_Ribbon_Box"},
13939: {"AegisName":"Diadem_Box"},
13940: {"AegisName":"Siege_Scroll_Box"},
13941: {"AegisName":"TW_Valentine_Scroll"},
13942: {"AegisName":"Love_Angel_Box_1m"},
13943: {"AegisName":"Squirrel_Box_1m"},
13944: {"AegisName":"Gogo_Box_1m"},
13945: {"AegisName":"BRO_SM_Package"},
13946: {"AegisName":"BRO_MG_Package"},
13947: {"AegisName":"BRO_AC_Package"},
13948: {"AegisName":"BRO_AR_Package"},
13949: {"AegisName":"BRO_MC_Package"},
13950: {"AegisName":"BRO_TF_Package"},
13951: {"AegisName":"Wasteland_Outlaw_Box"},
13952: {"AegisName":"Lever_Action_Rifle_Box"},
13953: {"AegisName":"All_In_One_Ring_Box"},
13954: {"AegisName":"Spiritual_Tunic_Box"},
13955: {"AegisName":"Recuperative_Armor_Box"},
13956: {"AegisName":"Shelter_Resistance_Box"},
13957: {"AegisName":"Sylphid_Manteau_Box"},
13958: {"AegisName":"Refresh_Shoes_Box"},
13959: {"AegisName":"Toast_Box"},
13960: {"AegisName":"Name_Change_Coupon_Box"},
13961: {"AegisName":"Mojji_Box"},
13962: {"AegisName":"Deprotai_Doll_Hat_Box"},
13963: {"AegisName":"Claris_Doll_Hat_Box"},
13964: {"AegisName":"Sorin_Doll_Hat_Box"},
13965: {"AegisName":"Tayelin_Doll_Hat_Box"},
13966: {"AegisName":"Binit_Doll_Hat_Box"},
13967: {"AegisName":"Debril_Doll_Hat_Box"},
13968: {"AegisName":"Bubblegum_Lower_Box"},
13969: {"AegisName":"Lucky_Clip_Box"},
13970: {"AegisName":"Iron_10_Box"},
13971: {"AegisName":"Steel_10_Box"},
13972: {"AegisName":"Coal_10_Box"},
13973: {"AegisName":"Poison_Bottle_30_Box"},
13974: {"AegisName":"TW_Scroll01"},
13975: {"AegisName":"Picture_Diary_Box"},
13976: {"AegisName":"Mini_Heart_Box"},
13977: {"AegisName":"Newcomer_Box"},
13978: {"AegisName":"Kid_Box"},
13979: {"AegisName":"Magic_Castle_Box"},
13980: {"AegisName":"Bulging_Head_Box"},
13981: {"AegisName":"Picture_Diary_Box_1m"},
13982: {"AegisName":"Mini_Heart_Box_1m"},
13983: {"AegisName":"Newcomer_Box_1m"},
13984: {"AegisName":"Kid_Box_1m"},
13985: {"AegisName":"Magic_Castle_Box_1m"},
13986: {"AegisName":"Bulging_Head_Box_1m"},
13987: {"AegisName":"Ori_Stone_5_Box"},
13988: {"AegisName":"Ori_Stone_50_Box"},
13989: {"AegisName":"Acidbomb_10_Box"},
13990: {"AegisName":"Job_Manual50_Box"},
13991: {"AegisName":"Tiger_Mask_Box"},
13992: {"AegisName":"Cat_Hat_Box"},
13993: {"AegisName":"Alice_Doll_Box"},
13994: {"AegisName":"Speed_Up_Potion_Box5"},
13995: {"AegisName":"Speed_Up_Potion_Box10"},
13996: {"AegisName":"Big_Bun_Box100"},
13997: {"AegisName":"Big_Bun_Box500"},
13998: {"AegisName":"Giant_Fly_Wing_Box500"},
13999: {"AegisName":"Pill__Box100"},
14000: {"AegisName":"Pill__Box500"},
14001: {"AegisName":"Basic_Siege_Supply_Box"},
14002: {"AegisName":"Adv_Siege_Supply_Box"},
14003: {"AegisName":"Elite_Siege_Supply_Box"},
14004: {"AegisName":"Poison_Bottle_10_Box"},
14005: {"AegisName":"Poison_Bottle_5_Box"},
14006: {"AegisName":"F_Drooping_W_Kitty_Box"},
14007: {"AegisName":"F_Rabbit_Ear_Hat_Box"},
14008: {"AegisName":"F_L_Orc_Hero_Helm_Box"},
14009: {"AegisName":"F_Love_Angel_Box"},
14010: {"AegisName":"F_Squirrel_Box"},
14011: {"AegisName":"F_Gogo_Box"},
14012: {"AegisName":"F_Love_Angel_Box_1m"},
14013: {"AegisName":"F_Squirrel_Box_1m"},
14014: {"AegisName":"F_Gogo_Box_1m"},
14015: {"AegisName":"F_Wasteland_Outlaw_Box"},
14016: {"AegisName":"F_Lever_Action_Rifle_Bo"},
14017: {"AegisName":"F_All_In_One_Ring_Box"},
14018: {"AegisName":"F_Spritual_Tunic_Box"},
14019: {"AegisName":"F_Recuperative_Box"},
14020: {"AegisName":"F_Shelter_Resist_Box"},
14021: {"AegisName":"F_Sylphid_Manteau_Box"},
14022: {"AegisName":"F_Refresh_Shoes_Box"},
14023: {"AegisName":"F_Toast_Box"},
14024: {"AegisName":"F_Robo_Eye_Box"},
14025: {"AegisName":"F_Twin_Ribbon_Box"},
14026: {"AegisName":"F_Diadem_Box"},
14027: {"AegisName":"F_Fish_Head_Hat_Box"},
14028: {"AegisName":"F_Santa_Poring_Hat_Box"},
14029: {"AegisName":"F_Bell_Ribbon_Box"},
14030: {"AegisName":"F_Mimic_Scroll_Box5"},
14031: {"AegisName":"F_Disguise_Scroll_Box5"},
14032: {"AegisName":"F_Alice_Scroll_Box5"},
14033: {"AegisName":"F_Mimic_Scroll_Box10"},
14034: {"AegisName":"F_Disguise_Scroll_Box10"},
14035: {"AegisName":"F_Alice_Scroll_Box10"},
14036: {"AegisName":"F_New_Style_Coupon_Box"},
14037: {"AegisName":"F_Repair_Scroll_Box"},
14038: {"AegisName":"F_Repair_Scroll_Box10"},
14039: {"AegisName":"F_Hockey_Mask_Box"},
14040: {"AegisName":"F_Observer_Box"},
14041: {"AegisName":"F_WOB_Rune_Box5"},
14042: {"AegisName":"F_WOB_Rune_Box10"},
14043: {"AegisName":"F_WOB_Schwaltz_Box5"},
14044: {"AegisName":"F_WOB_Schwaltz_Box10"},
14045: {"AegisName":"F_WOB_Rachel_Box5"},
14046: {"AegisName":"F_WOB_Rachel_Box10"},
14047: {"AegisName":"F_WOB_Local_Box5"},
14048: {"AegisName":"F_WOB_Local_Box10"},
14049: {"AegisName":"F_Spark_Candy_Box5"},
14050: {"AegisName":"F_Spark_Candy_Box10"},
14051: {"AegisName":"F_Dun_Tel_Scroll2_Box5"},
14052: {"AegisName":"F_Dun_Tel_Scroll2_Box10"},
14053: {"AegisName":"F_Little_Angel_Doll_Box"},
14054: {"AegisName":"F_Triple_Poring_Hat_Box"},
14055: {"AegisName":"F_Nagan_Box"},
14056: {"AegisName":"F_Skewer_Box"},
14057: {"AegisName":"F_Survival_Rod_Box"},
14058: {"AegisName":"F_Quadrille_Box"},
14059: {"AegisName":"F_Great_Axe_Box"},
14060: {"AegisName":"F_Bloody_Roar_Box"},
14061: {"AegisName":"F_Hardback_Box"},
14062: {"AegisName":"F_Fire_Brand_Box"},
14063: {"AegisName":"F_Immaterial_Sword_Box"},
14064: {"AegisName":"F_Unholy_Touch_Box"},
14065: {"AegisName":"F_Clack_Of_Servival_Box"},
14066: {"AegisName":"F_Masquerade_Box"},
14067: {"AegisName":"F_Orc_Hero_Helm_Box"},
14068: {"AegisName":"F_Ear_Of_Devil_Wing_Box"},
14069: {"AegisName":"F_Dark_Blindfold_Box"},
14070: {"AegisName":"F_K_Drooping_Kitty_Box"},
14071: {"AegisName":"F_Corsair_Box"},
14072: {"AegisName":"F_Bloody_Iron_Ball_Box"},
14073: {"AegisName":"F_Spiritual_Ring_Box"},
14074: {"AegisName":"F_G_O_I_Box5"},
14075: {"AegisName":"F_G_O_I_Box10"},
14076: {"AegisName":"F_Shadow_Armor_S_Box5"},
14077: {"AegisName":"F_Shadow_Armor_S_Box10"},
14078: {"AegisName":"F_Shadow_Armor_S_Box30"},
14079: {"AegisName":"F_Holy_Armor_S_Box5"},
14080: {"AegisName":"F_Holy_Armor_S_Box10"},
14081: {"AegisName":"F_Holy_Armor_S_Box30"},
14082: {"AegisName":"FS_Def_Potion_Box10"},
14083: {"AegisName":"FS_Def_Potion_Box30"},
14084: {"AegisName":"FS_Def_Potion_Box50"},
14085: {"AegisName":"FB_Def_Potion_Box10"},
14086: {"AegisName":"FB_Def_Potion_Box30"},
14087: {"AegisName":"FB_Def_Potion_Box50"},
14088: {"AegisName":"FS_Mdef_Potion_Box10"},
14089: {"AegisName":"FS_Mdef_Potion_Box30"},
14090: {"AegisName":"FS_Mdef_Potion_Box50"},
14091: {"AegisName":"FB_Mdef_Potion_Box10"},
14092: {"AegisName":"FB_Mdef_Potion_Box30"},
14093: {"AegisName":"FB_Mdef_Potion_Box50"},
14094: {"AegisName":"F_Flying_Angel_Box"},
14095: {"AegisName":"F_Cat_Hat_Box"},
14096: {"AegisName":"F_M_F_H_Box"},
14097: {"AegisName":"F_Chick_Hat_Box"},
14098: {"AegisName":"F_Pecopeco_Hairband_Box"},
14099: {"AegisName":"F_Red_Glasses_Box"},
14100: {"AegisName":"F_Whisper_Mask_Box"},
14101: {"AegisName":"F_Ramen_Hat_Box"},
14102: {"AegisName":"F_Dun_Tele_Scroll1_Box"},
14103: {"AegisName":"F_Max_Weight_Up_Box"},
14104: {"AegisName":"F_S_Life_Potion_Box"},
14105: {"AegisName":"F_S_Life_Potion_Box30"},
14106: {"AegisName":"F_S_Life_Potion_Box50"},
14107: {"AegisName":"F_M_Life_Potion_Box"},
14108: {"AegisName":"F_M_Life_Potion_Box30"},
14109: {"AegisName":"F_M_Life_Potion_Box50"},
14110: {"AegisName":"F_Abrasive_Box5"},
14111: {"AegisName":"F_Abrasive_Box10"},
14112: {"AegisName":"F_Regeneration_Box5"},
14113: {"AegisName":"F_Regeneration_Box10"},
14114: {"AegisName":"F_Dun_Tele_Scroll_Box10"},
14115: {"AegisName":"F_Infiltrator_Box"},
14116: {"AegisName":"F_Muramasa_Box"},
14117: {"AegisName":"F_Excalibur_Box"},
14118: {"AegisName":"F_Combat_Knife_Box"},
14119: {"AegisName":"F_Counter_Dagger_Box"},
14120: {"AegisName":"F_Kaiser_Knuckle_Box"},
14121: {"AegisName":"F_Mighty_Staff_Box"},
14122: {"AegisName":"F_Right_Epsilon_Box"},
14123: {"AegisName":"F_Balistar_Box"},
14124: {"AegisName":"F_Diary_Of_Great_Sage"},
14125: {"AegisName":"F_Asura_Box"},
14126: {"AegisName":"F_Apple_Of_Archer_Box"},
14127: {"AegisName":"F_Bunny_Band_Box"},
14128: {"AegisName":"F_Sahkkat_Box"},
14129: {"AegisName":"F_Lord_Circlet_Box"},
14130: {"AegisName":"F_Elven_Ears_Box"},
14131: {"AegisName":"F_Steel_Flower_Box"},
14132: {"AegisName":"F_Critical_Ring_Box"},
14133: {"AegisName":"F_Earring_Box"},
14134: {"AegisName":"F_Ring_Box"},
14135: {"AegisName":"F_Necklace_Box"},
14136: {"AegisName":"F_Glove_Box"},
14137: {"AegisName":"F_Brooch_Box"},
14138: {"AegisName":"F_Rosary_Box"},
14139: {"AegisName":"F_Safety_Ring_Box"},
14140: {"AegisName":"F_Vesper_Core_Box01"},
14141: {"AegisName":"F_Vesper_Core_Box02"},
14142: {"AegisName":"F_Vesper_Core_Box03"},
14143: {"AegisName":"F_Vesper_Core_Box04"},
14144: {"AegisName":"F_Vigorgra_Package1"},
14145: {"AegisName":"F_Vigorgra_Package2"},
14146: {"AegisName":"F_Vigorgra_Package3"},
14147: {"AegisName":"F_Vigorgra_Package4"},
14148: {"AegisName":"F_Vigorgra_Package5"},
14149: {"AegisName":"F_Vigorgra_Package6"},
14150: {"AegisName":"F_Vigorgra_Package7"},
14151: {"AegisName":"F_Vigorgra_Package8"},
14152: {"AegisName":"F_Vigorgra_Package9"},
14153: {"AegisName":"F_Vigorgra_Package10"},
14154: {"AegisName":"F_Vigorgra_Package11"},
14155: {"AegisName":"F_Vigorgra_Package12"},
14156: {"AegisName":"F_Battle_Manual_Box"},
14157: {"AegisName":"F_Insurance_Package"},
14158: {"AegisName":"F_Bubble_Gum_Box"},
14159: {"AegisName":"F_Str_Dish_Box"},
14160: {"AegisName":"F_Agi_Dish_Box"},
14161: {"AegisName":"F_Int_Dish_Box"},
14162: {"AegisName":"F_Dex_Dish_Box"},
14163: {"AegisName":"F_Luk_Dish_Box"},
14164: {"AegisName":"F_Vit_Dish_Box"},
14165: {"AegisName":"F_Kafra_Card_Box"},
14166: {"AegisName":"F_Giant_Fly_Wing_Box"},
14167: {"AegisName":"F_Neuralizer_Box"},
14168: {"AegisName":"F_Convex_Mirror_Box"},
14169: {"AegisName":"F_Blessing_10_Box"},
14170: {"AegisName":"F_Inc_Agi_10_Scroll_Box"},
14171: {"AegisName":"F_Aspersio_5_Scroll_Box"},
14172: {"AegisName":"F_Assumptio_5_Box"},
14173: {"AegisName":"F_Wind_Walk_10_Box"},
14174: {"AegisName":"F_Adrenaline_Scroll_Box"},
14175: {"AegisName":"F_Megaphone_Box"},
14176: {"AegisName":"F_Enriched_Elunium_Box"},
14177: {"AegisName":"F_Enriched_Oridecon_Box"},
14178: {"AegisName":"F_Siegfried_Box"},
14179: {"AegisName":"F_Giant_Fly_Wing_Box50"},
14180: {"AegisName":"F_Giant_Fly_Wing_Box100"},
14181: {"AegisName":"F_Dex_Dish_Box30"},
14182: {"AegisName":"F_Dex_Dish_Box50"},
14183: {"AegisName":"F_Luk_Dish_Box30"},
14184: {"AegisName":"F_Luk_Dish_Box50"},
14185: {"AegisName":"F_Inc_Agi_10_Box30"},
14186: {"AegisName":"F_Inc_Agi_10_Box50"},
14187: {"AegisName":"F_Vit_Dish_Box30"},
14188: {"AegisName":"F_Vit_Dish_Box50"},
14189: {"AegisName":"F_Insurance_Package30"},
14190: {"AegisName":"F_Insurance_Package50"},
14191: {"AegisName":"F_Convex_Mirror_Box5"},
14192: {"AegisName":"F_Convex_Mirror_Box30"},
14193: {"AegisName":"F_Blessing10_Box30"},
14194: {"AegisName":"F_Blessing10_Box50"},
14195: {"AegisName":"F_Adrenaline10_Box30"},
14196: {"AegisName":"F_Adrenaline10_Box50"},
14197: {"AegisName":"F_Assumptio_5_Box30"},
14198: {"AegisName":"F_Assumptio_5_Box50"},
14199: {"AegisName":"F_Aspersio_5_Box30"},
14200: {"AegisName":"F_Aspersio_5_Box50"},
14201: {"AegisName":"F_Agi_Dish_Box30"},
14202: {"AegisName":"F_Agi_Dish_Box50"},
14203: {"AegisName":"F_Wind_Walk10_Box30"},
14204: {"AegisName":"F_Wind_Walk10_Box50"},
14205: {"AegisName":"F_Int_Dish_Box30"},
14206: {"AegisName":"F_Int_Dish_Box50"},
14207: {"AegisName":"F_Battle_Manual_Box1"},
14208: {"AegisName":"F_Battle_Manual_Box5"},
14209: {"AegisName":"F_Siegfried_Box5"},
14210: {"AegisName":"F_Siegfried_Box20"},
14211: {"AegisName":"F_Kafra_Card_Box30"},
14212: {"AegisName":"F_Kafra_Card_Box50"},
14213: {"AegisName":"F_Str_Dish_Box30"},
14214: {"AegisName":"F_Str_Dish_Box50"},
14215: {"AegisName":"F_Bubble_Gum_Box1"},
14216: {"AegisName":"F_Bubble_Gum_Box5"},
14217: {"AegisName":"F_Megaphone_Box1"},
14218: {"AegisName":"F_Megaphone_Box5"},
14219: {"AegisName":"F_Enriched_Elunium_Box5"},
14220: {"AegisName":"FEnriched_Oridecon_Box5"},
14221: {"AegisName":"MP_Scroll_Box"},
14222: {"AegisName":"MP_Scroll_Box30"},
14223: {"AegisName":"MP_Scroll_Box50"},
14224: {"AegisName":"Quagmire_Scroll_Box"},
14225: {"AegisName":"Quagmire_Scroll_Box30"},
14226: {"AegisName":"Quagmire_Scroll_Box50"},
14227: {"AegisName":"Healing_Staff_Box"},
14228: {"AegisName":"Praxinus_Box"},
14229: {"AegisName":"Sakura"},
14230: {"AegisName":"Headset_OST_Box"},
14231: {"AegisName":"Novice_Set_Box"},
14232: {"AegisName":"Yggdrasilberry_Box_"},
14233: {"AegisName":"Dead_Tree_Branch_Box1"},
14234: {"AegisName":"Dead_Tree_Branch_Box2"},
14235: {"AegisName":"Battle_Manual50_Box"},
14236: {"AegisName":"Str_Dish20_Box"},
14237: {"AegisName":"Agi_Dish20_Box"},
14238: {"AegisName":"Vit_Dish20_Box"},
14239: {"AegisName":"Int_Dish20_Box"},
14240: {"AegisName":"Dex_Dish20_Box"},
14241: {"AegisName":"Luk_Dish20_Box"},
14242: {"AegisName":"Beholder_Ring_Box"},
14243: {"AegisName":"Hallow_Ring_Box"},
14244: {"AegisName":"Clamorous_Ring_Box"},
14245: {"AegisName":"Chemical_Ring_Box"},
14246: {"AegisName":"Insecticide_Ring_Box"},
14247: {"AegisName":"Fisher_Ring_Box"},
14248: {"AegisName":"Decussate_Ring_Box"},
14249: {"AegisName":"Bloody_Ring_Box"},
14250: {"AegisName":"Satanic_Ring_Box"},
14251: {"AegisName":"Dragoon_Ring_Box"},
14252: {"AegisName":"Beholder_Ring_Box2"},
14253: {"AegisName":"Hallow_Ring_Box2"},
14254: {"AegisName":"Clamorous_Ring_Box2"},
14255: {"AegisName":"Chemical_Ring_Box2"},
14256: {"AegisName":"Insecticide_Ring_Box2"},
14257: {"AegisName":"Fisher_Ring_Box2"},
14258: {"AegisName":"Decussate_Ring_Box2"},
14259: {"AegisName":"Bloody_Ring_Box2"},
14260: {"AegisName":"Satanic_Ring_Box2"},
14261: {"AegisName":"Dragoon_Ring_Box2"},
14262: {"AegisName":"FPicture_Diary_Box"},
14263: {"AegisName":"FMini_Heart_Box"},
14264: {"AegisName":"FNewcomer_Box"},
14265: {"AegisName":"FKid_Box"},
14266: {"AegisName":"FMagic_Castle_Box"},
14267: {"AegisName":"FBulging_Head_Box"},
14268: {"AegisName":"FPicture_Diary_Box_1m"},
14269: {"AegisName":"FMini_Heart_Box_1m"},
14270: {"AegisName":"FNewcomer_Box_1m"},
14271: {"AegisName":"FKid_Box_1m"},
14272: {"AegisName":"FMagic_Castle_Box_1m"},
14273: {"AegisName":"FBulging_Head_Box_1m"},
14274: {"AegisName":"FMP_Scroll_Box"},
14275: {"AegisName":"FMP_Scroll_Box30"},
14276: {"AegisName":"FMP_Scroll_Box50"},
14277: {"AegisName":"FQuagmire_Scroll_Box"},
14278: {"AegisName":"FQuagmire_Scroll_Box30"},
14279: {"AegisName":"FQuagmire_Scroll_Box50"},
14280: {"AegisName":"FHealing_Staff_Box"},
14281: {"AegisName":"FPraxinus_Box"},
14282: {"AegisName":"Empelium_Box"},
14283: {"AegisName":"Marriage_Covenant_Box"},
14284: {"AegisName":"Muffler_C_Box"},
14285: {"AegisName":"Valkyrja's_Shield_C_Box"},
14286: {"AegisName":"Skul_Ring_C_Box"},
14287: {"AegisName":"S_Barricade_Repair_Kit"},
14288: {"AegisName":"S_Gstone_Repair_Kit"},
14289: {"AegisName":"Cloth_Dye_Coupon_Box"},
14290: {"AegisName":"Cloth_Dye_Coupon2_Box"},
14291: {"AegisName":"FCloth_Dye_Coupon_Box"},
14292: {"AegisName":"FCloth_Dye_Coupon_Box2"},
14293: {"AegisName":"Mercenary_Contract_Box"},
14294: {"AegisName":"Mercenary_Contract_5Box"},
14295: {"AegisName":"Mercenary_Con_10Box"},
14296: {"AegisName":"Angel_Scroll"},
14297: {"AegisName":"Devil_Scroll"},
14298: {"AegisName":"Surprise_Scroll"},
14299: {"AegisName":"Evolved_Leaf_Box"},
14300: {"AegisName":"Mask_Of_Ifrit_Box"},
14301: {"AegisName":"Ifrit's_Ear_Box"},
14302: {"AegisName":"Filr_Hat_Box"},
14303: {"AegisName":"Angel_Spirit_Box"},
14304: {"AegisName":"Scuba_Mask_Box"},
14305: {"AegisName":"Neko_Mimi_Kafra_Box"},
14306: {"AegisName":"RWC_Special_Scroll"},
14307: {"AegisName":"RWC_Limited_Scroll"},
14308: {"AegisName":"Ardor_Scroll"},
14309: {"AegisName":"Gang_Scarf_Box"},
14310: {"AegisName":"Ninja_Scroll_Box"},
14311: {"AegisName":"FAngel_Spirit_Box"},
14312: {"AegisName":"FGang_Scarf_Box"},
14313: {"AegisName":"FNinja_Scroll_Box"},
14314: {"AegisName":"PhreeoniS_Box"},
14315: {"AegisName":"GhostringS_Box"},
14316: {"AegisName":"July7_Scroll"},
14317: {"AegisName":"Bacsojin_Scroll"},
14318: {"AegisName":"Radio_Antenna_Box"},
14319: {"AegisName":"Tiraya_Bonnet_Box"},
14320: {"AegisName":"Balloon_Hat_Box"},
14321: {"AegisName":"Holy_Saber_Box"},
14322: {"AegisName":"Book_Of_Prayer_Box"},
14323: {"AegisName":"Phenomena_Whip_Box"},
14324: {"AegisName":"Staff_Of_Darkness_Box"},
14325: {"AegisName":"Monk_Knuckle_Box"},
14326: {"AegisName":"Mace_Of_Madness_Box"},
14327: {"AegisName":"Spear_Of_Excellent_Box"},
14328: {"AegisName":"Bow_Of_Evil_Box"},
14329: {"AegisName":"Katar_Of_Speed_Box"},
14330: {"AegisName":"SS_Revolver_Box"},
14331: {"AegisName":"Guildsman_Recruiter_Box"},
14332: {"AegisName":"Party_Recruiter_Hat_Box"},
14333: {"AegisName":"Bf_Recruiter_Hat_Box"},
14334: {"AegisName":"Friend_Recr_Hat_Box"},
14335: {"AegisName":"Gf_Recruiter_Hat_Box"},
14336: {"AegisName":"Marcher_Hat_Box"},
14337: {"AegisName":"F_Guildsman_Recr_Box"},
14338: {"AegisName":"F_Party_Recr_Hat_Box"},
14339: {"AegisName":"FBf_Recruiter_Hat_Box"},
14340: {"AegisName":"F_Friend_Recr_Hat_Box"},
14341: {"AegisName":"FGf_Recruiter_Hat_Box"},
14342: {"AegisName":"FMarcher_Hat_Box"},
14343: {"AegisName":"Spiked_Scarf_Box"},
14344: {"AegisName":"Rainbow_Scarf_Box"},
14345: {"AegisName":"Animal_Scroll"},
14346: {"AegisName":"Bro_Flag_Box"},
14347: {"AegisName":"Greed_Scroll_C20Box"},
14348: {"AegisName":"Greed_Scroll_C50Box"},
14349: {"AegisName":"Mental_Potion20_Box"},
14350: {"AegisName":"Mental_Potion50_Box"},
14351: {"AegisName":"Tyr_Blessing_Box20"},
14352: {"AegisName":"Tyr_Blessing_Box50"},
14353: {"AegisName":"F_Greed_Scroll_C20Box"},
14354: {"AegisName":"F_Greed_Scroll_C50Box"},
14355: {"AegisName":"F_Mental_Potion20_Box"},
14356: {"AegisName":"F_Mental_Potion50_Box"},
14357: {"AegisName":"F_Tyr_Blessing_Box20"},
14358: {"AegisName":"F_Tyr_Blessing_Box50"},
14359: {"AegisName":"TaogunkaS_Box"},
14360: {"AegisName":"MistressS_Box"},
14361: {"AegisName":"Orc_HeroS_Box"},
14362: {"AegisName":"Orc_LoadS_Box"},
14363: {"AegisName":"Heart_Scroll"},
14364: {"AegisName":"Job_Manual25_Box1"},
14365: {"AegisName":"Job_Manual25_Box5"},
14366: {"AegisName":"Job_Manual25_Box10"},
14367: {"AegisName":"F_Job_Manual25_Box1"},
14368: {"AegisName":"F_Job_Manual25_Box5"},
14369: {"AegisName":"F_Job_Manual25_Box10"},
14370: {"AegisName":"Goddess_Bless_Box"},
14371: {"AegisName":"Angel_Bless_Box"},
14372: {"AegisName":"Powder_Snow_Box"},
14373: {"AegisName":"Little_Heart_Box"},
14374: {"AegisName":"J_Firecracker_Box"},
14375: {"AegisName":"Holy_Celestial_Axe_Box"},
14376: {"AegisName":"Angeling_Pot_Box"},
14377: {"AegisName":"Shout_Megaphone_Box"},
14378: {"AegisName":"Dun_Tele_Scroll3_Box_fr"},
14379: {"AegisName":"Love_Daddy_Box"},
14380: {"AegisName":"Anubis_Helm_Box"},
14381: {"AegisName":"Piercing_Box_M"},
14382: {"AegisName":"Lich_Bone_Box_M"},
14383: {"AegisName":"Long_Horn_Box_M"},
14384: {"AegisName":"Hunting_Spear_Box_M"},
14385: {"AegisName":"Death_Note_Box_M"},
14386: {"AegisName":"Destruction_Box_M"},
14387: {"AegisName":"Rider_Insignia_Box_M"},
14388: {"AegisName":"Mithril_Cape_Box_M"},
14389: {"AegisName":"Sniping_Box_M"},
14390: {"AegisName":"Orleans_Box_M"},
14391: {"AegisName":"Spiritual_Box_M"},
14392: {"AegisName":"Variant_Box_M"},
14393: {"AegisName":"Almighty_Charm_Box"},
14394: {"AegisName":"Santa_Hat_1_Box"},
14395: {"AegisName":"J_Captain_Hat_Box"},
14396: {"AegisName":"Coke_Hat_Box"},
14397: {"AegisName":"Bonus_Box01"},
14398: {"AegisName":"Bonus_Box02"},
14399: {"AegisName":"Bonus_Box03"},
14400: {"AegisName":"Bonus_Box04"},
14401: {"AegisName":"Bonus_Box05"},
14402: {"AegisName":"Bonus_Box06"},
14403: {"AegisName":"Bonus_Box07"},
14404: {"AegisName":"Bonus_Box08"},
14405: {"AegisName":"Bonus_Box09"},
14406: {"AegisName":"Bonus_Box10"},
14407: {"AegisName":"Xmas_Scroll"},
14408: {"AegisName":"New_Year_Scroll"},
14409: {"AegisName":"F_Santa_Hat_1_Box"},
14410: {"AegisName":"F_Captain_Hat_Box"},
14411: {"AegisName":"F_Coke_Hat_Box"},
14412: {"AegisName":"F_Bonus_Box01"},
14413: {"AegisName":"F_Bonus_Box02"},
14414: {"AegisName":"F_Bonus_Box03"},
14415: {"AegisName":"F_Bonus_Box04"},
14416: {"AegisName":"F_Bonus_Box05"},
14417: {"AegisName":"F_Bonus_Box06"},
14418: {"AegisName":"F_Bonus_Box07"},
14419: {"AegisName":"F_Bonus_Box08"},
14420: {"AegisName":"F_Bonus_Box09"},
14421: {"AegisName":"F_Bonus_Box10"},
14422: {"AegisName":"Shaman's_Old_Paper_Box"},
14423: {"AegisName":"Broken_Sword_Box"},
14424: {"AegisName":"Wing_Of_Bizofnil_Box"},
14426: {"AegisName":"Fortune_Sword_Box_I"},
14427: {"AegisName":"House_Auger_Box_I"},
14428: {"AegisName":"Kamaitachi_Box_I"},
14429: {"AegisName":"Berserk_Guitar_Box_I"},
14430: {"AegisName":"Doom_Slayer_Box_I"},
14431: {"AegisName":"Huuma_Blaze_Box_I"},
14432: {"AegisName":"Odin's_Blessing_Box_I"},
14433: {"AegisName":"Ring_Of_F_Lord_Box_I"},
14434: {"AegisName":"Ring_Of_Reson_Box_I"},
14435: {"AegisName":"Boy's_Cap_Box_I"},
14436: {"AegisName":"Ulle_Cap_Box_I"},
14437: {"AegisName":"Spinx_Helm_Box_I"},
14438: {"AegisName":"Honglyun's_Sword_Box"},
14439: {"AegisName":"Power_Of_Thor_Box"},
14440: {"AegisName":"Dice_Hat_Box"},
14441: {"AegisName":"King_Tiger_Doll_Hat_Box"},
14442: {"AegisName":"Wondering_Wolf_Helm_Box"},
14443: {"AegisName":"Pizza_Hat_Box"},
14444: {"AegisName":"Icecream_Hat_Box"},
14447: {"AegisName":"Pirate's_Pride_Box"},
14448: {"AegisName":"Necromencer's_Hood_Box"},
14449: {"AegisName":"Fugin_Egg01"},
14450: {"AegisName":"Fugin_Egg02"},
14451: {"AegisName":"Fugin_Egg03"},
14452: {"AegisName":"Fugin_Egg04"},
14453: {"AegisName":"Fugin_Egg05"},
14454: {"AegisName":"Fugin_Egg06"},
14455: {"AegisName":"Munin_Egg01"},
14456: {"AegisName":"Munin_Egg02"},
14457: {"AegisName":"Munin_Egg03"},
14458: {"AegisName":"Munin_Egg04"},
14459: {"AegisName":"Rabbit_Magic_Hat_Box"},
14460: {"AegisName":"China_Wedding_Veil_Box"},
14461: {"AegisName":"Asara_Fairy_Hat_Box"},
14462: {"AegisName":"Darkness_Helm_Box2"},
14463: {"AegisName":"New_Cowboy_Hat_Box"},
14464: {"AegisName":"F_Darkness_Helm_Box2"},
14465: {"AegisName":"F_New_Cowboy_Hat_Box"},
14466: {"AegisName":"Valentine_Pledge_Box"},
14467: {"AegisName":"Carnival_Hat_Box"},
14468: {"AegisName":"Carnival_Circlet_Box"},
14469: {"AegisName":"Ox_Tail_Scroll"},
14470: {"AegisName":"T_Nightmare_Box"},
14471: {"AegisName":"T_Loli_Ruri_Box"},
14472: {"AegisName":"T_Goblin_Leader_Box"},
14473: {"AegisName":"T_Incubus_Box"},
14474: {"AegisName":"T_Miyabi_Ningyo_Box"},
14475: {"AegisName":"T_Whisper_Box"},
14476: {"AegisName":"T_Wicked_Nymph_Box"},
14477: {"AegisName":"T_Medusa_Box"},
14478: {"AegisName":"T_Stoneshooter_Box"},
14479: {"AegisName":"T_Marionette_Box"},
14480: {"AegisName":"T_Leafcat_Box"},
14481: {"AegisName":"T_Dullahan_Box"},
14482: {"AegisName":"T_Shinobi_Box"},
14483: {"AegisName":"T_Golem_Box"},
14484: {"AegisName":"T_Civil_Servant_Box"},
14485: {"AegisName":"Academy_Badge_Box"},
14486: {"AegisName":"Academy_Fresh_Hat_Box"},
14487: {"AegisName":"Academy_Gradu_Cap_Box"},
14488: {"AegisName":"Blue_Pajamas_Hat_Box"},
14489: {"AegisName":"Pink_Pajamas_Hat_Box"},
14490: {"AegisName":"Shark_Hat_Box"},
14491: {"AegisName":"Sting_Hat_Box"},
14492: {"AegisName":"FShark_Hat_Box"},
14493: {"AegisName":"FSting_Hat_Box"},
14494: {"AegisName":"Samambaia_Box"},
14495: {"AegisName":"Aquarius_Diadem_Box"},
14496: {"AegisName":"Aquarius_Crown_Box"},
14497: {"AegisName":"Pisces_Diadem_Box"},
14498: {"AegisName":"Pisces_Crown_Box"},
14499: {"AegisName":"Peacock_Feather_Box"},
14500: {"AegisName":"Insurance60"},
14505: {"AegisName":"Dun_1HR_Voucher"},
14506: {"AegisName":"Dun_Voucher"},
14508: {"AegisName":"Zeny_Scroll"},
14509: {"AegisName":"Light_Center_Pot"},
14510: {"AegisName":"Light_Awakening_Pot"},
14511: {"AegisName":"Light_Berserk_Pot"},
14512: {"AegisName":"Meteor_10_Scroll"},
14513: {"AegisName":"Storm_10_Scroll"},
14514: {"AegisName":"Vermilion_10_Scroll"},
14515: {"AegisName":"Lex_Aeterna_Scroll"},
14516: {"AegisName":"Magnificat_5_Scroll"},
14517: {"AegisName":"CP_Helm_Scroll"},
14518: {"AegisName":"CP_Shield_Scroll"},
14519: {"AegisName":"CP_Armor_Scroll"},
14520: {"AegisName":"CP_Weapon_Scroll"},
14521: {"AegisName":"Repair_Scroll"},
14522: {"AegisName":"Big_Bun"},
14523: {"AegisName":"Pill_"},
14524: {"AegisName":"Superb_Fish_Slice"},
14525: {"AegisName":"Chewy_Ricecake"},
14526: {"AegisName":"Oriental_Pastry"},
14527: {"AegisName":"Dun_Tele_Scroll1"},
14528: {"AegisName":"PVP_Tele_Scroll"},
14529: {"AegisName":"Greed_Scroll"},
14530: {"AegisName":"Flee_30_Scroll"},
14531: {"AegisName":"Accuracy_30_Scroll"},
14532: {"AegisName":"Battle_Manual25"},
14533: {"AegisName":"Battle_Manual100"},
14534: {"AegisName":"Small_Life_Potion"},
14535: {"AegisName":"Med_Life_Potion"},
14536: {"AegisName":"Abrasive"},
14537: {"AegisName":"Regeneration_Potion"},
14538: {"AegisName":"Glass_Of_Illusion"},
14539: {"AegisName":"Shadow_Armor_S"},
14540: {"AegisName":"Holy_Armor_S"},
14541: {"AegisName":"S_Def_Potion"},
14542: {"AegisName":"B_Def_Potion"},
14543: {"AegisName":"S_Mdef_Potion"},
14544: {"AegisName":"B_Mdef_Potion"},
14545: {"AegisName":"Battle_Manual_X3"},
14546: {"AegisName":"Fire_Cracker_Love"},
14547: {"AegisName":"Fire_Cracker_Wday"},
14548: {"AegisName":"Fire_Cracker_Vday"},
14549: {"AegisName":"Fire_Cracker_Bday"},
14550: {"AegisName":"Fire_Cracker_Xmas"},
14551: {"AegisName":"Str_Dish01_"},
14552: {"AegisName":"Str_Dish02_"},
14553: {"AegisName":"Str_Dish03_"},
14554: {"AegisName":"Int_Dish01_"},
14555: {"AegisName":"Int_Dish02_"},
14556: {"AegisName":"Int_Dish03_"},
14557: {"AegisName":"Vit_Dish01_"},
14558: {"AegisName":"Vit_Dish02_"},
14559: {"AegisName":"Vit_Dish03_"},
14560: {"AegisName":"Agi_Dish01_"},
14561: {"AegisName":"Agi_Dish02_"},
14562: {"AegisName":"Agi_Dish03_"},
14563: {"AegisName":"Dex_Dish01_"},
14564: {"AegisName":"Dex_Dish02_"},
14565: {"AegisName":"Dex_Dish03_"},
14566: {"AegisName":"Luk_Dish01_"},
14567: {"AegisName":"Luk_Dish02_"},
14568: {"AegisName":"Luk_Dish03_"},
14569: {"AegisName":"Knife_Goblin_Ring"},
14570: {"AegisName":"Flail_Goblin_Ring"},
14571: {"AegisName":"Hammer_Goblin_Ring"},
14572: {"AegisName":"Holy_Marble"},
14573: {"AegisName":"Red_Burning_Stone"},
14574: {"AegisName":"Skull_Of_Vagabond"},
14575: {"AegisName":"Str_Dish05_"},
14576: {"AegisName":"Int_Dish05_"},
14577: {"AegisName":"Vit_Dish05_"},
14578: {"AegisName":"Agi_Dish05_"},
14579: {"AegisName":"Dex_Dish05_"},
14580: {"AegisName":"Luk_Dish05_"},
14581: {"AegisName":"Dun_Tele_Scroll2"},
14582: {"AegisName":"WOB_Rune"},
14583: {"AegisName":"WOB_Schwaltz"},
14584: {"AegisName":"WOB_Rachel"},
14585: {"AegisName":"WOB_Local"},
14586: {"AegisName":"Spark_Candy"},
14587: {"AegisName":"Repair_Scroll_"},
14588: {"AegisName":"Pty_Blessing_Scroll"},
14589: {"AegisName":"Pty_Inc_Agi_Scroll"},
14590: {"AegisName":"Pty_Assumptio_Scroll"},
14591: {"AegisName":"Siege_Teleport_Scroll"},
14592: {"AegisName":"Job_Manual50"},
14593: {"AegisName":"Magic_Power_Scroll"},
14594: {"AegisName":"Quagmire_Scroll"},
14595: {"AegisName":"Unsealed_Magic_Spell"},
14596: {"AegisName":"Pierre_Treasurebox"},
14597: {"AegisName":"PhreeoniS"},
14598: {"AegisName":"GhostringS"},
14599: {"AegisName":"Greed_Scroll_C"},
14600: {"AegisName":"Mental_Potion"},
14601: {"AegisName":"Tyr's_Blessing"},
14602: {"AegisName":"TaogunkaS"},
14603: {"AegisName":"MistressS"},
14604: {"AegisName":"Orc_HeroS"},
14605: {"AegisName":"Orc_LoadS"},
14606: {"AegisName":"Job_Manual25"},
14607: {"AegisName":"Luxurious_Dinner_W"},
14608: {"AegisName":"Luxurious_Dinner_E"},
14609: {"AegisName":"Spoiled_Cuisine"},
14611: {"AegisName":"M_Def_Potion"},
14612: {"AegisName":"M_Mdef_Potion"},
14613: {"AegisName":"RWC_Scroll_2012"},
14614: {"AegisName":"Ex_Def_Potion"},
14616: {"AegisName":"STR_Biscuit_Stick"},
14617: {"AegisName":"VIT_Biscuit_Stick"},
14618: {"AegisName":"AGI_Biscuit_Stick"},
14619: {"AegisName":"INT_Biscuit_Stick"},
14620: {"AegisName":"DEX_Biscuit_Stick"},
14621: {"AegisName":"LUK_Biscuit_Stick"},
14623: {"AegisName":"GoldenTreasureBox"},
14624: {"AegisName":"Blue_Scroll"},
14626: {"AegisName":"Indigo_Scroll"},
14627: {"AegisName":"Xmax_Egg_Kr"},
14628: {"AegisName":"C_Festival_Ticket"},
14629: {"AegisName":"Enchant_Stone_Box"},
14643: {"AegisName":"Violet_Scroll"},
14645: {"AegisName":"Wing_Of_Baalzebub"},
14646: {"AegisName":"Orleans_Full_Course"},
14663: {"AegisName":"Sealed_D_Lord_Scroll"},
14664: {"AegisName":"Bi_Hwang_Scroll"},
14665: {"AegisName":"Jung_Bi_Scroll"},
14666: {"AegisName":"Je_Un_Scroll"},
14667: {"AegisName":"Yong_Kwang_Scroll"},
14672: {"AegisName":"StealFighter_20Lv"},
14673: {"AegisName":"StealFighter_25Lv"},
14674: {"AegisName":"Cup_Of_Boza"},
14675: {"AegisName":"Shadow_Box2"},
14679: {"AegisName":"Sealed_Knight_WS_Scroll"},
14681: {"AegisName":"Enchant_Stone_Box2"},
14682: {"AegisName":"Sealed_Berz_Scroll"},
14689: {"AegisName":"Sealed_Kiel_Scroll"},
14695: {"AegisName":"Enchant_Stone_Box3"},
14696: {"AegisName":"Sealed_Gloom_Scroll"},
14699: {"AegisName":"Garuda_Scroll"},
14701: {"AegisName":"TW_13y_Lucky_Egg_06"},
14704: {"AegisName":"Gemstone_Shadow_Box"},
14705: {"AegisName":"Sealed_F_Bishop_Scroll"},
14713: {"AegisName":"Sealed_Ifrit_Scroll"},
14717: {"AegisName":"2013_RWC_Scroll"},
14718: {"AegisName":"Sealed_TurtleG_Scroll"},
14723: {"AegisName":"LI_Neuralizer"},
14724: {"AegisName":"LI_Neuralizer2"},
14725: {"AegisName":"Sealed_Bacsojin_Scroll"},
14726: {"AegisName":"Greed_Shadow_Box"},
14727: {"AegisName":"Heal_Shadow_Box"},
14728: {"AegisName":"Hiding_Shadow_Box"},
14729: {"AegisName":"Cloaking_Shadow_Box"},
14730: {"AegisName":"Costume_Festival_Box2"},
14731: {"AegisName":"Teleport_Shadow_Box"},
14732: {"AegisName":"Steal_Shadow_Box"},
14733: {"AegisName":"Sealed_Pharaoh_Scroll"},
14735: {"AegisName":"Costama_Egg22"},
14739: {"AegisName":"Sealed_B_Ygnizem_Scroll"},
14740: {"AegisName":"Sealed_Apo_H_Scroll"},
14741: {"AegisName":"Imortal_Midgard_Scroll"},
14753: {"AegisName":"Hero_Midgard_Scroll"},
14758: {"AegisName":"Guarantee_Relax_Scroll"},
14765: {"AegisName":"Job_Manual_Limit"},
14766: {"AegisName":"Limit_Power_Booster"},
14780: {"AegisName":"Pump_Of_Spirit_Scroll"},
14781: {"AegisName":"Happy_Balloon_Scroll"},
14799: {"AegisName":"AID_Manual_Bubble_7d"},
14805: {"AegisName":"July_Lucky_Scroll"},
14826: {"AegisName":"Dungeon_Ticket"},
14840: {"AegisName":"DF_Megaphone"},
14841: {"AegisName":"DF_Songpyun"},
14843: {"AegisName":"DF_Insurance"},
14844: {"AegisName":"DF_Kafra_Card"},
14845: {"AegisName":"DF_Blessing_10_Scroll"},
14846: {"AegisName":"DF_Inc_Agi_10_Scroll"},
14847: {"AegisName":"DF_Small_Life_Potion"},
14849: {"AegisName":"DF_Vit_Dish10"},
14850: {"AegisName":"DF_Luk_Dish10"},
14851: {"AegisName":"DF_Dex_Dish10"},
14852: {"AegisName":"DF_Int_Dish10"},
14853: {"AegisName":"DF_Agi_Dish10"},
14854: {"AegisName":"DF_Str_Dish10"},
14861: {"AegisName":"DF_GhostringS"},
14862: {"AegisName":"DF_Tyr's_Blessing"},
14866: {"AegisName":"DF_Holy_Armor_S"},
14869: {"AegisName":"DF_Red_Booster"},
14875: {"AegisName":"DF_Med_Life_Potion"},
14886: {"AegisName":"UltimateCook_S"},
14887: {"AegisName":"EF_UltimateCook"},
14908: {"AegisName":"Korea_Rice_Cake_B"},
15000: {"AegisName":"Bone_Plate"},
15001: {"AegisName":"Odin's_Blessing_I"},
15002: {"AegisName":"Rune_Plate"},
15003: {"AegisName":"Freyja_SRobe7"},
15004: {"AegisName":"Freyja_SRobe30"},
15005: {"AegisName":"Freyja_SRobe60"},
15006: {"AegisName":"Freyja_SRobe90"},
15007: {"AegisName":"Time_Keepr_Robe"},
15008: {"AegisName":"Flame_Sprits_Armor__"},
15009: {"AegisName":"Para_Team_Uniform1"},
15010: {"AegisName":"Para_Team_Uniform2"},
15011: {"AegisName":"Para_Team_Uniform3"},
15012: {"AegisName":"Puente_Robe"},
15013: {"AegisName":"Claire_Suits"},
15014: {"AegisName":"Ebone_Armor"},
15015: {"AegisName":"Upg_Adv_Suit"},
15016: {"AegisName":"Upg_Coat"},
15017: {"AegisName":"Upg_Saint_Robe"},
15018: {"AegisName":"Upg_Tights"},
15019: {"AegisName":"Upg_Thief_Cloth"},
15020: {"AegisName":"Upg_Mail"},
15021: {"AegisName":"Upg_Formal_Dress"},
15022: {"AegisName":"Brazil_Swimsuit"},
15023: {"AegisName":"Half_Brynhild"},
15024: {"AegisName":"Army_Padding"},
15025: {"AegisName":"Golden_Rod_Robe"},
15026: {"AegisName":"Aqua_Robe"},
15027: {"AegisName":"Crimson_Robe"},
15028: {"AegisName":"Forest_Robe"},
15029: {"AegisName":"Robe_Of_Affection"},
15030: {"AegisName":"Robe_Of_Judgement"},
15031: {"AegisName":"Para_Team_Armor"},
15032: {"AegisName":"Tidung"},
15033: {"AegisName":"Tutorial_Mattle"},
15034: {"AegisName":"Tutorial_Mattle_"},
15035: {"AegisName":"2010Love_Daddy"},
15036: {"AegisName":"Ur_Plate"},
15037: {"AegisName":"Peuz_Plate"},
15038: {"AegisName":"Sabah_Cloth"},
15039: {"AegisName":"Nab_Cloth"},
15040: {"AegisName":"Prison_Uniform"},
15041: {"AegisName":"Boitata_Armor"},
15042: {"AegisName":"White_Wing_Suits"},
15043: {"AegisName":"Black_Wing_Suits"},
15044: {"AegisName":"Green_Operation_Coat"},
15045: {"AegisName":"Armor_Of_Valor"},
15046: {"AegisName":"Siege_Plate"},
15047: {"AegisName":"Siege_Suits"},
15048: {"AegisName":"Siege_Robe"},
15049: {"AegisName":"Armor_Of_Faith"},
15050: {"AegisName":"Armor_Of_Sanctity"},
15051: {"AegisName":"Bakonawa_Armor"},
15052: {"AegisName":"Bayani_Bakonawa_Armor"},
15053: {"AegisName":"Special_Ninja_Suit"},
15054: {"AegisName":"Ninja_Scale_Armor"},
15055: {"AegisName":"Tenebris_Latitantes"},
15056: {"AegisName":"Special_Ninja_Suit_"},
15057: {"AegisName":"Pure_White_Apron"},
15058: {"AegisName":"Rider_Suit"},
15059: {"AegisName":"2011Love_Daddy"},
15060: {"AegisName":"Sky_Blue_Smock"},
15061: {"AegisName":"Egir_Armor"},
15062: {"AegisName":"TE_Woe_Coat"},
15063: {"AegisName":"TE_Woe_Chain_Mail"},
15064: {"AegisName":"TE_Woe_Mage_Coat"},
15065: {"AegisName":"AmeshaSpenta"},
15066: {"AegisName":"Engraved_Armor"},
15067: {"AegisName":"Rune_Suit"},
15068: {"AegisName":"Im_Angel's_Protection"},
15069: {"AegisName":"Suit_Of_Sid"},
15070: {"AegisName":"Robe_Of_Happiness"},
15071: {"AegisName":"Valkyrie_Robe"},
15072: {"AegisName":"Nectar_Suit"},
15073: {"AegisName":"Anti_Magic_Suit"},
15074: {"AegisName":"Geffen_Mage_Robe"},
15075: {"AegisName":"GC_Battle_Armor"},
15076: {"AegisName":"RA_Battle_Armor"},
15077: {"AegisName":"LG_Battle_Armor"},
15078: {"AegisName":"RK_Battle_Armor"},
15079: {"AegisName":"NC_Battle_Armor"},
15080: {"AegisName":"SC_Battle_Armor"},
15081: {"AegisName":"SR_Battle_Armor"},
15082: {"AegisName":"AB_Battle_Armor"},
15083: {"AegisName":"WL_Battle_Armor"},
15084: {"AegisName":"WA_Battle_Armor"},
15085: {"AegisName":"GN_Battle_Armor"},
15086: {"AegisName":"Vermilion_Bird_Armor"},
15087: {"AegisName":"Azure_Dragon_Armor"},
15088: {"AegisName":"School_Uniform"},
15089: {"AegisName":"Lounge_Suit"},
15090: {"AegisName":"Armor_Of_Gray"},
15091: {"AegisName":"Gray_Robe"},
15092: {"AegisName":"Black_Tortoise_Armor"},
15093: {"AegisName":"Hero_Plate"},
15094: {"AegisName":"Hero_Magic_Coat"},
15095: {"AegisName":"Hero_Judgement_Shawl"},
15096: {"AegisName":"Hero_Trade_Mail"},
15097: {"AegisName":"Hero_Hidden_Cloth"},
15098: {"AegisName":"Hero_Taget_Suits"},
15099: {"AegisName":"White_Tiger_Armor"},
15100: {"AegisName":"Frozen_Breastplate"},
15101: {"AegisName":"Harden_Breastplate"},
15102: {"AegisName":"Hunter_Mail"},
15103: {"AegisName":"Kirin_Armor"},
15104: {"AegisName":"FishingMan_Mail"},
15105: {"AegisName":"Kaftan"},
15106: {"AegisName":"Engineer_Mail"},
15107: {"AegisName":"Entomologist_Mail"},
15108: {"AegisName":"VenomInsect_Armor"},
15109: {"AegisName":"Egregori_Mail"},
15110: {"AegisName":"Supplement_Part_Str"},
15111: {"AegisName":"Upgrade_Part_Plate"},
15112: {"AegisName":"Military_Mail"},
15113: {"AegisName":"Exorcist_Mail"},
15114: {"AegisName":"Wedding_Dress_"},
15115: {"AegisName":"Rose_Robe"},
15116: {"AegisName":"Airship_Armor"},
15117: {"AegisName":"Felock_Armor"},
15121: {"AegisName":"Robe_Of_Sarah"},
15122: {"AegisName":"Botany_Mail"},
15123: {"AegisName":"Whikebain_Suit"},
15124: {"AegisName":"Father_Mail"},
15125: {"AegisName":"FemaleDiver_Clothe"},
15126: {"AegisName":"Doram_Only_Suit"},
15127: {"AegisName":"Female_Poring_Earmuff"},
15128: {"AegisName":"Excelion_Suit"},
15129: {"AegisName":"Doram_High_Suit"},
15130: {"AegisName":"Dragon_Mail"},
15134: {"AegisName":"Vicious_Cloth"},
15135: {"AegisName":"Dragon_Cloth"},
15136: {"AegisName":"Tatenasi_Armor"},
15137: {"AegisName":"Tatenasi_Armor_"},
15138: {"AegisName":"Egir_Armor_K"},
15139: {"AegisName":"Shepherd_Cloth"},
15140: {"AegisName":"Natural_Cloth"},
15141: {"AegisName":"Armor_Of_Goddess"},
15142: {"AegisName":"Orca_Cloth"},
15143: {"AegisName":"Vermin_Cloth"},
15144: {"AegisName":"Agricul_Cloth"},
15145: {"AegisName":"EvilDragon_Armor"},
15146: {"AegisName":"Robe_Of_Flattery"},
15147: {"AegisName":"Robe_Of_Vituperation"},
15148: {"AegisName":"Supplement_Part_Str_J"},
15149: {"AegisName":"Upgrade_Part_Plate_J"},
15150: {"AegisName":"White_Shirt"},
15151: {"AegisName":"White_Eco_Shirt"},
15152: {"AegisName":"Union_Mail"},
15153: {"AegisName":"Union_Mattle"},
15154: {"AegisName":"Union_Suit"},
15155: {"AegisName":"Union_Robe"},
15156: {"AegisName":"Doram_Ele_Suit"},
15162: {"AegisName":"Lounge_Suit_"},
15163: {"AegisName":"Agenda_Robe"},
15164: {"AegisName":"Consultation_Robe"},
15165: {"AegisName":"PureWhite_Marching_Hat"},
15166: {"AegisName":"Necklace_Rosary"},
15167: {"AegisName":"Toughen_Time_Keepr_Robe"},
15169: {"AegisName":"Kardui_Robe"},
15170: {"AegisName":"Goibne's_Armor_"},
15171: {"AegisName":"Angeling_Suit"},
15173: {"AegisName":"Cursed_Devils_Mail"},
15174: {"AegisName":"Supper_Swimsuit_K"},
15175: {"AegisName":"Armor_Of_Flamedragon"},
15176: {"AegisName":"Vigilante_Suits"},
15177: {"AegisName":"Robe_Of_Elemental"},
15178: {"AegisName":"Golden_Ninja_Suit"},
15179: {"AegisName":"Mine_Worker_Vest"},
15180: {"AegisName":"Hippie_Cloth"},
15181: {"AegisName":"Para_Team_Armor100"},
15182: {"AegisName":"Para_Team_Armor115"},
15183: {"AegisName":"Para_Team_Armor130"},
15184: {"AegisName":"Para_Team_Armor145"},
15185: {"AegisName":"Para_Team_Armor160"},
15186: {"AegisName":"Kafra_Suit"},
15187: {"AegisName":"Diva_Robe"},
15188: {"AegisName":"Mirage_Robe"},
15189: {"AegisName":"Einherial_Armor"},
15191: {"AegisName":"Khalitzburg_Armor"},
15195: {"AegisName":"Puente_Robe_IL"},
15196: {"AegisName":"Armor_Of_Seadragon"},
15204: {"AegisName":"Abyss_Dress"},
15205: {"AegisName":"Holy_Coat"},
15207: {"AegisName":"2017RTCRobe"},
15208: {"AegisName":"Rora_Plate_Mail"},
15209: {"AegisName":"Drake_Coat"},
15210: {"AegisName":"Rental_SupperSwimsuit"},
15211: {"AegisName":"Return_TW_1th_Armor"},
15212: {"AegisName":"YSF01_Plate"},
15213: {"AegisName":"YSF01_Plate_J"},
15214: {"AegisName":"IA_Dress"},
15215: {"AegisName":"Tatenasi_Armor_TW"},
15216: {"AegisName":"Siege_Robe_1Tier"},
15217: {"AegisName":"Siege_Suits_1Tier"},
15218: {"AegisName":"Siege_Plate_1Tier"},
15219: {"AegisName":"Ghostring_Suit_BR"},
15220: {"AegisName":"60Lv_Suits"},
15221: {"AegisName":"70Lv_Armor"},
15222: {"AegisName":"70Lv_Robe"},
15223: {"AegisName":"80Lv_Mail"},
15224: {"AegisName":"80Lv_Cloth"},
15225: {"AegisName":"80Lv_Robe"},
15226: {"AegisName":"80Lv_Dress"},
15227: {"AegisName":"90Lv_Mail"},
15228: {"AegisName":"90Lv_Cloth"},
15229: {"AegisName":"90Lv_Robe"},
15230: {"AegisName":"90Lv_Dress"},
15231: {"AegisName":"SimpleSuits10"},
15232: {"AegisName":"SimpleSuits20"},
15233: {"AegisName":"SimpleSuits30"},
15234: {"AegisName":"SuitsofKingdom40"},
15235: {"AegisName":"SuitsofKingdom50"},
15236: {"AegisName":"SuitsofKingdom60"},
15237: {"AegisName":"Gods_Armor"},
15238: {"AegisName":"EvilDragon_Armor_BR"},
15239: {"AegisName":"Angeling_Suit_BR"},
15240: {"AegisName":"ArmorOfFlamedragonBR"},
15241: {"AegisName":"Vigilante_Suits_J"},
15242: {"AegisName":"Robe_Of_Elemental_J"},
15243: {"AegisName":"Golden_Ninja_Suit_J"},
15244: {"AegisName":"Mine_Worker_Vest_J"},
15245: {"AegisName":"Hippie_Cloth_J"},
15246: {"AegisName":"True_Hunting_Mail"},
15247: {"AegisName":"R_Hunting_Mail"},
15248: {"AegisName":"Whikebain_Suit_BR"},
15249: {"AegisName":"Antonio_Coat"},
15250: {"AegisName":"Rebeginer_Suits"},
15251: {"AegisName":"D_Leather_Armor"},
15252: {"AegisName":"D_Leather_Robe"},
15253: {"AegisName":"D_Leather_Suits"},
15254: {"AegisName":"Abyss_Dress_BR"},
15255: {"AegisName":"Leather_Jacket_Z"},
15256: {"AegisName":"Adventurer_Suit_Z"},
15257: {"AegisName":"Mantle_Z"},
15258: {"AegisName":"Coat_Z"},
15259: {"AegisName":"Padded_Armor_Z"},
15260: {"AegisName":"Chain_Mail_Z"},
15261: {"AegisName":"Plate_Armor_Z"},
15262: {"AegisName":"Silk_Robe_Z"},
15263: {"AegisName":"Scapulare_Z"},
15264: {"AegisName":"Saint_Robe_Z"},
15265: {"AegisName":"Wooden_Mail_Z"},
15266: {"AegisName":"Tights_Z"},
15267: {"AegisName":"Silver_Robe_Z"},
15268: {"AegisName":"Thief_Clothes_Z"},
15269: {"AegisName":"Leaf_Robe"},
15270: {"AegisName":"Stem_Suits"},
15271: {"AegisName":"Oak_Armor"},
15272: {"AegisName":"Khalitzburg_Armor_BR"},
15273: {"AegisName":"White_Shirt_J"},
15274: {"AegisName":"White_Eco_Shirt_J"},
15275: {"AegisName":"Doram_Only_Suit_J"},
15276: {"AegisName":"Doram_High_Suit_J"},
15277: {"AegisName":"Doram_Ele_Suit_J"},
15278: {"AegisName":"Overwhelm_Str_Armor"},
15279: {"AegisName":"Overwhelm_Int_Armor"},
15280: {"AegisName":"S_CriticalHit_Armor"},
15281: {"AegisName":"Khalitzburg_Armor_Z"},
15282: {"AegisName":"Witchs_White_Shirt"},
15283: {"AegisName":"Armor_of_Rosary"},
15343: {"AegisName":"Supplement_Part_Str_"},
15344: {"AegisName":"Upgrade_Part_Plate_"},
15345: {"AegisName":"ArmorOfSeadragonBR"},
15346: {"AegisName":"Overwhelm_Luk_Armor"},
15347: {"AegisName":"Overwhelm_Vit_Armor"},
15348: {"AegisName":"Goibne_Armor_IL"},
15349: {"AegisName":"Brave_suit"},
15352: {"AegisName":"Nature_Dress"},
15353: {"AegisName":"Overwhelm_Agi_Armor"},
15354: {"AegisName":"Overwhelm_Dex_Armor"},
15362: {"AegisName":"Apollo_Armor_TW"},
15363: {"AegisName":"Mars_Armor_TW"},
15365: {"AegisName":"Vinus_Armor_TW"},
15367: {"AegisName":"Astraea_Armor"},
15369: {"AegisName":"Cylinder_Hairband_BR"},
15372: {"AegisName":"Phreeoni_Wing_BR"},
15374: {"AegisName":"lunar_eclipse_Armor_"},
15375: {"AegisName":"lunar_eclipse_Armor"},
15376: {"AegisName":"Illusion_Armor_A"},
15377: {"AegisName":"Illusion_Armor_B"},
15378: {"AegisName":"Lava_Leather_Armor"},
15379: {"AegisName":"Lava_Leather_Suits"},
15380: {"AegisName":"Lava_Leather_Robe"},
15383: {"AegisName":"Time_Overload_Robe"},
15384: {"AegisName":"Rite_Robe"},
15385: {"AegisName":"MemorialD_Assistant"},
15386: {"AegisName":"Kings_Mail"},
15387: {"AegisName":"Jirant_Dress"},
15388: {"AegisName":"Schmidt_Suits"},
15389: {"AegisName":"Schmidt_Manteau"},
15390: {"AegisName":"Regia_Hunting_Mail"},
15391: {"AegisName":"DragonA_Red"},
15392: {"AegisName":"DragonA_Green"},
15393: {"AegisName":"DragonA_Gold"},
15394: {"AegisName":"DragonA_Purple"},
15395: {"AegisName":"DragonA_Blue"},
15396: {"AegisName":"DragonA_Silver"},
15397: {"AegisName":"CassockA_STR"},
15398: {"AegisName":"CassockA_AGI"},
15399: {"AegisName":"CassockA_VIT"},
15400: {"AegisName":"CassockA_DEX"},
15401: {"AegisName":"CassockA_INT"},
15402: {"AegisName":"CassockA_LUK"},
15405: {"AegisName":"Fafnir_Scale_J"},
15407: {"AegisName":"WhiteknightArmor"},
15408: {"AegisName":"Leo_Mail_J"},
15409: {"AegisName":"Bloody_Dress"},
15410: {"AegisName":"H_AD_Suits"},
15412: {"AegisName":"Cancer_Mail_J"},
15417: {"AegisName":"Armor_of_Purple_Thread"},
15418: {"AegisName":"Libra_Mail_J"},
15419: {"AegisName":"Armor_of_White_Thread"},
15420: {"AegisName":"Icefall_Dress"},
15421: {"AegisName":"Triad_God_Mail_J_"},
15424: {"AegisName":"Scorpio_Mail_J"},
15425: {"AegisName":"Taurus_Mail_J"},
15426: {"AegisName":"Aquarius_Mail_J"},
15430: {"AegisName":"Diana_Suits"},
15431: {"AegisName":"Mercury_Suits"},
15432: {"AegisName":"Bacchus_Armor"},
15433: {"AegisName":"Neptune_Uniform"},
15434: {"AegisName":"Golden_Angel_Statue_YG"},
15440: {"AegisName":"Fierce_Physique_Armor_E"},
15441: {"AegisName":"Fierce_Magique_Armor_E"},
15442: {"AegisName":"Fierce_Physique_Manteau"},
15443: {"AegisName":"Fierce_Magique_Manteau"},
15444: {"AegisName":"Night_Owl_Shawl_EXE"},
15446: {"AegisName":"Cetrion_Ring_EXE"},
15447: {"AegisName":"Pollux_Robe_J"},
15448: {"AegisName":"Procyon_Robe_J"},
15449: {"AegisName":"Skarlet_Robe_EXE"},
15450: {"AegisName":"SKahn_Yoroi_EXE"},
15451: {"AegisName":"Albatross_Armor_EXE"},
15460: {"AegisName":"Rachel_Armor"},
15461: {"AegisName":"Apollo_Armor_TH"},
15462: {"AegisName":"Jupiter_Armor_TH"},
15463: {"AegisName":"Mars_Armor_TH"},
15464: {"AegisName":"Ceres_Armor_TH"},
15465: {"AegisName":"Vinus_Armor_TH"},
15466: {"AegisName":"Vulcan_Armor_TH"},
15467: {"AegisName":"Neptune_Armor_TH"},
15468: {"AegisName":"Neptune_ArmorDoram_TH"},
15469: {"AegisName":"aegis_15469"},
15470: {"AegisName":"aegis_15470"},
15471: {"AegisName":"ROZ_FV_CassockA_VIT"},
15472: {"AegisName":"Comp_Kafra_Suit"},
15473: {"AegisName":"Comp_Overwhelm_Str_Armo"},
15474: {"AegisName":"Comp_Overwhelm_V_Armor"},
15475: {"AegisName":"Comp_Overwh_Agi_Armor"},
15476: {"AegisName":"aegis_15476"},
15477: {"AegisName":"Comp_Overwh_D_Armor"},
15478: {"AegisName":"Comp_Overwh_L_Armor"},
15479: {"AegisName":"aegis_15479"},
15480: {"AegisName":"aegis_15480"},
15481: {"AegisName":"aegis_15481"},
15482: {"AegisName":"aegis_15482"},
15483: {"AegisName":"aegis_15483"},
15484: {"AegisName":"aegis_15484"},
15822: {"AegisName":"Magaleta_Ribbon_EXE"},
15823: {"AegisName":"Golden_Crown_J"},
15824: {"AegisName":"Phoenix_Crown_J"},
15825: {"AegisName":"C_Black_Musang_J"},
15826: {"AegisName":"Seyrandel_Hat_EXE"},
15827: {"AegisName":"Ceryne_Hat_EXE"},
15828: {"AegisName":"Germes_Hat_EXE"},
15829: {"AegisName":"Flaward_Hat_EXE"},
15830: {"AegisName":"Germes_Horn_EXE"},
15831: {"AegisName":"Kuken_Hat_EXE"},
15832: {"AegisName":"Cetrion_Circlet_EXE"},
15833: {"AegisName":"Cetrion_Bracelet_EXE"},
15834: {"AegisName":"DRaiden_Sakkat_EXE"},
15835: {"AegisName":"STsung_Speller1_EXE"},
15836: {"AegisName":"C_Skarlet_Band_EXE"},
15838: {"AegisName":"C_VesperHeadGear_J"},
15839: {"AegisName":"C_Droop_Gunslinger_J"},
15840: {"AegisName":"C_Bio_Protector"},
15841: {"AegisName":"C_Hat_of_Goggle"},
15842: {"AegisName":"C_Disapear_Time_J"},
15843: {"AegisName":"C_Hunters_Dinner"},
15844: {"AegisName":"C_Cow_Hat1_J"},
15845: {"AegisName":"Shaokahn_Helmet_EXE"},
15846: {"AegisName":"C_Artist_Silk_Hat"},
15847: {"AegisName":"C_EXE_Wing_Cap_TH"},
15848: {"AegisName":"Motaro_Horn_EXE"},
15849: {"AegisName":"Kintaro_Bracelet_EXE"},
15850: {"AegisName":"STsung_Speller2_EXE"},
15851: {"AegisName":"C_Freyja_Crown_J"},
15853: {"AegisName":"C_Gold_Ingot_Poring_J"},
15855: {"AegisName":"Ermac_Veil_EXE"},
15856: {"AegisName":"Kronika_Orb_EXE"},
15857: {"AegisName":"Shang_Rainbow_EXE"},
15858: {"AegisName":"C_Choco_Banana"},
15875: {"AegisName":"C_King_Of_Spirit_Circle"},
15876: {"AegisName":"C_RTC_Second_Best"},
15877: {"AegisName":"C_P_blossom_Hairpin"},
15878: {"AegisName":"Joker_Card_EXE"},
15879: {"AegisName":"KungJin_Headpiece_EXE"},
15880: {"AegisName":"Joker_Face_EXE"},
15881: {"AegisName":"C_Rose_Crispinette"},
15882: {"AegisName":"C_Rhythm_Hairband"},
15883: {"AegisName":"Nezuko_Eyes_EXE"},
15884: {"AegisName":"Nezuko_Bamboo_EXE"},
15885: {"AegisName":"Erron_Hat_EXE"},
15887: {"AegisName":"Odious_Robe_EXE"},
15888: {"AegisName":"C_Hand_Of_Devil"},
15889: {"AegisName":"C_Boitata_Hat_J"},
15890: {"AegisName":"C_BLACKDEATHKING_GOLDEN"},
15891: {"AegisName":"Mountain_Helmet"},
15892: {"AegisName":"Themis_Helm"},
15893: {"AegisName":"C_Helm_Of_Sun_V"},
15894: {"AegisName":"C_Rebirth_Circlet"},
15897: {"AegisName":"Rebirth_Circlet"},
15898: {"AegisName":"Kings_Crown_A"},
15899: {"AegisName":"C_Kings_Crown_A"},
15904: {"AegisName":"C_Love_Guard_V"},
15905: {"AegisName":"C_Helmet_Of_Siegfried_J"},
15906: {"AegisName":"Northern_Cross"},
15920: {"AegisName":"Charm_Of_Flame_Heart_BR"},
15921: {"AegisName":"Charm_Of_Nature_BR"},
15922: {"AegisName":"Charm_Of_Frozen_BR"},
15923: {"AegisName":"Charm_Of_Wind_BR"},
15924: {"AegisName":"Tatoo_Brush_BR"},
15925: {"AegisName":"aegis_15925"},
15926: {"AegisName":"aegis_15926"},
15927: {"AegisName":"aegis_15927"},
15928: {"AegisName":"aegis_15928"},
15932: {"AegisName":"aegis_15932"},
15945: {"AegisName":"aegis_15945"},
15947: {"AegisName":"Comp_Blue_Rear_Ribbon"},
15948: {"AegisName":"aegis_15948"},
15949: {"AegisName":"aegis_15949"},
15950: {"AegisName":"aegis_15950"},
15951: {"AegisName":"aegis_15951"},
15952: {"AegisName":"aegis_15952"},
15953: {"AegisName":"C_Somtam"},
15954: {"AegisName":"aegis_15954"},
15955: {"AegisName":"aegis_15955"},
15956: {"AegisName":"aegis_15956"},
15957: {"AegisName":"aegis_15957"},
15958: {"AegisName":"aegis_15958"},
15959: {"AegisName":"Comp_Phantom_Cap"},
15960: {"AegisName":"Comp_Scorpio_Diadem_K"},
15961: {"AegisName":"Comp_Clock_Casket_RD"},
15962: {"AegisName":"Comp_L_Sorcerer_Crown"},
15963: {"AegisName":"Comp_Ignis_CapK"},
15964: {"AegisName":"Comp_Sagi_DiademK"},
15965: {"AegisName":"Comp_Stripe_Hat"},
15966: {"AegisName":"aegis_15966"},
15967: {"AegisName":"aegis_15967"},
15968: {"AegisName":"aegis_15968"},
15969: {"AegisName":"aegis_15969"},
15970: {"AegisName":"aegis_15970"},
15976: {"AegisName":"aegis_15976"},
15977: {"AegisName":"aegis_15977"},
15978: {"AegisName":"aegis_15978"},
15980: {"AegisName":"aegis_15980"},
15981: {"AegisName":"aegis_15981"},
15982: {"AegisName":"aegis_15982"},
15983: {"AegisName":"aegis_15983"},
15984: {"AegisName":"aegis_15984"},
15985: {"AegisName":"aegis_15985"},
16000: {"AegisName":"Erde"},
16001: {"AegisName":"Red_Square_Bag"},
16002: {"AegisName":"Stunner_C"},
16003: {"AegisName":"Carga_Mace"},
16004: {"AegisName":"P_Mace1"},
16005: {"AegisName":"P_Mace2"},
16006: {"AegisName":"Tourist_Mace"},
16007: {"AegisName":"Mjolnir_C"},
16008: {"AegisName":"F_Spanner_C"},
16009: {"AegisName":"E_Spanner_C"},
16010: {"AegisName":"Red_Ether_Bag"},
16011: {"AegisName":"Adventure_Mace"},
16012: {"AegisName":"Academy_Mace"},
16013: {"AegisName":"Mace_Of_Judgement"},
16014: {"AegisName":"P_Mace3"},
16015: {"AegisName":"Cat_Club"},
16016: {"AegisName":"Tuna"},
16017: {"AegisName":"Bloody_Cross"},
16018: {"AegisName":"Mace_Of_Judgement2"},
16019: {"AegisName":"Upg_Mace"},
16020: {"AegisName":"Velum_Stunner"},
16021: {"AegisName":"Velum_Flail"},
16022: {"AegisName":"Nemesis_"},
16023: {"AegisName":"Metal_Mace"},
16024: {"AegisName":"Quadrille_"},
16025: {"AegisName":"TE_Woe_Mace"},
16026: {"AegisName":"RWC_Memory_Mace"},
16027: {"AegisName":"Hammer_Of_Evil_Slayer"},
16028: {"AegisName":"Thanos_Hammer"},
16029: {"AegisName":"Noble_Cross"},
16030: {"AegisName":"Pilebuncker_S"},
16031: {"AegisName":"Pilebuncker_P"},
16032: {"AegisName":"Pilebuncker_T"},
16033: {"AegisName":"Robot's_Arm"},
16034: {"AegisName":"Half_Mjolnir"},
16035: {"AegisName":"Half_BF_Morning_Star1"},
16036: {"AegisName":"Ru_Blue_Mace"},
16037: {"AegisName":"Ru_Gold_Mace"},
16038: {"AegisName":"Mace_Of_Infinite"},
16039: {"AegisName":"Spoon"},
16040: {"AegisName":"Scarlet_Mace"},
16041: {"AegisName":"Sinister_Mace"},
16043: {"AegisName":"Meteor_Strike"},
16048: {"AegisName":"Union_Mace"},
16049: {"AegisName":"Mace_of_Trust"},
16050: {"AegisName":"Mace_of_Trust2"},
16051: {"AegisName":"Valkyrie_Hammer"},
16052: {"AegisName":"Iron_Driver_"},
16053: {"AegisName":"Lora_Iron_Ball"},
16054: {"AegisName":"Toughen_Metal_Mace"},
16055: {"AegisName":"UnrivaledMace"},
16056: {"AegisName":"Veteran_Hammer_"},
16057: {"AegisName":"Blue_Mace"},
16058: {"AegisName":"Diva_Mace"},
16059: {"AegisName":"Mirage_Mace"},
16060: {"AegisName":"Bottle"},
16061: {"AegisName":"Sinister_Mace_J"},
16063: {"AegisName":"Long_Mace_IL"},
16064: {"AegisName":"Probation_Mace"},
16065: {"AegisName":"Iron_Driver_IL"},
16075: {"AegisName":"Rebeginer_NC_Mace"},
16076: {"AegisName":"Rebeginer_N2_Mace"},
16083: {"AegisName":"Local01_Mace"},
16084: {"AegisName":"Local02_Mace"},
16085: {"AegisName":"Woe_Club_1_Z"},
16087: {"AegisName":"Variant_Mace"},
16088: {"AegisName":"Saphir_Hall_OS"},
16089: {"AegisName":"Ultio_Spes_OS"},
16092: {"AegisName":"Engine_Pilebuncker"},
16093: {"AegisName":"Coolant_Injection"},
16094: {"AegisName":"Gene_Rod"},
16095: {"AegisName":"Lucis_Flail"},
16096: {"AegisName":"Bright_Mace"},
16098: {"AegisName":"Leo_Mace_J"},
16099: {"AegisName":"Ein_1HHAMMER"},
16100: {"AegisName":"Angry_Mouth_C_Box"},
16101: {"AegisName":"KRO_Lucky_Box"},
16102: {"AegisName":"Claymore_C_box"},
16103: {"AegisName":"Jamadhar_C_Box"},
16104: {"AegisName":"Two_Handed_Axe_C_Box"},
16105: {"AegisName":"Lance_C_Box"},
16106: {"AegisName":"Huuma_Giant_Wheel_C_Box"},
16107: {"AegisName":"Orcish_Axe_C_Box"},
16108: {"AegisName":"Pike_C_Box"},
16109: {"AegisName":"Encyclopedia_C_Box"},
16110: {"AegisName":"Fist_C_Box"},
16111: {"AegisName":"Guitar_C_Box"},
16112: {"AegisName":"Rante_C_Box"},
16113: {"AegisName":"Damascus_C_Box"},
16114: {"AegisName":"Flamberge_C_Box"},
16115: {"AegisName":"Stunner_C_Box"},
16116: {"AegisName":"F_KRO_Lucky_Box"},
16117: {"AegisName":"F_Claymore_C_box"},
16118: {"AegisName":"F_Jamadhar_C_Box"},
16119: {"AegisName":"F_Two_Handed_Axe_C_Box"},
16120: {"AegisName":"F_Lance_C_Box"},
16121: {"AegisName":"F_Huuma_Giant_C_Box"},
16122: {"AegisName":"F_Orcish_Axe_C_Box"},
16123: {"AegisName":"F_Pike_C_Box"},
16124: {"AegisName":"F_Encyclopedia_C_Box"},
16125: {"AegisName":"F_Fist_C_Box"},
16126: {"AegisName":"F_Guitar_C_Box"},
16127: {"AegisName":"F_Rante_C_Box"},
16128: {"AegisName":"F_Damascus_C_Box"},
16129: {"AegisName":"F_Flamberge_C_Box"},
16130: {"AegisName":"F_Stunner_C_Box"},
16131: {"AegisName":"Lady_Tanee_Doll_Box"},
16132: {"AegisName":"Lunatic_Hat_Box"},
16133: {"AegisName":"G_Staff_Of_Light_Box"},
16134: {"AegisName":"King_Frog_Hat_Box"},
16135: {"AegisName":"Evil's_Bone_Hat_Box"},
16136: {"AegisName":"Goddess_Bless10_Box"},
16137: {"AegisName":"Angel_Bless10_Box"},
16138: {"AegisName":"Powder_Snow10_Box"},
16139: {"AegisName":"Little_Heart10_Box"},
16140: {"AegisName":"J_Firecracker10_Box"},
16141: {"AegisName":"Golden_Earing_Box"},
16142: {"AegisName":"Green_Lucky_Bag_Box"},
16143: {"AegisName":"F_Glasses_Box"},
16144: {"AegisName":"Star_Hairband_Box"},
16145: {"AegisName":"Wine_On_Sleeve_Box"},
16146: {"AegisName":"Spirit_Chain_Box"},
16147: {"AegisName":"Nice_Badge_Box"},
16148: {"AegisName":"Jade_Trinket_Box"},
16149: {"AegisName":"Summer_Fan_Box"},
16150: {"AegisName":"Death_Coil_Box"},
16151: {"AegisName":"Queen's_Coronet_Box"},
16152: {"AegisName":"Apro_Hair_Box"},
16153: {"AegisName":"Ball_Mask_Box"},
16154: {"AegisName":"Windup_Spring_Box"},
16155: {"AegisName":"Hell_Horn_Box"},
16156: {"AegisName":"Poring_Tck_Box"},
16157: {"AegisName":"Drops_Tck_Box"},
16158: {"AegisName":"Poporing_Tck_Box"},
16159: {"AegisName":"Lunatic_Tck_Box"},
16160: {"AegisName":"Picky_Tck_Box"},
16161: {"AegisName":"Pecopeco_Tck_Box"},
16162: {"AegisName":"Savage_Baby_Tck_Box"},
16163: {"AegisName":"Spore_Tck_Box"},
16164: {"AegisName":"Poison_Spore_Tck_Box"},
16165: {"AegisName":"Chonchon_Tck_Box"},
16166: {"AegisName":"Steel_Chonchon_Tck_Box"},
16167: {"AegisName":"Petit_Tck_Box"},
16168: {"AegisName":"Deviruchi_Tck_Box"},
16169: {"AegisName":"Isis_Tck_Box"},
16170: {"AegisName":"Smokie_Tck_Box"},
16171: {"AegisName":"Dokebi_Tck_Box"},
16172: {"AegisName":"Desert_Wolf_B_Tck_Box"},
16173: {"AegisName":"Yoyo_Tck_Box"},
16174: {"AegisName":"Sohee_Tck_Box"},
16175: {"AegisName":"Rocker_Tck_Box"},
16176: {"AegisName":"Hunter_Fly_Tck_Box"},
16177: {"AegisName":"Orc_Warrior_Tck_Box"},
16178: {"AegisName":"Bapho_Jr_Tck_Box"},
16179: {"AegisName":"Munak_Tck_Box"},
16180: {"AegisName":"Bongun_Tck_Box"},
16181: {"AegisName":"Goblin_Tck_Box"},
16182: {"AegisName":"Hardtack_Tck_Box"},
16183: {"AegisName":"Zherlthsh_Tck_Box"},
16184: {"AegisName":"Alice_Tck_Box"},
16185: {"AegisName":"Raven_Cap_Box"},
16186: {"AegisName":"B_Dragon_Hat_Box"},
16187: {"AegisName":"F_Angry_Mouth_C_Box"},
16188: {"AegisName":"Bunny_Magic_Hat_Box"},
16189: {"AegisName":"Side_Cap_Box"},
16190: {"AegisName":"F_Rabbit_Magic_Hat_Box"},
16191: {"AegisName":"F_Side_Cap_Box"},
16192: {"AegisName":"Quati_Hat_Box"},
16193: {"AegisName":"Tucan_Hat_Box"},
16194: {"AegisName":"Jaguar_Hat_Box"},
16195: {"AegisName":"Tw_March_Scroll"},
16196: {"AegisName":"Freyja_Shield_Box7"},
16197: {"AegisName":"Freyja_Shield_Box30"},
16198: {"AegisName":"Freyja_Shield_Box60"},
16199: {"AegisName":"Freyja_Shield_Box90"},
16200: {"AegisName":"Freyja_Robe_Box7"},
16201: {"AegisName":"Freyja_Robe_Box30"},
16202: {"AegisName":"Freyja_Robe_Box60"},
16203: {"AegisName":"Freyja_Robe_Box90"},
16204: {"AegisName":"Freyja_Scarf_Box7"},
16205: {"AegisName":"Freyja_Scarf_Box30"},
16206: {"AegisName":"Freyja_Scarf_Box60"},
16207: {"AegisName":"Freyja_Scarf_Box90"},
16208: {"AegisName":"Freyja_Sandal_Box7"},
16209: {"AegisName":"Freyja_Sandal_Box30"},
16210: {"AegisName":"Freyja_Sandal_Box60"},
16211: {"AegisName":"Freyja_Sandal_Box90"},
16212: {"AegisName":"Freyja_Circlet_Box7"},
16213: {"AegisName":"Freyja_Circlet_Box30"},
16214: {"AegisName":"Freyja_Circlet_Box60"},
16215: {"AegisName":"Freyja_Circlet_Box90"},
16216: {"AegisName":"Freyja_Bracelet_Box7"},
16217: {"AegisName":"Freyja_Bracelet_Box30"},
16218: {"AegisName":"Freyja_Bracelet_Box60"},
16219: {"AegisName":"Freyja_Bracelet_Box90"},
16220: {"AegisName":"Marionette_C_Box"},
16221: {"AegisName":"Whisper_C_Box"},
16222: {"AegisName":"Incubus_C_Box"},
16223: {"AegisName":"F_Marionette_C_Box"},
16224: {"AegisName":"F_Whisper_C_Box"},
16225: {"AegisName":"F_Incubus_C_Box"},
16226: {"AegisName":"Aries_Diadem_Box"},
16227: {"AegisName":"Aries_Crown_Box"},
16228: {"AegisName":"RJC_Katusa_Box"},
16229: {"AegisName":"Scarlet_Rose_Box"},
16230: {"AegisName":"Taurus_Diadem_Box"},
16231: {"AegisName":"Taurus_Crown_Box"},
16232: {"AegisName":"Reginleif_Box"},
16233: {"AegisName":"Fest_Lord_Circlet_Box"},
16234: {"AegisName":"Fest_Bunny_Band_Box"},
16235: {"AegisName":"Octopus_Hat_Box"},
16236: {"AegisName":"Leaf_Cat_Hat_Box"},
16237: {"AegisName":"Fur_Seal_Hat_Box"},
16238: {"AegisName":"Wild_Rose_Hat_Box"},
16239: {"AegisName":"Saci_Hat_Box"},
16240: {"AegisName":"Whikebain_Ears_Box"},
16241: {"AegisName":"Chicken_Hat_Box"},
16242: {"AegisName":"F_Whikebain_Ears_Box"},
16243: {"AegisName":"F_Chicken_Hat_Box"},
16244: {"AegisName":"Dolor_Hat_Box"},
16245: {"AegisName":"Tw_April_Scroll"},
16246: {"AegisName":"Crown_Of_Deceit_Box"},
16247: {"AegisName":"Dragon_Arhat_Mask_Box"},
16248: {"AegisName":"Tiger_Arhat_Mask_Box"},
16249: {"AegisName":"Knight_Gift_Box"},
16250: {"AegisName":"Valkyriee_Gift"},
16251: {"AegisName":"Gemini_Diadem_Box"},
16252: {"AegisName":"Gemini_Crown_Box"},
16253: {"AegisName":"Rabbit_Scroll"},
16254: {"AegisName":"Acti_Potion_Box"},
16255: {"AegisName":"F_Acti_Potion_Box"},
16256: {"AegisName":"RO_DS_Headgear_Box"},
16257: {"AegisName":"Buddah_Scroll"},
16258: {"AegisName":"HD_Bradium_Box5"},
16259: {"AegisName":"HD_Carnium_Box5"},
16260: {"AegisName":"HD_Bradium_Box10"},
16261: {"AegisName":"HD_Carnium_Box10"},
16262: {"AegisName":"F_HD_Bradium_Box5"},
16263: {"AegisName":"F_HD_Carnium_Box5"},
16264: {"AegisName":"F_HD_Bradium_Box10"},
16265: {"AegisName":"F_HD_Carnium_Box10"},
16266: {"AegisName":"Idn_Inde_Beret_Box"},
16267: {"AegisName":"HE_Battle_Manual_Box"},
16268: {"AegisName":"HE_Bubble_Gum_Box"},
16269: {"AegisName":"Cancer_Diadem_Box"},
16270: {"AegisName":"Cancer_Crown_Box"},
16271: {"AegisName":"Hockey_Mask_Box1"},
16272: {"AegisName":"Observer_Box1"},
16273: {"AegisName":"All_In_One_Ring_Box1"},
16274: {"AegisName":"Spritual_Tunic_Box1"},
16275: {"AegisName":"Recuperative_Armor_Box1"},
16276: {"AegisName":"Shelter_Resist_Box1"},
16277: {"AegisName":"Sylphid_Manteau_Box1"},
16278: {"AegisName":"Refresh_Shoes_Box1"},
16279: {"AegisName":"Well_Baked_Toast_Box1"},
16280: {"AegisName":"Wasteland_Outlaw_Box1"},
16281: {"AegisName":"Lever_Act_Rifle_Box1"},
16282: {"AegisName":"Healing_Staff_Box1"},
16283: {"AegisName":"Praxinus_Box1"},
16284: {"AegisName":"Guild_Recruit_Box1"},
16285: {"AegisName":"Party_Recruit_Hat_Box1"},
16286: {"AegisName":"Bf_Recruit_Hat_Box1"},
16287: {"AegisName":"Gf_Recruit_Hat_Box1"},
16288: {"AegisName":"Friend_Recruit_Hat_Box1"},
16289: {"AegisName":"Claymore_C_box1"},
16290: {"AegisName":"Two_Handed_Axe_C_Box1"},
16291: {"AegisName":"Lance_C_Box1"},
16292: {"AegisName":"Jamadhar_C_Box1"},
16293: {"AegisName":"Huuma_Giant_C_Box1"},
16294: {"AegisName":"Orcish_Axe_C_Box1"},
16295: {"AegisName":"Pike_C_Box1"},
16296: {"AegisName":"Encyclopedia_C_Box1"},
16297: {"AegisName":"Fist_C_Box1"},
16298: {"AegisName":"Guitar_C_Box1"},
16299: {"AegisName":"Rante_C_Box1"},
16300: {"AegisName":"Damascus_C_Box1"},
16301: {"AegisName":"Flamberge_C_Box1"},
16302: {"AegisName":"Stunner_C_Box1"},
16303: {"AegisName":"Angry_Mouth_C_Box1"},
16304: {"AegisName":"Evil_Incarnation_Disabl"},
16305: {"AegisName":"Upg_Guard_Box"},
16306: {"AegisName":"F_Upg_Guard_Box"},
16307: {"AegisName":"Upg_Buckler_Box"},
16308: {"AegisName":"F_Upg_Buckler_Box"},
16309: {"AegisName":"Upg_Shield_Box"},
16310: {"AegisName":"F_Upg_Shield_Box"},
16311: {"AegisName":"Upg_Shoes_Box"},
16312: {"AegisName":"F_Upg_Shoes_Box"},
16313: {"AegisName":"Upg_Boots_Box"},
16314: {"AegisName":"F_Upg_Boots_Box"},
16315: {"AegisName":"Upg_Greave_Box"},
16316: {"AegisName":"F_Upg_Greave_Box"},
16317: {"AegisName":"Upg_Hood_Box"},
16318: {"AegisName":"F_Upg_Hood_Box"},
16319: {"AegisName":"Upg_Muffler_Box"},
16320: {"AegisName":"F_Upg_Muffler_Box"},
16321: {"AegisName":"Upg_Manteau_Box"},
16322: {"AegisName":"F_Upg_Manteau_Box"},
16323: {"AegisName":"Upg_Clip_Box"},
16324: {"AegisName":"F_Upg_Clip_Box"},
16325: {"AegisName":"Rune_Hairband_Box"},
16326: {"AegisName":"F_Rune_Hairband_Box"},
16327: {"AegisName":"Upg_Adv_Suit_Box"},
16328: {"AegisName":"F_Upg_Adv_Suit_Box"},
16329: {"AegisName":"Upg_Coat_Box"},
16330: {"AegisName":"F_Upg_Coat_Box"},
16331: {"AegisName":"Upg_Saint_Robe_Box"},
16332: {"AegisName":"F_Upg_Saint_Robe_Box"},
16333: {"AegisName":"Upg_Tights_Box"},
16334: {"AegisName":"F_Upg_Tights_Box"},
16335: {"AegisName":"Upg_Thief_Cloth_Box"},
16336: {"AegisName":"F_Upg_Thief_Cloth_Box"},
16337: {"AegisName":"Upg_Mail_Box"},
16338: {"AegisName":"F_Upg_Mail_Box"},
16339: {"AegisName":"Upg_Formal_Dress_Box"},
16340: {"AegisName":"F_Upg_Formal_Dress_Box"},
16341: {"AegisName":"Greed_Clip_Box"},
16342: {"AegisName":"F_Greed_Clip_Box"},
16343: {"AegisName":"Leo_Crown_Box"},
16344: {"AegisName":"Leo_Diadem_Box"},
16345: {"AegisName":"F_Leo_Crown_Box"},
16346: {"AegisName":"F_Leo_Diadem_Box"},
16347: {"AegisName":"Shooting_Star_C_Box"},
16348: {"AegisName":"Bloody_Fear_C_Box"},
16349: {"AegisName":"Ahlspiess_C_Box"},
16350: {"AegisName":"Staff_Of_Healing_C_Box"},
16351: {"AegisName":"Anti_Demon_Shield_C_Box"},
16352: {"AegisName":"F_Shooting_Star_C_Box"},
16353: {"AegisName":"F_Bloody_Fear_C_Box"},
16354: {"AegisName":"F_Ahlspiess_C_Box"},
16355: {"AegisName":"F_S_Healing_C_Box"},
16356: {"AegisName":"F_A_Demon_Shield_C_Box"},
16357: {"AegisName":"F_Evils_Bone_Hat_Box"},
16358: {"AegisName":"Mbl_Pet_Random_Box"},
16359: {"AegisName":"7th_Anni_Random_Box"},
16360: {"AegisName":"Desert_Prince_Box"},
16361: {"AegisName":"FDesert_Prince_Box"},
16362: {"AegisName":"Sigrun's_Wing_Box"},
16363: {"AegisName":"FSigrun's_Wing_Box"},
16364: {"AegisName":"Sleipnir_Box"},
16365: {"AegisName":"Magingiorde_Box"},
16366: {"AegisName":"Brysinggamen_Box"},
16367: {"AegisName":"Mjolnir_Box"},
16368: {"AegisName":"Virgo_Crown_Box"},
16369: {"AegisName":"Freyja_Ring_Box"},
16370: {"AegisName":"F_Freyja_Ring_Box"},
16371: {"AegisName":"Tw_Aug_Scroll"},
16372: {"AegisName":"Clover_Box_Mouth"},
16373: {"AegisName":"F_Clover_Box_Mouth"},
16374: {"AegisName":"Bgum_Mouth_Box"},
16375: {"AegisName":"F_BGum_Box_In_Mouth"},
16376: {"AegisName":"Odin's_Recall7"},
16377: {"AegisName":"Odin's_Recall30"},
16378: {"AegisName":"Siege_Scroll_Box30"},
16379: {"AegisName":"Tele_Scroll2_Box10"},
16380: {"AegisName":"S_Tele_Scroll2_Box30"},
16381: {"AegisName":"F_Siege_Tele_10Sc_Box"},
16382: {"AegisName":"F_Siege_Scroll_Box1_30"},
16383: {"AegisName":"F_Siege_Scroll_Box2_10"},
16384: {"AegisName":"F_Siege_Scroll_Box2_30"},
16385: {"AegisName":"Clover_Box_Mouth2"},
16386: {"AegisName":"Clover_Box_Mouth4"},
16387: {"AegisName":"F_Clover_Box_Mouth2"},
16388: {"AegisName":"F_Clover_Box_Mouth4"},
16389: {"AegisName":"BGum_Box_In_Mouth2"},
16390: {"AegisName":"BGum_Box_In_Mouth4"},
16391: {"AegisName":"F_BGum_Box_In_Mouth2"},
16392: {"AegisName":"F_BGum_Box_In_Mouth4"},
16393: {"AegisName":"HD_Ori_Box5"},
16394: {"AegisName":"HD_Ori_Box10"},
16395: {"AegisName":"HD_Elu_Box5"},
16396: {"AegisName":"HD_Elu_Box10"},
16397: {"AegisName":"Virgo_Diadem_Box"},
16398: {"AegisName":"F_Virgo_Crown_Box"},
16399: {"AegisName":"F_Virgo_Diadem_Box"},
16400: {"AegisName":"F_HD_Ori_Box5"},
16401: {"AegisName":"F_HD_Ori_Box10"},
16402: {"AegisName":"F_HD_Elu_Box5"},
16403: {"AegisName":"F_HD_Elu_Box10"},
16405: {"AegisName":"Midgard_Coin_Box"},
16406: {"AegisName":"FMidgard_Coin_Box"},
16407: {"AegisName":"Freyja_Ring_Box2"},
16408: {"AegisName":"F_Freyja_Ring_Box2"},
16409: {"AegisName":"Tw_Sep_Scroll"},
16410: {"AegisName":"Chung_Hairband_Box"},
16411: {"AegisName":"FChung_Hairband_Box"},
16412: {"AegisName":"Ice_Wing_Ear_Box"},
16413: {"AegisName":"FIce_Wing_Ear_Box"},
16414: {"AegisName":"Turtle_Hat_Box"},
16415: {"AegisName":"FTurtle_Hat_Box"},
16418: {"AegisName":"F_Giant_Fly_Wing_Box500"},
16419: {"AegisName":"F_Greed_Box30"},
16420: {"AegisName":"F_Pet_Egg_Scroll9"},
16421: {"AegisName":"F_Marriage_Covenant_Box"},
16422: {"AegisName":"F_Magestic_Goat_Box"},
16423: {"AegisName":"F_Pet_Egg_Scroll3"},
16424: {"AegisName":"F_Executioner_Box"},
16425: {"AegisName":"F_Cutlas_Box"},
16426: {"AegisName":"F_Moonlight_Sword_Box"},
16427: {"AegisName":"F_Spanner_Box"},
16428: {"AegisName":"F_Solar_Sword_Box"},
16429: {"AegisName":"F_Tomahawk_Box"},
16430: {"AegisName":"F_Bow_Of_Rudra_Box"},
16431: {"AegisName":"F_Pole_Axe_Box"},
16432: {"AegisName":"BM_Pack_Box_A"},
16433: {"AegisName":"F_BM_Pack_Box_A"},
16434: {"AegisName":"BM_Pack_Box_B"},
16435: {"AegisName":"F_BM_Pack_Box_B"},
16436: {"AegisName":"Libra_Crown_Box"},
16437: {"AegisName":"FLibra_Crown_Box"},
16438: {"AegisName":"Libra_Diadem_Box"},
16439: {"AegisName":"FLibra_Diadem_Box"},
16440: {"AegisName":"Filir_Wing_Box"},
16441: {"AegisName":"FFilir_Wing_Box"},
16442: {"AegisName":"Shaman_Hat_Box"},
16443: {"AegisName":"F_Shaman_Hat_Box"},
16444: {"AegisName":"Golden_Crown_Box"},
16445: {"AegisName":"F_Golden_Crown_Box"},
16446: {"AegisName":"Tw_October_Scroll"},
16447: {"AegisName":"Scorpio_Crown_Box"},
16448: {"AegisName":"Scorpio_Diadem_Box"},
16449: {"AegisName":"FScorpio_Crown_Box"},
16450: {"AegisName":"FScorpio_Diadem_Box"},
16451: {"AegisName":"F_Raven_Cap_Box"},
16452: {"AegisName":"Bright_Fury_Box"},
16453: {"AegisName":"Triangle_Rune_Cap_Box"},
16454: {"AegisName":"F_Bright_Fury_Box"},
16455: {"AegisName":"F_Triangle_Rune_Cap_Box"},
16456: {"AegisName":"My_Scroll1"},
16457: {"AegisName":"Tw_Nov_Scroll"},
16458: {"AegisName":"2009Love_Daddy_Box"},
16459: {"AegisName":"Queen_Ant_Diadem_Box"},
16460: {"AegisName":"FQueen_Ant_Diadem_Box"},
16461: {"AegisName":"Redwing_Hat_Box"},
16462: {"AegisName":"FRed_Wing_Hat_Box"},
16466: {"AegisName":"My_Scroll2"},
16467: {"AegisName":"Xmas_Card_Box"},
16468: {"AegisName":"F_Xmas_Card_Box"},
16469: {"AegisName":"Xmas_Card_Box2"},
16470: {"AegisName":"F_Xmas_Card_Box2"},
16481: {"AegisName":"E_S_Life_Potion_Box"},
16483: {"AegisName":"E_Abrasive_Box10"},
16492: {"AegisName":"E_Bunny_Band_Box"},
16503: {"AegisName":"E_Insurance_Package"},
16504: {"AegisName":"E_Bubble_Gum_Box"},
16505: {"AegisName":"E_Str_Dish_Box"},
16506: {"AegisName":"E_Agi_Dish_Box"},
16507: {"AegisName":"E_Int_Dish_Box"},
16508: {"AegisName":"E_Dex_Dish_Box"},
16509: {"AegisName":"E_Luk_Dish_Box"},
16510: {"AegisName":"E_Vit_Dish_Box"},
16514: {"AegisName":"E_Blessing_10_Scr_Box"},
16515: {"AegisName":"E_Inc_Agi_10_Scr_Box"},
16542: {"AegisName":"Xmas_Bless"},
16543: {"AegisName":"Snowman_Hat_Box"},
16544: {"AegisName":"FSnowman_Hat_Box"},
16548: {"AegisName":"Sagittarius_Crown_Box"},
16549: {"AegisName":"Sagittarius_Diadem_Box"},
16550: {"AegisName":"FSagittarius_Crown_Box"},
16551: {"AegisName":"FSagittarius_Diadem_Box"},
16554: {"AegisName":"E_Elven_Sunglass_Box"},
16555: {"AegisName":"Pr_Reset_Stone_Box"},
16556: {"AegisName":"FPr_Reset_Stone_Box"},
16557: {"AegisName":"CP_Helm_Scroll10"},
16558: {"AegisName":"CP_Shield_Scroll10"},
16559: {"AegisName":"CP_Armor_Scroll10"},
16560: {"AegisName":"CP_Weapon_Scroll10"},
16561: {"AegisName":"CP_Scroll_Package"},
16562: {"AegisName":"Majestic_Devil_Scroll"},
16563: {"AegisName":"BM100_Box_5"},
16565: {"AegisName":"Capricon_Crown_Box"},
16566: {"AegisName":"FCapricon_Crown_Box"},
16567: {"AegisName":"Capricon_Diadem_Box"},
16568: {"AegisName":"FCapricon_Diadem_Box"},
16569: {"AegisName":"Summber_Scroll"},
16570: {"AegisName":"Muscles_Story_J_Box"},
16571: {"AegisName":"Onigiri_Hat_Box"},
16573: {"AegisName":"Skull_Hood_Box"},
16574: {"AegisName":"F_Skull_Hood_Box"},
16576: {"AegisName":"Illusion_Nothing"},
16577: {"AegisName":"Dragon_Captain"},
16580: {"AegisName":"Lacma_Box"},
16581: {"AegisName":"F_Lacma_Box"},
16582: {"AegisName":"Red_Bunny_Band_Box"},
16584: {"AegisName":"Sloth_Hat_Box"},
16585: {"AegisName":"F_Sloth_Hat_Box"},
16586: {"AegisName":"Duneyrr_Helm_Box"},
16587: {"AegisName":"F_Duneyrr_Helm_Box"},
16588: {"AegisName":"Thoughtful_Hat_Box"},
16589: {"AegisName":"F_Thoughtful_Hat_Box"},
16590: {"AegisName":"E_Thoughtful_Hat_Box"},
16591: {"AegisName":"Summer_Scroll2"},
16592: {"AegisName":"Family_Hat_Box"},
16593: {"AegisName":"F_Family_Hat_Box"},
16596: {"AegisName":"Helm_Of_Abyss_Box"},
16597: {"AegisName":"F_Helm_Of_Abyss_Box"},
16598: {"AegisName":"Acti_Potion_Box2"},
16599: {"AegisName":"F_Acti_Potion_Box2"},
16600: {"AegisName":"Spring_Flower_Scr_Tw"},
16601: {"AegisName":"Blue_Arara_Hat_Box"},
16602: {"AegisName":"F_Blue_Arara_Hat_Box"},
16603: {"AegisName":"Drooping_Boto_Box"},
16604: {"AegisName":"F_Drooping_Boto_Box"},
16605: {"AegisName":"Tendrilion_Hat_Box"},
16606: {"AegisName":"F_Tendrilion_Hat_Box"},
16619: {"AegisName":"Yellow_Bunnyband_Box"},
16620: {"AegisName":"F_Yellow_Bunnyband_Box"},
16621: {"AegisName":"Pink_Bunnyband_Box"},
16622: {"AegisName":"F_Pink_Bunnyband_Box"},
16623: {"AegisName":"Green_Bunnyband_Box"},
16624: {"AegisName":"F_Green_Bunnyrband_Box"},
16625: {"AegisName":"Half_Asprika_Box"},
16626: {"AegisName":"Half_Megin_Box"},
16627: {"AegisName":"Half_Brysing_Box"},
16628: {"AegisName":"Half_Brynhild_Box"},
16629: {"AegisName":"Granpeco_Hairband_Box"},
16630: {"AegisName":"F_Granpeco_Hairband_Box"},
16631: {"AegisName":"Aributa_Scroll"},
16632: {"AegisName":"test_3"},
16633: {"AegisName":"Bubble_Gum_Plus_10Box"},
16634: {"AegisName":"Spiked_Scarf_Box2"},
16635: {"AegisName":"Rainbow_Scarf_Box2"},
16636: {"AegisName":"Spiked_Scarf_Box3"},
16637: {"AegisName":"Rainbow_Scarf_Box3"},
16638: {"AegisName":"Ribbon_Of_Life_Box"},
16639: {"AegisName":"Ribbon_Of_Life_Box2"},
16640: {"AegisName":"Ribbon_Of_Life_Box3"},
16641: {"AegisName":"F_Spiked_Scarf_Box"},
16642: {"AegisName":"F_Rainbow_Scarf_Box"},
16643: {"AegisName":"F_Spiked_Scarf_Box2"},
16644: {"AegisName":"F_Rainbow_Scarf_Box2"},
16645: {"AegisName":"F_Spiked_Scarf_Box3"},
16646: {"AegisName":"F_Rainbow_Scarf_Box3"},
16647: {"AegisName":"F_Ribbon_Of_Life_Box"},
16648: {"AegisName":"F_Ribbon_Of_Life_Box2"},
16649: {"AegisName":"F_Ribbon_Of_Life_Box3"},
16650: {"AegisName":"F_Gemini_Diadem_Box"},
16651: {"AegisName":"F_Gemini_Crown_Box"},
16652: {"AegisName":"Flame_Light"},
16653: {"AegisName":"BM75_10Box"},
16654: {"AegisName":"Valiant_Will"},
16655: {"AegisName":"Rapid_Life_Water_Box"},
16656: {"AegisName":"F_Rapid_Life_Water_Box"},
16657: {"AegisName":"Rapid_Life_Water_Box2"},
16658: {"AegisName":"F_Rapid_Life_Water_Box2"},
16659: {"AegisName":"Zodiac_Diadem_Pack"},
16660: {"AegisName":"Auger_Of_Spirit_Box"},
16661: {"AegisName":"F_Auger_Of_Spirit_Box"},
16662: {"AegisName":"F_Aries_Diadem_Box"},
16663: {"AegisName":"F_Aries_Crown_Box"},
16664: {"AegisName":"Leo_Scroll"},
16665: {"AegisName":"Virgo_Scroll"},
16666: {"AegisName":"Magic_Candy_Box10"},
16667: {"AegisName":"F_Magic_Candy_Box10"},
16668: {"AegisName":"Colorful_Ketupat_Box"},
16670: {"AegisName":"Battle_Manual_Box_A"},
16671: {"AegisName":"Magic_Candy_Box10_2"},
16672: {"AegisName":"F_Magic_Candy_Box10_2"},
16673: {"AegisName":"Libra_Scroll"},
16674: {"AegisName":"New_Insurance_Box"},
16675: {"AegisName":"Splash_Scroll"},
16676: {"AegisName":"Zodiac_Crown_Pack"},
16677: {"AegisName":"Vending_Scroll2_Box10"},
16678: {"AegisName":"Vending_Scroll2_Box50"},
16679: {"AegisName":"F_Vending_Scroll2_Box10"},
16680: {"AegisName":"F_Vending_Scroll2_Box50"},
16681: {"AegisName":"BR_Independence_Scrol"},
16682: {"AegisName":"Boarding_Halter_Box"},
16683: {"AegisName":"B_Halter_Box_30Days"},
16684: {"AegisName":"Wing_Of_Fly_Box10"},
16685: {"AegisName":"Wing_Of_Fly_Box50"},
16686: {"AegisName":"Wing_Of_Fly_Box100"},
16687: {"AegisName":"RWC2010_SuitcaseA"},
16688: {"AegisName":"RWC2010_SuitcaseB"},
16689: {"AegisName":"Garuda_Hat_Box"},
16690: {"AegisName":"F_Garuda_Hat_Box"},
16691: {"AegisName":"Scorpio_Scroll"},
16692: {"AegisName":"FAlice_Hat_Box"},
16693: {"AegisName":"Crescent_Helm_Box"},
16694: {"AegisName":"FCrescent_Helm_Box"},
16695: {"AegisName":"Dragon_Skull_Box"},
16696: {"AegisName":"FDragon_Skull_Box"},
16697: {"AegisName":"Drooping_Bunny_Box"},
16698: {"AegisName":"FDrooping_Bunny_Box"},
16699: {"AegisName":"Fish_On_Head_Box"},
16701: {"AegisName":"Pair_Ribbon_Box"},
16702: {"AegisName":"FPair_Ribbon_Box"},
16703: {"AegisName":"Smoking_Pipe_Box"},
16704: {"AegisName":"FSmoking_Pipe_Box"},
16705: {"AegisName":"Hibiscus_Bpx"},
16706: {"AegisName":"F_Hibiscus_Bpx"},
16707: {"AegisName":"Jumping_Poring_Box"},
16708: {"AegisName":"FJumping_Poring_Box"},
16709: {"AegisName":"Kettle_Hat_Box"},
16710: {"AegisName":"FKettle_Hat_Box"},
16711: {"AegisName":"Magic_Eyes_Box"},
16712: {"AegisName":"FMagic_Eyes_Box"},
16713: {"AegisName":"Propeller_Box"},
16714: {"AegisName":"F_Propeller_Box"},
16715: {"AegisName":"Dog_Hat_Box"},
16716: {"AegisName":"F_Dog_Hat_Box"},
16717: {"AegisName":"Sheep_Hat_Box"},
16718: {"AegisName":"FSheep_Hat_Box"},
16719: {"AegisName":"FTiger_Mask_Box"},
16720: {"AegisName":"Vacation_Hat_Box"},
16721: {"AegisName":"FVacation_Hat_Box"},
16722: {"AegisName":"Vane_Hairpin_Box"},
16723: {"AegisName":"FVane_Hairpin_Box"},
16724: {"AegisName":"Vanilmirth_Hat_Box"},
16725: {"AegisName":"FVanilmirth_Hat_Box"},
16726: {"AegisName":"Water_Lily_Crown_Box"},
16727: {"AegisName":"FWater_Lily_Crown_Box"},
16728: {"AegisName":"Pink_Fur_Hat_Box"},
16729: {"AegisName":"F_Pink_Fur_Hat_Box"},
16730: {"AegisName":"Ribbon_Green_Box"},
16731: {"AegisName":"F_Ribbon_Green_Box"},
16732: {"AegisName":"Wh_Deviruchi_Cap_Box"},
16733: {"AegisName":"F_Wh_Deviruchi_Cap_Box"},
16734: {"AegisName":"Blu_Drooping_Kitty_Box"},
16735: {"AegisName":"FBlu_Drooping_Kitty_Box"},
16736: {"AegisName":"Fantastic_Wig_Box"},
16737: {"AegisName":"F_Fantastic_Wig_Box"},
16738: {"AegisName":"Yellow_Wizard_Hat_Box"},
16739: {"AegisName":"F_Yellow_Wizard_Hat_Box"},
16740: {"AegisName":"Ptotection_Seagod_Box"},
16741: {"AegisName":"Hairtail_Box1"},
16742: {"AegisName":"Hairtail_Box2"},
16743: {"AegisName":"Spearfish_Box1"},
16744: {"AegisName":"Spearfish_Box2"},
16745: {"AegisName":"Saurel_Box1"},
16746: {"AegisName":"Saurel_Box2"},
16747: {"AegisName":"Tuna_Box1"},
16748: {"AegisName":"Tuna_Box2"},
16749: {"AegisName":"Malang_Crab_Box1"},
16750: {"AegisName":"Malang_Crab_Box2"},
16751: {"AegisName":"Brindle_Eel_Box1"},
16752: {"AegisName":"Brindle_Eel_Box2"},
16753: {"AegisName":"Unbreak_Weap_Box"},
16754: {"AegisName":"F_Unbreak_Weap_Box"},
16755: {"AegisName":"Unbreak_Def_Box"},
16756: {"AegisName":"F_Unbreak_Def_Box"},
16757: {"AegisName":"Hallo_Scroll"},
16758: {"AegisName":"Umbala_Spirit_Box"},
16759: {"AegisName":"F_Umbala_Spirit_Box"},
16760: {"AegisName":"Umbala_Spirit_Box2"},
16761: {"AegisName":"F_Umbala_Spirit_Box2"},
16762: {"AegisName":"Umbala_Spirit_Box_7day"},
16763: {"AegisName":"Ptotection_Seagod_Box2"},
16764: {"AegisName":"Ptotection_Seagod_Box3"},
16765: {"AegisName":"Octo_Hstick_Box"},
16766: {"AegisName":"Octo_Hstick_Box2"},
16767: {"AegisName":"Octo_Hstick_Box3"},
16770: {"AegisName":"Silvervine_Fruit_Box10"},
16771: {"AegisName":"Silvervine_Fruit_Box40"},
16774: {"AegisName":"Asgard_Scroll"},
16775: {"AegisName":"Sagittarius_Scroll"},
16776: {"AegisName":"C_Vending_Scroll2_Box10"},
16777: {"AegisName":"C_Vending_Scroll2_Box50"},
16778: {"AegisName":"C_Str_Dish_Box"},
16779: {"AegisName":"C_Str_Dish_Box50"},
16780: {"AegisName":"C_Agi_Dish_Box"},
16781: {"AegisName":"C_Agi_Dish_Box50"},
16782: {"AegisName":"C_Vit_Dish_Box"},
16783: {"AegisName":"C_Vit_Dish_Box50"},
16784: {"AegisName":"C_Int_Dish_Box"},
16785: {"AegisName":"C_Int_Dish_Box50"},
16786: {"AegisName":"C_Dex_Dish_Box"},
16787: {"AegisName":"C_Dex_Dish_Box50"},
16788: {"AegisName":"C_Luk_Dish_Box"},
16789: {"AegisName":"C_Luk_Dish_Box50"},
16790: {"AegisName":"C_Insurance_Package"},
16791: {"AegisName":"C_Insurance_Package50"},
16792: {"AegisName":"C_Kafra_Card_Box"},
16793: {"AegisName":"C_Kafra_Card_Box50"},
16794: {"AegisName":"C_Giant_Fly_Wing_Box"},
16795: {"AegisName":"C_Giant_Fly_Wing_Box100"},
16796: {"AegisName":"C_Siegfried_Box5"},
16797: {"AegisName":"C_Siegfried_Box20"},
16798: {"AegisName":"C_Convex_Mirror_Box5"},
16799: {"AegisName":"C_Convex_Mirror_Box30"},
16800: {"AegisName":"C_Blessing_10_Box"},
16801: {"AegisName":"C_Blessing_10_Box50"},
16802: {"AegisName":"C_Inc_Agi_10_Scroll_Box"},
16803: {"AegisName":"C_Inc_Agi_10_Box50"},
16804: {"AegisName":"C_Adrenaline_5_box"},
16805: {"AegisName":"C_Adrenaline_5_box50"},
16806: {"AegisName":"C_Aspersio_5_Scroll_Box"},
16807: {"AegisName":"C_Aspersio_5_Box50"},
16808: {"AegisName":"C_Battle_Manual_Box"},
16809: {"AegisName":"C_Battle_Manual_Box10"},
16810: {"AegisName":"C_Bubble_Gum_Box"},
16811: {"AegisName":"C_Bubble_Gum_Box10"},
16812: {"AegisName":"C_Megaphone_Box"},
16813: {"AegisName":"C_Megaphone_Box10"},
16814: {"AegisName":"C_Enriched_Elunium_Box"},
16815: {"AegisName":"C_Enriched_Elunium_Box5"},
16816: {"AegisName":"C_Enriched_Oridecon_Box"},
16817: {"AegisName":"C_Enc_Oridecon_Box5"},
16818: {"AegisName":"C_Neuralizer_Box"},
16819: {"AegisName":"C_Abrasive_Box5"},
16820: {"AegisName":"C_Abrasive_Box10"},
16821: {"AegisName":"C_Dun_Tele_Scroll_Box5"},
16822: {"AegisName":"C_Dun_Tele_Scroll_Box10"},
16823: {"AegisName":"C_Max_Weight_Up_Box"},
16824: {"AegisName":"C_Regeneration_Box5"},
16825: {"AegisName":"C_Regeneration_Box10"},
16826: {"AegisName":"Sagittarius_Scr_Box"},
16827: {"AegisName":"C_Small_Life_Potion_Box"},
16828: {"AegisName":"C_S_Life_Potion_Box50"},
16829: {"AegisName":"C_Med_Life_Potion_Box"},
16830: {"AegisName":"C_Med_Life_Potion_Box50"},
16831: {"AegisName":"C_G_Illusion_Box5"},
16832: {"AegisName":"C_G_Illusion_Box10"},
16833: {"AegisName":"C_S_ArmorBox5"},
16834: {"AegisName":"C_S_ArmorBox10"},
16835: {"AegisName":"C_Holy_Armor_S_Box5"},
16836: {"AegisName":"C_Holy_Armor_S_Box30"},
16837: {"AegisName":"C_Dun_Tele_Scroll2_Box5"},
16838: {"AegisName":"C_Dun_Tele_S2_Box10"},
16839: {"AegisName":"C_Spark_Candy_Box5"},
16840: {"AegisName":"C_Spark_Candy_Box10"},
16841: {"AegisName":"C_Repair_Scroll_Box"},
16842: {"AegisName":"C_Repair_Scroll_Box10"},
16843: {"AegisName":"C_New_Style_Box"},
16844: {"AegisName":"C_Alice_Scroll_Box5"},
16845: {"AegisName":"C_Alice_Scroll_Box10"},
16846: {"AegisName":"C_Mimic_Scroll_Box5"},
16847: {"AegisName":"C_Mimic_Scroll_Box10"},
16848: {"AegisName":"C_Disguise_Croll_Box5"},
16849: {"AegisName":"C_Disguise_Croll_Box10"},
16850: {"AegisName":"C_MP_Scroll_Box"},
16851: {"AegisName":"C_MP_Scroll_Box50"},
16852: {"AegisName":"C_Quagmire_Scroll_Box"},
16853: {"AegisName":"C_Quagmire_Scroll_Box50"},
16854: {"AegisName":"CCloth_Dye_Coupon_Box"},
16855: {"AegisName":"CCloth_Dye_Coupon2_Box"},
16856: {"AegisName":"C_Greed_Scroll_C20Box"},
16857: {"AegisName":"C_Greed_Scroll_C50Box"},
16858: {"AegisName":"C_Mental_Potion20_Box"},
16859: {"AegisName":"C_Mental_Potion50_Box"},
16860: {"AegisName":"C_Tyr_Blessing_Box20"},
16861: {"AegisName":"C_Tyr_Blessing_Box50"},
16862: {"AegisName":"C_Job_Manual25_Box1"},
16863: {"AegisName":"C_Job_Manual25_Box10"},
16864: {"AegisName":"C_Siege_Scroll_Box1_10"},
16865: {"AegisName":"C_Siege_Scroll_Box1_30"},
16866: {"AegisName":"C_Siege_Scroll_Box2_10"},
16867: {"AegisName":"C_Siege_Scroll_Box2_30"},
16868: {"AegisName":"C_HD_Bradium_Box5"},
16869: {"AegisName":"C_HD_Bradium_Box10"},
16870: {"AegisName":"C_HD_Carnium_Box5"},
16871: {"AegisName":"C_HD_Carnium_Box10"},
16872: {"AegisName":"C_HD_Ori_Box5"},
16873: {"AegisName":"C_HD_Ori_Box10"},
16874: {"AegisName":"C_HD_Elu_Box5"},
16875: {"AegisName":"C_HD_Elu_Box10"},
16876: {"AegisName":"C_Rapid_Life_Water_Box2"},
16877: {"AegisName":"C_Magic_Candy_Box102"},
16878: {"AegisName":"C_Umbala_Spirit_Box2"},
16879: {"AegisName":"C_Muramasa_Box"},
16880: {"AegisName":"C_Excalibur_Box"},
16881: {"AegisName":"C_Combat_Knife_Box"},
16882: {"AegisName":"C_Counter_Dagger_Box"},
16883: {"AegisName":"C_Mighty_Staff_Box"},
16884: {"AegisName":"C_Right_Epsilon_Box"},
16885: {"AegisName":"C_Balistar_Box"},
16886: {"AegisName":"C_D_Great_Sage_Box"},
16887: {"AegisName":"C_Asura_Box"},
16888: {"AegisName":"C_Brooch_Box"},
16889: {"AegisName":"C_Safety_Ring_Box"},
16890: {"AegisName":"C_Pecopeco_Hairband_Box"},
16891: {"AegisName":"C_Nagan_Box"},
16892: {"AegisName":"C_Skewer_Box"},
16893: {"AegisName":"C_Quadrille_Box"},
16894: {"AegisName":"C_Fire_Brand_Box"},
16895: {"AegisName":"C_Masquerade_Box"},
16896: {"AegisName":"C_Orc_Hero_Helm_Box"},
16897: {"AegisName":"C_KRO_D_Kitty_Box"},
16898: {"AegisName":"C_Bloody_Iron_Ball_Box"},
16899: {"AegisName":"C_Hockey_Mask_Box"},
16900: {"AegisName":"C_Observer_Box"},
16901: {"AegisName":"C_All_In_One_Ring_Box"},
16902: {"AegisName":"C_Spiritual_Tunic_Box"},
16903: {"AegisName":"C_Recup_Armor_Box"},
16904: {"AegisName":"C_Shelter_Resist_Box"},
16905: {"AegisName":"C_Sylphid_Manteau_Box"},
16906: {"AegisName":"C_Refresh_Shoes_Box"},
16907: {"AegisName":"C_Wasteland_Outlaw_Box"},
16908: {"AegisName":"C_Lever_Act_Rifle_Box"},
16909: {"AegisName":"C_Claymore_C_box"},
16910: {"AegisName":"C_Jamadhar_C_Box"},
16911: {"AegisName":"C_Two_Handed_Axe_C_Box"},
16912: {"AegisName":"C_Lance_C_Box"},
16913: {"AegisName":"C_Orcish_Axe_C_Box"},
16914: {"AegisName":"C_Encyclopedia_C_Box"},
16915: {"AegisName":"C_Pike_C_Box"},
16916: {"AegisName":"C_Fist_C_Box"},
16917: {"AegisName":"C_Damascus_C_Box"},
16918: {"AegisName":"C_Flamberge_C_Box"},
16919: {"AegisName":"C_Stunner_C_Box"},
16920: {"AegisName":"C_Marriage_Covenant_Box"},
16921: {"AegisName":"C_Shooting_Star_C_Box"},
16922: {"AegisName":"C_Bloody_Fear_C_Box"},
16923: {"AegisName":"C_Staff_Healing_C_Box"},
16924: {"AegisName":"C_Clover_Box_Mouth"},
16925: {"AegisName":"C_Clover_Box_Mouth2"},
16926: {"AegisName":"C_Clover_Box_Mouth4"},
16927: {"AegisName":"C_BGum_Box_In_Mouth"},
16928: {"AegisName":"C_BGum_Box_In_Mouth2"},
16929: {"AegisName":"C_BGum_Box_In_Mouth4"},
16930: {"AegisName":"C_Spiked_Scarf_Box"},
16931: {"AegisName":"C_Spiked_Scarf_Box2"},
16932: {"AegisName":"C_Spiked_Scarf_Box3"},
16933: {"AegisName":"C_Rainbow_Scarf_Box"},
16934: {"AegisName":"C_Rainbow_Scarf_Box2"},
16935: {"AegisName":"C_Rainbow_Scarf_Box3"},
16936: {"AegisName":"C_Ribbon_Of_Life_Box"},
16937: {"AegisName":"C_Ribbon_Of_Life_Box2"},
16938: {"AegisName":"C_Ribbon_Of_Life_Box3"},
16939: {"AegisName":"C_Love_Angel_Box"},
16940: {"AegisName":"C_Love_Angel_Box_1m"},
16941: {"AegisName":"C_Squirrel_Box"},
16942: {"AegisName":"C_Squirrel_Box_1m"},
16943: {"AegisName":"C_Picture_Diary_Box"},
16944: {"AegisName":"C_Picture_Diary_Box_1m"},
16945: {"AegisName":"C_Mini_Heart_Box"},
16946: {"AegisName":"C_Mini_Heart_Box_1m"},
16947: {"AegisName":"C_Newcomer_Box"},
16948: {"AegisName":"C_Newcomer_Box_1m"},
16949: {"AegisName":"C_Kid_Box"},
16950: {"AegisName":"C_Kid_Box_1m"},
16951: {"AegisName":"C_Magic_Castle_Box"},
16952: {"AegisName":"C_Magic_Castle_Box_1m"},
16953: {"AegisName":"C_Bulging_Head_Box"},
16954: {"AegisName":"C_Bulging_Head_Box_1m"},
16955: {"AegisName":"P_Upg_Guard_Box"},
16956: {"AegisName":"C_Upg_Buckler_Box"},
16957: {"AegisName":"C_Upg_Shield_Box"},
16958: {"AegisName":"C_Upg_Shoes_Box"},
16959: {"AegisName":"C_Upg_Boots_Box"},
16960: {"AegisName":"C_Upg_Greave_Box"},
16961: {"AegisName":"C_Upg_Hood_Box"},
16962: {"AegisName":"C_Upg_Muffler_Box"},
16963: {"AegisName":"C_Upg_Manteau_Box"},
16964: {"AegisName":"C_Upg_Clip_Box"},
16965: {"AegisName":"C_Upg_Adv_Suit_Box"},
16966: {"AegisName":"C_Upg_Coat_Box"},
16967: {"AegisName":"C_Upg_Saint_Robe_Box"},
16968: {"AegisName":"C_Upg_Tights_Box"},
16969: {"AegisName":"C_Upg_Thief_Cloth_Box"},
16970: {"AegisName":"C_Upg_Mail_Box"},
16971: {"AegisName":"C_Upg_Formal_Dress_Box"},
16972: {"AegisName":"Weather_Report_Box"},
16973: {"AegisName":"Yellow_Hat_Box"},
16974: {"AegisName":"Comin_Actor_Box"},
16975: {"AegisName":"Singing_Bird_Box"},
16976: {"AegisName":"Hen_Set_Box"},
16977: {"AegisName":"Red_Minicrown_Box"},
16978: {"AegisName":"C_Green_FoxtailBox"},
16979: {"AegisName":"Silvervine_Fruit_Box4"},
16990: {"AegisName":"Sagittar_Diadem_Scroll"},
16991: {"AegisName":"Sagittar_Di_Scroll_Box"},
16992: {"AegisName":"Butterfly_Wing_Box20"},
16993: {"AegisName":"Butterfly_Wing_Box50"},
16995: {"AegisName":"Old_Hat_Box"},
16996: {"AegisName":"Capri_Crown_Scroll"},
16997: {"AegisName":"Capri_Crown_Scroll_Box"},
16998: {"AegisName":"Archangel_Wing_Box"},
16999: {"AegisName":"Bravery_Bag_Box"},
17000: {"AegisName":"Wander_Man_Box5"},
17001: {"AegisName":"Wander_Man_Box10"},
17002: {"AegisName":"Wicked_Nymph_Box5"},
17003: {"AegisName":"Wicked_Nymph_Box10"},
17004: {"AegisName":"Kasa_Scroll_Box5"},
17005: {"AegisName":"Kasa_Scroll_Box10"},
17006: {"AegisName":"Salamander_Box5"},
17007: {"AegisName":"Salamander_Box10"},
17008: {"AegisName":"Teddy_Bear_Box5"},
17009: {"AegisName":"Teddy_Bear_Box10"},
17011: {"AegisName":"Capricon_Di_Scroll"},
17012: {"AegisName":"Capricon_Di_Scroll_Box"},
17013: {"AegisName":"Malang_Woe_Encard_Box"},
17014: {"AegisName":"Butterfly_ear_Box"},
17015: {"AegisName":"Stuckhead_Screw_Box"},
17016: {"AegisName":"Aquarius_Diadem_Scroll"},
17017: {"AegisName":"Aquarius_Di_Scroll_Box"},
17018: {"AegisName":"Libra_Scroll2"},
17019: {"AegisName":"Scorpio_Scroll2"},
17020: {"AegisName":"Tw_Nov_Scroll2"},
17021: {"AegisName":"Summer_Scroll3"},
17022: {"AegisName":"Super_Pet_Egg1_2"},
17023: {"AegisName":"Super_Pet_Egg4_2"},
17024: {"AegisName":"Lovely_Aquarius_Scroll"},
17025: {"AegisName":"Lovely_Aquarius_Box"},
17026: {"AegisName":"Boitata_Scroll"},
17027: {"AegisName":"Refine_Ore_Box"},
17028: {"AegisName":"Pisces_Diadem_Scroll"},
17029: {"AegisName":"Pisces_Diadem_S_Box"},
17030: {"AegisName":"St_Pat_Hat_box"},
17035: {"AegisName":"Energetic_Pisces_Scroll"},
17036: {"AegisName":"Energetic_Pisces_Box"},
17037: {"AegisName":"Trans_Box_Devi"},
17038: {"AegisName":"Trans_Box_Ray_Arch"},
17039: {"AegisName":"Trans_Box_Mavka"},
17040: {"AegisName":"Trans_Box_Marduk"},
17041: {"AegisName":"Trans_Box_Banshee"},
17042: {"AegisName":"Trans_Box_Poring"},
17043: {"AegisName":"Trans_Box_Golem"},
17044: {"AegisName":"Donation_Ribbon_Box"},
17045: {"AegisName":"Korean_Judge_Hat_Box"},
17046: {"AegisName":"Attend_C_Box"},
17050: {"AegisName":"Aries_Scroll_"},
17051: {"AegisName":"Aries_Scroll_box"},
17052: {"AegisName":"Holy_Mom_Blaze_Box"},
17056: {"AegisName":"Wiz_Card_Album"},
17057: {"AegisName":"Swordman_Card_Album"},
17058: {"AegisName":"Thief_Card_Album"},
17059: {"AegisName":"Acolyte_Card_Album"},
17060: {"AegisName":"Merchant_Card_Album"},
17061: {"AegisName":"Archer_Card_Album"},
17062: {"AegisName":"Taurus_Diadem_Scroll"},
17063: {"AegisName":"Taurus_Di_Scroll_Box"},
17064: {"AegisName":"Tw_Sagitt_Scroll"},
17065: {"AegisName":"Mbl_Taurus_Crown_Box"},
17066: {"AegisName":"Poison_Bottle_Box50"},
17067: {"AegisName":"Poison_Bottle_Box100"},
17068: {"AegisName":"Acidbomb_Box50"},
17069: {"AegisName":"Acidbomb_Box100"},
17070: {"AegisName":"Acidbomb_Box500"},
17071: {"AegisName":"Superb_Fish_Box50"},
17072: {"AegisName":"Superb_Fish_Box100"},
17073: {"AegisName":"Superb_Fish_Box500"},
17074: {"AegisName":"Empty_Bottle_Box10"},
17075: {"AegisName":"Empty_Bottle_Box100"},
17076: {"AegisName":"Empty_Bottle_Box500"},
17077: {"AegisName":"Taurus_Crown_Scroll"},
17078: {"AegisName":"Taurus_Crown_Scroll_Box"},
17079: {"AegisName":"Indonesian_Box2"},
17080: {"AegisName":"Scorpio_Scroll3"},
17081: {"AegisName":"Yggdrasil_Crown_Box"},
17082: {"AegisName":"Gemi_Diadem_Scroll"},
17083: {"AegisName":"Gemi_Diadem_Scroll_Box"},
17084: {"AegisName":"Upg_Katar_Box"},
17085: {"AegisName":"Upg_Two_Handed_Axe_Box"},
17086: {"AegisName":"Upg_Lance_Box"},
17087: {"AegisName":"Upg_Book_Box"},
17088: {"AegisName":"Upg_Staff_Box"},
17089: {"AegisName":"Upg_Dagger_Box"},
17090: {"AegisName":"Upg_Revolver_Box"},
17091: {"AegisName":"Upg_Mace_Box"},
17092: {"AegisName":"Upg_Bow_Box"},
17093: {"AegisName":"Upg_Twohand_Sword_Box"},
17094: {"AegisName":"Upg_Katar_Box2"},
17095: {"AegisName":"Upg_Two_Handed_Axe_Box2"},
17096: {"AegisName":"Upg_Lance_Box2"},
17097: {"AegisName":"Upg_Book_Box2"},
17098: {"AegisName":"Upg_Staff_Box2"},
17099: {"AegisName":"Upg_Dagger_Box2"},
17100: {"AegisName":"Upg_Revolver_Box2"},
17101: {"AegisName":"Upg_Mace_Box2"},
17102: {"AegisName":"Upg_Bow_Box2"},
17103: {"AegisName":"Upg_Twohand_Sword_Box2"},
17104: {"AegisName":"HD_Oridecon_50Box"},
17105: {"AegisName":"HD_Elunium_50Box"},
17106: {"AegisName":"Max_Weight_Up_10Box"},
17107: {"AegisName":"Gemi_Crown_Scroll"},
17108: {"AegisName":"Gemi_Crown_Scroll_Box"},
17109: {"AegisName":"Capri_Scroll"},
17110: {"AegisName":"Aquarius_Scroll"},
17113: {"AegisName":"Pisces_Scroll"},
17114: {"AegisName":"Horn_Of_Ancient_Box"},
17115: {"AegisName":"Sprout_Hat_Box"},
17116: {"AegisName":"Mercury_Helm_Box"},
17117: {"AegisName":"Aries_Scroll"},
17118: {"AegisName":"ASPD_Potion_Box10"},
17120: {"AegisName":"Taurus_Scroll"},
17121: {"AegisName":"Starry_Scroll"},
17122: {"AegisName":"Immuned_Shield_Box"},
17123: {"AegisName":"Black_Devil_Mask_Box"},
17124: {"AegisName":"Cat_Ears_Beret_Box"},
17125: {"AegisName":"Red_Bread_Hat_Box"},
17126: {"AegisName":"ASPD_Potion_Box10_2"},
17127: {"AegisName":"Leo_Scroll2"},
17134: {"AegisName":"RWC_Scroll"},
17135: {"AegisName":"Trans_A_Set"},
17136: {"AegisName":"Trans_B_Set"},
17137: {"AegisName":"Trans_C_Set"},
17138: {"AegisName":"Ms_Cancer_Scroll"},
17139: {"AegisName":"Ms_RWC_Super_Scroll"},
17140: {"AegisName":"Ms_Leo_Scroll"},
17141: {"AegisName":"Ms_Virgo_Scroll"},
17143: {"AegisName":"Ms_Scorpio_Scroll"},
17144: {"AegisName":"Made_Dish_Set"},
17145: {"AegisName":"Made_Dish_Box"},
17146: {"AegisName":"Dep_Alice_Hat_Box"},
17147: {"AegisName":"Ribbon_Chef_Hat_Box"},
17152: {"AegisName":"Bridal_Ribbon_Box"},
17153: {"AegisName":"Red_Booster_Box20"},
17154: {"AegisName":"Red_Booster_Box20_2"},
17155: {"AegisName":"Upg_Huuma_Shuriken_Box"},
17156: {"AegisName":"TCG_Card_Scroll"},
17157: {"AegisName":"Vital_Flower_Box"},
17158: {"AegisName":"Flame_Gemstone_Box"},
17159: {"AegisName":"Change_Name_Card_Box"},
17160: {"AegisName":"Change_Name_Card_Box2"},
17162: {"AegisName":"Boarding_Halter_Box7"},
17163: {"AegisName":"Mystic_Powder_Box30"},
17164: {"AegisName":"Mystic_Powder_Box30_2"},
17165: {"AegisName":"Challenge_Kit"},
17166: {"AegisName":"Hellomother_Hat_Box"},
17171: {"AegisName":"EC_Battle_Manual_Box"},
17172: {"AegisName":"EC_Job_Manual25_Box10"},
17173: {"AegisName":"Global_Hat_Fes_Box"},
17174: {"AegisName":"Global_Hat_Fes_5_Box"},
17175: {"AegisName":"Global_Hat_Fes_Box2"},
17176: {"AegisName":"Boarding_Halter_Box3"},
17177: {"AegisName":"Made_Dish_Box1"},
17178: {"AegisName":"Mysterious_Water_Box50"},
17179: {"AegisName":"C_Myst_Water_Box50"},
17180: {"AegisName":"Mysterious_Water_Box50_"},
17181: {"AegisName":"Jan_Groove_Box"},
17182: {"AegisName":"Fallen_Angel_Wing_Box"},
17184: {"AegisName":"3rd_Test_Pass_Box"},
17193: {"AegisName":"Refine_Ore_Box2"},
17194: {"AegisName":"Red_Potion_RG_Box"},
17195: {"AegisName":"Blue_Potion_RG_Box"},
17196: {"AegisName":"GoldenApple_P_RG_Box"},
17197: {"AegisName":"GoldenApple_RG_Box"},
17198: {"AegisName":"Golden_Potion_RG_Box"},
17200: {"AegisName":"RG_Noble_Hat_Box"},
17201: {"AegisName":"RG_Soft_Sheep_Hat_Box"},
17202: {"AegisName":"Baksojin_Hat_Box"},
17203: {"AegisName":"Free_Pass_Box"},
17204: {"AegisName":"Miraculous_Egg"},
17205: {"AegisName":"Special_Po_Box"},
17206: {"AegisName":"Battle_Manual_Limit_Box"},
17207: {"AegisName":"Idn_Heart_Scroll"},
17209: {"AegisName":"Tw_Rainbow_Scroll"},
17210: {"AegisName":"Tw_Red_Scroll"},
17211: {"AegisName":"Tw_Orange_Scroll"},
17212: {"AegisName":"Tw_Yellow_Scroll"},
17224: {"AegisName":"Almighty_Box"},
17226: {"AegisName":"C_Center_Pot_Box"},
17227: {"AegisName":"C_Awakening_Pot_Box"},
17228: {"AegisName":"C_Berserk_Pot_Box"},
17229: {"AegisName":"C_Wing_Of_Fly_Box"},
17230: {"AegisName":"Valerian_Scroll"},
17231: {"AegisName":"Refine_Ore_Box3"},
17232: {"AegisName":"Guarantee7_Box"},
17233: {"AegisName":"Scroll_Of_Death"},
17234: {"AegisName":"Scroll_Of_Life"},
17235: {"AegisName":"Scroll_Of_Magic"},
17236: {"AegisName":"Scroll_Of_Thews"},
17237: {"AegisName":"Scroll_Of_Darkness"},
17238: {"AegisName":"Scroll_Of_Holiness"},
17239: {"AegisName":"Horned_Scroll"},
17240: {"AegisName":"Mercury_Scroll"},
17241: {"AegisName":"Amistr_Cap_Box"},
17242: {"AegisName":"Immortal_Egg"},
17244: {"AegisName":"Almighty_Box2"},
17245: {"AegisName":"Idn_Independ_Scroll"},
17246: {"AegisName":"HD_Elunium_Box30"},
17247: {"AegisName":"HD_Oridecon_Box30"},
17251: {"AegisName":"C_Wing_Of_Fly_3Day_Box"},
17252: {"AegisName":"RWC_2012_Set_Box"},
17253: {"AegisName":"RWC_2012_Ring_Box"},
17254: {"AegisName":"RWC_2012_Pendant_Box"},
17255: {"AegisName":"Sapphire_Egg"},
17256: {"AegisName":"Good_Student_Gift_Box"},
17257: {"AegisName":"Bad_Student_Gift_Box"},
17262: {"AegisName":"Ex_Def_Potion_Box"},
17263: {"AegisName":"C_Center_Pot_3d_Box"},
17264: {"AegisName":"C_Awakening_Pot_3d_Box"},
17265: {"AegisName":"C_Berserk_Pot_3d_Box"},
17266: {"AegisName":"BM_Limit_Pack"},
17270: {"AegisName":"STR_Biscuit_Stick_Box"},
17271: {"AegisName":"VIT_Biscuit_Stick_Box"},
17272: {"AegisName":"AGI_Biscuit_Stick_Box"},
17273: {"AegisName":"INT_Biscuit_Stick_Box"},
17274: {"AegisName":"DEX_Biscuit_Stick_Box"},
17275: {"AegisName":"LUK_Biscuit_Stick_Box"},
17277: {"AegisName":"Unlimited_Box"},
17278: {"AegisName":"Unlimited_10_Box"},
17279: {"AegisName":"Unlimited_20_Box"},
17281: {"AegisName":"Refine_Ore_Box4"},
17282: {"AegisName":"Refine_Ore_Box4_Set10"},
17283: {"AegisName":"Refine_Ore_Box4_Set20"},
17284: {"AegisName":"E_Change_Name_Card_Box"},
17285: {"AegisName":"E_New_Style_Box"},
17286: {"AegisName":"E_Cloth_Dye_Coupon_Box"},
17287: {"AegisName":"E_Cloth_Dye_Coupon_Box2"},
17288: {"AegisName":"Customizing_Box"},
17289: {"AegisName":"Wing_Of_Baalzebub_Box"},
17290: {"AegisName":"Orleans_Full_Course_Box"},
17292: {"AegisName":"Shadow_Box"},
17293: {"AegisName":"Physical_S_Package"},
17294: {"AegisName":"Magical_S_Package"},
17298: {"AegisName":"Vigorgra_Package"},
17299: {"AegisName":"Vigorgra_Package_Set"},
17302: {"AegisName":"Shadow_Box2_Box"},
17303: {"AegisName":"Shadow_Box2_Set"},
17304: {"AegisName":"Neuralizer_Box_3"},
17306: {"AegisName":"Status_Reset_Coupon_Box"},
17307: {"AegisName":"Midgard_Scroll"},
17308: {"AegisName":"Half_Asprika_Box_1"},
17311: {"AegisName":"Half_Brynhild_Box_1"},
17314: {"AegisName":"C_Wing_Of_Fly_1Day_Box"},
17315: {"AegisName":"Silvervine_Box10_"},
17316: {"AegisName":"Silvervine_Box110"},
17317: {"AegisName":"Sweet_Midgard_Scroll"},
17320: {"AegisName":"Brithday_IdRO10th_Scr"},
17321: {"AegisName":"3_Life_Potion_pack"},
17322: {"AegisName":"3_Life_Potion_10pack"},
17326: {"AegisName":"Requiem_Scroll"},
17331: {"AegisName":"Almighty_Box3"},
17332: {"AegisName":"Almighty100_Box"},
17336: {"AegisName":"J_Shop_Coupon_Box"},
17337: {"AegisName":"Holy_Spirit_Scroll"},
17338: {"AegisName":"Refine_Ore_Box5"},
17339: {"AegisName":"Refine_Ore_Box5_Set10"},
17394: {"AegisName":"Old_Hat_Box_"},
17396: {"AegisName":"Half_L_Maje_Box_1day"},
17397: {"AegisName":"Half_L_Maje_Box_7day"},
17398: {"AegisName":"Half_BF_Spear1_Box_1day"},
17399: {"AegisName":"Half_BF_Spear1_Box_7day"},
17400: {"AegisName":"Half_BF_Book2_Box_1day"},
17401: {"AegisName":"Half_BF_Book2_Box_7day"},
17402: {"AegisName":"Half_BF_Staff4_Box_1day"},
17403: {"AegisName":"Half_BF_Staff4_Box_7day"},
17404: {"AegisName":"Half_BF_Staff2_Box_1day"},
17405: {"AegisName":"Half_BF_Staff2_Box_7day"},
17406: {"AegisName":"Half_BF_Knuc1_Box_1day"},
17407: {"AegisName":"Half_BF_Knuc1_Box_7day"},
17408: {"AegisName":"Half_BF_Dag2_Box_1day"},
17409: {"AegisName":"Half_BF_Dag2_Box_7day"},
17410: {"AegisName":"Half_BF_HuShu2_Box_1day"},
17411: {"AegisName":"Half_BF_HuShu2_Box_7day"},
17412: {"AegisName":"Half_BF_Sword1_Box_1day"},
17413: {"AegisName":"Half_BF_Sword1_Box_7day"},
17414: {"AegisName":"Half_Mjolnir_Box_1day"},
17415: {"AegisName":"Half_Mjolnir_Box_7day"},
17416: {"AegisName":"Half_BF_MStar1_Box_1day"},
17417: {"AegisName":"Half_BF_MStar1_Box_7day"},
17418: {"AegisName":"Half_BF_Bow1_Box_1day"},
17419: {"AegisName":"Half_BF_Bow1_Box_7day"},
17420: {"AegisName":"Half_BF_Katar2_Box_1day"},
17421: {"AegisName":"Half_BF_Katar2_Box_7day"},
17422: {"AegisName":"Half_BF_THAxe1_Box_1day"},
17423: {"AegisName":"Half_BF_THAxe1_Box_7day"},
17424: {"AegisName":"Half_BF_Rifle1_Box_1day"},
17425: {"AegisName":"Half_BF_Rifle1_Box_7day"},
17426: {"AegisName":"Half_BF_Shgun1_Box_1day"},
17427: {"AegisName":"Half_BF_Shgun1_Box_7day"},
17429: {"AegisName":"Shadow_Box3"},
17430: {"AegisName":"11th_S_Package"},
17431: {"AegisName":"Thanks_Giving_Scroll"},
17432: {"AegisName":"Silvervine_Box10_2"},
17433: {"AegisName":"Silvervine_Box110_2"},
17435: {"AegisName":"ID_Legend_hero_Scroll"},
17438: {"AegisName":"3_Life_Potion_pack2"},
17439: {"AegisName":"3_Life_Potion_10pack2"},
17440: {"AegisName":"LI_Change_Name_Box"},
17441: {"AegisName":"LI_Boarding_Halter_Box"},
17442: {"AegisName":"LI_Empelium_Box"},
17443: {"AegisName":"LI_Upg_Buckler_BOX"},
17447: {"AegisName":"Blessing_Midgard_Scroll"},
17449: {"AegisName":"Biscuit_Stick_Set"},
17455: {"AegisName":"Premium_Book_Box"},
17456: {"AegisName":"Vigorgra_Package_v2"},
17457: {"AegisName":"Vigorgra_Package_Set_V2"},
17461: {"AegisName":"Costama_Egg18"},
17464: {"AegisName":"Winter_Midgard_Scroll"},
17465: {"AegisName":"Refine_Ore_Box6"},
17466: {"AegisName":"Refine_Ore_Box6_Set10"},
17467: {"AegisName":"C_Siegfried_Box50"},
17468: {"AegisName":"LI_Neuralizer_3Box"},
17469: {"AegisName":"LI_Neuralizer_1Box"},
17470: {"AegisName":"Costama_Egg19"},
17471: {"AegisName":"Spring_Festival_Scroll"},
17472: {"AegisName":"Vigorgra_Package_v3"},
17473: {"AegisName":"Vigorgra_Package_Set_V3"},
17474: {"AegisName":"C_Wing_Of_Fly_5Day_Box"},
17475: {"AegisName":"LC_Max_Weight_Up_10Box"},
17477: {"AegisName":"Unlimited_Box2"},
17478: {"AegisName":"Unlimited_10_Box2"},
17479: {"AegisName":"Midgard_Fes_Scroll"},
17481: {"AegisName":"Costama_Egg21"},
17482: {"AegisName":"Solaris_Festival_Scroll"},
17483: {"AegisName":"3_Life_Potion_pack3"},
17484: {"AegisName":"3_Life_Potion_10pack3"},
17490: {"AegisName":"Time_Travel_Scroll"},
17491: {"AegisName":"Refine_Ore_Box7"},
17492: {"AegisName":"Refine_Ore_Box7_Set10"},
17493: {"AegisName":"Costama_Egg23"},
17494: {"AegisName":"Happy_Time_Scroll"},
17495: {"AegisName":"Silvervine_Box10_3"},
17496: {"AegisName":"Silvervine_Box110_3"},
17497: {"AegisName":"Costama_Egg24"},
17498: {"AegisName":"3_Life_Potion_pack4"},
17499: {"AegisName":"3_Life_Potion_10pack4"},
17501: {"AegisName":"Vigorgra_Package_v4"},
17502: {"AegisName":"Vigorgra_Package_Set_V4"},
17507: {"AegisName":"Nyangvine_Box4"},
17508: {"AegisName":"Nyangvine_Box10"},
17509: {"AegisName":"Nyangvine_Box40"},
17510: {"AegisName":"Refine_Ore_Box8"},
17511: {"AegisName":"Refine_Ore_Box8_Set10"},
17512: {"AegisName":"LI_HD_Elunium_Box30"},
17513: {"AegisName":"LI_HD_Oridecon_Box30"},
17515: {"AegisName":"Unlimited_Box3"},
17516: {"AegisName":"Unlimited_10_Box3"},
17517: {"AegisName":"Costama_Egg28"},
17519: {"AegisName":"Epic_Heroes_Scroll"},
17520: {"AegisName":"Limit_Manual_Box"},
17521: {"AegisName":"3_Life_Potion_pack5"},
17522: {"AegisName":"3_Life_Potion_10pack5"},
17523: {"AegisName":"Costama_Egg29"},
17524: {"AegisName":"Limit_Power_Booster_Box"},
17525: {"AegisName":"Limit_Power_Booster100"},
17526: {"AegisName":"Majestic_Lucky_Scroll"},
17527: {"AegisName":"Nyangvine_Box200"},
17532: {"AegisName":"Blessing_Lucky_Scroll"},
17544: {"AegisName":"Refine_Ore_Box9"},
17545: {"AegisName":"Refine_Ore_Box9_Set10"},
17547: {"AegisName":"2015LI_NeuralizerBox"},
17548: {"AegisName":"2015LI_S_R_C_Box"},
17549: {"AegisName":"LI_HD_BradiumBox30"},
17550: {"AegisName":"LI_HD_CarniumBox30"},
17552: {"AegisName":"Garnet_Lucky_Scroll"},
17567: {"AegisName":"Almighty_Box4"},
17568: {"AegisName":"Almighty100_Box2"},
17569: {"AegisName":"Dun_Voucher_Box1"},
17570: {"AegisName":"Dun_Voucher_Box2"},
17572: {"AegisName":"Erzulie_Lucky_Scroll"},
17573: {"AegisName":"Nyangvine_Box10_"},
17574: {"AegisName":"Nyangvine_Box100"},
17575: {"AegisName":"Service30_M_01_Box"},
17576: {"AegisName":"Service30_F_01_Box"},
17582: {"AegisName":"3_Life_Potion_pack6"},
17583: {"AegisName":"3_Life_Potion_10pack6"},
17584: {"AegisName":"Venus_Lucky_Scroll"},
17586: {"AegisName":"Refine_Ore_Box10"},
17587: {"AegisName":"Refine_Ore_Box10_Set10"},
17588: {"AegisName":"Amora_Lucky_Scroll"},
17590: {"AegisName":"Service30P_M_01_Box"},
17591: {"AegisName":"Service30P_F_01_Box"},
17592: {"AegisName":"Vigorgra_Package_v5"},
17593: {"AegisName":"Vigorgra_Package_Set_V5"},
17598: {"AegisName":"Sograt_Lucky_Scroll"},
17599: {"AegisName":"C_Greed_1Hour_Box"},
17600: {"AegisName":"C_CatPaw_1Day_Box"},
17601: {"AegisName":"Unlimited_Box4"},
17602: {"AegisName":"Unlimited_10_Box4"},
17607: {"AegisName":"Sanctuary_Lucky_Scroll"},
17608: {"AegisName":"C_Giant_Fly_1Day_Box"},
17609: {"AegisName":"Refine_Ore_Box11"},
17610: {"AegisName":"Refine_Ore_Box11_Set10"},
17613: {"AegisName":"Chronosian_Lucky_Scroll"},
17616: {"AegisName":"3_Life_Potion_pack7"},
17617: {"AegisName":"3_Life_Potion_10pack7"},
17628: {"AegisName":"Cyborg_Lucky_Scroll"},
17631: {"AegisName":"Almighty_Plus_Box"},
17632: {"AegisName":"Almighty100_PlusBox"},
17633: {"AegisName":"Undine_Lucky_Scroll"},
17639: {"AegisName":"Limit_Power_Booster2"},
17640: {"AegisName":"LimitPowerBooster2_100"},
17646: {"AegisName":"LC_Boarding_Halter_Box"},
17648: {"AegisName":"Smithy_Lucky_Scroll"},
17650: {"AegisName":"Refine_Ore_Box12"},
17651: {"AegisName":"Refine_Ore_Box12_Set10"},
17659: {"AegisName":"Ganymede_Lucky_Scroll"},
17662: {"AegisName":"Vigorgra_Plus_Package"},
17663: {"AegisName":"Vigorgra_Plus_Set"},
17665: {"AegisName":"LastAngel_LuckyScroll"},
17668: {"AegisName":"3_Life_Potion_pack8"},
17669: {"AegisName":"3_Life_Potion_10pack8"},
17671: {"AegisName":"Valkyrie_Lucky_Scroll"},
17672: {"AegisName":"Unlimited_Box5"},
17673: {"AegisName":"Unlimited_10_Box5"},
17674: {"AegisName":"Rainbow_Lucky_Scroll"},
17675: {"AegisName":"Refine_Ore_Box13"},
17676: {"AegisName":"Refine_Ore_Box13_Set10"},
17677: {"AegisName":"HD_Refine_Ore_Box"},
17681: {"AegisName":"Midgard_Lucky_Scroll"},
17683: {"AegisName":"Nyangvine_Box10_2"},
17684: {"AegisName":"Nyangvine_Box100_2"},
17689: {"AegisName":"AID_Buff_Box"},
17690: {"AegisName":"Vigorgra_Plus_Package2"},
17691: {"AegisName":"Vigorgra_Plus_Set2"},
17692: {"AegisName":"June_Lucky_Scroll"},
17712: {"AegisName":"3_Life_Potion_pack9"},
17713: {"AegisName":"3_Life_Potion_10pack9"},
17716: {"AegisName":"Refine_Ore_Box14"},
17717: {"AegisName":"Refine_Ore_Box14_Set10"},
17718: {"AegisName":"HD_Refine_Ore_Box2"},
17726: {"AegisName":"Almighty_Plus_Box2"},
17727: {"AegisName":"Almighty100_PlusBox2"},
17742: {"AegisName":"DEF_Scroll_Box"},
17743: {"AegisName":"DEF_Scroll_Box_Set"},
17748: {"AegisName":"Limit_Power_Booster3"},
17749: {"AegisName":"LimitPowerBooster3_100"},
17756: {"AegisName":"HD_High_Refine_Box"},
17759: {"AegisName":"Refine_Ore_Box15_Set10"},
17760: {"AegisName":"Refine_Ore_Box15"},
17761: {"AegisName":"HD_Refine_Ore_Box3"},
17764: {"AegisName":"Vigorgra_Plus_Package3"},
17765: {"AegisName":"Vigorgra_Plus_Set3"},
17766: {"AegisName":"C_CatPaw_7Day_Box"},
17774: {"AegisName":"Almighty_Plus_Box3"},
17775: {"AegisName":"Almighty100_PlusBox3"},
17776: {"AegisName":"3_Life_Potion_pack10"},
17777: {"AegisName":"3_Life_Potion_10pack10"},
17780: {"AegisName":"Cash_Can_Box"},
17783: {"AegisName":"Unlimited_10_Box6"},
17784: {"AegisName":"Unlimited_Box6"},
17792: {"AegisName":"Refine_Ore_Box16"},
17793: {"AegisName":"Refine_Ore_Box16_Set10"},
17794: {"AegisName":"HD_Refine_Ore_Box4"},
17795: {"AegisName":"HD_High_Refine_Box2"},
17799: {"AegisName":"DEF_Scroll_Box2"},
17800: {"AegisName":"DEF_Scroll_Box_Set2"},
17832: {"AegisName":"3_Life_Potion_pack11"},
17833: {"AegisName":"3_Life_Potion_10pack11"},
17881: {"AegisName":"RTC_Anniv_Box"},
17882: {"AegisName":"Refine_Ore_Box17_Set10"},
17883: {"AegisName":"Refine_Ore_Box17"},
17884: {"AegisName":"HD_Refine_Ore_Box5"},
17885: {"AegisName":"HD_High_Refine_Box3"},
17886: {"AegisName":"Infinity_Box"},
17887: {"AegisName":"Infinity_10_Box"},
17888: {"AegisName":"Comp_Kafra_Card_Box"},
17894: {"AegisName":"New_Vigorgra_Package"},
17895: {"AegisName":"New_Vigorgra_Set"},
17901: {"AegisName":"LimitPowerBooster4_100"},
17902: {"AegisName":"Limit_Power_Booster4"},
17914: {"AegisName":"2017_GStar_CostumeBox"},
17920: {"AegisName":"Zero_Merchant_Bell_Box"},
17921: {"AegisName":"Zero_Kafra_Bell_Box"},
17923: {"AegisName":"Refine_Ore_Box18"},
17924: {"AegisName":"Refine_Ore_Box18_Set10"},
17925: {"AegisName":"HD_Refine_Ore_Box6"},
17926: {"AegisName":"HD_High_Refine_Box4"},
17935: {"AegisName":"New_3_Potion_pack"},
17936: {"AegisName":"New_3_Potion_10pack"},
17940: {"AegisName":"Nyangvine_Box10_3"},
17941: {"AegisName":"Nyangvine_Box100_3"},
17944: {"AegisName":"Almighty_Plus_Box4"},
17945: {"AegisName":"Almighty100_PlusBox4"},
17948: {"AegisName":"Refine_Ore_Box19_Set10"},
17949: {"AegisName":"Refine_Ore_Box19"},
17950: {"AegisName":"HD_Refine_Ore_Box7"},
17951: {"AegisName":"HD_High_Refine_Box5"},
17959: {"AegisName":"DEF_Scroll_Box3"},
17960: {"AegisName":"DEF_Scroll_Box_Set3"},
17961: {"AegisName":"3_Life_Potion_pack12"},
17962: {"AegisName":"3_Life_Potion_10pack12"},
17967: {"AegisName":"Infinity_Box2"},
17968: {"AegisName":"Infinity_10_Box2"},
17969: {"AegisName":"A_Vigorgra_Set"},
17970: {"AegisName":"A_Vigorgra_Package"},
17971: {"AegisName":"A_3_Life_Potion_10pack"},
17972: {"AegisName":"A_3_Life_Potion_pack"},
17973: {"AegisName":"A_Almighty100_Box"},
17974: {"AegisName":"A_Almighty_Box"},
17975: {"AegisName":"A_Refine_Ore_Box_Set"},
17976: {"AegisName":"A_Refine_Ore_Box"},
17977: {"AegisName":"A_HD_Refine_Ore_Box"},
17978: {"AegisName":"A_HD_High_Refine_Box"},
17979: {"AegisName":"A_LimitPowerBooster_100"},
17980: {"AegisName":"A_LimitPowerBooster"},
17981: {"AegisName":"A_Infinity_10_Box"},
17982: {"AegisName":"A_Infinity_Box"},
17983: {"AegisName":"A_DEF_Scroll_Box_Set"},
17984: {"AegisName":"A_DEF_Scroll_Box"},
17985: {"AegisName":"A_Unlimited_10_Box"},
17986: {"AegisName":"A_Unlimited_Box"},
17999: {"AegisName":"Inventory_Ex_Box"},
18000: {"AegisName":"Cannon_Ball"},
18001: {"AegisName":"Holy_Cannon_Ball"},
18002: {"AegisName":"Dark_Cannon_Ball"},
18003: {"AegisName":"Soul_Cannon_Ball"},
18004: {"AegisName":"Iron_Cannon_Ball"},
18005: {"AegisName":"Ice_Cannon_Ball"},
18006: {"AegisName":"Lightning_Cannon_Ball"},
18007: {"AegisName":"Stone_Cannon_Ball"},
18008: {"AegisName":"Flare_Cannon_Ball"},
18009: {"AegisName":"Poisoning_Cannon_Ball"},
18100: {"AegisName":"Shooting_Star_C"},
18101: {"AegisName":"F_Bow_Of_Rudra_C"},
18102: {"AegisName":"E_Bow_Of_Rudra_C"},
18103: {"AegisName":"Mystic_Bow"},
18104: {"AegisName":"Adventure_Bow"},
18105: {"AegisName":"Academy_Bow"},
18106: {"AegisName":"P_Bow3"},
18107: {"AegisName":"Malang_Snow_Crab"},
18108: {"AegisName":"Brindle_Eel"},
18109: {"AegisName":"Catapult"},
18110: {"AegisName":"Big_CrossBow"},
18111: {"AegisName":"Creeper_Bow"},
18112: {"AegisName":"Upg_Bow"},
18113: {"AegisName":"Velum_Arbalest"},
18114: {"AegisName":"Velum_CrossBow"},
18115: {"AegisName":"Orc_Archer_Bow_"},
18116: {"AegisName":"Metal_Bow"},
18117: {"AegisName":"Royal_Bow"},
18118: {"AegisName":"TE_Woe_Bow"},
18119: {"AegisName":"Thanos_Bow"},
18120: {"AegisName":"Bow_Of_Evil_Slayer"},
18121: {"AegisName":"Sinister_Bow"},
18122: {"AegisName":"Gigantic_Bow"},
18123: {"AegisName":"Bow_Of_Storm"},
18124: {"AegisName":"Half_BF_Bow1"},
18125: {"AegisName":"Arcus_Daemonicus"},
18126: {"AegisName":"Ru_Blue_Bow"},
18127: {"AegisName":"Ru_Gold_Bow"},
18128: {"AegisName":"Bow_Of_Infinite"},
18129: {"AegisName":"Ixion_Wing_S"},
18130: {"AegisName":"Scarlet_Bow"},
18132: {"AegisName":"Union_Bow"},
18133: {"AegisName":"Bow_of_Trust"},
18137: {"AegisName":"Burning_Bow_"},
18138: {"AegisName":"Frozen_Bow_"},
18139: {"AegisName":"Earth_Bow_"},
18140: {"AegisName":"Gust_Bow_"},
18141: {"AegisName":"Toughen_Metal_Bow"},
18142: {"AegisName":"UnrivaledBow"},
18143: {"AegisName":"Avenger_Hunter_Bow"},
18144: {"AegisName":"Blue_Bow"},
18145: {"AegisName":"Vigilante_Bow"},
18146: {"AegisName":"Diva_Wing"},
18147: {"AegisName":"Mirage_Wing"},
18148: {"AegisName":"Sinister_Bow_J"},
18149: {"AegisName":"Balistar_IL"},
18150: {"AegisName":"Probation_CrossBow"},
18151: {"AegisName":"Probation_Bow"},
18153: {"AegisName":"Neev_Bow_Of_Rogue"},
18154: {"AegisName":"Neev_Hunter_Bow"},
18155: {"AegisName":"Neev_CrossBow"},
18163: {"AegisName":"Vigilante_Bow_J"},
18164: {"AegisName":"Royal_Bow_K"},
18165: {"AegisName":"Rebeginer_RN_Bow"},
18166: {"AegisName":"Rebeginer_WM_Bow"},
18170: {"AegisName":"Narcis_Bow"},
18172: {"AegisName":"Local01_Bow"},
18173: {"AegisName":"Local02_Bow"},
18174: {"AegisName":"Hunter_Bow_IL"},
18175: {"AegisName":"Woe_Bow1_Z"},
18176: {"AegisName":"Sky_Lightning_Bow"},
18177: {"AegisName":"Variant_Wing"},
18178: {"AegisName":"Virtual_Bow_OS"},
18179: {"AegisName":"MH_P89_OS"},
18180: {"AegisName":"AC_B44_OS"},
18182: {"AegisName":"Evt_Royal_Bow_K"},
18183: {"AegisName":"Evt_Narcis_Bow"},
18184: {"AegisName":"Rapid_Fire_C_Bow"},
18185: {"AegisName":"Sharp_Star_Bow"},
18186: {"AegisName":"Aiming_Bow"},
18187: {"AegisName":"Falken_Shooter"},
18188: {"AegisName":"Wind_Gale"},
18190: {"AegisName":"Ein_BHBOW"},
18191: {"AegisName":"G_Knight_Bow"},
18193: {"AegisName":"Rapid_Fire_C_Bow_J"},
18194: {"AegisName":"Sharp_Star_Bow_J"},
18195: {"AegisName":"Aiming_Bow_J"},
18196: {"AegisName":"Falken_Shooter_J"},
18197: {"AegisName":"Wind_Gale_J"},
18198: {"AegisName":"G_Knight_Archer_Bow"},
18200: {"AegisName":"Realgar_Shooter_EXE"},
18201: {"AegisName":"Comp_Scalet_DragonL_Bow"},
18202: {"AegisName":"Comp_Narcis_Bow"},
18500: {"AegisName":"Cheer_Scarf6"},
18501: {"AegisName":"Cheer_Scarf8"},
18502: {"AegisName":"Cheer_Scarf10"},
18503: {"AegisName":"Small_Horn_Of_Devil"},
18504: {"AegisName":"Anubis_Helm_J"},
18505: {"AegisName":"Umbala_Spirit"},
18506: {"AegisName":"Hattah_Black"},
18507: {"AegisName":"Elven_Ears_"},
18508: {"AegisName":"Garuda_Hat"},
18509: {"AegisName":"RWC2010_Indonesia"},
18510: {"AegisName":"Blood_Angel_Hair_Band"},
18511: {"AegisName":"Blood_Angel_Wing_Ear"},
18512: {"AegisName":"Necktie_Of_Tippler"},
18513: {"AegisName":"Shining_Sunflower"},
18514: {"AegisName":"Para_Team_Hat2"},
18515: {"AegisName":"RTC_Winner_Headgear"},
18516: {"AegisName":"RTC_2nd_Headgear"},
18517: {"AegisName":"RTC_3rd_Headgear"},
18518: {"AegisName":"Ear_Of_Angel's_Wing_"},
18519: {"AegisName":"Ear_Of_Devil's_Wing_"},
18520: {"AegisName":"Jaty_C"},
18521: {"AegisName":"Lucky_Clover"},
18522: {"AegisName":"Evil_Marcher_Hat"},
18523: {"AegisName":"Super_Scell"},
18524: {"AegisName":"Dokkebi_Mask"},
18525: {"AegisName":"Watermelon_Hat"},
18526: {"AegisName":"Yummy_Lollipop"},
18527: {"AegisName":"Gloomy_Pumpkin_Hat"},
18528: {"AegisName":"Tare_Neko_Cru"},
18529: {"AegisName":"Drooping_Wild_Rose"},
18530: {"AegisName":"Tha_Despero_Mask"},
18531: {"AegisName":"Drooping_Permeter"},
18532: {"AegisName":"Heart_Ribbon_Band"},
18533: {"AegisName":"Honeybee_Hat"},
18534: {"AegisName":"Fancy_Phantom_Mask"},
18535: {"AegisName":"Pumpkin_Hat_2010"},
18536: {"AegisName":"Foxtail"},
18537: {"AegisName":"Malangdo_Hat"},
18538: {"AegisName":"Devil_Whisper"},
18539: {"AegisName":"Skull_Cap"},
18540: {"AegisName":"Evil_Mask"},
18541: {"AegisName":"Little_Fhat"},
18542: {"AegisName":"Love_Guard"},
18543: {"AegisName":"Witchs_Hat"},
18544: {"AegisName":"Blrabbit_Hband"},
18545: {"AegisName":"Whrabbit_Hband"},
18546: {"AegisName":"Lover_In_Mouth"},
18547: {"AegisName":"Campus_Festival"},
18548: {"AegisName":"Tiny_Hat"},
18549: {"AegisName":"Butterfly_Hairpin"},
18550: {"AegisName":"Asgard_Blessing"},
18551: {"AegisName":"Galaxy_Circlet"},
18552: {"AegisName":"Proba_Angel_Blessing"},
18553: {"AegisName":"Mini_Tree"},
18554: {"AegisName":"King_Prawn_Hat"},
18555: {"AegisName":"General_Helmet"},
18556: {"AegisName":"Angel_Helmet"},
18557: {"AegisName":"Devil_Helmet"},
18558: {"AegisName":"Sinsuncho_Hat"},
18559: {"AegisName":"Fafnir_Skin"},
18560: {"AegisName":"Fafnir_Mask"},
18561: {"AegisName":"B_Feather_Beret"},
18562: {"AegisName":"Bone_Hat"},
18563: {"AegisName":"Heart_Wing_Hairband"},
18564: {"AegisName":"Love_Piece"},
18565: {"AegisName":"St_Pat_Hat"},
18566: {"AegisName":"Nut_Donut_In_Mouth"},
18567: {"AegisName":"Stretched_Nose"},
18568: {"AegisName":"Humming_Bird"},
18569: {"AegisName":"Soft_Sheep_Hat"},
18570: {"AegisName":"Ancient_Gold_Deco"},
18571: {"AegisName":"Lucky_Hat"},
18572: {"AegisName":"Korean_Judge_Hat"},
18573: {"AegisName":"White_Feather"},
18574: {"AegisName":"Lord_of_Death"},
18575: {"AegisName":"Wunderkammer"},
18576: {"AegisName":"YinYang_Earring"},
18577: {"AegisName":"24_Bolt"},
18578: {"AegisName":"Helm_Of_Valor"},
18579: {"AegisName":"9th_Anni_Hat"},
18580: {"AegisName":"Yggdrasil_Crown"},
18581: {"AegisName":"Red_Tiger_Mask"},
18582: {"AegisName":"Blue_Tiger_Mask"},
18583: {"AegisName":"Navy_Drooping_Kitty"},
18584: {"AegisName":"Brown_Drooping_Kitty"},
18585: {"AegisName":"Orange_Bunny_Hairband"},
18586: {"AegisName":"Violet_Bunny_Hairband"},
18587: {"AegisName":"Blue_Bunny_Hairband"},
18588: {"AegisName":"Silvah_Bunny_Hairband"},
18589: {"AegisName":"Strawberry_Hat"},
18590: {"AegisName":"Gemma_Hairband"},
18591: {"AegisName":"Mini_Glasses_"},
18592: {"AegisName":"Nestea_Hat"},
18593: {"AegisName":"Fancy_Mini_Crown"},
18594: {"AegisName":"Magni_Cap_"},
18595: {"AegisName":"Horn_Of_Ancient"},
18596: {"AegisName":"Sprout_Hat"},
18597: {"AegisName":"Mercury_Helm"},
18598: {"AegisName":"Mini_Tree_J"},
18599: {"AegisName":"Black_Devil_Mask"},
18600: {"AegisName":"Cat_Ears_Beret"},
18601: {"AegisName":"Red_Bread_Hat"},
18602: {"AegisName":"Watermelon_Slice"},
18603: {"AegisName":"Black_Devil_Mask_"},
18604: {"AegisName":"Falcon_Mask"},
18605: {"AegisName":"Dark_Age"},
18606: {"AegisName":"Tear_Drop"},
18607: {"AegisName":"Blush_"},
18608: {"AegisName":"Pair_Of_Red_Ribbon2"},
18609: {"AegisName":"Dark_Blindfold_"},
18610: {"AegisName":"7th_Anni_Hat_B"},
18611: {"AegisName":"Black_Glasses_"},
18612: {"AegisName":"White_Musang_Hat"},
18613: {"AegisName":"Black_Musang_Hat"},
18614: {"AegisName":"Grim_Reaper_Hat"},
18615: {"AegisName":"Injured_Eyepatch"},
18616: {"AegisName":"Long_Tongue"},
18617: {"AegisName":"Onigiri_In_Mouth"},
18618: {"AegisName":"Airplane_Hat"},
18619: {"AegisName":"Thief_Bandana"},
18620: {"AegisName":"Heart_Eyepatch"},
18621: {"AegisName":"Gangster_Mask_A"},
18622: {"AegisName":"Rocket_Helm1"},
18623: {"AegisName":"Rocket_Helm2"},
18624: {"AegisName":"Rocket_Helm3"},
18625: {"AegisName":"Rocket_Helm_RWC"},
18626: {"AegisName":"Gelato_Hat"},
18627: {"AegisName":"Dried_Leaf"},
18628: {"AegisName":"Tare_Domovoi"},
18629: {"AegisName":"B_Desert_Wolf_Hat"},
18630: {"AegisName":"Alicel_Drooping_Doll"},
18631: {"AegisName":"Ribbon_Chef_Hat"},
18632: {"AegisName":"Yellow_Poring_Clip"},
18633: {"AegisName":"Pink_Poring_Clip"},
18634: {"AegisName":"Green_Poring_Clip"},
18635: {"AegisName":"Blue_Poring_Clip"},
18636: {"AegisName":"Bridal_Ribbon"},
18637: {"AegisName":"Ancient_Admiral_Helm"},
18638: {"AegisName":"Citron_Hat"},
18639: {"AegisName":"Naval_Officer_Hat"},
18640: {"AegisName":"Starfish_Headband"},
18641: {"AegisName":"Ribbon_Magic_Hat"},
18642: {"AegisName":"Scissorhand_Model"},
18643: {"AegisName":"Rockhand_Model"},
18644: {"AegisName":"Paperhand_Model"},
18645: {"AegisName":"Sailor_Hat"},
18646: {"AegisName":"Cow_Hat"},
18647: {"AegisName":"Star_Eyepatch"},
18648: {"AegisName":"Tongue_Charm"},
18649: {"AegisName":"Lude_Mask"},
18650: {"AegisName":"RWC_Shouting_Mouth"},
18651: {"AegisName":"Ignis_Cap"},
18652: {"AegisName":"Vanargand_Helm"},
18653: {"AegisName":"Deviruchi_Headphone"},
18655: {"AegisName":"Goedo_Monocle"},
18656: {"AegisName":"Wit_Pumpkin_Hat"},
18657: {"AegisName":"Pegasus_Wing_Ears"},
18658: {"AegisName":"Holy_Santa_Beard"},
18659: {"AegisName":"Boitata_Hat"},
18660: {"AegisName":"Indi_Feather_Band"},
18661: {"AegisName":"Trident_Helmet"},
18662: {"AegisName":"Antler_Fedora"},
18663: {"AegisName":"Sunglasses_Bball_Hat"},
18664: {"AegisName":"Blind_Glasses"},
18665: {"AegisName":"Orange_In_Mouth"},
18666: {"AegisName":"CD_In_Mouth"},
18667: {"AegisName":"Cat_Lace_Hairband"},
18668: {"AegisName":"Droopy_Turtle_Hat"},
18669: {"AegisName":"Cowhide_Hat"},
18670: {"AegisName":"Hankie_In_Mouth"},
18671: {"AegisName":"Rudolf_Hairband"},
18672: {"AegisName":"Tare_Pope"},
18673: {"AegisName":"Tare_Pope_"},
18674: {"AegisName":"Planewing_Hat"},
18675: {"AegisName":"Green_Apple_Hat"},
18676: {"AegisName":"Hexagon_Spectacles"},
18677: {"AegisName":"Cherry_Twig_In_Mouth"},
18678: {"AegisName":"Leek_In_Mouth"},
18679: {"AegisName":"Abacus_In_Mouth"},
18680: {"AegisName":"Tw_Frog_Hat"},
18681: {"AegisName":"Puppy_Ears_Hat"},
18682: {"AegisName":"Teardrop"},
18683: {"AegisName":"Carrot_In_Mouth"},
18684: {"AegisName":"Showy_High_Cap"},
18685: {"AegisName":"Stardust_Hairband"},
18686: {"AegisName":"2011_RMSC_1"},
18687: {"AegisName":"2011_RMSC_2"},
18688: {"AegisName":"2011_RMSC_3"},
18689: {"AegisName":"2011_RMSC_4"},
18690: {"AegisName":"Sirt_Evil_Eye"},
18691: {"AegisName":"Rising_Black_Dragon"},
18692: {"AegisName":"Mike_Hat"},
18693: {"AegisName":"Sleeping_Kitty_Cat"},
18694: {"AegisName":"Red_Hood"},
18695: {"AegisName":"Phoenix_Crown"},
18696: {"AegisName":"Orange_Hat"},
18697: {"AegisName":"Syringe_In_Mouth"},
18698: {"AegisName":"Cheesy_Snack_In_Mouth"},
18699: {"AegisName":"Starving_Fish_Hat"},
18700: {"AegisName":"Rabbit_Ribbon"},
18701: {"AegisName":"Ancient_Civil_Man"},
18702: {"AegisName":"Shaving_Cream"},
18703: {"AegisName":"Stem_In_Mouth"},
18704: {"AegisName":"Drosera_Hairpin"},
18705: {"AegisName":"FlipHat"},
18706: {"AegisName":"Can_Hat"},
18707: {"AegisName":"Maneater_Flower_Hat"},
18708: {"AegisName":"Candy_Hat"},
18709: {"AegisName":"Black_Knitted_Hat"},
18710: {"AegisName":"Sugared_Fruit_Stick"},
18711: {"AegisName":"Electric_Sunglass"},
18712: {"AegisName":"Fan_In_Mouth"},
18713: {"AegisName":"Monkey_On_Fur_Hat"},
18714: {"AegisName":"Hippo_Hat"},
18715: {"AegisName":"Helm_Of_Thoth"},
18716: {"AegisName":"Strawberry_In_Mouth"},
18718: {"AegisName":"Rose_Hairband"},
18720: {"AegisName":"Magical_Booster"},
18724: {"AegisName":"L_Magestic_Goat_"},
18725: {"AegisName":"Rabbit_Ear_Knit_Hat"},
18726: {"AegisName":"Sky_Helm"},
18727: {"AegisName":"Sedora_Hat"},
18728: {"AegisName":"Egir_Helm"},
18729: {"AegisName":"MVP_Basketball"},
18730: {"AegisName":"Cryptura_Academy_Hat"},
18731: {"AegisName":"Valkyrie_Outing_Helm"},
18732: {"AegisName":"TE_Woe_Cap"},
18733: {"AegisName":"TE_Woe_Bone_Helm"},
18734: {"AegisName":"TE_Woe_Magic_Eyes"},
18735: {"AegisName":"Drooping_Elven_Ears"},
18736: {"AegisName":"Censor_Bar_"},
18737: {"AegisName":"Fortier_Mask"},
18738: {"AegisName":"White_Boys_Hat"},
18739: {"AegisName":"Carnation_Hairband"},
18740: {"AegisName":"C_Hair_Of_The_Strong"},
18741: {"AegisName":"C_Will_O_Wisp"},
18742: {"AegisName":"C_MoonStar_Accessory"},
18743: {"AegisName":"C_Spirit_Of_Chung_E"},
18744: {"AegisName":"C_World_Star"},
18745: {"AegisName":"Choco_Stick_In_Mouth"},
18746: {"AegisName":"Chilly_Breath"},
18747: {"AegisName":"Eyes_Of_Ifrit"},
18748: {"AegisName":"Gold_Ingot_Poring_Hat"},
18749: {"AegisName":"Majoruros_Horn"},
18750: {"AegisName":"Poker_Card_In_Mouth"},
18751: {"AegisName":"Extreme_Luck_Clover"},
18752: {"AegisName":"Cursed_Book"},
18753: {"AegisName":"Tw_Rice_Ball"},
18754: {"AegisName":"Blood_Sucker"},
18755: {"AegisName":"Feather_Beret_"},
18756: {"AegisName":"Black_Shiba_Inu_Hat"},
18758: {"AegisName":"Hat_Of_Scrat"},
18759: {"AegisName":"Stretched_Nose_M"},
18760: {"AegisName":"Remodel_Wizardry_Hat"},
18761: {"AegisName":"Remodel_Magician_Hat"},
18762: {"AegisName":"Remodel_Mask_Of_Fox"},
18763: {"AegisName":"Remodel_Joker_Jester"},
18764: {"AegisName":"Remodel_Bunny_Band"},
18765: {"AegisName":"Enhanced_Corsair"},
18766: {"AegisName":"Enhanced_Helm_Of_Angel"},
18767: {"AegisName":"Enhanced_Helm_Of_Sun"},
18768: {"AegisName":"Enhanced_Bone_Helm"},
18769: {"AegisName":"Remodel_Munak_Turban"},
18770: {"AegisName":"Remodel_Bongun_Hat"},
18771: {"AegisName":"Remodel_Opera_Mask"},
18772: {"AegisName":"Improved_Binoculars"},
18773: {"AegisName":"Improved_Fin_Helm"},
18774: {"AegisName":"Improved_Assassin_Mask"},
18775: {"AegisName":"Improved_Welding_Mask"},
18776: {"AegisName":"Improved_Kiss_Of_Angel"},
18777: {"AegisName":"Aladdin_Lamp"},
18778: {"AegisName":"Pink_Bunny_Band_J"},
18779: {"AegisName":"RWC_Champ_Crown_Red"},
18780: {"AegisName":"RWC_Champ_Crown_Blue"},
18781: {"AegisName":"RWC_Champ_Crown_Black"},
18782: {"AegisName":"Butterfly_Wing_Ear_J"},
18783: {"AegisName":"Rose_Crown"},
18784: {"AegisName":"Elder_Devil_Horn"},
18785: {"AegisName":"King_Poring_Hat"},
18786: {"AegisName":"Anemos_Mask"},
18787: {"AegisName":"Goal_Tender_Mask"},
18788: {"AegisName":"Starlight_Scope"},
18789: {"AegisName":"Poison_Spore_Hat"},
18790: {"AegisName":"Rainbow_Poring_Hat"},
18791: {"AegisName":"Shrine_Maiden_Hat"},
18792: {"AegisName":"Idn_Sakkat"},
18793: {"AegisName":"Sorc_Night_Cap"},
18796: {"AegisName":"RWC_Champ_Crown_QF"},
18797: {"AegisName":"Deep_Angel_Hairband"},
18798: {"AegisName":"Pink_Angel_Hairband"},
18799: {"AegisName":"Nero_Mask"},
18801: {"AegisName":"Gale_Hairband"},
18802: {"AegisName":"Boss_Hat"},
18803: {"AegisName":"Rose_Cascade"},
18804: {"AegisName":"Thornbush_Hairband"},
18805: {"AegisName":"Eclipse_Hat"},
18806: {"AegisName":"Black_Rabbit_Hat"},
18807: {"AegisName":"Yellow_Yuzu_Hat"},
18808: {"AegisName":"Wing_Form_Spectacle"},
18809: {"AegisName":"8th_Anni_Hat_B"},
18810: {"AegisName":"Hell_Pumpkin_Hat"},
18811: {"AegisName":"JRO_White_Snake"},
18812: {"AegisName":"Elder_Crown"},
18813: {"AegisName":"New_Wave_Sunglasses"},
18814: {"AegisName":"Angel_School_Cap"},
18815: {"AegisName":"Devil_School_Cap"},
18816: {"AegisName":"Adv_Angel_School_Cap"},
18817: {"AegisName":"Adv_Devil_School_Cap"},
18818: {"AegisName":"Red_Pencil_In_Mouth"},
18819: {"AegisName":"Blue_Pencil_In_Mouth"},
18820: {"AegisName":"Gray_Helmet"},
18821: {"AegisName":"Rainbow_Feather_Deco"},
18822: {"AegisName":"Flame_Wing_Ear"},
18823: {"AegisName":"Imperial_Feather"},
18824: {"AegisName":"Mask_Of_Bankrupt"},
18825: {"AegisName":"Money_Lost_Spirit"},
18827: {"AegisName":"Valkyrie_Circlet"},
18828: {"AegisName":"2012RMSCNO1"},
18829: {"AegisName":"2012RMSCNO2"},
18830: {"AegisName":"2012RMSCNO3"},
18831: {"AegisName":"2012RMSCNO4"},
18832: {"AegisName":"Rolf_Von_Gigue_666"},
18833: {"AegisName":"Marin_Crown"},
18834: {"AegisName":"Sakura_Hairband"},
18838: {"AegisName":"Angeling_Woolly_Hat"},
18839: {"AegisName":"Poring_Sunglasses"},
18841: {"AegisName":"Small_Poring_Band"},
18842: {"AegisName":"Hat_Of_Girl"},
18843: {"AegisName":"Small_Deviling_Hat"},
18844: {"AegisName":"Blue_Poring_Bubble"},
18845: {"AegisName":"Banshee_Master_Kiss"},
18846: {"AegisName":"C_Guard_Of_Neptune"},
18847: {"AegisName":"Jolly_Roger"},
18848: {"AegisName":"Lush_Rose"},
18849: {"AegisName":"Celines_Ribbon"},
18850: {"AegisName":"Polar_Bear_Cap"},
18851: {"AegisName":"ValentineHeart"},
18852: {"AegisName":"D_Strawberry_Hat"},
18853: {"AegisName":"D_Strawberry_Hat_"},
18854: {"AegisName":"ValentineYellowHeart"},
18855: {"AegisName":"Aviator_Hat"},
18856: {"AegisName":"W_King_Tiger_Doll_Hat"},
18857: {"AegisName":"Curupira_Hat"},
18858: {"AegisName":"Pink_Angeling_Bubble"},
18859: {"AegisName":"Angeling_Bubble"},
18860: {"AegisName":"Preschool_Hat"},
18861: {"AegisName":"Zaha_Doll_Hat_J"},
18862: {"AegisName":"Armor_Chiu_J"},
18863: {"AegisName":"Exorcist_Robe"},
18864: {"AegisName":"Earth_Goddess_Flower_J"},
18865: {"AegisName":"Sword_Master_Crown"},
18866: {"AegisName":"Owlduke_Silk_Hat"},
18867: {"AegisName":"Vajra"},
18868: {"AegisName":"Assassin_Skull_Mask"},
18869: {"AegisName":"Donut_In_Mouth_J"},
18870: {"AegisName":"Event_Sweet_Candy"},
18871: {"AegisName":"Event_Sweet_Candy2"},
18872: {"AegisName":"Snake_Hat"},
18873: {"AegisName":"Sweet_Valentine_Out"},
18874: {"AegisName":"One_Eyed_Glass_"},
18877: {"AegisName":"Baron_Evil_Eye"},
18878: {"AegisName":"Palace_Guard_Cap"},
18879: {"AegisName":"Angry_Scorpion_Hat"},
18880: {"AegisName":"BLACKDEATHKING_GOLDEN"},
18881: {"AegisName":"Yggdrasil_Hat"},
18882: {"AegisName":"Kannam_On_Head"},
18883: {"AegisName":"Black_Witch_Hat"},
18884: {"AegisName":"Tatenasi_Helmet"},
18885: {"AegisName":"Jejecap"},
18887: {"AegisName":"Aqua_Bunny_Band"},
18888: {"AegisName":"Maroon_Bunny_Band"},
18889: {"AegisName":"Golden_Bunny_Band"},
18890: {"AegisName":"Gray_Bunny_Band"},
18891: {"AegisName":"Husky_Hat"},
18892: {"AegisName":"Ufo_Poring_Hat"},
18893: {"AegisName":"Dragon_Claw_Helm"},
18894: {"AegisName":"Rainbow_Star"},
18895: {"AegisName":"Celestial_Dark_Flame"},
18896: {"AegisName":"Pterios_Fins"},
18897: {"AegisName":"Azure_Diadem"},
18898: {"AegisName":"Yggdrasil_Herald_Crown"},
18900: {"AegisName":"Weisswurst"},
18901: {"AegisName":"Seppl_Hat"},
18902: {"AegisName":"Shovel_Hat"},
18903: {"AegisName":"Frozen_Land_Rose"},
18904: {"AegisName":"Man_Medal"},
18905: {"AegisName":"Butterfly_Barrettes"},
18906: {"AegisName":"Holy_Rosario"},
18908: {"AegisName":"Isabella_Red_Ear"},
18909: {"AegisName":"Isabella_Brown_Ear"},
18910: {"AegisName":"Isabella_Blue_Ear"},
18912: {"AegisName":"Bell_Pigeon"},
18913: {"AegisName":"Gossip_Raven"},
18914: {"AegisName":"Kid_Deviling"},
18915: {"AegisName":"Blood_Buffterfly"},
18916: {"AegisName":"Bear_Balloon"},
18917: {"AegisName":"LoveLove_Balloon"},
18918: {"AegisName":"Long_Octopus_Balloon"},
18919: {"AegisName":"Jack_Castle_Bat"},
18920: {"AegisName":"Bork"},
18921: {"AegisName":"C_Aladdin_Lamp"},
18922: {"AegisName":"ILCHONGOM"},
18923: {"AegisName":"RokBlackCat"},
18924: {"AegisName":"Fez_Of_Gentle"},
18925: {"AegisName":"GodOfWinds_Fan"},
18926: {"AegisName":"Green_Foxtail"},
18929: {"AegisName":"Elephant_Model_Hat"},
18930: {"AegisName":"Gorilla_Model_Hat"},
18931: {"AegisName":"Lion_Model_Hat"},
18932: {"AegisName":"Rhino_Model_Hat"},
18933: {"AegisName":"Mechanical_Plant_Hat"},
18934: {"AegisName":"Fox_Ears_Bell_Ribbon"},
18935: {"AegisName":"There_Is_Something"},
18936: {"AegisName":"Golden_Fish"},
18937: {"AegisName":"Memories_Of_Lovers"},
18938: {"AegisName":"Astro_Circle"},
18939: {"AegisName":"Black_Cat_Ears_Beret"},
18940: {"AegisName":"10_Gallon_Hat_Of_Flame"},
18941: {"AegisName":"Hunting_Cap_Of_Gust"},
18942: {"AegisName":"Knit_Cap_Of_Water"},
18943: {"AegisName":"Silk_Hat_Of_Earth"},
18947: {"AegisName":"Pipe_Of_Jiraiya"},
18948: {"AegisName":"Mask_Of_Orochimaru"},
18949: {"AegisName":"Scroll_Of_Tsunade"},
18950: {"AegisName":"Gerhard_Von_Devi"},
18954: {"AegisName":"Rabbit_Head_Dress"},
18955: {"AegisName":"Pirates_Foolish"},
18956: {"AegisName":"Chocolate_Bomb"},
18959: {"AegisName":"Old_Pink_Poo_Hat"},
18960: {"AegisName":"Love_Daddy_2013"},
18962: {"AegisName":"Panda_Balloon"},
18965: {"AegisName":"Shaving_Foam"},
18968: {"AegisName":"Jinn_Marin_Balloon"},
18969: {"AegisName":"Boss_Beret"},
18970: {"AegisName":"Moon_Cat_Magic"},
18971: {"AegisName":"Old_Rune_Circlet"},
18972: {"AegisName":"Old_Mitra"},
18973: {"AegisName":"Old_Driver_Band_R"},
18974: {"AegisName":"Old_Driver_Band_Y"},
18975: {"AegisName":"Old_Shadow_Handicraft"},
18976: {"AegisName":"Old_Minstrel_Song_Hat"},
18977: {"AegisName":"Old_Midas_Whisper"},
18978: {"AegisName":"Old_Magic_Stone_Hat"},
18979: {"AegisName":"Old_Blazing_Soul"},
18980: {"AegisName":"Old_Wind_Whisper"},
18981: {"AegisName":"Old_Dying_Swan"},
18982: {"AegisName":"Old_Circlet_Of_Bone"},
18983: {"AegisName":"Old_Protect_Of_Crown"},
18984: {"AegisName":"Old_Camo_RabbitHood"},
18985: {"AegisName":"Falconer_Flute"},
18987: {"AegisName":"RWC13_Jormungandr_Hat"},
18992: {"AegisName":"New_Year_Hairpin"},
18993: {"AegisName":"Flower_Hat"},
18997: {"AegisName":"Riot_Chip"},
19004: {"AegisName":"Happy_Balloon"},
19006: {"AegisName":"Victory_Ear_Accessary"},
19010: {"AegisName":"Baby_Dragon_Hat"},
19011: {"AegisName":"Little_Devil_S_Horn"},
19014: {"AegisName":"Gravekeeper_Blinker"},
19015: {"AegisName":"C_Gemma_Hairband"},
19018: {"AegisName":"White_Choco_Bear"},
19019: {"AegisName":"Elemental_Crown"},
19020: {"AegisName":"Survive_Circlet"},
19021: {"AegisName":"Gigant_Helm"},
19022: {"AegisName":"Floating_Stone_Of_Int"},
19023: {"AegisName":"Q_Scaraba_Crown"},
19024: {"AegisName":"Protect_Feathers"},
19025: {"AegisName":"Puppy_Ears_Hat_Jp"},
19026: {"AegisName":"Egir_Helm_K"},
19027: {"AegisName":"10_Type_Glasses"},
19028: {"AegisName":"Minions_Of_Devil"},
19030: {"AegisName":"Pretty_Rabbit_Hood"},
19031: {"AegisName":"Fallen_Angel_Blessing"},
19033: {"AegisName":"Accessories_Of_Goddess"},
19034: {"AegisName":"37_Sculpt"},
19035: {"AegisName":"Otter_Hat"},
19036: {"AegisName":"Brabery_Hat"},
19037: {"AegisName":"93_BloodyWing"},
19038: {"AegisName":"12th_Crown"},
19039: {"AegisName":"12th_ElvenEars"},
19041: {"AegisName":"666_DevilEar"},
19042: {"AegisName":"Maneater_Flower_Hairpin"},
19043: {"AegisName":"Goibne's_Helmet_S"},
19044: {"AegisName":"Morrigane's_Helm_S"},
19045: {"AegisName":"14_RainbowWing"},
19046: {"AegisName":"DeadlyPoison_Manteau"},
19047: {"AegisName":"Angeling_KnitCap"},
19048: {"AegisName":"Elemental_Clothe"},
19050: {"AegisName":"Loki_Nidhogg_Hat"},
19051: {"AegisName":"Moon_Cat_Warrior"},
19052: {"AegisName":"Sigrun's_Wing_C"},
19053: {"AegisName":"Moon_Cat_Fighter"},
19079: {"AegisName":"CelestialWoman_Flower"},
19080: {"AegisName":"NettyHeart_BalloonGum"},
19081: {"AegisName":"Faceworm_Egg_Shell"},
19082: {"AegisName":"Bio_Protector"},
19083: {"AegisName":"Mask_of_Hero"},
19084: {"AegisName":"Parfait_V_Hat"},
19085: {"AegisName":"Sigrun's_Wing_"},
19086: {"AegisName":"Robo_Eye_"},
19087: {"AegisName":"Angel_Spirit_"},
19088: {"AegisName":"Binoculars_"},
19089: {"AegisName":"Blinker_"},
19090: {"AegisName":"Alarm_Mask_"},
19091: {"AegisName":"Opera_Ghost_Mask_"},
19092: {"AegisName":"Machoman_Glasses_"},
19093: {"AegisName":"Spinning_Eyes_"},
19094: {"AegisName":"Mr_Smile_"},
19095: {"AegisName":"Happy_Balloon_K"},
19096: {"AegisName":"Special_Kapra_Hat"},
19097: {"AegisName":"Ribbon_Piamat_K"},
19098: {"AegisName":"Piamette_Hood"},
19101: {"AegisName":"Glastheim_Onlooker"},
19102: {"AegisName":"Pale_Moon_Hat"},
19103: {"AegisName":"Kings_Crown"},
19104: {"AegisName":"YDragon_SkyWing"},
19105: {"AegisName":"Explosion_Gum"},
19106: {"AegisName":"Magicstone_Of_Grace"},
19107: {"AegisName":"Mad_Hatter"},
19108: {"AegisName":"Wild_Poring_Rider"},
19109: {"AegisName":"Valhalla_Idol"},
19110: {"AegisName":"Valhalla_Idol_"},
19111: {"AegisName":"Laser_Of_Eagle"},
19112: {"AegisName":"Tengu_Scroll"},
19113: {"AegisName":"Gemini_Eyes"},
19114: {"AegisName":"Sting_Silk_Ribbon"},
19115: {"AegisName":"Republic_Hat"},
19116: {"AegisName":"Red_Baby_Dragon"},
19117: {"AegisName":"Poring_Sunglasses_K"},
19118: {"AegisName":"Poring_Sunglasses_K_"},
19119: {"AegisName":"Toughen_Time_Keeper_Hat"},
19125: {"AegisName":"Cylinder_Hairband"},
19126: {"AegisName":"Shadow_Booster_"},
19127: {"AegisName":"Zherlthsh_Mask_"},
19128: {"AegisName":"Ifrit's_Ear_"},
19129: {"AegisName":"Chick_Hat_"},
19130: {"AegisName":"Magic_Eyes_"},
19131: {"AegisName":"Radio_Antenna_"},
19132: {"AegisName":"Masquerade_"},
19133: {"AegisName":"Odin_Mask_"},
19134: {"AegisName":"Whikebain_Ears_K"},
19135: {"AegisName":"Spirit_Of_Chung_E"},
19136: {"AegisName":"Spirit_Of_Chung_E_"},
19137: {"AegisName":"Strawberry_In_Mouth_"},
19138: {"AegisName":"SeraphimCoronet"},
19139: {"AegisName":"SurviveOrb"},
19140: {"AegisName":"Squirrel_Ear_Hat"},
19141: {"AegisName":"Tha_Maero_Mask_J"},
19142: {"AegisName":"Droop_Gunslinger_J"},
19143: {"AegisName":"Poring_Balloon"},
19144: {"AegisName":"Felock_Cap_"},
19145: {"AegisName":"Whistle"},
19146: {"AegisName":"Marin_Balloon"},
19147: {"AegisName":"Drops_Balloon"},
19148: {"AegisName":"SantaPoring_Balloon"},
19149: {"AegisName":"Poporing_Balloon"},
19150: {"AegisName":"Metaling_Balloon"},
19151: {"AegisName":"Deviling_Balloon"},
19152: {"AegisName":"Angeling_Balloon"},
19153: {"AegisName":"Ghostring_Balloon"},
19154: {"AegisName":"Archangeling_Balloon"},
19155: {"AegisName":"Demons_Eye"},
19156: {"AegisName":"Lunar_Rainbow"},
19157: {"AegisName":"Droop_Gunslinger"},
19158: {"AegisName":"C_Gemini_Eyes"},
19159: {"AegisName":"Barrel_Helm"},
19162: {"AegisName":"Scuba_Mask_K"},
19163: {"AegisName":"CatharinaPawnBrad60"},
19164: {"AegisName":"Para_Team_Hat100"},
19165: {"AegisName":"Para_Team_Hat160"},
19166: {"AegisName":"RoCelebrationHat"},
19168: {"AegisName":"Kafra_Employee_Band"},
19169: {"AegisName":"K_King_Tiger_Doll_Hat"},
19170: {"AegisName":"Guardian_Processor"},
19171: {"AegisName":"Magician_Knithat"},
19172: {"AegisName":"PoPe_Osuwari_Head"},
19173: {"AegisName":"Luwmin_Ice"},
19174: {"AegisName":"Flying_Drone"},
19175: {"AegisName":"Jack_Head"},
19176: {"AegisName":"Fallen_Angel_Blessing_"},
19177: {"AegisName":"Elemental_Crown_K"},
19178: {"AegisName":"Elemental_Crown_K_"},
19179: {"AegisName":"Rabbit_Magic_Hat_"},
19180: {"AegisName":"Anubis_Helm_"},
19181: {"AegisName":"New_Wave_Sunglasses_"},
19185: {"AegisName":"Blackhand_Of_Fate"},
19189: {"AegisName":"Racing_C_Mecha"},
19190: {"AegisName":"Racing_C_Gene"},
19191: {"AegisName":"Racing_C_Cross"},
19192: {"AegisName":"Racing_C_Chaser"},
19193: {"AegisName":"Racing_C_Warlock"},
19194: {"AegisName":"Racing_C_Sorcer"},
19195: {"AegisName":"Racing_C_Rune"},
19196: {"AegisName":"Racing_C_Royal"},
19197: {"AegisName":"Racing_C_Bishop"},
19198: {"AegisName":"Racing_C_Sura"},
19199: {"AegisName":"Racing_C_Ranger"},
19200: {"AegisName":"Racing_C_Mins"},
19201: {"AegisName":"Racing_C_Wander"},
19202: {"AegisName":"Racing_C_Gunner"},
19203: {"AegisName":"Racing_C_Ninja"},
19204: {"AegisName":"Racing_C_Super"},
19205: {"AegisName":"Racing_C_Doram"},
19209: {"AegisName":"Nurse_Cap_IL"},
19210: {"AegisName":"Apple_Of_Archer_IL"},
19211: {"AegisName":"Magical_Feather_K"},
19212: {"AegisName":"Malangdo_Pirate"},
19217: {"AegisName":"TW_Cock_Hat"},
19218: {"AegisName":"Time_Keeper_Glasses"},
19219: {"AegisName":"JP_EV12"},
19221: {"AegisName":"Golden_Angel_Band_TH"},
19223: {"AegisName":"Cap_IL"},
19238: {"AegisName":"PoringTownOnion"},
19239: {"AegisName":"PoringTownCarrot"},
19240: {"AegisName":"Toy_Syringe_K"},
19241: {"AegisName":"Magical_Booster_K"},
19242: {"AegisName":"Cat_Lace_Hairband_K"},
19243: {"AegisName":"Blue_Rear_Ribbon"},
19244: {"AegisName":"Necklace_Rosary_K"},
19245: {"AegisName":"Crimson_Booster"},
19246: {"AegisName":"Royalguard_Necklace"},
19247: {"AegisName":"Fancy_Flower_IL"},
19249: {"AegisName":"Spell_Circuit"},
19252: {"AegisName":"KarduiEar_BR"},
19256: {"AegisName":"Mobile_BeginnerMark"},
19261: {"AegisName":"2017RTCSymbole"},
19262: {"AegisName":"Jirant_Circlet"},
19263: {"AegisName":"General_Helmet_"},
19264: {"AegisName":"GoldFish_Hat"},
19265: {"AegisName":"Smoky_TransformHat"},
19266: {"AegisName":"Survive_Circlet_K"},
19267: {"AegisName":"SurviveOrb_K"},
19268: {"AegisName":"FaceWorm_Breath"},
19269: {"AegisName":"Angel_Of_Happiness_J"},
19272: {"AegisName":"Garden_Of_Eden"},
19273: {"AegisName":"Gemini_RedEyes"},
19274: {"AegisName":"OpenAir_Headset"},
19275: {"AegisName":"Rental_Scuba_Mask"},
19276: {"AegisName":"Return_TW_1th_Hat"},
19277: {"AegisName":"Soda_In_Mouth"},
19281: {"AegisName":"Agenda_RobeJ"},
19282: {"AegisName":"Consultation_RobeJ"},
19283: {"AegisName":"K_Heart_Wing_Hairband"},
19284: {"AegisName":"K_New_Wave_Sunglasses"},
19285: {"AegisName":"Helmet_Of_Siegfried_J"},
19286: {"AegisName":"IA_Choker"},
19287: {"AegisName":"C_Cat_Poring_Balloon"},
19288: {"AegisName":"C_Gigant_Helm"},
19289: {"AegisName":"C_Moon_Eyepatch"},
19290: {"AegisName":"C_Elder_Devil_Horn"},
19291: {"AegisName":"C_Shiba_Inu"},
19292: {"AegisName":"C_Wildcat_Knit_Cap"},
19293: {"AegisName":"C_SmartUnderRim_Glasses"},
19294: {"AegisName":"C_CatEars_Cyber_HeadP_R"},
19295: {"AegisName":"Red_Baby_Dragon_TW"},
19296: {"AegisName":"Classical_Fhat"},
19298: {"AegisName":"Tatenasi_Helmet_TW"},
19299: {"AegisName":"Tree_Of_Sprout_JP"},
19300: {"AegisName":"Dog_Officer"},
19306: {"AegisName":"Heart_Card_In_Mouth"},
19307: {"AegisName":"Willothewisp"},
19308: {"AegisName":"Amistr_Beret"},
19310: {"AegisName":"Rebeginer_Cap"},
19311: {"AegisName":"Greater_Dracul_Horn"},
19312: {"AegisName":"Neev_Barrette"},
19313: {"AegisName":"Neev_Barrette_"},
19314: {"AegisName":"Royal_Mantle"},
19316: {"AegisName":"Squirrel_Ear_Hat_BR"},
19318: {"AegisName":"Royalguard_Necklace_BR"},
19319: {"AegisName":"Beelzebub_Hat"},
19320: {"AegisName":"Dwarf_Beard_J"},
19321: {"AegisName":"Bell_Pigeon_J"},
19326: {"AegisName":"Book_of_Soyga"},
19327: {"AegisName":"Feather_Of_Seraphim"},
19328: {"AegisName":"Spider_Temp_TW"},
19329: {"AegisName":"Hand_Of_Devil"},
19337: {"AegisName":"Hat_of_Goggle"},
19338: {"AegisName":"Clover_Silkhat"},
19339: {"AegisName":"Egg_Crispinette"},
19340: {"AegisName":"Saint_Egg_Shell"},
19341: {"AegisName":"Devil_Egg_Shell"},
19342: {"AegisName":"Bull_Hat"},
19343: {"AegisName":"Circlet_Of_Phoenix"},
19344: {"AegisName":"Headband_Of_Power_IL"},
19347: {"AegisName":"Clinging_Doram_1"},
19349: {"AegisName":"Pizza_Hat_J"},
19350: {"AegisName":"Carrot_In_Mouth_J"},
19353: {"AegisName":"C_BearBalloon_TW"},
19364: {"AegisName":"Engineer_Cap_K"},
19366: {"AegisName":"Goibne_Helmet_IL"},
19367: {"AegisName":"Burst_Flame"},
19371: {"AegisName":"C_BaphoJ_Parachute_TW"},
19373: {"AegisName":"Sparkler_Stick_TH"},
19379: {"AegisName":"Striking_hat"},
19380: {"AegisName":"Floating_Ball"},
19381: {"AegisName":"Protect_cloth"},
19382: {"AegisName":"Pop_Popcorn_Hat"},
19387: {"AegisName":"Exa_Goat_Cap"},
19388: {"AegisName":"Crow_Tengu_Mask_Z"},
19389: {"AegisName":"E_Oxygen_Mask"},
19390: {"AegisName":"Mira_Tower_Hat"},
19391: {"AegisName":"Eyes_Of_Illusion"},
19393: {"AegisName":"Magic_Star_TW"},
19396: {"AegisName":"Racing_C_Star"},
19397: {"AegisName":"Racing_C_Soul"},
19398: {"AegisName":"Falcon_Feather"},
19399: {"AegisName":"Grand_Peco_Band_Z"},
19400: {"AegisName":"Sleepr_Hat_Z"},
19401: {"AegisName":"Gothic_Heart_Wing_TW"},
19402: {"AegisName":"Many_StarsJ"},
19403: {"AegisName":"Memory_Of_Noodle"},
19404: {"AegisName":"Biting_Off_Rideword"},
19405: {"AegisName":"Autumnal_Flavor"},
19406: {"AegisName":"Harvest_Festa_Hat"},
19407: {"AegisName":"Work_Cap"},
19408: {"AegisName":"Charm_Of_Misticfrozen"},
19409: {"AegisName":"Black_Feather"},
19410: {"AegisName":"Kings_Mini_Melon"},
19411: {"AegisName":"Floating_Gioia"},
19412: {"AegisName":"Flame_Bird"},
19415: {"AegisName":"White_Bird_Rose"},
19424: {"AegisName":"C_Master_Cat"},
19425: {"AegisName":"Master_Cat"},
19426: {"AegisName":"King_Of_Spirit_Circlet"},
19427: {"AegisName":"RabbitFamilyBalloon"},
19428: {"AegisName":"Morpheus_Hood_IL"},
19429: {"AegisName":"Zarathustra"},
19433: {"AegisName":"ResonateTaego_TW"},
19435: {"AegisName":"PoringBeret_TW"},
19436: {"AegisName":"VesperHeadGear"},
19437: {"AegisName":"LittleGarden"},
19438: {"AegisName":"ZilantNecklace"},
19439: {"AegisName":"Subject_Aura"},
19443: {"AegisName":"Star_Eyepatch_JP"},
19444: {"AegisName":"Star_Eyepatch_JP_"},
19445: {"AegisName":"Injured_Eyepatch_JP"},
19446: {"AegisName":"Injured_Eyepatch_JP_"},
19447: {"AegisName":"Leo_Crown_J"},
19449: {"AegisName":"Cancer_Crown_J"},
19451: {"AegisName":"Heavenly_Order"},
19452: {"AegisName":"Heavenly_Order_"},
19453: {"AegisName":"Jejecap_JP"},
19459: {"AegisName":"C_Luna_On_Shoulder"},
19460: {"AegisName":"Black_Veil_J"},
19462: {"AegisName":"Cat_In_Mouth_J"},
19463: {"AegisName":"Melon_Cap"},
19464: {"AegisName":"C_Melon_Cap"},
19465: {"AegisName":"Cherry_Blossom_Hat_YL"},
19466: {"AegisName":"C_Small_ocean"},
19468: {"AegisName":"Libra_Diadem_J"},
19469: {"AegisName":"Crown_Of_Saint_Jp"},
19471: {"AegisName":"Scorpio_Crown_J"},
19472: {"AegisName":"C_S_Circlet_Of_Time"},
19473: {"AegisName":"Taurus_Diadem_J"},
19474: {"AegisName":"S_Circlet_Of_Time_RK"},
19475: {"AegisName":"S_Circlet_Of_Time_LG"},
19476: {"AegisName":"S_Circlet_Of_Time_NC"},
19477: {"AegisName":"S_Circlet_Of_Time_GN"},
19478: {"AegisName":"S_Circlet_Of_Time_GC"},
19479: {"AegisName":"S_Circlet_Of_Time_SC"},
19480: {"AegisName":"S_Circlet_Of_Time_AB"},
19481: {"AegisName":"S_Circlet_Of_Time_SR"},
19482: {"AegisName":"S_Circlet_Of_Time_WL"},
19483: {"AegisName":"S_Circlet_Of_Time_SO"},
19484: {"AegisName":"S_Circlet_Of_Time_RA"},
19485: {"AegisName":"S_Circlet_Of_Time_WM"},
19486: {"AegisName":"S_Circlet_Of_Time_SJ"},
19487: {"AegisName":"S_Circlet_Of_Time_SP"},
19488: {"AegisName":"S_Circlet_Of_Time_RL"},
19489: {"AegisName":"S_Circlet_Of_Time_OB"},
19490: {"AegisName":"S_Circlet_Of_Time_KG"},
19491: {"AegisName":"S_Circlet_Of_Time_NV"},
19492: {"AegisName":"S_Circlet_Of_Time_SU"},
19495: {"AegisName":"Diabolus_Wing"},
19496: {"AegisName":"Aquarius_Crown_J"},
19497: {"AegisName":"Phantom_Of_Masquerade"},
19498: {"AegisName":"CitrusRibbon"},
19499: {"AegisName":"FortunetellinSealed"},
19500: {"AegisName":"T_Mr_Smile"},
19501: {"AegisName":"T_Spinx_Helm"},
19502: {"AegisName":"T_Goggle"},
19503: {"AegisName":"T_Munak_Hat"},
19504: {"AegisName":"T_Sunglasses"},
19505: {"AegisName":"T_Cigarette"},
19506: {"AegisName":"T_Valkyrie_Feather_Band"},
19507: {"AegisName":"Clear_Sun"},
19508: {"AegisName":"T_Gemmed_Sallet"},
19509: {"AegisName":"Butterfly_Wing_Ear"},
19510: {"AegisName":"Nut_On_Head"},
19511: {"AegisName":"Heart_Eye_Patch1"},
19512: {"AegisName":"Heart_Eye_Patch2"},
19513: {"AegisName":"Chicken_Beak"},
19514: {"AegisName":"Charlie_Beard"},
19515: {"AegisName":"Yellow_Hat"},
19516: {"AegisName":"Singing_Bird"},
19517: {"AegisName":"Cocks_Comb"},
19518: {"AegisName":"Rainbow"},
19519: {"AegisName":"Lightning_Cloud"},
19520: {"AegisName":"Rain_Cloud"},
19521: {"AegisName":"Charlie_Hat"},
19522: {"AegisName":"Mini_Crown1"},
19523: {"AegisName":"Donation_Ribbon"},
19524: {"AegisName":"C_Green_Feeler"},
19525: {"AegisName":"C_Jack_A_Dandy"},
19526: {"AegisName":"C_Helm"},
19527: {"AegisName":"C_Sharp_Gear"},
19528: {"AegisName":"C_Iron_Cane"},
19529: {"AegisName":"C_Angelic_Chain"},
19530: {"AegisName":"C_Wild_Rose"},
19531: {"AegisName":"C_Cube_Mask"},
19532: {"AegisName":"C_Red_Bunny_Band"},
19533: {"AegisName":"C_Spore_Hat"},
19534: {"AegisName":"C_Tha_Despero_Mask"},
19535: {"AegisName":"C_Sinsuncho_Hat"},
19536: {"AegisName":"C_Rose_Corsage"},
19537: {"AegisName":"C_Gryphon_Hat"},
19538: {"AegisName":"Full_Moon"},
19539: {"AegisName":"C_Reginleif_Hairband"},
19540: {"AegisName":"C_Rabbit_Earplug"},
19541: {"AegisName":"C_Romantic_White_Flower"},
19542: {"AegisName":"C_Devil_Whisper"},
19543: {"AegisName":"Oliver_Wolf_Hood"},
19544: {"AegisName":"C_Tare_Neko_Cru"},
19545: {"AegisName":"C_Boys_Cap"},
19546: {"AegisName":"C_Valkyrie_Helm"},
19547: {"AegisName":"C_Deviruchi_Cap"},
19548: {"AegisName":"C_Frog_Cap"},
19549: {"AegisName":"C_Magestic_Goat"},
19550: {"AegisName":"C_Blush"},
19551: {"AegisName":"C_Elven_Ears"},
19552: {"AegisName":"C_Centimental_Flower"},
19553: {"AegisName":"C_Assassin_Mask_"},
19554: {"AegisName":"C_Hahoe_Mask"},
19555: {"AegisName":"C_Crescent_Helm"},
19556: {"AegisName":"C_Kabuki_Mask"},
19557: {"AegisName":"C_Ayothaya_Hat"},
19558: {"AegisName":"C_Raven_Cap"},
19559: {"AegisName":"C_B_Dragon_Hat"},
19560: {"AegisName":"C_Quati_Hat"},
19561: {"AegisName":"C_Tucan_Hat"},
19562: {"AegisName":"C_Jaguar_Hat"},
19563: {"AegisName":"C_Dragon_Arhat_Mask"},
19564: {"AegisName":"C_Tiger_Arhat_Mask"},
19565: {"AegisName":"C_Chung_Hairband"},
19566: {"AegisName":"C_Samurai_Mask"},
19567: {"AegisName":"C_Hattah_Black"},
19568: {"AegisName":"C_Horn_Of_Ancient"},
19569: {"AegisName":"C_Sprout_Hat"},
19570: {"AegisName":"C_Mercury_Helm"},
19571: {"AegisName":"C_White_Musang_Hat"},
19572: {"AegisName":"C_Black_Musang_Hat"},
19573: {"AegisName":"C_Heart_Wing_Hairband"},
19574: {"AegisName":"C_Lord_of_Death"},
19575: {"AegisName":"C_Rising_Black_Dragon"},
19576: {"AegisName":"C_Tare_Pope"},
19577: {"AegisName":"10th_Anni_Poring_Hat"},
19578: {"AegisName":"C_Goggle"},
19579: {"AegisName":"C_Red_Wing_Hat"},
19580: {"AegisName":"C_Sphinx_Helm"},
19581: {"AegisName":"C_Brabery_Hat"},
19582: {"AegisName":"C_Cowboy_Hat"},
19583: {"AegisName":"C_Gangster_Patch"},
19584: {"AegisName":"C_Pirate_Dagger"},
19585: {"AegisName":"C_Feather_Beret"},
19586: {"AegisName":"C_Pink_Bunny_Band_J"},
19587: {"AegisName":"C_King_Poring_Hat"},
19588: {"AegisName":"C_Cat_Hat_J"},
19589: {"AegisName":"C_Fallen_Angel_Lost_J"},
19590: {"AegisName":"C_Twin_Ribbon_J"},
19591: {"AegisName":"C_Red_Ribbon_J"},
19592: {"AegisName":"C_Hibiscus_J"},
19593: {"AegisName":"C_Laurel_Wreath_J"},
19594: {"AegisName":"C_Geographer_J"},
19595: {"AegisName":"C_Dress_Hat_J"},
19596: {"AegisName":"C_Flying_Angel_J"},
19597: {"AegisName":"C_Magic_Eyes_J"},
19598: {"AegisName":"C_Wondering_Wolf_Helm"},
19599: {"AegisName":"C_Imp_Hat"},
19600: {"AegisName":"Drooping_Kiehl"},
19601: {"AegisName":"Drooping_Aliot"},
19602: {"AegisName":"C_Invisible_Cap"},
19603: {"AegisName":"C_Invisible_Sunglasses"},
19604: {"AegisName":"C_Invisible_Mask"},
19605: {"AegisName":"C_Gang_Scarf"},
19606: {"AegisName":"C_Ninja_Scroll"},
19607: {"AegisName":"C_Love_Chick_Hat"},
19608: {"AegisName":"C_Chick_Hat"},
19609: {"AegisName":"C_Red_Glasses"},
19610: {"AegisName":"C_Whisper_Mask"},
19611: {"AegisName":"C_Pecopeco_Wing_Ears"},
19612: {"AegisName":"C_Headset_OST"},
19613: {"AegisName":"C_Valkyrie_Feather_Band"},
19614: {"AegisName":"C_Super_Novice_Hat"},
19615: {"AegisName":"C_Loki_Mask"},
19616: {"AegisName":"C_Ear_Of_Black_Cat"},
19617: {"AegisName":"C_Ear_Of_Puppy"},
19618: {"AegisName":"C_Mask_Of_Fox"},
19619: {"AegisName":"C_Corsair"},
19620: {"AegisName":"C_Detective_Hat"},
19621: {"AegisName":"C_Ear_Of_Devils_Wing"},
19622: {"AegisName":"C_First_Moon_Hair_Pin"},
19623: {"AegisName":"C_Bizofnil_Wing_Deco"},
19624: {"AegisName":"C_Round_Eyes"},
19625: {"AegisName":"C_Bunny_Band"},
19626: {"AegisName":"C_Chullos"},
19627: {"AegisName":"C_Satellite_Hairband"},
19628: {"AegisName":"C_Headset"},
19629: {"AegisName":"C_Tiara"},
19630: {"AegisName":"C_Crown"},
19631: {"AegisName":"C_Boss_Hat"},
19632: {"AegisName":"C_Hat"},
19633: {"AegisName":"C_Flower_Hairband"},
19634: {"AegisName":"C_Flu_Mask"},
19635: {"AegisName":"C_Mini_Propeller"},
19636: {"AegisName":"C_Pierrot_Nose"},
19637: {"AegisName":"C_Nurse_Cap"},
19638: {"AegisName":"C_Mr_Smile"},
19639: {"AegisName":"C_Sahkkat"},
19640: {"AegisName":"C_Charming_Ribbon"},
19641: {"AegisName":"C_Helm_Of_Darkness"},
19642: {"AegisName":"C_Moonlight_Flower_Hat"},
19643: {"AegisName":"C_Whikebain_Ears"},
19644: {"AegisName":"C_Takius_Blindfold"},
19645: {"AegisName":"C_Chinese_Crown"},
19646: {"AegisName":"C_Ramen_Hat"},
19647: {"AegisName":"C_Red_Deviruchi_Cap"},
19648: {"AegisName":"C_Fallen_Leaves"},
19649: {"AegisName":"C_White_Baby_Cat_Ears"},
19650: {"AegisName":"C_Rainbow_Feather_Deco"},
19651: {"AegisName":"C_RWC_Shouting_Mouth"},
19652: {"AegisName":"C_Rabbit_Magic_Hat"},
19653: {"AegisName":"C_Marcher_Hat"},
19654: {"AegisName":"C_J_Captain_Hat"},
19655: {"AegisName":"C_Tiraya_Bonnet"},
19656: {"AegisName":"C_Minstrel_Hat"},
19657: {"AegisName":"C_Captain_Hat"},
19658: {"AegisName":"C_Vacation_Hat"},
19659: {"AegisName":"C_Gray_Fur_Hat"},
19660: {"AegisName":"C_Coppola"},
19661: {"AegisName":"C_Sweet_Bonnet"},
19662: {"AegisName":"C_Magician_Hat"},
19663: {"AegisName":"Wishing_Sky_Lantern"},
19664: {"AegisName":"C_Campus_Festival"},
19665: {"AegisName":"C_Poring_Cake_Cap"},
19666: {"AegisName":"C_Cookie_Hat"},
19667: {"AegisName":"C_Helm_Of_Dragoon"},
19668: {"AegisName":"C_Wind_Milestone"},
19669: {"AegisName":"C_Reginleif_Wings_J"},
19670: {"AegisName":"C_Southern_Cross"},
19671: {"AegisName":"C_Pig_Moneybox"},
19672: {"AegisName":"C_Poring_Letter"},
19673: {"AegisName":"C_Love_Guard"},
19674: {"AegisName":"C_Evil_Mask"},
19675: {"AegisName":"C_Jumping_Poring"},
19676: {"AegisName":"C_Rainbow_Poring_Hat"},
19677: {"AegisName":"C_Soulless_Wing"},
19678: {"AegisName":"C_Bell_Ribbon"},
19679: {"AegisName":"C_Round_Eyes_J"},
19680: {"AegisName":"C_Tongue_Mask"},
19681: {"AegisName":"C_Silver_Tiara"},
19682: {"AegisName":"C_Santa_Poring_Hat"},
19683: {"AegisName":"C_Sweet_Candy"},
19684: {"AegisName":"C_Happy_Wig"},
19685: {"AegisName":"C_ShineSantaPoring"},
19686: {"AegisName":"C_SantaHairband"},
19687: {"AegisName":"C_Lush_Rose"},
19688: {"AegisName":"C_RJC_Katusa"},
19689: {"AegisName":"C_Ati_Atihan_Hat"},
19690: {"AegisName":"C_Dark_Snake_Lord_Hat_J"},
19691: {"AegisName":"C_Blue_Ribbon"},
19692: {"AegisName":"C_Antique_Pipe_J"},
19693: {"AegisName":"C_Triple_Poring_Hat"},
19694: {"AegisName":"C_Vane_Hairpin"},
19695: {"AegisName":"C_Kettle_Hat"},
19696: {"AegisName":"C_Friend_Mochiring_Hat"},
19697: {"AegisName":"C_Rudolph_Santa_Hat"},
19698: {"AegisName":"C_Bf_Recruiter_Hat"},
19699: {"AegisName":"C_Gf_Recruiter_Hat"},
19700: {"AegisName":"RWC12_ChampCrown_J"},
19701: {"AegisName":"C_Red_Bonnet"},
19702: {"AegisName":"C_Santa_Hat_1"},
19703: {"AegisName":"C_Afro_Wig_Black"},
19704: {"AegisName":"C_Afro_Wig_Red"},
19705: {"AegisName":"C_Afro_Wig_Yellow"},
19706: {"AegisName":"C_Red_Dress_Hat"},
19707: {"AegisName":"C_Polar_Bear_Cap"},
19708: {"AegisName":"Elizabeth"},
19709: {"AegisName":"C_Yellow_Ribbon"},
19710: {"AegisName":"C_Wings_Of_Victory"},
19711: {"AegisName":"C_Kafra_Band"},
19712: {"AegisName":"C_Little_Angel_Doll"},
19713: {"AegisName":"C_Lucky_Clover"},
19714: {"AegisName":"C_Lady_Tanee_Doll"},
19715: {"AegisName":"C_Scarf"},
19716: {"AegisName":"C_Alice_Doll"},
19717: {"AegisName":"C_Ribbon_Pink"},
19718: {"AegisName":"C_Gothic_Head_Dress"},
19719: {"AegisName":"C_Coronet"},
19720: {"AegisName":"C_Oldman's_Romance"},
19721: {"AegisName":"C_Darkness_Helm"},
19722: {"AegisName":"C_Black_Glasses"},
19723: {"AegisName":"C_Sacred_Torch_Coronet"},
19724: {"AegisName":"C_Deprotai_Doll_Hat"},
19725: {"AegisName":"C_Bread_Bag2"},
19726: {"AegisName":"C_Scarlet_Rose"},
19727: {"AegisName":"C_Deviling_Hat"},
19728: {"AegisName":"C_Tare_Zonda"},
19729: {"AegisName":"C_Neko_Mimi_Kafra"},
19730: {"AegisName":"C_Snake_Hat"},
19731: {"AegisName":"C_Satanic_Chain"},
19732: {"AegisName":"C_Goblin_Mask_04"},
19733: {"AegisName":"C_Panda_Cap"},
19734: {"AegisName":"C_Binoculars"},
19735: {"AegisName":"C_Fin_Helm"},
19736: {"AegisName":"C_Gas_Mask"},
19737: {"AegisName":"C_Corsair_K"},
19738: {"AegisName":"C_Detective_Hat_K"},
19739: {"AegisName":"C_Sleeping_Kitty_Cat"},
19740: {"AegisName":"C_Guildsman_Recruiter"},
19741: {"AegisName":"C_Majestic_Evil_Horn"},
19742: {"AegisName":"Little_Golden_Wing"},
19743: {"AegisName":"C_Anubis_Helm_J"},
19744: {"AegisName":"C_Black_Tail_Ribbon"},
19745: {"AegisName":"C_Holy_Marching_Hat_J"},
19746: {"AegisName":"C_Cap_Of_Blindness"},
19747: {"AegisName":"C_Tha_Despero_Mask_J"},
19748: {"AegisName":"C_Diadem"},
19749: {"AegisName":"C_Gold_Spirit_Chain"},
19750: {"AegisName":"C_Saint_Frill_Ribbon"},
19751: {"AegisName":"C_Light_Darkness_Crown"},
19752: {"AegisName":"C_Shelter_Wing_Ears"},
19753: {"AegisName":"C_Celestial_Hat"},
19754: {"AegisName":"C_Good_Wedding_Veil"},
19755: {"AegisName":"C_YinYang_Earring"},
19756: {"AegisName":"C_Holy_Mom_Love"},
19757: {"AegisName":"C_Water_Lily_Crown"},
19758: {"AegisName":"C_King_Frog_Hat"},
19759: {"AegisName":"C_Umbrella_Hat"},
19760: {"AegisName":"C_Rainbow_Veil"},
19761: {"AegisName":"C_White_Lily"},
19762: {"AegisName":"C_Happy_Peace_Proof"},
19763: {"AegisName":"C_Leaf_Cat_Hat"},
19764: {"AegisName":"C_Card_In_The_Mouth"},
19765: {"AegisName":"C_Ear_Of_Angel's_Wing"},
19766: {"AegisName":"C_Yggdrasil_Hat"},
19767: {"AegisName":"C_Home_Cherry_Blossom"},
19768: {"AegisName":"C_Sakura_Coronet"},
19769: {"AegisName":"C_Mischievous_Fairy"},
19770: {"AegisName":"C_Japan_Winecup"},
19771: {"AegisName":"C_Butterfly_Hairpin"},
19772: {"AegisName":"C_Honeybee_Hat"},
19773: {"AegisName":"C_Angeling_Hairpin"},
19774: {"AegisName":"C_Emperor_Wreath_J"},
19775: {"AegisName":"C_Marvelous_Wig"},
19776: {"AegisName":"C_Tomboy_Fairy"},
19777: {"AegisName":"C_Twinkle_Little_Star"},
19778: {"AegisName":"C_King_Berry"},
19779: {"AegisName":"C_Persika"},
19780: {"AegisName":"C_Rabbit_Ear_Knit_Hat"},
19781: {"AegisName":"C_Ear_Of_Angel's_Wing_"},
19782: {"AegisName":"C_Drooping_Kitty"},
19783: {"AegisName":"C_Granpa_Beard"},
19784: {"AegisName":"C_Morrigane's_Helm"},
19785: {"AegisName":"C_Well_Baked_Toast"},
19786: {"AegisName":"C_Mistress_Crown"},
19787: {"AegisName":"C_Devoted_Eyes"},
19788: {"AegisName":"C_Heart_Eyepatch"},
19789: {"AegisName":"C_Sweet_Gents"},
19790: {"AegisName":"C_Wedding_Veil"},
19791: {"AegisName":"C_Alarm_Mask"},
19792: {"AegisName":"C_Goblin_Mask_01"},
19793: {"AegisName":"C_Goblin_Mask_02"},
19794: {"AegisName":"C_Goblin_Mask_03"},
19795: {"AegisName":"C_Lord_Circlet"},
19796: {"AegisName":"C_Bone_Helm"},
19797: {"AegisName":"C_Apple_Of_Archer"},
19798: {"AegisName":"C_Angry_Mouth"},
19799: {"AegisName":"C_Golden_Gear"},
19800: {"AegisName":"C_Carnation_Hairband"},
19801: {"AegisName":"C_Fox_Hat_J"},
19802: {"AegisName":"C_Drooping_Nine_Tail"},
19803: {"AegisName":"C_Pinwheel_Cap"},
19804: {"AegisName":"C_Red_Vane_Hairpin"},
19805: {"AegisName":"C_Taboo_Curse_Scroll"},
19806: {"AegisName":"C_Full_Bloom_Hairpin"},
19807: {"AegisName":"C_Majestic_Helmet"},
19808: {"AegisName":"C_Blazing_Sun"},
19809: {"AegisName":"C_Cowboy_Hat_J"},
19810: {"AegisName":"C_Ifrit's_Ear"},
19811: {"AegisName":"C_Beer_Cap"},
19812: {"AegisName":"C_Large_Hibiscus"},
19813: {"AegisName":"C_Icecream_Hat"},
19814: {"AegisName":"C_Shiny_Wig"},
19815: {"AegisName":"C_Lolita_Ten_Gallon_Hat"},
19816: {"AegisName":"C_Pecopeco_Cap"},
19817: {"AegisName":"C_Ifrits_Breath"},
19818: {"AegisName":"C_Droop_Morocc_Minion"},
19819: {"AegisName":"C_Necromencer_Hood"},
19820: {"AegisName":"C_Bone_Hat"},
19821: {"AegisName":"C_Hyegun_Hat"},
19822: {"AegisName":"C_Yellow_Bandana"},
19823: {"AegisName":"C_White_Cat_Hood"},
19824: {"AegisName":"C_Evil_Druid_Hat"},
19825: {"AegisName":"C_Vicious_Stop_Bandage"},
19826: {"AegisName":"C_Ice_Wing_Ear"},
19827: {"AegisName":"C_Amistr_Cap"},
19828: {"AegisName":"C_Fedora"},
19829: {"AegisName":"C_Straw_Hat"},
19830: {"AegisName":"C_Sunglasses"},
19831: {"AegisName":"C_Filir_Hat"},
19832: {"AegisName":"C_Poring_Hat"},
19833: {"AegisName":"C_Fillet"},
19834: {"AegisName":"C_Baseball_Cap"},
19835: {"AegisName":"C_Lif_Doll_Hat"},
19836: {"AegisName":"C_L_Magestic_Goat"},
19837: {"AegisName":"C_Asara_Fairy_Hat"},
19838: {"AegisName":"C_Fox_Hat"},
19839: {"AegisName":"C_Vanilmirth_Hat"},
19840: {"AegisName":"C_Helm_Of_Sun"},
19841: {"AegisName":"C_Dragonhelm_Copper"},
19842: {"AegisName":"C_Puppy_Hat"},
19843: {"AegisName":"C_Cat_Hairband"},
19844: {"AegisName":"C_Turban"},
19845: {"AegisName":"C_Hair_Protector"},
19846: {"AegisName":"C_Opera_Ghost_Mask"},
19847: {"AegisName":"C_Big_Sis_Ribbon"},
19848: {"AegisName":"C_Angeling_Hat"},
19849: {"AegisName":"C_Munak_Turban"},
19850: {"AegisName":"C_Bongun_Hat"},
19851: {"AegisName":"C_Brown_Bear_Cap"},
19852: {"AegisName":"C_Galapago_Cap"},
19853: {"AegisName":"C_Filir_Wing_Ears"},
19854: {"AegisName":"C_Ear_Of_Black_Cat_"},
19855: {"AegisName":"C_Happy_Summer_Wig"},
19856: {"AegisName":"C_Iceflake_Hat"},
19857: {"AegisName":"C_King_Prawn_Hat"},
19858: {"AegisName":"C_Leaf_Headgear"},
19859: {"AegisName":"C_Flying_Angel"},
19860: {"AegisName":"C_Cryptura_Hair_Cap"},
19861: {"AegisName":"C_Heart_Hair_Pin"},
19862: {"AegisName":"C_Horn_Of_Succubus"},
19863: {"AegisName":"C_Inccubus_Horn"},
19864: {"AegisName":"C_Afro_Wig"},
19865: {"AegisName":"C_Joker_Jester"},
19866: {"AegisName":"C_Blue_Pajamas_Hat"},
19867: {"AegisName":"C_Pink_Pajamas_Hat"},
19868: {"AegisName":"aegis_19868"},
19869: {"AegisName":"C_Ancient_Civil_Man"},
19870: {"AegisName":"C_Black_Rabbit_Hat"},
19871: {"AegisName":"C_Music_Decoration"},
19872: {"AegisName":"C_Phantom_Of_Opera"},
19873: {"AegisName":"C_Carnival_Hat"},
19874: {"AegisName":"C_Carnival_Circlet"},
19875: {"AegisName":"C_Love_Rabbit_Hood"},
19876: {"AegisName":"C_Rabbit_Ear_Hat"},
19877: {"AegisName":"C_Eyes_Of_Darkness"},
19878: {"AegisName":"C_Drooping_Bunny"},
19879: {"AegisName":"C_Black_Bunny_Band"},
19880: {"AegisName":"C_Gold_Tiara"},
19881: {"AegisName":"C_Pretty_Rabbit_Hood"},
19882: {"AegisName":"C_Flowerpot_Mask"},
19883: {"AegisName":"C_Piamette_Hood"},
19884: {"AegisName":"C_Vanargandr_Helm"},
19885: {"AegisName":"C_Blinker"},
19886: {"AegisName":"C_Luxury_Sunglasses"},
19887: {"AegisName":"C_One_Eyed_Glass"},
19888: {"AegisName":"C_Glasses"},
19889: {"AegisName":"C_Pair_Of_Red_Ribbon"},
19890: {"AegisName":"C_Wizardry_Hat"},
19891: {"AegisName":"C_Fried_Egg_Hat"},
19892: {"AegisName":"C_Night_Sparrow_Hat"},
19893: {"AegisName":"C_Black_Mage_Hat"},
19894: {"AegisName":"C_Shrine_Maiden_Hat"},
19895: {"AegisName":"C_Sorc_Night_Cap"},
19896: {"AegisName":"C_Ph_Ro_10th_Cap"},
19897: {"AegisName":"RPC13_1ST_Wreath"},
19898: {"AegisName":"RPC13_2ND_Wreath"},
19899: {"AegisName":"RPC13_3RD_Wreath"},
19900: {"AegisName":"Special_Eyepatch"},
19901: {"AegisName":"C_Viking_Helm"},
19902: {"AegisName":"C_Cigar"},
19903: {"AegisName":"C_Witchs_Hat"},
19904: {"AegisName":"C_Skull_Cap"},
19905: {"AegisName":"C_Secret_Society_Hood"},
19906: {"AegisName":"C_24_Bolt"},
19907: {"AegisName":"C_Fancy_Phantom_Mask"},
19908: {"AegisName":"C_Joker_Jester_"},
19909: {"AegisName":"C_White_Deviruchi_Cap"},
19910: {"AegisName":"C_Halloween_Hat"},
19911: {"AegisName":"C_Triangular_Roof_Hat"},
19912: {"AegisName":"C_Cat_Eye"},
19913: {"AegisName":"C_Poo_Poo_Hat"},
19914: {"AegisName":"Felock_Cap"},
19915: {"AegisName":"C_Little_Devil_S_Horn"},
19916: {"AegisName":"C_Black_Cat_Hat"},
19917: {"AegisName":"C_Gloomy_Pumpkin_Hat"},
19918: {"AegisName":"C_Lude_Mask"},
19919: {"AegisName":"C_Cube_Mask_"},
19920: {"AegisName":"C_Adv_Whisper_Mask"},
19921: {"AegisName":"C_Drooping_Wild_Rose"},
19922: {"AegisName":"C_Noah_Hat"},
19923: {"AegisName":"C_Dark_Age"},
19924: {"AegisName":"C_Odin_Mask"},
19925: {"AegisName":"C_One_Eyed_Glasses"},
19926: {"AegisName":"C_Ribbon_Black"},
19927: {"AegisName":"C_Gray_Drooping_Kitty"},
19928: {"AegisName":"C_Gothic_Heart_Wing"},
19929: {"AegisName":"C_Classical_Ribbon"},
19930: {"AegisName":"C_Angel_Mini_Silk_Hat"},
19931: {"AegisName":"C_Lazy_Raccoon"},
19932: {"AegisName":"C_Cap_Of_Concentration"},
19933: {"AegisName":"C_711_Headphone"},
19934: {"AegisName":"C_10Gallon_Hat_Of_Flame"},
19935: {"AegisName":"C_Hunting_Cap_Of_Gust"},
19936: {"AegisName":"C_Knit_Cap_Of_Water"},
19937: {"AegisName":"C_Silk_Hat_Of_Earth"},
19938: {"AegisName":"LI_C_Love_Rabbit_Hood"},
19939: {"AegisName":"C_Antler"},
19940: {"AegisName":"C_Event_Pierrot_Nose"},
19941: {"AegisName":"C_Ear_Mufs"},
19942: {"AegisName":"C_Orchid_Hairband"},
19943: {"AegisName":"C_Hat_Of_Judge"},
19944: {"AegisName":"C_RTC_Third_Best"},
19945: {"AegisName":"C_RTC_Third"},
19946: {"AegisName":"C_Rocket_Helm_RWC"},
19947: {"AegisName":"C_Rainbow_Scarf"},
19948: {"AegisName":"C_Globe_Hat"},
19949: {"AegisName":"C_RWC_2013_Hat"},
19950: {"AegisName":"C_RWC_Champ_Crown"},
19951: {"AegisName":"C_Solo_Play_Box2"},
19952: {"AegisName":"C_Bubble_Gum_In_Mouth"},
19953: {"AegisName":"C_Parade_Cap"},
19954: {"AegisName":"C_3D_Glasses"},
19955: {"AegisName":"C_Mini_Tree_J"},
19956: {"AegisName":"C_Soldier_Hat"},
19957: {"AegisName":"C_Scooter_Hat_J"},
19958: {"AegisName":"C_Choir_Hat"},
19959: {"AegisName":"C_Drooping_Argiope"},
19960: {"AegisName":"C_Chain_Puppet"},
19961: {"AegisName":"C_Rune_Circlet"},
19962: {"AegisName":"C_Mitra"},
19963: {"AegisName":"C_Driver_Band_R"},
19964: {"AegisName":"C_Driver_Band_Y"},
19965: {"AegisName":"C_Shadow_Handicraft"},
19966: {"AegisName":"C_Minstrel_Song_Hat"},
19967: {"AegisName":"C_Midas_Whisper"},
19968: {"AegisName":"C_Magic_Stone_Hat"},
19969: {"AegisName":"C_Blazing_Soul"},
19970: {"AegisName":"C_Wind_Whisper"},
19971: {"AegisName":"C_Dying_Swan"},
19972: {"AegisName":"C_Protect_Of_Crown"},
19973: {"AegisName":"C_Circlet_Of_Bone"},
19974: {"AegisName":"C_Camouflage_RabbitHood"},
19975: {"AegisName":"C_Boss_Beret"},
19976: {"AegisName":"C_Cat_Santa_Hat"},
19977: {"AegisName":"C_Golden_Exclamation"},
19978: {"AegisName":"C_Silver_Exclamation"},
19979: {"AegisName":"C_Golden_Question"},
19980: {"AegisName":"C_Silver_Question"},
19981: {"AegisName":"C_Santa_Beard"},
19982: {"AegisName":"C_Santa's_Hat"},
19983: {"AegisName":"C_Flower_Hairpin"},
19984: {"AegisName":"C_Winter_Hat"},
19985: {"AegisName":"C_Aura_Quartz_Crown"},
19986: {"AegisName":"C_Lunatic_Hat"},
19987: {"AegisName":"C_Blue_Fur_Hat"},
19988: {"AegisName":"C_Elder_Crown"},
19989: {"AegisName":"C_Mouton_Life"},
19990: {"AegisName":"C_Snow_Rabbit_Knit_Hat"},
19991: {"AegisName":"C_Galanthus_Guard"},
19992: {"AegisName":"C_Chilly_Breath"},
19993: {"AegisName":"C_Onigiri_In_Mouth"},
19994: {"AegisName":"C_saLUsalo_Cap"},
19995: {"AegisName":"Flower_Blossom"},
19996: {"AegisName":"Horse_King"},
19997: {"AegisName":"C_Bomb_Hat"},
19998: {"AegisName":"C_Dragon_Turtle_Hat"},
19999: {"AegisName":"C_Mouse_Hat1"},
20000: {"AegisName":"C_Mouse_Hat2"},
20001: {"AegisName":"C_Mouse_Hat3"},
20002: {"AegisName":"C_Mouse_Hat4"},
20003: {"AegisName":"C_Mouse_Hat5"},
20004: {"AegisName":"C_Big_Golden_Bell"},
20005: {"AegisName":"C_Pegasus_Wing_Ears"},
20006: {"AegisName":"C_Dark_Knight_Mask"},
20007: {"AegisName":"C_Bullock_Helm_J"},
20008: {"AegisName":"C_General_Helmet"},
20009: {"AegisName":"C_Dragon_Skull"},
20010: {"AegisName":"C_Rainbow_Wing_Ears"},
20011: {"AegisName":"C_Lightning_Speed"},
20012: {"AegisName":"C_Double_Horn_Helm"},
20013: {"AegisName":"C_Hat_Of_Cook"},
20014: {"AegisName":"Lincoln_Hat"},
20015: {"AegisName":"Lincoln_Beard"},
20016: {"AegisName":"Lobster_Hat"},
20017: {"AegisName":"C_Marionette_Doll"},
20018: {"AegisName":"Horo_Ears"},
20019: {"AegisName":"Beret_Of_Artist"},
20020: {"AegisName":"C_Zaha_Doll_Hat_J"},
20021: {"AegisName":"C_Heart_Ribbon_Band"},
20022: {"AegisName":"C_Love_Piece"},
20023: {"AegisName":"C_Red_Beret"},
20024: {"AegisName":"C_Ribbon_Orange"},
20025: {"AegisName":"C_Cow_Hat1"},
20026: {"AegisName":"C_Cow_Hat2"},
20027: {"AegisName":"C_Cow_Hat3"},
20028: {"AegisName":"C_Cow_Hat4"},
20029: {"AegisName":"C_Donut_In_Mouth_J"},
20030: {"AegisName":"C_Choco_Donut_In_Mouth"},
20031: {"AegisName":"C_Bunny_Head_Dress"},
20032: {"AegisName":"C_Firinto_Scarf"},
20033: {"AegisName":"C_Buddhist_Priest_Crown"},
20034: {"AegisName":"C_Jack_Castle_Bat"},
20035: {"AegisName":"C_Miracle_Blue_Rose"},
20036: {"AegisName":"C_Sword_Master_Crown"},
20037: {"AegisName":"C_Owlduke_Silk_Hat"},
20038: {"AegisName":"Alphonse_Helmet"},
20039: {"AegisName":"C_Butterfly_Wing_Ear_J"},
20040: {"AegisName":"C_Rose_Crown"},
20041: {"AegisName":"C_Earth_Goddess_Flower"},
20042: {"AegisName":"C_Hermose_Cap"},
20043: {"AegisName":"C_Red_Cherry_Blossom"},
20044: {"AegisName":"C_Carmen_Miranda_Hat"},
20045: {"AegisName":"C_Samambaia"},
20046: {"AegisName":"C_Decoration_bluerose"},
20047: {"AegisName":"C_Pray_Cherry_Blossom"},
20048: {"AegisName":"C_Wind_Of_The_Prairie"},
20049: {"AegisName":"C_Plaster"},
20050: {"AegisName":"C_Ph.D_Hat"},
20051: {"AegisName":"C_Stop_Post"},
20052: {"AegisName":"C_Notice_Board"},
20053: {"AegisName":"C_White_Tiger_Hat"},
20054: {"AegisName":"C_Baby_Pacifier"},
20055: {"AegisName":"C_Ghost_Bandana"},
20056: {"AegisName":"C_Bride_Corolla"},
20057: {"AegisName":"C_Feather_Bonnet"},
20058: {"AegisName":"C_Headband_Of_Power"},
20059: {"AegisName":"C_Welding_Mask"},
20060: {"AegisName":"C_Safety_Helmet"},
20061: {"AegisName":"C_Ganster_Mask"},
20062: {"AegisName":"C_Angel_Stairs"},
20063: {"AegisName":"Yellow_Brain_Hat"},
20064: {"AegisName":"Blue_Brain_Hat"},
20065: {"AegisName":"C_Hairband_Of_Grandpeco"},
20066: {"AegisName":"C_Pecopeco_Hairband"},
20067: {"AegisName":"C_Whrabbit_Hband"},
20068: {"AegisName":"C_Blrabbit_Hband"},
20069: {"AegisName":"C_Gryphon_Hairband"},
20070: {"AegisName":"C_Alpaca_Hood"},
20071: {"AegisName":"C_Worg_In_Mouth"},
20072: {"AegisName":"C_Deviruchi_Cap_"},
20073: {"AegisName":"C_Hair_Band"},
20074: {"AegisName":"C_Biretta"},
20075: {"AegisName":"C_Little_Fhat"},
20076: {"AegisName":"C_Idun_Wing_Ears"},
20077: {"AegisName":"C_Wing_Form_Spectacle"},
20078: {"AegisName":"C_White_Feather"},
20079: {"AegisName":"C_Love_Daddy_2013"},
20080: {"AegisName":"C_Shaman's_Hair_Orna"},
20081: {"AegisName":"MetalDragon_Helm"},
20082: {"AegisName":"MetalDragon_Hat"},
20083: {"AegisName":"Mythlit_Hat"},
20084: {"AegisName":"C_Clover_Coronet"},
20085: {"AegisName":"C_Clover_Silkhat"},
20086: {"AegisName":"C_DragonCintamani_Hat1"},
20087: {"AegisName":"C_DragonCintamani_Hat2"},
20088: {"AegisName":"C_DragonCintamani_Hat3"},
20089: {"AegisName":"C_DragonCintamani_Hat4"},
20090: {"AegisName":"C_Egg_Shell"},
20091: {"AegisName":"C_Smoking_Pipe"},
20092: {"AegisName":"C_Sales_Signboard"},
20093: {"AegisName":"C_Star_Sparkling"},
20094: {"AegisName":"C_Fillet_Green"},
20095: {"AegisName":"C_Fillet_Red"},
20096: {"AegisName":"C_Fillet_Blue"},
20097: {"AegisName":"C_Fillet_White"},
20098: {"AegisName":"C_Vampire_Hairband"},
20099: {"AegisName":"C_Ljosalfar"},
20100: {"AegisName":"C_Volume_Fhat"},
20101: {"AegisName":"C_Bragi_Wing_Ears"},
20102: {"AegisName":"C_Horse_King"},
20103: {"AegisName":"C_Drooping_Panda"},
20104: {"AegisName":"C_Picky_Egg_Shell"},
20105: {"AegisName":"C_Fish_Head_Hat"},
20106: {"AegisName":"C_Classic_Hat"},
20107: {"AegisName":"C_Fish_In_Mouth"},
20108: {"AegisName":"C_Blind_Glasses"},
20109: {"AegisName":"C_Jolly_Roger"},
20110: {"AegisName":"C_Coiledup_Snake_Hat1"},
20111: {"AegisName":"C_Coiledup_Snake_Hat2"},
20112: {"AegisName":"C_Aqua_Ten_Gallon_Hat"},
20113: {"AegisName":"C_Star_Reading_Hat"},
20114: {"AegisName":"C_Funeral_Costume"},
20115: {"AegisName":"C_Under_Rim_Glasses"},
20116: {"AegisName":"C_Mermaid_Headphone"},
20117: {"AegisName":"C_Raspberry_Mousse_Hat"},
20118: {"AegisName":"C_Hat_Of_Cake"},
20119: {"AegisName":"C_Fur_Hat"},
20120: {"AegisName":"C_Antenna"},
20121: {"AegisName":"C_Lotus_Flower_Hat"},
20122: {"AegisName":"Happy_Summer_Ribbon"},
20123: {"AegisName":"C_Eagle_Eyes"},
20124: {"AegisName":"C_Masquerade"},
20125: {"AegisName":"C_Mini_Glasses"},
20126: {"AegisName":"C_Thanatos_Mal_Mask"},
20127: {"AegisName":"C_Helm_Of_Abyss"},
20128: {"AegisName":"C_Remover_Hat"},
20129: {"AegisName":"C_Poporing_Cap"},
20130: {"AegisName":"C_Whisper_Tall_Hat"},
20131: {"AegisName":"C_C_Tower_Manager_Incom"},
20132: {"AegisName":"C_Subject_Aura"},
20133: {"AegisName":"C_Poring_Mascot_Costume"},
20134: {"AegisName":"C_Helm_Of_Abyss_White"},
20135: {"AegisName":"C12th_Crown"},
20136: {"AegisName":"C12th_ElvenEars"},
20137: {"AegisName":"C_Bomb_Wick"},
20138: {"AegisName":"C_Sea_Otter_Cap"},
20139: {"AegisName":"C_Horse_Hairpin1"},
20140: {"AegisName":"C_Horse_Hairpin2"},
20141: {"AegisName":"C_Observer"},
20142: {"AegisName":"C_Machoman_Glasses"},
20143: {"AegisName":"C_Candy_Cane_In_Mouth"},
20144: {"AegisName":"C_Ancient_Elven_Ear"},
20145: {"AegisName":"C_Robo_Eye"},
20146: {"AegisName":"C_Angel_Spirit"},
20147: {"AegisName":"C_Bell_Pigeon"},
20148: {"AegisName":"C_Noble_Hat"},
20149: {"AegisName":"C_Hexagon_Spectacles"},
20150: {"AegisName":"C_GodOfWinds_Fan"},
20151: {"AegisName":"C_Poison_Spore_Hat"},
20152: {"AegisName":"C_Straw_Rice_Bag"},
20153: {"AegisName":"C_Monochrome_Cap"},
20154: {"AegisName":"C_Maple_Which_Falls"},
20155: {"AegisName":"C_Ladys_Feather_Hat"},
20156: {"AegisName":"C_Fan_In_Mouth"},
20157: {"AegisName":"C_Fish_On_Head"},
20158: {"AegisName":"C_Circlet"},
20159: {"AegisName":"C_Blue_Hair_Band"},
20160: {"AegisName":"C_Fried_Egg"},
20161: {"AegisName":"C_Prontera_Army_Cap"},
20162: {"AegisName":"C_Lamb_Hat1"},
20163: {"AegisName":"C_Lamb_Hat2"},
20164: {"AegisName":"C_Duneyrr_Helm"},
20165: {"AegisName":"C_Tendrilion_Hat"},
20166: {"AegisName":"C_Hockey_Mask"},
20167: {"AegisName":"C_Devi_Headphone"},
20168: {"AegisName":"C_Skull_Jhood"},
20169: {"AegisName":"C_Long_Tongue"},
20170: {"AegisName":"C_Gray_Deviruchi_Cap"},
20171: {"AegisName":"C_Sepia_Cap"},
20172: {"AegisName":"C_Pumpkin_Head"},
20173: {"AegisName":"C_Lude_Hood"},
20174: {"AegisName":"C_Halloween_Hat_Orange"},
20175: {"AegisName":"C_Diabolic_Headphone"},
20176: {"AegisName":"Happy_Pierrot_Mask"},
20177: {"AegisName":"C_Drooping_Dorasuke"},
20178: {"AegisName":"C_Puppy_Love"},
20179: {"AegisName":"C_Monkey_On_Fur_Hat"},
20180: {"AegisName":"C_Westren_Grace"},
20181: {"AegisName":"C_Mistic_Rose"},
20182: {"AegisName":"C_Mottled_Egg_Shell"},
20183: {"AegisName":"C_There_Is_Something"},
20184: {"AegisName":"C_Party_Hat"},
20185: {"AegisName":"C_Fashion_Sunglass"},
20186: {"AegisName":"C_Magni_Cap"},
20187: {"AegisName":"C_Fricca_Circlet"},
20188: {"AegisName":"C_Morpheus_Hood"},
20189: {"AegisName":"C_Goibne_Helmet"},
20190: {"AegisName":"C_Chicken_Hat"},
20191: {"AegisName":"C_Black_Cat_Ears_Beret"},
20192: {"AegisName":"C_Green_Foxtail"},
20193: {"AegisName":"C_Foxtail"},
20194: {"AegisName":"C_Lion_Mask"},
20195: {"AegisName":"C_Scratching_Cat"},
20196: {"AegisName":"C_Leopard_Ear_Hat"},
20197: {"AegisName":"C_Amistr_Beret"},
20198: {"AegisName":"C_Misty_Ears"},
20199: {"AegisName":"C_Evil_Marcher_Hat"},
20200: {"AegisName":"C_Rabbit_Head_Dress"},
20201: {"AegisName":"C_Banshee_Master_Kiss"},
20202: {"AegisName":"C_Deviruchi_Balloon"},
20203: {"AegisName":"C_Bandana"},
20204: {"AegisName":"C_Hunting_Cap"},
20205: {"AegisName":"C_Fancy_Flower"},
20206: {"AegisName":"C_Cock_Hat1"},
20207: {"AegisName":"C_Stripe_Band"},
20208: {"AegisName":"C_Necktie"},
20209: {"AegisName":"C_Mermaid_Longing"},
20210: {"AegisName":"C_Cock_Hat2"},
20211: {"AegisName":"C_Cock_Hat3"},
20212: {"AegisName":"C_Loki_Nidhogg_Hat"},
20213: {"AegisName":"C_Sirt_Evil_Eye"},
20214: {"AegisName":"C_Evil_Marcher_Hat_J"},
20215: {"AegisName":"C_Black_Devil_Mask"},
20216: {"AegisName":"C_Rideword_Hat"},
20217: {"AegisName":"C_Arabian_Veil"},
20218: {"AegisName":"C_Spell_Circuit"},
20219: {"AegisName":"C_Angel_Marcher_Hat"},
20220: {"AegisName":"C_Dark_Night_Veil"},
20221: {"AegisName":"C_Eyes_Of_Ifrit"},
20222: {"AegisName":"C_Santa_Hat_2"},
20223: {"AegisName":"C_Centimental_Leaf"},
20224: {"AegisName":"C_Red_Tailed_Ribbon"},
20225: {"AegisName":"C_Pumpkin_Hat"},
20226: {"AegisName":"C_Hair_Brush"},
20227: {"AegisName":"C_Puppy_Hat2"},
20228: {"AegisName":"C_Pig_Moneybox2"},
20229: {"AegisName":"C_New_Year_Hairpin"},
20230: {"AegisName":"C_Mask_Of_Bankrupt"},
20231: {"AegisName":"C_Snowman_Hat"},
20232: {"AegisName":"C_Celines_Ribbon"},
20233: {"AegisName":"C_Gold_Angel_Sculpture"},
20234: {"AegisName":"C_Baphomet_Hat"},
20235: {"AegisName":"C_Frozen_Land_Rose"},
20236: {"AegisName":"C_Hellomother_Hat"},
20237: {"AegisName":"C_Pink_Fur_Hat"},
20238: {"AegisName":"C_Blue_Drooping_Kitty"},
20239: {"AegisName":"C_Large_Ribbon_Muffler"},
20240: {"AegisName":"C_Gift_Of_Snow"},
20241: {"AegisName":"C_Eclipse_Hat"},
20242: {"AegisName":"C_Snownow_Hat"},
20243: {"AegisName":"C_Choco_Mint_Bonnet"},
20244: {"AegisName":"C_Zherlthsh_Mask"},
20245: {"AegisName":"C_Cat_Foot_Hairpin"},
20246: {"AegisName":"C_Time_Accessory"},
20247: {"AegisName":"C_Blackhand_Of_Fate"},
20248: {"AegisName":"C_Black_Strong_Hair"},
20249: {"AegisName":"C_Red_Strong_Hair"},
20250: {"AegisName":"C_White_Strong_Hair"},
20251: {"AegisName":"C_Rose_Cascade"},
20252: {"AegisName":"C_Accessory_of_Ascetic"},
20253: {"AegisName":"C_Droopy_Alice_Doll"},
20254: {"AegisName":"C_Ribbon_Yellow"},
20255: {"AegisName":"C_Love_Cheek"},
20256: {"AegisName":"C_Honey_Pancakes"},
20257: {"AegisName":"C_Black_Rabbit_Bonnet"},
20258: {"AegisName":"C_Blue_Head_Dress"},
20259: {"AegisName":"C_Pink_Clover"},
20260: {"AegisName":"C_Star_Dust"},
20261: {"AegisName":"C_Cross_Band"},
20262: {"AegisName":"C_Fox_Ears_Bell_Ribbon"},
20263: {"AegisName":"C_Hat_Of_Drowsy_Cat"},
20264: {"AegisName":"C_Blood_Sucker"},
20265: {"AegisName":"C_Bird_Nest_Hat"},
20266: {"AegisName":"C_Secret_Zipper"},
20267: {"AegisName":"C_Penguin_Cap"},
20268: {"AegisName":"C_Sleep_Eclipse_Family"},
20269: {"AegisName":"C_White_Fox_Ear_Ribbon"},
20270: {"AegisName":"C_Gryphon_Wing_Ears"},
20271: {"AegisName":"C_Sunflower"},
20272: {"AegisName":"C_Snowy_Horn"},
20273: {"AegisName":"C_Soft_Sheep_Hat"},
20274: {"AegisName":"C_White_Choco_Bear"},
20275: {"AegisName":"C_Light_Bulb_Band"},
20276: {"AegisName":"C_Mushroom_Band"},
20277: {"AegisName":"C_Balloon_Hat"},
20278: {"AegisName":"C_Man_Medal"},
20279: {"AegisName":"C_Cheering_Whistle_J"},
20280: {"AegisName":"C_Pencil_In_Mouth"},
20281: {"AegisName":"C_Preschool_Hat"},
20282: {"AegisName":"C_White_Boys_Hat"},
20283: {"AegisName":"C_Over_Protector"},
20284: {"AegisName":"C_Cherry_Blossom_Hat"},
20285: {"AegisName":"C_Blossom_Fluttering"},
20286: {"AegisName":"C_Under_Rim_Glasses_Red"},
20287: {"AegisName":"C_Man_Medal_Gold"},
20288: {"AegisName":"C_BIJOUHAT"},
20289: {"AegisName":"C_Wing_Ear_Black"},
20290: {"AegisName":"C_Evil_Druid_Hat_Black"},
20291: {"AegisName":"C_Thoth_Mask"},
20292: {"AegisName":"C_Sara_Ramen_Hat"},
20293: {"AegisName":"C_Sleepr_Hat"},
20294: {"AegisName":"C_Savage_Baby_Hat_Jp"},
20295: {"AegisName":"C_Poring_Sunglasses_J"},
20296: {"AegisName":"C_Yoyo_Hat"},
20297: {"AegisName":"C_Cactus_Hat"},
20298: {"AegisName":"C_Happy_Lunatic_Ear"},
20299: {"AegisName":"C_Face_Crusher"},
20300: {"AegisName":"C_Hill_Wind_Mask"},
20301: {"AegisName":"C_Golden_Savage_Hat"},
20302: {"AegisName":"C_Beelzebub_Crown"},
20303: {"AegisName":"C_Mandragora_Cap"},
20304: {"AegisName":"C_Smokie_Hat"},
20305: {"AegisName":"C_NettyHeart_BalloonGum"},
20306: {"AegisName":"C_Artist_Hat"},
20307: {"AegisName":"C_BeginnerMark"},
20308: {"AegisName":"C_Koneko_Hat"},
20309: {"AegisName":"C_Dip_Schmitz"},
20310: {"AegisName":"C_Cute_Parrot"},
20311: {"AegisName":"C_Magical_Booster"},
20312: {"AegisName":"C_Baron_Evil_Eye"},
20313: {"AegisName":"C_CD_In_Mouth"},
20314: {"AegisName":"C_New_Wave_Sunglass"},
20315: {"AegisName":"C_Analyze_Eye"},
20316: {"AegisName":"C_Seraph_Wing_Helm"},
20317: {"AegisName":"C_CatEars_Cyber_HeadP"},
20318: {"AegisName":"C_Charleston_Antenna"},
20319: {"AegisName":"C_Crimson_Booster"},
20320: {"AegisName":"C_Red_Bandana"},
20321: {"AegisName":"C_37_Sculpt"},
20322: {"AegisName":"C_Otter_Hat"},
20323: {"AegisName":"C_Music_Decoration_J"},
20324: {"AegisName":"C_Pigeon_Hat"},
20325: {"AegisName":"C_Little_Aquarium"},
20326: {"AegisName":"C_Sailor_Collar"},
20327: {"AegisName":"C_Marine_Cap"},
20328: {"AegisName":"C_Golden_Fish"},
20329: {"AegisName":"C_Tare_HSchool_Doll_Hat"},
20330: {"AegisName":"C_Sombrero"},
20331: {"AegisName":"C_Desert_Prince"},
20332: {"AegisName":"C_Ribbon_Of_Lady"},
20333: {"AegisName":"C_Family_Hat"},
20334: {"AegisName":"C_Joystick_Hat"},
20335: {"AegisName":"C_Teardrop"},
20336: {"AegisName":"C_Sugared_Fruit_S"},
20337: {"AegisName":"C_Mahican"},
20338: {"AegisName":"C_Rainbow_L_Octopus"},
20339: {"AegisName":"C_Flower_Summer_Hat"},
20340: {"AegisName":"C_Straight_Pony_BL"},
20341: {"AegisName":"C_Cowlick_BL"},
20342: {"AegisName":"C_Loose_Wave_Twin_BL"},
20343: {"AegisName":"C_Melon_Helmet"},
20344: {"AegisName":"C_Happy_Balloon_J"},
20345: {"AegisName":"C_Guard_Of_Neptune_"},
20346: {"AegisName":"C_Drooping_Permeter"},
20347: {"AegisName":"C_Poring_Pirate"},
20348: {"AegisName":"C_Picnic_Hat"},
20349: {"AegisName":"C_FlyingGalapago"},
20350: {"AegisName":"C_Cowlick_YL"},
20351: {"AegisName":"C_Cowlick_GN"},
20352: {"AegisName":"C_Cowlick_PP"},
20353: {"AegisName":"C_Cowlick_RD"},
20354: {"AegisName":"C_Cowlick_OM"},
20355: {"AegisName":"C_Cowlick_BU"},
20356: {"AegisName":"C_Cowlick_WH"},
20357: {"AegisName":"C_Straight_Pony_YL"},
20358: {"AegisName":"C_Straight_Pony_GN"},
20359: {"AegisName":"C_Straight_Pony_PP"},
20360: {"AegisName":"C_Straight_Pony_RD"},
20361: {"AegisName":"C_Straight_Pony_OM"},
20362: {"AegisName":"C_Straight_Pony_BU"},
20363: {"AegisName":"C_Straight_Pony_WH"},
20364: {"AegisName":"C_Loose_Wave_Twin_YL"},
20365: {"AegisName":"C_Loose_Wave_Twin_GN"},
20366: {"AegisName":"C_Loose_Wave_Twin_PP"},
20367: {"AegisName":"C_Loose_Wave_Twin_RD"},
20368: {"AegisName":"C_Loose_Wave_Twin_OM"},
20369: {"AegisName":"C_Loose_Wave_Twin_BU"},
20370: {"AegisName":"C_Loose_Wave_Twin_WH"},
20371: {"AegisName":"C_Special_Kapra_Hat"},
20372: {"AegisName":"C_Hat_Of_Girl"},
20373: {"AegisName":"C_Watermelon_Hat"},
20374: {"AegisName":"C_Mechanical_Plant_Hat"},
20375: {"AegisName":"C_Ignis_Cap"},
20376: {"AegisName":"C_Memories_Of_Lovers"},
20377: {"AegisName":"C_Flying_Helmet"},
20378: {"AegisName":"C_Sky_Helm"},
20379: {"AegisName":"C_PocketWatch_Hair_Orna"},
20380: {"AegisName":"C_Mech_Feather_Hairband"},
20381: {"AegisName":"C_Steampunk_Hat"},
20382: {"AegisName":"C_Silversniper_Doll"},
20383: {"AegisName":"C_Magicdecoy_Doll"},
20384: {"AegisName":"C_PurpleCrystal_Tiara"},
20385: {"AegisName":"C_Orc_Hero_Helm"},
20386: {"AegisName":"C_Victory_Wing_Helm"},
20387: {"AegisName":"C_Crossed_Hair_Band"},
20388: {"AegisName":"C_Ayam"},
20389: {"AegisName":"C_Censor_Bar"},
20390: {"AegisName":"C_Goblini_Mask"},
20391: {"AegisName":"C_Silent_Executer"},
20392: {"AegisName":"C_Sniper_Goggle"},
20393: {"AegisName":"C_Schmidt_Helm"},
20394: {"AegisName":"C_Pumpkin_Cock_Hat"},
20395: {"AegisName":"C_Black_Witch_Hat"},
20396: {"AegisName":"C_Woodie_Hat"},
20397: {"AegisName":"C_Jakk"},
20398: {"AegisName":"C_Niflheim_Bunny_Hat"},
20399: {"AegisName":"C_Crow_Tengu_Mask"},
20400: {"AegisName":"C_Holy_Rosario"},
20401: {"AegisName":"C_Angel_Spirit_Guides"},
20402: {"AegisName":"C_Holy_Klobuk"},
20403: {"AegisName":"C_Dolor_Hat"},
20404: {"AegisName":"C_Blessing_Of_Angels"},
20405: {"AegisName":"C_Eremes_Scarf"},
20406: {"AegisName":"C_Commandments_Of_Chain"},
20407: {"AegisName":"C_Subject_Aura_Red"},
20408: {"AegisName":"C_Bldy_Light_Dark_Crown"},
20409: {"AegisName":"C_There_Is_Something_JP"},
20410: {"AegisName":"C_Bone_Head"},
20411: {"AegisName":"C_Claris_Doll_Hat"},
20412: {"AegisName":"C_Tayelin_Doll_Hat"},
20413: {"AegisName":"C_Isabella_Brown_Ear"},
20414: {"AegisName":"C_Crown_Of_Deceit"},
20415: {"AegisName":"C_RTC_Winner_Only"},
20416: {"AegisName":"C_1Grade_Balloon"},
20417: {"AegisName":"C_2Grade_Balloon"},
20418: {"AegisName":"C_3Grade_Balloon"},
20419: {"AegisName":"C_4Grade_Balloon"},
20420: {"AegisName":"C_5Grade_Balloon"},
20421: {"AegisName":"C_6Grade_Balloon"},
20422: {"AegisName":"C_7Grade_Balloon"},
20423: {"AegisName":"C_8Grade_Balloon"},
20424: {"AegisName":"C_9Grade_Balloon"},
20425: {"AegisName":"C_10Grade_Balloon"},
20426: {"AegisName":"C_11Grade_Balloon"},
20427: {"AegisName":"C_12Grade_Balloon"},
20428: {"AegisName":"C_13Grade_Balloon"},
20429: {"AegisName":"C_Piamette_BowTie"},
20430: {"AegisName":"C_Morocc_Kid_Servant"},
20431: {"AegisName":"C_Maggi_Head_Dress"},
20432: {"AegisName":"C_Khalitzburg_KN_Helm"},
20433: {"AegisName":"C_Louise_Red_Hat"},
20434: {"AegisName":"C_Droop_Gunslinger"},
20435: {"AegisName":"C_Camellia_Hair_Pin"},
20436: {"AegisName":"C_Angeling_KnitCap"},
20437: {"AegisName":"C_Sakura_Hairband"},
20438: {"AegisName":"C_Abacus_In_Mouth"},
20439: {"AegisName":"C_Glow_Of_New_Year"},
20440: {"AegisName":"C_Tone_Of_Gold"},
20441: {"AegisName":"C_L_RibbonMuff_Red"},
20442: {"AegisName":"C_RW_Mochiring_Hat"},
20443: {"AegisName":"C_Unicorn_Helm"},
20444: {"AegisName":"C_Aniv_Star_Hat"},
20445: {"AegisName":"C_Candle"},
20446: {"AegisName":"C_Rabbit_Ear_Eggshell"},
20447: {"AegisName":"C_Small_Poring_Band"},
20448: {"AegisName":"C_Cons_Of_Water"},
20449: {"AegisName":"C_White_Black_Temp"},
20450: {"AegisName":"C_Gram_Peony"},
20451: {"AegisName":"C_Sky_Of_Memory"},
20452: {"AegisName":"C_berry_Prince_Crown"},
20453: {"AegisName":"C_Hat_Of_Bundle"},
20454: {"AegisName":"C_Headgear_Of_Queen"},
20455: {"AegisName":"C_Republic_Hat"},
20456: {"AegisName":"C_Combat_Vestige"},
20457: {"AegisName":"C_Feather_Fluttering"},
20458: {"AegisName":"C_Wild_Poring_Rider"},
20459: {"AegisName":"C_Valhalla_Idol"},
20460: {"AegisName":"C_Thornbush_Hairband"},
20461: {"AegisName":"C_93_BloodyWing"},
20462: {"AegisName":"C_Cat_Ears_Cape"},
20463: {"AegisName":"C_Two_Tone_Beret"},
20464: {"AegisName":"C_Monochrome_RibbonHat"},
20465: {"AegisName":"C_Glasses_Without_Lens"},
20466: {"AegisName":"C_Crimson_Ribbon"},
20467: {"AegisName":"C_Elemental_Crown"},
20468: {"AegisName":"C_Youinone_Mask"},
20469: {"AegisName":"C_Bogy_Horn"},
20470: {"AegisName":"C_SweetChocolate_Hat"},
20471: {"AegisName":"C_Tulip_Hairpin"},
20472: {"AegisName":"C_Helm_Of_Angel"},
20473: {"AegisName":"C_Mine_Helm"},
20474: {"AegisName":"C_Banana_Hat"},
20475: {"AegisName":"C_Bridal_Ribbon"},
20476: {"AegisName":"C_Costume01_L"},
20477: {"AegisName":"C_Costume02_L"},
20478: {"AegisName":"C_Costume03_L"},
20479: {"AegisName":"C_Costume04_L"},
20480: {"AegisName":"C_Costume05_L"},
20481: {"AegisName":"C_Mask_of_Ifrit"},
20482: {"AegisName":"C_Heaven_Cage"},
20483: {"AegisName":"C_Butterfly_Barrettes"},
20484: {"AegisName":"C_Sunflower_Hairpin"},
20485: {"AegisName":"C_Maneater_Flower_Hp"},
20486: {"AegisName":"C_Twin_Margaret"},
20487: {"AegisName":"C_Floral_Waltz"},
20488: {"AegisName":"C_Pope_Ribbon"},
20489: {"AegisName":"C_Pope_Crown"},
20490: {"AegisName":"C_Full_Bloom_Hp_Blue"},
20491: {"AegisName":"C_Laser_Of_Eagle"},
20492: {"AegisName":"C_Whistle"},
20493: {"AegisName":"C_Wing_Headphone"},
20494: {"AegisName":"C_Ufo_Poring_Hat"},
20495: {"AegisName":"C_Quati_Hat_J"},
20496: {"AegisName":"C_Black_Shiba_Inu_Hat"},
20497: {"AegisName":"C_Umbala_Spirit"},
20498: {"AegisName":"C_Elephant_Hat"},
20499: {"AegisName":"C_Cat_Ear_Hat"},
20500: {"AegisName":"T_Archangel_Wing"},
20501: {"AegisName":"C_Mechanic_Wing"},
20502: {"AegisName":"C_Devil_Wing"},
20503: {"AegisName":"C_Bag_Of_Antonio"},
20504: {"AegisName":"C_Cupid_Wing_Pink"},
20505: {"AegisName":"C_Cupid_Wing_Skyblue"},
20506: {"AegisName":"C_Invisible_Manteau"},
20507: {"AegisName":"C_Poring_Bag"},
20508: {"AegisName":"C_Poster_Girl_Hat"},
20509: {"AegisName":"C_Wings_of_Uriel"},
20510: {"AegisName":"C_SwordWing"},
20511: {"AegisName":"C_Blue_Fairy_Wing"},
20512: {"AegisName":"C_Bravery_Bag"},
20513: {"AegisName":"C_EXE_Backpack"},
20514: {"AegisName":"C_Thanatos_Sword"},
20515: {"AegisName":"C_Magic_Circle"},
20516: {"AegisName":"C_Wings_of_Michael"},
20517: {"AegisName":"C_GiantCatBag_TW"},
20518: {"AegisName":"C_Gerhard_Von_Devi_Bag"},
20519: {"AegisName":"C_Full_BloomCherry_Tree"},
20520: {"AegisName":"C_Costume07_L"},
20521: {"AegisName":"C_BlackCatBag_TW"},
20522: {"AegisName":"C_Blessings_Of_Soul"},
20523: {"AegisName":"C_2018_RTC_Cape_TW"},
20524: {"AegisName":"C_Shining_Angel_Wing"},
20525: {"AegisName":"C_Bloody_Wing"},
20526: {"AegisName":"C_BlueAngeling_Wing"},
20527: {"AegisName":"C_PinkButterfly_Wing"},
20528: {"AegisName":"C_GoldButterfly_Wing"},
20529: {"AegisName":"C_2018_RTC_Cape_ROS"},
20530: {"AegisName":"C_Wings_of_Gabriel"},
20531: {"AegisName":"C_Invisible_Manteau_TW"},
20532: {"AegisName":"C_Exploding_Wave_Sca_V"},
20533: {"AegisName":"C_PinkButterfly_Wing_T"},
20534: {"AegisName":"C_GiantCatBag_JP"},
20535: {"AegisName":"C_Digital_Space"},
20536: {"AegisName":"C_Violet_Halo"},
20537: {"AegisName":"C_Maple_Which_Falls_Rd"},
20538: {"AegisName":"C_Magic_Circle_Rainbow"},
20539: {"AegisName":"C_CherryFesRibbon_TW"},
20540: {"AegisName":"C_SnackParty_TW"},
20541: {"AegisName":"C_AngelRibbonWing_TW"},
20542: {"AegisName":"C_BlackBearBackpack_TW"},
20543: {"AegisName":"C_Halloween_Poring_Bag"},
20544: {"AegisName":"C_Gold_Shower_J"},
20545: {"AegisName":"C_Chrismas_Tree"},
20546: {"AegisName":"C_Backside_Ribbon_Bell"},
20547: {"AegisName":"C_Ghost_Effect"},
20548: {"AegisName":"C_Popping_Poring_Aura"},
20549: {"AegisName":"C_99LV_Royal_Guard_Blue"},
20550: {"AegisName":"C_99LV_Warlock_Violet"},
20551: {"AegisName":"C_99LV_Sorcerer_LBlue"},
20552: {"AegisName":"C_99LV_Ranger_Green"},
20553: {"AegisName":"C_99LV_Minstrel_Pink"},
20554: {"AegisName":"C_99LV_Archbishop_White"},
20555: {"AegisName":"C_99LV_Guill_Silver"},
20556: {"AegisName":"C_99LV_ShadowC_Black"},
20557: {"AegisName":"C_99LV_Mechanic_Gold"},
20558: {"AegisName":"C_99LV_Genetic_YGreen"},
20559: {"AegisName":"C_160LV_Rune_Red"},
20560: {"AegisName":"C_160LV_Royal_G_Blue"},
20561: {"AegisName":"C_160LV_Warlock_Violet"},
20562: {"AegisName":"C_160LV_Sorcerer_LBlue"},
20563: {"AegisName":"C_160LV_Ranger_Green"},
20564: {"AegisName":"C_160LV_Minstrel_Pink"},
20565: {"AegisName":"C_160LV_Archb_White"},
20566: {"AegisName":"C_160LV_Guill_Silver"},
20567: {"AegisName":"C_160LV_ShadowC_Black"},
20568: {"AegisName":"C_160LV_Mechanic_Gold"},
20569: {"AegisName":"C_160LV_Genetic_YGreen"},
20570: {"AegisName":"C_HeartChocoBag"},
20571: {"AegisName":"C_Valkyrie_Wing"},
20572: {"AegisName":"C_WingOfHeart"},
20573: {"AegisName":"C_VioletHalo"},
20574: {"AegisName":"C_School_Bag_RD"},
20575: {"AegisName":"C_School_Bag_BL"},
20576: {"AegisName":"C_Cat_Fork"},
20577: {"AegisName":"C_Balloon_Wing"},
20578: {"AegisName":"C_Wings_Of_Raguel"},
20579: {"AegisName":"C_Wings_Of_Raphael"},
20580: {"AegisName":"C_Heart_Wing_Backpack"},
20581: {"AegisName":"C_Soldier_Backpack"},
20582: {"AegisName":"C_T_Bear_Bag"},
20583: {"AegisName":"C_Magic_Star_TW"},
20584: {"AegisName":"C_Big_Foxtail"},
20585: {"AegisName":"C_Ru_Bear_Bag"},
20586: {"AegisName":"C_Loli_Ruri_Moon"},
20587: {"AegisName":"C_Light_Darkness_Wing"},
20588: {"AegisName":"C_Nifl_Bloom"},
20589: {"AegisName":"C_Gimmick_One_Feather"},
20590: {"AegisName":"C_Evil_Druid_Cross"},
20591: {"AegisName":"C_Bow_On_the_Back"},
20592: {"AegisName":"C_Santa_Backpack"},
20593: {"AegisName":"C_Ice_Wing"},
20594: {"AegisName":"C_Big_Ribbon_Cloak"},
20595: {"AegisName":"C_School_Bag_RD_E"},
20596: {"AegisName":"C_BlackBear_Back_TW"},
20597: {"AegisName":"C_Evil_Scythe"},
20598: {"AegisName":"C_GiantCatBag_JP_BL"},
20599: {"AegisName":"C_Sakura_Wing"},
20600: {"AegisName":"Fantastic_Aura"},
20601: {"AegisName":"C_99LV_Rune_Red"},
20602: {"AegisName":"C_Seraphim_Wing_TW"},
20603: {"AegisName":"C_P_Ulysses_Feather"},
20604: {"AegisName":"C_Blessed_Veil"},
20605: {"AegisName":"C_Leaf_Umbrella"},
20606: {"AegisName":"C_Golden_Angel_Wing"},
20607: {"AegisName":"C_Baldr_Wing_TW"},
20608: {"AegisName":"C_99LV_Star_E_MBlue"},
20609: {"AegisName":"C_160LV_Star_E_MBlue"},
20610: {"AegisName":"C_99LV_Soul_R_Gray"},
20611: {"AegisName":"C_160LV_Soul_R_Gray"},
20612: {"AegisName":"C_Ten_G_Shield_TW"},
20613: {"AegisName":"C_Wing_Of_Spider"},
20614: {"AegisName":"C_Kyel_hyre_Ulti_TW"},
20615: {"AegisName":"C_School_Bag_BU"},
20616: {"AegisName":"C_School_Bag_PU"},
20617: {"AegisName":"C_Wing_Of_Eutaxy"},
20618: {"AegisName":"C_Big_B_Rabbit"},
20619: {"AegisName":"C_Phaya_Ploeng_Suriyan"},
20620: {"AegisName":"C_Songkran_Watergun"},
20621: {"AegisName":"C_Dark_Lord_Manteau"},
20622: {"AegisName":"C_2023RTC_S_Robe1"},
20623: {"AegisName":"C_2023RTC_S_Robe2"},
20624: {"AegisName":"C_2023RTC_S_Robe3"},
20625: {"AegisName":"C_ROS2023_Cape_1"},
20626: {"AegisName":"C_ROS2023_Cape_2"},
20627: {"AegisName":"C_Pitaya_R_Bag"},
20628: {"AegisName":"C_Pitaya_B_Bag"},
20629: {"AegisName":"C_Pitaya_Y_Bag"},
20700: {"AegisName":"Egir_Manteau"},
20701: {"AegisName":"Sol_Manteau"},
20702: {"AegisName":"TE_Woe_Muffler"},
20703: {"AegisName":"TE_Woe_Manteau"},
20704: {"AegisName":"TE_Woe_Magic_Manteau"},
20705: {"AegisName":"Lumiere_Manteau"},
20706: {"AegisName":"Amistr_Bag"},
20707: {"AegisName":"Kirin_Wing"},
20708: {"AegisName":"Poison_Manteau"},
20709: {"AegisName":"Mana_Manteau"},
20710: {"AegisName":"Impr_Angel's_Warmth"},
20711: {"AegisName":"Manteau_Of_Diego"},
20712: {"AegisName":"Valkyrie_Cape"},
20713: {"AegisName":"Manteau_Of_Torrent"},
20714: {"AegisName":"Assassin_Muffler"},
20715: {"AegisName":"Earthquake_Manteau"},
20716: {"AegisName":"Esprit_Manteau"},
20717: {"AegisName":"FaceWorm_Skin"},
20718: {"AegisName":"FaceWorm_Skin_"},
20719: {"AegisName":"BF_Hood"},
20720: {"AegisName":"Manteau_Of_Storm"},
20721: {"AegisName":"Cloak_Of_Gray"},
20722: {"AegisName":"Soul_Of_Tree"},
20723: {"AegisName":"Manteau_Of_Hunter"},
20724: {"AegisName":"Love_Dad_Wings_2012"},
20725: {"AegisName":"Ribbon_Piamat"},
20726: {"AegisName":"Fire_Dragon_Coat"},
20727: {"AegisName":"Brilliant_Golden_Wings"},
20728: {"AegisName":"Water_Dragon_Coat"},
20729: {"AegisName":"Wind_Dragon_Coat"},
20730: {"AegisName":"Loyalists_Hood"},
20731: {"AegisName":"Ground_Dragon_Coat"},
20732: {"AegisName":"Supplement_Part_Con"},
20733: {"AegisName":"Upgrade_Part_Engine"},
20734: {"AegisName":"Manteau_Of_Leafwind"},
20735: {"AegisName":"Manteau_Of_Flame_Heart"},
20737: {"AegisName":"C_Kirin_Wing"},
20743: {"AegisName":"Airship_Cape"},
20744: {"AegisName":"Felock_Cape"},
20745: {"AegisName":"Manteau_Of_Mistic_Froz"},
20746: {"AegisName":"C_Rudra_Wing"},
20747: {"AegisName":"Manteau_Great_Nature"},
20748: {"AegisName":"Manteau_Of_Fallen"},
20749: {"AegisName":"Manteau_Of_Fallen_"},
20750: {"AegisName":"Rouban_Manteau"},
20753: {"AegisName":"Lian_Robe"},
20756: {"AegisName":"Egir_Manteau_K"},
20761: {"AegisName":"C_Wing_Of_Happiness"},
20762: {"AegisName":"C_GreatDevilWing"},
20763: {"AegisName":"C_Amistr_Bag"},
20764: {"AegisName":"C_Fallen_Angel_Wing"},
20765: {"AegisName":"C_Archangel_Wing"},
20766: {"AegisName":"Beam_Of_Light_Manteau"},
20767: {"AegisName":"Bravery_Bag_J"},
20768: {"AegisName":"Archangel_Wing_J"},
20769: {"AegisName":"Small_Hut_Manteau"},
20770: {"AegisName":"Limnil_Cape"},
20771: {"AegisName":"Choas_Manteau"},
20772: {"AegisName":"Grudge_Manteau"},
20773: {"AegisName":"Excelion_Wing"},
20774: {"AegisName":"Cutoff_Manteau"},
20776: {"AegisName":"Supplement_Part_Con_J"},
20777: {"AegisName":"Upgrade_Part_Engine_J"},
20778: {"AegisName":"RedLotus_Stole"},
20779: {"AegisName":"ManteauOfCracks"},
20780: {"AegisName":"Union_MHP_Manteau"},
20781: {"AegisName":"Union_FLEE_Manteau"},
20782: {"AegisName":"Union_SP_Muffler"},
20783: {"AegisName":"Hero_Cape"},
20784: {"AegisName":"Amistr_Bag_J"},
20787: {"AegisName":"Union_CRI_Muffler"},
20788: {"AegisName":"Doram_Only_Cape"},
20789: {"AegisName":"Doram_High_Cape"},
20790: {"AegisName":"Doram_Ele_Cape"},
20796: {"AegisName":"Soheon_Winged_Robe"},
20797: {"AegisName":"Etran_Shirt"},
20798: {"AegisName":"GrimReaper_Protection"},
20799: {"AegisName":"Elemental_Towel"},
20800: {"AegisName":"Enforcer_cape"},
20801: {"AegisName":"Toughen_Time_Keepr_MT"},
20802: {"AegisName":"AmistrBag_Teleport"},
20803: {"AegisName":"AmistrBag_Heal"},
20804: {"AegisName":"AmistrBag_Greed"},
20805: {"AegisName":"AmistrBag_Incagi"},
20806: {"AegisName":"AmistrBag_Magnum"},
20807: {"AegisName":"AmistrBag_Endure"},
20808: {"AegisName":"AmistrBag_Sight"},
20809: {"AegisName":"AmistrBag_Concentrate"},
20811: {"AegisName":"AmistrBag_Hiding"},
20812: {"AegisName":"Kirin_Wing_J"},
20813: {"AegisName":"Clack_Of_Servival_"},
20814: {"AegisName":"Wakwak_Manteau"},
20815: {"AegisName":"SeraphimRobe"},
20816: {"AegisName":"Yoichi_Muffler"},
20817: {"AegisName":"Diffusion_Bravery_Bag"},
20818: {"AegisName":"Cursed_Devils_Manteau"},
20819: {"AegisName":"Oxygen_Bomb_K"},
20820: {"AegisName":"Cloak_Of_Elemental"},
20821: {"AegisName":"Golden_Scarf"},
20822: {"AegisName":"Mine_Worker_Backpack"},
20823: {"AegisName":"Para_Team_Manteau100"},
20824: {"AegisName":"Para_Team_Manteau130"},
20825: {"AegisName":"Para_Team_Manteau160"},
20826: {"AegisName":"Angel_feather"},
20827: {"AegisName":"Diva_Manteau"},
20828: {"AegisName":"Mirage_Manteau"},
20830: {"AegisName":"Seraphim_Wing_J2"},
20831: {"AegisName":"Elder_Spirit"},
20833: {"AegisName":"Fallen_Angel_Wing_TH"},
20834: {"AegisName":"Manteau_Of_Vagabond"},
20835: {"AegisName":"K_Fallen_Angel_Wing"},
20836: {"AegisName":"Skin_Of_Lindwurm"},
20837: {"AegisName":"Skin_Of_Gwiber"},
20838: {"AegisName":"Muffler_IL"},
20840: {"AegisName":"Cape_Of_Ancient_Lord_IL"},
20841: {"AegisName":"Golden_Angel_Wing_TH"},
20842: {"AegisName":"Bag_Of_Antonio_Melee"},
20843: {"AegisName":"Bag_Of_Antonio_Range"},
20844: {"AegisName":"Bag_Of_Antonio_Magic"},
20845: {"AegisName":"Skin_Of_Marraco"},
20846: {"AegisName":"Temporal_Manteau"},
20847: {"AegisName":"Clack_Of_Servival_IL"},
20852: {"AegisName":"Jirant_Cloak"},
20853: {"AegisName":"Rudo_Black_Wings"},
20854: {"AegisName":"Medical_Cape"},
20855: {"AegisName":"Rental_Oxygen_Bomb"},
20856: {"AegisName":"YSF01_Manteau"},
20857: {"AegisName":"VeilCoyote"},
20858: {"AegisName":"YSF01_Manteau_J"},
20859: {"AegisName":"Phreeoni_Wing"},
20860: {"AegisName":"BattleSurcoat"},
20861: {"AegisName":"SwordWing_J"},
20862: {"AegisName":"EXE_Backpack"},
20863: {"AegisName":"MenblattWing"},
20864: {"AegisName":"Siege_Manteau_1Tier"},
20865: {"AegisName":"Siege_Muffler_1Tier"},
20866: {"AegisName":"Golden_Angel_Wing_TW"},
20867: {"AegisName":"60Lv_Hood"},
20868: {"AegisName":"70Lv_Manteau"},
20869: {"AegisName":"70Lv_Muffler"},
20870: {"AegisName":"80Lv_Manteau"},
20871: {"AegisName":"80Lv_Cloak"},
20872: {"AegisName":"80Lv_Muffler"},
20873: {"AegisName":"80Lv_Cape"},
20874: {"AegisName":"90Lv_Manteau"},
20875: {"AegisName":"90Lv_Cloak"},
20876: {"AegisName":"90Lv_Muffler"},
20877: {"AegisName":"90Lv_Cape"},
20900: {"AegisName":"Golden_Scarf_J"},
20902: {"AegisName":"True_Hunting_Manteau"},
20903: {"AegisName":"R_Hunting_Manteau"},
20904: {"AegisName":"Etran_Shirt_BR"},
20905: {"AegisName":"Astrea_Cape"},
20906: {"AegisName":"Rebeginer_Manteau"},
20907: {"AegisName":"Fairy_Cloth"},
20908: {"AegisName":"Jirant_Cloak_BR"},
20909: {"AegisName":"BattleSurcoat_BR"},
20910: {"AegisName":"Etran_Shirt_TW"},
20915: {"AegisName":"Doram_Only_Cape_J"},
20916: {"AegisName":"Doram_High_Cape_J"},
20917: {"AegisName":"Doram_Ele_Cape_J"},
20918: {"AegisName":"Angel_Poring_Wing"},
20922: {"AegisName":"Leviathan_muffler"},
20923: {"AegisName":"Goibne_Shoulder_IL"},
20924: {"AegisName":"Brave_muffler"},
20925: {"AegisName":"Commander_manteau_J"},
20926: {"AegisName":"2018_RTC_Cape4_TW"},
20927: {"AegisName":"2018_RTC_Cape1_TW"},
20928: {"AegisName":"2018_RTC_Cape2_TW"},
20929: {"AegisName":"2018_RTC_Cape3_TW"},
20931: {"AegisName":"Rainbow_Scarf_Jp"},
20932: {"AegisName":"Old_Moc_Shawl"},
20933: {"AegisName":"Illusion_Engine_A"},
20934: {"AegisName":"Illusion_Engine_B"},
20935: {"AegisName":"Lava_Leather_Manteau"},
20936: {"AegisName":"Lava_Leather_Muffler"},
20937: {"AegisName":"Lava_Leather_Hode"},
20938: {"AegisName":"Rudra_Wing"},
20939: {"AegisName":"Time_Overload_Hood"},
20940: {"AegisName":"Violet_Halo"},
20941: {"AegisName":"Phoenix_Muffler"},
20942: {"AegisName":"Manteau_Of_Guardsman"},
20943: {"AegisName":"Geffen_Magic_Muffler"},
20944: {"AegisName":"Anti_Magic_Manteau"},
20945: {"AegisName":"Regia_Hunting_Manteau"},
20946: {"AegisName":"Drag_Manteau"},
20947: {"AegisName":"Cassock_Manteau"},
20948: {"AegisName":"Morpheus_Shawl_IL"},
20949: {"AegisName":"Skin_Of_Ladon_J"},
20951: {"AegisName":"Leo_Mantle_J"},
20952: {"AegisName":"Anony_As_Muffler"},
20953: {"AegisName":"H_AD_Hood"},
20954: {"AegisName":"Cancer_Manteau_J"},
20955: {"AegisName":"Chrismas_Tree"},
20962: {"AegisName":"Skin_Of_Typhon"},
20963: {"AegisName":"Temporal_M_Str"},
20964: {"AegisName":"Temporal_M_Agi"},
20965: {"AegisName":"Temporal_M_Vit"},
20966: {"AegisName":"Temporal_M_Int"},
20967: {"AegisName":"Temporal_M_Dex"},
20968: {"AegisName":"Temporal_M_Luk"},
20969: {"AegisName":"Rainbow_Muffler_Jp"},
20970: {"AegisName":"Libra_Manteau_J"},
20971: {"AegisName":"Taurus_Manteau_J"},
20972: {"AegisName":"Aquarius_Manteau_J"},
20973: {"AegisName":"Spiritual_Cloth"},
20976: {"AegisName":"Scorpio_Manteau_J"},
20983: {"AegisName":"Pollux_Mantle_J"},
20984: {"AegisName":"Procyon_Mantle_J"},
20985: {"AegisName":"C_Gourd_bottle_J"},
20986: {"AegisName":"Scientist_Mantle"},
20987: {"AegisName":"C_Heart_Wing_Bag_J"},
20988: {"AegisName":"C_Mechanical_Butterfly"},
20989: {"AegisName":"C_Mainspring_Screw"},
20990: {"AegisName":"C_Rotating_Gears"},
20991: {"AegisName":"Fairy_Of_Eden"},
20992: {"AegisName":"C_Fairy_Of_Eden"},
20993: {"AegisName":"Avoidance_Cape"},
20994: {"AegisName":"Ancient_Megalith_Mantle"},
21000: {"AegisName":"Upg_Twohand_Sword"},
21001: {"AegisName":"Velum_Claymore"},
21002: {"AegisName":"Velum_Katzbalger"},
21003: {"AegisName":"Muramasa_"},
21004: {"AegisName":"Alca_Bringer_"},
21005: {"AegisName":"Metal_Two_Hand_Sword"},
21006: {"AegisName":"TE_Woe_Two_Hand_Sword"},
21007: {"AegisName":"Heavy_Sword"},
21008: {"AegisName":"Kogarasu_Maru"},
21009: {"AegisName":"Thanos_Great_Sword"},
21010: {"AegisName":"Tw_Sword_Of_Evil_Slayer"},
21011: {"AegisName":"Giant_Blade"},
21012: {"AegisName":"Some_Wizard_MagicSword"},
21013: {"AegisName":"Hetairoi_Sword"},
21014: {"AegisName":"D_Sword_Of_Infinite"},
21015: {"AegisName":"Scarlet_Twohand_Sword"},
21016: {"AegisName":"Sinister_Twohand_Sword"},
21018: {"AegisName":"Two_Hand_Spear_170"},
21019: {"AegisName":"Onimaru"},
21023: {"AegisName":"Toughen_Metal_TH_Sword"},
21024: {"AegisName":"Veteran_Sword_"},
21026: {"AegisName":"Diva_Claymore"},
21027: {"AegisName":"Mirage_Claymore"},
21028: {"AegisName":"Sinister_Thand_Sword_J"},
21030: {"AegisName":"Probation_TH_Sword"},
21031: {"AegisName":"Neev_Claymore"},
21037: {"AegisName":"Rebeginer_RK_T_Sword"},
21038: {"AegisName":"Oriental_Sword"},
21039: {"AegisName":"T_Sword_Of_Kingdom"},
21041: {"AegisName":"Local01_T_Sword"},
21042: {"AegisName":"Onimaru_BR"},
21043: {"AegisName":"Local02_T_Sword"},
21044: {"AegisName":"Woe_Twohand_Sword1_Z"},
21046: {"AegisName":"Variant_Claymore"},
21047: {"AegisName":"Beam_Claymore_OS"},
21049: {"AegisName":"Evt_Oriental_Sword"},
21050: {"AegisName":"Taegoolyeon_IL"},
21051: {"AegisName":"Volar"},
21052: {"AegisName":"Vernan"},
21053: {"AegisName":"FullForce"},
21054: {"AegisName":"Ein_BHSWORD"},
21055: {"AegisName":"G_Knight_Sword"},
21056: {"AegisName":"Volar_J"},
21057: {"AegisName":"Vernan_J"},
21058: {"AegisName":"Up_Dragonic_Slayer"},
21063: {"AegisName":"Solid_Claymore"},
21064: {"AegisName":"aegis_21064"},
21065: {"AegisName":"Comp_Oriental_Sword"},
21066: {"AegisName":"Comp_Dragonic_Slayer"},
21200: {"AegisName":"C_Tear_Drop"},
21201: {"AegisName":"Eat_Coin"},
21202: {"AegisName":"C_Eat_Coin"},
21205: {"AegisName":"Nut_Cracker"},
21206: {"AegisName":"C_Nut_Cracker"},
21207: {"AegisName":"C_bullhead"},
21300: {"AegisName":"C_Guardian_Lion_Mask"},
21400: {"AegisName":"aegis_21400"},
22000: {"AegisName":"Temporal_Str_Boots"},
22001: {"AegisName":"Temporal_Int_Boots"},
22002: {"AegisName":"Temporal_Agi_Boots"},
22003: {"AegisName":"Temporal_Vit_Boots"},
22004: {"AegisName":"Temporal_Dex_Boots"},
22005: {"AegisName":"Temporal_Luk_Boots"},
22006: {"AegisName":"Temporal_Str_Boots_"},
22007: {"AegisName":"Temporal_Vit_Boots_"},
22008: {"AegisName":"Temporal_Dex_Boots_"},
22009: {"AegisName":"Temporal_Int_Boots_"},
22010: {"AegisName":"Temporal_Agi_Boots_"},
22011: {"AegisName":"Temporal_Luk_Boots_"},
22012: {"AegisName":"Mana_Boots"},
22013: {"AegisName":"test_5"},
22014: {"AegisName":"Enhanced_Variant_Shoes"},
22015: {"AegisName":"Impr_Angel's_Arrival"},
22016: {"AegisName":"Assassin_Shoes"},
22017: {"AegisName":"Fisherman_Shoes"},
22018: {"AegisName":"Shoes_Of_Wise_Man"},
22019: {"AegisName":"Immuned_Boots"},
22020: {"AegisName":"GC_Battle_Boots"},
22021: {"AegisName":"RA_Battle_Boots"},
22022: {"AegisName":"LG_Battle_Boots"},
22023: {"AegisName":"RK_Battle_Boots"},
22024: {"AegisName":"NC_Battle_Boots"},
22025: {"AegisName":"SC_Battle_Boots"},
22026: {"AegisName":"SR_Battle_Boots"},
22027: {"AegisName":"AB_Battle_Boots"},
22028: {"AegisName":"WL_Battle_Boots"},
22029: {"AegisName":"WA_Battle_Boots"},
22030: {"AegisName":"GN_Battle_Boots"},
22031: {"AegisName":"Aurelian_Shoes"},
22032: {"AegisName":"Shoes_Of_Exorcism"},
22033: {"AegisName":"Boots_Of_Gray"},
22034: {"AegisName":"Scarlet_Gaites"},
22035: {"AegisName":"Vet_Nepen_Heel"},
22036: {"AegisName":"Vet_SliverFox_Boots"},
22037: {"AegisName":"Vet_Ungo_Boots"},
22038: {"AegisName":"Shoes_Of_Hope"},
22042: {"AegisName":"Talaria_Shoes"},
22043: {"AegisName":"Supplement_Part_Agi"},
22044: {"AegisName":"Upgrade_Part_Booster"},
22045: {"AegisName":"Beach_Sandals"},
22046: {"AegisName":"Airship_Boots"},
22047: {"AegisName":"Felock_Boots"},
22048: {"AegisName":"Sombre_Shoes"},
22049: {"AegisName":"Sol_Shoes"},
22050: {"AegisName":"Gardener_Shoes"},
22051: {"AegisName":"Ramor_Shoes"},
22052: {"AegisName":"Gravekeepr_Shoes"},
22055: {"AegisName":"Sharel_Shoes"},
22056: {"AegisName":"Fallen_Angel_Shoes"},
22057: {"AegisName":"Flow_Shoes"},
22058: {"AegisName":"DragonTrainer_Shoes"},
22059: {"AegisName":"Egir_Shoes_K"},
22060: {"AegisName":"Boots_Of_Hunter"},
22061: {"AegisName":"Lumiere_Shoes"},
22062: {"AegisName":"Mechanic_Shoes"},
22063: {"AegisName":"Rouban_Shoes"},
22064: {"AegisName":"Thorny_Shoes"},
22065: {"AegisName":"Poison_Shoes"},
22066: {"AegisName":"Esprit_Shoes"},
22067: {"AegisName":"Witch_Shoes"},
22068: {"AegisName":"Santa's_Shoes"},
22069: {"AegisName":"Lian_Shoes"},
22070: {"AegisName":"Applause_Sandal"},
22071: {"AegisName":"Applause_Sandal_"},
22072: {"AegisName":"Hikingboots"},
22073: {"AegisName":"Supplement_Part_Agi_J"},
22074: {"AegisName":"Upgrade_Part_Booster_J"},
22075: {"AegisName":"Shoes_Of_Cracks"},
22076: {"AegisName":"Hardwood_Slipper"},
22077: {"AegisName":"Red_Eco_Boots"},
22078: {"AegisName":"Union_STR_Boots"},
22079: {"AegisName":"Union_AGI_Boots"},
22080: {"AegisName":"Union_DEX_Shoes"},
22081: {"AegisName":"Union_INT_Shoes"},
22082: {"AegisName":"Polyhedron_Shoes"},
22083: {"AegisName":"Doram_Only_Shoes"},
22084: {"AegisName":"Doram_High_Shoes"},
22085: {"AegisName":"Doram_Ele_Shoes"},
22089: {"AegisName":"Scarlet_Gaites_"},
22091: {"AegisName":"Fisherman_Shoes_"},
22092: {"AegisName":"Aurelian_Shoes_"},
22093: {"AegisName":"Shoes_Of_Exorcism_"},
22094: {"AegisName":"Gardener_Shoes_"},
22095: {"AegisName":"Gravekeepr_Shoes_"},
22096: {"AegisName":"Fallen_Angel_Shoes_"},
22097: {"AegisName":"DragonTrainer_Shoes_"},
22098: {"AegisName":"Boots_Of_Hunter_"},
22099: {"AegisName":"Mechanic_Shoes_"},
22100: {"AegisName":"Medical_Boots_"},
22101: {"AegisName":"AngelPoring_Boots"},
22102: {"AegisName":"Toughen_Time_Keepr_Bts"},
22103: {"AegisName":"Excelion_Leg"},
22104: {"AegisName":"Pororoca_Shoes"},
22105: {"AegisName":"Cuffs_"},
22106: {"AegisName":"Giant_Boots"},
22107: {"AegisName":"Modify_Str_Boots"},
22108: {"AegisName":"Modify_Int_Boots"},
22109: {"AegisName":"Modify_Agi_Boots"},
22110: {"AegisName":"Modify_Vit_Boots"},
22111: {"AegisName":"Modify_Dex_Boots"},
22112: {"AegisName":"Modify_Luk_Boots"},
22113: {"AegisName":"Modify_Str_Boots_"},
22114: {"AegisName":"Modify_Int_Boots_"},
22115: {"AegisName":"Modify_Agi_Boots_"},
22116: {"AegisName":"Modify_Vit_Boots_"},
22117: {"AegisName":"Modify_Dex_Boots_"},
22118: {"AegisName":"Modify_Luk_Boots_"},
22119: {"AegisName":"Cursed_Devils_Boots"},
22120: {"AegisName":"Shoes_Of_Punishment"},
22122: {"AegisName":"Para_Team_Boots100"},
22123: {"AegisName":"Para_Team_Boots115"},
22124: {"AegisName":"Para_Team_Boots130"},
22125: {"AegisName":"Para_Team_Boots145"},
22126: {"AegisName":"Para_Team_Boots160"},
22127: {"AegisName":"Diva_Shoes"},
22128: {"AegisName":"Mirage_Shoes"},
22129: {"AegisName":"ShoesOfHero"},
22131: {"AegisName":"Cowboy_Boots"},
22132: {"AegisName":"Nergal_Shoes"},
22133: {"AegisName":"Shoes_IL"},
22134: {"AegisName":"Enforcer_Shoes"},
22138: {"AegisName":"Demonist_Shoes"},
22139: {"AegisName":"2017RTCShoes"},
22140: {"AegisName":"Elvira_Boots"},
22141: {"AegisName":"YSF01_Greave"},
22142: {"AegisName":"ShoesOfGuardsman"},
22143: {"AegisName":"YSF01_Greave_J"},
22144: {"AegisName":"IA_Boots"},
22145: {"AegisName":"TenguShoes"},
22146: {"AegisName":"Siege_Shoes_1Tier"},
22147: {"AegisName":"Siege_Boots_1Tier"},
22148: {"AegisName":"Siege_Greave_1Tier"},
22149: {"AegisName":"Thorny_Shoes_BR"},
22150: {"AegisName":"60Lv_Sandal"},
22151: {"AegisName":"70Lv_Boots"},
22152: {"AegisName":"70Lv_Shoes"},
22153: {"AegisName":"80Lv_Greave"},
22154: {"AegisName":"80Lv_Boots"},
22155: {"AegisName":"80Lv_Shoes"},
22156: {"AegisName":"80Lv_Sandal"},
22157: {"AegisName":"90Lv_Greave"},
22158: {"AegisName":"90Lv_Boots"},
22159: {"AegisName":"90Lv_Shoes"},
22160: {"AegisName":"90Lv_Sandal"},
22167: {"AegisName":"Astraea_Shoes"},
22168: {"AegisName":"True_Hunting_Boots"},
22169: {"AegisName":"R_Hunting_Boots"},
22170: {"AegisName":"Shoes_Of_Servival"},
22171: {"AegisName":"Ancient_Hero_Boots"},
22172: {"AegisName":"Gray_Wing_Boots"},
22173: {"AegisName":"Rebeginer_Boots"},
22174: {"AegisName":"Scaraba_High_Heels"},
22178: {"AegisName":"Anony_Sm_Shoes"},
22182: {"AegisName":"Shoes_Of_Punishment_BR"},
22185: {"AegisName":"Doram_Only_Shoes_J"},
22186: {"AegisName":"Doram_High_Shoes_J"},
22187: {"AegisName":"Doram_Ele_Shoes_J"},
22189: {"AegisName":"Shoes_Of_Pilgrim"},
22190: {"AegisName":"Boots_IL"},
22191: {"AegisName":"Nergal_Shoes_TW"},
22192: {"AegisName":"Goibne_Boots_IL"},
22193: {"AegisName":"Brave_shoes"},
22194: {"AegisName":"Loli_Ruri_Shoes"},
22195: {"AegisName":"Booster_shoes"},
22196: {"AegisName":"Illusion_Leg_A"},
22197: {"AegisName":"Illusion_Leg_B"},
22198: {"AegisName":"Traveler_Shoes"},
22199: {"AegisName":"Lava_Leather_Boots"},
22200: {"AegisName":"Lava_Leather_Shoes"},
22201: {"AegisName":"Lava_Leather_Sandle"},
22202: {"AegisName":"Temporal_Boots_TW"},
22203: {"AegisName":"Space_shoes_JP"},
22204: {"AegisName":"Time_Overload_Boots"},
22206: {"AegisName":"Regia_Hunting_Boots"},
22207: {"AegisName":"Imperial_Boots"},
22208: {"AegisName":"Dragon_Boots"},
22209: {"AegisName":"Cassock_Boots"},
22210: {"AegisName":"Fluffy_FishShoes_J"},
22211: {"AegisName":"BuddhistShoes"},
22212: {"AegisName":"Hollow_Shoes"},
22213: {"AegisName":"Leo_Shoes_J"},
22214: {"AegisName":"Authority_Sandals"},
22215: {"AegisName":"H_AD_Sandle"},
22216: {"AegisName":"Cancer_Shoes_J"},
22221: {"AegisName":"Demonist_Shoes_"},
22222: {"AegisName":"Agenda_Shoes_TW"},
22225: {"AegisName":"Shoes_Of_Punishment_"},
22227: {"AegisName":"Libra_Shoes_J"},
22228: {"AegisName":"Triad_God_Shoes_J_"},
22230: {"AegisName":"Taurus_Shoes_J"},
22231: {"AegisName":"Aquarius_Shoes_J"},
22233: {"AegisName":"Scorpio_Shoes_J"},
22234: {"AegisName":"FrontiaBoots"},
22238: {"AegisName":"Great_Hero_Boots"},
22240: {"AegisName":"Fierce_Physique_Boots"},
22241: {"AegisName":"Fierce_Magique_Boots"},
22242: {"AegisName":"Procyon_Shoes_J"},
22243: {"AegisName":"Mamaragan"},
22244: {"AegisName":"Chic_Silent_Shoes"},
22245: {"AegisName":"Space_shoes_JP_"},
22249: {"AegisName":"Insidious_Shoes_EXE"},
22257: {"AegisName":"aegis_22257"},
22258: {"AegisName":"Comp_Temporal_Boots_TW"},
22259: {"AegisName":"aegis_22259"},
22507: {"AegisName":"ShabbyOldScroll"},
22508: {"AegisName":"Para_Team_Mark_"},
22510: {"AegisName":"WolfKing_Scroll"},
22511: {"AegisName":"Fenrir_Card__"},
22513: {"AegisName":"Kings_Gift"},
22514: {"AegisName":"Candy_Holder"},
22515: {"AegisName":"Key_Of_Twisted_Time"},
22516: {"AegisName":"Dark_Red_Clot"},
22517: {"AegisName":"Loki_Summon_Scroll"},
22518: {"AegisName":"Idn_Wisdom_Egg"},
22519: {"AegisName":"Pc_Stop"},
22520: {"AegisName":"Pc_Stop_Cancel"},
22521: {"AegisName":"80LVUP"},
22522: {"AegisName":"100LVUP"},
22523: {"AegisName":"120LVUP"},
22524: {"AegisName":"130LVUP"},
22525: {"AegisName":"140LVUP"},
22526: {"AegisName":"150LVUP"},
22527: {"AegisName":"160LVUP"},
22528: {"AegisName":"Pet_Ticket_Box"},
22529: {"AegisName":"Shadow_Mix_Recipe"},
22530: {"AegisName":"Christmas_Box"},
22531: {"AegisName":"Special_Christmas_Box"},
22532: {"AegisName":"Santa_Gift"},
22533: {"AegisName":"New_Year_Gift_Box"},
22534: {"AegisName":"Closedmind_Box"},
22535: {"AegisName":"WorkerScroll_A"},
22536: {"AegisName":"WorkerScroll_B"},
22537: {"AegisName":"PrizeOfHero"},
22538: {"AegisName":"Hanbok_bag"},
22539: {"AegisName":"Made_Dish_Box2"},
22540: {"AegisName":"Runstone_Lux"},
22541: {"AegisName":"PCBang_Coupon_Box6"},
22542: {"AegisName":"Center_Potion_B"},
22543: {"AegisName":"Berserk_Potion_B"},
22544: {"AegisName":"Awakening_Potion_B"},
22545: {"AegisName":"Speed_Up_Potion_B"},
22546: {"AegisName":"Slow_Down_Potion_B"},
22547: {"AegisName":"Anodyne_B"},
22548: {"AegisName":"Water_Of_Darkness_B"},
22549: {"AegisName":"Poison_Bottle_B"},
22550: {"AegisName":"Cookie_Bag_B"},
22551: {"AegisName":"Sesame_Pastry_B"},
22552: {"AegisName":"Honey_Pastry_B"},
22553: {"AegisName":"Rainbow_Cake_B"},
22554: {"AegisName":"First_Aid_Kit_B"},
22555: {"AegisName":"HQ_Chocolate"},
22556: {"AegisName":"LuxuryChocolate"},
22557: {"AegisName":"ArtisanChocolate"},
22558: {"AegisName":"Lucky_Bag"},
22559: {"AegisName":"Mock_Strawberry"},
22563: {"AegisName":"Lucky_Bag_Of_New_Era"},
22566: {"AegisName":"Frost_Crystal"},
22567: {"AegisName":"Squad_Prize"},
22568: {"AegisName":"Nyd_Summon_Scroll"},
22569: {"AegisName":"Kings_Gift2"},
22571: {"AegisName":"Easter_Egg"},
22589: {"AegisName":"Savage_Ora"},
22590: {"AegisName":"Grand_Peco_Ora"},
22591: {"AegisName":"Dest_Wolf_Ora"},
22592: {"AegisName":"Happy_Call_Box"},
22605: {"AegisName":"Gingerbread2"},
22610: {"AegisName":"Beginning_Box"},
22611: {"AegisName":"Packing_Envelope"},
22612: {"AegisName":"Decomposition_Potion"},
22613: {"AegisName":"Polluted_Potion"},
22614: {"AegisName":"Premium_Manual"},
22617: {"AegisName":"ClearBox_S"},
22618: {"AegisName":"ClearBox_A"},
22619: {"AegisName":"Ghost_Summon_Scroll"},
22620: {"AegisName":"Memorial_Box"},
22621: {"AegisName":"Squid_Bbq"},
22623: {"AegisName":"Beginning_Box2"},
22624: {"AegisName":"Riesen_Bretzel"},
22625: {"AegisName":"Oktoberfest_Bag"},
22626: {"AegisName":"JanuaryGiftBox_"},
22627: {"AegisName":"FebruaryGiftBox_"},
22628: {"AegisName":"Green_Package"},
22629: {"AegisName":"Green_Package40"},
22630: {"AegisName":"Green_Package80"},
22631: {"AegisName":"Green_Package99"},
22640: {"AegisName":"17173_Green_Package"},
22641: {"AegisName":"17173_Green_Package40"},
22642: {"AegisName":"17173_Green_Package80"},
22643: {"AegisName":"17173_Green_Package99"},
22644: {"AegisName":"S_Green_Package"},
22645: {"AegisName":"S_Green_Package40"},
22646: {"AegisName":"S_Green_Package80"},
22647: {"AegisName":"S_Green_Package99"},
22648: {"AegisName":"Angeling_Package"},
22649: {"AegisName":"Deviling_Package"},
22652: {"AegisName":"Brilliant_Hat_Box"},
22653: {"AegisName":"Wet_CardAlbum"},
22654: {"AegisName":"Golden_Card"},
22657: {"AegisName":"Honey_Rice_Cake_"},
22658: {"AegisName":"BraisedShortRibs"},
22659: {"AegisName":"BraisedSpareribs"},
22660: {"AegisName":"Sealed_Letter"},
22668: {"AegisName":"Guyak_Pudding_20_Box"},
22669: {"AegisName":"HALLOWEEN_G_BOX"},
22670: {"AegisName":"DARK_INVITATION"},
22671: {"AegisName":"MarchGiftBox_"},
22672: {"AegisName":"AprilGiftBox_"},
22673: {"AegisName":"MayGiftBox_"},
22674: {"AegisName":"JuneGiftBox_"},
22675: {"AegisName":"Mystery_Scroll"},
22676: {"AegisName":"HangulDay_Box"},
22679: {"AegisName":"Chest_Of_Death"},
22685: {"AegisName":"Solo_Christmas_Gift"},
22686: {"AegisName":"Solo_Cookie"},
22687: {"AegisName":"Pieces_Of_Sentiment"},
22691: {"AegisName":"Piece_Of_Record1"},
22692: {"AegisName":"Piece_Of_Record2"},
22693: {"AegisName":"Piece_Of_Record3"},
22694: {"AegisName":"Piece_Of_Record4"},
22695: {"AegisName":"Piece_Of_Record5"},
22699: {"AegisName":"Test_Reagent"},
22700: {"AegisName":"Jumping_Kit_Box"},
22701: {"AegisName":"Pegasus_Cotton_Candy"},
22702: {"AegisName":"Minus_Str"},
22703: {"AegisName":"Minus_Agi"},
22704: {"AegisName":"Minus_Vit"},
22705: {"AegisName":"Minus_Int"},
22706: {"AegisName":"Minus_Dex"},
22707: {"AegisName":"Minus_Luk"},
22708: {"AegisName":"Pitapat_Box"},
22717: {"AegisName":"Ball_Wanderer"},
22718: {"AegisName":"Ball_Rude"},
22719: {"AegisName":"Ball_Tatacho"},
22720: {"AegisName":"Ball_Novus"},
22721: {"AegisName":"Question_Box"},
22734: {"AegisName":"QuizRevol_Box"},
22735: {"AegisName":"Sealed_M_Flower_Scroll"},
22736: {"AegisName":"JulyGiftBox_"},
22737: {"AegisName":"Bullet_Case_Blood_"},
22738: {"AegisName":"Bullet_Case_Silver_"},
22739: {"AegisName":"Sphere_Case_Wind_"},
22740: {"AegisName":"Sphere_Case_Darkness_"},
22741: {"AegisName":"Sphere_Case_Poison_"},
22742: {"AegisName":"Sphere_Case_Water_"},
22743: {"AegisName":"Sphere_Case_Fire_"},
22744: {"AegisName":"Bullet_Case_AP"},
22745: {"AegisName":"Bullet_Case_Blaze"},
22746: {"AegisName":"Bullet_Case_Fleeze"},
22747: {"AegisName":"Bullet_Case_Electric"},
22748: {"AegisName":"Bullet_Case_Stone"},
22749: {"AegisName":"Sanctified_Bullet_Case"},
22750: {"AegisName":"Trans_Scroll_Sca"},
22751: {"AegisName":"Trans_Scroll_Wander"},
22752: {"AegisName":"Trans_Scroll_Gazeti"},
22753: {"AegisName":"Trans_Scroll_Karcher"},
22754: {"AegisName":"Trans_Scroll_Necro"},
22755: {"AegisName":"Trans_Scroll_Wghost"},
22756: {"AegisName":"AugustGiftBox_"},
22757: {"AegisName":"Matk_Trans_Scroll"},
22758: {"AegisName":"Ratk_Trans_Scroll"},
22759: {"AegisName":"Aspd_Trans_Scroll"},
22760: {"AegisName":"Argiope_CaptureBox"},
22761: {"AegisName":"LuciolaVespa_CaptureBox"},
22762: {"AegisName":"Centipede_CaptureBox"},
22764: {"AegisName":"PetTradeTicket_Box"},
22770: {"AegisName":"Shark_Skewered"},
22771: {"AegisName":"Tuna_Skewered"},
22772: {"AegisName":"Snapper_Skwered"},
22773: {"AegisName":"Piranha_Skewered"},
22774: {"AegisName":"Salmon_Skewered"},
22775: {"AegisName":"Eel_Skewered"},
22776: {"AegisName":"Carp_Skewered"},
22777: {"AegisName":"BuffGiftBox"},
22781: {"AegisName":"PC_NomalBox"},
22782: {"AegisName":"PC_WoodenBox"},
22783: {"AegisName":"PC_GoldenBox"},
22784: {"AegisName":"PC_PlatinumBox"},
22802: {"AegisName":"Guarantee6_Box"},
22808: {"AegisName":"NoviceBox"},
22812: {"AegisName":"Sealed_Dracula_Scroll"},
22813: {"AegisName":"Bearers_Shadow_Box"},
22814: {"AegisName":"CatPaw_Ticket"},
22816: {"AegisName":"G_Mysterious_Water"},
22817: {"AegisName":"G_Small_Life_Potion"},
22818: {"AegisName":"G_Med_Life_Potion"},
22819: {"AegisName":"G_Almighty"},
22820: {"AegisName":"G_ASPD_Potion"},
22821: {"AegisName":"G_Red_Booster"},
22822: {"AegisName":"SW_Wear2014"},
22823: {"AegisName":"Sealed_B_Shecil_Scroll"},
22825: {"AegisName":"Costume_Set1_Kr"},
22826: {"AegisName":"Enchant_Stone_Box4"},
22827: {"AegisName":"Shadow_Cube"},
22828: {"AegisName":"Sealed_Scroll"},
22829: {"AegisName":"Sealed_Card"},
22837: {"AegisName":"Essence_Of_Time"},
22838: {"AegisName":"Something_Candy_Holder"},
22839: {"AegisName":"Happy_Box_J"},
22841: {"AegisName":"Pumpkin_Candy"},
22842: {"AegisName":"Sealed_Dracula_Scroll2"},
22843: {"AegisName":"superstar_cake"},
22844: {"AegisName":"Sealed_Dracula_Album"},
22845: {"AegisName":"Sealed_Mysterious_Egg"},
22846: {"AegisName":"Sealed_Dracula_Card_"},
22847: {"AegisName":"BadgeOfProntera"},
22848: {"AegisName":"KeysPrison"},
22849: {"AegisName":"P_Temporal_Crystal"},
22850: {"AegisName":"JanuaryGiftBox"},
22851: {"AegisName":"FebruaryGiftBox"},
22852: {"AegisName":"MarchGiftBox"},
22853: {"AegisName":"AprilGiftBox"},
22854: {"AegisName":"MayGiftBox"},
22855: {"AegisName":"JuneGiftBox"},
22856: {"AegisName":"JulyGiftBox"},
22857: {"AegisName":"AugustGiftBox"},
22858: {"AegisName":"SeptemberGiftBox"},
22859: {"AegisName":"OctoberGiftBox"},
22860: {"AegisName":"NovemberGiftBox"},
22861: {"AegisName":"DecemberGiftBox"},
22868: {"AegisName":"Enchant_Stone_Box5"},
22869: {"AegisName":"LuckyRouletteTickets"},
22870: {"AegisName":"Xmas_Package_14"},
22873: {"AegisName":"Sealed_Berz_Scroll2"},
22874: {"AegisName":"Sealed_Berz_Album"},
22875: {"AegisName":"Sealed_Berz_Card_"},
22876: {"AegisName":"Shabby_Purse"},
22881: {"AegisName":"Binding_Rope"},
22882: {"AegisName":"Choco_Tteokguk"},
22883: {"AegisName":"SeptemberGiftBox_"},
22884: {"AegisName":"OctoberGiftBox_"},
22885: {"AegisName":"NovemberGiftBox_"},
22886: {"AegisName":"DecemberGiftBox_"},
22887: {"AegisName":"2015GoldPCBox"},
22888: {"AegisName":"2015_New_Year_Scroll"},
22893: {"AegisName":"New_Year_Shadow_Cube"},
22894: {"AegisName":"2015LI_Neuralizer"},
22895: {"AegisName":"2015LI_R_S_C"},
22896: {"AegisName":"2015LI_R_S_C_"},
22899: {"AegisName":"DowntownMap"},
22901: {"AegisName":"BlueboxOfQuestions"},
22902: {"AegisName":"Sealed_Scroll2"},
22905: {"AegisName":"Enchant_Stone_Box6"},
22906: {"AegisName":"Sealed_Scroll3"},
22907: {"AegisName":"Service30_M_01_Call"},
22908: {"AegisName":"Service30_F_01_Call"},
22909: {"AegisName":"Weapon_5Up_Box"},
22910: {"AegisName":"Weapon_6Up_Box"},
22911: {"AegisName":"Weapon_7Up_Box"},
22912: {"AegisName":"Weapon_8Up_Box"},
22913: {"AegisName":"Weapon_9Up_Box"},
22914: {"AegisName":"Bubble_Gum_24h"},
22915: {"AegisName":"Weapon_11Up_Box"},
22916: {"AegisName":"Weapon_12Up_Box"},
22917: {"AegisName":"Weapon_13Up_Box"},
22918: {"AegisName":"Weapon_14Up_Box"},
22919: {"AegisName":"Weapon_15Up_Box"},
22920: {"AegisName":"Weapon_16Up_Box"},
22921: {"AegisName":"Weapon_17Up_Box"},
22922: {"AegisName":"Weapon_18Up_Box"},
22923: {"AegisName":"Weapon_19Up_Box"},
22924: {"AegisName":"Armor_5Up_Box"},
22925: {"AegisName":"Armor_6Up_Box"},
22926: {"AegisName":"Armor_7Up_Box"},
22927: {"AegisName":"Armor_8Up_Box"},
22928: {"AegisName":"Armor_9Up_Box"},
22929: {"AegisName":"Job_Manual25_24h"},
22930: {"AegisName":"Armor_11Up_Box"},
22931: {"AegisName":"Armor_12Up_Box"},
22932: {"AegisName":"Armor_13Up_Box"},
22933: {"AegisName":"Armor_14Up_Box"},
22934: {"AegisName":"Armor_15Up_Box"},
22935: {"AegisName":"Armor_16Up_Box"},
22936: {"AegisName":"Armor_17Up_Box"},
22937: {"AegisName":"Armor_18Up_Box"},
22938: {"AegisName":"Armor_19Up_Box"},
22943: {"AegisName":"Armor_10Up_Box"},
22944: {"AegisName":"Weapon_10Up_Box"},
22945: {"AegisName":"Cherry_Blossom_Cake"},
22946: {"AegisName":"Status_Decrease_Scroll"},
22947: {"AegisName":"Minus_Str_Box"},
22948: {"AegisName":"Minus_Agi_Box"},
22949: {"AegisName":"Minus_Vit_Box"},
22950: {"AegisName":"Minus_Int_Box"},
22951: {"AegisName":"Minus_Dex_Box"},
22952: {"AegisName":"Minus_Luk_Box"},
22953: {"AegisName":"Enchant_Stone_Box7"},
22971: {"AegisName":"Mad_Bunny_Scroll"},
22972: {"AegisName":"Sealed_Hat_Box"},
22973: {"AegisName":"Shadow_Cube_Weapon"},
22974: {"AegisName":"Shadow_Cube_Armor"},
22975: {"AegisName":"Shadow_Cube_Shield"},
22976: {"AegisName":"Shadow_Cube_Shoes"},
22977: {"AegisName":"Shadow_Cube_Pendant"},
22978: {"AegisName":"Shadow_Cube_Earing"},
22979: {"AegisName":"Comp_Battle_Bubble"},
22980: {"AegisName":"InfinityD_ReturnScroll"},
22982: {"AegisName":"Service30P_M_01_Call"},
22983: {"AegisName":"Service30P_F_01_Call"},
22984: {"AegisName":"Dr_Life_Potion_01"},
22985: {"AegisName":"Dr_Life_Potion_02"},
22988: {"AegisName":"Sealed_Hat_Box2"},
22989: {"AegisName":"Improved_NomalBox"},
22991: {"AegisName":"Soccer_Cake"},
22996: {"AegisName":"Comp_Neuralizer"},
22997: {"AegisName":"C_Greed_Scroll"},
22998: {"AegisName":"C_CatPaw_Ticket"},
22999: {"AegisName":"Comp_Trans_Scroll"},
23001: {"AegisName":"Enchant_Stone_Box8"},
23007: {"AegisName":"Improved_WoodenBox"},
23008: {"AegisName":"AID_Bubble_Gum_24h"},
23010: {"AegisName":"AID_Manual_24h"},
23011: {"AegisName":"AID_Insurance_24h"},
23012: {"AegisName":"Comp_Small_Mana_Potion"},
23013: {"AegisName":"Improved_GoldenBox"},
23014: {"AegisName":"Improved_PlatinumBox"},
23015: {"AegisName":"Red_Slim_Pot_Box"},
23016: {"AegisName":"Pieces_Of_Grudge"},
23021: {"AegisName":"13thCelebrateBox"},
23022: {"AegisName":"CrossEventBox"},
23023: {"AegisName":"C_Giant_Fly_Wing"},
23024: {"AegisName":"Piamette_Scroll"},
23025: {"AegisName":"Pope_Merc_Scroll"},
23026: {"AegisName":"CasualPope_Merc_Scroll"},
23027: {"AegisName":"Dandelion_Ring"},
23028: {"AegisName":"Capture_Rope"},
23029: {"AegisName":"Cowlick_Box"},
23030: {"AegisName":"Straight_Pony_Box"},
23031: {"AegisName":"Loose_Wave_Twin_Box"},
23032: {"AegisName":"Minus_Status_Box"},
23033: {"AegisName":"Invisible_Box"},
23034: {"AegisName":"Invisible_Scroll"},
23036: {"AegisName":"Pope_Merc_Scroll2"},
23037: {"AegisName":"CasualPope_Merc_Scroll2"},
23038: {"AegisName":"White_Slim_Potion_Box_"},
23039: {"AegisName":"Mastela_Fruit_Box_"},
23040: {"AegisName":"White_Potion_Box_"},
23041: {"AegisName":"Royal_Jelly_Box2_"},
23042: {"AegisName":"Seed_Of_Yggdrasil_"},
23043: {"AegisName":"Yggdrasil_Seed_Box_"},
23044: {"AegisName":"Elvira_Candy"},
23045: {"AegisName":"Mont_Blanc_Cake"},
23046: {"AegisName":"Comp_Mystic_Powder"},
23047: {"AegisName":"Comp_Tyr's_Blessing"},
23048: {"AegisName":"Comp_Regenerate_Potion"},
23049: {"AegisName":"Comp_Spark_Candy"},
23050: {"AegisName":"Comp_Magic_Candy"},
23051: {"AegisName":"New_Hat_Scroll"},
23052: {"AegisName":"New_Hat_Box"},
23058: {"AegisName":"Enchant_Stone_Box9"},
23059: {"AegisName":"Face_Paint_Box"},
23060: {"AegisName":"Surface_Paint_Box"},
23061: {"AegisName":"Incisive_Arrow_Cntr"},
23062: {"AegisName":"CokingOpenBox"},
23063: {"AegisName":"Freeze_Dream"},
23069: {"AegisName":"2015_Special_Scroll"},
23070: {"AegisName":"2015_Special_Box"},
23072: {"AegisName":"2015_Angel_Scroll"},
23073: {"AegisName":"AngelPoring_Box"},
23074: {"AegisName":"DecemberGiftBox_2016"},
23075: {"AegisName":"NovemberGiftBox_2016"},
23076: {"AegisName":"Build_Up_Potion_SS"},
23077: {"AegisName":"Build_Up_Potion_SC"},
23078: {"AegisName":"Build_Up_Potion_AC"},
23079: {"AegisName":"Strawberry_CreamCake"},
23080: {"AegisName":"Crystal_Of_Grudge"},
23081: {"AegisName":"Kunai_Scroll_Of_Flame"},
23082: {"AegisName":"Kunai_Scroll_Of_Icicle"},
23083: {"AegisName":"Kunai_Scroll_Of_Wind"},
23084: {"AegisName":"Kunai_Scroll_Of_Soil"},
23085: {"AegisName":"Kunai_Scroll_Of_Poison"},
23086: {"AegisName":"Enchant_Stone_Box10"},
23087: {"AegisName":"Small_Leather_Bag"},
23094: {"AegisName":"Comp_Glass_Of_Illusion"},
23095: {"AegisName":"Poring_Scroll"},
23096: {"AegisName":"MOBI_Support_Box"},
23097: {"AegisName":"Time_Guardian_Box2"},
23098: {"AegisName":"Assorted_ShdowBox"},
23100: {"AegisName":"Gunslinger_Enchant"},
23106: {"AegisName":"Amistr_Scroll"},
23107: {"AegisName":"Amistr_Box"},
23115: {"AegisName":"Class_Shadow_Cube"},
23116: {"AegisName":"Shadow_Scroll"},
23119: {"AegisName":"Spirit_Scroll"},
23120: {"AegisName":"Sealed_Hat_Box3"},
23123: {"AegisName":"Bullet_Case_Flare"},
23124: {"AegisName":"Bullet_Case_Lighting"},
23125: {"AegisName":"Bullet_Case_Ice"},
23126: {"AegisName":"Bullet_Case_Poison"},
23127: {"AegisName":"Bullet_Case_Blind"},
23128: {"AegisName":"Cachua_Weapon"},
23129: {"AegisName":"Cachua_Robe"},
23130: {"AegisName":"Cachua_Mail"},
23131: {"AegisName":"Cachua_Shoes"},
23132: {"AegisName":"Cachua_Shield"},
23133: {"AegisName":"Cachua_Helm"},
23134: {"AegisName":"Balloon_Scroll"},
23135: {"AegisName":"Poring_Balloon_Box"},
23136: {"AegisName":"WOB_Box"},
23137: {"AegisName":"Ribel_Jumping_Box"},
23142: {"AegisName":"EXPUP_Potion1"},
23143: {"AegisName":"JEXPUP_Potion1"},
23144: {"AegisName":"EXPUP_Potion1Box"},
23145: {"AegisName":"JEXPUP_Potion1Box"},
23148: {"AegisName":"Premium_Box_2d"},
23149: {"AegisName":"Premium_Box_3d"},
23150: {"AegisName":"Lapine_DdukddakBox"},
23151: {"AegisName":"EnchantStone_Recipe"},
23152: {"AegisName":"EventItem_Recipe"},
23153: {"AegisName":"PetEgg_Recipe"},
23154: {"AegisName":"Nyang_Costume_Recipe"},
23159: {"AegisName":"Poison_Pack2"},
23160: {"AegisName":"Shadow_Cube_Sak"},
23161: {"AegisName":"Gunslinger_Box"},
23162: {"AegisName":"Gunslinger_Scroll"},
23165: {"AegisName":"Service30_AID_Buff"},
23167: {"AegisName":"Green_Scroll_K"},
23168: {"AegisName":"Mini_Fan_Box"},
23169: {"AegisName":"Alchemist_Box"},
23170: {"AegisName":"Fan_Upgrade_Kit"},
23171: {"AegisName":"Sealed_Gloom_Card_"},
23172: {"AegisName":"Sealed_Pharaoh_Card_"},
23173: {"AegisName":"Sealed_Kiel_Card_"},
23174: {"AegisName":"Enchant_Stone_Box11"},
23175: {"AegisName":"Suit_Upgrade_Kit"},
23176: {"AegisName":"Kafra_Scroll"},
23177: {"AegisName":"Comp_Kafra_Card"},
23178: {"AegisName":"Kafra_Box"},
23187: {"AegisName":"Sap_Jelly"},
23188: {"AegisName":"Airship_Part"},
23189: {"AegisName":"Little_Dall_Needle"},
23191: {"AegisName":"Varetyr_5_Scroll"},
23192: {"AegisName":"DiamondDust5_Scroll"},
23193: {"AegisName":"CrimsonRock_5_Scroll"},
23194: {"AegisName":"Sienna_5_Scroll"},
23195: {"AegisName":"Sigrun_Scroll"},
23196: {"AegisName":"Agust_Lucky_Scroll"},
23198: {"AegisName":"PremiumWoodenBox"},
23199: {"AegisName":"PremiumGoldenBox"},
23200: {"AegisName":"PremiumPlatinumBox"},
23201: {"AegisName":"PremiumNomalBox"},
23202: {"AegisName":"Vin_Chaud"},
23203: {"AegisName":"Small_Mana_Potion"},
23204: {"AegisName":"M_DEFScroll"},
23205: {"AegisName":"New_Hat_Scroll2"},
23206: {"AegisName":"New_Hat_Box2"},
23207: {"AegisName":"Premium_Box"},
23209: {"AegisName":"Premium_Box_1d"},
23210: {"AegisName":"Premium_Box_4d"},
23211: {"AegisName":"Premium_Box_5d"},
23212: {"AegisName":"Premium_Box_6d"},
23213: {"AegisName":"Premium_Box_5d7"},
23214: {"AegisName":"Premium_Box_8d"},
23215: {"AegisName":"Premium_Box_9d"},
23216: {"AegisName":"Premium_Box_10d"},
23217: {"AegisName":"2016_Special_Scroll"},
23218: {"AegisName":"2016_Special_Box"},
23221: {"AegisName":"EF_DEX_Biscuit_Stick"},
23222: {"AegisName":"EF_LUK_Biscuit_Stick"},
23223: {"AegisName":"EF_STR_Biscuit_Stick"},
23224: {"AegisName":"EF_VIT_Biscuit_Stick"},
23225: {"AegisName":"EF_AGI_Biscuit_Stick"},
23226: {"AegisName":"EF_INT_Biscuit_Stick"},
23227: {"AegisName":"Biscuit_Stick_2Set"},
23228: {"AegisName":"HazyMooncake"},
23229: {"AegisName":"FallenAngelWing_Reset"},
23234: {"AegisName":"Racing_Exchange"},
23235: {"AegisName":"Candlelight_Scroll"},
23236: {"AegisName":"JobShadow_Mix_Weapon"},
23237: {"AegisName":"JobShadow_Mix_Armor"},
23238: {"AegisName":"JobShadow_Mix_Shoes"},
23239: {"AegisName":"JobShadow_Mix_Shield"},
23240: {"AegisName":"JobShadow_Mix_Pendant"},
23241: {"AegisName":"JobShadow_Mix_Earing"},
23242: {"AegisName":"Fried_Chicken"},
23243: {"AegisName":"Fried_Chicken_1"},
23245: {"AegisName":"Lapine_Scroll"},
23246: {"AegisName":"LI_Lapine_DdukddakBox"},
23247: {"AegisName":"StatusShadow_Mix"},
23248: {"AegisName":"GemstoneShadow_Mix"},
23249: {"AegisName":"BearersShadow_Mix"},
23250: {"AegisName":"ComposeShadow_Mix"},
23251: {"AegisName":"Rose_Bundle_A"},
23252: {"AegisName":"Orleans_Bundle_A"},
23253: {"AegisName":"Black_Shiba_Bundle_A"},
23254: {"AegisName":"Valkyrie_Bundle_A"},
23255: {"AegisName":"Kardui_Bundle_A"},
23256: {"AegisName":"Elixir_Bandage"},
23257: {"AegisName":"Dew_Of_Old_Tree"},
23258: {"AegisName":"Foul_Rotten_Meat"},
23259: {"AegisName":"St_Cupcake"},
23260: {"AegisName":"Parfait"},
23261: {"AegisName":"Macaron"},
23262: {"AegisName":"Hair_Bun_Box"},
23263: {"AegisName":"Roll_Twin_Box"},
23264: {"AegisName":"Long_Pony_Box"},
23265: {"AegisName":"Sprint_Bundle_A"},
23266: {"AegisName":"Etran_Bundle_A"},
23267: {"AegisName":"1LVUP"},
23268: {"AegisName":"10LVUP"},
23269: {"AegisName":"20LVUP"},
23270: {"AegisName":"30LVUP"},
23271: {"AegisName":"40LVUP"},
23272: {"AegisName":"50LVUP"},
23273: {"AegisName":"60LVUP"},
23274: {"AegisName":"70LVUP"},
23275: {"AegisName":"90LVUP"},
23276: {"AegisName":"175LVUP"},
23277: {"AegisName":"Mado_Box"},
23278: {"AegisName":"HelpmeShorty"},
23280: {"AegisName":"N_Fly_Wing2"},
23281: {"AegisName":"RaceShadow_Mix"},
23282: {"AegisName":"Biscuit_Stick_2Set_"},
23283: {"AegisName":"Love_Scroll"},
23284: {"AegisName":"Advanced_Taiming_Item"},
23285: {"AegisName":"Candy_Box_Melee"},
23286: {"AegisName":"Candy_Box_Range"},
23287: {"AegisName":"Candy_Box_Magic"},
23288: {"AegisName":"Cps_Fly_Wing"},
23289: {"AegisName":"Candy_Bag_Scroll_Melee"},
23290: {"AegisName":"Candy_Bag_Scroll_Range"},
23291: {"AegisName":"Candy_Bag_Scroll_Magic"},
23294: {"AegisName":"Pororoca_Shoes_Bundle_A"},
23295: {"AegisName":"Lian_Bundle_B"},
23296: {"AegisName":"D_Buger"},
23297: {"AegisName":"Lovely_Egg_Box"},
23299: {"AegisName":"Enchant_Stone_Box12"},
23302: {"AegisName":"PoringsPreciousBox"},
23303: {"AegisName":"C_CatPaw_1Day_Para"},
23304: {"AegisName":"C_Wing_Of_Fly_1Day_Para"},
23305: {"AegisName":"Cat_Scroll"},
23307: {"AegisName":"Comp_M_DEFScroll"},
23308: {"AegisName":"Booster_Amplifier"},
23309: {"AegisName":"Magical_Booster_Box"},
23310: {"AegisName":"Cat_Head_Dress_Basket"},
23311: {"AegisName":"Magical_Cat_Hand"},
23312: {"AegisName":"Chemicals_Bag"},
23317: {"AegisName":"Comp_Cherryblossom_C"},
23318: {"AegisName":"Shadow_Scroll2"},
23320: {"AegisName":"Melon_Juice"},
23321: {"AegisName":"Sweet_Melon_Juice"},
23322: {"AegisName":"Melon_Parfait"},
23323: {"AegisName":"C_Wing_Of_Fly_3Day_Box_"},
23324: {"AegisName":"StabilityShadow_Mix"},
23325: {"AegisName":"Mobile_Novice_Box"},
23328: {"AegisName":"Asha_Vahishta"},
23329: {"AegisName":"C_Wing_Of_Fly_5Day_Box_"},
23330: {"AegisName":"C_Giant_Fly_1Day_Box_"},
23331: {"AegisName":"C_Wing_Of_Fly_Box_"},
23332: {"AegisName":"May_Gold_Scroll"},
23333: {"AegisName":"New_Hat_Box3"},
23334: {"AegisName":"ExShadow_DdukddakBox"},
23335: {"AegisName":"Material_Shadow_Cube"},
23336: {"AegisName":"Mysterious_Medal_Box"},
23338: {"AegisName":"Comp_Wing_Of_Fly"},
23340: {"AegisName":"Comp_Megaphone"},
23342: {"AegisName":"Vend_Arbeit1_1Lv"},
23343: {"AegisName":"Vend_Arbeit1_2Lv"},
23344: {"AegisName":"Vend_Arbeit1_3Lv"},
23345: {"AegisName":"Buy_Arbeit1_1Lv"},
23346: {"AegisName":"Buy_Arbeit1_2Lv"},
23347: {"AegisName":"Buy_Arbeit1_3Lv"},
23348: {"AegisName":"Vend_Arbeit_1Lv"},
23349: {"AegisName":"Vend_Arbeit_2Lv"},
23350: {"AegisName":"Vend_Arbeit_3Lv"},
23351: {"AegisName":"Buy_Arbeit_1Lv"},
23352: {"AegisName":"Buy_Arbeit_2Lv"},
23353: {"AegisName":"Buy_Arbeit_3Lv"},
23354: {"AegisName":"Vend_Arbeit3_1Lv"},
23355: {"AegisName":"Vend_Arbeit3_2Lv"},
23356: {"AegisName":"Vend_Arbeit3_3Lv"},
23357: {"AegisName":"Buy_Arbeit3_1Lv"},
23358: {"AegisName":"Buy_Arbeit3_2Lv"},
23359: {"AegisName":"Buy_Arbeit3_3Lv"},
23360: {"AegisName":"Psychotropic"},
23361: {"AegisName":"Serum"},
23362: {"AegisName":"Pig_Potato"},
23363: {"AegisName":"E_Watermelon_Pudding"},
23364: {"AegisName":"Cryptura_Cookie"},
23365: {"AegisName":"Cryptura_Giftbox"},
23367: {"AegisName":"Tamato_Noodle"},
23368: {"AegisName":"Store_Search1"},
23374: {"AegisName":"Fire_Armor_S"},
23375: {"AegisName":"Cold_Armor_S"},
23376: {"AegisName":"Wind_Armor_S"},
23377: {"AegisName":"Earth_Armor_S"},
23383: {"AegisName":"General_Scroll"},
23388: {"AegisName":"CookingBox10"},
23405: {"AegisName":"Green_Scroll_K2"},
23436: {"AegisName":"Shadow_Refine_Hammer"},
23438: {"AegisName":"New_Shadow_Cube"},
23440: {"AegisName":"Sentimental_Scroll"},
23444: {"AegisName":"July_Hair_Box"},
23445: {"AegisName":"Grilled_Turkey"},
23446: {"AegisName":"Savage_Trap"},
23473: {"AegisName":"Infinity_Scroll"},
23474: {"AegisName":"InfinityShadow_Mix"},
23475: {"AegisName":"Infinity_Drink"},
23484: {"AegisName":"Firstaid_Box_5"},
23485: {"AegisName":"Firstaid_Box_10"},
23486: {"AegisName":"Firstaid_Box_15"},
23487: {"AegisName":"Firstaid_Box_20"},
23488: {"AegisName":"Firstaid_Box_25"},
23489: {"AegisName":"Firstaid_Box_30"},
23490: {"AegisName":"Firstaid_Box_35"},
23491: {"AegisName":"Firstaid_Box_40"},
23492: {"AegisName":"Firstaid_Box_45"},
23493: {"AegisName":"Firstaid_Box_50"},
23494: {"AegisName":"Firstaid_Box_55"},
23495: {"AegisName":"Firstaid_Box_60"},
23496: {"AegisName":"Firstaid_Box_65"},
23497: {"AegisName":"Firstaid_Box_70"},
23498: {"AegisName":"Firstaid_Box_75"},
23499: {"AegisName":"Firstaid_Box_80"},
23500: {"AegisName":"Firstaid_Box_85"},
23501: {"AegisName":"Firstaid_Box_90"},
23502: {"AegisName":"Firstaid_Box_95"},
23503: {"AegisName":"Red_Potion_B_20"},
23504: {"AegisName":"Orange_Potion_B_20"},
23505: {"AegisName":"Yellow_Potion_B_20"},
23506: {"AegisName":"White_Potion_B_20"},
23524: {"AegisName":"Enchant_Stone_Box13"},
23533: {"AegisName":"Vote_Rose"},
23537: {"AegisName":"Bloody_Scroll"},
23538: {"AegisName":"BloodyKnight_Shield_Box"},
23545: {"AegisName":"Silver_Statue"},
23546: {"AegisName":"Cursed_Blood"},
23547: {"AegisName":"Gold_Statue"},
23548: {"AegisName":"Ice_Candy"},
23549: {"AegisName":"Snow_Cookie"},
23550: {"AegisName":"Winter_Cookie"},
23551: {"AegisName":"Festi_Cookie"},
23552: {"AegisName":"Flora_Cookie"},
23553: {"AegisName":"Snow_Festa_Box"},
23554: {"AegisName":"Snow_Festa_CardPack"},
23556: {"AegisName":"Hunter_Food"},
23575: {"AegisName":"Adventurer_Box_1"},
23576: {"AegisName":"Adventurer_Box_15"},
23577: {"AegisName":"Adventurer_Box_30"},
23578: {"AegisName":"Adventurer_Box_45"},
23579: {"AegisName":"Adventurer_Box_60"},
23580: {"AegisName":"Adventurer_Box_75"},
23581: {"AegisName":"Adventurer_Box_90"},
23582: {"AegisName":"E_Wing_Of_Fly_3Day_Box"},
23583: {"AegisName":"Rebeginer_Box"},
23584: {"AegisName":"Rebeginer_S_Box"},
23585: {"AegisName":"Rebeginer_Box_100"},
23586: {"AegisName":"Rebeginer_Box_110"},
23587: {"AegisName":"Rebeginer_Box_120"},
23604: {"AegisName":"Main_Dish_Course"},
23605: {"AegisName":"Challenge_Drink"},
23606: {"AegisName":"Power_Drink"},
23607: {"AegisName":"Unlimited_Drink"},
23611: {"AegisName":"Mimir_Spring_Water"},
23612: {"AegisName":"Baldrs_Blessing"},
23618: {"AegisName":"2017_Special_Scroll"},
23619: {"AegisName":"2017_Special_Box"},
23629: {"AegisName":"Enchant_Stone_Box14"},
23647: {"AegisName":"Zero_Merchant_Bell"},
23648: {"AegisName":"Zero_Kafra_Bell"},
23650: {"AegisName":"Ice_Scroll"},
23660: {"AegisName":"Dogly_Bottle_Z"},
23661: {"AegisName":"2018_New_Year_Scroll"},
23662: {"AegisName":"2018_Year_Shadow_Cube"},
23663: {"AegisName":"2018_Material_Cube"},
23664: {"AegisName":"2018_Lapine_DdukddakBox"},
23665: {"AegisName":"PhysicalMagical_Mix"},
23666: {"AegisName":"ImmunedAthena_Mix"},
23667: {"AegisName":"HardChamption_Mix"},
23668: {"AegisName":"KingbirdAncient_Mix"},
23669: {"AegisName":"CriticalHit_Mix"},
23674: {"AegisName":"Sweets_Evt_Box"},
23675: {"AegisName":"Geffen_Magic_Scroll"},
23676: {"AegisName":"Gray_Charcoal_Melee"},
23677: {"AegisName":"Gray_Charcoal_Magic"},
23678: {"AegisName":"Gray_Charcoal_Range"},
23679: {"AegisName":"Geffen_Magic_Scroll2"},
23682: {"AegisName":"Enchant_Stone_Box15"},
23683: {"AegisName":"EVT_JAN02KR"},
23684: {"AegisName":"2018_Visionary_Card"},
23700: {"AegisName":"Lunar_New_Year_Scroll"},
23706: {"AegisName":"Charleston_Parts_W"},
23707: {"AegisName":"Charleston_Parts_R"},
23708: {"AegisName":"February_Hair_Box"},
23710: {"AegisName":"2018_Spring_Scroll"},
23711: {"AegisName":"Booby_Trap_Box"},
23718: {"AegisName":"2018_Sakura_Scroll"},
23719: {"AegisName":"Sealed_Card2"},
23720: {"AegisName":"Shadow_Random_Mix"},
23723: {"AegisName":"Melon_Bread"},
23724: {"AegisName":"Celebrate_Egg"},
23725: {"AegisName":"E_Main_Dish_C"},
23726: {"AegisName":"E_Challenge_Drink"},
23727: {"AegisName":"E_Unlimited_Drink"},
23728: {"AegisName":"E_Power_Drink"},
23732: {"AegisName":"E_Mimir_Spring_W"},
23733: {"AegisName":"E_Baldrs_Blessing"},
23743: {"AegisName":"Noodle_Festa_Can"},
23744: {"AegisName":"Cream_Noodle"},
23751: {"AegisName":"Comp_AID_Buff_Box"},
23752: {"AegisName":"Comp_Box"},
23754: {"AegisName":"Comp_All_Ring_Box"},
23761: {"AegisName":"Advanced_Taiming_Item2"},
23763: {"AegisName":"Mysterious_Egg3"},
23764: {"AegisName":"Comp_Box2"},
23765: {"AegisName":"May_Rainbow_Scroll"},
23766: {"AegisName":"Overwhelm_Armor_Box"},
23767: {"AegisName":"Powerful_Helm_Box"},
23770: {"AegisName":"Enchant_Stone_Box16"},
23771: {"AegisName":"Mysterious_Plastic"},
23772: {"AegisName":"EP17_1_SPC01"},
23773: {"AegisName":"EP17_1_SPC02"},
23774: {"AegisName":"EP17_1_SPC03"},
23775: {"AegisName":"EP17_1_SPC04"},
23776: {"AegisName":"EP17_1_SPC05"},
23777: {"AegisName":"EP17_1_SPC06"},
23778: {"AegisName":"EP17_1_SPC07"},
23779: {"AegisName":"EP17_1_SPC08"},
23780: {"AegisName":"EP17_1_SPC09"},
23781: {"AegisName":"EP17_1_SPC10"},
23784: {"AegisName":"Sweet_Candy_Box"},
23804: {"AegisName":"Pump_Of_Spirit_Scroll2"},
23805: {"AegisName":"Spirit_Hat_Box"},
23806: {"AegisName":"Hero_Weapon_Box"},
23815: {"AegisName":"Magma_Essence"},
23817: {"AegisName":"Bs_Making_S"},
23818: {"AegisName":"Bs_Item_M_S_2"},
23819: {"AegisName":"Bs_Item_M_S_8"},
23820: {"AegisName":"Bs_Item_M_S_10"},
23821: {"AegisName":"Bs_Item_M_S_11"},
23822: {"AegisName":"Bs_Item_M_S_34"},
23823: {"AegisName":"Bs_Item_M_S_41"},
23824: {"AegisName":"Bs_Item_M_S_42"},
23825: {"AegisName":"Bs_Item_M_S_43"},
23826: {"AegisName":"Bs_Item_M_S_44"},
23827: {"AegisName":"Bs_Sha_M_S_1"},
23828: {"AegisName":"Bs_Sha_M_S_17"},
23829: {"AegisName":"Bs_Sha_M_S_18"},
23830: {"AegisName":"Bs_Sha_M_S_19"},
23831: {"AegisName":"Bs_Sha_M_S_20"},
23832: {"AegisName":"Bs_Item_M_S_4"},
23833: {"AegisName":"Bs_Item_M_S_6"},
23834: {"AegisName":"Bs_Item_M_S_7"},
23835: {"AegisName":"Bs_Item_M_S_12"},
23836: {"AegisName":"Bs_Item_M_S_13"},
23837: {"AegisName":"Bs_Item_M_S_15"},
23838: {"AegisName":"Bs_Item_M_S_28"},
23839: {"AegisName":"Bs_Item_M_S_29"},
23840: {"AegisName":"Bs_Item_M_S_31"},
23841: {"AegisName":"Bs_Item_M_S_32"},
23842: {"AegisName":"Bs_Item_M_S_33"},
23843: {"AegisName":"Bs_Item_M_S_36"},
23844: {"AegisName":"Bs_Item_M_S_37"},
23845: {"AegisName":"Bs_Item_M_S_38"},
23846: {"AegisName":"Bs_Item_M_S_39"},
23847: {"AegisName":"Bs_Item_M_S_40"},
23848: {"AegisName":"Bs_Item_M_S_45"},
23849: {"AegisName":"Bs_Item_M_S_46"},
23850: {"AegisName":"Bs_Item_M_S_47"},
23851: {"AegisName":"Bs_Item_M_S_48"},
23852: {"AegisName":"Bs_Item_M_S_49"},
23853: {"AegisName":"Bs_Item_M_S_50"},
23854: {"AegisName":"Bs_Sha_M_S_2"},
23855: {"AegisName":"Bs_Sha_M_S_5"},
23856: {"AegisName":"Bs_Sha_M_S_6"},
23857: {"AegisName":"Bs_Sha_M_S_7"},
23858: {"AegisName":"Bs_Sha_M_S_8"},
23859: {"AegisName":"Bs_Sha_M_S_13"},
23860: {"AegisName":"Bs_Sha_M_S_15"},
23861: {"AegisName":"Bs_Sha_M_S_16"},
23862: {"AegisName":"Bs_Sha_M_S_23"},
23863: {"AegisName":"Bs_Item_M_S_5"},
23864: {"AegisName":"Bs_Item_M_S_9"},
23865: {"AegisName":"Bs_Item_M_S_14"},
23866: {"AegisName":"Bs_Item_M_S_16"},
23867: {"AegisName":"Bs_Item_M_S_17"},
23868: {"AegisName":"Bs_Item_M_S_19"},
23869: {"AegisName":"Bs_Item_M_S_27"},
23870: {"AegisName":"Bs_Item_M_S_35"},
23871: {"AegisName":"Bs_Sha_M_S_9"},
23872: {"AegisName":"Bs_Sha_M_S_10"},
23873: {"AegisName":"Bs_Sha_M_S_11"},
23874: {"AegisName":"Bs_Sha_M_S_21"},
23875: {"AegisName":"Bs_Sha_M_S_22"},
23876: {"AegisName":"Bs_Item_M_S_1"},
23877: {"AegisName":"Bs_Item_M_S_3"},
23878: {"AegisName":"StarSoul_Scroll"},
23879: {"AegisName":"Bs_Item_M_S_18"},
23880: {"AegisName":"Bs_Item_M_S_20"},
23881: {"AegisName":"Bs_Item_M_S_21"},
23882: {"AegisName":"Bs_Item_M_S_22"},
23883: {"AegisName":"Bs_Item_M_S_23"},
23884: {"AegisName":"Bs_Item_M_S_24"},
23885: {"AegisName":"Bs_Item_M_S_25"},
23886: {"AegisName":"Bs_Item_M_S_26"},
23887: {"AegisName":"Bs_Item_M_S_30"},
23888: {"AegisName":"Bs_Sha_M_S_3"},
23889: {"AegisName":"Bs_Sha_M_S_4"},
23890: {"AegisName":"Bs_Sha_M_S_12"},
23891: {"AegisName":"Bs_Sha_M_S_14"},
23892: {"AegisName":"Bs_Sha_M_S_24"},
23893: {"AegisName":"Bs_Sha_M_S_25"},
23894: {"AegisName":"Bs_Item_M_S_51"},
23896: {"AegisName":"Comp_ConnectError"},
23897: {"AegisName":"2018_Jump_Thx_Box"},
23898: {"AegisName":"Comp_Power_Booster"},
23899: {"AegisName":"Comp_Almighty"},
23900: {"AegisName":"Time_Overload_Box"},
23901: {"AegisName":"110LVUP"},
23905: {"AegisName":"Season_Evt_Reward_3"},
23906: {"AegisName":"Season_Evt_Reward_4"},
23907: {"AegisName":"Season_Evt_Reward_5"},
23913: {"AegisName":"Job_Enchant_Stone_Box"},
23914: {"AegisName":"Main_Lucky_Box"},
23919: {"AegisName":"K_Secret_Key"},
23921: {"AegisName":"Season_Evt_Reward"},
23922: {"AegisName":"Candy_Box"},
23923: {"AegisName":"Poring_Sunglasses_Box"},
23924: {"AegisName":"Sigrun_Shadow_Box"},
23925: {"AegisName":"Mad_Bunny_Box"},
23926: {"AegisName":"Shadow_9_Refine_Hammer"},
23949: {"AegisName":"Level_Achievement_Box"},
23952: {"AegisName":"Sillit_Pong_Box"},
23962: {"AegisName":"Malang_Cat_Can2"},
23967: {"AegisName":"EnchantStone_Recipe_9m"},
23981: {"AegisName":"Abyss_Ddbox"},
23985: {"AegisName":"Abyss_itembox"},
23986: {"AegisName":"Odin_itembox"},
23992: {"AegisName":"Bio_W_Box"},
23993: {"AegisName":"Bio_Docu_Box"},
23994: {"AegisName":"Bio_Reactant_Box"},
24000: {"AegisName":"T_Str1_Armor_S"},
24001: {"AegisName":"T_Dex1_Weapon_S"},
24002: {"AegisName":"T_Luk1_Shield_S"},
24003: {"AegisName":"T_Agi1_Shoes_S"},
24004: {"AegisName":"T_Vit1_Acc_R_S"},
24005: {"AegisName":"T_Int1_Acc_L_S"},
24006: {"AegisName":"T_Str2_Armor_S"},
24007: {"AegisName":"T_Dex2_Weapon_S"},
24008: {"AegisName":"T_Luk2_Shield_S"},
24009: {"AegisName":"T_Agi2_Shoes_S"},
24010: {"AegisName":"T_Vit2_Acc_R_S"},
24011: {"AegisName":"T_Int2_Acc_L_S"},
24012: {"AegisName":"S_Promotion_Weapon"},
24013: {"AegisName":"S_Promotion_Armor"},
24014: {"AegisName":"S_Promotion_Shoes"},
24015: {"AegisName":"S_Promotion_Shield"},
24016: {"AegisName":"S_Promotion_Earring"},
24017: {"AegisName":"S_Promotion_Pendant"},
24018: {"AegisName":"S_Physical_Earring"},
24019: {"AegisName":"S_Physical_Weapon"},
24020: {"AegisName":"S_Physical_Pendant"},
24021: {"AegisName":"S_Magical_Earring"},
24022: {"AegisName":"S_Magical_Weapon"},
24023: {"AegisName":"S_Magical_Pendant"},
24024: {"AegisName":"S_Breezy_Armor"},
24025: {"AegisName":"S_Champion_Shoes"},
24026: {"AegisName":"S_Athena_Shield"},
24027: {"AegisName":"S_Immune_Armor"},
24028: {"AegisName":"S_Hard_Armor"},
24029: {"AegisName":"S_Ancient_Armor"},
24030: {"AegisName":"S_Critical_Armor"},
24031: {"AegisName":"S_Kingbird_Weapon"},
24032: {"AegisName":"S_Cri_Hit_Weapon"},
24033: {"AegisName":"S_Healing_Weapon"},
24034: {"AegisName":"S_Lucky_Weapon"},
24035: {"AegisName":"S_Power_Earring"},
24036: {"AegisName":"S_Int_Pendant"},
24037: {"AegisName":"S_Dexterous_Armor"},
24038: {"AegisName":"S_Vital_Shoes"},
24039: {"AegisName":"S_Athletic_Shield"},
24040: {"AegisName":"S_Lucky_Armor"},
24041: {"AegisName":"S_Power_Pendant"},
24042: {"AegisName":"S_Int_Earring"},
24043: {"AegisName":"S_Dexterous_Weapon"},
24044: {"AegisName":"S_Vital_Shield"},
24045: {"AegisName":"S_Athletic_Shoes"},
24046: {"AegisName":"S_Resist_Spell_Pendant"},
24047: {"AegisName":"S_Rapid_Pendant"},
24048: {"AegisName":"S_Caster_Pendant"},
24049: {"AegisName":"S_Hard_Earring"},
24050: {"AegisName":"S_Wise_Earring"},
24051: {"AegisName":"S_Athena_Earring"},
24052: {"AegisName":"S_Cranial_Shield"},
24053: {"AegisName":"S_Safeguard_Shield"},
24054: {"AegisName":"S_Brutal_Shield"},
24055: {"AegisName":"S_Gargantua_Shield"},
24056: {"AegisName":"S_Homers_Shield"},
24057: {"AegisName":"S_Dragoon_Shield"},
24058: {"AegisName":"S_Satanic_Shield"},
24059: {"AegisName":"S_Flameguard_Shield"},
24060: {"AegisName":"S_Requiem_Shield"},
24061: {"AegisName":"S_Cadi_Shield"},
24062: {"AegisName":"S_Bloody_Shoes"},
24063: {"AegisName":"S_Liberation_Shoes"},
24064: {"AegisName":"S_Chemical_Shoes"},
24065: {"AegisName":"S_Clamorous_Shoes"},
24066: {"AegisName":"S_Insecticide_Shoes"},
24067: {"AegisName":"S_Fisher_Shoes"},
24068: {"AegisName":"S_Seraphim_Shoes"},
24069: {"AegisName":"S_Beholder_Shoes"},
24070: {"AegisName":"S_Divine_Shoes"},
24071: {"AegisName":"S_Dragoon_Shoes"},
24072: {"AegisName":"S_Big_Armor"},
24073: {"AegisName":"S_Medium_Armor"},
24074: {"AegisName":"S_Small_Armor"},
24075: {"AegisName":"S_Big_Weapon"},
24076: {"AegisName":"S_Medium_Weapon"},
24077: {"AegisName":"S_Small_Weapon"},
24078: {"AegisName":"S_Spiritual_Weapon"},
24079: {"AegisName":"S_Spiritual_Earring"},
24080: {"AegisName":"S_Spiritual_Pendent"},
24081: {"AegisName":"S_Malicious_Armor"},
24082: {"AegisName":"S_Malicious_Shoes"},
24083: {"AegisName":"S_Malicious_Shield"},
24084: {"AegisName":"S_Gemstone_Armor"},
24085: {"AegisName":"S_Gemstone_Shoes"},
24086: {"AegisName":"S_Gemstone_Shield"},
24087: {"AegisName":"S_Gemstone_Weapon"},
24088: {"AegisName":"S_Gemstone_Earring"},
24089: {"AegisName":"S_Gemstone_Pendent"},
24090: {"AegisName":"S_Stability_Shield"},
24091: {"AegisName":"S_Plasterer's_Armor"},
24092: {"AegisName":"S_Plasterer's_Shoes"},
24093: {"AegisName":"S_Insomniac_Armor"},
24094: {"AegisName":"S_Insomniac_Shoes"},
24095: {"AegisName":"S_Peerless_Armor"},
24096: {"AegisName":"S_Peerless_Shoes"},
24097: {"AegisName":"S_Adurate_Armor"},
24098: {"AegisName":"S_Adurate_Shoes"},
24099: {"AegisName":"Unfreez_Weapon_S"},
24100: {"AegisName":"Unfreeze_Earing_S"},
24101: {"AegisName":"Unfreeze_Pendent_S"},
24102: {"AegisName":"Vitality_Earing_S"},
24103: {"AegisName":"Vitality_Pendant_S"},
24104: {"AegisName":"S_Neutral_Weapon"},
24105: {"AegisName":"S_Neutral_Earring"},
24106: {"AegisName":"S_Neutral_Pendent"},
24107: {"AegisName":"S_Curse_Lift_Earring"},
24108: {"AegisName":"S_Curse_Lift_Pendent"},
24109: {"AegisName":"S_Caster_earring"},
24110: {"AegisName":"S_Caster_Weapon"},
24111: {"AegisName":"S_Spell_Flow_Shoes"},
24112: {"AegisName":"S_Spell_Flow_Armor"},
24113: {"AegisName":"S_Spell_Flow_Shield"},
24114: {"AegisName":"S_Greed_Armor"},
24115: {"AegisName":"S_Greed_Shoes"},
24116: {"AegisName":"S_Greed_Shield"},
24117: {"AegisName":"S_Greed_Weapon"},
24118: {"AegisName":"S_Greed_Earring"},
24119: {"AegisName":"S_Greed_Pendant"},
24120: {"AegisName":"S_Heal_Armor"},
24121: {"AegisName":"S_Heal_Shoes"},
24122: {"AegisName":"S_Heal_Shield"},
24123: {"AegisName":"S_Heal_Weapon"},
24124: {"AegisName":"S_Heal_Earring"},
24125: {"AegisName":"S_Heal_Pendant"},
24126: {"AegisName":"S_Hiding_Armor"},
24127: {"AegisName":"S_Hiding_Shoes"},
24128: {"AegisName":"S_Hiding_Shield"},
24129: {"AegisName":"S_Hiding_Weapon"},
24130: {"AegisName":"S_Hiding_Earring"},
24131: {"AegisName":"S_Hiding_Pendant"},
24132: {"AegisName":"S_Cloaking_Armor"},
24133: {"AegisName":"S_Cloaking_Shoes"},
24134: {"AegisName":"S_Cloaking_Shield"},
24135: {"AegisName":"S_Cloaking_Weapon"},
24136: {"AegisName":"S_Cloaking_Earring"},
24137: {"AegisName":"S_Cloaking_Pendant"},
24138: {"AegisName":"S_Teleport_Armor"},
24139: {"AegisName":"S_Teleport_Shoes"},
24140: {"AegisName":"S_Teleport_Shield"},
24141: {"AegisName":"S_Teleport_Weapon"},
24142: {"AegisName":"S_Teleport_Earring"},
24143: {"AegisName":"S_Teleport_Pendant"},
24144: {"AegisName":"S_Steal_Armor"},
24145: {"AegisName":"S_Steal_Shoes"},
24146: {"AegisName":"S_Steal_Shield"},
24147: {"AegisName":"S_Steal_Weapon"},
24148: {"AegisName":"S_Steal_Earring"},
24149: {"AegisName":"S_Steal_Pendant"},
24150: {"AegisName":"S_Infinity_Earring"},
24151: {"AegisName":"S_Infinity_Pendant"},
24152: {"AegisName":"S_Solid_Weapon"},
24153: {"AegisName":"S_Solid_Earring"},
24154: {"AegisName":"S_Immortal_Armor"},
24155: {"AegisName":"S_Immortal_Pendant"},
24156: {"AegisName":"S_Executioner_Weapon"},
24157: {"AegisName":"S_Exorcist_Weapon"},
24158: {"AegisName":"S_Hunting_Weapon"},
24159: {"AegisName":"S_Insect_Net_Weapon"},
24160: {"AegisName":"S_Fishing_Weapon"},
24161: {"AegisName":"S_Dragon_Killer_Weapon"},
24162: {"AegisName":"S_Corrupt_Weapon"},
24163: {"AegisName":"S_Vibration_Weapon"},
24164: {"AegisName":"S_Holy_Water_Weapon"},
24165: {"AegisName":"S_Scissors_Weapon"},
24166: {"AegisName":"S_Penetration_Earring"},
24167: {"AegisName":"S_Penetration_Pendent"},
24168: {"AegisName":"S_Tempest_Earring"},
24169: {"AegisName":"S_Tempest_Pendent"},
24170: {"AegisName":"S_M_Executioner_Weapon"},
24171: {"AegisName":"S_M_Exorcist_Weapon"},
24172: {"AegisName":"S_M_Hunting_Weapon"},
24173: {"AegisName":"S_M_Insect_Net_Weapon"},
24174: {"AegisName":"S_M_Fishing_Weapon"},
24175: {"AegisName":"S_M_Dragon_K_Weapon"},
24176: {"AegisName":"S_M_Corrupt_Weapon"},
24177: {"AegisName":"S_M_Vibration_Weapon"},
24178: {"AegisName":"S_M_Holy_Water_Weapon"},
24179: {"AegisName":"S_M_Scissors_Weapon"},
24180: {"AegisName":"S_Bearers_Armor"},
24181: {"AegisName":"S_Bearers_Shoes"},
24182: {"AegisName":"S_Bearers_Shield"},
24183: {"AegisName":"S_Bearers_Weapon"},
24184: {"AegisName":"S_Bearers_Earring"},
24185: {"AegisName":"S_Bearers_Pendent"},
24186: {"AegisName":"S_Basis_Armor"},
24187: {"AegisName":"S_Hallowed_Armor"},
24188: {"AegisName":"S_Saharic_Armor"},
24189: {"AegisName":"S_Underneath_Armor"},
24190: {"AegisName":"S_Flam_Armor"},
24191: {"AegisName":"S_Windy_Armor"},
24192: {"AegisName":"S_Envenom_Armor"},
24193: {"AegisName":"S_Damned_Armor"},
24194: {"AegisName":"S_Geist_Armor"},
24195: {"AegisName":"S_Divine_Armor"},
24196: {"AegisName":"S_Hasty_Shoes"},
24197: {"AegisName":"S_Hasty_Armor"},
24198: {"AegisName":"S_Basis_Shield"},
24199: {"AegisName":"S_Hallowed_Shield"},
24200: {"AegisName":"S_Saharic_Shield"},
24201: {"AegisName":"S_Underneath_Shield"},
24202: {"AegisName":"S_Flam_Shield"},
24203: {"AegisName":"S_Windy_Shield"},
24204: {"AegisName":"S_Envenom_Shield"},
24205: {"AegisName":"S_Damned_Shield"},
24206: {"AegisName":"S_Geist_Shield"},
24207: {"AegisName":"S_Divine_Shield"},
24208: {"AegisName":"S_Expert_Shoes"},
24209: {"AegisName":"S_Expert_Shield"},
24210: {"AegisName":"S_Beginner_Shoes"},
24211: {"AegisName":"S_Beginner_Shield"},
24212: {"AegisName":"S_Rookie_Shoes"},
24213: {"AegisName":"S_Rookie_Shield"},
24214: {"AegisName":"S_Advanced_Shoes"},
24215: {"AegisName":"S_Advanced_Shield"},
24216: {"AegisName":"S_Attack_Armor"},
24217: {"AegisName":"S_Blitz_Earring"},
24218: {"AegisName":"S_Blitz_Pendent"},
24219: {"AegisName":"S_ColdBolt_Armor"},
24220: {"AegisName":"S_FireBolt_Armor"},
24221: {"AegisName":"S_LightingBolt_Armor"},
24222: {"AegisName":"S_EarthSpike_Armor"},
24223: {"AegisName":"S_Enhance_Force_Weapon"},
24224: {"AegisName":"S_Force_Weapon"},
24225: {"AegisName":"S_Force_Earring"},
24226: {"AegisName":"S_Force_Pendant"},
24227: {"AegisName":"S_Enhance_Spirit_Weapon"},
24228: {"AegisName":"S_Spirit_Weapon"},
24229: {"AegisName":"S_Spirit_Earring"},
24230: {"AegisName":"S_Spirit_Pendant"},
24231: {"AegisName":"S_Blitz_Shoes"},
24232: {"AegisName":"S_Blitz_Shield"},
24233: {"AegisName":"S_Exceed_Weapon"},
24234: {"AegisName":"S_Titan_Earring"},
24235: {"AegisName":"S_Titan_Pendant"},
24236: {"AegisName":"S_Boned_Earring"},
24237: {"AegisName":"S_Boned_Pendant"},
24238: {"AegisName":"S_Gigantic_Earring"},
24239: {"AegisName":"S_Gigantic_Pendant"},
24240: {"AegisName":"S_Caster_Shoes"},
24241: {"AegisName":"S_Caster_Shield"},
24242: {"AegisName":"S_Caster_Armor"},
24243: {"AegisName":"S_Reload_Shoes"},
24244: {"AegisName":"S_Reload_Shield"},
24245: {"AegisName":"S_Reload_Armor"},
24246: {"AegisName":"S_Swordman_earring"},
24247: {"AegisName":"S_Merchant_earring"},
24248: {"AegisName":"S_Acolyte_earring"},
24249: {"AegisName":"S_Magician_earring"},
24250: {"AegisName":"S_Swordman_Pendant"},
24251: {"AegisName":"S_Merchant_Pendant"},
24252: {"AegisName":"S_Acolyte_Pendant"},
24253: {"AegisName":"S_Thief_Pendant"},
24254: {"AegisName":"S_Magician_Pendant"},
24255: {"AegisName":"S_Archer_Pendant"},
24256: {"AegisName":"S_Knight_Shoes"},
24257: {"AegisName":"S_Crusader_Shoes"},
24258: {"AegisName":"S_Blacksmith_Shoes"},
24259: {"AegisName":"S_Alchemist_Shoes"},
24260: {"AegisName":"S_Priest_Shoes"},
24261: {"AegisName":"S_Monk_Shoes"},
24262: {"AegisName":"S_Assassin_Shoes"},
24263: {"AegisName":"S_Rogue_Shoes"},
24264: {"AegisName":"S_Wizard_Shoes"},
24265: {"AegisName":"S_Sage_Shoes"},
24266: {"AegisName":"S_Hunter_Shoes"},
24267: {"AegisName":"S_Bard_Shoes"},
24268: {"AegisName":"S_Dancer_Shoes"},
24269: {"AegisName":"S_Knight_Armor"},
24270: {"AegisName":"S_Crusader_Armor"},
24271: {"AegisName":"S_Blacksmith_Armor"},
24272: {"AegisName":"S_Alchemist_Armor"},
24273: {"AegisName":"S_Priest_Armor"},
24274: {"AegisName":"S_Monk_Armor"},
24275: {"AegisName":"S_Assassin_Armor"},
24276: {"AegisName":"S_Rogue_Armor"},
24277: {"AegisName":"S_Wizard_Armor"},
24278: {"AegisName":"S_Sage_Armor"},
24279: {"AegisName":"S_Hunter_Armor"},
24280: {"AegisName":"S_Bard_Armor"},
24281: {"AegisName":"S_Dancer_Armor"},
24282: {"AegisName":"S_SuperNovice_Weapon"},
24283: {"AegisName":"S_Gunslinger_Weapon"},
24284: {"AegisName":"S_Taekwon_Weapon"},
24285: {"AegisName":"S_Ninja_Weapon"},
24286: {"AegisName":"S_DoramMagical_Weapon"},
24287: {"AegisName":"S_DoramPhysical_Weapon"},
24288: {"AegisName":"S_Runeknight_Weapon"},
24289: {"AegisName":"S_Royalguard_Weapon"},
24290: {"AegisName":"S_Mechanic_weapon"},
24291: {"AegisName":"S_Genetic_Weapon"},
24292: {"AegisName":"S_Archbishop_Weapon"},
24293: {"AegisName":"S_Sura_weapon"},
24294: {"AegisName":"S_Guillotine_Weapon"},
24295: {"AegisName":"S_Shadowchaser_Weapon"},
24296: {"AegisName":"S_Warlock_Weapon"},
24297: {"AegisName":"S_Sorcerer_Weapon"},
24298: {"AegisName":"S_Ranger_Weapon"},
24299: {"AegisName":"S_Minstrel_Weapon"},
24300: {"AegisName":"S_Wanderer_Weapon"},
24301: {"AegisName":"S_Runeknight_Shield"},
24302: {"AegisName":"S_Royalguard_Shield"},
24303: {"AegisName":"S_Mechanic_Shield"},
24304: {"AegisName":"S_Genetic_Shield"},
24305: {"AegisName":"S_Archbishop_Shield"},
24306: {"AegisName":"S_Sura_Shield"},
24307: {"AegisName":"S_Guillotine_Shield"},
24308: {"AegisName":"S_Shadowchaser_Shield"},
24309: {"AegisName":"S_Warlock_Shield"},
24310: {"AegisName":"S_Sorcerer_Shield"},
24311: {"AegisName":"S_Ranger_Shield"},
24312: {"AegisName":"S_Minstrel_Shield"},
24313: {"AegisName":"S_Wanderer_Shield"},
24314: {"AegisName":"S_Ninja_Shield"},
24315: {"AegisName":"S_Taekwon_Shield"},
24316: {"AegisName":"S_DoramPhysical_Shield"},
24317: {"AegisName":"S_DoramMagical_Shield"},
24318: {"AegisName":"S_SuperNovice_Shield"},
24319: {"AegisName":"S_Gunslinger_Shield"},
24320: {"AegisName":"S2_Hasty_Shoes"},
24321: {"AegisName":"S2_Bearers_Pendent"},
24322: {"AegisName":"S2_Gemstone_Earring"},
24323: {"AegisName":"S2_Spell_Flow_Shield"},
24324: {"AegisName":"S2_Spiritual_Weapon"},
24325: {"AegisName":"S2_Malicious_Armor"},
24326: {"AegisName":"S_Sigrun_Armor"},
24327: {"AegisName":"S_Sigrun_Shield"},
24328: {"AegisName":"S2_Force_Ex_Weapon"},
24329: {"AegisName":"S2_Spirit_M_E_Weapon"},
24330: {"AegisName":"S2_Caster_Armor"},
24331: {"AegisName":"S2_Reload_Armor"},
24332: {"AegisName":"S_Critical_Shield"},
24333: {"AegisName":"S_Critical_Shoes"},
24334: {"AegisName":"S_MagicCompose_Armor"},
24335: {"AegisName":"S2_Gemstone_Weapon"},
24336: {"AegisName":"S2_Gemstone_Shield"},
24337: {"AegisName":"S2_Bearers_Armor"},
24338: {"AegisName":"S2_Bearers_Shoes"},
24339: {"AegisName":"S_AllMighty_Earring"},
24340: {"AegisName":"S_AllMighty_Pendant"},
24341: {"AegisName":"S_AllRace_Shoes"},
24342: {"AegisName":"S_AllRace_Shield"},
24343: {"AegisName":"S_Blitz_Weapon"},
24344: {"AegisName":"S_Blitz_Armor"},
24345: {"AegisName":"S_Tempest_Shield"},
24346: {"AegisName":"S_Tempest_Shoes"},
24347: {"AegisName":"S_M_ExeHoly_Armor"},
24348: {"AegisName":"S_M_ExoCorrupt_Armor"},
24349: {"AegisName":"S_M_DragonVib_Armor"},
24350: {"AegisName":"S_M_SciHunting_Armor"},
24351: {"AegisName":"S_M_FishInsect_Armor"},
24352: {"AegisName":"S2_Plasterer's_Armor"},
24353: {"AegisName":"S2_Insomniac_Shoes"},
24354: {"AegisName":"S2_Peerless_Armor"},
24355: {"AegisName":"S2_Adurate_Shoes"},
24356: {"AegisName":"Unfreez_Weapon_S2"},
24357: {"AegisName":"Vitality_Earing_S2"},
24358: {"AegisName":"S2_Neutral_Weapon"},
24359: {"AegisName":"S2_Curse_Lift_Pendent"},
24360: {"AegisName":"S_Tension_Weapon"},
24361: {"AegisName":"S_Tension_Earring"},
24362: {"AegisName":"S_Tension_Pendent"},
24363: {"AegisName":"S_Elegant_Weapon"},
24364: {"AegisName":"S_Elegant_Earring"},
24365: {"AegisName":"S_Elegant_Pendent"},
24366: {"AegisName":"S_Healing_Shield"},
24367: {"AegisName":"S_Healing_Shoes"},
24368: {"AegisName":"S_Restore_Earring"},
24369: {"AegisName":"S_Restore_Pendent"},
24370: {"AegisName":"S_MortalBlow_Weapon"},
24371: {"AegisName":"S_MortalBlow_Earring"},
24372: {"AegisName":"S_MortalBlow_Pendent"},
24373: {"AegisName":"S_Penetration_Shoes"},
24374: {"AegisName":"S_Penetration_Shield"},
24375: {"AegisName":"S_ExeHoly_Armor"},
24376: {"AegisName":"S_ExoCorrupt_Armor"},
24377: {"AegisName":"S_DragonVib_Armor"},
24378: {"AegisName":"S_SciHunting_Armor"},
24379: {"AegisName":"S_FishInsect_Armor"},
24380: {"AegisName":"Sentimental_Weapone_S"},
24381: {"AegisName":"Sentimental_Earring_S"},
24382: {"AegisName":"Sentimental_Pendant_S"},
24383: {"AegisName":"Enchanting_Weapone_S"},
24384: {"AegisName":"Enchanting_Earring_S"},
24385: {"AegisName":"Enchanting_Pendant_S"},
24386: {"AegisName":"S_Infinity_Weapon"},
24387: {"AegisName":"Rebeginer_Armor_S"},
24388: {"AegisName":"Rebeginer_Shield_S"},
24389: {"AegisName":"Rebeginer_Shoes_S"},
24390: {"AegisName":"Rebeginer_Weapon_S"},
24391: {"AegisName":"Rebeginer_Earring_S"},
24392: {"AegisName":"Rebeginer_Pendant_S"},
24393: {"AegisName":"S_Physical_Shoes"},
24394: {"AegisName":"S_Physical_Shield"},
24395: {"AegisName":"S_Physical_Armor"},
24396: {"AegisName":"S_Magical_Shoes"},
24397: {"AegisName":"S_Magical_Shield"},
24398: {"AegisName":"S_Magical_Armor"},
24399: {"AegisName":"S_ImmunedAthena_Shield"},
24400: {"AegisName":"S_HardChamption_Shoes"},
24401: {"AegisName":"S_KingbirdAncient_Armor"},
24402: {"AegisName":"S_Rebellion_Armor"},
24403: {"AegisName":"S_Kagerou_Armor"},
24404: {"AegisName":"S_Oboro_Armor"},
24405: {"AegisName":"S_Rebellion_Shoes"},
24406: {"AegisName":"S_Kagerou_Shoes"},
24407: {"AegisName":"S_Oboro_Shoes"},
24408: {"AegisName":"S_DoramPhysical_Armor"},
24409: {"AegisName":"S_DoramPhysical_Shoes"},
24410: {"AegisName":"S_DoramMagical_Armor"},
24411: {"AegisName":"S_DoramMagical_Shoes"},
24412: {"AegisName":"S_Star_Emperor_Armor"},
24413: {"AegisName":"S_Star_Emperor_Shoes"},
24414: {"AegisName":"S_Soul_Reaper_Armor"},
24415: {"AegisName":"S_Soul_Reaper_Shoes"},
24416: {"AegisName":"S_Timeoverload_Weapon"},
24417: {"AegisName":"S_Timeoverload_Armor"},
24418: {"AegisName":"S_Timeoverload_Shield"},
24419: {"AegisName":"S_Timeoverload_Shoes"},
24420: {"AegisName":"S_Timeoverload_Earing"},
24421: {"AegisName":"S_Timeoverload_Pandent"},
24423: {"AegisName":"S_Tempest_Weapon"},
24424: {"AegisName":"S_Tempest_Armor"},
24425: {"AegisName":"S_PerfectSize_Weapon"},
24426: {"AegisName":"S_PerfectSize_Armor"},
24427: {"AegisName":"S_M_Exo_Co_Weapon"},
24428: {"AegisName":"S_M_Viv_Dr_Weapon"},
24429: {"AegisName":"S_M_Sci_Hu_Weapon"},
24430: {"AegisName":"S_M_Fis_In_Weapon"},
24431: {"AegisName":"S_M_Exe_Ho_Weapon"},
24432: {"AegisName":"S_Penetration_Weapon"},
24433: {"AegisName":"S_Penetration_Armor"},
24434: {"AegisName":"S_Exe_Ho_Weapon"},
24435: {"AegisName":"S_Fis_In_Weapon"},
24436: {"AegisName":"S_Sci_Hu_Weapon"},
24437: {"AegisName":"S_Viv_Dr_Weapon"},
24438: {"AegisName":"S_Exo_Co_Weapon"},
24439: {"AegisName":"S_Hasty_Weapon"},
24440: {"AegisName":"S_Sonic_Armor"},
24441: {"AegisName":"S_Sonic_Shield"},
24442: {"AegisName":"S_Sonic_Shoes"},
24443: {"AegisName":"S_Ignition_Weapon"},
24444: {"AegisName":"S_Ignition_Pendant"},
24445: {"AegisName":"S_Ignition_Earing"},
24446: {"AegisName":"S_W_Breath_Armor"},
24447: {"AegisName":"S_W_Breath_Shield"},
24448: {"AegisName":"S_W_Breath_Shoes"},
24449: {"AegisName":"S_F_Breath_Weapon"},
24450: {"AegisName":"S_F_Breath_Pendant"},
24451: {"AegisName":"S_F_Breath_Earing"},
24452: {"AegisName":"S_Cluster_Armor"},
24453: {"AegisName":"S_Cluster_Shield"},
24454: {"AegisName":"S_Cluster_Shoes"},
24455: {"AegisName":"S_Aimed_Weapon"},
24456: {"AegisName":"S_Aimed_Pendant"},
24457: {"AegisName":"S_Aimed_Earing"},
24458: {"AegisName":"S_Arrow_Armor"},
24459: {"AegisName":"S_Arrow_Shield"},
24460: {"AegisName":"S_Arrow_Shoes"},
24461: {"AegisName":"S_Shooting_Weapon"},
24462: {"AegisName":"S_Shooting_Pendant"},
24463: {"AegisName":"S_Shooting_Earing"},
24464: {"AegisName":"S_Tornado_Armor"},
24465: {"AegisName":"S_Tornado_Shield"},
24466: {"AegisName":"S_Tornado_Shoes"},
24467: {"AegisName":"S_Boomerang_Weapon"},
24468: {"AegisName":"S_Boomerang_Pendant"},
24469: {"AegisName":"S_Boomerang_Earing"},
24470: {"AegisName":"S_Vulcan_Armor"},
24471: {"AegisName":"S_Vulcan_Shield"},
24472: {"AegisName":"S_Vulcan_Shoes"},
24473: {"AegisName":"S_Arms_Weapon"},
24474: {"AegisName":"S_Arms_Pendant"},
24475: {"AegisName":"S_Arms_Earing"},
24476: {"AegisName":"S_Rampage_Armor"},
24477: {"AegisName":"S_Rampage_Shield"},
24478: {"AegisName":"S_Rampage_Shoes"},
24479: {"AegisName":"S_Skynetblow_Weapon"},
24480: {"AegisName":"S_Skynetblow_Pendant"},
24481: {"AegisName":"S_Skynetblow_Earing"},
24482: {"AegisName":"S_Knucklearrow_Armor"},
24483: {"AegisName":"S_Knucklearrow_Shield"},
24484: {"AegisName":"S_Knucklearrow_Shoes"},
24485: {"AegisName":"S_TigerCannon_Weapon"},
24486: {"AegisName":"S_Tigercannon_Pendant"},
24487: {"AegisName":"S_Tigercannon_Earing"},
24488: {"AegisName":"S_Duplelight_Armor"},
24489: {"AegisName":"S_Duplelight_Shield"},
24490: {"AegisName":"S_Duplelight_Shoes"},
24491: {"AegisName":"S_Adoramus_Weapon"},
24492: {"AegisName":"S_Adoramus_Pendant"},
24493: {"AegisName":"S_Adoramus_Earing"},
24494: {"AegisName":"S_Judex_Armor"},
24495: {"AegisName":"S_Judex_Shield"},
24496: {"AegisName":"S_Judex_Shoes"},
24497: {"AegisName":"S_Magnus_Weapon"},
24498: {"AegisName":"S_Magnus_Pendant"},
24499: {"AegisName":"S_Magnus_Earing"},
24500: {"AegisName":"S_Rainstorm_Armor"},
24501: {"AegisName":"S_Rainstorm_Shield"},
24502: {"AegisName":"S_Rainstorm_Shoes"},
24503: {"AegisName":"S_Arrowvulcan_Weapon"},
24504: {"AegisName":"S_Arrowvulcan_Pendant"},
24505: {"AegisName":"S_Arrowvulcan_Earing"},
24506: {"AegisName":"S_Metalic_Armor"},
24507: {"AegisName":"S_Metalic_Shield"},
24508: {"AegisName":"S_Metalic_Shoes"},
24509: {"AegisName":"S_Reverberation_Weapon"},
24510: {"AegisName":"S_Reverberation_Pendant"},
24511: {"AegisName":"S_Reverberation_Earing"},
24512: {"AegisName":"S_Jack_Armor"},
24513: {"AegisName":"S_Jack_Shield"},
24514: {"AegisName":"S_Jack_Shoes"},
24515: {"AegisName":"S_Strain_Weapon"},
24516: {"AegisName":"S_Strain_Pendant"},
24517: {"AegisName":"S_Strain_Earing"},
24518: {"AegisName":"S_Crimson_Armor"},
24519: {"AegisName":"S_Crimson_Shield"},
24520: {"AegisName":"S_Crimson_Shoes"},
24521: {"AegisName":"S_Chain_Weapon"},
24522: {"AegisName":"S_Chain_Pendant"},
24523: {"AegisName":"S_Chain_Earing"},
24524: {"AegisName":"S_Triangle_Armor"},
24525: {"AegisName":"S_Triangle_Shield"},
24526: {"AegisName":"S_Triangle_Shoes"},
24527: {"AegisName":"S_Shadowspell_Weapon"},
24528: {"AegisName":"S_Shadowspell_Pendant"},
24529: {"AegisName":"S_Shadowspell_Earing"},
24530: {"AegisName":"S_Menace_Armor"},
24531: {"AegisName":"S_Menace_Shield"},
24532: {"AegisName":"S_Menace_Shoes"},
24533: {"AegisName":"S_Paint_Weapon"},
24534: {"AegisName":"S_Paint_Pendant"},
24535: {"AegisName":"S_Paint_Earing"},
24536: {"AegisName":"S_Rolling_Armor"},
24537: {"AegisName":"S_Rolling_Shield"},
24538: {"AegisName":"S_Rolling_Shoes"},
24539: {"AegisName":"S_Katar_Weapon"},
24540: {"AegisName":"S_Katar_Pendant"},
24541: {"AegisName":"S_Katar_Earing"},
24542: {"AegisName":"S_Slash_Armor"},
24543: {"AegisName":"S_Slash_Shield"},
24544: {"AegisName":"S_Slash_Shoes"},
24545: {"AegisName":"S_Ripper_Weapon"},
24546: {"AegisName":"S_Ripper_Pendant"},
24547: {"AegisName":"S_Ripper_Earing"},
24548: {"AegisName":"S_Dust_Armor"},
24549: {"AegisName":"S_Dust_Shield"},
24550: {"AegisName":"S_Dust_Shoes"},
24551: {"AegisName":"S_Grave_Weapon"},
24552: {"AegisName":"S_Grave_Pendant"},
24553: {"AegisName":"S_Grave_Earing"},
24554: {"AegisName":"S_Psychic_Armor"},
24555: {"AegisName":"S_Psychic_Shield"},
24556: {"AegisName":"S_Psychic_Shoes"},
24557: {"AegisName":"S_Varetyr_Weapon"},
24558: {"AegisName":"S_Varetyr_Pendant"},
24559: {"AegisName":"S_Varetyr_Earing"},
24560: {"AegisName":"S_Cart_Tornado_Armor"},
24561: {"AegisName":"S_Cart_Tornado_Shield"},
24562: {"AegisName":"S_Cart_Tornado_Shoes"},
24563: {"AegisName":"S_Cannon_Cart_Weapon"},
24564: {"AegisName":"S_Cannon_Cart_Pendant"},
24565: {"AegisName":"S_Cannon_Cart_Earing"},
24566: {"AegisName":"S_Spore_Bomb_Armor"},
24567: {"AegisName":"S_Spore_Bomb_Shield"},
24568: {"AegisName":"S_Spore_Bomb_Shoes"},
24569: {"AegisName":"S_Crazy_Weapon"},
24570: {"AegisName":"S_Crazy_Pendant"},
24571: {"AegisName":"S_Crazy_Earing"},
24572: {"AegisName":"S_Brand_Armor"},
24573: {"AegisName":"S_Brand_Shield"},
24574: {"AegisName":"S_Brand_Shoes"},
24575: {"AegisName":"S_Chain_Press_Weapon"},
24576: {"AegisName":"S_Chain_Press_Pendant"},
24577: {"AegisName":"S_Chain_Press_Earing"},
24578: {"AegisName":"S_Banish_Cannon_Armor"},
24579: {"AegisName":"S_Banish_Cannon_Shield"},
24580: {"AegisName":"S_Banish_Cannon_Shoes"},
24581: {"AegisName":"S_Genesis_Weapon"},
24582: {"AegisName":"S_Genesis_Pendant"},
24583: {"AegisName":"S_Genesis_Earing"},
24584: {"AegisName":"S_Booster_Armor"},
24585: {"AegisName":"S_Booster_Shield"},
24586: {"AegisName":"S_Booster_Shoes"},
24587: {"AegisName":"S_Booster_Earing"},
24588: {"AegisName":"S_Booster_Pandent"},
24589: {"AegisName":"S_RK_B_Weapon"},
24590: {"AegisName":"S_LG_B_Weapon"},
24591: {"AegisName":"S_NC_B_Weapon"},
24592: {"AegisName":"S_GN_B_Weapon"},
24593: {"AegisName":"S_GC_B_Weapon"},
24594: {"AegisName":"S_SC_B_Weapon"},
24595: {"AegisName":"S_WL_B_Weapon"},
24596: {"AegisName":"S_SO_B_Weapon"},
24597: {"AegisName":"S_AB_B_Weapon"},
24598: {"AegisName":"S_SR_B_Weapon"},
24599: {"AegisName":"S_RA_B_Weapon"},
24600: {"AegisName":"S_WM_B_Weapon"},
24601: {"AegisName":"S_Tail_Dragon_Weapon"},
24602: {"AegisName":"S_Tail_Dragon_Shield"},
24603: {"AegisName":"S_Tail_Dragon_Armor"},
24604: {"AegisName":"S_Flare_Dance_Earing"},
24605: {"AegisName":"S_Flare_Dance_Pendant"},
24606: {"AegisName":"S_Flare_Dance_Shoes"},
24607: {"AegisName":"S_God_Hammer_Weapon"},
24608: {"AegisName":"S_God_Hammer_Shield"},
24609: {"AegisName":"S_God_Hammer_Armor"},
24610: {"AegisName":"S_Shatter_Buster_Earing"},
24611: {"AegisName":"S_Shatter_B_Pendant"},
24612: {"AegisName":"S_Shatter_Buster_Shoes"},
24613: {"AegisName":"S_Trip_Weapon"},
24614: {"AegisName":"S_Trip_Shield"},
24615: {"AegisName":"S_Trip_Armor"},
24616: {"AegisName":"S_Super_Magic_Shield"},
24617: {"AegisName":"S_Super_Magic_Armor"},
24618: {"AegisName":"S_Super_Magic_Shoes"},
24619: {"AegisName":"S_Super_Power_Weapon"},
24620: {"AegisName":"S_Super_Power_Pendant"},
24621: {"AegisName":"S_Super_Power_Earing"},
24622: {"AegisName":"S_Kunai_Weapon"},
24623: {"AegisName":"S_Kunai_Shield"},
24624: {"AegisName":"S_Kunai_Armor"},
24625: {"AegisName":"S_Syuriken_Earing"},
24626: {"AegisName":"S_Syuriken_Pendant"},
24627: {"AegisName":"S_Syuriken_Shoes"},
24628: {"AegisName":"S_Kamaenraku_Weapon"},
24629: {"AegisName":"S_Kamaenraku_Shield"},
24630: {"AegisName":"S_Kamaenraku_Armor"},
24631: {"AegisName":"S_Huusouka_Earing"},
24632: {"AegisName":"S_Huusouka_Pendant"},
24633: {"AegisName":"S_Huusouka_Shoes"},
24634: {"AegisName":"S_Pickyrush_Weapon"},
24635: {"AegisName":"S_Pickyrush_Shield"},
24636: {"AegisName":"S_Pickyrush_Armor"},
24637: {"AegisName":"S_SavageRabbit_Earing"},
24638: {"AegisName":"S_SavageRabbit_Pendant"},
24639: {"AegisName":"S_SavageRabbit_Shoes"},
24640: {"AegisName":"S_Catnip_Weapon"},
24641: {"AegisName":"S_Catnip_Shield"},
24642: {"AegisName":"S_Catnip_Armor"},
24643: {"AegisName":"S_Silvervine_Earing"},
24644: {"AegisName":"S_Silvervine_Pendant"},
24645: {"AegisName":"S_Silvervine_Shoes"},
24646: {"AegisName":"S_Sunshine_Weapon"},
24647: {"AegisName":"S_Sunshine_Shield"},
24648: {"AegisName":"S_Sunshine_Armor"},
24649: {"AegisName":"S_Moonlight_Earring"},
24650: {"AegisName":"S_Moonlight_Pendant"},
24651: {"AegisName":"S_Moonlight_Shoes"},
24652: {"AegisName":"S_Stardust_Weapon"},
24653: {"AegisName":"S_Stardust_Shield"},
24654: {"AegisName":"S_Stardust_Armor"},
24655: {"AegisName":"S_S_Weapon"},
24656: {"AegisName":"S_S_Shield"},
24657: {"AegisName":"S_S_Armor"},
24658: {"AegisName":"S_Evilcurse_Earring"},
24659: {"AegisName":"S_Evilcurse_Pendant"},
24660: {"AegisName":"S_Evilcurse_Shoes"},
24661: {"AegisName":"S_FullPene_Earring"},
24662: {"AegisName":"S_FullPene_Pendant"},
24663: {"AegisName":"S_FullPene_Armor"},
24664: {"AegisName":"S_FullPene_Shoes"},
24665: {"AegisName":"S_FullTemp_Earring"},
24666: {"AegisName":"S_FullTemp_Shoes"},
24667: {"AegisName":"S_FullTemp_Armor"},
24668: {"AegisName":"S_FullTemp_Pendant"},
24669: {"AegisName":"S_Mammoth_Armor"},
24670: {"AegisName":"S_Mammoth_Shoes"},
24671: {"AegisName":"S_Mammoth_Pendant"},
24672: {"AegisName":"S_Mammoth_Earring"},
24673: {"AegisName":"S_Mammoth_Weapon"},
24674: {"AegisName":"S_Mammoth_Shield"},
24675: {"AegisName":"S_TrueGem_Armor"},
24676: {"AegisName":"S_TrueGem_Shoes"},
24677: {"AegisName":"S_TrueGem_Earring"},
24678: {"AegisName":"S_TrueGem_Pendant"},
24679: {"AegisName":"S_M_Mammoth_Armor"},
24680: {"AegisName":"S_M_Mammoth_Shoes"},
24681: {"AegisName":"S_M_Mammoth_Earring"},
24682: {"AegisName":"S_M_Mammoth_Pendant"},
24683: {"AegisName":"S_EXP_Shield"},
24684: {"AegisName":"S_SNV_Weapon"},
24685: {"AegisName":"S_Absorb_Shield"},
24686: {"AegisName":"S_Absorb_Weapon"},
24687: {"AegisName":"S_1Para_Weapon"},
24688: {"AegisName":"S_1Para_Shield"},
24689: {"AegisName":"S_1Para_Armor"},
24690: {"AegisName":"S_1Para_Shoes"},
24691: {"AegisName":"S_1Para_Earing"},
24692: {"AegisName":"S_1Para_Pendant"},
24693: {"AegisName":"S_2Para_Shield"},
24694: {"AegisName":"S_2Para_Armor"},
24695: {"AegisName":"S_2Para_Shoes"},
24696: {"AegisName":"S_2Para_Earing"},
24697: {"AegisName":"S_2Para_Pendant"},
24698: {"AegisName":"S_2Para_RK_Weapon"},
24699: {"AegisName":"S_2Para_LG_Weapon"},
24700: {"AegisName":"S_2Para_NC_Weapon"},
24701: {"AegisName":"S_2Para_GN_Weapon"},
24702: {"AegisName":"S_2Para_GC_Weapon"},
24703: {"AegisName":"S_2Para_SC_Weapon"},
24704: {"AegisName":"S_2Para_WL_Weapon"},
24705: {"AegisName":"S_2Para_SO_Weapon"},
24706: {"AegisName":"S_2Para_AB_Weapon"},
24707: {"AegisName":"S_2Para_SR_Weapon"},
24708: {"AegisName":"S_2Para_RA_Weapon"},
24709: {"AegisName":"S_2Para_WM_Weapon"},
24710: {"AegisName":"S_2Para_KO_Weapon"},
24711: {"AegisName":"S_2Para_RL_Weapon"},
24712: {"AegisName":"S_2Para_SJ_Weapon"},
24713: {"AegisName":"S_2Para_SP_Weapon"},
24714: {"AegisName":"S_2Para_SU_Weapon"},
24715: {"AegisName":"S_2Para_NV_Weapon"},
24722: {"AegisName":"S_AutoSpell_Shield"},
24723: {"AegisName":"S_AutoSpell_Armor"},
24724: {"AegisName":"S_AutoSpell_Shoes"},
24725: {"AegisName":"S_AutoSpell_Weapon"},
24726: {"AegisName":"S_AutoSpell_Pendant"},
24727: {"AegisName":"S_AutoSpell_Earring"},
24728: {"AegisName":"S_M_AutoSpell_Armor"},
24729: {"AegisName":"S_M_AutoSpell_Shoes"},
24730: {"AegisName":"S_M_AutoSpell_Earring"},
24731: {"AegisName":"S_M_AutoSpell_Pendant"},
24732: {"AegisName":"S_Hasty_Shield"},
24733: {"AegisName":"S_Infinity_Shield"},
24734: {"AegisName":"S_Durable_Weapon"},
24735: {"AegisName":"S_Durable_Shield"},
24736: {"AegisName":"S_Clever_Weapon"},
24737: {"AegisName":"S_Clever_Shield"},
24738: {"AegisName":"S_CriticalHit_Weapon"},
24739: {"AegisName":"S_SU_Weapon"},
24740: {"AegisName":"S_SJ_Weapon"},
24741: {"AegisName":"S_KO_Weapon"},
24742: {"AegisName":"S_RL_Weapon"},
24743: {"AegisName":"S_SP_Weapon"},
24744: {"AegisName":"S_NV_Weapon"},
24745: {"AegisName":"S_KingbirdAnc_Weapon"},
24746: {"AegisName":"S_S_Reload_Shield"},
24747: {"AegisName":"S_SpellCaster_Armor"},
24748: {"AegisName":"S_SpellCaster_Shoes"},
24749: {"AegisName":"S_SpellCaster_Earring"},
24750: {"AegisName":"S_SpellCaster_Pendant"},
24751: {"AegisName":"S_P_Power_Weapon"},
24752: {"AegisName":"S_P_Power_Shield"},
24753: {"AegisName":"S_M_Spell_Weapon"},
24754: {"AegisName":"S_M_Spell_Shield"},
24755: {"AegisName":"S_Concentration_Weapon"},
24756: {"AegisName":"S_Concentration_Shield"},
24757: {"AegisName":"S_Wisdom_Weapon"},
24758: {"AegisName":"S_Wisdom_Shield"},
24759: {"AegisName":"S_Stamina_Weapon"},
24760: {"AegisName":"S_Stamina_Shield"},
24761: {"AegisName":"S_Creative_Weapon"},
24762: {"AegisName":"S_Creative_Shield"},
24763: {"AegisName":"S_R_Bearers_Shoes"},
24764: {"AegisName":"S_R_Bearers_Armor"},
24765: {"AegisName":"S_R_Bearers_Pendant"},
24766: {"AegisName":"S_R_Bearers_Earring"},
24767: {"AegisName":"S_Mega_Blitz_Shield"},
24768: {"AegisName":"S_Mega_Blitz_Weapon"},
24770: {"AegisName":"S_EXP_Weapon"},
24778: {"AegisName":"aegis_24778"},
24779: {"AegisName":"aegis_24779"},
24780: {"AegisName":"aegis_24780"},
24781: {"AegisName":"aegis_24781"},
24782: {"AegisName":"aegis_24782"},
24783: {"AegisName":"aegis_24783"},
24792: {"AegisName":"S_Master_Weapon"},
24793: {"AegisName":"S_Master_Shield"},
24800: {"AegisName":"S_DK_Armor"},
24801: {"AegisName":"S_DK_Shoes"},
24802: {"AegisName":"S_DK_Earring"},
24803: {"AegisName":"S_DK_Pendant"},
24804: {"AegisName":"S_IG_Armor"},
24805: {"AegisName":"S_IG_Shoes"},
24806: {"AegisName":"S_IG_Earring"},
24807: {"AegisName":"S_IG_Pendant"},
24808: {"AegisName":"S_SHC_Armor"},
24809: {"AegisName":"S_SHC_Shoes"},
24810: {"AegisName":"S_SHC_Earring"},
24811: {"AegisName":"S_SHC_Pendant"},
24812: {"AegisName":"S_ABC_Armor"},
24813: {"AegisName":"S_ABC_Shoes"},
24814: {"AegisName":"S_ABC_Earring"},
24815: {"AegisName":"S_ABC_Pendant"},
24816: {"AegisName":"S_CD_Armor"},
24817: {"AegisName":"S_CD_Shoes"},
24818: {"AegisName":"S_CD_Earring"},
24819: {"AegisName":"S_CD_Pendant"},
24820: {"AegisName":"S_IQ_Armor"},
24821: {"AegisName":"S_IQ_Shoes"},
24822: {"AegisName":"S_IQ_Earring"},
24823: {"AegisName":"S_IQ_Pendant"},
24824: {"AegisName":"S_MT_Armor"},
24825: {"AegisName":"S_MT_Shoes"},
24826: {"AegisName":"S_MT_Earring"},
24827: {"AegisName":"S_MT_Pendant"},
24828: {"AegisName":"S_BO_Armor"},
24829: {"AegisName":"S_BO_Shoes"},
24830: {"AegisName":"S_BO_Earring"},
24831: {"AegisName":"S_BO_Pendant"},
24832: {"AegisName":"S_WH_Armor"},
24833: {"AegisName":"S_WH_Shoes"},
24834: {"AegisName":"S_WH_Earring"},
24835: {"AegisName":"S_WH_Pendant"},
24836: {"AegisName":"S_TR_Armor"},
24837: {"AegisName":"S_TR_Shoes"},
24838: {"AegisName":"S_TR_Earring"},
24839: {"AegisName":"S_TR_Pendant"},
24840: {"AegisName":"S_AG_Armor"},
24841: {"AegisName":"S_AG_Shoes"},
24842: {"AegisName":"S_AG_Earring"},
24843: {"AegisName":"S_AG_Pendant"},
24844: {"AegisName":"S_EM_Armor"},
24845: {"AegisName":"S_EM_Shoes"},
24846: {"AegisName":"S_EM_Earring"},
24847: {"AegisName":"S_EM_Pendant"},
24848: {"AegisName":"S_NW_Armor"},
24849: {"AegisName":"S_NW_Shoes"},
24850: {"AegisName":"S_NW_Earring"},
24851: {"AegisName":"S_NW_Pendant"},
24852: {"AegisName":"S_SH_Armor"},
24853: {"AegisName":"S_SH_Shoes"},
24854: {"AegisName":"S_SH_Earring"},
24855: {"AegisName":"S_SH_Pendant"},
24856: {"AegisName":"S_SS_Armor"},
24857: {"AegisName":"S_SS_Shoes"},
24858: {"AegisName":"S_SS_Earring"},
24859: {"AegisName":"S_SS_Pendant"},
24860: {"AegisName":"S_SKE_Armor"},
24861: {"AegisName":"S_SKE_Shoes"},
24862: {"AegisName":"S_SKE_Earring"},
24863: {"AegisName":"S_SKE_Pendant"},
24864: {"AegisName":"S_SOA_Armor"},
24865: {"AegisName":"S_SOA_Shoes"},
24866: {"AegisName":"S_SOA_Earring"},
24867: {"AegisName":"S_SOA_Pendant"},
24868: {"AegisName":"S_HN_Armor"},
24869: {"AegisName":"S_HN_Shoes"},
24870: {"AegisName":"S_HN_Earring"},
24871: {"AegisName":"S_HN_Pendant"},
24872: {"AegisName":"S_Full_Power_Armor"},
24873: {"AegisName":"S_Full_Power_Shoes"},
24874: {"AegisName":"S_Full_Rate_Armor"},
24875: {"AegisName":"S_Full_Rate_Shoes"},
24876: {"AegisName":"S_Focusing_Pendant"},
24877: {"AegisName":"S_Focusing_Earring"},
24878: {"AegisName":"S_Stout_Pendant"},
24879: {"AegisName":"S_Stout_Earring"},
24883: {"AegisName":"S_Full_Spell_Armor"},
24884: {"AegisName":"S_Full_Spell_Shoes"},
24885: {"AegisName":"S_Centering_Pendant"},
24886: {"AegisName":"S_Centering_Earring"},
24887: {"AegisName":"S_Witty_Pendant"},
24888: {"AegisName":"S_Witty_Earring"},
24906: {"AegisName":"S_SHC_EC_Earring"},
24907: {"AegisName":"S_SHC_EC_Pendant"},
24908: {"AegisName":"S_SHC_SI_Armor"},
24909: {"AegisName":"S_SHC_SI_Shoes"},
24910: {"AegisName":"S_WH_GS_Earring"},
24911: {"AegisName":"S_WH_GS_Pendant"},
24912: {"AegisName":"S_WH_CB_Armor"},
24913: {"AegisName":"S_WH_CB_Shoes"},
24914: {"AegisName":"S_SS_SR_Earring"},
24915: {"AegisName":"S_SS_SR_Pendant"},
24916: {"AegisName":"S_SS_KR_Armor"},
24917: {"AegisName":"S_SS_KR_Shoes"},
24918: {"AegisName":"S_DK_SS_Earring"},
24919: {"AegisName":"S_DK_SS_Pendant"},
24920: {"AegisName":"S_DK_HS_Armor"},
24921: {"AegisName":"S_DK_HS_Shoes"},
24922: {"AegisName":"S_TR_RW_Earring"},
24923: {"AegisName":"S_TR_RW_Pendant"},
24924: {"AegisName":"S_TR_MF_Armor"},
24925: {"AegisName":"S_TR_MF_Shoes"},
24926: {"AegisName":"S_NW_SO_Earring"},
24927: {"AegisName":"S_NW_SO_Pendant"},
24928: {"AegisName":"S_NW_WB_Armor"},
24929: {"AegisName":"S_NW_WB_Shoes"},
24936: {"AegisName":"S_MT_MS_Earring"},
24937: {"AegisName":"S_MT_MS_Pendant"},
24938: {"AegisName":"S_MT_PR_Armor"},
24939: {"AegisName":"S_MT_PR_Shoes"},
24940: {"AegisName":"S_BO_EP_Earring"},
24941: {"AegisName":"S_BO_EP_Pendant"},
24942: {"AegisName":"S_BO_MD_Armor"},
24943: {"AegisName":"S_BO_MD_Shoes"},
24944: {"AegisName":"S_HN_VJ_Earring"},
24945: {"AegisName":"S_HN_VJ_Pendant"},
24946: {"AegisName":"S_HN_TB_Armor"},
24947: {"AegisName":"S_HN_TB_Shoes"},
24948: {"AegisName":"S_IG_OC_Earring"},
24949: {"AegisName":"S_IG_OC_Pendant"},
24950: {"AegisName":"S_IG_RF_Armor"},
24951: {"AegisName":"S_IG_RF_Shoes"},
24952: {"AegisName":"S_IQ_EB_Earring"},
24953: {"AegisName":"S_IQ_EB_Pendant"},
24954: {"AegisName":"S_IQ_BFB_Armor"},
24955: {"AegisName":"S_IQ_BFB_Shoes"},
24956: {"AegisName":"S_SU_CS_Earring"},
24957: {"AegisName":"S_SU_CS_Pendant"},
24958: {"AegisName":"S_SU_HB_Armor"},
24959: {"AegisName":"S_SU_HB_Shoes"},
24967: {"AegisName":"S_CD_AR_Earring"},
24968: {"AegisName":"S_CD_AR_Pendant"},
24969: {"AegisName":"S_CD_DF_Armor"},
24970: {"AegisName":"S_CD_DF_Shoes"},
24971: {"AegisName":"S_AG_FB_Earring"},
24972: {"AegisName":"S_AG_FB_Pendant"},
24973: {"AegisName":"S_AG_SH_Armor"},
24974: {"AegisName":"S_AG_SH_Shoes"},
24975: {"AegisName":"S_SKE_NS_Earring"},
24976: {"AegisName":"S_SKE_NS_Pendant"},
24977: {"AegisName":"S_SKE_SB_Armor"},
24978: {"AegisName":"S_SKE_SB_Shoes"},
24979: {"AegisName":"S_EM_CO_Earring"},
24980: {"AegisName":"S_EM_CO_Pendant"},
24981: {"AegisName":"S_EM_LS_Armor"},
24982: {"AegisName":"S_EM_LS_Shoes"},
24983: {"AegisName":"S_ABC_AF_Earring"},
24984: {"AegisName":"S_ABC_AF_Pendant"},
24985: {"AegisName":"S_ABC_FA_Armor"},
24986: {"AegisName":"S_ABC_FA_Shoes"},
24987: {"AegisName":"S_SOA_TOWB_Earring"},
24988: {"AegisName":"S_SOA_TOWB_Pendant"},
24989: {"AegisName":"S_SOA_TOFG_Armor"},
24990: {"AegisName":"S_SOA_TOFG_Shoes"},
24993: {"AegisName":"S_Magical_M_Armor"},
24994: {"AegisName":"S_Magical_M_Shoes"},
24995: {"AegisName":"S_Magical_M_Earring"},
24996: {"AegisName":"S_Magical_M_Pendant"},
24997: {"AegisName":"S_Spell_M_Armor"},
24998: {"AegisName":"S_Spell_M_Shoes"},
24999: {"AegisName":"S_Spell_M_Earring"},
25000: {"AegisName":"SPdrainStone_Top"},
25001: {"AegisName":"DEFStone_Middle"},
25002: {"AegisName":"ChangeLUK_Middle"},
25003: {"AegisName":"ChangeSTR_Middle"},
25004: {"AegisName":"ChangeAGI_Middle"},
25005: {"AegisName":"ChangeINT_Middle"},
25006: {"AegisName":"ChangeVIT_Middle"},
25007: {"AegisName":"ChangeDEX_Middle"},
25008: {"AegisName":"ChangeVIT_Bottom"},
25009: {"AegisName":"ChangeAGI_Bottom"},
25010: {"AegisName":"ChangeDEX_Bottom"},
25011: {"AegisName":"ChangeLUK_Bottom"},
25012: {"AegisName":"ChangeSTR_Bottom"},
25013: {"AegisName":"ChangeINT_Bottom"},
25014: {"AegisName":"MDEFStone_Bottom"},
25015: {"AegisName":"EXPStone_Bottom"},
25016: {"AegisName":"ATKStone_Bottom"},
25017: {"AegisName":"MATKStone_Bottom"},
25038: {"AegisName":"Breaked_Trap"},
25039: {"AegisName":"Captured_Trap"},
25041: {"AegisName":"Pump_Of_Spirit"},
25042: {"AegisName":"Service_30_Egg_Shell"},
25043: {"AegisName":"Thorn_Vines_Pipe"},
25044: {"AegisName":"Hard_Thorn_Vines"},
25045: {"AegisName":"High_Quality_Cloth"},
25046: {"AegisName":"Embark_Warrant"},
25047: {"AegisName":"Carlou_Nyac"},
25048: {"AegisName":"Full_Lunch"},
25049: {"AegisName":"Basil_Rac"},
25051: {"AegisName":"Union_Token"},
25058: {"AegisName":"TwinkleEffect_Top"},
25059: {"AegisName":"GhostEffect_Middle"},
25060: {"AegisName":"Critical_Stone"},
25061: {"AegisName":"Range_Stone"},
25062: {"AegisName":"Greed_Stone"},
25063: {"AegisName":"MaxHP2_Stone"},
25064: {"AegisName":"MaxSP2_Stone"},
25065: {"AegisName":"Detoxify_Stone"},
25066: {"AegisName":"Recovery_Stone"},
25067: {"AegisName":"CastingStone_Robe"},
25068: {"AegisName":"ASPDStone_Top"},
25069: {"AegisName":"ReloadStone_Top"},
25070: {"AegisName":"ReloadStone_Middle"},
25071: {"AegisName":"ReloadStone_Bottom"},
25072: {"AegisName":"Kyrie_Stone"},
25073: {"AegisName":"Worn_Out_Papyrus"},
25074: {"AegisName":"Antique_Coin"},
25075: {"AegisName":"Sword_Of_Admiral"},
25076: {"AegisName":"QouSeraSera"},
25077: {"AegisName":"KnightsSupply"},
25078: {"AegisName":"Liqueur_Of_Lotus"},
25079: {"AegisName":"FaintBreathing"},
25080: {"AegisName":"FoxBeads"},
25083: {"AegisName":"MRabbit_SHair"},
25084: {"AegisName":"Captured_MRabbit"},
25085: {"AegisName":"MRabbit_Hair"},
25086: {"AegisName":"Gift_Wrapping_Ribbon"},
25087: {"AegisName":"Old_Doll"},
25088: {"AegisName":"Dream_Piece"},
25089: {"AegisName":"Gift_Wrapping_Wing"},
25098: {"AegisName":"Jobmap_1st"},
25099: {"AegisName":"Jobmap_su"},
25100: {"AegisName":"Jobmap_sword"},
25101: {"AegisName":"Jobmap_magic"},
25102: {"AegisName":"Jobmap_Merch"},
25103: {"AegisName":"Jobmap_acol"},
25104: {"AegisName":"Jobmap_thief"},
25105: {"AegisName":"Jobmap_archer"},
25106: {"AegisName":"Jobmap_taekwon"},
25107: {"AegisName":"Jobmap_rune"},
25108: {"AegisName":"Jobmap_royal"},
25109: {"AegisName":"Jobmap_war"},
25110: {"AegisName":"Jobmap_socer"},
25111: {"AegisName":"Jobmap_mecha"},
25112: {"AegisName":"Jobmap_gene"},
25113: {"AegisName":"Jobmap_bishop"},
25114: {"AegisName":"Jobmap_sura"},
25115: {"AegisName":"Jobmap_cross"},
25116: {"AegisName":"Jobmap_chaser"},
25117: {"AegisName":"Jobmap_ranger"},
25118: {"AegisName":"Jobmap_mins"},
25119: {"AegisName":"Jobmap_wander"},
25120: {"AegisName":"Jobmap_ninja"},
25121: {"AegisName":"Jobmap_gun"},
25122: {"AegisName":"Jobmap_super2"},
25123: {"AegisName":"Jobmap_karma2"},
25127: {"AegisName":"Particles_Of_Energy1"},
25128: {"AegisName":"Particles_Of_Energy2"},
25129: {"AegisName":"Particles_Of_Energy3"},
25130: {"AegisName":"Particles_Of_Energy4"},
25131: {"AegisName":"Particles_Of_Energy5"},
25132: {"AegisName":"Pumpkin_Decorations"},
25133: {"AegisName":"Dry_White_Stem"},
25135: {"AegisName":"Comp_Auger_Of_Spirit"},
25136: {"AegisName":"ElectricEffect_Middle"},
25137: {"AegisName":"GreenFloor_Bottom"},
25138: {"AegisName":"ShrinkEffect_Middle"},
25139: {"AegisName":"Identify_Stone"},
25140: {"AegisName":"Resurrection_Stone"},
25141: {"AegisName":"EXPStone_Middle"},
25142: {"AegisName":"DoramToken"},
25143: {"AegisName":"Gift_Stuffed_Doll"},
25144: {"AegisName":"Bridge_Stuffed_Doll"},
25145: {"AegisName":"Burned_Specter_Doll"},
25146: {"AegisName":"Relentless_Queen_Doll"},
25147: {"AegisName":"Meal_Done_Ribbit_Doll"},
25148: {"AegisName":"Cute_Eat_Machine_Doll"},
25149: {"AegisName":"Hot_Muffler_Doll"},
25150: {"AegisName":"Alice_Hug_Pillow"},
25151: {"AegisName":"Rachels_Revolver"},
25152: {"AegisName":"Cherish_Bouquet"},
25153: {"AegisName":"Broken_Gun_Wreck"},
25154: {"AegisName":"Antique_Powder"},
25155: {"AegisName":"Swz_Honor_Token"},
25156: {"AegisName":"Piece_Of_Chimera"},
25157: {"AegisName":"Fallen_Leaves_Branch"},
25158: {"AegisName":"Core_Jelly"},
25159: {"AegisName":"Heart_Hunter_Seal"},
25160: {"AegisName":"Borrow_Book"},
25161: {"AegisName":"Handmade_cookie2"},
25162: {"AegisName":"Anchovy_cookie"},
25163: {"AegisName":"Arms_Shop_AD"},
25164: {"AegisName":"Fresh_Tea_Leaves"},
25165: {"AegisName":"High_Class_Tea"},
25166: {"AegisName":"Very_Shining_Ring"},
25167: {"AegisName":"Old_Letter"},
25169: {"AegisName":"Sticky_Slime"},
25170: {"AegisName":"MinorCastingStone_Robe"},
25171: {"AegisName":"EXPStone_Top"},
25172: {"AegisName":"CastingStone_Top"},
25173: {"AegisName":"CastingStone_Middle"},
25174: {"AegisName":"CastingStone_Bottom"},
25175: {"AegisName":"LexAeternaStone_Middle"},
25176: {"AegisName":"BlueAuraEffect_Middle"},
25177: {"AegisName":"ShadowEffect_Middle"},
25178: {"AegisName":"PinkGlowEffect_Middle"},
25179: {"AegisName":"Blessing_Star"},
25180: {"AegisName":"Old_Couple_Ring"},
25181: {"AegisName":"Wood_Rosary"},
25182: {"AegisName":"Assassin_PT_Dagger"},
25183: {"AegisName":"Deco_Thimble_Archer"},
25184: {"AegisName":"Portable_Sewingbox"},
25185: {"AegisName":"Locket_Pendant"},
25187: {"AegisName":"Slug_Bullet"},
25188: {"AegisName":"Handkerchief_of_Girl"},
25200: {"AegisName":"Cloud_Fluff"},
25201: {"AegisName":"Arcane_Toenail"},
25205: {"AegisName":"ShrinkEffect_Bottom"},
25206: {"AegisName":"ElectricEffect_Top"},
25207: {"AegisName":"Upg_SPdrainStone_Top"},
25208: {"AegisName":"Upg_SPdrainStone_Robe"},
25209: {"AegisName":"Upg_HPdrainStone_Robe"},
25210: {"AegisName":"Upg_HPdrainStone_Top"},
25212: {"AegisName":"Coagulated_Blood"},
25218: {"AegisName":"Tree_Branches"},
25219: {"AegisName":"WindowPaper"},
25220: {"AegisName":"Moonlight_KiteString"},
25221: {"AegisName":"MoonScent_Tree_Branches"},
25222: {"AegisName":"MoonPattern_WindowPaper"},
25223: {"AegisName":"Para_Team_Coin"},
25224: {"AegisName":"WhiteBodyEffect_Middle"},
25225: {"AegisName":"ExplodingEffect_Middle"},
25226: {"AegisName":"WaterFieldEffect_Bottom"},
25227: {"AegisName":"Heal_Stone"},
25228: {"AegisName":"Teleport_Stone"},
25229: {"AegisName":"Steal_Stone"},
25231: {"AegisName":"Suspicious_Bottle"},
25232: {"AegisName":"Cheap_Lubricant"},
25233: {"AegisName":"Wad_Of_Cotton"},
25235: {"AegisName":"StoneForWork"},
25238: {"AegisName":"General_Lubricant_"},
25239: {"AegisName":"High_RankLubricant_"},
25240: {"AegisName":"Independence_Permit"},
25245: {"AegisName":"Little_Skel_Bone"},
25246: {"AegisName":"Juice_Package"},
25247: {"AegisName":"Violet_Stone"},
25248: {"AegisName":"Violet_Stone_Box"},
25249: {"AegisName":"Mane_Of_Cow"},
25250: {"AegisName":"Coin_Of_Rr"},
25251: {"AegisName":"Fermented_Grapes"},
25252: {"AegisName":"Sprig_Of_Holly"},
25253: {"AegisName":"Sugar_Box"},
25254: {"AegisName":"Firewood"},
25256: {"AegisName":"HazyDream"},
25257: {"AegisName":"Bloody_LoveLetter"},
25258: {"AegisName":"BrokenArrow"},
25259: {"AegisName":"SubjugationFlyer"},
25260: {"AegisName":"Violet_Stone_Chip"},
25261: {"AegisName":"Torn_Diary"},
25262: {"AegisName":"Dried_Clover"},
25263: {"AegisName":"Short_Bat_Fur"},
25264: {"AegisName":"NightmareOfLump"},
25265: {"AegisName":"Shining_Spore"},
25266: {"AegisName":"Dried_Leaf_Of_Ygg"},
25267: {"AegisName":"SuspiciousMagicCircle"},
25268: {"AegisName":"Sticky_Blood"},
25269: {"AegisName":"Mushroom_Sap"},
25270: {"AegisName":"Swaying_Mane"},
25271: {"AegisName":"IllusionStone"},
25272: {"AegisName":"IllusoryStone"},
25273: {"AegisName":"Mysterious_Medal"},
25274: {"AegisName":"Racing_Thx_Ticket"},
25276: {"AegisName":"CleanBone"},
25277: {"AegisName":"DeadlyPoisonPowder"},
25278: {"AegisName":"BanditsScarf"},
25279: {"AegisName":"CrudeAmmo"},
25280: {"AegisName":"BrokenShotgun"},
25281: {"AegisName":"CrudeScimiter"},
25282: {"AegisName":"WornRevolver"},
25283: {"AegisName":"BrownMuffler"},
25284: {"AegisName":"SwampBugPeelings"},
25285: {"AegisName":"BrownRatTail"},
25286: {"AegisName":"Octo_Octo_Fluid"},
25287: {"AegisName":"Mysterious_Feather"},
25290: {"AegisName":"Sweets_Coin"},
25291: {"AegisName":"Fac_Choco"},
25292: {"AegisName":"Stolen_Cacao"},
25294: {"AegisName":"Clover_Ticket"},
25295: {"AegisName":"Happiness_Clover"},
25296: {"AegisName":"Fatal_Thing"},
25297: {"AegisName":"Frozen_PieceOfRock"},
25298: {"AegisName":"SpritJewel"},
25299: {"AegisName":"Snowball"},
25300: {"AegisName":"KTULLANUXsEye"},
25302: {"AegisName":"DoubleAttack_Stone"},
25303: {"AegisName":"Critical_Stone_Robe"},
25304: {"AegisName":"Critical_Stone_Top"},
25305: {"AegisName":"Critical_Stone_Bottom"},
25306: {"AegisName":"CastStone_Robe"},
25307: {"AegisName":"Private_M_Ticket"},
25308: {"AegisName":"Cash_Can"},
25309: {"AegisName":"Dry_Branch"},
25310: {"AegisName":"DF_Token_Of_Siegfried"},
25311: {"AegisName":"PieceOfBlackSpirit"},
25312: {"AegisName":"OldDoll"},
25313: {"AegisName":"OldShell"},
25314: {"AegisName":"ShipsLog"},
25315: {"AegisName":"Piece_Of_Shell"},
25316: {"AegisName":"Shabby_Metal_Chip"},
25318: {"AegisName":"Dalcom_Skin"},
25319: {"AegisName":"Ice_Box"},
25320: {"AegisName":"Suspicious_Melon"},
25340: {"AegisName":"Golden_Corn"},
25341: {"AegisName":"Red_Hot_Marble"},
25342: {"AegisName":"Healthful_Herb"},
25344: {"AegisName":"Flat_Round_Stone"},
25358: {"AegisName":"Retrieve_Datacard"},
25359: {"AegisName":"Slightly_Old_Bax"},
25360: {"AegisName":"Receipt"},
25365: {"AegisName":"Thin_Noodle"},
25366: {"AegisName":"Noodle_Festa_Coupon"},
25367: {"AegisName":"Promotion_Fan"},
25375: {"AegisName":"Mightysoul_Essence"},
25376: {"AegisName":"Pet_Coin"},
25377: {"AegisName":"High_Class_Pet_food"},
25378: {"AegisName":"Hardly_Sealed_Letter"},
25379: {"AegisName":"Hardly_Sealed_Letter2"},
25380: {"AegisName":"DragonMustacheNoodle"},
25381: {"AegisName":"Breath_Fired_Dumpling"},
25382: {"AegisName":"Dragon_Head_Cookie"},
25383: {"AegisName":"Dragon_Mustache_Candy"},
25390: {"AegisName":"Captured_Savage"},
25391: {"AegisName":"Goodly_Bough"},
25392: {"AegisName":"Free_Pass_Ticket"},
25393: {"AegisName":"Delicious_Corn"},
25394: {"AegisName":"Fruit_Lunch"},
25395: {"AegisName":"Small_Embers"},
25401: {"AegisName":"Black_Fur"},
25408: {"AegisName":"Memory_Of_Gyol"},
25409: {"AegisName":"SuraStone_Top"},
25410: {"AegisName":"SuraStone_Middle"},
25411: {"AegisName":"SuraStone_Bottom"},
25412: {"AegisName":"SuraStone_Robe"},
25413: {"AegisName":"RangerStone_Top"},
25414: {"AegisName":"RangerStone_Middle"},
25415: {"AegisName":"RangerStone_Bottom"},
25416: {"AegisName":"RangerStone_Robe"},
25417: {"AegisName":"SorcererStone_Top"},
25418: {"AegisName":"SorcererStone_Middle"},
25419: {"AegisName":"SorcererStone_Bottom"},
25420: {"AegisName":"SorcererStone_Robe"},
25421: {"AegisName":"Pumpkin_Decor"},
25422: {"AegisName":"White_Thin_Stem"},
25425: {"AegisName":"SnowFlower_Of_Spell"},
25426: {"AegisName":"Warm_Cotton"},
25427: {"AegisName":"Rebeginer_W_Coupon"},
25428: {"AegisName":"Rebeginer_W_7Up"},
25445: {"AegisName":"RuneknightStone_Top"},
25446: {"AegisName":"RuneknightStone_Middle"},
25447: {"AegisName":"RuneknightStone_Bottom"},
25448: {"AegisName":"RuneknightStone_Robe"},
25449: {"AegisName":"GeneticStone_Robe"},
25450: {"AegisName":"GeneticStone_Top"},
25451: {"AegisName":"GeneticStone_Middle"},
25452: {"AegisName":"GeneticStone_Bottom"},
25453: {"AegisName":"WarlockStone_Top"},
25454: {"AegisName":"WarlockStone_Middle"},
25455: {"AegisName":"WarlockStone_Bottom"},
25456: {"AegisName":"WarlockStone_Robe"},
25461: {"AegisName":"Special_Tool_Box_Coupon"},
25464: {"AegisName":"World_Tour_Ticket"},
25479: {"AegisName":"Dogly_Bottle"},
25482: {"AegisName":"Earth_Card_BZ"},
25483: {"AegisName":"Fire_Card_BZ"},
25484: {"AegisName":"Water_Card_BZ"},
25485: {"AegisName":"Wind_Card_BZ"},
25486: {"AegisName":"Fire_Badge_BZ"},
25487: {"AegisName":"Water_Badge_BZ"},
25488: {"AegisName":"Wind_Badge_BZ"},
25489: {"AegisName":"Earth_Badge_BZ"},
25490: {"AegisName":"ShadowchaserStone_Top"},
25491: {"AegisName":"ShadowchaseStone_Middle"},
25492: {"AegisName":"ShadowchaseStone_Bottom"},
25493: {"AegisName":"ShadowchaserStone_Robe"},
25494: {"AegisName":"MechanicStone_Top"},
25495: {"AegisName":"MechanicStone_Middle"},
25496: {"AegisName":"MechanicStone_Bottom"},
25497: {"AegisName":"MechanicStone_Robe"},
25498: {"AegisName":"WanderMinstrelStone_Top"},
25499: {"AegisName":"WanderMinstStone_Middle"},
25500: {"AegisName":"WanderMinstStone_Bottom"},
25501: {"AegisName":"WanderMinstreStone_Robe"},
25502: {"AegisName":"EVT_JAN01KR"},
25503: {"AegisName":"Flower_V"},
25504: {"AegisName":"Visionary_Ticket"},
25505: {"AegisName":"Jokers_Wild"},
25506: {"AegisName":"Cute_Broom"},
25507: {"AegisName":"Showy_Coral_Reef"},
25508: {"AegisName":"Token_of_OrcGeneral"},
25509: {"AegisName":"Shining_Round_Shell"},
25511: {"AegisName":"Evt_March04_KR"},
25512: {"AegisName":"Evt_March05_KR"},
25615: {"AegisName":"NasariansSoulstone"},
25616: {"AegisName":"Green_Bearopy"},
25617: {"AegisName":"Chonchon_Doll_HQ"},
25618: {"AegisName":"Gothic_China_Doll"},
25619: {"AegisName":"Clay_Doll"},
25622: {"AegisName":"White_Snake_Tear"},
25627: {"AegisName":"Gold_Card"},
25629: {"AegisName":"Konts_Letter"},
25633: {"AegisName":"Token_Of_Wootan"},
25634: {"AegisName":"Wootan_D_S_Piece"},
25635: {"AegisName":"Wootan_F_Fur"},
25636: {"AegisName":"Shooting_Stone"},
25637: {"AegisName":"Hair_Leaf"},
25638: {"AegisName":"Token_Of_Bigstone"},
25639: {"AegisName":"Fragment_Of_Rock"},
25640: {"AegisName":"Pot_Stone"},
25641: {"AegisName":"Hard_Mud"},
25642: {"AegisName":"Weak_Worm"},
25643: {"AegisName":"Autographed_Book"},
25655: {"AegisName":"Evt_May01_KR"},
25656: {"AegisName":"Evt_June01_KR"},
25657: {"AegisName":"Evt_July01_KR"},
25658: {"AegisName":"Evt_July02_KR"},
25659: {"AegisName":"Evt_May02_KR"},
25664: {"AegisName":"Evt_July03_KR"},
25665: {"AegisName":"Dienes_Envelope"},
25666: {"AegisName":"Id_Card"},
25668: {"AegisName":"EP17_1_EVT01"},
25669: {"AegisName":"EP17_1_EVT02"},
25670: {"AegisName":"EP17_1_EVT03"},
25671: {"AegisName":"EP17_1_EVT04"},
25672: {"AegisName":"EP17_1_EVT05"},
25673: {"AegisName":"EP17_1_EVT06"},
25674: {"AegisName":"EP17_1_EVT07"},
25675: {"AegisName":"EP17_1_EVT08"},
25676: {"AegisName":"EP17_1_EVT09"},
25677: {"AegisName":"EP17_1_EVT10"},
25678: {"AegisName":"EP17_1_EVT11"},
25679: {"AegisName":"EP17_1_EVT12"},
25680: {"AegisName":"EP17_1_EVT13"},
25681: {"AegisName":"EP17_1_EVT14"},
25682: {"AegisName":"EP17_1_EVT15"},
25683: {"AegisName":"EP17_1_EVT16"},
25684: {"AegisName":"EP17_1_EVT17"},
25685: {"AegisName":"EP17_1_EVT18"},
25686: {"AegisName":"EP17_1_EVT19"},
25687: {"AegisName":"EP17_1_EVT20"},
25688: {"AegisName":"EP17_1_EVT21"},
25689: {"AegisName":"EP17_1_EVT22"},
25690: {"AegisName":"EP17_1_EVT23"},
25691: {"AegisName":"EP17_1_EVT24"},
25692: {"AegisName":"EP17_1_EVT25"},
25693: {"AegisName":"EP17_1_EVT26"},
25694: {"AegisName":"EP17_1_EVT27"},
25695: {"AegisName":"EP17_1_EVT28"},
25696: {"AegisName":"EP17_1_EVT29"},
25697: {"AegisName":"EP17_1_EVT30"},
25698: {"AegisName":"EP17_1_EVT31"},
25699: {"AegisName":"EP17_1_EVT32"},
25700: {"AegisName":"EP17_1_EVT33"},
25701: {"AegisName":"EP17_1_EVT34"},
25702: {"AegisName":"EP17_1_EVT35"},
25703: {"AegisName":"EP17_1_EVT36"},
25704: {"AegisName":"EP17_1_EVT37"},
25705: {"AegisName":"EP17_1_EVT38"},
25706: {"AegisName":"HighpriestStone_Top"},
25707: {"AegisName":"HighpriestStone_Middle"},
25708: {"AegisName":"HighpriestStone_Bottom"},
25709: {"AegisName":"ArchbishopStone_Robe"},
25710: {"AegisName":"PaladinStone_Top"},
25711: {"AegisName":"PaladinStone_Middle"},
25712: {"AegisName":"PaladinStone_Bottom"},
25713: {"AegisName":"RoyalguardStone_Robe"},
25714: {"AegisName":"AssacrossStone_Top"},
25715: {"AegisName":"AssacrossStone_Middle"},
25716: {"AegisName":"AssacrossStone_Bottom"},
25717: {"AegisName":"GuillcrossStone_Robe"},
25723: {"AegisName":"EP17_1_EVT39"},
25728: {"AegisName":"Shadowdecon_Ore"},
25729: {"AegisName":"Shadowdecon"},
25730: {"AegisName":"Zelunium_Ore"},
25731: {"AegisName":"Zelunium"},
25733: {"AegisName":"EP17_1_Open_Event"},
25734: {"AegisName":"Sealed_Weapon_Ticket"},
25735: {"AegisName":"Unsealing_Token"},
25736: {"AegisName":"J_Shop_Coupon2"},
25739: {"AegisName":"GH_Cursed_Crystal"},
25740: {"AegisName":"GH_Cursed_Gemstone"},
25759: {"AegisName":"Dragenergy_Green"},
25760: {"AegisName":"Dragenergy_Blue"},
25761: {"AegisName":"Dragenergy_Red"},
25762: {"AegisName":"Dragenergy_Gold"},
25763: {"AegisName":"Dragenergy_Purple"},
25764: {"AegisName":"Dragenergy_Silver"},
25765: {"AegisName":"Drabone_L"},
25766: {"AegisName":"Drabone_S"},
25767: {"AegisName":"Angel_Dream"},
25768: {"AegisName":"Shard_Blue"},
25769: {"AegisName":"Shard_Gold"},
25770: {"AegisName":"Valkyrie_Armor2"},
25771: {"AegisName":"Valkyrie_Armor3"},
25772: {"AegisName":"Delicious_Juice"},
25773: {"AegisName":"Snake_Deadly_Poison"},
25774: {"AegisName":"Mantis_Flower"},
25775: {"AegisName":"Soft_Scarf"},
25776: {"AegisName":"Purple_Solid_Shell"},
25777: {"AegisName":"Suspicious_Sap"},
25778: {"AegisName":"Brilliant_Jelly"},
25779: {"AegisName":"Short_Rope"},
25780: {"AegisName":"Essence_Of_Demon"},
25781: {"AegisName":"Little_Lovely_Candle"},
25782: {"AegisName":"Medicinal_Stuff"},
25783: {"AegisName":"Cold_Holy_Water"},
25784: {"AegisName":"Small_Flashlight"},
25786: {"AegisName":"Bio_Reseearch_Docu"},
25787: {"AegisName":"Bio_Test_Fragment"},
25791: {"AegisName":"Inventory_Ex_Evt"},
25792: {"AegisName":"Inventory_Ex_Dis"},
25793: {"AegisName":"Inventory_Ex"},
25797: {"AegisName":"SuraStone_Robe2"},
25798: {"AegisName":"SuraStone_Bottom2"},
25799: {"AegisName":"SuraStone_Middle2"},
25800: {"AegisName":"SuraStone_Top2"},
25801: {"AegisName":"SorcererStone_Robe2"},
25802: {"AegisName":"SorcererStone_Bottom2"},
25803: {"AegisName":"SorcererStone_Middle2"},
25804: {"AegisName":"SorcererStone_Top2"},
25805: {"AegisName":"ShadowchaserStone_Robe2"},
25806: {"AegisName":"ShadowchasStone_Bottom2"},
25807: {"AegisName":"ShadowchasStone_Middle2"},
25808: {"AegisName":"ShadowchaserStone_Top2"},
25809: {"AegisName":"Ein_REDIUM"},
25810: {"AegisName":"Ein_RINDIUM"},
25811: {"AegisName":"Ein_ODIUM"},
25812: {"AegisName":"Ein_PURDIUM"},
25813: {"AegisName":"Ein_WHIDIUM"},
25814: {"AegisName":"Ein_DYNITE"},
25815: {"AegisName":"Ein_SOLIDDUST"},
25816: {"AegisName":"Ein_RUSTHELM"},
25817: {"AegisName":"Ein_EYEROCK"},
25820: {"AegisName":"Metal_W_Ticket"},
25840: {"AegisName":"PayPromotion_Coupon"},
25841: {"AegisName":"Smooth_Noodle"},
25842: {"AegisName":"SoulreaperStone_Robe"},
25843: {"AegisName":"SoullinkerStone_Top"},
25844: {"AegisName":"SoullinkerStone_Middle"},
25845: {"AegisName":"SoullinkerStone_Bottom"},
25846: {"AegisName":"GladiatorStone_Top"},
25847: {"AegisName":"GladiatorStone_Middle"},
25848: {"AegisName":"GladiatorStone_Bottom"},
25849: {"AegisName":"StaremperorStone_Robe"},
25850: {"AegisName":"NinjaStone_Top"},
25851: {"AegisName":"NinjaStone_Middle"},
25852: {"AegisName":"NinjaStone_Bottom"},
25853: {"AegisName":"KagerouStone_Robe"},
25854: {"AegisName":"OboroStone_Robe"},
25855: {"AegisName":"GunslingerStone_Top"},
25856: {"AegisName":"GunslingerStone_Middle"},
25857: {"AegisName":"GunslingerStone_Bottom"},
25858: {"AegisName":"RebellionStone_Robe"},
25859: {"AegisName":"DoramStone_Top"},
25860: {"AegisName":"DoramStone_Middle"},
25861: {"AegisName":"DoramStone_Bottom"},
25862: {"AegisName":"DoramStone_Robe"},
25863: {"AegisName":"2019_SStarR_Ticket"},
25864: {"AegisName":"S_Circlet_Of_Time"},
25865: {"AegisName":"Jewel_Of_Time_Ore"},
25866: {"AegisName":"Spell_Of_Time"},
25867: {"AegisName":"Fragment_Of_Time"},
25876: {"AegisName":"Harvest_Lottery_Ticket"},
25892: {"AegisName":"Abysmal_Clam"},
25893: {"AegisName":"Deepsea_Fish_Tail"},
25894: {"AegisName":"Rotten_Deepseafish"},
25895: {"AegisName":"Deep_Sea_Starfish"},
25896: {"AegisName":"Deep_Sea_Crab"},
25897: {"AegisName":"Crown_Of_Witch"},
25898: {"AegisName":"Siroods_Fish_Rod"},
25899: {"AegisName":"E_Abyss1"},
25920: {"AegisName":"Armor_Ore_3"},
25921: {"AegisName":"Mature_Cacao"},
25924: {"AegisName":"Boost_C_Enchant_1"},
25928: {"AegisName":"Evt_NY2023_Enc_C_1"},
25929: {"AegisName":"Evt_NY2023_Enc_C_2"},
25934: {"AegisName":"Loft_StoneSTR"},
25935: {"AegisName":"Loft_StoneLUK"},
25936: {"AegisName":"Loft_StoneDEX"},
25937: {"AegisName":"Loft_StoneINT"},
25938: {"AegisName":"Loft_StoneVIT"},
25939: {"AegisName":"Loft_StoneAGI"},
25940: {"AegisName":"Loft_StoneUltimate"},
26001: {"AegisName":"Toughen_Metal_Lance"},
26004: {"AegisName":"Diva_Lance"},
26005: {"AegisName":"Mirage_Lance"},
26006: {"AegisName":"Sinister_Lance_J"},
26007: {"AegisName":"Spectral_Spear_IL"},
26008: {"AegisName":"Neev_Glaive"},
26015: {"AegisName":"Rebeginer_LG_Lance"},
26016: {"AegisName":"T_Lance_Of_Kingdom"},
26017: {"AegisName":"Local01_T_Spear"},
26018: {"AegisName":"Local02_T_Spear"},
26019: {"AegisName":"Woe_T_Lance1_Z"},
26021: {"AegisName":"Variant_Lance"},
26024: {"AegisName":"Ein_BHSPEAR"},
26100: {"AegisName":"P_Foxtail2"},
26101: {"AegisName":"P_Foxtail3"},
26102: {"AegisName":"UnrivaledStaff"},
26103: {"AegisName":"JP_Rod01_L"},
26104: {"AegisName":"Blue_Staff"},
26105: {"AegisName":"Diva_Wand"},
26106: {"AegisName":"Mirage_Wand"},
26107: {"AegisName":"Staff_Of_Elder"},
26108: {"AegisName":"Sinister_Rod_J"},
26109: {"AegisName":"Staff_Of_Bordeaux_IL"},
26110: {"AegisName":"CandyCaneRod"},
26111: {"AegisName":"Metal_Foxtail"},
26112: {"AegisName":"Probation_Foxtail"},
26118: {"AegisName":"Shadow_Staff_K"},
26119: {"AegisName":"Rebeginer_SO_Rod"},
26120: {"AegisName":"Rebeginer_DO_Rod"},
26138: {"AegisName":"Wand_Of_Flame"},
26139: {"AegisName":"Wand_Of_Ice"},
26140: {"AegisName":"WitchsBroomStick"},
26142: {"AegisName":"Local01_Wand"},
26143: {"AegisName":"Diva_Foxtail"},
26144: {"AegisName":"Mirage_Foxtail"},
26145: {"AegisName":"Local02_Wand"},
26146: {"AegisName":"Woe_Healstaff1_Z"},
26147: {"AegisName":"Woe_Wand1_Z"},
26148: {"AegisName":"Owl_D_Stick"},
26149: {"AegisName":"Variant_Wand"},
26150: {"AegisName":"Variant_Foxtail"},
26151: {"AegisName":"Rutilus_Stick_OS"},
26152: {"AegisName":"Staff_Of_Puffy_jp"},
26154: {"AegisName":"SoulWeight"},
26155: {"AegisName":"MeawFoxtail"},
26156: {"AegisName":"Evt_Shadow_Staff_K"},
26158: {"AegisName":"Crimson_Rose_Stick"},
26159: {"AegisName":"Psychic_Spear_Rod"},
26160: {"AegisName":"Dust_Grave"},
26161: {"AegisName":"Ponitendtia"},
26162: {"AegisName":"Ein_1HWAND"},
26163: {"AegisName":"Rainbow_Foxtail"},
26164: {"AegisName":"ElectricFox_OS"},
26165: {"AegisName":"R_Cleric_Staff"},
26166: {"AegisName":"R_Magician_Wand"},
26167: {"AegisName":"Aquarius_Staff_J"},
26168: {"AegisName":"Crimson_Rose_Stick_J"},
26169: {"AegisName":"Psychic_Spear_Rod_J"},
26170: {"AegisName":"Dust_Grave_J"},
26171: {"AegisName":"Ponitendtia_J"},
26172: {"AegisName":"R_Foxtail_rod"},
26175: {"AegisName":"Chromium_Staff_EXE"},
26176: {"AegisName":"Karlite_Staff_EXE"},
26177: {"AegisName":"Wizards_Memory"},
26178: {"AegisName":"Comp_Shadow_Staff_K"},
26200: {"AegisName":"Hippie_Rope"},
26201: {"AegisName":"Diva_Blade_Whip"},
26202: {"AegisName":"Mirage_Blade_Whip"},
26203: {"AegisName":"Sinister_Wire_J"},
26204: {"AegisName":"Hippie_Rope_J"},
26207: {"AegisName":"Local01_Book"},
26208: {"AegisName":"Local01_Whip"},
26209: {"AegisName":"Local02_Whip"},
26210: {"AegisName":"Woe_Whip1_Z"},
26212: {"AegisName":"Heart_Whip"},
26213: {"AegisName":"Scarlet_Ribbon"},
26215: {"AegisName":"Ein_1HWHIP"},
26216: {"AegisName":"R_Wheep"},
26217: {"AegisName":"Heart_Whip_J"},
26218: {"AegisName":"Scarlet_Ribbon_J"},
26221: {"AegisName":"Dark_Illu_Whips_TH"},
27002: {"AegisName":"XM_Mystcase_Card_J"},
27007: {"AegisName":"XM_Celine_Kimi_Card_J"},
27008: {"AegisName":"AmdaraisH_Card_J"},
27009: {"AegisName":"CorruptionRootH_Card_J"},
27012: {"AegisName":"Kick_Step_Card"},
27013: {"AegisName":"KickAndKick_Card"},
27014: {"AegisName":"GreenCenere_Card"},
27015: {"AegisName":"RepairRobot_T_Card"},
27016: {"AegisName":"ExplorationRover_T_Card"},
27017: {"AegisName":"Scr_MT_Robots_Card"},
27018: {"AegisName":"GC109_Card"},
27019: {"AegisName":"DR815_Card"},
27020: {"AegisName":"T_W_O_Card"},
27025: {"AegisName":"Lich_Lord_Card"},
27026: {"AegisName":"Fire_Condor_Card"},
27027: {"AegisName":"Fire_Sand_Man_Card"},
27028: {"AegisName":"Fire_Frilldora_Card"},
27029: {"AegisName":"Fire_Golem_Card"},
27030: {"AegisName":"Fulbuk_Card"},
27031: {"AegisName":"Labyrinth_Bapho_Card"},
27032: {"AegisName":"Labyrinth_Dra_Card"},
27035: {"AegisName":"As_Ragged_Golem_Card_J"},
27040: {"AegisName":"Bijou_Card_J"},
27055: {"AegisName":"Sorcerer_Card_J"},
27056: {"AegisName":"Sura_Card_J"},
27057: {"AegisName":"Minstrel_Card_J"},
27058: {"AegisName":"GuillotineCross_Card_J"},
27059: {"AegisName":"Archbishop_Card_J"},
27060: {"AegisName":"Ranger_Card_J"},
27061: {"AegisName":"Mechanic_Card_J"},
27062: {"AegisName":"Warlock_Card_J"},
27063: {"AegisName":"RuneKnight_Card_J"},
27064: {"AegisName":"RoyalGuard_Card_J"},
27065: {"AegisName":"Genetic_Card_J"},
27066: {"AegisName":"ShadowChaser_Card_J"},
27067: {"AegisName":"Wanderer_Card_J"},
27068: {"AegisName":"Real_Eremes_Card_J"},
27069: {"AegisName":"Real_Magaleta_Card_J"},
27070: {"AegisName":"Real_Katrinn_Card_J"},
27071: {"AegisName":"Real_Shecil_Card_J"},
27072: {"AegisName":"Real_Harword_Card_J"},
27073: {"AegisName":"Real_Seyren_Card_J"},
27074: {"AegisName":"Real_Randel_Card_J"},
27075: {"AegisName":"Real_Flamel_Card_J"},
27076: {"AegisName":"Real_Ceila_Card_J"},
27077: {"AegisName":"Real_Chen_Card_J"},
27078: {"AegisName":"Real_Gertie_Card_J"},
27079: {"AegisName":"Real_Trentini_Card_J"},
27080: {"AegisName":"Real_Alphoccio_Card_J"},
27081: {"AegisName":"AngerMoonlight_Card"},
27082: {"AegisName":"AngerNineTail_Card"},
27083: {"AegisName":"BitterBonGun_Card"},
27084: {"AegisName":"BitterSohee_Card"},
27085: {"AegisName":"BitterMunak_Card"},
27086: {"AegisName":"BitterArcherSk_Card"},
27087: {"AegisName":"WizardOfVeritas_Card"},
27088: {"AegisName":"FuryHero_Card"},
27089: {"AegisName":"T_W_O_Card_J"},
27092: {"AegisName":"Charleston_Card_J"},
27101: {"AegisName":"SweetNightM_Card"},
27102: {"AegisName":"MattDrainliar_Card"},
27103: {"AegisName":"LivingDead_Card"},
27104: {"AegisName":"Ill_Dracula_Card"},
27105: {"AegisName":"Bomi_Card"},
27106: {"AegisName":"Grand_Pere_Card"},
27107: {"AegisName":"PlayingPere_Card"},
27108: {"AegisName":"SingingPere_Card"},
27109: {"AegisName":"JitterbugCard"},
27110: {"AegisName":"AngerGazeti_Card"},
27111: {"AegisName":"AngerSnowier_Card"},
27112: {"AegisName":"AngerIceTitan_Card"},
27113: {"AegisName":"AwakenKtullanux_Card"},
27114: {"AegisName":"OminousSolider_Card"},
27115: {"AegisName":"OminousPermeter_Card"},
27116: {"AegisName":"OminousHeater_Card"},
27117: {"AegisName":"OminousAssulter_Card"},
27118: {"AegisName":"OminousFreezer_Card"},
27119: {"AegisName":"OminousTurtleG_Card"},
27120: {"AegisName":"Iara_Card"},
27121: {"AegisName":"Piranha_Card"},
27122: {"AegisName":"Curupira_Card"},
27123: {"AegisName":"Toucan_Card"},
27124: {"AegisName":"Jaguar_Card"},
27125: {"AegisName":"Headless_Mule_Card"},
27126: {"AegisName":"Boitata_Card"},
27127: {"AegisName":"AncientKing_Groza_Card"},
27128: {"AegisName":"Abyss_AncientKing_Card"},
27129: {"AegisName":"Card_Of_Justice"},
27130: {"AegisName":"Card_Of_Star"},
27131: {"AegisName":"Card_Of_Temperance"},
27132: {"AegisName":"Card_Of_Tram"},
27133: {"AegisName":"Card_Of_Reaper"},
27134: {"AegisName":"Card_Of_Hermit"},
27135: {"AegisName":"Card_Of_Emperor"},
27136: {"AegisName":"Card_Of_Moon"},
27137: {"AegisName":"Card_Of_Lover"},
27138: {"AegisName":"Card_Of_Hierophant"},
27139: {"AegisName":"Card_Of_Devil"},
27140: {"AegisName":"Card_Of_Power"},
27141: {"AegisName":"Evil_Card_J"},
27143: {"AegisName":"Chimera_1_Card_J"},
27146: {"AegisName":"CUITE_Card_J"},
27147: {"AegisName":"Human_Kimera_Card"},
27148: {"AegisName":"Matter_Kimera_Card"},
27149: {"AegisName":"Heart_Hunter_Card"},
27150: {"AegisName":"Venom_Kimera_Card"},
27151: {"AegisName":"Evil_Card"},
27152: {"AegisName":"Cutie_Card"},
27157: {"AegisName":"Wood_Goblin_Card"},
27158: {"AegisName":"Les_Card"},
27159: {"AegisName":"Uzhas_Card"},
27160: {"AegisName":"Vavayaga_Card"},
27161: {"AegisName":"Mavka_Card"},
27162: {"AegisName":"Gopinich_Card"},
27163: {"AegisName":"Faceworm_Card"},
27164: {"AegisName":"Faceworm_Q_Card"},
27165: {"AegisName":"Faceworm_D_Card"},
27166: {"AegisName":"Faceworm_Egg_Card"},
27167: {"AegisName":"Faceworm_L_Card"},
27168: {"AegisName":"Irene_Elder_Card"},
27169: {"AegisName":"Payon_Soldier_Card"},
27170: {"AegisName":"Cowraiders1_Card"},
27171: {"AegisName":"Cowraiders2_Card"},
27172: {"AegisName":"Cowraiders3_Card"},
27173: {"AegisName":"E_Cowraiders1_Card"},
27174: {"AegisName":"E_Cowraiders2_Card"},
27175: {"AegisName":"E_Cowraiders3_Card"},
27176: {"AegisName":"Rr_Cramp_Card"},
27177: {"AegisName":"Rr_Arclouse_Card"},
27178: {"AegisName":"Gaster_Card"},
27179: {"AegisName":"Coyote_Card"},
27180: {"AegisName":"Mechaspider_Card"},
27181: {"AegisName":"AirShip_Raid_Card"},
27182: {"AegisName":"Felock_Card"},
27183: {"AegisName":"Gigantes_Card"},
27184: {"AegisName":"Knight_Sakray_Card"},
27191: {"AegisName":"Gaster_Card_J"},
27196: {"AegisName":"S_Nihil_Card"},
27197: {"AegisName":"S_Agnes_Card"},
27198: {"AegisName":"S_Jurgen_Card"},
27199: {"AegisName":"S_Spica_Card"},
27200: {"AegisName":"Nihil_Card"},
27201: {"AegisName":"Agnes_Card"},
27202: {"AegisName":"Jurgen_Card"},
27203: {"AegisName":"Spica_Card"},
27209: {"AegisName":"SLD_Q_Scaraba_Card"},
27210: {"AegisName":"SLD_Thanatos_Card"},
27211: {"AegisName":"SLD_Baphomet_Card"},
27212: {"AegisName":"SLD_Maya_Card"},
27213: {"AegisName":"SLD_Clown_Card"},
27214: {"AegisName":"SLD_Professor_Card"},
27215: {"AegisName":"SLD_Champion_Card"},
27216: {"AegisName":"SLD_Creator_Card"},
27217: {"AegisName":"SLD_Stalker_Card"},
27218: {"AegisName":"SLD_Paladin_Card"},
27219: {"AegisName":"SLD_Gypsy_Card"},
27220: {"AegisName":"SLD_Daehyon_Card"},
27221: {"AegisName":"SLD_Gioia_Card"},
27222: {"AegisName":"SLD_Pyuriel_Card"},
27224: {"AegisName":"SLD_Kades_Card"},
27225: {"AegisName":"SLD_Timeholder_Card"},
27228: {"AegisName":"Big_Eggring_Card_J"},
27237: {"AegisName":"Faceworm_Q_Card_J"},
27247: {"AegisName":"Grand_Pere_Card_J"},
27248: {"AegisName":"Sarah_Card_J"},
27249: {"AegisName":"Archi_Card"},
27250: {"AegisName":"Dio_Anemos_Card"},
27251: {"AegisName":"Geffen_Gang_Card"},
27252: {"AegisName":"Geffen_Thug_Card"},
27253: {"AegisName":"Geffen_Thief_Card"},
27254: {"AegisName":"Pa_Monk_Card"},
27255: {"AegisName":"Ordre_Card"},
27256: {"AegisName":"Blut_Hase_Card"},
27257: {"AegisName":"Kuro_Akuma_Card"},
27258: {"AegisName":"Hyper_Death_Card"},
27259: {"AegisName":"Rechenier_Card"},
27260: {"AegisName":"Odorico_Card"},
27261: {"AegisName":"Jew_Card"},
27262: {"AegisName":"Dy_Card"},
27263: {"AegisName":"Fei_Kanabian_Card"},
27264: {"AegisName":"Evil_Shadow_Card"},
27265: {"AegisName":"Evil_Fanatics_Card"},
27286: {"AegisName":"Colorful_T_Bear_Card"},
27287: {"AegisName":"Shining_T_Bear_Card"},
27288: {"AegisName":"Pitman_Worker_Card"},
27289: {"AegisName":"Fragment_Of_Soul_Card"},
27290: {"AegisName":"Sinister_Obsidian_Card"},
27291: {"AegisName":"Ancient_Trijoint_Card"},
27292: {"AegisName":"Ancient_Sta_Golem_Card"},
27293: {"AegisName":"Ancient_Megalith_Card"},
27294: {"AegisName":"Ancient_Tao_Gunka_Card"},
27295: {"AegisName":"Ancient_S_Shooter_Card"},
27296: {"AegisName":"Ancient_W_Shooter_Card"},
27297: {"AegisName":"Ancient_W_Fighter_Card"},
27298: {"AegisName":"Ancient_W_Deffend_Card"},
27301: {"AegisName":"Labyrinth_Dop_Card"},
27304: {"AegisName":"E_EA2S_Card"},
27305: {"AegisName":"EL_A17T_Card"},
27306: {"AegisName":"Bellare_Card"},
27307: {"AegisName":"High_Bellare_Card"},
27308: {"AegisName":"Sanare_Card"},
27309: {"AegisName":"High_Sanare_Card"},
27310: {"AegisName":"Plaga_Card"},
27311: {"AegisName":"Mutant_Plaga_Card"},
27312: {"AegisName":"Dolor_Card"},
27313: {"AegisName":"Mt_Dolor_Card"},
27314: {"AegisName":"Venenum_Card"},
27315: {"AegisName":"Mt_Venenum_Card"},
27316: {"AegisName":"Caput_Card"},
27317: {"AegisName":"Mt_Caput_Card"},
27318: {"AegisName":"Miguel_Card"},
27319: {"AegisName":"R48_85_Bestia_Card"},
27320: {"AegisName":"E_EA1L_Card"},
27321: {"AegisName":"DespairGodMorocc_Card"},
27322: {"AegisName":"Ahat_Card"},
27323: {"AegisName":"Shnaim_Card"},
27324: {"AegisName":"Brinaranea_Card"},
27325: {"AegisName":"Muspellskoll_Card"},
27326: {"AegisName":"MinionOfMorocc_Card"},
27327: {"AegisName":"ReaperAnkou_Card"},
27328: {"AegisName":"LivingDeath_Card"},
27329: {"AegisName":"Schmidt_Card"},
27330: {"AegisName":"Kronecker_Card"},
27331: {"AegisName":"S_Kronecker_Card"},
27332: {"AegisName":"Skia_Card"},
27333: {"AegisName":"S_Skia_Card"},
27334: {"AegisName":"Chaos_Baphomet_Card"},
27335: {"AegisName":"Chaos_Ba_Jr_Card"},
27336: {"AegisName":"Chaos_S_Winder_Card"},
27337: {"AegisName":"Chaos_H_Fly_Card"},
27338: {"AegisName":"Chaos_Mantis_Card"},
27339: {"AegisName":"Chaos_Goring_Card"},
27340: {"AegisName":"Chaos_K_Mantis_Card"},
27341: {"AegisName":"Chaos_Poporing_Card"},
27342: {"AegisName":"Chaos_Stem_W_Card"},
27343: {"AegisName":"Chaos_Acolyte_Card"},
27344: {"AegisName":"Witch_Zilant_Card"},
27345: {"AegisName":"Dragon_Zilant_Card"},
27346: {"AegisName":"Firm_Muspell_Card"},
27347: {"AegisName":"Firm_Kaho_Card"},
27348: {"AegisName":"Firm_Lava_G_Card"},
27349: {"AegisName":"Firm_Explosion_Card"},
27350: {"AegisName":"Firm_Deleter1_Card"},
27351: {"AegisName":"Firm_Deleter2_Card"},
27352: {"AegisName":"Firm_Nightmare_T_Card"},
27353: {"AegisName":"Firm_Blazzer_Card"},
27354: {"AegisName":"Polluted_Raydric_Card"},
27355: {"AegisName":"Polluted_Ray_A_Card"},
27356: {"AegisName":"Frozen_Gargoyle_Card"},
27357: {"AegisName":"Polluted_Sting_Card"},
27358: {"AegisName":"Prison_Breaker_Card"},
27359: {"AegisName":"Ice_Ghost_Card"},
27360: {"AegisName":"Flame_Ghost_Card"},
27361: {"AegisName":"Polluted_W_Man_Card"},
27362: {"AegisName":"Polluted_Spi_Q_Card"},
27363: {"AegisName":"Polluted_Dark_L_Card"},
27364: {"AegisName":"Card_Of_Fool"},
27365: {"AegisName":"Card_Of_WheelOfF"},
27366: {"AegisName":"Card_Of_TheHangedM"},
27367: {"AegisName":"Card_Of_TheWorld"},
27368: {"AegisName":"Colorful_T_Bear_Card_J"},
27369: {"AegisName":"Shining_T_Bear_Card_J"},
27370: {"AegisName":"Pitman_Worker_Card_J"},
27371: {"AegisName":"Fragment_Of_Soul_Card_J"},
27372: {"AegisName":"Sinister_Obsidian_Card_"},
27373: {"AegisName":"Ancient_Trijoint_Card_J"},
27374: {"AegisName":"Anc_Sta_Golem_Card_J"},
27375: {"AegisName":"Anc_Megalith_Card_J"},
27376: {"AegisName":"Anc_Tao_Gunka_Card_J"},
27377: {"AegisName":"Anc_S_Shooter_Card_J"},
27378: {"AegisName":"Anc_W_Shooter_Card_J"},
27379: {"AegisName":"Anc_W_Fighter_Card_J"},
27380: {"AegisName":"Anc_W_Deffend_Card_J"},
27381: {"AegisName":"C_Himel_Card"},
27382: {"AegisName":"C_CorruptionRoot_Card"},
27383: {"AegisName":"C_Amdarais_Card"},
27384: {"AegisName":"C_White_Knight_Card"},
27385: {"AegisName":"C_Khaliz_Knight_Card"},
27386: {"AegisName":"C_Raydric_Card"},
27387: {"AegisName":"C_Raydric_Archer_Card"},
27388: {"AegisName":"C_Cursed_Butler"},
27389: {"AegisName":"Wolf_Card_EV"},
27390: {"AegisName":"S_Wolf_Card_E"},
27391: {"AegisName":"Poe_Card_E"},
27392: {"AegisName":"S_Poe_Card_E"},
27393: {"AegisName":"Kathryn_Card"},
27394: {"AegisName":"S_Kathryn_Card"},
27395: {"AegisName":"Isaac_Card"},
27396: {"AegisName":"S_Issac_Card"},
27397: {"AegisName":"E_Imune"},
27398: {"AegisName":"Dodge3_J"},
27399: {"AegisName":"Offering_to_God"},
27400: {"AegisName":"Resistance_Long_Dis5"},
27401: {"AegisName":"Absorbsprits_Lv1"},
27402: {"AegisName":"Latent_Release_SU"},
27403: {"AegisName":"Latent_Release_SJ"},
27404: {"AegisName":"Latent_Release_SP"},
27405: {"AegisName":"Latent_Release_KG"},
27406: {"AegisName":"Latent_Release_OB"},
27407: {"AegisName":"Latent_Release_RL"},
27408: {"AegisName":"Immun_Fire"},
27409: {"AegisName":"Immun_Water"},
27410: {"AegisName":"Immun_Wind"},
27411: {"AegisName":"Immun_Earth"},
27412: {"AegisName":"MHP15"},
27413: {"AegisName":"Big_Fire_BR"},
27414: {"AegisName":"Sky_Ground_BR"},
27415: {"AegisName":"Storm_BR"},
27416: {"AegisName":"Water_Sky_BR"},
27417: {"AegisName":"aegis_27417"},
27421: {"AegisName":"Shard_Jewelry_Str"},
27422: {"AegisName":"Shard_Jewelry_Agi"},
27423: {"AegisName":"Shard_Jewelry_Dex"},
27424: {"AegisName":"Shard_Jewelry_Luk"},
27425: {"AegisName":"Shard_Jewelry_Vit"},
27426: {"AegisName":"Shard_Jewelry_Int"},
28000: {"AegisName":"Thanos_Katar"},
28001: {"AegisName":"Katar_Of_Evil_Slayer"},
28002: {"AegisName":"Half_BF_Katar2"},
28005: {"AegisName":"Ru_Blue_Katar"},
28006: {"AegisName":"Ru_Gold_Katar"},
28007: {"AegisName":"Scarlet_Katar"},
28008: {"AegisName":"Sinister_Katar"},
28010: {"AegisName":"Katar_170"},
28011: {"AegisName":"Union_Katar"},
28014: {"AegisName":"Kings_Double_Edge"},
28015: {"AegisName":"Toughen_Metal_Katar"},
28018: {"AegisName":"Diva_Katar"},
28019: {"AegisName":"Mirage_Katar"},
28020: {"AegisName":"Sinister_Katar_J"},
28022: {"AegisName":"Infiltrator_IL"},
28023: {"AegisName":"Ghoul_Leg_IL"},
28024: {"AegisName":"Probation_Katar"},
28026: {"AegisName":"Neev_Various_Jur"},
28027: {"AegisName":"Rebeginer_GC_Katar"},
28034: {"AegisName":"Local01_Katar"},
28035: {"AegisName":"Local02_Katar"},
28036: {"AegisName":"Woe_Katar1_Z"},
28037: {"AegisName":"Variant_Katar"},
28038: {"AegisName":"Meuchler_OS"},
28039: {"AegisName":"Shiver_Katar_K"},
28040: {"AegisName":"Evt_Shiver_Katar_K"},
28042: {"AegisName":"Reaper_Cross"},
28044: {"AegisName":"Agudo_Filo"},
28045: {"AegisName":"Ein_BHKATAR"},
28046: {"AegisName":"R_Katar"},
28047: {"AegisName":"Scorpio_Katar_J"},
28048: {"AegisName":"Reaper_Cross_J"},
28049: {"AegisName":"Agudo_Filo_J"},
28053: {"AegisName":"Comp_Shiver_Katar_K_TH"},
28100: {"AegisName":"Thanos_Axe"},
28101: {"AegisName":"Tornado_Axe"},
28102: {"AegisName":"Half_BF_Two_Handed_Axe1"},
28103: {"AegisName":"Ru_Blue_Axe_M"},
28104: {"AegisName":"Ru_Gold_Axe_M"},
28105: {"AegisName":"Axe_Of_Infinite"},
28106: {"AegisName":"Scarlet_Twohand_Axe"},
28107: {"AegisName":"Sinister_Twohand_Axe"},
28110: {"AegisName":"Union_Twohand_Axe"},
28113: {"AegisName":"Toughen_Metal_THand_Axe"},
28114: {"AegisName":"Veteran_Axe_"},
28116: {"AegisName":"Mine_Worker_Pickax"},
28117: {"AegisName":"Diva_Twohand_Axe"},
28118: {"AegisName":"Mirage_Twohand_Axe"},
28119: {"AegisName":"Sinister_Twohand_Axe_J"},
28120: {"AegisName":"Probation_TH_Axe"},
28121: {"AegisName":"Neev_Guillotine"},
28122: {"AegisName":"Neev_Buster"},
28127: {"AegisName":"Mine_Worker_Pickax_J"},
28130: {"AegisName":"Avenger"},
28131: {"AegisName":"Local01_T_Axe"},
28132: {"AegisName":"Local02_T_Axe"},
28133: {"AegisName":"Woe_Twohand_Axe1_Z"},
28135: {"AegisName":"Variant_Twohand_Axe"},
28136: {"AegisName":"Blasti_OS"},
28137: {"AegisName":"Evt_Avenger"},
28138: {"AegisName":"Maxi_Spanner"},
28140: {"AegisName":"Ein_BHAXE"},
28141: {"AegisName":"G_Knight_BattleAxe"},
28142: {"AegisName":"Maxi_Spanner_J"},
28144: {"AegisName":"aegis_28144"},
28200: {"AegisName":"END_OF_HORIZON"},
28201: {"AegisName":"Southern_Cross_R"},
28202: {"AegisName":"Southern_Cross_R_"},
28203: {"AegisName":"Half_BF_Rifle1"},
28204: {"AegisName":"Half_BF_Shotgun1"},
28214: {"AegisName":"EXODUS_JOKER_XIII"},
28215: {"AegisName":"Probation_Rifle"},
28216: {"AegisName":"Probation_Gatling_Gun"},
28217: {"AegisName":"Probation_Launcher"},
28218: {"AegisName":"Probation_Shotgun"},
28223: {"AegisName":"Just_Finish"},
28224: {"AegisName":"Dust_Fire"},
28225: {"AegisName":"Burning_Rose"},
28226: {"AegisName":"Revenger"},
28227: {"AegisName":"Diva_Rifle"},
28228: {"AegisName":"Mirage_Rifle"},
28229: {"AegisName":"Diva_Gatling_Gun"},
28230: {"AegisName":"Mirage_Gatling_Gun"},
28231: {"AegisName":"Diva_Launcher"},
28232: {"AegisName":"Mirage_Launcher"},
28233: {"AegisName":"Diva_Shotgun"},
28234: {"AegisName":"Mirage_Shotgun"},
28235: {"AegisName":"Neev_Rifle"},
28236: {"AegisName":"Calf_Kingcobra_J"},
28237: {"AegisName":"Calf_Diamondback_J"},
28238: {"AegisName":"Calf_Anaconda_J"},
28239: {"AegisName":"Calf_Python_J"},
28240: {"AegisName":"Calf_Kingcobra"},
28241: {"AegisName":"Calf_Diamondback"},
28242: {"AegisName":"Calf_Anaconda"},
28243: {"AegisName":"Calf_Python"},
28244: {"AegisName":"Gate_KeeperDD_IL"},
28249: {"AegisName":"Variant_Rifle"},
28250: {"AegisName":"Variant_Gatling_Gun"},
28251: {"AegisName":"Variant_Shotgun"},
28252: {"AegisName":"Variant_Launcher"},
28253: {"AegisName":"HR_S55_OS"},
28254: {"AegisName":"Butcher_IL"},
28255: {"AegisName":"Master_Soul_Rifle"},
28256: {"AegisName":"Demon_S_Shot"},
28257: {"AegisName":"Golden_L_Launcher"},
28258: {"AegisName":"The_Black_Gatling"},
28261: {"AegisName":"Comp_Demon_S_Shot"},
28300: {"AegisName":"Kotone_Of_Ninja"},
28301: {"AegisName":"Ball_Of_Huuma"},
28302: {"AegisName":"Vesper_Core01_"},
28303: {"AegisName":"Vesper_Core02_"},
28304: {"AegisName":"Vesper_Core03_"},
28305: {"AegisName":"Vesper_Core04_"},
28306: {"AegisName":"Bless_Of_Moon"},
28310: {"AegisName":"Earring_Of_Sarah_L"},
28311: {"AegisName":"Earring_Of_Sarah_R"},
28312: {"AegisName":"Platinum_Ring"},
28313: {"AegisName":"Operation_Glove"},
28314: {"AegisName":"Hand_Of_Glory"},
28315: {"AegisName":"RCC2013_ARMLET"},
28316: {"AegisName":"RCC2013_ARMLET_"},
28317: {"AegisName":"RCC2013_RING"},
28318: {"AegisName":"RCC2013_RING_"},
28319: {"AegisName":"Cauda_Daemonica"},
28320: {"AegisName":"Assassin_Acc"},
28321: {"AegisName":"Falconer_Claw"},
28322: {"AegisName":"Falconer_Glove"},
28323: {"AegisName":"Exorcist_Gloves"},
28324: {"AegisName":"Steam_Starter_Ring"},
28326: {"AegisName":"Broken_Chip_1"},
28327: {"AegisName":"Broken_Chip_2"},
28332: {"AegisName":"Jewel_Ring"},
28333: {"AegisName":"Gold_PC_Ring"},
28340: {"AegisName":"A_Drop_Of_Heal"},
28341: {"AegisName":"Sachet"},
28342: {"AegisName":"Critical_Anklet"},
28346: {"AegisName":"Star_Egg_Badge"},
28347: {"AegisName":"Icarus_Wing_S"},
28348: {"AegisName":"Bowman_Scarf_S"},
28349: {"AegisName":"Cursed_Star_S"},
28350: {"AegisName":"Shinobi's_Sash_S"},
28351: {"AegisName":"Whike_Black_Tail_S"},
28352: {"AegisName":"VesperGear1"},
28353: {"AegisName":"VesperGear2"},
28354: {"AegisName":"DowntownMap_"},
28355: {"AegisName":"ShiningHolyWater_"},
28356: {"AegisName":"BadgeOfProntera_"},
28357: {"AegisName":"VesperGear3"},
28358: {"AegisName":"Cursed_Lucky_Clover"},
28359: {"AegisName":"VesperGear4"},
28368: {"AegisName":"Supplement_Part_Dex_J"},
28369: {"AegisName":"Upgrade_Part_Gun_B_J"},
28370: {"AegisName":"Broken_Chip_1_J"},
28371: {"AegisName":"Broken_Chip_2_J"},
28372: {"AegisName":"Imperial_Ring"},
28374: {"AegisName":"Foxtail_Ring"},
28377: {"AegisName":"Magical_Ring"},
28379: {"AegisName":"Shadow_Ring"},
28380: {"AegisName":"Fresh_G_Necklace"},
28381: {"AegisName":"Pretty_G_Necklace"},
28382: {"AegisName":"Charm_G_Necklace"},
28386: {"AegisName":"Fallen_Monk_Rosary"},
28387: {"AegisName":"Bishop_Necklace"},
28388: {"AegisName":"Bloody_Iron_Ball_"},
28391: {"AegisName":"S_Thief_earring"},
28392: {"AegisName":"S_Archer_earring"},
28394: {"AegisName":"King_of_Spirit_Ring"},
28410: {"AegisName":"Sapphire_Wrist"},
28411: {"AegisName":"Emerald_Earring"},
28412: {"AegisName":"The_One_Apple_Ring"},
28413: {"AegisName":"LowSaurelCharm"},
28414: {"AegisName":"MiddleSaurelCharm"},
28415: {"AegisName":"HigherSaurelCharm"},
28416: {"AegisName":"LowLeafCharm"},
28417: {"AegisName":"MiddleLeafCharm"},
28418: {"AegisName":"HigherLeafCharm"},
28419: {"AegisName":"LowRabbitCharm"},
28420: {"AegisName":"MiddleRabbitCharm"},
28421: {"AegisName":"HigherRabbitCharm"},
28422: {"AegisName":"ShiningTwigCharm"},
28423: {"AegisName":"FreshTunaCharm"},
28424: {"AegisName":"PlumpyWormCharm"},
28425: {"AegisName":"Mercenary_Ring_A"},
28426: {"AegisName":"Mercenary_Ring_B"},
28427: {"AegisName":"Blue_4leaf_Necklace"},
28428: {"AegisName":"4SeasonsClover"},
28429: {"AegisName":"Arquien's_Necklace"},
28430: {"AegisName":"Archpriest_Ring"},
28431: {"AegisName":"Sprint_Ring_"},
28432: {"AegisName":"Spiritual_Ring_"},
28433: {"AegisName":"Luminous_Blue_Stone"},
28434: {"AegisName":"Boxer_Glove"},
28435: {"AegisName":"Secret_Scroll_Of_Ninja"},
28436: {"AegisName":"Elvira_Pendant"},
28437: {"AegisName":"ArchPriest_Glove"},
28438: {"AegisName":"Fairy_Leaf_Powder"},
28439: {"AegisName":"SeeOtter_Fan"},
28440: {"AegisName":"FurSeal_Fan"},
28441: {"AegisName":"Vigilante_Bedge"},
28442: {"AegisName":"Hippie_Feather"},
28443: {"AegisName":"Para_Team_Ring100A"},
28444: {"AegisName":"Para_Team_Necklace100A"},
28445: {"AegisName":"Para_Team_Ring115A"},
28446: {"AegisName":"Para_Team_Necklace115A"},
28447: {"AegisName":"Para_Team_Ring130A"},
28448: {"AegisName":"Para_Team_Necklace130A"},
28449: {"AegisName":"Para_Team_Ring145A"},
28450: {"AegisName":"Para_Team_Necklace145A"},
28451: {"AegisName":"Para_Team_Ring160A"},
28452: {"AegisName":"Para_Team_Necklace160A"},
28453: {"AegisName":"Para_Team_Ring100B"},
28454: {"AegisName":"Para_Team_Necklace100B"},
28455: {"AegisName":"Para_Team_Ring115B"},
28456: {"AegisName":"Para_Team_Necklace115B"},
28457: {"AegisName":"Para_Team_Ring130B"},
28458: {"AegisName":"Para_Team_Necklace130B"},
28459: {"AegisName":"Para_Team_Ring145B"},
28460: {"AegisName":"Para_Team_Necklace145B"},
28461: {"AegisName":"Para_Team_Ring160B"},
28462: {"AegisName":"Para_Team_Necklace160B"},
28463: {"AegisName":"Para_Team_Ring100C"},
28464: {"AegisName":"Para_Team_Necklace100C"},
28465: {"AegisName":"Para_Team_Ring115C"},
28466: {"AegisName":"Para_Team_Necklace115C"},
28467: {"AegisName":"Para_Team_Ring130C"},
28468: {"AegisName":"Para_Team_Necklace130C"},
28469: {"AegisName":"Para_Team_Ring145C"},
28470: {"AegisName":"Para_Team_Necklace145C"},
28471: {"AegisName":"Para_Team_Ring160C"},
28472: {"AegisName":"Para_Team_Necklace160C"},
28473: {"AegisName":"Para_Team_Ring100D"},
28474: {"AegisName":"Para_Team_Necklace100D"},
28475: {"AegisName":"Para_Team_Ring115D"},
28476: {"AegisName":"Para_Team_Necklace115D"},
28477: {"AegisName":"Para_Team_Ring130D"},
28478: {"AegisName":"Para_Team_Necklace130D"},
28479: {"AegisName":"Para_Team_Ring145D"},
28480: {"AegisName":"Para_Team_Necklace145D"},
28481: {"AegisName":"Para_Team_Ring160D"},
28482: {"AegisName":"Para_Team_Necklace160D"},
28483: {"AegisName":"ProtectRingofKing"},
28484: {"AegisName":"Scarf_Of_Rebellion"},
28485: {"AegisName":"Shinobi's_Sash_H"},
28491: {"AegisName":"Matagi_Swordaxe"},
28492: {"AegisName":"Tip_Of_Thief_Vol1"},
28495: {"AegisName":"Badge_Of_Vigilante1"},
28496: {"AegisName":"Badge_Of_Vigilante2"},
28499: {"AegisName":"BadgeOfProntera__J"},
28500: {"AegisName":"Fanatic_Necklace"},
28501: {"AegisName":"Horn_Of_Kirin"},
28502: {"AegisName":"Mob_Scarf"},
28503: {"AegisName":"Keraunos"},
28505: {"AegisName":"RingOfDevil"},
28506: {"AegisName":"StormStone"},
28507: {"AegisName":"Glove_Of_Wizard"},
28508: {"AegisName":"Skul_Ring_IL"},
28509: {"AegisName":"Ring_IL"},
28510: {"AegisName":"Vampire's_Servant"},
28511: {"AegisName":"Time_Keeper_Ring"},
28513: {"AegisName":"Celine_Brooch"},
28514: {"AegisName":"Bless_Flower_Ring"},
28515: {"AegisName":"Imperial_Ring_BR"},
28516: {"AegisName":"2017RTCRING"},
28517: {"AegisName":"Ring_Of_The_Abyss_King"},
28518: {"AegisName":"Cursed_Demon_Ring"},
28519: {"AegisName":"So_Heon_Saber"},
28520: {"AegisName":"EgirRing"},
28521: {"AegisName":"Giant_Protection"},
28522: {"AegisName":"Ring_Of_Fallen"},
28523: {"AegisName":"Ring_Of_Disaster"},
28531: {"AegisName":"Glove_Of_Smith"},
28533: {"AegisName":"ChemicalGlove"},
28534: {"AegisName":"RKC_2017_Pendant"},
28535: {"AegisName":"RKC_2017_Ring"},
28536: {"AegisName":"Emerald_Earring_TW"},
28537: {"AegisName":"Arquiens_Necklace_BR"},
28538: {"AegisName":"Glove_Of_Wizard_BR"},
28539: {"AegisName":"60Lv_Ring"},
28540: {"AegisName":"70Lv_Ring"},
28541: {"AegisName":"70Lv_Mring"},
28542: {"AegisName":"80Lv_Aring"},
28543: {"AegisName":"80Lv_Gloves"},
28544: {"AegisName":"80Lv_Mring"},
28545: {"AegisName":"80Lv_Necklace"},
28546: {"AegisName":"90Lv_Aring"},
28547: {"AegisName":"90Lv_Gloves"},
28548: {"AegisName":"90Lv_Mring"},
28549: {"AegisName":"90Lv_Necklace"},
28551: {"AegisName":"Imperial_Glove"},
28552: {"AegisName":"Two_Dragon_Ring"},
28553: {"AegisName":"Shinobi_Sash_H_BR"},
28560: {"AegisName":"YinYang_Talisman"},
28561: {"AegisName":"Ring_Of_Brave"},
28562: {"AegisName":"True_Hunting_Ring1"},
28563: {"AegisName":"True_Hunting_Ring2"},
28564: {"AegisName":"Valkyrie_Drop"},
28565: {"AegisName":"Perverse_Demon_Mask"},
28566: {"AegisName":"Rebeginer_Ring"},
28567: {"AegisName":"King_of_Spirit_Ring_TW"},
28573: {"AegisName":"Emerald_Ring"},
28575: {"AegisName":"Verus_Core"},
28577: {"AegisName":"Fresh_G_Necklace_J"},
28578: {"AegisName":"Pretty_G_Necklace_J"},
28579: {"AegisName":"Charm_G_Necklace_J"},
28580: {"AegisName":"LowSaurelCharm_J"},
28581: {"AegisName":"MiddleSaurelCharm_J"},
28582: {"AegisName":"HigherSaurelCharm_J"},
28583: {"AegisName":"LowLeafCharm_J"},
28584: {"AegisName":"MiddleLeafCharm_J"},
28585: {"AegisName":"HigherLeafCharm_J"},
28586: {"AegisName":"LowRabbitCharm_J"},
28587: {"AegisName":"MiddleRabbitCharm_J"},
28588: {"AegisName":"HigherRabbitCharm_J"},
28589: {"AegisName":"ShiningTwigCharm_J"},
28590: {"AegisName":"FreshTunaCharm_J"},
28591: {"AegisName":"PlumpyWormCharm_J"},
28592: {"AegisName":"Angel_Poring_Earing"},
28593: {"AegisName":"Angel_Poring_Ring"},
28594: {"AegisName":"Temporal_Ring"},
28595: {"AegisName":"BlueDragonRing_TW"},
28596: {"AegisName":"Toy_Ring"},
28597: {"AegisName":"CherryBlossom_Badge_TW"},
28598: {"AegisName":"Supplement_Part_Chip"},
28600: {"AegisName":"Ru_Blue_Book"},
28601: {"AegisName":"Ru_Gold_Book"},
28602: {"AegisName":"Demon_Hunting_Bible"},
28604: {"AegisName":"Scarlet_Bible"},
28605: {"AegisName":"Sinister_Book"},
28606: {"AegisName":"Union_Bible"},
28607: {"AegisName":"Toughen_Metal_Book"},
28608: {"AegisName":"Origin_Of_Elemental"},
28609: {"AegisName":"Diva_Book"},
28610: {"AegisName":"Mirage_Book"},
28611: {"AegisName":"Sinister_Book_J"},
28612: {"AegisName":"Book_Of_The_Apo_IL"},
28613: {"AegisName":"Probation_Magicbook"},
28614: {"AegisName":"Probation_Bible"},
28615: {"AegisName":"Origin_Of_Elemental_J"},
28616: {"AegisName":"Rebeginer_AB_Bible"},
28617: {"AegisName":"Demon_Hunting_Bible_BR"},
28618: {"AegisName":"Time_Kamiji"},
28619: {"AegisName":"Prisoner_Dairy"},
28625: {"AegisName":"Local02_Book"},
28626: {"AegisName":"Tablet_IL"},
28627: {"AegisName":"Variant_Book"},
28628: {"AegisName":"Prohibited_Grimoire"},
28629: {"AegisName":"Circuit_Board_OS"},
28630: {"AegisName":"Demon_Hunting_Bible_K"},
28631: {"AegisName":"OneSkyOneSun"},
28632: {"AegisName":"Evt_D_H_Bible_K"},
28633: {"AegisName":"Boltigin"},
28635: {"AegisName":"Ein_1HBOOK"},
28636: {"AegisName":"R_Sage_Book"},
28637: {"AegisName":"Boltigin_J"},
28643: {"AegisName":"Pollux_Book_J"},
28645: {"AegisName":"aegis_28645"},
28646: {"AegisName":"Comp_D_Hunt_Bible_K"},
28700: {"AegisName":"Ru_Gold_Dagger"},
28701: {"AegisName":"Ru_Gold_Knife"},
28702: {"AegisName":"Ru_Gold_Ashura"},
28703: {"AegisName":"Dagger_Of_Infinite"},
28705: {"AegisName":"Scarlet_Dagger"},
28706: {"AegisName":"Sinister_Dagger"},
28708: {"AegisName":"Dagger_of_Trust"},
28712: {"AegisName":"Kings_Eager"},
28713: {"AegisName":"Kings_Bless"},
28714: {"AegisName":"Toughen_Metal_Dagger"},
28715: {"AegisName":"UnrivaledDagger"},
28716: {"AegisName":"Tooth_Blade_"},
28717: {"AegisName":"Valkyrie_Knife"},
28719: {"AegisName":"Diffusion_Lacma"},
28720: {"AegisName":"Blue_Dagger"},
28721: {"AegisName":"Monokage"},
28722: {"AegisName":"Diva_Dagger"},
28723: {"AegisName":"Mirage_Dagger"},
28724: {"AegisName":"Sinister_Dagger_J"},
28725: {"AegisName":"Moonlight_Sword_IL"},
28726: {"AegisName":"Probation_Dagger"},
28737: {"AegisName":"Mist_Sword"},
28738: {"AegisName":"Monokage_J"},
28740: {"AegisName":"Rebeginer_SC_Dagger"},
28744: {"AegisName":"Magic_Sword"},
28745: {"AegisName":"Counter_Dagger_IL"},
28747: {"AegisName":"Local01_Dagger"},
28748: {"AegisName":"Local01_Asura"},
28749: {"AegisName":"Local02_Dagger"},
28750: {"AegisName":"Local02_Asura"},
28751: {"AegisName":"Woe_Knife1_Z"},
28753: {"AegisName":"Variant_Dagger"},
28754: {"AegisName":"Koikiri"},
28755: {"AegisName":"Kuroiro_OS"},
28759: {"AegisName":"Evt_Magic_Sword"},
28761: {"AegisName":"Scarlet_Athame"},
28762: {"AegisName":"Bazerald_IL"},
28763: {"AegisName":"Sharp_Wind_Sword"},
28764: {"AegisName":"Fog_Dew_Sword"},
28765: {"AegisName":"Judgement_Slasher"},
28766: {"AegisName":"Repent_Slasher"},
28767: {"AegisName":"Jack_The_Knife"},
28768: {"AegisName":"Platinum_Dagger"},
28771: {"AegisName":"Ein_1HDAGGER"},
28772: {"AegisName":"Ein_1HMAGGER"},
28774: {"AegisName":"R_Gladius_R"},
28775: {"AegisName":"R_Gladius_L"},
28776: {"AegisName":"R_Magician_Dagger"},
28777: {"AegisName":"Judgement_Slasher_J"},
28778: {"AegisName":"Repent_Slasher_J"},
28779: {"AegisName":"Jack_The_Knife_J"},
28780: {"AegisName":"Platinum_Dagger_J"},
28784: {"AegisName":"Procyon_Dagger_J"},
28785: {"AegisName":"Time_Gap_ABC_Dagger"},
28786: {"AegisName":"Comp_Magic_Sword"},
28787: {"AegisName":"aegis_28787"},
28789: {"AegisName":"Time_Gap_SS_Dagger1"},
28900: {"AegisName":"ShieldOfGuardsman"},
28901: {"AegisName":"Mad_Bunny_K"},
28902: {"AegisName":"Mad_Bunny_K_"},
28903: {"AegisName":"Scutum"},
28904: {"AegisName":"Union_Guard"},
28905: {"AegisName":"Union_Buckler"},
28906: {"AegisName":"Shield_Of_Flame"},
28907: {"AegisName":"Shield_Of_Gust"},
28908: {"AegisName":"BIgShield_Of_Water"},
28909: {"AegisName":"Shield_Of_Earth"},
28910: {"AegisName":"Imuke_Upper_Shield"},
28912: {"AegisName":"Rudo_Heart_Roll"},
28913: {"AegisName":"Ultra_Light_MShield"},
28914: {"AegisName":"Toughen_Time_Keepr_Shd"},
28915: {"AegisName":"Bunker_Shield_"},
28916: {"AegisName":"Gaia_Shield"},
28917: {"AegisName":"JP_Shield01_L"},
28918: {"AegisName":"Shield_Of_Chaos"},
28920: {"AegisName":"ShieldOfGuardsman_J"},
28921: {"AegisName":"Anemos_Shield"},
28922: {"AegisName":"Herald_Of_GOD_IL"},
28927: {"AegisName":"Kings_Guard"},
28928: {"AegisName":"Ultra_Light_MShieldJ"},
28929: {"AegisName":"HappyShield"},
28941: {"AegisName":"Excelion_Shield"},
28942: {"AegisName":"Bloody_Knight_Shield"},
28943: {"AegisName":"Forbidden_Grimoire"},
28944: {"AegisName":"Scutum_BR"},
28945: {"AegisName":"Bloody_Knight_Shield_"},
28946: {"AegisName":"Bloody_Knight_Shield__"},
28947: {"AegisName":"Gaia_Shield_BR"},
28948: {"AegisName":"Doram_Shield"},
28949: {"AegisName":"Jewel_Shield"},
28950: {"AegisName":"Variant_Shield"},
28951: {"AegisName":"Nero_Shield"},
28953: {"AegisName":"Poring_B_Shield"},
28955: {"AegisName":"Fotia_Shield"},
28956: {"AegisName":"Jirant_Mirror"},
28962: {"AegisName":"Haurvatat"},
28970: {"AegisName":"Rachel_Sheild_Cru"},
28972: {"AegisName":"aegis_28972"},
28973: {"AegisName":"aegis_28973"},
28974: {"AegisName":"aegis_28974"},
28977: {"AegisName":"aegis_28977"},
28979: {"AegisName":"aegis_28979"},
28980: {"AegisName":"aegis_28980"},
28982: {"AegisName":"aegis_28982"},
28983: {"AegisName":"aegis_28983"},
28984: {"AegisName":"aegis_28984"},
28985: {"AegisName":"aegis_28985"},
29000: {"AegisName":"Neev_INT_1"},
29001: {"AegisName":"Neev_INT_2"},
29002: {"AegisName":"Neev_INT_3"},
29003: {"AegisName":"Neev_DEX_1"},
29004: {"AegisName":"Neev_DEX_2"},
29005: {"AegisName":"Neev_DEX_3"},
29006: {"AegisName":"Neev_LUK_1"},
29007: {"AegisName":"Neev_LUK_2"},
29008: {"AegisName":"Neev_LUK_3"},
29009: {"AegisName":"Neev_VIT_1"},
29010: {"AegisName":"Neev_VIT_2"},
29011: {"AegisName":"Neev_VIT_3"},
29013: {"AegisName":"HPdrain3"},
29014: {"AegisName":"STR3INT"},
29015: {"AegisName":"STR3DEX"},
29016: {"AegisName":"INT3DEX"},
29017: {"AegisName":"INT3VIT"},
29018: {"AegisName":"DEX3VIT"},
29019: {"AegisName":"DEX3AGI"},
29020: {"AegisName":"VIT3AGI"},
29021: {"AegisName":"VIT3LUK"},
29022: {"AegisName":"AGI3LUK"},
29023: {"AegisName":"AGI3STR"},
29024: {"AegisName":"LUK3STR"},
29025: {"AegisName":"LUK3INT"},
29026: {"AegisName":"Def20"},
29027: {"AegisName":"EXP2"},
29028: {"AegisName":"Atk1p_Top"},
29029: {"AegisName":"Atk1p_Bottom"},
29030: {"AegisName":"Matk1p_Top"},
29031: {"AegisName":"Matk1p_Bottom"},
29032: {"AegisName":"SPdrain1_Top"},
29033: {"AegisName":"Mdef4_Bottom"},
29040: {"AegisName":"Ghost_Effect"},
29041: {"AegisName":"Twinkle_Effect"},
29045: {"AegisName":"Storm"},
29046: {"AegisName":"Greed"},
29047: {"AegisName":"Fatal0"},
29048: {"AegisName":"Expert_Archer0"},
29049: {"AegisName":"HP100_"},
29050: {"AegisName":"SP50_"},
29051: {"AegisName":"Detoxify"},
29052: {"AegisName":"Recovery"},
29053: {"AegisName":"Skill_Delay1_Top"},
29054: {"AegisName":"Skill_Delay1_Middle"},
29055: {"AegisName":"Skill_Delay1_Bottom"},
29056: {"AegisName":"FixedCasting05"},
29057: {"AegisName":"Kyrie"},
29061: {"AegisName":"Mettle1"},
29062: {"AegisName":"Mettle2"},
29063: {"AegisName":"Mettle3"},
29064: {"AegisName":"Mettle4"},
29065: {"AegisName":"Mettle5"},
29066: {"AegisName":"Mettle6"},
29067: {"AegisName":"Mettle7"},
29068: {"AegisName":"Mettle8"},
29069: {"AegisName":"Mettle9"},
29070: {"AegisName":"Mettle10"},
29071: {"AegisName":"MagicEessence1"},
29072: {"AegisName":"MagicEessence2"},
29073: {"AegisName":"MagicEessence3"},
29074: {"AegisName":"MagicEessence4"},
29075: {"AegisName":"MagicEessence5"},
29076: {"AegisName":"MagicEessence6"},
29077: {"AegisName":"MagicEessence7"},
29078: {"AegisName":"MagicEessence8"},
29079: {"AegisName":"MagicEessence9"},
29080: {"AegisName":"MagicEessence10"},
29081: {"AegisName":"Acute1"},
29082: {"AegisName":"Acute2"},
29083: {"AegisName":"Acute3"},
29084: {"AegisName":"Acute4"},
29085: {"AegisName":"Acute5"},
29086: {"AegisName":"Acute6"},
29087: {"AegisName":"Acute7"},
29088: {"AegisName":"Acute8"},
29089: {"AegisName":"Acute9"},
29090: {"AegisName":"Acute10"},
29091: {"AegisName":"MasterArcher1"},
29092: {"AegisName":"MasterArcher2"},
29093: {"AegisName":"MasterArcher3"},
29094: {"AegisName":"MasterArcher4"},
29095: {"AegisName":"MasterArcher5"},
29096: {"AegisName":"MasterArcher6"},
29097: {"AegisName":"MasterArcher7"},
29098: {"AegisName":"MasterArcher8"},
29099: {"AegisName":"MasterArcher9"},
29100: {"AegisName":"MasterArcher10"},
29101: {"AegisName":"Adamatine1"},
29102: {"AegisName":"Adamatine2"},
29103: {"AegisName":"Adamatine3"},
29104: {"AegisName":"Adamatine4"},
29105: {"AegisName":"Adamatine5"},
29106: {"AegisName":"Adamatine6"},
29107: {"AegisName":"Adamatine7"},
29108: {"AegisName":"Adamatine8"},
29109: {"AegisName":"Adamatine9"},
29110: {"AegisName":"Adamatine10"},
29111: {"AegisName":"Affection1"},
29112: {"AegisName":"Affection2"},
29113: {"AegisName":"Affection3"},
29114: {"AegisName":"Affection4"},
29115: {"AegisName":"Affection5"},
29116: {"AegisName":"Affection6"},
29117: {"AegisName":"Affection7"},
29118: {"AegisName":"Affection8"},
29119: {"AegisName":"Affection9"},
29120: {"AegisName":"Affection10"},
29121: {"AegisName":"JusticeOfGoddess_A"},
29122: {"AegisName":"JusticeOfGoddess_S"},
29123: {"AegisName":"LoveOfGoddess_A"},
29124: {"AegisName":"LoveOfGoddess_S"},
29125: {"AegisName":"InsightOfGoddess_A"},
29126: {"AegisName":"InsightOfGoddess_S"},
29127: {"AegisName":"Mana_Vermilion"},
29128: {"AegisName":"Mana_Braze"},
29129: {"AegisName":"Mana_Chrome"},
29130: {"AegisName":"Mana_Twilight"},
29131: {"AegisName":"Mana_Chaos"},
29132: {"AegisName":"Mana_Rise"},
29133: {"AegisName":"Mana_Heal"},
29134: {"AegisName":"Heart_Of_Winner"},
29135: {"AegisName":"Keen1"},
29136: {"AegisName":"Keen2"},
29137: {"AegisName":"Keen3"},
29138: {"AegisName":"Keen4"},
29139: {"AegisName":"Keen5"},
29140: {"AegisName":"Orcish_Hero_Of_Anger"},
29141: {"AegisName":"Roar_Of_Baphomet"},
29142: {"AegisName":"Electric_Effect"},
29143: {"AegisName":"Green_Floor_Effect"},
29144: {"AegisName":"Shrink_Effect"},
29145: {"AegisName":"EXP2MIDDLE"},
29146: {"AegisName":"Identify"},
29147: {"AegisName":"Resurrection"},
29148: {"AegisName":"AngelPoring_Purple"},
29149: {"AegisName":"AngelPoring_SkyBlue"},
29150: {"AegisName":"AngelPoring_Green"},
29151: {"AegisName":"AngelPoring_Pink"},
29152: {"AegisName":"AngelPoring_DeepRed"},
29153: {"AegisName":"AngelPoring_Clear"},
29154: {"AegisName":"FixedCasting03"},
29155: {"AegisName":"LexAeterna"},
29156: {"AegisName":"Casting_Top"},
29157: {"AegisName":"Casting_Middle"},
29158: {"AegisName":"Casting_Bottom"},
29159: {"AegisName":"EXP2TOP"},
29160: {"AegisName":"BlueAura_Effect"},
29161: {"AegisName":"Pink_Glow_Effect"},
29162: {"AegisName":"Shadow_Effect"},
29166: {"AegisName":"Reactor_A_Tolerance"},
29167: {"AegisName":"Reactor_A_HIT"},
29168: {"AegisName":"Reactor_A_FLEE"},
29169: {"AegisName":"Reactor_A_MDEF"},
29170: {"AegisName":"Reactor_S_ATK"},
29171: {"AegisName":"Reactor_S_MATK"},
29172: {"AegisName":"Reactor_S_Avoid"},
29173: {"AegisName":"Reactor_S_MHP"},
29174: {"AegisName":"Reactor_S_Quick"},
29175: {"AegisName":"Reactor_S_CRI"},
29176: {"AegisName":"Sky_Ground"},
29177: {"AegisName":"Kyoukou1"},
29178: {"AegisName":"Kyoukou2"},
29179: {"AegisName":"Kyoukou3"},
29180: {"AegisName":"Kyoukou4"},
29181: {"AegisName":"Kyoukou5"},
29182: {"AegisName":"Atk_Race_0"},
29183: {"AegisName":"Atk_Race_1"},
29184: {"AegisName":"Atk_Race_2"},
29185: {"AegisName":"Atk_Race_3"},
29186: {"AegisName":"Atk_Race_4"},
29187: {"AegisName":"Atk_Race_5"},
29188: {"AegisName":"Atk_Race_6"},
29189: {"AegisName":"Atk_Race_7"},
29190: {"AegisName":"Atk_Race_8"},
29191: {"AegisName":"Atk_Race_9"},
29192: {"AegisName":"Atk_Property_0"},
29193: {"AegisName":"Atk_Property_1"},
29194: {"AegisName":"Atk_Property_2"},
29195: {"AegisName":"Atk_Property_3"},
29196: {"AegisName":"Atk_Property_4"},
29197: {"AegisName":"Atk_Property_5"},
29198: {"AegisName":"Atk_Property_6"},
29199: {"AegisName":"Atk_Property_7"},
29200: {"AegisName":"Atk_Property_8"},
29201: {"AegisName":"Atk_Property_9"},
29202: {"AegisName":"Atk_Size_0"},
29203: {"AegisName":"Atk_Size_1"},
29204: {"AegisName":"Atk_Size_2"},
29205: {"AegisName":"Atk_Class_1"},
29206: {"AegisName":"Atk_Range"},
29207: {"AegisName":"Atk_Drain_HP"},
29208: {"AegisName":"SPdrain2_Top"},
29209: {"AegisName":"SPdrain2"},
29210: {"AegisName":"HPdrain23"},
29211: {"AegisName":"HPdrain23_Top"},
29212: {"AegisName":"HIT3"},
29213: {"AegisName":"HIT6"},
29214: {"AegisName":"E_Flameguard"},
29215: {"AegisName":"E_Warmth"},
29216: {"AegisName":"E_Genie"},
29217: {"AegisName":"E_Glorious"},
29218: {"AegisName":"E_Ghost"},
29219: {"AegisName":"E_Angelic"},
29220: {"AegisName":"E_Innoxious"},
29221: {"AegisName":"E_Divine"},
29222: {"AegisName":"E_Holy"},
29223: {"AegisName":"Water_Sky"},
29224: {"AegisName":"WhiteBody_Effect"},
29225: {"AegisName":"WaterField_Effect"},
29226: {"AegisName":"ExplodingWave_Effect"},
29227: {"AegisName":"Heal"},
29228: {"AegisName":"Steal"},
29229: {"AegisName":"Teleport"},
29230: {"AegisName":"JP_EV02"},
29231: {"AegisName":"Energy_Drop4"},
29232: {"AegisName":"Energy_Drop5"},
29233: {"AegisName":"Energy_Drop6"},
29234: {"AegisName":"Energy_Drop7"},
29235: {"AegisName":"Dodge1_J"},
29236: {"AegisName":"Dodge2_J"},
29237: {"AegisName":"Evasion5"},
29238: {"AegisName":"Evasion10"},
29239: {"AegisName":"Hit5"},
29240: {"AegisName":"Hit10"},
29241: {"AegisName":"Critical10"},
29242: {"AegisName":"IndestructibleArmor1"},
29243: {"AegisName":"NoDispell1"},
29244: {"AegisName":"PlayerTolerance1"},
29245: {"AegisName":"PlayerTolerance2"},
29246: {"AegisName":"PlayerTolerance3"},
29247: {"AegisName":"PlayerTolerance4"},
29248: {"AegisName":"PlayerTolerance5"},
29249: {"AegisName":"Neev_Rest_1"},
29250: {"AegisName":"Neev_Rest_2"},
29251: {"AegisName":"Neev_Rest_3"},
29252: {"AegisName":"Neev_Rest_4"},
29253: {"AegisName":"Neev_Eternity1"},
29254: {"AegisName":"Neev_Eternity2"},
29255: {"AegisName":"Neev_Eternity3"},
29256: {"AegisName":"Neev_Eternity4"},
29257: {"AegisName":"Neev_Eternity5"},
29258: {"AegisName":"Neev_Eternity6"},
29259: {"AegisName":"Neev_Eternity7"},
29260: {"AegisName":"Neev_Wound1"},
29261: {"AegisName":"Neev_Wound2"},
29262: {"AegisName":"Neev_Wound3"},
29263: {"AegisName":"Neev_Wound4"},
29264: {"AegisName":"Neev_Wound5"},
29265: {"AegisName":"Neev_Wound6"},
29266: {"AegisName":"Neev_Wound7"},
29267: {"AegisName":"Neev_Wound8"},
29268: {"AegisName":"Neev_Wound9"},
29269: {"AegisName":"Neev_Wound10"},
29270: {"AegisName":"Neev_Blood1"},
29271: {"AegisName":"Neev_Blood2"},
29272: {"AegisName":"Neev_Blood3"},
29273: {"AegisName":"Neev_Blood4"},
29274: {"AegisName":"Neev_Blood5"},
29275: {"AegisName":"Neev_Blood6"},
29276: {"AegisName":"Neev_Honor1"},
29277: {"AegisName":"Neev_Honor2"},
29278: {"AegisName":"Neev_Honor3"},
29279: {"AegisName":"Neev_Death1"},
29280: {"AegisName":"Neev_Death2"},
29281: {"AegisName":"Neev_Death3"},
29282: {"AegisName":"Neev_Death4"},
29300: {"AegisName":"Jade_J"},
29302: {"AegisName":"Armor_Water"},
29303: {"AegisName":"Armor_Wind"},
29304: {"AegisName":"Armor_Ground"},
29305: {"AegisName":"Armor_Fire"},
29306: {"AegisName":"Armor_Darkness"},
29307: {"AegisName":"Armor_Saint"},
29308: {"AegisName":"Armor_Undead"},
29309: {"AegisName":"Armor_Poison"},
29310: {"AegisName":"Racing_E_Rune1"},
29311: {"AegisName":"Racing_E_Rune2"},
29312: {"AegisName":"Racing_E_Rune3"},
29313: {"AegisName":"Racing_E_Royal1"},
29314: {"AegisName":"Racing_E_Royal2"},
29315: {"AegisName":"Racing_E_Royal3"},
29316: {"AegisName":"Racing_E_Mecha1"},
29317: {"AegisName":"Racing_E_Mecha2"},
29318: {"AegisName":"Racing_E_Mecha3"},
29319: {"AegisName":"Racing_E_Gene1"},
29320: {"AegisName":"Racing_E_Gene2"},
29321: {"AegisName":"Racing_E_Gene3"},
29322: {"AegisName":"Racing_E_Cross1"},
29323: {"AegisName":"Racing_E_Cross2"},
29324: {"AegisName":"Racing_E_Cross3"},
29325: {"AegisName":"Racing_E_Chaser1"},
29326: {"AegisName":"Racing_E_Chaser2"},
29327: {"AegisName":"Racing_E_Chaser3"},
29328: {"AegisName":"Racing_E_Warlock1"},
29329: {"AegisName":"Racing_E_Warlock2"},
29330: {"AegisName":"Racing_E_Warlock3"},
29331: {"AegisName":"Racing_E_Sorcer1"},
29332: {"AegisName":"Racing_E_Sorcer2"},
29333: {"AegisName":"Racing_E_Sorcer3"},
29334: {"AegisName":"Racing_E_Bishop1"},
29335: {"AegisName":"Racing_E_Bishop2"},
29336: {"AegisName":"Racing_E_Bishop3"},
29337: {"AegisName":"Racing_E_Sura1"},
29338: {"AegisName":"Racing_E_Sura2"},
29339: {"AegisName":"Racing_E_Sura3"},
29340: {"AegisName":"Racing_E_Ranger1"},
29341: {"AegisName":"Racing_E_Ranger2"},
29342: {"AegisName":"Racing_E_Ranger3"},
29343: {"AegisName":"Racing_E_Wand_Min1"},
29344: {"AegisName":"Racing_E_Wand_Min2"},
29345: {"AegisName":"Racing_E_Wand_Min3"},
29346: {"AegisName":"Racing_E_Gunner1"},
29347: {"AegisName":"Racing_E_Gunner2"},
29348: {"AegisName":"Racing_E_Gunner3"},
29349: {"AegisName":"Racing_E_Ninja1"},
29350: {"AegisName":"Racing_E_Ninja2"},
29351: {"AegisName":"Racing_E_Ninja3"},
29352: {"AegisName":"Racing_E_Super1"},
29353: {"AegisName":"Racing_E_Super2"},
29354: {"AegisName":"Racing_E_Super3"},
29355: {"AegisName":"Racing_E_Doram1"},
29356: {"AegisName":"Racing_E_Doram2"},
29357: {"AegisName":"Racing_E_Doram3"},
29358: {"AegisName":"Casting_Robe"},
29359: {"AegisName":"Fatal_Top"},
29360: {"AegisName":"Fatal_Bottom"},
29361: {"AegisName":"Fatal_Robe"},
29362: {"AegisName":"DoubleAttack"},
29366: {"AegisName":"Strong_Blow1"},
29367: {"AegisName":"Strong_Blow2"},
29368: {"AegisName":"Strong_Blow3"},
29369: {"AegisName":"Strong_Blow4"},
29370: {"AegisName":"Strong_Blow5"},
29371: {"AegisName":"Release_Of_Magic"},
29372: {"AegisName":"CastFixed_Delay50"},
29373: {"AegisName":"Skill_DelaySP"},
29374: {"AegisName":"ThriftSP"},
29375: {"AegisName":"PlayerTolerance6"},
29376: {"AegisName":"PlayerTolerance7"},
29377: {"AegisName":"PlayerTolerance8"},
29378: {"AegisName":"PlayerTolerance9"},
29379: {"AegisName":"PlayerTolerance10"},
29380: {"AegisName":"ATK5"},
29381: {"AegisName":"MATK5"},
29382: {"AegisName":"Neev_Honor_Hit"},
29383: {"AegisName":"Neev_Honor_Flee"},
29384: {"AegisName":"Neev_Honor_Luk"},
29385: {"AegisName":"Neev_Death_Tech"},
29386: {"AegisName":"Neev_Death_Luk"},
29423: {"AegisName":"Sura_Top"},
29424: {"AegisName":"Sura_Middle"},
29425: {"AegisName":"Sura_Bottom"},
29426: {"AegisName":"Sura_Robe"},
29427: {"AegisName":"Sura_Robe2"},
29428: {"AegisName":"Ranger_Top"},
29429: {"AegisName":"Ranger_Middle"},
29430: {"AegisName":"Ranger_Bottom"},
29431: {"AegisName":"Ranger_Robe"},
29432: {"AegisName":"Sorcerer_Top"},
29433: {"AegisName":"Sorcerer_Middle"},
29434: {"AegisName":"Sorcerer_Bottom"},
29435: {"AegisName":"Sorcerer_Robe"},
29436: {"AegisName":"Dynast"},
29438: {"AegisName":"ReactorZ_Knockback"},
29439: {"AegisName":"ReactorZ_Immortal"},
29440: {"AegisName":"ReactorZ_Killgain"},
29441: {"AegisName":"ReactorZ_Reincarnation"},
29442: {"AegisName":"ReactorZ_NoDispell"},
29443: {"AegisName":"ReactorZ_Clairvoyance"},
29444: {"AegisName":"ReactorZ_CastFixed"},
29445: {"AegisName":"Amplification1"},
29446: {"AegisName":"Amplification2"},
29447: {"AegisName":"Amplification3"},
29448: {"AegisName":"Amplification4"},
29449: {"AegisName":"Amplification5"},
29460: {"AegisName":"Runeknight_Top"},
29461: {"AegisName":"Runeknight_Middle"},
29462: {"AegisName":"Runeknight_Bottom"},
29463: {"AegisName":"Runeknight_Robe"},
29464: {"AegisName":"Genetic_Top"},
29465: {"AegisName":"Genetic_Middle"},
29466: {"AegisName":"Genetic_Bottom"},
29467: {"AegisName":"Genetic_Robe"},
29468: {"AegisName":"Warlock_Top"},
29469: {"AegisName":"Warlock_Middle"},
29470: {"AegisName":"Warlock_Bottom"},
29471: {"AegisName":"Warlock_Robe"},
29477: {"AegisName":"Shadowchaser_Top"},
29478: {"AegisName":"Shadowchaser_Middle"},
29479: {"AegisName":"Shadowchaser_Bottom"},
29480: {"AegisName":"Shadowchaser_Robe"},
29481: {"AegisName":"Mechanic_Top"},
29482: {"AegisName":"Mechanic_Middle"},
29483: {"AegisName":"Mechanic_Bottom"},
29484: {"AegisName":"Mechanic_Robe"},
29485: {"AegisName":"WanderMinstrel_Top"},
29486: {"AegisName":"WanderMinstrel_Middle"},
29487: {"AegisName":"WanderMinstrel_Bottom"},
29488: {"AegisName":"WanderMinstrel_Robe"},
29509: {"AegisName":"Hero"},
29510: {"AegisName":"Neev_Wound11"},
29511: {"AegisName":"Reactor_A_Player"},
29512: {"AegisName":"Endurance"},
29513: {"AegisName":"Highpriest_Top"},
29514: {"AegisName":"Highpriest_Middle"},
29515: {"AegisName":"Highpriest_Bottom"},
29516: {"AegisName":"Archbishop_Robe"},
29517: {"AegisName":"Paladin_Top"},
29518: {"AegisName":"Paladin_Middle"},
29519: {"AegisName":"Paladin_Bottom"},
29520: {"AegisName":"Royalguard_Robe"},
29521: {"AegisName":"Assassincross_Top"},
29522: {"AegisName":"Assassincross_Middle"},
29523: {"AegisName":"Assassincross_Bottom"},
29524: {"AegisName":"Guillotinecross_Robe"},
29525: {"AegisName":"NJ_1"},
29526: {"AegisName":"NJ_2"},
29527: {"AegisName":"Improve_Orb_Def"},
29528: {"AegisName":"Improve_Orb_Mdef"},
29529: {"AegisName":"Improve_Orb_HealHP"},
29530: {"AegisName":"Improve_Orb_Spirit"},
29531: {"AegisName":"Improve_Orb_Health"},
29532: {"AegisName":"Improve_Orb_HealSP"},
29533: {"AegisName":"Improve_Orb_Heal"},
29534: {"AegisName":"Improve_Orb_Atk"},
29535: {"AegisName":"Improve_Orb_Matk"},
29536: {"AegisName":"Improve_Orb_Archer"},
29537: {"AegisName":"Improve_Orb_Speed"},
29538: {"AegisName":"Improve_Orb_Cast"},
29539: {"AegisName":"Improve_Orb_Cri"},
29540: {"AegisName":"Improve_Orb_Delay"},
29541: {"AegisName":"Improve_Orb_Fix"},
29542: {"AegisName":"Improve_Orb_Above"},
29543: {"AegisName":"Improve_Orb_Life"},
29544: {"AegisName":"Improve_Orb_Soul"},
29545: {"AegisName":"Improve_Orb_M_Heal"},
29546: {"AegisName":"Improve_Orb_M_Soul"},
29547: {"AegisName":"Improve_Orb_L_Vit"},
29548: {"AegisName":"Improve_Orb_L_INT"},
29549: {"AegisName":"Improve_Orb_L_DEX"},
29550: {"AegisName":"Improve_Orb_L_STR"},
29551: {"AegisName":"Improve_Orb_L_AGI"},
29552: {"AegisName":"Improve_Orb_L_LUK"},
29579: {"AegisName":"Racing_E_Star1"},
29580: {"AegisName":"Racing_E_Star2"},
29581: {"AegisName":"Racing_E_Star3"},
29582: {"AegisName":"Racing_E_Soul1"},
29583: {"AegisName":"Racing_E_Soul2"},
29584: {"AegisName":"Racing_E_Soul3"},
29585: {"AegisName":"Arcana"},
29586: {"AegisName":"PlayerTolerance12"},
29587: {"AegisName":"Gh_md_agi"},
29588: {"AegisName":"Gh_md_str"},
29589: {"AegisName":"Gh_md_dex"},
29590: {"AegisName":"Gh_md_int"},
29591: {"AegisName":"Gh_md_vit"},
29592: {"AegisName":"Gh_md_luk"},
29593: {"AegisName":"Unfrozen_JP"},
29594: {"AegisName":"Seyren_Memory"},
29595: {"AegisName":"Harword_Memory"},
29596: {"AegisName":"Eremes_Memory"},
29598: {"AegisName":"Katrinn_Memory"},
29599: {"AegisName":"Magaleta_Memory"},
29600: {"AegisName":"Shecil_Memory"},
29601: {"AegisName":"Randel_Memory"},
29602: {"AegisName":"Flamel_Memory"},
29603: {"AegisName":"Gertie_Memory"},
29604: {"AegisName":"Celia_Memory"},
29605: {"AegisName":"Chen_Memory"},
29606: {"AegisName":"Tren_Memory"},
29607: {"AegisName":"Alpho_Memory"},
29611: {"AegisName":"Sura_Bottom2"},
29612: {"AegisName":"Sura_Middle2"},
29613: {"AegisName":"Sura_Top2"},
29614: {"AegisName":"Sorcerer_Robe2"},
29615: {"AegisName":"Sorcerer_Bottom2"},
29616: {"AegisName":"Sorcerer_Middle2"},
29617: {"AegisName":"Sorcerer_Top2"},
29618: {"AegisName":"Shadowchaser_Robe2"},
29619: {"AegisName":"Shadowchaser_Bottom2"},
29620: {"AegisName":"Shadowchaser_Middle2"},
29621: {"AegisName":"Shadowchaser_Top2"},
29646: {"AegisName":"Lucky_Amulet6"},
29647: {"AegisName":"Lucky_Amulet7"},
29648: {"AegisName":"Lucky_Amulet8"},
29649: {"AegisName":"IgnoreDef50"},
29650: {"AegisName":"IgnoreMdef50"},
29651: {"AegisName":"Soullinker_Top"},
29652: {"AegisName":"Soullinker_Middle"},
29653: {"AegisName":"Soullinker_Bottom"},
29654: {"AegisName":"Soulreaper_Robe"},
29655: {"AegisName":"Gladiator_Top"},
29656: {"AegisName":"Gladiator_Middle"},
29657: {"AegisName":"Gladiator_Bottom"},
29658: {"AegisName":"Staremperor_Robe"},
29659: {"AegisName":"Ninja_Top"},
29660: {"AegisName":"Ninja_Middle"},
29661: {"AegisName":"Ninja_Bottom"},
29662: {"AegisName":"Kagerou_Robe"},
29663: {"AegisName":"Oboro_Robe"},
29664: {"AegisName":"Gunslinger_Top"},
29665: {"AegisName":"Gunslinger_Middle"},
29666: {"AegisName":"Gunslinger_Bottom"},
29667: {"AegisName":"Rebellion_Robe"},
29668: {"AegisName":"Doram_Top"},
29669: {"AegisName":"Doram_Middle"},
29670: {"AegisName":"Doram_Bottom"},
29671: {"AegisName":"Doram_Robe"},
29672: {"AegisName":"Time_Jewely_Str_1"},
29673: {"AegisName":"Time_Jewely_Str_2"},
29674: {"AegisName":"Time_Jewely_Str_3"},
29675: {"AegisName":"Time_Jewely_Agi_1"},
29676: {"AegisName":"Time_Jewely_Agi_2"},
29677: {"AegisName":"Time_Jewely_Agi_3"},
29678: {"AegisName":"Time_Jewely_Vit_1"},
29679: {"AegisName":"Time_Jewely_Vit_2"},
29680: {"AegisName":"Time_Jewely_Vit_3"},
29681: {"AegisName":"Time_Jewely_Int_1"},
29682: {"AegisName":"Time_Jewely_Int_2"},
29683: {"AegisName":"Time_Jewely_Int_3"},
29684: {"AegisName":"Time_Jewely_Dex_1"},
29685: {"AegisName":"Time_Jewely_Dex_2"},
29686: {"AegisName":"Time_Jewely_Dex_3"},
29687: {"AegisName":"Time_Jewely_Luk_1"},
29688: {"AegisName":"Time_Jewely_Luk_2"},
29689: {"AegisName":"Time_Jewely_Luk_3"},
29690: {"AegisName":"Wepon_Property_Fire"},
29691: {"AegisName":"Wepon_Property_Water"},
29692: {"AegisName":"Wepon_Property_Wind"},
29693: {"AegisName":"Wepon_Property_Ground"},
29695: {"AegisName":"Wepon_Property_Darkness"},
29696: {"AegisName":"Wepon_Property_Telekine"},
29697: {"AegisName":"Wepon_Property_Poison"},
29698: {"AegisName":"Matk_Race_0"},
29699: {"AegisName":"Matk_Race_2"},
29700: {"AegisName":"Matk_Race_7"},
29701: {"AegisName":"Matk_Property_1"},
29702: {"AegisName":"Matk_Property_7"},
29703: {"AegisName":"Matk_Property_9"},
29704: {"AegisName":"Matk_Size_0"},
29705: {"AegisName":"Matk_Class_1"},
29706: {"AegisName":"Tenacity1"},
29707: {"AegisName":"Tenacity2"},
29708: {"AegisName":"Tenacity3"},
29709: {"AegisName":"Tenacity4"},
29710: {"AegisName":"Tenacity5"},
29711: {"AegisName":"Tenacity6"},
29712: {"AegisName":"Tenacity7"},
29713: {"AegisName":"Tenacity8"},
29714: {"AegisName":"Tenacity9"},
29715: {"AegisName":"Tenacity10"},
29716: {"AegisName":"StarE_Enchant_1"},
29717: {"AegisName":"StarE_Enchant_2"},
29718: {"AegisName":"StarE_Enchant_3"},
29719: {"AegisName":"SoulR_Enchant_1"},
29720: {"AegisName":"SoulR_Enchant_2"},
29721: {"AegisName":"SoulR_Enchant_3"},
29722: {"AegisName":"Curse_Effect_J"},
29723: {"AegisName":"Star_Effect_J"},
29724: {"AegisName":"Murderous_Grudge"},
29725: {"AegisName":"aegis_29725"},
29727: {"AegisName":"aegis_29727"},
31000: {"AegisName":"Rudo_Card_J"},
31001: {"AegisName":"Lora_Card_J"},
31002: {"AegisName":"Elvira_Card_J"},
31003: {"AegisName":"Gioia_Card_J"},
31004: {"AegisName":"Soheon_Card_J"},
31005: {"AegisName":"Daehyon_Card_J"},
31006: {"AegisName":"LoVA_Hades_Card"},
31007: {"AegisName":"LoVA_R_Hades_Card"},
31008: {"AegisName":"LoVA_Lulu_Card"},
31009: {"AegisName":"LoVA_R_Lulu_Card"},
31010: {"AegisName":"LoVA_Kima_Card"},
31011: {"AegisName":"LoVA_R_Kima_Card"},
31012: {"AegisName":"LoVA_Bahamut_Card"},
31013: {"AegisName":"LoVA_R_Bahamut_Card"},
31014: {"AegisName":"LoVA_Ragnarok_Card"},
31015: {"AegisName":"LoVA_R_Ragnarok_Card"},
31016: {"AegisName":"XM_Tree_Card"},
31017: {"AegisName":"XM_Cookie_Card"},
31018: {"AegisName":"XM_Mystcase_Card"},
31019: {"AegisName":"XM_Lude_Card"},
31020: {"AegisName":"XM_Hylozoist_Card"},
31021: {"AegisName":"XM_Marionette_Card"},
31022: {"AegisName":"XM_Teddy_Bear_Card"},
31023: {"AegisName":"XM_Celine_Kimi_Card"},
31024: {"AegisName":"As_Bdy_Knight_Card"},
31025: {"AegisName":"As_Wind_Ghost_Card"},
31026: {"AegisName":"As_Ragged_Golem_Card"},
31027: {"AegisName":"C_Pretty_Bear"},
31028: {"AegisName":"C_Black_Cat_Hood"},
31029: {"AegisName":"C_Pig_Nose"},
31030: {"AegisName":"C_Tiger_Face"},
31031: {"AegisName":"C_Tare_Pope_Casual"},
31032: {"AegisName":"C_Tare_Luwmin"},
31033: {"AegisName":"C_BelieversCap"},
31034: {"AegisName":"C_Pirate_Bandana"},
31035: {"AegisName":"C_Bankruptcy_Of_Heart"},
31036: {"AegisName":"C_Satto_Hat"},
31037: {"AegisName":"C_Beret"},
31038: {"AegisName":"C_Cheks_Vandana"},
31039: {"AegisName":"C_Kings_Crown"},
31040: {"AegisName":"C_Magical_Feather"},
31041: {"AegisName":"C_Cat_Lace_Hairband"},
31042: {"AegisName":"C_Survive_Circlet"},
31043: {"AegisName":"C_Ribbon_White"},
31044: {"AegisName":"C_Pink_Drooping_Kitty"},
31045: {"AegisName":"C_Blue_Rear_Ribbon"},
31046: {"AegisName":"C_White_Rose_Princess"},
31047: {"AegisName":"C_First_Love_Cheek"},
31048: {"AegisName":"C_White_Lily_Balck"},
31049: {"AegisName":"C_Marin_Crown"},
31050: {"AegisName":"C_Flower_Poring_Hat"},
31051: {"AegisName":"C_HappySummer_SunVisor"},
31052: {"AegisName":"C_Alchemist_Mask"},
31053: {"AegisName":"C_King_Tiger_Doll_Hat"},
31054: {"AegisName":"C_Sting_Hat"},
31055: {"AegisName":"C_Poring_Soap_Pipe"},
31056: {"AegisName":"C_Exploding_Wave_Red"},
31057: {"AegisName":"C_Eremes_Scarf_Black"},
31058: {"AegisName":"C_Gelato_Hat"},
31059: {"AegisName":"C_Sailor_Hat"},
31060: {"AegisName":"C_Starfish_Headband"},
31061: {"AegisName":"C_Forceps_Hairpin"},
31062: {"AegisName":"C_Eleanor_Wig"},
31063: {"AegisName":"C_Hair_Bun_BU"},
31064: {"AegisName":"C_Hair_Bun_RD"},
31065: {"AegisName":"C_Hair_Bun_YL"},
31066: {"AegisName":"C_Hair_Bun_GN"},
31067: {"AegisName":"C_Hair_Bun_BL"},
31068: {"AegisName":"C_Hair_Bun_WH"},
31069: {"AegisName":"C_Hair_Bun_OM"},
31070: {"AegisName":"C_Hair_Bun_PP"},
31071: {"AegisName":"C_Roll_Twin_BU"},
31072: {"AegisName":"C_Roll_Twin_RD"},
31073: {"AegisName":"C_Roll_Twin_YL"},
31074: {"AegisName":"C_Roll_Twin_GN"},
31075: {"AegisName":"C_Roll_Twin_BL"},
31076: {"AegisName":"C_Roll_Twin_WH"},
31077: {"AegisName":"C_Roll_Twin_OM"},
31078: {"AegisName":"C_Roll_Twin_PP"},
31079: {"AegisName":"C_Long_Pony_BU"},
31080: {"AegisName":"C_Long_Pony_RD"},
31081: {"AegisName":"C_Long_Pony_YL"},
31082: {"AegisName":"C_Long_Pony_GN"},
31083: {"AegisName":"C_Long_Pony_BL"},
31084: {"AegisName":"C_Long_Pony_WH"},
31085: {"AegisName":"C_Long_Pony_OM"},
31086: {"AegisName":"C_Long_Pony_PP"},
31087: {"AegisName":"C_Dwarf_Beard"},
31088: {"AegisName":"C_Mad_Hatter"},
31089: {"AegisName":"C_Exploding_Wave_Sca"},
31090: {"AegisName":"C_Angeling_Wanna_Fly"},
31091: {"AegisName":"C_Gold_Shower"},
31092: {"AegisName":"C_Rabbit_Ribbon"},
31093: {"AegisName":"C_Underlamp"},
31094: {"AegisName":"C_Dice_Hat"},
31095: {"AegisName":"C_JP_EV01"},
31096: {"AegisName":"C_JP_EV02"},
31097: {"AegisName":"C_JP_EV03"},
31098: {"AegisName":"C_JP_EV04"},
31099: {"AegisName":"C_JP_EV05"},
31100: {"AegisName":"C_JP_EV06"},
31101: {"AegisName":"C_JP_EV07"},
31102: {"AegisName":"C_JP_EV08"},
31103: {"AegisName":"C_JP_EV09"},
31104: {"AegisName":"C_JP_EV10"},
31105: {"AegisName":"C_RoCelebrationHat"},
31106: {"AegisName":"Eye_Patch_Blue"},
31107: {"AegisName":"Eye_Patch_Red"},
31108: {"AegisName":"C_Free_Hug_BR"},
31109: {"AegisName":"C_Guildsman_Recruit_BR"},
31110: {"AegisName":"C_Party_Seeker_BR"},
31111: {"AegisName":"C_Party_Mem_Recruit_BR"},
31112: {"AegisName":"C_Begging_Board_BR"},
31113: {"AegisName":"C_Doctor_Cap"},
31114: {"AegisName":"C_Pretend_Murdered"},
31115: {"AegisName":"C_Truemoney_TH"},
31116: {"AegisName":"C_Truemoney_TH7"},
31117: {"AegisName":"C_Hoplite_Helmet"},
31118: {"AegisName":"C_Assassin_Skull_Mask"},
31119: {"AegisName":"C_Blue_Wizardry_Hat"},
31120: {"AegisName":"C_Vampire_Familiar"},
31121: {"AegisName":"C_Stall_Of_Bat"},
31122: {"AegisName":"C_Bloody_Stop_Bandage"},
31123: {"AegisName":"C_Ghostring_Tall_Hat"},
31124: {"AegisName":"C_Ribbon_Chef_Hat"},
31125: {"AegisName":"C_QueenAnzRevenge"},
31126: {"AegisName":"C_Nestea_Hat"},
31127: {"AegisName":"C_Taiwan_Flag_Hat"},
31128: {"AegisName":"C_Bride_Mask"},
31129: {"AegisName":"C_Mr_Scream"},
31130: {"AegisName":"C_Indian_Hair_Piece"},
31131: {"AegisName":"C_Holy_Bonnet"},
31132: {"AegisName":"C_Christmas_Wreath"},
31133: {"AegisName":"C_Gambler_Seal"},
31134: {"AegisName":"C_Chatty_Parrot"},
31135: {"AegisName":"C_Fancy_Mini_Crown"},
31136: {"AegisName":"C_Clock_Casket"},
31137: {"AegisName":"C_Blue_Rose_Ornament"},
31138: {"AegisName":"C_Piamette_Hood_Red"},
31139: {"AegisName":"C_White_Rabbit_Ear"},
31140: {"AegisName":"C_Cowboy_Hat_B"},
31141: {"AegisName":"C_Cactus_Corsage"},
31142: {"AegisName":"C_Time_Accessory_J"},
31143: {"AegisName":"C_Krathong_Crown_TH"},
31144: {"AegisName":"C_Indi_Feather_Band"},
31145: {"AegisName":"C_AliceFriesinger_Hat69"},
31146: {"AegisName":"C_KarduiEar"},
31147: {"AegisName":"C_Tare_Domovoi"},
31148: {"AegisName":"C_Debril_Doll_Hat"},
31149: {"AegisName":"C_Nydhog_Wig"},
31150: {"AegisName":"C_Shalosh_Head_Dress"},
31151: {"AegisName":"C_Chasher_Ear"},
31152: {"AegisName":"C_Piamette_BowTie_Red"},
31153: {"AegisName":"C_Aniv_Star_Hat2"},
31154: {"AegisName":"C_Cap"},
31155: {"AegisName":"C_Spinning_Eyes"},
31156: {"AegisName":"C_Fruit_Shell"},
31157: {"AegisName":"C_Spirit_Chain"},
31158: {"AegisName":"C_Squirrel_Ear_Hat"},
31159: {"AegisName":"C_Jormungandr_Hat"},
31160: {"AegisName":"C_Rune_Helm"},
31161: {"AegisName":"C_Tiger_Mask"},
31162: {"AegisName":"C_Shaving_Foam"},
31163: {"AegisName":"C_Sheep_Hat"},
31164: {"AegisName":"C_Brown_Stall"},
31165: {"AegisName":"C_Piggyback"},
31166: {"AegisName":"C_Teddy_Bear_Hood"},
31167: {"AegisName":"C_Lunatic_Ear_Black"},
31168: {"AegisName":"C_Mouton_Life_BL"},
31169: {"AegisName":"C_Hat_Of_Outlaw"},
31170: {"AegisName":"C_Power_Of_Thor"},
31171: {"AegisName":"C_Cat_Hat"},
31172: {"AegisName":"C_Roast_Memory"},
31173: {"AegisName":"C_Crown_Parrot"},
31174: {"AegisName":"C_Weird_Bread_Bag"},
31175: {"AegisName":"C_Strawberry_Hat"},
31176: {"AegisName":"C_Looking"},
31177: {"AegisName":"C_Tail_Hat"},
31178: {"AegisName":"C_Flame_Muffler"},
31179: {"AegisName":"C_Wolf_Masquerade"},
31180: {"AegisName":"C_Shura_King_Pledge"},
31181: {"AegisName":"C_Necklace_Rosary"},
31182: {"AegisName":"C_Side_Cap"},
31183: {"AegisName":"C_Fallen_Angel_Blessing"},
31184: {"AegisName":"C_Hawkeyes"},
31185: {"AegisName":"C_Engineer_Cap"},
31186: {"AegisName":"C_Black_Cat"},
31187: {"AegisName":"C_War_Princess_Ribbon"},
31188: {"AegisName":"C_Mono_Gothic_Bonnet"},
31189: {"AegisName":"C_Cat_Ears_Cape_Red"},
31190: {"AegisName":"C_Angel_Mini_Silk_Hat_B"},
31191: {"AegisName":"C_Whikebain_Ears_TW"},
31192: {"AegisName":"C_Baby_Cat_Ears_TW"},
31193: {"AegisName":"C_Tare_Ahat"},
31194: {"AegisName":"C_Spinning_Propeller"},
31195: {"AegisName":"C_Choco_Minihat"},
31196: {"AegisName":"C_JP_EV12"},
31197: {"AegisName":"C_Egg_Crispinette"},
31198: {"AegisName":"C_Octopus_Hat_J"},
31199: {"AegisName":"C_Weird_Goatee"},
31200: {"AegisName":"C_Wrapping_Ribbon"},
31201: {"AegisName":"C_Royal_Rabbit_Crown"},
31202: {"AegisName":"C_Dog_Officer"},
31203: {"AegisName":"C_Charcoal_Stove"},
31204: {"AegisName":"C_Drooping_White_Kitty"},
31205: {"AegisName":"C_L_Orc_Hero_Helm"},
31206: {"AegisName":"C_Rune_Hairband"},
31207: {"AegisName":"C_Dokkebi_Mask"},
31208: {"AegisName":"C_Straight_Long_YL"},
31209: {"AegisName":"C_Straight_Long_WH"},
31210: {"AegisName":"C_Side_Pigtail_BU"},
31211: {"AegisName":"C_Side_Pigtail_RD"},
31212: {"AegisName":"C_Side_Pigtail_YL"},
31213: {"AegisName":"C_Side_Pigtail_GN"},
31214: {"AegisName":"C_Side_Pigtail_BL"},
31215: {"AegisName":"C_Side_Pigtail_WH"},
31216: {"AegisName":"C_Side_Pigtail_OM"},
31217: {"AegisName":"C_Side_Pigtail_PP"},
31218: {"AegisName":"C_Low_Pony_BU"},
31219: {"AegisName":"C_Low_Pony_RD"},
31220: {"AegisName":"C_Low_Pony_YL"},
31221: {"AegisName":"C_Low_Pony_GN"},
31222: {"AegisName":"C_Low_Pony_BL"},
31223: {"AegisName":"C_Low_Pony_WH"},
31224: {"AegisName":"C_Low_Pony_OM"},
31225: {"AegisName":"C_Low_Pony_PP"},
31226: {"AegisName":"C_Long_Twin_BU"},
31227: {"AegisName":"C_Long_Twin_RD"},
31228: {"AegisName":"C_Long_Twin_YL"},
31229: {"AegisName":"C_Long_Twin_GN"},
31230: {"AegisName":"C_Long_Twin_BL"},
31231: {"AegisName":"C_Long_Twin_WH"},
31232: {"AegisName":"C_Long_Twin_OM"},
31233: {"AegisName":"C_Long_Twin_PP"},
31234: {"AegisName":"C_Persika_J"},
31235: {"AegisName":"C_Large_Ribbonmuffler_V"},
31236: {"AegisName":"C_Subject_Aura_V"},
31237: {"AegisName":"C_Pope_Ribbon_V"},
31238: {"AegisName":"C_Good_Wedding_Veil_V"},
31239: {"AegisName":"C_Love_Rabbithood_V"},
31240: {"AegisName":"C_Whisper_Mask_V"},
31241: {"AegisName":"C_Blazing_Sun_V"},
31242: {"AegisName":"C_Anubis_Helm_V"},
31243: {"AegisName":"C_Tongue_Mask_V"},
31244: {"AegisName":"C_Sky_Helm_V"},
31245: {"AegisName":"C_Bell_Flower"},
31246: {"AegisName":"C_Humming_Bird"},
31247: {"AegisName":"C_Hippo_Hat"},
31248: {"AegisName":"C_Isabella_Red_Ear"},
31249: {"AegisName":"C_Rabbit_Hopping"},
31250: {"AegisName":"C_Wonderful_Beast_Ear"},
31251: {"AegisName":"C_Cat_Mouth"},
31252: {"AegisName":"C_Cat_Ear_Hat_White"},
31253: {"AegisName":"C_Bright_Fury"},
31254: {"AegisName":"C_Horse_King_Red"},
31255: {"AegisName":"C_Dalcom_Helmet"},
31256: {"AegisName":"C_Jaguar_Hat_J"},
31257: {"AegisName":"C_Clay_Poring_Jar"},
31258: {"AegisName":"C_White_Clay_Filler"},
31259: {"AegisName":"C_Bubble_A_Angel_H"},
31260: {"AegisName":"C_Observer_J"},
31261: {"AegisName":"C_Soda_In_Mouth"},
31262: {"AegisName":"C_Disposable_3D_Glass"},
31263: {"AegisName":"C_Disposable_Popcorn"},
31264: {"AegisName":"C_Shelterwing_Ears_V"},
31265: {"AegisName":"C_Straightpony_BU_V"},
31266: {"AegisName":"C_Straightpony_RD_V"},
31267: {"AegisName":"C_Straightpony_YL_V"},
31268: {"AegisName":"C_Straightpony_GN_V"},
31269: {"AegisName":"C_Straightpony_BL_V"},
31270: {"AegisName":"C_Straightpony_WH_V"},
31271: {"AegisName":"C_Straightpony_OM_V"},
31272: {"AegisName":"C_Straightpony_PP_V"},
31273: {"AegisName":"C_Cowlick_BU_V"},
31274: {"AegisName":"C_Cowlick_RD_V"},
31275: {"AegisName":"C_Cowlick_YL_V"},
31276: {"AegisName":"C_Cowlick_GN_V"},
31277: {"AegisName":"C_Cowlick_BL_V"},
31278: {"AegisName":"C_Cowlick_WH_V"},
31279: {"AegisName":"C_Cowlick_OM_V"},
31280: {"AegisName":"C_Cowlick_PP_V"},
31281: {"AegisName":"C_Loosewavetwin_BU_V"},
31282: {"AegisName":"C_Loosewavetwin_RD_V"},
31283: {"AegisName":"C_Loosewavetwin_YL_V"},
31284: {"AegisName":"C_Loosewavetwin_GN_V"},
31285: {"AegisName":"C_Loosewavetwin_BL_V"},
31286: {"AegisName":"C_Loosewavetwin_WH_V"},
31287: {"AegisName":"C_Loosewavetwin_OM_V"},
31288: {"AegisName":"C_Loosewavetwin_PP_V"},
31289: {"AegisName":"C_Wing_Ear_BL_V"},
31290: {"AegisName":"C_Adv_Ang_SchCap"},
31291: {"AegisName":"C_Adv_Dev_SchCap"},
31292: {"AegisName":"C_Invisible_Mask_TW"},
31293: {"AegisName":"C_Kings_Crown_Purple"},
31294: {"AegisName":"C_Jirant_Circlet_Red"},
31295: {"AegisName":"C_Priest_Hat_J"},
31296: {"AegisName":"C_Strawberry_In_Mouth"},
31297: {"AegisName":"C_Love_Berry"},
31298: {"AegisName":"C_Para_Team_Hat2"},
31299: {"AegisName":"C_White_Rabbit"},
31300: {"AegisName":"C_Warm_Cat_Muffler"},
31301: {"AegisName":"C_Blinking_Eyes"},
31302: {"AegisName":"C_Black_Magenta_Ribbon"},
31303: {"AegisName":"C_Memory_Of_Noodle"},
31304: {"AegisName":"C_Fan_Of_Summer"},
31305: {"AegisName":"C_TW_1th_Balloon"},
31306: {"AegisName":"C_Tucan_Hat_JP"},
31307: {"AegisName":"C_Blue_Arara_Hat"},
31308: {"AegisName":"C_Protect_Feathers"},
31309: {"AegisName":"C_PW_Marching_Hat"},
31310: {"AegisName":"C_666_DevilEar"},
31311: {"AegisName":"C_Tha_Maero_Mask_J"},
31312: {"AegisName":"C_Hades_Helm"},
31313: {"AegisName":"C_FallenAngelWingEar"},
31314: {"AegisName":"C_Ghost_Holiday"},
31315: {"AegisName":"C_Stall_Of_Angel"},
31316: {"AegisName":"C_FlutterButterfly_BL"},
31317: {"AegisName":"C_15th_Anniversary_Wing"},
31318: {"AegisName":"C_Gerhard_Von_Devi"},
31319: {"AegisName":"C_Fan_Of_Summer_R"},
31320: {"AegisName":"C_Pinwheel_Cap_R"},
31321: {"AegisName":"C_Shining_Sunflower"},
31322: {"AegisName":"C_Candy_Hat"},
31323: {"AegisName":"C_Love_Daddy"},
31324: {"AegisName":"C_DJ_Kitty"},
31325: {"AegisName":"C_Q_Scaraba_Crown"},
31326: {"AegisName":"C_Rolf_Von_Gigue_666"},
31327: {"AegisName":"C_Stretched_Nose_M"},
31328: {"AegisName":"C_Faceworm_Egg_Shell"},
31329: {"AegisName":"C_Alice_Wig"},
31330: {"AegisName":"C_Fallen_Angel_Valletta"},
31331: {"AegisName":"C_Chung_E_Shinyon_Cap"},
31332: {"AegisName":"C_Khalitzburg_Helm_BL"},
31333: {"AegisName":"C_Straight_Pony_WH_V"},
31334: {"AegisName":"C_Straight_Pony_BU_V"},
31335: {"AegisName":"C_Straight_Pony_OM_V"},
31336: {"AegisName":"C_Straight_Pony_RD_V"},
31337: {"AegisName":"C_Straight_Pony_PP_V"},
31338: {"AegisName":"C_Straight_Pony_GN_V"},
31339: {"AegisName":"C_Straight_Pony_YL_V"},
31340: {"AegisName":"C_Straight_Pony_BL_V"},
31341: {"AegisName":"C_Low_Pony_BU_V"},
31342: {"AegisName":"C_Low_Pony_RD_V"},
31343: {"AegisName":"C_Low_Pony_YL_V"},
31344: {"AegisName":"C_Low_Pony_GN_V"},
31345: {"AegisName":"C_Low_Pony_BL_V"},
31346: {"AegisName":"C_Low_Pony_WH_V"},
31347: {"AegisName":"C_Low_Pony_OM_V"},
31348: {"AegisName":"C_Low_Pony_PP_V"},
31349: {"AegisName":"C_Roll_Twin_BU_V"},
31350: {"AegisName":"C_Roll_Twin_RD_V"},
31351: {"AegisName":"C_Roll_Twin_YL_V"},
31352: {"AegisName":"C_Roll_Twin_GN_V"},
31353: {"AegisName":"C_Roll_Twin_BL_V"},
31354: {"AegisName":"C_Roll_Twin_WH_V"},
31355: {"AegisName":"C_Roll_Twin_OM_V"},
31356: {"AegisName":"C_Roll_Twin_PP_V"},
31357: {"AegisName":"Oliver_Wolf_Hood_CN"},
31358: {"AegisName":"C_Hahoe_Mask_CN"},
31359: {"AegisName":"C_Assassin_Mask_CN"},
31360: {"AegisName":"C_Centimental_Flower_CN"},
31361: {"AegisName":"C_Blush_CN"},
31362: {"AegisName":"C_Magestic_Goat_CN"},
31363: {"AegisName":"C_Frog_Cap_CN"},
31364: {"AegisName":"C_Deviruchi_Cap_CN"},
31365: {"AegisName":"C_Boys_Cap_CN"},
31366: {"AegisName":"C_Valkyrie_Helm_CN"},
31367: {"AegisName":"C_Wish_Tree_Hat"},
31368: {"AegisName":"C_Harvest_Festa_Hat"},
31369: {"AegisName":"C_Straight_Long_WHK"},
31370: {"AegisName":"C_Straight_Long_YLK"},
31371: {"AegisName":"C_Sorin_Doll_Hat"},
31372: {"AegisName":"C_Binit_Doll_Hat"},
31373: {"AegisName":"C_Kings_Crown_"},
31374: {"AegisName":"C_Explosion_Gum"},
31375: {"AegisName":"C_Demons_Eye"},
31376: {"AegisName":"C_Jirant_Circlet"},
31377: {"AegisName":"C_Glastheim_Onlooker"},
31378: {"AegisName":"C_CatharinaPawnBrad60"},
31379: {"AegisName":"C_Drama_Clockwork"},
31380: {"AegisName":"C_Gossip_Raven"},
31381: {"AegisName":"C_Diabolic_Lapel"},
31382: {"AegisName":"C_Cat_Ears_Punkish"},
31383: {"AegisName":"C_Volume_Low_Twin"},
31384: {"AegisName":"C_False_Ears"},
31385: {"AegisName":"C_Gothic_Pumpkin_Head"},
31386: {"AegisName":"C_SurviveOrb"},
31387: {"AegisName":"C_Jjakk"},
31388: {"AegisName":"C_Garden_Of_Eden"},
31389: {"AegisName":"C_White_Bird_Rose"},
31390: {"AegisName":"C_Let_It_Snow"},
31391: {"AegisName":"C_Floating_Stone_Of_Int"},
31392: {"AegisName":"C_Radio_Antenna"},
31393: {"AegisName":"C_Vajra"},
31394: {"AegisName":"C_White_Wizardry_Hat"},
31395: {"AegisName":"C_Book_Of_Magic"},
31396: {"AegisName":"C_Sorcerer_Hood"},
31397: {"AegisName":"C_Pope_Sitting_Head"},
31398: {"AegisName":"C_Blinking_Thin_Eyes"},
31399: {"AegisName":"C_Darkness_Veil"},
31400: {"AegisName":"C_Ribbon"},
31401: {"AegisName":"C_Blue_Coif"},
31402: {"AegisName":"C_Idun_Green_Apple"},
31403: {"AegisName":"C_Wall"},
31404: {"AegisName":"C_Poring_Traffic_Light"},
31405: {"AegisName":"C_Eleanor_Wig_YL"},
31406: {"AegisName":"C_Nydhog_Wig_WH"},
31407: {"AegisName":"C_Alice_Wig_PK"},
31408: {"AegisName":"C_RORush_Goat"},
31409: {"AegisName":"C_Barrel_Helm"},
31410: {"AegisName":"C_Gods_Helm"},
31411: {"AegisName":"C_Leo_Diadem"},
31412: {"AegisName":"C_Virgo_Crown"},
31413: {"AegisName":"C_Taurus_Crown"},
31414: {"AegisName":"C_Cancer_Diadem"},
31415: {"AegisName":"C_Wanderer_Sakkat"},
31416: {"AegisName":"C_SeraphimCoronet"},
31417: {"AegisName":"C_Onigiri_Hat"},
31418: {"AegisName":"C_Leek_In_Mouth"},
31419: {"AegisName":"C_Angel_Of_Happiness"},
31420: {"AegisName":"C_SantaPoring_Promo"},
31421: {"AegisName":"C_Pink_Angeling_Bubble"},
31422: {"AegisName":"C_Angeling_Bubble"},
31423: {"AegisName":"C_Bear_Balloon"},
31424: {"AegisName":"C_LoveLove_Balloon"},
31425: {"AegisName":"C_Long_Octopus_Balloon"},
31426: {"AegisName":"C_Male_Poring_Balloon"},
31427: {"AegisName":"C_Fmale_Poring_Balloon"},
31428: {"AegisName":"C_Panda_Balloon"},
31429: {"AegisName":"C_Blue_Poring_Bubble"},
31430: {"AegisName":"C_Seppl_Hat_TW"},
31431: {"AegisName":"C_Curupira_Hat_TW"},
31432: {"AegisName":"C_Luwmin_Ice"},
31433: {"AegisName":"C_Astro_Circle"},
31434: {"AegisName":"C_Cloud_Buster"},
31435: {"AegisName":"C_Magician_Knithat"},
31436: {"AegisName":"C_White_Drooping_Kitty"},
31437: {"AegisName":"C_Baby_Penguin"},
31438: {"AegisName":"C_Fluffy_Angel_Cape"},
31439: {"AegisName":"C_Fluffy_Heart_Earmuffs"},
31440: {"AegisName":"C_Snow_Bear_Food"},
31441: {"AegisName":"C_Penguin_Cap_BU"},
31442: {"AegisName":"C_Mr_Smile_V"},
31443: {"AegisName":"C_Munak_Turban_V"},
31444: {"AegisName":"C_Bongun_Hat_V"},
31445: {"AegisName":"Feather_Fedora_TW"},
31446: {"AegisName":"C_Toy_Syringe"},
31447: {"AegisName":"C_Pale_Moon_Hat"},
31448: {"AegisName":"C_Sting_Silk_Ribbon"},
31449: {"AegisName":"C_Blue_Rose_Eyepatch"},
31450: {"AegisName":"C_Lolita_Two_Side_Up"},
31451: {"AegisName":"C_Blue_Frill_Ribbon"},
31452: {"AegisName":"C_White_Cat"},
31453: {"AegisName":"C_L_RibbonMuff_Black"},
31454: {"AegisName":"C_Love_Feeling"},
31455: {"AegisName":"Enchanted_Dog"},
31456: {"AegisName":"C_Baby_Leopard_Cat"},
31457: {"AegisName":"C_Husky_Hat"},
31458: {"AegisName":"C_1Grade_Balloon_TW"},
31459: {"AegisName":"C_Sweets_Bonbon"},
31460: {"AegisName":"C_Blessing_Sky_Lantern"},
31461: {"AegisName":"C_Male_Poring_Earmuff"},
31462: {"AegisName":"C_Female_Poring_Earmuff"},
31463: {"AegisName":"C_Flying_Drone"},
31464: {"AegisName":"C_Mike_Hat"},
31465: {"AegisName":"C_Egg_Minihat"},
31466: {"AegisName":"C_Holy_Egg_Hat"},
31467: {"AegisName":"C_Mimic_Egg_Shell"},
31468: {"AegisName":"C_Stripe_Hat"},
31469: {"AegisName":"C_Costume08_L"},
31470: {"AegisName":"C_Tengu_Scroll"},
31471: {"AegisName":"C_CelestialWoman_Flower"},
31472: {"AegisName":"C_Fairy_Feathers"},
31473: {"AegisName":"C_Tipsy"},
31474: {"AegisName":"C_Straight_Long_BL"},
31475: {"AegisName":"C_Black_Fox_Ear_Ribbon"},
31476: {"AegisName":"C_Cherry_Blossom_Hat_YL"},
31477: {"AegisName":"C_Costume06_L"},
31478: {"AegisName":"C_Eleanor_Wig_V"},
31479: {"AegisName":"C_ManyStars_TW"},
31480: {"AegisName":"C_Jioia_TW"},
31481: {"AegisName":"C_CatCoffeeCup_TW"},
31482: {"AegisName":"C_LunaticMuffler_TW"},
31483: {"AegisName":"C_CatEarRibbon_TW"},
31484: {"AegisName":"C_JP_EV13"},
31485: {"AegisName":"C_JP_EV14"},
31486: {"AegisName":"C_Diver's_Goggles"},
31487: {"AegisName":"C_Eye_Bandage"},
31488: {"AegisName":"C_Mvp"},
31489: {"AegisName":"C_Bouquet_Hat"},
31490: {"AegisName":"C_Poring_Muffler"},
31491: {"AegisName":"C_Orange_Tabby_Cat"},
31492: {"AegisName":"C_Cat_Ears_Cape_Brown"},
31493: {"AegisName":"C_Volume_Low_Twin_WH"},
31494: {"AegisName":"C_Volume_Low_TwinK"},
31495: {"AegisName":"C_Lolita_Two_Side_UpK"},
31496: {"AegisName":"C_Yggdrasil_Crown"},
31497: {"AegisName":"C_Flowery_Vision_TH"},
31498: {"AegisName":"C_Elephangel_TH"},
31499: {"AegisName":"C_Easter_Egg_Shell"},
31500: {"AegisName":"C_Sparkler_Stick_TH"},
31501: {"AegisName":"C_Sparkler_Fountain_TH"},
31502: {"AegisName":"C_Aches_Love_Cobra_TH"},
31503: {"AegisName":"C_TW_2th_Balloon"},
31504: {"AegisName":"C_Starving_Fish_Hat"},
31505: {"AegisName":"C_Falcon_Mask"},
31506: {"AegisName":"C_Malangdo_Pirate"},
31507: {"AegisName":"C_Yellow_Drooping_Kitty"},
31508: {"AegisName":"C_Isabella_Blue_Ear"},
31509: {"AegisName":"C_Fawn_Ear"},
31510: {"AegisName":"C_Cat_Ear_Short"},
31511: {"AegisName":"C_Cat_Ear_Long"},
31512: {"AegisName":"C_Panda_Rabbit"},
31513: {"AegisName":"C_Rabbit_Hopping_BL"},
31514: {"AegisName":"C_American_S_hair"},
31515: {"AegisName":"C_Leopard_Cat"},
31516: {"AegisName":"C_Mini_Melon"},
31517: {"AegisName":"C_JP_EV15"},
31518: {"AegisName":"C_Pop_Popcorn_Hat"},
31519: {"AegisName":"C_Slurp_Slurp_Hat"},
31520: {"AegisName":"C_Popcorn_Hat"},
31521: {"AegisName":"C_Citron_Hat"},
31522: {"AegisName":"C_Orange_Hat"},
31523: {"AegisName":"C_Yellow_Yuzu_Hat"},
31524: {"AegisName":"C_Lunch_box"},
31525: {"AegisName":"C_Kid_Deviling"},
31526: {"AegisName":"C_Shaman_Hat"},
31527: {"AegisName":"C_14_RainbowWing"},
31528: {"AegisName":"C_Stardust_Hairband"},
31529: {"AegisName":"C_Happy_Rabbit_Ribbon"},
31530: {"AegisName":"C_Greater_Dracul_Horn"},
31531: {"AegisName":"C_Lovely_Heart_Cap"},
31532: {"AegisName":"C_Neev_Barrette"},
31533: {"AegisName":"C_Warm_Cat_Muffler_BL"},
31534: {"AegisName":"C_Rainbow_Star"},
31535: {"AegisName":"C_Old_Pink_Poo_Hat"},
31536: {"AegisName":"C_Chibi_Beelzebub_Hat"},
31537: {"AegisName":"C_Return_TW_2th_Hat"},
31538: {"AegisName":"C_Love_Feeling_J"},
31539: {"AegisName":"C_Bulgogi_TW"},
31540: {"AegisName":"C_Gemini_RedEyes"},
31541: {"AegisName":"C_Drosera_Hairpin"},
31542: {"AegisName":"C_Clay_Poring_Jar_Jp"},
31543: {"AegisName":"C_Eru_Rava_Hat"},
31544: {"AegisName":"C_Piamette_Roll_Hair"},
31545: {"AegisName":"C_Eremes_Scarf_BU"},
31546: {"AegisName":"C_Clock_Casket_RD"},
31547: {"AegisName":"C_Poporing_Mascot_Cos"},
31548: {"AegisName":"C_Love_Cheek_V"},
31549: {"AegisName":"C_Little_Aquarium_V"},
31550: {"AegisName":"C_Tone_Of_Gold_V"},
31551: {"AegisName":"C_Black_Glasses_V"},
31552: {"AegisName":"C_Blue_Ribbon_V"},
31553: {"AegisName":"C_Wings_Of_Victory_V"},
31554: {"AegisName":"C_Bread_Bag2_V"},
31555: {"AegisName":"C_Hoplite_Helmet_V"},
31556: {"AegisName":"C_Moonlight_F_Hat_V"},
31557: {"AegisName":"C_Hoplite_Helmet_Silver"},
31558: {"AegisName":"C_Hoplite_Helmet_Black"},
31559: {"AegisName":"C_Royalguard_Necklace"},
31560: {"AegisName":"C_DVAngelNurseCap"},
31561: {"AegisName":"C_8Type_PurgatorialWing"},
31562: {"AegisName":"C_Zherlthsh_Doll"},
31563: {"AegisName":"C_Blue_EyeShadow_JP"},
31564: {"AegisName":"C_Variant_Veil"},
31565: {"AegisName":"C_Princess_Ribbon_Crown"},
31566: {"AegisName":"C_Stall_Of_Dominions"},
31567: {"AegisName":"C_Sheep_Horn"},
31568: {"AegisName":"C_Floating_Ball_TW"},
31569: {"AegisName":"C_OpenAir_Headset"},
31570: {"AegisName":"C_Cyclops_Visor"},
31571: {"AegisName":"C_Guardian_Processor"},
31572: {"AegisName":"C_Mobile_Pursuit_System"},
31573: {"AegisName":"C_Mecha_Cat_Ears"},
31574: {"AegisName":"C_Cyber_Income"},
31575: {"AegisName":"C_Electro_Two_Side_Up"},
31576: {"AegisName":"C_Spring_Rabbit_Hat"},
31577: {"AegisName":"C_Roast_Memory_J"},
31578: {"AegisName":"C_Alchemist_Mask_V"},
31579: {"AegisName":"C_Lovegame_Hat"},
31580: {"AegisName":"C_Autumnal_Flavor"},
31581: {"AegisName":"C_Jack_Head"},
31582: {"AegisName":"C_Jirant_Circlet_"},
31583: {"AegisName":"C_Willothewisp"},
31584: {"AegisName":"C_Marin_Muffler"},
31585: {"AegisName":"C_Drops_Muffler"},
31586: {"AegisName":"C_Poporing_Muffler"},
31587: {"AegisName":"C_NationalDay_helmet_TW"},
31588: {"AegisName":"C_SnowFlake_Tiara"},
31589: {"AegisName":"C_Gold_Magestic_Goat"},
31590: {"AegisName":"C_Der_Meisterpinsel"},
31591: {"AegisName":"C_Crown_Of_Saint"},
31592: {"AegisName":"C_ROEXE2_TH"},
31593: {"AegisName":"C_Yellow_Scarf"},
31594: {"AegisName":"C_Red_Pencil_Mouth"},
31595: {"AegisName":"C_Book_of_Soyga"},
31596: {"AegisName":"C_Spider_Temp_TW"},
31597: {"AegisName":"C_GoldFish_Hat"},
31598: {"AegisName":"C_Forest_Guide"},
31599: {"AegisName":"C_Medium_Wave"},
31600: {"AegisName":"C_Kishu_Inu"},
31601: {"AegisName":"C_Under_Rim_Glasses_Bu"},
31602: {"AegisName":"C_Midgarts_Glory"},
31603: {"AegisName":"C_Cat_Ear_ShortK"},
31604: {"AegisName":"C_Cat_Ear_LongK"},
31605: {"AegisName":"C_Volume_Low_Twin_WHK"},
31606: {"AegisName":"C_Autumn_Headband"},
31607: {"AegisName":"C_B_EarWitchHat"},
31608: {"AegisName":"C_Magicstone_Of_Grace"},
31609: {"AegisName":"C_Noble_Mask"},
31610: {"AegisName":"C_Yellow_Wizardry_Hat"},
31611: {"AegisName":"C_Dark_Snake_Lord_Stall"},
31612: {"AegisName":"C_Large_Sorcerer_Crown"},
31613: {"AegisName":"C_Blue_Strong_Hair"},
31614: {"AegisName":"C_Fox"},
31615: {"AegisName":"C_Geisha_Make"},
31616: {"AegisName":"C_Sleep_Sheep_TW"},
31617: {"AegisName":"C_Lady_Tanee_TW"},
31618: {"AegisName":"C_DancingButterfly_TW"},
31619: {"AegisName":"C_Magic_Inheritor_TW"},
31620: {"AegisName":"C_Snow_Fox_TW"},
31621: {"AegisName":"C_HappyMargay_TW"},
31622: {"AegisName":"C_LostTime_TW"},
31623: {"AegisName":"C_RomanticRose_TW"},
31624: {"AegisName":"C_HeartOfCat_TW"},
31625: {"AegisName":"C_Protect_Cloth"},
31626: {"AegisName":"C_FluffyWing_TW"},
31627: {"AegisName":"C_L_Magesic2_TW"},
31628: {"AegisName":"C_Bogy_Cap_TW"},
31629: {"AegisName":"C_Evil_Bone_Hat"},
31630: {"AegisName":"C_BaphoJ_Parachute_JP"},
31631: {"AegisName":"C_Drooping_Schmidt"},
31632: {"AegisName":"C_Drooping_Oscar"},
31633: {"AegisName":"C_Drooping_Heinrich"},
31634: {"AegisName":"C_Rudolf_Hairband"},
31635: {"AegisName":"C_Fairy_Long_BD"},
31636: {"AegisName":"C_Fairy_Long_SV"},
31637: {"AegisName":"C_Straight_Long_BU"},
31638: {"AegisName":"C_Straight_Long_RD"},
31639: {"AegisName":"C_Straight_Long_GL"},
31640: {"AegisName":"C_Straight_Long_GN"},
31641: {"AegisName":"C_Straight_Long_JBL"},
31642: {"AegisName":"C_Straight_Long_LPP"},
31643: {"AegisName":"C_Straight_Long_OM"},
31644: {"AegisName":"C_Straight_Long_PP"},
31645: {"AegisName":"C_Side_Tail_BU"},
31646: {"AegisName":"C_Side_Tail_RD"},
31647: {"AegisName":"C_Side_Tail_YL"},
31648: {"AegisName":"C_Side_Tail_GN"},
31649: {"AegisName":"C_Side_Tail_BL"},
31650: {"AegisName":"C_Side_Tail_WH"},
31651: {"AegisName":"C_Side_Tail_OM"},
31652: {"AegisName":"C_Side_Tail_PP"},
31653: {"AegisName":"C_Back_Signon_BU"},
31654: {"AegisName":"C_Back_Signon_RD"},
31655: {"AegisName":"C_Back_Signon_YL"},
31656: {"AegisName":"C_Back_Signon_GN"},
31657: {"AegisName":"C_Back_Signon_BL"},
31658: {"AegisName":"C_Back_Signon_WH"},
31659: {"AegisName":"C_Back_Signon_OM"},
31660: {"AegisName":"C_Back_Signon_PP"},
31661: {"AegisName":"C_Alphonse_Helmet"},
31662: {"AegisName":"C_Red_Hood"},
31663: {"AegisName":"C_Asara_Fairy_Hat_J"},
31664: {"AegisName":"C_B_Desert_Wolf_Hat"},
31665: {"AegisName":"C_GoldPoring_Hat_TW"},
31666: {"AegisName":"C_Crown_of_Unity"},
31667: {"AegisName":"C_PoringBeret_TW"},
31668: {"AegisName":"C_Majoruros_Horn"},
31669: {"AegisName":"C_Adv_Whisper_Mask_J"},
31670: {"AegisName":"C_Miyabi_Long_Hair"},
31671: {"AegisName":"C_Twin_Canon"},
31672: {"AegisName":"C_Mermaid_Wig"},
31673: {"AegisName":"C_Picnic_Basket"},
31674: {"AegisName":"C_Jitterbug_Cap"},
31675: {"AegisName":"C_Orange_Stem_Hat"},
31676: {"AegisName":"C_Orange_In_Mouth"},
31677: {"AegisName":"C_Stretched_Nose"},
31678: {"AegisName":"C_Pig_Girl_TW"},
31679: {"AegisName":"C_Pig_Boy_TW"},
31680: {"AegisName":"C_Fairy_Long_SVK"},
31681: {"AegisName":"C_Fairy_Long_BDK"},
31682: {"AegisName":"C_Drooping_Elven_Ears"},
31683: {"AegisName":"C_Heart_Wing_Hairband_V"},
31684: {"AegisName":"C_Kururinpa_Hair"},
31685: {"AegisName":"C_Fluffy_Semi_Long"},
31686: {"AegisName":"C_Desert_Wolf_B"},
31687: {"AegisName":"C_Alchemist_Square_Bag"},
31688: {"AegisName":"C_Poring_On_Shoulder"},
31689: {"AegisName":"C_Piamette_Roll_HairK"},
31690: {"AegisName":"C_Flame_Bird"},
31691: {"AegisName":"C_Bell_Pigeon_J"},
31692: {"AegisName":"C_YDragon_SkyWing"},
31693: {"AegisName":"C_LunaticMuffler"},
31694: {"AegisName":"C_Poring_Letter_TW"},
31695: {"AegisName":"C_Tree_Of_Sprout_JP"},
31696: {"AegisName":"C_Shark_Hat"},
31697: {"AegisName":"C_Bird_Nest"},
31698: {"AegisName":"C_Pigtail_Red_Hood"},
31699: {"AegisName":"C_Smiling_Eyes"},
31700: {"AegisName":"C_ScarfOfHero_TW"},
31701: {"AegisName":"C_ScarfOfHero_R"},
31702: {"AegisName":"C_Moon_Cat_Fighter"},
31703: {"AegisName":"C_Valentine_Hat"},
31704: {"AegisName":"C_Sweet_Valentine_Hat"},
31705: {"AegisName":"C_Red_White_Hat"},
31706: {"AegisName":"C_Tatenasi_Helmet"},
31707: {"AegisName":"C_Nine_Tail_Fox_Hair"},
31708: {"AegisName":"C_Gothic_Skull_Ribbon"},
31709: {"AegisName":"C_Golden_Violet"},
31710: {"AegisName":"C_Skygirl_Flower"},
31711: {"AegisName":"C_Gemmed_Crown"},
31712: {"AegisName":"C_Oxygen_Mask"},
31713: {"AegisName":"C_Mystery_Fruit_Shell"},
31714: {"AegisName":"C_Indian_Headband"},
31715: {"AegisName":"C_Orange_Rabbit"},
31716: {"AegisName":"C_Blinking_Eyes_RD"},
31717: {"AegisName":"C_Medium_Wave_BD"},
31718: {"AegisName":"C_Bless_Sky_Lantern_J"},
31719: {"AegisName":"C_Cons_Of_Fire"},
31720: {"AegisName":"C_VesperHeadGear"},
31721: {"AegisName":"C_ResonateTaego"},
31722: {"AegisName":"C_Sedora_Hat"},
31723: {"AegisName":"C_Tw_Rice_Ball"},
31724: {"AegisName":"C_Rice_Ball_Hood"},
31725: {"AegisName":"C_Lunar_Rainbow"},
31726: {"AegisName":"C_Hankie_In_Mouth"},
31727: {"AegisName":"C_Ribbon_Green"},
31728: {"AegisName":"C_Nobility_Hat"},
31729: {"AegisName":"C_Miracle_Plant"},
31730: {"AegisName":"C_Volume_Low_Twin_CB"},
31731: {"AegisName":"C_SnackParty"},
31732: {"AegisName":"C_BearBalloon"},
31733: {"AegisName":"C_Phantom_Of_Masquerade"},
31734: {"AegisName":"C_CitrusRibbon"},
31735: {"AegisName":"C_FortunetellinSealed"},
31736: {"AegisName":"C_Popcorn_Hair"},
31737: {"AegisName":"C_Wings_Of_Lucifer"},
31738: {"AegisName":"C_Side_Tail_PP_M_TW"},
31739: {"AegisName":"C_Side_Tail_OM_M_TW"},
31740: {"AegisName":"C_Side_Tail_WH_M_TW"},
31741: {"AegisName":"C_Side_Tail_BL_M_TW"},
31742: {"AegisName":"C_Side_Tail_GN_M_TW"},
31743: {"AegisName":"C_Side_Tail_YL_M_TW"},
31744: {"AegisName":"C_Side_Tail_RD_M_TW"},
31745: {"AegisName":"C_Side_Tail_BU_M_TW"},
31746: {"AegisName":"C_St_Long_PP_M_TW"},
31747: {"AegisName":"C_St_Long_OM_M_TW"},
31748: {"AegisName":"C_St_Long_LPP_M_TW"},
31749: {"AegisName":"C_St_Long_JBL_M_TW"},
31750: {"AegisName":"C_St_Long_GN_M_TW"},
31751: {"AegisName":"C_St_Long_GL_M_TW"},
31752: {"AegisName":"C_St_Long_RD_M_TW"},
31753: {"AegisName":"C_St_Long_BU_M_TW"},
31754: {"AegisName":"C_B_S_PP_M_TW"},
31755: {"AegisName":"C_B_S_OM_M_TW"},
31756: {"AegisName":"C_B_S_WH_M_TW"},
31757: {"AegisName":"C_B_S_BL_M_TW"},
31758: {"AegisName":"C_B_S_GN_M_TW"},
31759: {"AegisName":"C_B_S_YL_M_TW"},
31760: {"AegisName":"C_B_S_RD_M_TW"},
31761: {"AegisName":"C_B_S_BU_M_TW"},
31762: {"AegisName":"C_Heart_Card_In_Mouth"},
31763: {"AegisName":"C_Fortier_Mask"},
31764: {"AegisName":"C_Rainbow_Veil_V"},
31765: {"AegisName":"C_Garnet_Tiara"},
31766: {"AegisName":"C_Peony_Hair_Ornament"},
31767: {"AegisName":"C_TW_3rd_Balloon"},
31768: {"AegisName":"C_2019RTC_CeleAura_TW"},
31769: {"AegisName":"C_Orange_Bunny_Band"},
31770: {"AegisName":"C_Violet_Bunny_Band"},
31771: {"AegisName":"C_Blue_Bunny_Band"},
31772: {"AegisName":"C_Silver_Bunny_Hairband"},
31773: {"AegisName":"C_Aqua_Bunny_Band"},
31774: {"AegisName":"C_Maroon_Bunny_Band"},
31775: {"AegisName":"C_Golden_Bunny_Band"},
31776: {"AegisName":"C_Gray_Bunny_Band"},
31777: {"AegisName":"C_YellowBunny_Hairband"},
31778: {"AegisName":"C_PinkBunny_Hairband"},
31779: {"AegisName":"C_Green_Bunny_Hairband"},
31780: {"AegisName":"C_Sloth_Hat"},
31781: {"AegisName":"C_Green_Poring_Hairpin"},
31782: {"AegisName":"C_Solo_Play_Box1"},
31783: {"AegisName":"C_Doram_Balloon"},
31784: {"AegisName":"C_Exa_Goat_Cap"},
31785: {"AegisName":"C_Monster_Fish_Gill"},
31786: {"AegisName":"C_Red_Baby_Dragon"},
31787: {"AegisName":"C_SavageB_On_Shoulder"},
31788: {"AegisName":"C_Piamette_Roll_Hair_SV"},
31789: {"AegisName":"C_Turkey_Hat"},
31790: {"AegisName":"C_Blood_Grimoire_J"},
31791: {"AegisName":"C_Pig_Mask_J"},
31792: {"AegisName":"C_Baryon_HeadPhone_TW"},
31793: {"AegisName":"C_Feather_Of_Seraphim"},
31794: {"AegisName":"C_Puppy_Ears_Hat_Jp"},
31795: {"AegisName":"C_Elephangel_J"},
31796: {"AegisName":"C_Drooping_Boto"},
31797: {"AegisName":"C_Shih_Tzu_Long"},
31798: {"AegisName":"C_Baby_Panda"},
31799: {"AegisName":"C_Pretty_Bear_WH"},
31800: {"AegisName":"C_Br_Twin_Ribbon"},
31801: {"AegisName":"C_Karada_Meguri_Tea_Hat"},
31802: {"AegisName":"C_Royal_Milk_Tea_Hat"},
31803: {"AegisName":"C_Cons_Of_Wind"},
31804: {"AegisName":"C_Flower_Hat"},
31805: {"AegisName":"C_Sunglasses_Bball_Hat"},
31806: {"AegisName":"C_Tw_Frog_Hat"},
31807: {"AegisName":"C_Peacock_Feather"},
31808: {"AegisName":"C_Red_PhD_Hat"},
31809: {"AegisName":"C_Red_Wizardry_Hat"},
31810: {"AegisName":"C_Deep_Angel_Hairband"},
31811: {"AegisName":"C_Thief_Hood"},
31812: {"AegisName":"C_Bulb_Hairband"},
31813: {"AegisName":"C_Luna_On_Shoulder_J"},
31814: {"AegisName":"C_RabbitFamilyBalloon"},
31815: {"AegisName":"C_Angola_Intention"},
31816: {"AegisName":"C_Rabbit_Winged_Robe"},
31817: {"AegisName":"C_Rabbit_Two_Side_Up"},
31818: {"AegisName":"C_TopPlayer_TW"},
31819: {"AegisName":"C_Dullahan_Mask"},
31820: {"AegisName":"C_Golden_Baseball_Cap"},
31821: {"AegisName":"C_Jeje_Cap"},
31822: {"AegisName":"C_Summer_Baseball_Cap"},
31823: {"AegisName":"C_Nose_Glasses_J"},
31824: {"AegisName":"C_Mask_Of_Cat_J"},
31825: {"AegisName":"C_Tongue_Charm_J"},
31826: {"AegisName":"C_Sunglass_Bear_Cap_J"},
31827: {"AegisName":"Durumagi"},
31828: {"AegisName":"C_Maple_Falls_RdK"},
31829: {"AegisName":"C_Love_China_CN"},
31830: {"AegisName":"C_DragonKnight_Eyepatch"},
31831: {"AegisName":"C_Disguise_Mantle"},
31832: {"AegisName":"C_Bicolor_Cat_Witch_Hat"},
31833: {"AegisName":"C_Halloween_Cat_Short"},
31834: {"AegisName":"C_Halloween_Cat_Long"},
31835: {"AegisName":"C_2019_D10_Muffler_TW"},
31836: {"AegisName":"C_Aviator_Hat"},
31837: {"AegisName":"C_SharkHead_J"},
31838: {"AegisName":"C_Golden_Wreath"},
31839: {"AegisName":"C_FluffyWing_J"},
31840: {"AegisName":"C_BJ_HeadsetA"},
31841: {"AegisName":"C_BJ_HeadsetB"},
31842: {"AegisName":"C_Striking_hat"},
31843: {"AegisName":"C_Heavenly_Order"},
31844: {"AegisName":"C_Mob_Scarf"},
31845: {"AegisName":"C_Palace_Guard_Cap"},
31846: {"AegisName":"C_Lovely_Ribbon_Hair"},
31847: {"AegisName":"C_Blink_Eyes_Cocktai_BU"},
31848: {"AegisName":"C_Rose_Gothic_Bonnet"},
31849: {"AegisName":"C_Runaway_Accelerator"},
31850: {"AegisName":"C_Gift_of_Panagia"},
31851: {"AegisName":"C_Phalanx"},
31852: {"AegisName":"C_WitchManteau"},
31853: {"AegisName":"C_ZombieMask"},
31854: {"AegisName":"C_SnackParty_J"},
31855: {"AegisName":"Mushroom_Hair"},
31856: {"AegisName":"C_Airy_Two_Side_Up_BD"},
31857: {"AegisName":"C_Airy_Two_Side_Up_SV"},
31858: {"AegisName":"C_Signon_Princ_Wave_BU"},
31859: {"AegisName":"C_Signon_Princ_Wave_RD"},
31860: {"AegisName":"C_Signon_Princ_Wave_YL"},
31861: {"AegisName":"C_Signon_Princ_Wave_GN"},
31862: {"AegisName":"C_Signon_Princ_Wave_BL"},
31863: {"AegisName":"C_Signon_Princ_Wave_WH"},
31864: {"AegisName":"C_Signon_Princ_Wave_OM"},
31865: {"AegisName":"C_Signon_Princ_Wave_PP"},
31866: {"AegisName":"C_Braid_Headband_BU"},
31867: {"AegisName":"C_Braid_Headband_RD"},
31868: {"AegisName":"C_Braid_Headband_YL"},
31869: {"AegisName":"C_Braid_Headband_GN"},
31870: {"AegisName":"C_Braid_Headband_BL"},
31871: {"AegisName":"C_Braid_Headband_WH"},
31872: {"AegisName":"C_Braid_Headband_OM"},
31873: {"AegisName":"C_Braid_Headband_PP"},
31874: {"AegisName":"C_Exotic_Bob_L_LB"},
31875: {"AegisName":"C_Exotic_Bob_L_YL"},
31876: {"AegisName":"C_Exotic_Bob_L_WH"},
31877: {"AegisName":"C_Exotic_Bob_L_LPP"},
31878: {"AegisName":"C_Exotic_Bob_R_PK"},
31879: {"AegisName":"C_Exotic_Bob_R_BG"},
31880: {"AegisName":"C_Exotic_Bob_R_JBL"},
31881: {"AegisName":"C_Exotic_Bob_R_BW"},
31882: {"AegisName":"C_Choco_Stick_In_Mouth"},
31883: {"AegisName":"C_Nine_Tail_Fox_Hair_J"},
31884: {"AegisName":"C_Magic_Helm"},
31885: {"AegisName":"Cons_Of_Earth"},
31886: {"AegisName":"C_Pierced_Apple_E"},
31887: {"AegisName":"C_Pure_Love_Muffler"},
31888: {"AegisName":"C_W_King_Tiger_Doll_Hat"},
31889: {"AegisName":"C_Gemini_Crown"},
31890: {"AegisName":"C_Sagittarius_Diadem"},
31891: {"AegisName":"C_Surpentarius_Crown"},
31892: {"AegisName":"C_Aquarius_Diadem"},
31893: {"AegisName":"C_Libra_Crown"},
31894: {"AegisName":"C_Scorpio_Diadem"},
31895: {"AegisName":"C_Aries_Diadem"},
31896: {"AegisName":"C_Capricon_Crown"},
31897: {"AegisName":"C_Pisces_Crown"},
31898: {"AegisName":"C_Sagittarius_Crown"},
31899: {"AegisName":"C_Freyja_Crown"},
31900: {"AegisName":"C_Hair_Of_The_Strong_R"},
31901: {"AegisName":"C_White_Strong_Hair_R"},
31902: {"AegisName":"C_10_Type_Glasses"},
31903: {"AegisName":"C_White_Snake"},
31904: {"AegisName":"C_Para_Team_Hat100"},
31905: {"AegisName":"C_Blanc_Neige_Prince"},
31906: {"AegisName":"C_PGstone_Knit_Hat_PK"},
31907: {"AegisName":"C_PGstone_Knit_Hat_BW"},
31908: {"AegisName":"C_Antler_Fedora"},
31909: {"AegisName":"C_711_Knit_Hat"},
31910: {"AegisName":"C_Shaving_Cream"},
31911: {"AegisName":"C_LittleGarden"},
31912: {"AegisName":"C_Black_Veil_J"},
31913: {"AegisName":"C_Black_Feather"},
31914: {"AegisName":"C_Red_Bread_Hat"},
31915: {"AegisName":"c_Sweet_Corone"},
31916: {"AegisName":"C_Frill_Collar"},
31917: {"AegisName":"C_2018_RTC_Cape4_TW_J"},
31918: {"AegisName":"C_Party_Recruiter_Hat"},
31919: {"AegisName":"C_Friend_Recruiter_Hat"},
31920: {"AegisName":"C_Western_Grace"},
31921: {"AegisName":"C_Fairy_Long_CB"},
31922: {"AegisName":"C_Fluffy_Semi_Long_SV"},
31923: {"AegisName":"C_Baby_Polar_Bear"},
31924: {"AegisName":"C_Blinking_Eyes_BU"},
31925: {"AegisName":"C_Valentine_Hat_US"},
31926: {"AegisName":"C_Aura_Quartz_REU"},
31927: {"AegisName":"C_Blue_Pencil_In_Mouth"},
31928: {"AegisName":"C_Cylinder_Hairband"},
31929: {"AegisName":"C_Cryptura_Academy_Hat"},
31930: {"AegisName":"C_Mike_Stand"},
31931: {"AegisName":"C_Half_Rim_Glasses"},
31932: {"AegisName":"C_Suit_Sollar"},
31933: {"AegisName":"C_Miyabi_Long_Hair_LPP"},
31934: {"AegisName":"C_Blink_Eyes_Sakura"},
31935: {"AegisName":"C_Baby_Dragon_Hat"},
31936: {"AegisName":"C_Nut_Donut_In_Mouth"},
31937: {"AegisName":"C_Unicorn_Ornament"},
31938: {"AegisName":"C_L_Knitting_Low_Twin"},
31939: {"AegisName":"C_Carnation_Corolla"},
31940: {"AegisName":"C_Earth_Godess_Mask"},
31941: {"AegisName":"C_Super_Cell"},
31942: {"AegisName":"C_Romance_Rose_J"},
31943: {"AegisName":"C_Frog_Hood"},
31944: {"AegisName":"C_Elegant_Wave"},
31945: {"AegisName":"C_Golden_Angel_Band"},
31946: {"AegisName":"C_Frantic_Looking"},
31947: {"AegisName":"C_Sinister_Horn_Gear"},
31948: {"AegisName":"C_Eyes_Of_Illusion"},
31949: {"AegisName":"C_Diabolus_Wing"},
31950: {"AegisName":"C_Nut_Cracker_JP"},
31951: {"AegisName":"C_Happy_Cat_JP"},
31952: {"AegisName":"C_GatesofNetherWorld"},
31953: {"AegisName":"C_Cor_Core_Headset"},
31954: {"AegisName":"C_Vassalage_Necklace"},
31955: {"AegisName":"C_Angeling_1st"},
31956: {"AegisName":"C_Angeling_2nd"},
31957: {"AegisName":"C_Cons_Of_Poison"},
31958: {"AegisName":"C_SantaPoring_Balloon"},
31959: {"AegisName":"C_RK_Hair_BL"},
31960: {"AegisName":"C_RK_Hair_BU"},
31961: {"AegisName":"C_RK_Hair_GN"},
31962: {"AegisName":"C_RK_Hair_OM"},
31963: {"AegisName":"C_RK_Hair_PK"},
31964: {"AegisName":"C_RK_Hair_PP"},
31965: {"AegisName":"C_RK_Hair_RD"},
31966: {"AegisName":"C_RK_Hair_WH"},
31967: {"AegisName":"C_RK_Hair_YL"},
31968: {"AegisName":"C_AB_Hair_BL"},
31969: {"AegisName":"C_AB_Hair_LPP"},
31970: {"AegisName":"C_AB_Hair_OM"},
31971: {"AegisName":"C_AB_Hair_WH"},
31972: {"AegisName":"C_Purificatory_Mask"},
31973: {"AegisName":"C_Blossom_Glasses"},
31974: {"AegisName":"C_Melon_Headphone"},
31975: {"AegisName":"C_Sweet_Potato_In_Mouth"},
31976: {"AegisName":"C_Focus_Beret"},
31977: {"AegisName":"C_Rent_Dog_Officer_TH"},
31978: {"AegisName":"C_Fire_Giant_Red"},
31979: {"AegisName":"C_Fire_Giant_Gold"},
31980: {"AegisName":"aegis_31980"},
32000: {"AegisName":"Blue_Spear"},
32001: {"AegisName":"Diva_Spear"},
32002: {"AegisName":"Mirage_Spear"},
32003: {"AegisName":"Sinister_Spear_J"},
32004: {"AegisName":"Probation_Lance"},
32005: {"AegisName":"Pole_Axe_IL"},
32007: {"AegisName":"Jirant_Spear"},
32012: {"AegisName":"Metal_Stick_J"},
32013: {"AegisName":"Metal_Stick"},
32014: {"AegisName":"Blut_Spear"},
32015: {"AegisName":"Woe_Onehand_Spear1_Z"},
32017: {"AegisName":"Variant_Spear"},
32018: {"AegisName":"Undine_Spear_K"},
32019: {"AegisName":"Boost_Lance_OS"},
32021: {"AegisName":"Evt_Undine_Spear_K"},
32023: {"AegisName":"Argen_Blanco"},
32024: {"AegisName":"Harve"},
32025: {"AegisName":"Fortrage"},
32026: {"AegisName":"Ein_1HSPEAR"},
32027: {"AegisName":"G_Knight_Spear"},
32028: {"AegisName":"Argen_Blanco_J"},
32029: {"AegisName":"Harve_J"},
32030: {"AegisName":"Fortrage_J"},
32031: {"AegisName":"Aries_Spear_J"},
32034: {"AegisName":"Comp_Undine_Spear_K"},
32101: {"AegisName":"Local01_Violin"},
32102: {"AegisName":"Local02_Violin"},
32103: {"AegisName":"Woe_Instrument1_Z"},
32104: {"AegisName":"Hyegun_Erhu"},
32105: {"AegisName":"Variant_Viollin"},
32106: {"AegisName":"Variant_Blade_Whip"},
32107: {"AegisName":"Black_Circle"},
32108: {"AegisName":"Antique_Cello"},
32110: {"AegisName":"Ein_1HLUTE"},
32111: {"AegisName":"R_Cello"},
32112: {"AegisName":"Black_Circle_J"},
32113: {"AegisName":"Antique_Cello_J"},
32117: {"AegisName":"Dark_Illu_Guitar_TH"},
32202: {"AegisName":"Comp_All_In_One_Ring"},
32203: {"AegisName":"Accelerator_Chip"},
32204: {"AegisName":"Immortal_Dog_Tag"},
32206: {"AegisName":"Prta_Mil_Glove"},
32207: {"AegisName":"Illusion_B_R"},
32208: {"AegisName":"Illusion_B_L"},
32209: {"AegisName":"Illusion_BC_R"},
32210: {"AegisName":"Illusion_BC_L"},
32219: {"AegisName":"Astraea_Ring"},
32221: {"AegisName":"Time_Overload_Ring"},
32222: {"AegisName":"Brooch_Of_Hero"},
32227: {"AegisName":"Fenrir_Chain"},
32228: {"AegisName":"Schmidt_Insignia_Str"},
32229: {"AegisName":"Schmidt_Insignia_Int"},
32230: {"AegisName":"Schmidt_Insignia_Luk"},
32231: {"AegisName":"Schmidt_Insignia_Vit"},
32232: {"AegisName":"Schmidt_Insignia_Agi"},
32233: {"AegisName":"Schmidt_Insignia_Dex"},
32234: {"AegisName":"UnrivaledRing"},
32237: {"AegisName":"Celine_Brooch_K"},
32238: {"AegisName":"Morpheus_Ring_IL"},
32239: {"AegisName":"Morpheus_Armlet_IL"},
32242: {"AegisName":"Old_DetachmentsRing_J"},
32243: {"AegisName":"Star_Force_Ring_TW"},
32245: {"AegisName":"RingOfThought_TW"},
32246: {"AegisName":"Main_Memory_JP"},
32247: {"AegisName":"Leo_Ring_J"},
32248: {"AegisName":"Ein_SAFETY_PENDR"},
32249: {"AegisName":"Ein_SAFETY_PENDL"},
32250: {"AegisName":"Ein_SAFETY_EPAULR"},
32251: {"AegisName":"Ein_SAFETY_EPAULL"},
32252: {"AegisName":"H_AD_Clip"},
32253: {"AegisName":"Cancer_Ring_J"},
32258: {"AegisName":"RingofJupiter"},
32259: {"AegisName":"CannonConverter_TW"},
32261: {"AegisName":"Libra_Ring_J"},
32262: {"AegisName":"Ball_Of_RasenHuuma"},
32263: {"AegisName":"Shield_Ring"},
32264: {"AegisName":"Taurus_Ring_J"},
32265: {"AegisName":"Tip_Of_Thief_Vol2"},
32266: {"AegisName":"Aquarius_Ring_J"},
32267: {"AegisName":"Scorpio_Ring_J"},
32270: {"AegisName":"Luminous_Blue_Stone_TW"},
32278: {"AegisName":"Sealed_Ring_TW"},
32281: {"AegisName":"Scorpion_Chain_EXE"},
32282: {"AegisName":"Erron_Black_Glove_EXE"},
32285: {"AegisName":"Record_Mage_TW"},
32286: {"AegisName":"Record_Merchant_TW"},
32287: {"AegisName":"Record_Thief_TW"},
32288: {"AegisName":"Record_Acol_TW"},
32293: {"AegisName":"Pollux_Ring_J"},
32294: {"AegisName":"Procyon_Ring_J"},
32295: {"AegisName":"Crystal_Blade_Necklace"},
32296: {"AegisName":"Crystal_Blade_Necklace_"},
32300: {"AegisName":"Variant_Handgun"},
32301: {"AegisName":"Gold_Lux_IL"},
32302: {"AegisName":"Crimson_Rose"},
32303: {"AegisName":"Ein_1HGUN"},
32304: {"AegisName":"R_Revolver"},
32305: {"AegisName":"Titanium_Gun_EXE"},
32350: {"AegisName":"Farthezan"},
32351: {"AegisName":"Estal"},
32352: {"AegisName":"Ein_1HSWORD"},
32353: {"AegisName":"G_Knight_JewelSword"},
32354: {"AegisName":"Farthezan_J"},
32355: {"AegisName":"Estal_J"},
32358: {"AegisName":"Comp_Sword_Of_Bluefire"},
32401: {"AegisName":"R_Pillar"},
32402: {"AegisName":"R_Syringe"},
32403: {"AegisName":"G_Alchemist_Staff"},
32404: {"AegisName":"Engine_Pilebuncker_J"},
32405: {"AegisName":"Coolant_Injection_J"},
32406: {"AegisName":"Gene_Rod_J"},
32407: {"AegisName":"Lucis_Flail_J"},
32408: {"AegisName":"Bright_Mace_J"},
100000: {"AegisName":"IDTest_Special"},
100002: {"AegisName":"PayPromotion_Box"},
100003: {"AegisName":"ILL_Piece_A"},
100004: {"AegisName":"ILL_Piece_B"},
100005: {"AegisName":"G_Small_Mana_Potion"},
100006: {"AegisName":"G_M_DEFScroll"},
100007: {"AegisName":"G_Limit_Power_Booster"},
100008: {"AegisName":"G_Infinity_Drink"},
100009: {"AegisName":"Joy_Of_Victory"},
100010: {"AegisName":"PerfectSize_Mix"},
100011: {"AegisName":"MagicPiercing_Mix"},
100019: {"AegisName":"Enchant_Stone_Box18"},
100020: {"AegisName":"E_Bcrystal_Box"},
100021: {"AegisName":"E_Mcrystal_Box"},
100022: {"AegisName":"E_Scrystal_Box"},
100023: {"AegisName":"Ancient_Hero_Bravery"},
100024: {"AegisName":"TimeExtension1"},
100025: {"AegisName":"Ancient_Hero_Wisdom"},
100026: {"AegisName":"TimeExtension2"},
100029: {"AegisName":"Booster_Pack_1"},
100030: {"AegisName":"Booster_Pack_15"},
100031: {"AegisName":"Booster_Pack_30"},
100032: {"AegisName":"Booster_Pack_45"},
100033: {"AegisName":"Booster_Pack_60"},
100034: {"AegisName":"Booster_Pack_75"},
100035: {"AegisName":"Booster_Pack_90"},
100036: {"AegisName":"Booster_Pack_100"},
100037: {"AegisName":"Booster_Pack_115"},
100038: {"AegisName":"Booster_Pack_130"},
100039: {"AegisName":"Booster_Pack_145"},
100040: {"AegisName":"Booster_Pack_160"},
100041: {"AegisName":"Booster_Pack_175"},
100043: {"AegisName":"Boost_Up_1"},
100044: {"AegisName":"Boost_Up_2"},
100045: {"AegisName":"Stater_A_Box"},
100046: {"AegisName":"Boost_Atk_Box"},
100047: {"AegisName":"Boost_Ran_Box"},
100048: {"AegisName":"Boost_Ele_Box"},
100049: {"AegisName":"Boost_Defn_Box"},
100050: {"AegisName":"Goal_Gift_Box"},
100051: {"AegisName":"Booster_Pack_Preorder"},
100052: {"AegisName":"Enchant_Stone_Box19"},
100053: {"AegisName":"Piercing_Mix"},
100054: {"AegisName":"Time_Over_S_Box"},
100058: {"AegisName":"Hasty_Mix"},
100060: {"AegisName":"EnchantStone_Recipe_4m"},
100061: {"AegisName":"E_Red_Booster"},
100065: {"AegisName":"WL_MB_SG"},
100066: {"AegisName":"WL_MB_LOV"},
100067: {"AegisName":"WL_MB_MS"},
100068: {"AegisName":"WL_MB_DL"},
100069: {"AegisName":"WL_MB_JF"},
100070: {"AegisName":"WL_MB_ES"},
100071: {"AegisName":"WL_MB_CR"},
100072: {"AegisName":"WL_MB_CL"},
100073: {"AegisName":"WL_MB_CM"},
100074: {"AegisName":"WL_MB_TV"},
100075: {"AegisName":"DishSet05"},
100076: {"AegisName":"DishSet06"},
100077: {"AegisName":"DishSet07"},
100078: {"AegisName":"DishSet08"},
100079: {"AegisName":"DishSet09"},
100080: {"AegisName":"DishSet10"},
100081: {"AegisName":"Kr_B_Special01"},
100083: {"AegisName":"BackSignon_Box_TW"},
100087: {"AegisName":"Boarding_Halter_Box30_Z"},
100098: {"AegisName":"RTC_EnergyDrink_TW"},
100100: {"AegisName":"Temporal_Manteau_Box"},
100109: {"AegisName":"Lapine_DdukddakBox2"},
100125: {"AegisName":"Metal_7_Ticket"},
100127: {"AegisName":"Kr_B_Special02"},
100128: {"AegisName":"Noblesse_Rifine_Ticket"},
100129: {"AegisName":"Imperial_Rifine_Ticket"},
100130: {"AegisName":"Grace_Rifine_Ticket"},
100131: {"AegisName":"Imperial_Convert1"},
100132: {"AegisName":"Imperial_Convert2"},
100133: {"AegisName":"Grace_Convert1"},
100134: {"AegisName":"Grace_Convert2"},
100135: {"AegisName":"Imperial_Convert3"},
100136: {"AegisName":"Imperial_Convert4"},
100137: {"AegisName":"Grace_Convert3"},
100138: {"AegisName":"Grace_Convert4"},
100142: {"AegisName":"Abyss_Ddbox2"},
100144: {"AegisName":"Abyss_Ddbox3"},
100145: {"AegisName":"Abyss_Ddbox4"},
100147: {"AegisName":"Bath_Foam_A"},
100148: {"AegisName":"Bath_Foam_B"},
100149: {"AegisName":"Bath_Foam_C"},
100150: {"AegisName":"Aroma_Oil"},
100151: {"AegisName":"Skill_Sha_M_S_Weapon"},
100152: {"AegisName":"GoldPCBang_ShieldBox"},
100153: {"AegisName":"Set_Of_Taiming_Item2"},
100158: {"AegisName":"Mado_Box02"},
100160: {"AegisName":"Auto_M_Box"},
100161: {"AegisName":"Epic_M_Box"},
100162: {"AegisName":"Auto_M_I_Box_A"},
100163: {"AegisName":"Auto_M_I_Box_B"},
100164: {"AegisName":"Auto_Imp_Melee_1"},
100165: {"AegisName":"Auto_Imp_Melee_2"},
100166: {"AegisName":"Auto_Imp_Melee_3"},
100167: {"AegisName":"Auto_Imp_Magic_1"},
100168: {"AegisName":"Auto_Imp_Magic_2"},
100169: {"AegisName":"Auto_Imp_Magic_3"},
100170: {"AegisName":"GoldPCBang_MileageBox"},
100171: {"AegisName":"Cannon_Ball_Box"},
100172: {"AegisName":"Iron_Cannon_Ball_Box"},
100173: {"AegisName":"Soul_Cannon_Ball_Box"},
100174: {"AegisName":"Poi_Arrow_Container"},
100176: {"AegisName":"Dark_Cannon_Ball_Box"},
100177: {"AegisName":"Holy_Cannon_Ball_Box"},
100178: {"AegisName":"Cannon_Box_6"},
100179: {"AegisName":"Magic_Gear_Fuel_Box"},
100180: {"AegisName":"RepairA_Box"},
100181: {"AegisName":"RepairB_Box"},
100182: {"AegisName":"RepairC_Box"},
100183: {"AegisName":"Flame_Stone_Bundle"},
100184: {"AegisName":"Ice_Stone_Bundle"},
100185: {"AegisName":"Wind_Stone_Bundle"},
100186: {"AegisName":"Shadow_Orb_Bundle"},
100187: {"AegisName":"Charm_Fire_Bundle"},
100188: {"AegisName":"Charm_Ice_Bundle"},
100189: {"AegisName":"Charm_Wind_Bundle"},
100190: {"AegisName":"Charm_Earth_Bundle"},
100191: {"AegisName":"Kunai_Scroll_Explosive"},
100192: {"AegisName":"Gemstone_Blue"},
100193: {"AegisName":"Gemstone_YL"},
100194: {"AegisName":"Gemstone_Red"},
100195: {"AegisName":"Bullet_Case_Full"},
100196: {"AegisName":"Bullet_Case_Mine"},
100197: {"AegisName":"Bullet_Case_Tail"},
100198: {"AegisName":"Skill_Shadow_Cube"},
100202: {"AegisName":"Enchant_Stone_Box20"},
100205: {"AegisName":"Class_Sha_R_M_Melee"},
100206: {"AegisName":"Class_Sha_R_M_Magic"},
100207: {"AegisName":"Skill_Sha_R_M_Melee"},
100208: {"AegisName":"Skill_Sha_R_M_Magic"},
100209: {"AegisName":"Skill_Sha_M_S_Shield"},
100210: {"AegisName":"Skill_Sha_M_S_Pendant"},
100211: {"AegisName":"Skill_Sha_M_S_Earing"},
100212: {"AegisName":"Skill_Sha_M_S_Shoes"},
100213: {"AegisName":"Skill_Sha_M_S_Armor"},
100214: {"AegisName":"Shadowdecon_Ore_Box"},
100215: {"AegisName":"Zelunium_Ore_Box"},
100231: {"AegisName":"Ref_T_Potion"},
100232: {"AegisName":"Add_Atk_Potion"},
100233: {"AegisName":"Add_Matk_Potion"},
100251: {"AegisName":"Illu_Enhance_Cube"},
100252: {"AegisName":"Auto_Enhance_Cube"},
100253: {"AegisName":"Gstar2019Box"},
100268: {"AegisName":"Temporal_Refine_Cube"},
100269: {"AegisName":"Geffen_Refine_Cube"},
100270: {"AegisName":"Old_Refine_Cube"},
100271: {"AegisName":"Refine_Hero_Weapon"},
100272: {"AegisName":"Refine_Hero_Boots"},
100273: {"AegisName":"Remodel_Hero_Boots"},
100274: {"AegisName":"Oriental_Sword_Cube"},
100275: {"AegisName":"Dragonic_Slayer_Cube"},
100276: {"AegisName":"Shiver_Katar_K_Cube"},
100277: {"AegisName":"Blade_Katar_Cube"},
100314: {"AegisName":"Enchant_Stone_Box21"},
100316: {"AegisName":"G_Tyrs_Blessing"},
100317: {"AegisName":"G_Mental_Potion"},
100319: {"AegisName":"Exotic_Bob_Box"},
100321: {"AegisName":"OS_Weapon_Refine_Cube"},
100322: {"AegisName":"Racecap_Refine_Cube"},
100323: {"AegisName":"Runeknight_S_Cube"},
100324: {"AegisName":"Guillotinecross_S_Cube"},
100325: {"AegisName":"Archbishop_S_Cube"},
100326: {"AegisName":"Sura_S_Cube"},
100327: {"AegisName":"Sword_Of_Bluefire_Cube"},
100328: {"AegisName":"Slate_Sword_Cube"},
100329: {"AegisName":"Narcis_Bow_Cube"},
100330: {"AegisName":"Trumpet_Shell_K_Cube"},
100331: {"AegisName":"Barb_Wire_K_Cube"},
100332: {"AegisName":"2019_Chrismas_Present"},
100333: {"AegisName":"E_Infinity_Drink"},
100335: {"AegisName":"Booster_Pack_190"},
100336: {"AegisName":"Booster_Pack_200"},
100337: {"AegisName":"Booster_Call"},
100338: {"AegisName":"Booster_W_Up_1"},
100339: {"AegisName":"Booster_W_Up_2"},
100340: {"AegisName":"Booster_W_Up_3"},
100341: {"AegisName":"E_ILL_Up"},
100342: {"AegisName":"Exp_Up_1"},
100343: {"AegisName":"Exp_Up_2"},
100344: {"AegisName":"Exp_Up_3"},
100345: {"AegisName":"Exp_Up_4"},
100346: {"AegisName":"Jexp_Up_1"},
100347: {"AegisName":"2020_Goal_Gift_Box"},
100351: {"AegisName":"Core_Battle_Manual"},
100352: {"AegisName":"Real_Battle_Manual"},
100354: {"AegisName":"Auto_Armor_Refine_Cube"},
100355: {"AegisName":"Bio_Weapon_Refine_Cube"},
100356: {"AegisName":"Ranger_S_Cube"},
100357: {"AegisName":"Warlock_S_Cube"},
100358: {"AegisName":"Sorcerer_S_Cube"},
100359: {"AegisName":"WanderMins_S_Cube"},
100360: {"AegisName":"Avenger_Cube"},
100361: {"AegisName":"Meteor_Striker_Cube"},
100362: {"AegisName":"Magic_Sword_Cube"},
100363: {"AegisName":"Fatalist_Cube"},
100365: {"AegisName":"MD_Geffen_Rarmor"},
100366: {"AegisName":"MD_Geffen_Rhood"},
100367: {"AegisName":"MD_Geffen_Racc"},
100368: {"AegisName":"MD_Geffen_Rsheild"},
100371: {"AegisName":"Homun_F_Tablet"},
100372: {"AegisName":"RoyalGuard_S_Cube"},
100373: {"AegisName":"ShadowChaser_S_Cube"},
100374: {"AegisName":"Mechanic_S_Cube"},
100375: {"AegisName":"Genetic_S_Cube"},
100376: {"AegisName":"Royal_Bow_K_Cube"},
100377: {"AegisName":"Scalet_Dragon_L_Cube"},
100378: {"AegisName":"Shadow_Staff_K_Cube"},
100379: {"AegisName":"Freezing_Rod_Cube"},
100381: {"AegisName":"3Lv_9Refine_Weapon_7Gu"},
100382: {"AegisName":"3Lv_10Refine_Weapon_8Gu"},
100383: {"AegisName":"3Lv_11Refine_Weapon_9Gu"},
100384: {"AegisName":"3Lv_12Refine_Weapon_10G"},
100385: {"AegisName":"4Lv_9Refine_Weapon_8Gu"},
100386: {"AegisName":"4Lv_10Refine_Weapon_9Gu"},
100387: {"AegisName":"4Lv_11Refine_Weapon_10G"},
100388: {"AegisName":"Iron_Nail_K_Cube"},
100390: {"AegisName":"Ray_Knuckle_Cube"},
100391: {"AegisName":"Moonlight_Box_IL"},
100392: {"AegisName":"S_Moonlight_Box_IL"},
100393: {"AegisName":"Undine_Spear_K_Cube"},
100394: {"AegisName":"Light_Blade_Cube"},
100395: {"AegisName":"Iron_Staff_Cube"},
100396: {"AegisName":"Blue_Crystal_Staff_Cube"},
100397: {"AegisName":"Demon_Hunt_Bible_Cube"},
100398: {"AegisName":"Saint_Hall_Cube"},
100399: {"AegisName":"MeawFoxtail_Cube"},
100400: {"AegisName":"Fog_Dew_Sword_Cube"},
100401: {"AegisName":"Humma_Clear_Cube"},
100402: {"AegisName":"OneSkyOneSun_Cube"},
100403: {"AegisName":"SoulWeight_Cube"},
100404: {"AegisName":"Crimson_Rose_Cube"},
100405: {"AegisName":"Master_Soul_Rifle_Cube"},
100406: {"AegisName":"Golden_L_Launcher_Cube"},
100407: {"AegisName":"The_Black_Gatling_Cube"},
100408: {"AegisName":"Demon_S_Shot_Cube"},
100412: {"AegisName":"Great_Hero_Bravery"},
100413: {"AegisName":"Great_Hero_Wisdom"},
100414: {"AegisName":"Vampire_Box_IL"},
100415: {"AegisName":"S_Vampire_Box_IL"},
100416: {"AegisName":"S_Frozen_Box_IL"},
100417: {"AegisName":"Turtle_Is_Box_IL"},
100418: {"AegisName":"S_Turtle_Is_Box_IL"},
100419: {"AegisName":"Teddy_Bear_Box_IL"},
100420: {"AegisName":"S_Teddy_Bear_Box_IL"},
100421: {"AegisName":"Luanda_Box_IL"},
100422: {"AegisName":"S_Luanda_Box_IL"},
100423: {"AegisName":"Labyrinth_Box_IL"},
100424: {"AegisName":"S_Teddy_Labyrinth_IL"},
100425: {"AegisName":"Underwater_Box_IL"},
100426: {"AegisName":"S_Underwater_Box_IL"},
100428: {"AegisName":"Signon_Prin_Wave_Box"},
100433: {"AegisName":"EnchantStone_Recipe_3m"},
100436: {"AegisName":"Circlet_Refine_Cube"},
100437: {"AegisName":"Hero_Weapon_Cube"},
100442: {"AegisName":"New_S_Weapon_Cube"},
100443: {"AegisName":"New_S_Shield_Cube"},
100444: {"AegisName":"New_S_Armor_Cube"},
100445: {"AegisName":"New_S_Shoes_Cube"},
100446: {"AegisName":"New_S_Earring_Cube"},
100447: {"AegisName":"New_S_Pendant_Cube"},
100452: {"AegisName":"Minus_Pow"},
100453: {"AegisName":"Minus_Spl"},
100454: {"AegisName":"Minus_Sta"},
100455: {"AegisName":"Minus_Wis"},
100456: {"AegisName":"Minus_Con"},
100457: {"AegisName":"Minus_Crt"},
100460: {"AegisName":"MD_Airboat_Bexp"},
100462: {"AegisName":"MD_Airboat_Reward"},
100465: {"AegisName":"Stone_Robe_Box"},
100466: {"AegisName":"Egir_Power_Box"},
100467: {"AegisName":"Egir_Magic_Box"},
100468: {"AegisName":"Egirnion_Box"},
100469: {"AegisName":"OS_Helm_Box"},
100470: {"AegisName":"Famous_Hat_Box"},
100475: {"AegisName":"MD_Airboat_Expbox"},
100476: {"AegisName":"MD_Airboat_Random"},
100477: {"AegisName":"Poenetentia_Box1"},
100478: {"AegisName":"Poenetentia_Box2"},
100479: {"AegisName":"Sakray_Fury"},
100480: {"AegisName":"Sakray_Fury2"},
100481: {"AegisName":"Overclocker"},
100485: {"AegisName":"Sakray_Regret"},
100486: {"AegisName":"Sakray_Regret2"},
100487: {"AegisName":"Loki_Coin_2"},
100488: {"AegisName":"Loki_Advice_2"},
100495: {"AegisName":"Stone_Robe2_Box"},
100496: {"AegisName":"Stone_Top_Box"},
100497: {"AegisName":"Stone_Top2_Box"},
100498: {"AegisName":"Stone_Middle_Box"},
100499: {"AegisName":"Stone_Middle2_Box"},
100500: {"AegisName":"Stone_Bottom_Box"},
100501: {"AegisName":"Stone_Bottom2_Box"},
100502: {"AegisName":"Enchant_Stone_Box22"},
100508: {"AegisName":"Exp_Up_1_S"},
100509: {"AegisName":"Exp_Up_2_S"},
100510: {"AegisName":"Exp_Up_3_S"},
100511: {"AegisName":"Exp_Up_4_S"},
100512: {"AegisName":"Ex_Skill_Shadow_Cube"},
100515: {"AegisName":"Cachua_Costume_Box"},
100516: {"AegisName":"Eye_Cleaner"},
100517: {"AegisName":"Ear_Cleaner"},
100518: {"AegisName":"Tonics"},
100519: {"AegisName":"Mini_Extinguisher"},
100520: {"AegisName":"Water_Of_Lucky"},
100521: {"AegisName":"Strong_Antidote"},
100522: {"AegisName":"High_Energy_Chocolate"},
100523: {"AegisName":"Refined_Holy_Water"},
100534: {"AegisName":"Kr_B_Special03"},
100537: {"AegisName":"Class_Shadow_WP_Cube"},
100538: {"AegisName":"Class_Shadow_AM_Cube"},
100539: {"AegisName":"Class_Shadow_SU_Cube"},
100540: {"AegisName":"Class_Shadow_SD_Cube"},
100541: {"AegisName":"Class_Shadow_PD_Cube"},
100542: {"AegisName":"Class_Shadow_EA_Cube"},
100547: {"AegisName":"BioWeapon_Helm_Box"},
100553: {"AegisName":"Tree_Of_Sprout_Box"},
100569: {"AegisName":"Special_Costume_Box"},
100570: {"AegisName":"Special_Costume_Box_"},
100572: {"AegisName":"FullPeneShadow_Mix"},
100573: {"AegisName":"Rag_Inven_Box"},
100574: {"AegisName":"AID_Manual_1h"},
100575: {"AegisName":"AID_Bubble_Gum_1h"},
100576: {"AegisName":"AID_Insurance_1h"},
100577: {"AegisName":"AID_Special_1h"},
100579: {"AegisName":"PendantStoneForWork"},
100580: {"AegisName":"Dark_Stone"},
100585: {"AegisName":"Thanatos_Pendant_Box"},
100591: {"AegisName":"Thanos_W_Reform_1"},
100592: {"AegisName":"Thanos_W_Reform_2"},
100596: {"AegisName":"FullTempShadow_Mix"},
100600: {"AegisName":"Shadow_Mix_Recipe2"},
100601: {"AegisName":"Illusion_Module_Mix"},
100602: {"AegisName":"Automatic_Module_Mix"},
100603: {"AegisName":"Lapine_DdukddakBox3"},
100616: {"AegisName":"Auction_Promotion"},
100619: {"AegisName":"Thanos_Refine_Hammer"},
100620: {"AegisName":"True_GemShadow_Mix"},
100621: {"AegisName":"Mammoth_Mix"},
100623: {"AegisName":"Shadow_Mix_Recipe_TH"},
100626: {"AegisName":"GrayWolf_7_Ticket"},
100627: {"AegisName":"GrayWolf_9_Ticket"},
100648: {"AegisName":"Consecrate_Weapon_1"},
100649: {"AegisName":"Consecrate_Weapon_2"},
100650: {"AegisName":"Pontifex_Courage"},
100651: {"AegisName":"Pontifex_Wisdom"},
100652: {"AegisName":"Pontifex_Tenacity"},
100653: {"AegisName":"Pontifex_Belief"},
100655: {"AegisName":"Blue_Prints_Scroll"},
100661: {"AegisName":"EXPShadow_Mix"},
100684: {"AegisName":"Bio_Helm_Refine_Cube"},
100690: {"AegisName":"Material_Shadow_CubeII"},
100691: {"AegisName":"AbsorbShadow_Mix"},
100694: {"AegisName":"C_Armor_Reform_1"},
100695: {"AegisName":"C_Armor_Reform_2"},
100699: {"AegisName":"Twins_Box_IL"},
100700: {"AegisName":"S_Twins_Box_IL"},
100706: {"AegisName":"Ancient_Hero_Will"},
100707: {"AegisName":"Mammoth_Shadow_Box"},
100708: {"AegisName":"Shadow_R_M_Box"},
100709: {"AegisName":"All_Shadow_Cube"},
100710: {"AegisName":"EXP_Overclocker"},
100717: {"AegisName":"Fluffy_Semi_Long_Box"},
100721: {"AegisName":"Enchant_Stone_Box23"},
100722: {"AegisName":"Booster_RandomOpt_P"},
100723: {"AegisName":"Booster_RandomOpt_M"},
100724: {"AegisName":"Spring_Energy"},
100726: {"AegisName":"Booster_Pack_215"},
100727: {"AegisName":"Booster_Pack_230"},
100728: {"AegisName":"AngelPoringJewel_Box"},
100742: {"AegisName":"Up_Hero_Weapon_Box"},
100744: {"AegisName":"Hero_LT_Refine_Melee"},
100745: {"AegisName":"Hero_LT_Refine_Magic"},
100746: {"AegisName":"C_Weapon_Reform_1"},
100747: {"AegisName":"C_Weapon_Reform_2"},
100748: {"AegisName":"C_Weapon_Reform_3"},
100750: {"AegisName":"High_Refine_Guarantee"},
100751: {"AegisName":"Refine_Guarantee"},
100752: {"AegisName":"Special_Refine_Cube"},
100753: {"AegisName":"Hero_Equipment_Cube"},
100754: {"AegisName":"Kr_B_Special04"},
100783: {"AegisName":"MajorAutoSpell_Mix"},
100784: {"AegisName":"Shadow_Changer_W_Shi"},
100785: {"AegisName":"AutoSpell_Shadow_Box"},
100786: {"AegisName":"C_Armor_Reform_3"},
100796: {"AegisName":"Darkness_Bible"},
100810: {"AegisName":"BroadcastBox_"},
100816: {"AegisName":"Summer_Energy"},
100817: {"AegisName":"Thanos_Upgrade_Box"},
100819: {"AegisName":"Hero_Weapon_Up_Box_1"},
100820: {"AegisName":"Hero_Weapon_Up_Box_2"},
100821: {"AegisName":"Hero_Weapon_Hammer_1"},
100822: {"AegisName":"Hero_Weapon_Hammer_2"},
100823: {"AegisName":"Lens_Craft_Stone"},
100829: {"AegisName":"Farfalle"},
100830: {"AegisName":"Cream_Noodle2"},
100831: {"AegisName":"Festival_Noodle2"},
100832: {"AegisName":"Tamato_Noodle2"},
100833: {"AegisName":"Oil_Noodle"},
100834: {"AegisName":"Hero_Weapon_Up_Box_3"},
100835: {"AegisName":"Hero_Weapon_Hammer_3"},
100848: {"AegisName":"Watermelon_Pudding_J"},
100870: {"AegisName":"S_Enchant_Stone_Box"},
100874: {"AegisName":"C_Giant_Fly_1Day_Box__"},
100875: {"AegisName":"C_Wing_Of_Fly_3Day_B__"},
100880: {"AegisName":"S_Piercing_Box"},
100886: {"AegisName":"PhyMag_Shadow_Box"},
100887: {"AegisName":"MagicalShadow_Mix"},
100888: {"AegisName":"PhysicalShadow_Mix"},
100890: {"AegisName":"Shadow_Changer_A_W"},
100900: {"AegisName":"Teleport_Ep19_01"},
100901: {"AegisName":"Teleport_Ep18_01"},
100902: {"AegisName":"Teleport_Ep17_02"},
100903: {"AegisName":"Teleport_Ep17_01"},
100904: {"AegisName":"Teleport_Ep16_01"},
100906: {"AegisName":"E_All_In_One_Buff"},
100908: {"AegisName":"S_M_Piercing_Box"},
100910: {"AegisName":"S_Dual_Stone_Box"},
100911: {"AegisName":"S_Costume_Box"},
100913: {"AegisName":"EXP_Drop_Up_7days"},
100914: {"AegisName":"EXP_Drop_Up_1Hours"},
100917: {"AegisName":"Hero_Weapon_Hammer_4"},
100918: {"AegisName":"Hero_Weapon_Up_Box_4"},
100920: {"AegisName":"Enchant_Stone_Box24"},
100929: {"AegisName":"GM_Lost_Bagpack"},
100933: {"AegisName":"E_Potion_Box"},
100934: {"AegisName":"Buff_Scroll_Box"},
100938: {"AegisName":"Hero_Weapon_Hammer_5"},
100939: {"AegisName":"Hero_Weapon_Up_Box_5"},
100943: {"AegisName":"Season_Evt_Reward_9"},
100949: {"AegisName":"EXP_Drop_Up_1day"},
100950: {"AegisName":"Evt_RagFes_Box"},
100951: {"AegisName":"S_Ignition_Cube"},
100952: {"AegisName":"S_W_Breath_Cube"},
100954: {"AegisName":"S_F_Breath_Cube"},
100955: {"AegisName":"S_Sonic_Cube"},
100956: {"AegisName":"S_Banish_Cannon_Cube"},
100957: {"AegisName":"S_Brand_Cube"},
100958: {"AegisName":"S_Genesis_Cube"},
100959: {"AegisName":"S_Chain_Press_Cube"},
100960: {"AegisName":"S_Strain_Cube"},
100961: {"AegisName":"S_Jack_Cube"},
100962: {"AegisName":"S_Chain_Cube"},
100963: {"AegisName":"S_Crimson_Cube"},
100964: {"AegisName":"S_Grave_Cube"},
100965: {"AegisName":"S_Dust_Cube"},
100966: {"AegisName":"S_Varetyr_Cube"},
100967: {"AegisName":"S_Psychic_Cube"},
100968: {"AegisName":"S_Vulcan_Cube"},
100969: {"AegisName":"S_Boomerang_Cube"},
100970: {"AegisName":"S_Arms_Cube"},
100971: {"AegisName":"S_Tornado_Cube"},
100972: {"AegisName":"S_Spore_Bomb_Cube"},
100973: {"AegisName":"S_Cannon_Cart_Cube"},
100974: {"AegisName":"S_Crazy_Cube"},
100975: {"AegisName":"S_Cart_Tornado_Cube"},
100976: {"AegisName":"S_Duplelight_Cube"},
100977: {"AegisName":"S_Magnus_Cube"},
100978: {"AegisName":"S_Adoramus_Cube"},
100979: {"AegisName":"S_Judex_Cube"},
100980: {"AegisName":"S_Knucklearrow_Cube"},
100981: {"AegisName":"S_Skynetblow_Cube"},
100982: {"AegisName":"S_Rampage_Cube"},
100983: {"AegisName":"S_TigerCannon_Cube"},
100984: {"AegisName":"S_Rolling_Cube"},
100985: {"AegisName":"S_Ripper_Cube"},
100986: {"AegisName":"S_Slash_Cube"},
100987: {"AegisName":"S_Katar_Cube"},
100988: {"AegisName":"S_Menace_Cube"},
100989: {"AegisName":"S_Shadowspell_Cube"},
100990: {"AegisName":"S_Triangle_Cube"},
100991: {"AegisName":"S_Paint_Cube"},
100992: {"AegisName":"S_Shooting_Cube"},
100994: {"AegisName":"S_Arrow_Cube"},
100995: {"AegisName":"S_Aimed_Cube"},
100996: {"AegisName":"S_Cluster_Cube"},
100997: {"AegisName":"S_Rainstorm_Cube"},
100998: {"AegisName":"S_Metalic_Cube"},
100999: {"AegisName":"S_Arrowvulcan_Cube"},
101000: {"AegisName":"S_Reverberation_Cube"},
101001: {"AegisName":"S_Moonlight_Cube"},
101002: {"AegisName":"S_Sunshine_Cube"},
101003: {"AegisName":"S_Stardust_Cube"},
101004: {"AegisName":"S_S_Cube"},
101005: {"AegisName":"S_Evilcurse_Cube"},
101006: {"AegisName":"S_Syuriken_Cube"},
101007: {"AegisName":"S_Kunai_Cube"},
101008: {"AegisName":"S_Huusouka_Cube"},
101009: {"AegisName":"S_Kamaenraku_Cube"},
101010: {"AegisName":"S_God_Hammer_Cube"},
101011: {"AegisName":"S_Shatter_Buster_Cube"},
101012: {"AegisName":"S_Tail_Dragon_Cube"},
101013: {"AegisName":"S_Trip_Cube"},
101014: {"AegisName":"S_Flare_Dance_Cube"},
101015: {"AegisName":"S_Super_Magic_Cube"},
101016: {"AegisName":"S_Super_Power_Cube"},
101017: {"AegisName":"S_Silvervine_Cube"},
101018: {"AegisName":"S_Catnip_Cube"},
101019: {"AegisName":"S_SavageRabbit_Cube"},
101020: {"AegisName":"S_Pickyrush_Cube"},
101021: {"AegisName":"S_RuneKnight_Cube"},
101022: {"AegisName":"S_RoyalGuard_Cube"},
101023: {"AegisName":"S_Warlock_Cube"},
101024: {"AegisName":"S_Sorcerer_Cube"},
101025: {"AegisName":"S_Mechanic_Cube"},
101026: {"AegisName":"S_Generic_Cube"},
101027: {"AegisName":"S_ArchBishop_Cube"},
101028: {"AegisName":"S_Sura_Cube"},
101029: {"AegisName":"S_GuillotineCross_Cube"},
101030: {"AegisName":"S_ShadowChaser_Cube"},
101031: {"AegisName":"S_Ranger_Cube"},
101032: {"AegisName":"S_Wanderer_Cube"},
101033: {"AegisName":"S_Minstrel_Cube"},
101034: {"AegisName":"S_Star_Emperor_Cube"},
101035: {"AegisName":"S_Soul_Reaper_Cube"},
101036: {"AegisName":"S_Kagerou_Cube"},
101037: {"AegisName":"S_Oboro_Cube"},
101038: {"AegisName":"S_Rebellion_Cube"},
101039: {"AegisName":"S_SuperNovice_Cube"},
101040: {"AegisName":"S_Doram_Cube"},
101041: {"AegisName":"S_Mammoth_Cube"},
101042: {"AegisName":"S_Gemstone_Cube"},
101043: {"AegisName":"S_Pene1_Cube"},
101044: {"AegisName":"S_Pene2_Cube"},
101045: {"AegisName":"S_Temp1_Cube"},
101046: {"AegisName":"S_Temp2_Cube"},
101047: {"AegisName":"Blacksmith_Bless_Box_3"},
101048: {"AegisName":"Shadow_Hammer_Box_3"},
101060: {"AegisName":"Select_Example1"},
101062: {"AegisName":"Select_Example2"},
101067: {"AegisName":"Barmund_Rune_Box"},
101070: {"AegisName":"Chuseog_Present_Box"},
101074: {"AegisName":"Sealed_Card3"},
101075: {"AegisName":"SLD_Card_Recipe"},
101077: {"AegisName":"Vivatus_Weapon_Hammer"},
101078: {"AegisName":"Adulter_Weapon_Up_Box"},
101097: {"AegisName":"DF_Infinity_Drink"},
101099: {"AegisName":"ClockTower_Regulator"},
101100: {"AegisName":"Poenetentia_Box3"},
101101: {"AegisName":"Poenetentia_Box4"},
101103: {"AegisName":"Enchant_Stone_Box25"},
101107: {"AegisName":"Cannon_Box_Ice"},
101108: {"AegisName":"Cannon_Box_Lightning"},
101109: {"AegisName":"Cannon_Box_Stone"},
101110: {"AegisName":"Cannon_Box_Flare"},
101111: {"AegisName":"Cannon_Box_Poisoning"},
101112: {"AegisName":"Kunai_Scroll"},
101113: {"AegisName":"Kunai_Scroll_Nothing"},
101114: {"AegisName":"Kunai_Scroll_Shadow"},
101115: {"AegisName":"Kunai_Scroll_Hamaya"},
101116: {"AegisName":"Nw_Grenade_Box"},
101117: {"AegisName":"Soa_Charm_Bundle"},
101118: {"AegisName":"SS_Charm_Box"},
101119: {"AegisName":"SS_Charm_F_Box"},
101120: {"AegisName":"SS_Charm_W_Box"},
101121: {"AegisName":"SS_Charm_G_Box"},
101122: {"AegisName":"SS_Charm_L_Box"},
101123: {"AegisName":"RO_Live_Shop_Box"},
101124: {"AegisName":"RO_Live_Shop_Ex_Box"},
101126: {"AegisName":"DF_Halloween_Candy"},
101128: {"AegisName":"Season_Evt_Reward_11"},
101129: {"AegisName":"Payment_Costume_Box1"},
101130: {"AegisName":"Payment_Costume_Box2"},
101139: {"AegisName":"E_Boarding_Halter_Box"},
101148: {"AegisName":"Security_Campaign_Box"},
101159: {"AegisName":"C_Braid_Half_Up_Box"},
101161: {"AegisName":"Season_Evt_Reward_12"},
101162: {"AegisName":"Ep19_Rgan_Scroll"},
101166: {"AegisName":"Kr_B_Special05"},
101167: {"AegisName":"Kr_B_Special06"},
101168: {"AegisName":"Kr_B_Special07"},
101169: {"AegisName":"Kr_B_Special09"},
101170: {"AegisName":"Kr_B_Special08"},
101177: {"AegisName":"FullPenest_Shadow_Up"},
101178: {"AegisName":"Reload_Shadow_Up"},
101179: {"AegisName":"SpellCaster_Shadow_Up"},
101180: {"AegisName":"Ex_Status_Shadow_Up"},
101181: {"AegisName":"ReloadShadow_Mix"},
101182: {"AegisName":"SpellCasterShadow_Mix"},
101183: {"AegisName":"Ice_F_Stone_Box"},
101184: {"AegisName":"Ice_F_Stone_Box2"},
101185: {"AegisName":"Snow_F_Enchant"},
101186: {"AegisName":"Glacier_W_Enchant"},
101187: {"AegisName":"Snow_F_Refine"},
101188: {"AegisName":"Glacier_W_Refine"},
101189: {"AegisName":"Hero_Weapon_Hammer_6"},
101190: {"AegisName":"Hero_Weapon_Up_Box_6"},
101194: {"AegisName":"Hero_Token_Box"},
101200: {"AegisName":"Motp_Potion"},
101217: {"AegisName":"Snow_F_Enchant2"},
101218: {"AegisName":"Snow_F_Enchant3"},
101219: {"AegisName":"Snow_F_Enchant4"},
101220: {"AegisName":"Snow_F_Enchant5"},
101234: {"AegisName":"Booster_Pack_120"},
101236: {"AegisName":"Booster_Pack_150"},
101238: {"AegisName":"E_EXP_Drop_Up_7days"},
101240: {"AegisName":"Season_Evt_Reward_1"},
101241: {"AegisName":"Strange_Tteokguk"},
101243: {"AegisName":"Shadow_Changer_NPC"},
101257: {"AegisName":"R_BearersShadow_Mix"},
101258: {"AegisName":"M_BlitzShadow_Mix"},
101259: {"AegisName":"Special_Hat_Hammer"},
101260: {"AegisName":"R_Bearers_Shadow_Up"},
101261: {"AegisName":"M_Blitz_Shadow_Up"},
101262: {"AegisName":"Absorb_Shadow_Up"},
101264: {"AegisName":"Mammoth_Shadow_Up"},
101268: {"AegisName":"2021_Winter_Event_Box1"},
101269: {"AegisName":"2021_Winter_Event_Box2"},
101271: {"AegisName":"Enchant_Stone_Box26"},
101276: {"AegisName":"New_Year_Rice_Soup"},
101279: {"AegisName":"2022_LunarNewYears_box"},
101306: {"AegisName":"Poenitentia_Hammer"},
101307: {"AegisName":"Barmund_Hammer"},
101308: {"AegisName":"True_GemShadow_Up"},
101309: {"AegisName":"EXPShadow_Up"},
101310: {"AegisName":"MagicalShadow_Up"},
101311: {"AegisName":"InfinityShadow_Up"},
101314: {"AegisName":"aegis_101314"},
101321: {"AegisName":"2022Reward_Box"},
101322: {"AegisName":"aegis_101322"},
101331: {"AegisName":"Fruits_Set_Trap"},
101336: {"AegisName":"aegis_101336"},
101337: {"AegisName":"aegis_101337"},
101340: {"AegisName":"Bs_Item_M_S_52"},
101341: {"AegisName":"Bs_Item_M_S_53"},
101342: {"AegisName":"Bs_Item_M_S_54"},
101343: {"AegisName":"Bs_Item_M_S_55"},
101344: {"AegisName":"Bs_Item_M_S_56"},
101345: {"AegisName":"Bs_Item_M_S_57"},
101346: {"AegisName":"Bs_Item_M_S_58"},
101347: {"AegisName":"Bs_Item_M_S_59"},
101352: {"AegisName":"E_Bubble_Gum_Box10"},
101355: {"AegisName":"OS_Weapon_Reform"},
101357: {"AegisName":"BlessOfRabbit"},
101359: {"AegisName":"MajorAutoSpell_Up"},
101360: {"AegisName":"Hasty_Up"},
101361: {"AegisName":"PhysicalShadow_Up"},
101362: {"AegisName":"PerfectSize_Up"},
101363: {"AegisName":"OS_Helm_Hammer"},
101364: {"AegisName":"OS_Weapon_Hammer"},
101389: {"AegisName":"Helm_Of_Faith_Hammer"},
101390: {"AegisName":"Clock_Tower_W_Hammer"},
101391: {"AegisName":"VR_Books001"},
101393: {"AegisName":"aegis_101393"},
101394: {"AegisName":"aegis_101394"},
101399: {"AegisName":"Enchant_Ticket_3"},
101404: {"AegisName":"aegis_101404"},
101406: {"AegisName":"aegis_101406"},
101407: {"AegisName":"aegis_101407"},
101408: {"AegisName":"aegis_101408"},
101416: {"AegisName":"aegis_101416"},
101423: {"AegisName":"Boost_Armor_Box"},
101453: {"AegisName":"Special_Coin_Pack"},
101454: {"AegisName":"Metal_W_Box"},
101455: {"AegisName":"E_Auto_Up"},
101456: {"AegisName":"Memento_Box"},
101457: {"AegisName":"P_Memento_Box"},
101458: {"AegisName":"Booster_Hat_Box"},
101459: {"AegisName":"Booster_Back_Box"},
101460: {"AegisName":"P_Booster230_Gift"},
101461: {"AegisName":"Fan_Greed_1Hour_Box"},
101463: {"AegisName":"HD_Elunium_10Box_MSP"},
101465: {"AegisName":"HD_Oridecon_10Box_MSP"},
101470: {"AegisName":"Minus_Status_Box_"},
101471: {"AegisName":"Alchemist_Box_"},
101473: {"AegisName":"P_Booster_Call"},
101474: {"AegisName":"Booster_B_M_1"},
101475: {"AegisName":"Booster_B_M_2"},
101476: {"AegisName":"Booster230_Gift"},
101482: {"AegisName":"Freedom_Stick_Cube"},
101483: {"AegisName":"Blessed_Knife_Cube"},
101490: {"AegisName":"Booster_Pack_10"},
101491: {"AegisName":"Booster_Pack_20"},
101492: {"AegisName":"Booster_Pack_40"},
101493: {"AegisName":"Booster_Pack_50"},
101494: {"AegisName":"Booster_Pack_70"},
101495: {"AegisName":"Booster_Pack_80"},
101496: {"AegisName":"Booster_Pack_110"},
101497: {"AegisName":"Booster_Pack_140"},
101498: {"AegisName":"Booster_Pack_170"},
101499: {"AegisName":"Booster_Pack_180"},
101500: {"AegisName":"Booster_Pack_210"},
101501: {"AegisName":"Booster_Pack_220"},
101502: {"AegisName":"Booster_Pack_240"},
101503: {"AegisName":"Booster_Pack_250"},
101512: {"AegisName":"aegis_101512"},
101513: {"AegisName":"aegis_101513"},
101514: {"AegisName":"aegis_101514"},
101522: {"AegisName":"F_VR_Book001"},
101523: {"AegisName":"F_VR_Book002"},
101524: {"AegisName":"F_VR_Book003"},
101525: {"AegisName":"F_VR_Book004"},
101538: {"AegisName":"Booster_Call_Package"},
101542: {"AegisName":"FullPene_Select_Box"},
101543: {"AegisName":"FullPene_Earring_Box"},
101544: {"AegisName":"FullPene_Pendant_Box"},
101545: {"AegisName":"FullPene_Armor_Box"},
101546: {"AegisName":"FullPene_Shoes_Box"},
101547: {"AegisName":"FullTemp_Select_Box"},
101548: {"AegisName":"FullTemp_Earring_Box"},
101549: {"AegisName":"FullTemp_Pendant_Box"},
101550: {"AegisName":"FullTemp_Armor_Box"},
101551: {"AegisName":"FullTemp_Shoes_Box"},
101552: {"AegisName":"Durable_Select_Box"},
101553: {"AegisName":"Durable_Weapon_Box"},
101554: {"AegisName":"Durable_Shield_Box"},
101555: {"AegisName":"Clever_Select_Box"},
101556: {"AegisName":"Clever_Weapon_Box"},
101557: {"AegisName":"Clever_Shield_Box"},
101563: {"AegisName":"OS_Helm_Box_"},
101564: {"AegisName":"AllMighty_Up"},
101565: {"AegisName":"Shadow_R_M_Box_"},
101567: {"AegisName":"KAKAO_Plus_Box"},
101589: {"AegisName":"E_Boarding_Halter_Box2"},
101592: {"AegisName":"Force_of_Fullmoon"},
101596: {"AegisName":"Evt_20th_Shield"},
101597: {"AegisName":"Evt_20th_Protector"},
101599: {"AegisName":"Evt_Makingmaterials_Box"},
101600: {"AegisName":"Evt_20th_Whitegold"},
101601: {"AegisName":"Evt_20th_Gold"},
101602: {"AegisName":"Evt_20th_Silver"},
101603: {"AegisName":"Evt_20th_Bronze"},
101604: {"AegisName":"Evt_20th_Return"},
101605: {"AegisName":"Evt_20th_Return2"},
101637: {"AegisName":"EP19_DGW_Refine"},
101638: {"AegisName":"D_Glacier_W_Enchant"},
101639: {"AegisName":"D_Gw_Extractor"},
101645: {"AegisName":"GMT_Robe_Stone"},
101649: {"AegisName":"Mjo_Ein_Enchant"},
101653: {"AegisName":"Viva_Adul_Hat_Box_11"},
101654: {"AegisName":"AllMighty_Select_Box"},
101655: {"AegisName":"AllMighty_Earring_Box"},
101656: {"AegisName":"AllMighty_Pendant_Box"},
101657: {"AegisName":"TrueGem_Select_Box"},
101658: {"AegisName":"TrueGem_Earring_Box"},
101659: {"AegisName":"TrueGem_Pendant_Box"},
101660: {"AegisName":"TrueGem_Shoes_Box"},
101661: {"AegisName":"TrueGem_Armor_Box"},
101662: {"AegisName":"PerfectSize_Select_Box"},
101663: {"AegisName":"PerfectSize_Weapon_Box"},
101664: {"AegisName":"PerfectSize_Armor_Box"},
101665: {"AegisName":"EXPShadow_Mix2"},
101666: {"AegisName":"Shadow_Up_Box"},
101675: {"AegisName":"aegis_101675"},
101705: {"AegisName":"F_VR_Book006"},
101706: {"AegisName":"F_VR_Book007"},
101717: {"AegisName":"Mammoth_Earring_Box"},
101718: {"AegisName":"Mammoth_Pendant_Box"},
101719: {"AegisName":"Mammoth_Armor_Box"},
101720: {"AegisName":"Mammoth_Shoes_Box"},
101721: {"AegisName":"SpellCaster_Earring_Box"},
101722: {"AegisName":"SpellCaster_Pendant_Box"},
101723: {"AegisName":"SpellCaster_Armor_Box"},
101724: {"AegisName":"SpellCaster_Shoes_Box"},
101725: {"AegisName":"Absorb_Weapon_Box"},
101726: {"AegisName":"Absorb_Shield_Box"},
101727: {"AegisName":"Mammoth_Select_Box"},
101728: {"AegisName":"SpellCaster_Select_Box"},
101729: {"AegisName":"Absorb_Select_Box"},
101744: {"AegisName":"E_Cloth_Dye_Box"},
101745: {"AegisName":"Dimmen_A_Reform"},
101746: {"AegisName":"Dimmen_A_Enchant"},
101750: {"AegisName":"Herosria_Gift"},
101752: {"AegisName":"RO_Festival_Box"},
101753: {"AegisName":"Heros_Purple_H_Jam"},
101754: {"AegisName":"Heros_Red_H_Jam"},
101755: {"AegisName":"Heros_Blue_H_Jam"},
101756: {"AegisName":"Heros_Yellow_H_Jam"},
101757: {"AegisName":"Heros_White_H_Jam"},
101759: {"AegisName":"Plain_Rune_Box5"},
101760: {"AegisName":"Flame_Rune_Box5"},
101761: {"AegisName":"Ice_Rune_Box5"},
101762: {"AegisName":"Death_Rune_Box5"},
101765: {"AegisName":"Barmund_P_Enchant"},
101766: {"AegisName":"Barmund_D_Enchant"},
101767: {"AegisName":"Barmund_F_Enchant"},
101768: {"AegisName":"Barmund_I_Enchant"},
101769: {"AegisName":"Barmund_Plain_Reform"},
101770: {"AegisName":"Barmund_Death_Reform"},
101771: {"AegisName":"Barmund_Flame_Reform"},
101772: {"AegisName":"Barmund_Ice_Reform"},
101774: {"AegisName":"Service1_M_01_Box"},
101775: {"AegisName":"Service1_M_05_Box"},
101776: {"AegisName":"Service1_M_07_Box"},
101777: {"AegisName":"Service1_M_10_Box"},
101778: {"AegisName":"Service1P_M_01_Box"},
101779: {"AegisName":"Service1P_M_05_Box"},
101780: {"AegisName":"Service1P_M_07_Box"},
101781: {"AegisName":"Service1P_M_10_Box"},
101782: {"AegisName":"Service1_F_01_Box"},
101783: {"AegisName":"Service1_F_05_Box"},
101784: {"AegisName":"Service1_F_07_Box"},
101785: {"AegisName":"Service1_F_10_Box"},
101786: {"AegisName":"Service1P_F_01_Box"},
101787: {"AegisName":"Service1P_F_05_Box"},
101788: {"AegisName":"Service1P_F_07_Box"},
101789: {"AegisName":"Service1P_F_10_Box"},
101792: {"AegisName":"SubjectCape_Refine_Cube"},
101801: {"AegisName":"R_Bearers_Select_Box"},
101802: {"AegisName":"R_Bearers_Earring_Box"},
101803: {"AegisName":"R_Bearers_Pendant_Box"},
101804: {"AegisName":"R_Bearers_Armor_Box"},
101805: {"AegisName":"R_Bearers_Shoes_Box"},
101806: {"AegisName":"Hasty_Select_Box"},
101807: {"AegisName":"Hasty_Weapon_Box"},
101808: {"AegisName":"Hasty_Shield_Box"},
101809: {"AegisName":"S_Reload_Shield_Box"},
101816: {"AegisName":"Dimmen_A_Refine"},
101834: {"AegisName":"F_VR_Book009"},
101835: {"AegisName":"F_VR_Book005"},
101837: {"AegisName":"F_VR_Book008"},
101839: {"AegisName":"RO_Arena_Box"},
101840: {"AegisName":"RO_Arena_Box2"},
101856: {"AegisName":"MAutoSpell_Select_Box"},
101858: {"AegisName":"MAutoSpell_Earring_Box"},
101859: {"AegisName":"MAutoSpell_Pendant_Box"},
101860: {"AegisName":"MAutoSpell_Armor_Box"},
101861: {"AegisName":"MAutoSpell_Shoes_Box"},
101862: {"AegisName":"Infinity_Select_Box"},
101863: {"AegisName":"Infinity_Weapon_Box"},
101864: {"AegisName":"Infinity_Shield_Box"},
101869: {"AegisName":"Luxurious_Blue_Box"},
101876: {"AegisName":"aegis_101876"},
101889: {"AegisName":"Vr_Book_Event"},
101912: {"AegisName":"Temple_Rune_Box5"},
101913: {"AegisName":"Venom_Rune_Box5"},
101914: {"AegisName":"Soul_Rune_Box5"},
101919: {"AegisName":"EXP_Select_Box"},
101920: {"AegisName":"EXP_Weapon_Box"},
101921: {"AegisName":"EXP_Shield_Box"},
101922: {"AegisName":"M_Blitz_Select_Box"},
101923: {"AegisName":"M_Blitz_Weapon_Box"},
101924: {"AegisName":"M_Blitz_Shield_Box"},
101925: {"AegisName":"Cvt_Wing_Box"},
101930: {"AegisName":"Barmund_S_Enchant"},
101931: {"AegisName":"Barmund_V_Enchant"},
101932: {"AegisName":"Barmund_T_Enchant"},
101933: {"AegisName":"Barmund_Soul_Reform"},
101934: {"AegisName":"Barmund_Venom_Reform"},
101935: {"AegisName":"Barmund_Temple_Reform"},
101936: {"AegisName":"Barmund_S_Reform"},
101937: {"AegisName":"Barmund_V_Reform"},
101938: {"AegisName":"Barmund_T_Reform"},
101947: {"AegisName":"A_Bubble_Gum"},
101948: {"AegisName":"A_Bubble_Gum_Box10"},
101952: {"AegisName":"SunShine_Sand"},
101954: {"AegisName":"Intake_Hair_Box"},
102015: {"AegisName":"Mocadas_Enchant_Box"},
102016: {"AegisName":"F_Ein_1HDAGGER_Box"},
102017: {"AegisName":"Mocadas_Refine_Box"},
102018: {"AegisName":"Amp_Blueprint1"},
102019: {"AegisName":"Amp_Blueprint3"},
102020: {"AegisName":"Amp_Blueprint2"},
102021: {"AegisName":"Amp_Blueprint4"},
102022: {"AegisName":"Amp_Blueprint6"},
102023: {"AegisName":"Amp_Blueprint5"},
102024: {"AegisName":"Amp_Blueprint7"},
102025: {"AegisName":"Amp_Blueprint8"},
102026: {"AegisName":"Amp_Blueprint9"},
102027: {"AegisName":"Amp_Blueprint10"},
102028: {"AegisName":"Amp_Blueprint11"},
102029: {"AegisName":"Amp_Blueprint12"},
102030: {"AegisName":"Amp_Blueprint13"},
102031: {"AegisName":"Amp_Blueprint14"},
102032: {"AegisName":"Amp_Blueprint15"},
102033: {"AegisName":"Amp_Blueprint16"},
102034: {"AegisName":"Amp_Blueprint17"},
102035: {"AegisName":"Amp_Blueprint18"},
102038: {"AegisName":"Dead_Soul_Aura"},
102040: {"AegisName":"Mocadas_Slabs1"},
102041: {"AegisName":"Mocadas_Slabs2"},
102042: {"AegisName":"Mocadas_Slabs3"},
102043: {"AegisName":"Mocadas_Slabs4"},
102044: {"AegisName":"Mocadas_Slabs5"},
102045: {"AegisName":"Mocadas_Slabs6"},
102046: {"AegisName":"Mocadas_Slabs7"},
102047: {"AegisName":"Mocadas_Slabs8"},
102048: {"AegisName":"Mocadas_Slabs9"},
102049: {"AegisName":"Mocadas_Slabs10"},
102050: {"AegisName":"Mocadas_Slabs11"},
102051: {"AegisName":"Mocadas_Slabs12"},
102052: {"AegisName":"Mocadas_Slabs13"},
102053: {"AegisName":"Mocadas_Slabs14"},
102054: {"AegisName":"Mocadas_Slabs15"},
102055: {"AegisName":"Mocadas_Slabs16"},
102056: {"AegisName":"Mocadas_Slabs17"},
102057: {"AegisName":"Mocadas_Slabs18"},
102058: {"AegisName":"Mocadas_Slabs19"},
102059: {"AegisName":"Mocadas_Slabs20"},
102060: {"AegisName":"Mocadas_Slabs21"},
102061: {"AegisName":"Mocadas_Slabs22"},
102062: {"AegisName":"Mocadas_Slabs23"},
102067: {"AegisName":"Pene_Set_Cube"},
102068: {"AegisName":"S_Bearers_Cube"},
102069: {"AegisName":"Temp_Set_Cube"},
102070: {"AegisName":"Justice_Weapon_Box"},
102071: {"AegisName":"Injustice_Weapon_Box"},
102072: {"AegisName":"Justice_Weapon_Hammer"},
102073: {"AegisName":"Injustice_Weapon_Hammer"},
102074: {"AegisName":"GoodnEvil_Helm_Box"},
102075: {"AegisName":"GoodnEvil_Helm_Hammer"},
102084: {"AegisName":"GoodnEvil_Circlet_Box"},
102121: {"AegisName":"aegis_102121"},
102123: {"AegisName":"Shadow_Select_Box_Set"},
102124: {"AegisName":"F_Ein_Weapon_Hammer"},
102125: {"AegisName":"Refine_Hammer_Box"},
102126: {"AegisName":"Amp_Blueprint19"},
102128: {"AegisName":"All_In_One_buff"},
102129: {"AegisName":"All_In_One_Healing"},
102193: {"AegisName":"aegis_102193"},
102202: {"AegisName":"Ep20_Fatty_Icegangu"},
102213: {"AegisName":"Hero_Weapon_Up_S_Box"},
102214: {"AegisName":"Hero_Weapon_Hammer_S"},
102215: {"AegisName":"aegis_102215"},
102216: {"AegisName":"aegis_102216"},
102217: {"AegisName":"Hero_Weapon_S_Box_1"},
102218: {"AegisName":"Hero_Weapon_S_Box_2"},
102219: {"AegisName":"Hero_Weapon_S_Box_3"},
102220: {"AegisName":"Hero_Weapon_S_Box_4"},
102221: {"AegisName":"Hero_Weapon_S_Box_5"},
102222: {"AegisName":"Hero_Weapon_S_Box_6"},
102223: {"AegisName":"Hero_Weapon_S_Box_7"},
102224: {"AegisName":"Hero_Up_Cube_11"},
102226: {"AegisName":"SLD_Boss_Card_Album"},
102227: {"AegisName":"Glacier_Armor_9Refine"},
102228: {"AegisName":"EP20_DGA_Refine"},
102238: {"AegisName":"Isgard_Crown_Hammer"},
102246: {"AegisName":"VIP_Black_Card"},
102247: {"AegisName":"VIP_Gift"},
102248: {"AegisName":"VVIP_Gift"},
102249: {"AegisName":"SVIP_Gift"},
102277: {"AegisName":"Loki_Advice"},
102278: {"AegisName":"Loki_Coin"},
102295: {"AegisName":"Bs_Item_M_S_60"},
102306: {"AegisName":"2023_Spring_Select"},
102307: {"AegisName":"2023_Spring_Collection"},
102308: {"AegisName":"Bs_Item_M_S_61"},
102310: {"AegisName":"Bs_Item_M_S_62"},
102311: {"AegisName":"Bs_Item_M_S_63"},
102332: {"AegisName":"aegis_102332"},
102333: {"AegisName":"Stone_Robe3_Box"},
102337: {"AegisName":"RO_Concert_Scroll"},
102338: {"AegisName":"RO_Concert_Scroll2"},
102340: {"AegisName":"RO_Concert_Scroll_Box"},
102342: {"AegisName":"Loki_Advice_3"},
102343: {"AegisName":"Loki_Coin_3"},
102344: {"AegisName":"Fan_Upgrade_Kit_EX"},
102345: {"AegisName":"Fan_Upgrade_Kit_EX_10"},
102353: {"AegisName":"CatPaw_1Day_Box"},
102354: {"AegisName":"Battle_Aura_TW"},
102373: {"AegisName":"Bar_D_A_Seal"},
102374: {"AegisName":"Bar_D_A_Unseal"},
102396: {"AegisName":"FA_Armor_Reform_1"},
102397: {"AegisName":"FA_Armor_Reform_2"},
102404: {"AegisName":"Maya_Scroll_TW"},
102413: {"AegisName":"aegis_102413"}
}
